/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ScannerSignUpResponseDto {
  user: {
    isNew: boolean;
  };
}

export interface ScannerSignUpBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  ssoUserId: string;
}

export interface HubspotUtmInfo {
  utm_source?: string;
  referrer?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  utm_ad?: string;
  gclid?: string;
  fbclid?: string;
  fbp?: string;
  fbc?: string;
  cid?: string;
  li_fat_id?: string;
  msclkid?: string;
  search_query?: string;
  campaign_id?: string;
  adset_id?: string;
  ad_id?: string;
  matchtype?: string;
  placement?: string;
  GeoLoc?: string;
  network?: string;
  device?: string;
  user_agent?: string;
  currenturl?: string;
  yclid?: string;
  obcid?: string;
  tblci?: string;
  ttcid?: string;
  ip?: string | null;
  uId?: string | null;
  ga4SessionId?: string;
  hubspotutk?: string | null;
  leadType?: string;
  meetingSource?: MeetingSource;
  aff_click_id?: string;
  aff_timestamp?: number;
  keyword_id?: string;
  abver?: string;
  gbraid?: string;
  wbraid?: string;
}

export enum MeetingSource {
  Website = 'Website',
  WebinarsConference = 'Webinars/Conference',
  Email = 'Email',
}

export interface ToggleWidgetVisibilityDto {
  state: SiteWidgetState;
}

export enum SiteWidgetState {
  ON = 'ON',
  OFF = 'OFF',
}

export interface CreateSiteResponseDto {
  siteId: number | null;
  isNew: boolean;
  isValid: boolean;
}

export interface CreateSiteDto {
  host: string;
}

export interface GetAgencySiteResponseDto {
  options: AgencySiteOptions;
  products: AgencySiteProducts;
}

export interface AgencySiteOptions {
  widgetVisible: true;
}

export type AgencySiteProducts = RecordAgencySiteProductsTransactionTypesUserPaidAddonDto;

export type RecordAgencySiteProductsTransactionTypesUserPaidAddonDto = Record<string, UserPaidAddonDto>;

export interface UserPaidAddonDto {
  addon: Addon | null;
  userService: IUserService | null;
  subscription: SubscriptionPairDto | null;
  meta?: {
    sites?: UserPaidProductMetaSite[];
    cost?: number;
    whiteLabelAgencyFree?: boolean;
    customBrandingAgencyFree?: boolean;
    discount?: number;
    paidAsAgency?: boolean;
    isTrialApplicable?: boolean;
  };
}

export interface Addon {
  id: number;
  user_service_id: number;
  site_id: number;
  is_enabled: boolean;
  is_renewable: boolean;
}

export interface IUserService {
  id: number;
  subscriptionId: number | null;
  subjectTransactionType: UserwaySubjectTransactionType;
  userId: number;
  isTrial: boolean;
  managedByUserWay: boolean;
  billingCycleMonths: number;
  /** @format date-time */
  startsAt: string;
  expiresAt?: string | null;
  comment?: string | null;
  status: UserServiceStatus;
}

export enum UserwaySubjectTransactionType {
  WHITE_LABEL = 'WHITE_LABEL',
  CUSTOM_BRANDING = 'CUSTOM_BRANDING',
  MODIFY_MENU = 'MODIFY_MENU',
  USAGE_STATS = 'USAGE_STATS',
  LIVE_TRANSLATIONS = 'LIVE_TRANSLATIONS',
  REMEDIATION = 'REMEDIATION',
  REMEDIATION_PLUS = 'REMEDIATION_PLUS',
  REMEDIATION_ULTIMATE = 'REMEDIATION_ULTIMATE',
  SCANNING_AND_MONITORING = 'SCANNING_AND_MONITORING',
  IMG_REMEDIATION = 'IMG_REMEDIATION',
  PDF_AUTO_REMEDIATION = 'PDF_AUTO_REMEDIATION',
  DONATION = 'DONATION',
  PDF_REMEDIATION = 'PDF_REMEDIATION',
  VIDEO_REMEDIATION = 'VIDEO_REMEDIATION',
  STATEMENT_OF_COMPLIANCE = 'STATEMENT_OF_COMPLIANCE',
  GENERAL = 'GENERAL',
  AUDIT = 'AUDIT',
  AUDIT_VPAT = 'AUDIT_VPAT',
  AUDIT_VALIDATION = 'AUDIT_VALIDATION',
  AUDIT_LANDING_PAGE = 'AUDIT_LANDING_PAGE',
  AUDIT_STANDARD_WEBSITE = 'AUDIT_STANDARD_WEBSITE',
  AUDIT_ECOMMERCE_SITE = 'AUDIT_ECOMMERCE_SITE',
  AUDIT_LARGE_WEBSITE = 'AUDIT_LARGE_WEBSITE',
  AUDIT_WEB_APP = 'AUDIT_WEB_APP',
  AUDIT_GENERAL = 'AUDIT_GENERAL',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  SLA_SUPPORT = 'SLA_SUPPORT',
  SUCCESS_PROGRAM = 'SUCCESS_PROGRAM',
  REMEDIATION_SERVICES = 'REMEDIATION_SERVICES',
  LEGAL_PUNCH_LIST = 'LEGAL_PUNCH_LIST',
  LEGAL_RENOVATION = 'LEGAL_RENOVATION',
  LEGAL_PROOF_POSITIVE = 'LEGAL_PROOF_POSITIVE',
  LEGAL_EXPERT_REPORT = 'LEGAL_EXPERT_REPORT',
  LEGAL_EXPERT_DEPOSITION = 'LEGAL_EXPERT_DEPOSITION',
  LEGAL_EXPERT_TRIAL_TESTIMONY = 'LEGAL_EXPERT_TRIAL_TESTIMONY',
  SSO = 'SSO',
  PRM = 'PRM',
  ROR = 'ROR',
  CPA = 'CPA',
  STP = 'STP',
  PLE = 'PLE',
  HR = 'HR',
  TRAINING_NVDA_FOR_TESTERS = 'TRAINING_NVDA_FOR_TESTERS',
  TRAINING_ACCESSIBILITY_OVERVIEW = 'TRAINING_ACCESSIBILITY_OVERVIEW',
  TRAINING_EMPATHY_LAB = 'TRAINING_EMPATHY_LAB',
  TRAINING_VIRTUAL_DESIGN_BASICS = 'TRAINING_VIRTUAL_DESIGN_BASICS',
  TRAINING_CODE_FE = 'TRAINING_CODE_FE',
  TRAINING_CODE_ARIA = 'TRAINING_CODE_ARIA',
  TRAINING_CONTENT_WRITERS = 'TRAINING_CONTENT_WRITERS',
  TRAINING_PDF_CONTENT_WRITERS = 'TRAINING_PDF_CONTENT_WRITERS',
  TRAINING_WCAG_CRITERIA = 'TRAINING_WCAG_CRITERIA',
  TRAINING_ACCESSIBLE_FORMS = 'TRAINING_ACCESSIBLE_FORMS',
  TRAINING_ACCESSIBLE_SOCIAL_MEDIA = 'TRAINING_ACCESSIBLE_SOCIAL_MEDIA',
  TRAINING_PDF_REMEDIATION = 'TRAINING_PDF_REMEDIATION',
  DEV_STAGING_SITE = 'DEV_STAGING_SITE',
  BULK_PACKAGE_SITE = 'BULK_PACKAGE_SITE',
  CA11YMANAGED = 'CA11Y_MANAGED',
  CA11YSELFHOSTED = 'CA11Y_SELF_HOSTED',
  CHARGEBACK = 'CHARGEBACK',
  REFUND = 'REFUND',
  CHARGEBACK_REINSTATED = 'CHARGEBACK_REINSTATED',
}

export enum UserServiceStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}

export interface SubscriptionPairDto {
  userwaySubscription: ISubscription;
  providerSubscription: StripeSubscription | null;
}

export interface ISubscription {
  id: number;
  userId: number;
  paymentDataId: number | null;
  status: SubscriptionStatus;
  currency: PricingCurrency;
  reasonOfCancellation: string | null;
  dateOfCancellation: string | null;
  dateOfCancellationSubmitted: string | null;
  paymentProvider: BillingProvider;
  paymentProviderSubscriptionId: string;
  forcedPricingVersionType: PricingVersionType | null;
  isSalesManaged: boolean;
  metadata?: SubscriptionMetadata;
  /** @format date-time */
  createdAt: string;
}

export enum SubscriptionStatus {
  INIT = 'INIT',
  ACTIVE = 'ACTIVE',
  REQUIRES_PAYMENT_METHOD = 'REQUIRES_PAYMENT_METHOD',
  REQUIRES_AUTH = 'REQUIRES_AUTH',
  PAST_DUE = 'PAST_DUE',
  CLOSED = 'CLOSED',
}

export enum PricingCurrency {
  USD = 'USD',
  EUR = 'EUR',
}

export enum BillingProvider {
  STRIPE = 'STRIPE',
  BLUESNAP = 'BLUESNAP',
  THIRD_PARTY = 'THIRD_PARTY',
}

export enum PricingVersionType {
  Value0Initial = '0-initial',
  Value20210101 = '2021-01-01',
  Value20230813 = '2023-08-13',
  Value20230901 = '2023-09-01',
  Value20230911 = '2023-09-11',
  Value20230928 = '2023-09-28',
  Value20240402 = '2024-04-02',
}

export interface SubscriptionMetadata {
  nextAutoRenewAddonSettings?: BillingAddonSettings[];
}

export interface BillingAddonSettings {
  tier?: ProductPricingTier;
  flowId?: UUID;
  pricing_tier?: string;
  pricing?: PricingDetails;
  proPlus?: boolean;
  isMrrForced?: boolean;
}

export interface ProductPricingTier {
  name: string;
  cost: number;
}

export type UUID = string;

export interface PricingDetails {
  version: PricingVersionType;
  currency: PricingCurrency;
}

/**
 * Subscriptions allow you to charge a customer on a recurring basis.
 *
 * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
 */
export interface StripeSubscription {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'subscription';
  /** ID of the Connect Application that created the subscription. */
  application: string | StripeApplication | StripeDeletedApplication | null;
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the application owner's Stripe account. */
  application_fee_percent: number | null;
  automatic_tax: StripeSubscriptionAutomaticTax;
  /** Determines the date of the first full invoice, and, for plans with `month` or `year` intervals, the day of the month for subsequent invoices. The timestamp is in UTC format. */
  billing_cycle_anchor: number;
  /** Define thresholds at which an invoice will be sent, and the subscription advanced to a new billing period */
  billing_thresholds: StripeSubscriptionBillingThresholds | null;
  /** A date in the future at which the subscription will automatically get canceled */
  cancel_at: number | null;
  /** If the subscription has been canceled with the `at_period_end` flag set to `true`, `cancel_at_period_end` on the subscription will be true. You can use this attribute to determine whether a subscription that has a status of active is scheduled to be canceled at the end of the current period. */
  cancel_at_period_end: boolean;
  /** If the subscription has been canceled, the date of that cancellation. If the subscription was canceled with `cancel_at_period_end`, `canceled_at` will reflect the time of the most recent update request, not the end of the subscription period when the subscription is automatically moved to a canceled state. */
  canceled_at: number | null;
  /** Details about why this subscription was cancelled */
  cancellation_details: StripeSubscriptionCancellationDetails | null;
  /** Either `charge_automatically`, or `send_invoice`. When charging automatically, Stripe will attempt to pay this subscription at the end of the cycle using the default source attached to the customer. When sending an invoice, Stripe will email your customer an invoice with payment instructions and mark the subscription as `active`. */
  collection_method: StripeSubscriptionCollectionMethod;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** End of the current period that the subscription has been invoiced for. At the end of this period, a new invoice will be created. */
  current_period_end: number;
  /** Start of the current period that the subscription has been invoiced for. */
  current_period_start: number;
  /** ID of the customer who owns the subscription. */
  customer: string | StripeCustomer | StripeDeletedCustomer;
  /** Number of days a customer has to pay invoices generated by this subscription. This value will be `null` for subscriptions where `collection_method=charge_automatically`. */
  days_until_due: number | null;
  /** ID of the default payment method for the subscription. It must belong to the customer associated with the subscription. This takes precedence over `default_source`. If neither are set, invoices will use the customer's [invoice_settings.default_payment_method](https://stripe.com/docs/api/customers/object#customer_object-invoice_settings-default_payment_method) or [default_source](https://stripe.com/docs/api/customers/object#customer_object-default_source). */
  default_payment_method: string | StripePaymentMethod | null;
  /** ID of the default payment source for the subscription. It must belong to the customer associated with the subscription and be in a chargeable state. If `default_payment_method` is also set, `default_payment_method` will take precedence. If neither are set, invoices will use the customer's [invoice_settings.default_payment_method](https://stripe.com/docs/api/customers/object#customer_object-invoice_settings-default_payment_method) or [default_source](https://stripe.com/docs/api/customers/object#customer_object-default_source). */
  default_source: string | StripeCustomerSource | null;
  /** The tax rates that will apply to any subscription item that does not have `tax_rates` set. Invoices created will have their `default_tax_rates` populated from the subscription. */
  default_tax_rates?: StripeTaxRate[] | null;
  /** The subscription's description, meant to be displayable to the customer. Use this field to optionally store an explanation of the subscription for rendering in Stripe surfaces. */
  description: string | null;
  /** Describes the current discount applied to this subscription, if there is one. When billing, a discount applied to a subscription overrides a discount applied on a customer-wide basis. */
  discount: StripeDiscount | null;
  /** If the subscription has ended, the date the subscription ended. */
  ended_at: number | null;
  /** List of subscription items, each with an attached price. */
  items: StripeApiListStripeSubscriptionItem;
  /** The most recent invoice this subscription has generated. */
  latest_invoice: string | StripeInvoice | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** Specifies the approximate timestamp on which any pending invoice items will be billed according to the schedule provided at `pending_invoice_item_interval`. */
  next_pending_invoice_item_invoice: number | null;
  /** The account (if any) the charge was made on behalf of for charges associated with this subscription. See the Connect documentation for details. */
  on_behalf_of: string | StripeAccount | null;
  /** If specified, payment collection for this subscription will be paused. */
  pause_collection: StripeSubscriptionPauseCollection | null;
  /** Payment settings passed on to invoices created by the subscription. */
  payment_settings: StripeSubscriptionPaymentSettings | null;
  /** Specifies an interval for how often to bill for any pending invoice items. It is analogous to calling [Create an invoice](https://stripe.com/docs/api#create_invoice) for the given subscription at the specified interval. */
  pending_invoice_item_interval: StripeSubscriptionPendingInvoiceItemInterval | null;
  /** You can use this [SetupIntent](https://stripe.com/docs/api/setup_intents) to collect user authentication when creating a subscription without immediate payment or updating a subscription's payment method, allowing you to optimize for off-session payments. Learn more in the [SCA Migration Guide](https://stripe.com/docs/billing/migration/strong-customer-authentication#scenario-2). */
  pending_setup_intent: string | StripeSetupIntent | null;
  /** If specified, [pending updates](https://stripe.com/docs/billing/subscriptions/pending-updates) that will be applied to the subscription once the `latest_invoice` has been paid. */
  pending_update: StripeSubscriptionPendingUpdate | null;
  /** The schedule attached to the subscription */
  schedule: string | StripeSubscriptionSchedule | null;
  /** Date when the subscription was first created. The date might differ from the `created` date due to backdating. */
  start_date: number;
  /**
   * Possible values are `incomplete`, `incomplete_expired`, `trialing`, `active`, `past_due`, `canceled`, or `unpaid`.
   *
   * For `collection_method=charge_automatically` a subscription moves into `incomplete` if the initial payment attempt fails. A subscription in this state can only have metadata and default_source updated. Once the first invoice is paid, the subscription moves into an `active` state. If the first invoice is not paid within 23 hours, the subscription transitions to `incomplete_expired`. This is a terminal state, the open invoice will be voided and no further invoices will be generated.
   *
   * A subscription that is currently in a trial period is `trialing` and moves to `active` when the trial period is over.
   *
   * If subscription `collection_method=charge_automatically` it becomes `past_due` when payment to renew it fails and `canceled` or `unpaid` (depending on your subscriptions settings) when Stripe has exhausted all payment retry attempts.
   *
   * If subscription `collection_method=send_invoice` it becomes `past_due` when its invoice is not paid by the due date, and `canceled` or `unpaid` if it is still not paid by an additional deadline after that. Note that when a subscription has a status of `unpaid`, no subsequent invoices will be attempted (invoices will be created, but then immediately automatically closed). After receiving updated payment information from a customer, you may choose to reopen and pay their closed invoices.
   */
  status: StripeSubscriptionStatus;
  /** ID of the test clock this subscription belongs to. */
  test_clock: string | StripeTestHelpersTestClock | null;
  /** The account (if any) the subscription's payments will be attributed to for tax reporting, and where funds from each payment will be transferred to for each of the subscription's invoices. */
  transfer_data: StripeSubscriptionTransferData | null;
  /** If the subscription has a trial, the end of that trial. */
  trial_end: number | null;
  /** Settings related to subscription trials. */
  trial_settings: StripeSubscriptionTrialSettings | null;
  /** If the subscription has a trial, the beginning of that trial. */
  trial_start: number | null;
}

/** The Application object. */
export interface StripeApplication {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'application';
  deleted?: null;
  /** The name of the application. */
  name: string | null;
}

/** The DeletedApplication object. */
export interface StripeDeletedApplication {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'application';
  /** Always true for a deleted object */
  deleted: true;
  /** The name of the application. */
  name: string | null;
}

export interface StripeSubscriptionAutomaticTax {
  /** Whether Stripe automatically computes tax on this subscription. */
  enabled: boolean;
}

export interface StripeSubscriptionBillingThresholds {
  /** Monetary threshold that triggers the subscription to create an invoice */
  amount_gte: number | null;
  /** Indicates if the `billing_cycle_anchor` should be reset when a threshold is reached. If true, `billing_cycle_anchor` will be updated to the date/time the threshold was last reached; otherwise, the value will remain unchanged. This value may not be `true` if the subscription contains items with plans that have `aggregate_usage=last_ever`. */
  reset_billing_cycle_anchor: boolean | null;
}

export interface StripeSubscriptionCancellationDetails {
  /** Additional comments about why the user canceled the subscription, if the subscription was cancelled explicitly by the user. */
  comment: string | null;
  /** The customer submitted reason for why they cancelled, if the subscription was cancelled explicitly by the user. */
  feedback: StripeSubscriptionCancellationDetailsFeedback | null;
  /** Why this subscription was cancelled. */
  reason: StripeSubscriptionCancellationDetailsReason | null;
}

export enum StripeSubscriptionCancellationDetailsFeedback {
  CustomerService = 'customer_service',
  LowQuality = 'low_quality',
  MissingFeatures = 'missing_features',
  Other = 'other',
  SwitchedService = 'switched_service',
  TooComplex = 'too_complex',
  TooExpensive = 'too_expensive',
  Unused = 'unused',
}

export enum StripeSubscriptionCancellationDetailsReason {
  CancellationRequested = 'cancellation_requested',
  PaymentDisputed = 'payment_disputed',
  PaymentFailed = 'payment_failed',
}

export enum StripeSubscriptionCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice',
}

/**
 * This object represents a customer of your business. It lets you create recurring charges and track payments that belong to the same customer.
 *
 * Related guide: [Save a card during payment](https://stripe.com/docs/payments/save-during-payment)
 */
export interface StripeCustomer {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'customer';
  /** The customer's address. */
  address?: StripeAddress | null;
  /** Current balance, if any, being stored on the customer. If negative, the customer has credit to apply to their next invoice. If positive, the customer has an amount owed that will be added to their next invoice. The balance does not refer to any unpaid invoices; it solely takes into account amounts that have yet to be successfully applied to any invoice. This balance is only taken into account as invoices are finalized. */
  balance: number;
  /** The current funds being held by Stripe on behalf of the customer. These funds can be applied towards payment intents with source "cash_balance". The settings[reconciliation_mode] field describes whether these funds are applied to such payment intents manually or automatically. */
  cash_balance?: StripeCashBalance | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO code for the currency](https://stripe.com/docs/currencies) the customer can be charged in for recurring billing purposes. */
  currency?: string | null;
  /**
   * ID of the default payment source for the customer.
   *
   * If you are using payment methods created via the PaymentMethods API, see the [invoice_settings.default_payment_method](https://stripe.com/docs/api/customers/object#customer_object-invoice_settings-default_payment_method) field instead.
   */
  default_source: string | StripeCustomerSource | null;
  deleted?: null;
  /**
   * When the customer's latest invoice is billed by charging automatically, `delinquent` is `true` if the invoice's latest charge failed. When the customer's latest invoice is billed by sending an invoice, `delinquent` is `true` if the invoice isn't paid by its due date.
   *
   * If an invoice is marked uncollectible by [dunning](https://stripe.com/docs/billing/automatic-collection), `delinquent` doesn't get reset to `false`.
   */
  delinquent?: boolean | null;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** Describes the current discount active on the customer, if there is one. */
  discount?: StripeDiscount | null;
  /** The customer's email address. */
  email: string | null;
  /** The current multi-currency balances, if any, being stored on the customer. If positive in a currency, the customer has a credit to apply to their next invoice denominated in that currency. If negative, the customer has an amount owed that will be added to their next invoice denominated in that currency. These balances do not refer to any unpaid invoices. They solely track amounts that have yet to be successfully applied to any invoice. A balance in a particular currency is only applied to any invoice as an invoice in that currency is finalized. */
  invoice_credit_balance?: Record<string, number>;
  /** The prefix for the customer used to generate unique invoice numbers. */
  invoice_prefix?: string | null;
  invoice_settings: StripeCustomerInvoiceSettings;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** The customer's full name or business name. */
  name?: string | null;
  /** The suffix of the customer's next invoice number, e.g., 0001. */
  next_invoice_sequence?: number;
  /** The customer's phone number. */
  phone?: string | null;
  /** The customer's preferred locales (languages), ordered by preference. */
  preferred_locales?: string[] | null;
  /** Mailing and shipping address for the customer. Appears on invoices emailed to this customer. */
  shipping: StripeCustomerShipping | null;
  /** The customer's payment sources, if any. */
  sources?: StripeApiListStripeCustomerSource;
  /** The customer's current subscriptions, if any. */
  subscriptions?: StripeApiListInterface1840160676871133518401606768525530184016067666255301840160676642553218401606760255321840160676025533;
  tax?: StripeCustomerTax;
  /** Describes the customer's tax exemption status. One of `none`, `exempt`, or `reverse`. When set to `reverse`, invoice and receipt PDFs include the text **"Reverse charge"**. */
  tax_exempt?: StripeCustomerTaxExempt | null;
  /** The customer's tax IDs. */
  tax_ids?: StripeApiListStripeTaxId;
  /** ID of the test clock this customer belongs to. */
  test_clock?: string | StripeTestHelpersTestClock | null;
}

/** The Address object. */
export interface StripeAddress {
  /** City/District/Suburb/Town/Village. */
  city: string | null;
  /** 2-letter country code. */
  country: string | null;
  /** Address line 1 (Street address/PO Box/Company name). */
  line1: string | null;
  /** Address line 2 (Apartment/Suite/Unit/Building). */
  line2: string | null;
  /** ZIP or postal code. */
  postal_code: string | null;
  /** State/County/Province/Region. */
  state: string | null;
}

/** A customer's `Cash balance` represents real funds. Customers can add funds to their cash balance by sending a bank transfer. These funds can be used for payment and can eventually be paid out to your bank account. */
export interface StripeCashBalance {
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'cash_balance';
  /** A hash of all cash balances available to this customer. You cannot delete a customer with any cash balances, even if the balance is 0. Amounts are represented in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  available: Record<string, number> | null;
  /** The ID of the customer whose cash balance this object represents. */
  customer: string;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  settings: StripeCashBalanceSettings;
}

export interface StripeCashBalanceSettings {
  /** The configuration for how funds that land in the customer cash balance are reconciled. */
  reconciliation_mode: StripeCashBalanceSettingsReconciliationMode;
  /** A flag to indicate if reconciliation mode returned is the user's default or is specific to this customer cash balance */
  using_merchant_default: boolean;
}

export enum StripeCashBalanceSettingsReconciliationMode {
  Automatic = 'automatic',
  Manual = 'manual',
}

export type StripeCustomerSource = StripeAccountDebitSource | StripeBankAccount | StripeCard | StripeSource;

/** The resulting source of [a Connect platform debiting a connected account](https://stripe.com/docs/connect/account-debits#charging-a-connected-account). */
export interface StripeAccountDebitSource {
  id: string;
  object: 'account';
}

/**
 * These bank accounts are payment methods on `Customer` objects.
 *
 * On the other hand [External Accounts](https://stripe.com/docs/api#external_accounts) are transfer destinations on `Account` objects for [Custom accounts](https://stripe.com/docs/connect/custom-accounts). They can be bank accounts or debit cards as well, and are documented in the links above.
 *
 * Related guide: [Bank debits and transfers](https://stripe.com/docs/payments/bank-debits-transfers)
 */
export interface StripeBankAccount {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'bank_account';
  /** The ID of the account that the bank account is associated with. */
  account?: string | StripeAccount | null;
  /** The name of the person or business that owns the bank account. */
  account_holder_name: string | null;
  /** The type of entity that holds the account. This can be either `individual` or `company`. */
  account_holder_type: string | null;
  /** The bank account type. This can only be `checking` or `savings` in most countries. In Japan, this can only be `futsu` or `toza`. */
  account_type: string | null;
  /** A set of available payout methods for this bank account. Only values from this set should be passed as the `method` when creating a payout. */
  available_payout_methods?: StripeBankAccountAvailablePayoutMethod[] | null;
  /** Name of the bank associated with the routing number (e.g., `WELLS FARGO`). */
  bank_name: string | null;
  /** Two-letter ISO code representing the country the bank account is located in. */
  country: string;
  /** Three-letter [ISO code for the currency](https://stripe.com/docs/payouts) paid out to the bank account. */
  currency: string;
  /** The ID of the customer that the bank account is associated with. */
  customer?: string | StripeCustomer | StripeDeletedCustomer | null;
  /** Whether this bank account is the default external account for its currency. */
  default_for_currency?: boolean | null;
  deleted?: null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Information about upcoming new requirements for the bank account, including what information needs to be collected. */
  future_requirements?: StripeBankAccountFutureRequirements | null;
  /** The last four digits of the bank account number. */
  last4: string;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata?: StripeMetadata | null;
  /** Information about the requirements for the bank account, including what information needs to be collected. */
  requirements?: StripeBankAccountRequirements | null;
  /** The routing transit number for the bank account. */
  routing_number: string | null;
  /**
   * For bank accounts, possible values are `new`, `validated`, `verified`, `verification_failed`, or `errored`. A bank account that hasn't had any activity or validation performed is `new`. If Stripe can determine that the bank account exists, its status will be `validated`. Note that there often isn't enough information to know (e.g., for smaller credit unions), and the validation is not always run. If customer bank account verification has succeeded, the bank account status will be `verified`. If the verification failed for any reason, such as microdeposit failure, the status will be `verification_failed`. If a transfer sent to this bank account fails, we'll set the status to `errored` and will not continue to send transfers until the bank details are updated.
   *
   * For external accounts, possible values are `new`, `errored` and `verification_failed`. If a transfer fails, the status is set to `errored` and transfers are stopped until account details are updated. In India, if we can't [verify the owner of the bank account](https://support.stripe.com/questions/bank-account-ownership-verification), we'll set the status to `verification_failed`. Other validations aren't run against external accounts because they're only used for payouts. This means the other statuses don't apply.
   */
  status: string;
}

/**
 * This is an object representing a Stripe account. You can retrieve it to see properties on the account like its current requirements or if the account is enabled to make live charges or receive payouts.
 *
 * For Custom accounts, the properties below are always returned. For other accounts, some properties are returned until that account has started to go through Connect Onboarding. Once you create an [Account Link](https://stripe.com/docs/api/account_links) for a Standard or Express account, some parameters are no longer returned. These are marked as **Custom Only** or **Custom and Express** below. Learn about the differences [between accounts](https://stripe.com/docs/connect/accounts).
 */
export interface StripeAccount {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'account';
  /** Business information about the account. */
  business_profile?: StripeAccountBusinessProfile | null;
  /** The business type. */
  business_type?: StripeAccountBusinessType | null;
  capabilities?: StripeAccountCapabilities;
  /** Whether the account can create live charges. */
  charges_enabled: boolean;
  company?: StripeAccountCompany;
  controller?: StripeAccountController;
  /** The account's country. */
  country?: string;
  /** Time at which the account was connected. Measured in seconds since the Unix epoch. */
  created?: number;
  /** Three-letter ISO currency code representing the default currency for the account. This must be a currency that [Stripe supports in the account's country](https://stripe.com/docs/payouts). */
  default_currency?: string;
  deleted?: null;
  /** Whether account details have been submitted. Standard accounts cannot receive payouts before this is true. */
  details_submitted: boolean;
  /** An email address associated with the account. It's not used for authentication and Stripe doesn't market to this field without explicit approval from the platform. */
  email: string | null;
  /** External accounts (bank accounts and debit cards) currently attached to this account */
  external_accounts?: StripeApiListInterface213819169487496921381916948513884213819169466138842138191694641388621381916940138862138191694013887StripeCard;
  future_requirements?: StripeAccountFutureRequirements;
  /**
   * This is an object representing a person associated with a Stripe account.
   *
   * A platform cannot access a Standard or Express account's persons after the account starts onboarding, such as after generating an account link for the account. See the [Standard onboarding](https://stripe.com/docs/connect/standard-accounts) or [Express onboarding documentation](https://stripe.com/docs/connect/express-accounts) for information about platform pre-filling and account onboarding steps.
   *
   * Related guide: [Handling identity verification with the API](https://stripe.com/docs/connect/identity-verification-api#person-information)
   */
  individual?: StripePerson;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata?: StripeMetadata;
  /** Whether Stripe can send payouts to this account. */
  payouts_enabled: boolean;
  requirements?: StripeAccountRequirements;
  /** Options for customizing how the account functions within Stripe. */
  settings?: StripeAccountSettings | null;
  tos_acceptance?: StripeAccountTosAcceptance;
  /** The Stripe account type. Can be `standard`, `express`, or `custom`. */
  type: StripeAccountType;
}

export interface StripeAccountBusinessProfile {
  /** [The merchant category code for the account](https://stripe.com/docs/connect/setting-mcc). MCCs are used to classify businesses based on the goods or services they provide. */
  mcc: string | null;
  /** The customer-facing business name. */
  name: string | null;
  /** Internal-only description of the product sold or service provided by the business. It's used by Stripe for risk and underwriting purposes. */
  product_description?: string | null;
  /** A publicly available mailing address for sending support issues to. */
  support_address: StripeAddress | null;
  /** A publicly available email address for sending support issues to. */
  support_email: string | null;
  /** A publicly available phone number to call with support issues. */
  support_phone: string | null;
  /** A publicly available website for handling support issues. */
  support_url: string | null;
  /** The business's publicly available website. */
  url: string | null;
}

export enum StripeAccountBusinessType {
  Company = 'company',
  GovernmentEntity = 'government_entity',
  Individual = 'individual',
  NonProfit = 'non_profit',
}

export interface StripeAccountCapabilities {
  /** The status of the Canadian pre-authorized debits payments capability of the account, or whether the account can directly process Canadian pre-authorized debits charges. */
  acss_debit_payments?: StripeAccountCapabilitiesAcssDebitPayments;
  /** The status of the Affirm capability of the account, or whether the account can directly process Affirm charges. */
  affirm_payments?: StripeAccountCapabilitiesAffirmPayments;
  /** The status of the Afterpay Clearpay capability of the account, or whether the account can directly process Afterpay Clearpay charges. */
  afterpay_clearpay_payments?: StripeAccountCapabilitiesAfterpayClearpayPayments;
  /** The status of the BECS Direct Debit (AU) payments capability of the account, or whether the account can directly process BECS Direct Debit (AU) charges. */
  au_becs_debit_payments?: StripeAccountCapabilitiesAuBecsDebitPayments;
  /** The status of the Bacs Direct Debits payments capability of the account, or whether the account can directly process Bacs Direct Debits charges. */
  bacs_debit_payments?: StripeAccountCapabilitiesBacsDebitPayments;
  /** The status of the Bancontact payments capability of the account, or whether the account can directly process Bancontact charges. */
  bancontact_payments?: StripeAccountCapabilitiesBancontactPayments;
  /** The status of the customer_balance payments capability of the account, or whether the account can directly process customer_balance charges. */
  bank_transfer_payments?: StripeAccountCapabilitiesBankTransferPayments;
  /** The status of the blik payments capability of the account, or whether the account can directly process blik charges. */
  blik_payments?: StripeAccountCapabilitiesBlikPayments;
  /** The status of the boleto payments capability of the account, or whether the account can directly process boleto charges. */
  boleto_payments?: StripeAccountCapabilitiesBoletoPayments;
  /** The status of the card issuing capability of the account, or whether you can use Issuing to distribute funds on cards */
  card_issuing?: StripeAccountCapabilitiesCardIssuing;
  /** The status of the card payments capability of the account, or whether the account can directly process credit and debit card charges. */
  card_payments?: StripeAccountCapabilitiesCardPayments;
  /** The status of the Cartes Bancaires payments capability of the account, or whether the account can directly process Cartes Bancaires card charges in EUR currency. */
  cartes_bancaires_payments?: StripeAccountCapabilitiesCartesBancairesPayments;
  /** The status of the Cash App Pay capability of the account, or whether the account can directly process Cash App Pay payments. */
  cashapp_payments?: StripeAccountCapabilitiesCashappPayments;
  /** The status of the EPS payments capability of the account, or whether the account can directly process EPS charges. */
  eps_payments?: StripeAccountCapabilitiesEpsPayments;
  /** The status of the FPX payments capability of the account, or whether the account can directly process FPX charges. */
  fpx_payments?: StripeAccountCapabilitiesFpxPayments;
  /** The status of the giropay payments capability of the account, or whether the account can directly process giropay charges. */
  giropay_payments?: StripeAccountCapabilitiesGiropayPayments;
  /** The status of the GrabPay payments capability of the account, or whether the account can directly process GrabPay charges. */
  grabpay_payments?: StripeAccountCapabilitiesGrabpayPayments;
  /** The status of the iDEAL payments capability of the account, or whether the account can directly process iDEAL charges. */
  ideal_payments?: StripeAccountCapabilitiesIdealPayments;
  /** The status of the india_international_payments capability of the account, or whether the account can process international charges (non INR) in India. */
  india_international_payments?: StripeAccountCapabilitiesIndiaInternationalPayments;
  /** The status of the JCB payments capability of the account, or whether the account (Japan only) can directly process JCB credit card charges in JPY currency. */
  jcb_payments?: StripeAccountCapabilitiesJcbPayments;
  /** The status of the Klarna payments capability of the account, or whether the account can directly process Klarna charges. */
  klarna_payments?: StripeAccountCapabilitiesKlarnaPayments;
  /** The status of the konbini payments capability of the account, or whether the account can directly process konbini charges. */
  konbini_payments?: StripeAccountCapabilitiesKonbiniPayments;
  /** The status of the legacy payments capability of the account. */
  legacy_payments?: StripeAccountCapabilitiesLegacyPayments;
  /** The status of the link_payments capability of the account, or whether the account can directly process Link charges. */
  link_payments?: StripeAccountCapabilitiesLinkPayments;
  /** The status of the OXXO payments capability of the account, or whether the account can directly process OXXO charges. */
  oxxo_payments?: StripeAccountCapabilitiesOxxoPayments;
  /** The status of the P24 payments capability of the account, or whether the account can directly process P24 charges. */
  p24_payments?: StripeAccountCapabilitiesP24Payments;
  /** The status of the paynow payments capability of the account, or whether the account can directly process paynow charges. */
  paynow_payments?: StripeAccountCapabilitiesPaynowPayments;
  /** The status of the promptpay payments capability of the account, or whether the account can directly process promptpay charges. */
  promptpay_payments?: StripeAccountCapabilitiesPromptpayPayments;
  /** The status of the SEPA Direct Debits payments capability of the account, or whether the account can directly process SEPA Direct Debits charges. */
  sepa_debit_payments?: StripeAccountCapabilitiesSepaDebitPayments;
  /** The status of the Sofort payments capability of the account, or whether the account can directly process Sofort charges. */
  sofort_payments?: StripeAccountCapabilitiesSofortPayments;
  /** The status of the tax reporting 1099-K (US) capability of the account. */
  tax_reporting_us_1099_k?: StripeAccountCapabilitiesTaxReportingUs1099K;
  /** The status of the tax reporting 1099-MISC (US) capability of the account. */
  tax_reporting_us_1099_misc?: StripeAccountCapabilitiesTaxReportingUs1099Misc;
  /** The status of the transfers capability of the account, or whether your platform can transfer funds to the account. */
  transfers?: StripeAccountCapabilitiesTransfers;
  /** The status of the banking capability, or whether the account can have bank accounts. */
  treasury?: StripeAccountCapabilitiesTreasury;
  /** The status of the US bank account ACH payments capability of the account, or whether the account can directly process US bank account charges. */
  us_bank_account_ach_payments?: StripeAccountCapabilitiesUsBankAccountAchPayments;
  /** The status of the Zip capability of the account, or whether the account can directly process Zip charges. */
  zip_payments?: StripeAccountCapabilitiesZipPayments;
}

export enum StripeAccountCapabilitiesAcssDebitPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesAffirmPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesAfterpayClearpayPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesAuBecsDebitPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesBacsDebitPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesBancontactPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesBankTransferPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesBlikPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesBoletoPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesCardIssuing {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesCardPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesCartesBancairesPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesCashappPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesEpsPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesFpxPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesGiropayPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesGrabpayPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesIdealPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesIndiaInternationalPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesJcbPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesKlarnaPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesKonbiniPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesLegacyPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesLinkPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesOxxoPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesP24Payments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesPaynowPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesPromptpayPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesSepaDebitPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesSofortPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesTaxReportingUs1099K {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesTaxReportingUs1099Misc {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesTransfers {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesTreasury {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesUsBankAccountAchPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeAccountCapabilitiesZipPayments {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export interface StripeAccountCompany {
  /** The Address object. */
  address?: StripeAddress;
  /** The Kana variation of the company's primary address (Japan only). */
  address_kana?: StripeAccountCompanyAddressKana | null;
  /** The Kanji variation of the company's primary address (Japan only). */
  address_kanji?: StripeAccountCompanyAddressKanji | null;
  /** Whether the company's directors have been provided. This Boolean will be `true` if you've manually indicated that all directors are provided via [the `directors_provided` parameter](https://stripe.com/docs/api/accounts/update#update_account-company-directors_provided). */
  directors_provided?: boolean;
  /** Whether the company's executives have been provided. This Boolean will be `true` if you've manually indicated that all executives are provided via [the `executives_provided` parameter](https://stripe.com/docs/api/accounts/update#update_account-company-executives_provided), or if Stripe determined that sufficient executives were provided. */
  executives_provided?: boolean;
  /** The export license ID number of the company, also referred as Import Export Code (India only). */
  export_license_id?: string;
  /** The purpose code to use for export transactions (India only). */
  export_purpose_code?: string;
  /** The company's legal name. */
  name?: string | null;
  /** The Kana variation of the company's legal name (Japan only). */
  name_kana?: string | null;
  /** The Kanji variation of the company's legal name (Japan only). */
  name_kanji?: string | null;
  /** Whether the company's owners have been provided. This Boolean will be `true` if you've manually indicated that all owners are provided via [the `owners_provided` parameter](https://stripe.com/docs/api/accounts/update#update_account-company-owners_provided), or if Stripe determined that sufficient owners were provided. Stripe determines ownership requirements using both the number of owners provided and their total percent ownership (calculated by adding the `percent_ownership` of each owner together). */
  owners_provided?: boolean;
  /** This hash is used to attest that the beneficial owner information provided to Stripe is both current and correct. */
  ownership_declaration?: StripeAccountCompanyOwnershipDeclaration | null;
  /** The company's phone number (used for verification). */
  phone?: string | null;
  /** The category identifying the legal structure of the company or legal entity. See [Business structure](https://stripe.com/docs/connect/identity-verification#business-structure) for more details. */
  structure?: StripeAccountCompanyStructure;
  /** Whether the company's business ID number was provided. */
  tax_id_provided?: boolean;
  /** The jurisdiction in which the `tax_id` is registered (Germany-based companies only). */
  tax_id_registrar?: string;
  /** Whether the company's business VAT number was provided. */
  vat_id_provided?: boolean;
  /** Information on the verification state of the company. */
  verification?: StripeAccountCompanyVerification | null;
}

export interface StripeAccountCompanyAddressKana {
  /** City/Ward. */
  city: string | null;
  /** Two-letter country code ([ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)). */
  country: string | null;
  /** Block/Building number. */
  line1: string | null;
  /** Building details. */
  line2: string | null;
  /** ZIP or postal code. */
  postal_code: string | null;
  /** Prefecture. */
  state: string | null;
  /** Town/cho-me. */
  town: string | null;
}

export interface StripeAccountCompanyAddressKanji {
  /** City/Ward. */
  city: string | null;
  /** Two-letter country code ([ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)). */
  country: string | null;
  /** Block/Building number. */
  line1: string | null;
  /** Building details. */
  line2: string | null;
  /** ZIP or postal code. */
  postal_code: string | null;
  /** Prefecture. */
  state: string | null;
  /** Town/cho-me. */
  town: string | null;
}

export interface StripeAccountCompanyOwnershipDeclaration {
  /** The Unix timestamp marking when the beneficial owner attestation was made. */
  date: number | null;
  /** The IP address from which the beneficial owner attestation was made. */
  ip: string | null;
  /** The user-agent string from the browser where the beneficial owner attestation was made. */
  user_agent: string | null;
}

export enum StripeAccountCompanyStructure {
  FreeZoneEstablishment = 'free_zone_establishment',
  FreeZoneLlc = 'free_zone_llc',
  GovernmentInstrumentality = 'government_instrumentality',
  GovernmentalUnit = 'governmental_unit',
  IncorporatedNonProfit = 'incorporated_non_profit',
  LimitedLiabilityPartnership = 'limited_liability_partnership',
  Llc = 'llc',
  MultiMemberLlc = 'multi_member_llc',
  PrivateCompany = 'private_company',
  PrivateCorporation = 'private_corporation',
  PrivatePartnership = 'private_partnership',
  PublicCompany = 'public_company',
  PublicCorporation = 'public_corporation',
  PublicPartnership = 'public_partnership',
  SingleMemberLlc = 'single_member_llc',
  SoleEstablishment = 'sole_establishment',
  SoleProprietorship = 'sole_proprietorship',
  TaxExemptGovernmentInstrumentality = 'tax_exempt_government_instrumentality',
  UnincorporatedAssociation = 'unincorporated_association',
  UnincorporatedNonProfit = 'unincorporated_non_profit',
}

export interface StripeAccountCompanyVerification {
  document: StripeAccountCompanyVerificationDocument;
}

export interface StripeAccountCompanyVerificationDocument {
  /** The back of a document returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `additional_verification`. */
  back: string | StripeFile | null;
  /** A user-displayable string describing the verification state of this document. */
  details: string | null;
  /** One of `document_corrupt`, `document_expired`, `document_failed_copy`, `document_failed_greyscale`, `document_failed_other`, `document_failed_test_mode`, `document_fraudulent`, `document_incomplete`, `document_invalid`, `document_manipulated`, `document_not_readable`, `document_not_uploaded`, `document_type_not_supported`, or `document_too_large`. A machine-readable code specifying the verification state for this document. */
  details_code: string | null;
  /** The front of a document returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `additional_verification`. */
  front: string | StripeFile | null;
}

/**
 * This is an object representing a file hosted on Stripe's servers. The file may have been uploaded by yourself using the [create file](https://stripe.com/docs/api#create_file) request (for example, when uploading dispute evidence) or it may have been created by Stripe (for example, the results of a [Sigma scheduled query](https://stripe.com/docs/api#scheduled_queries)).
 *
 * Related guide: [File upload guide](https://stripe.com/docs/file-upload)
 */
export interface StripeFile {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'file';
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The time at which the file expires and is no longer available in epoch seconds. */
  expires_at: number | null;
  /** A filename for the file, suitable for saving to a filesystem. */
  filename: string | null;
  /** A list of [file links](https://stripe.com/docs/api#file_links) that point at this file. */
  links?: StripeApiListStripeFileLink | null;
  /** The [purpose](https://stripe.com/docs/file-upload#uploading-a-file) of the uploaded file. */
  purpose: StripeFilePurpose;
  /** The size in bytes of the file object. */
  size: number;
  /** A user friendly title for the document. */
  title: string | null;
  /** The type of the file returned (e.g., `csv`, `pdf`, `jpg`, or `png`). */
  type: string | null;
  /** The URL from which the file can be downloaded using your live secret API key. */
  url: string | null;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeFileLink {
  object: 'list';
  data: StripeFileLink[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/** To share the contents of a `File` object with non-Stripe users, you can create a `FileLink`. `FileLink`s contain a URL that can be used to retrieve the contents of the file without authentication. */
export interface StripeFileLink {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'file_link';
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Whether this link is already expired. */
  expired: boolean;
  /** Time at which the link expires. */
  expires_at: number | null;
  /** The file object this link points to. */
  file: string | StripeFile;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** The publicly accessible URL to download the file. */
  url: string | null;
}

/** Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
export type StripeMetadata = Record<string, string>;

export enum StripeFilePurpose {
  AccountRequirement = 'account_requirement',
  AdditionalVerification = 'additional_verification',
  BusinessIcon = 'business_icon',
  BusinessLogo = 'business_logo',
  CustomerSignature = 'customer_signature',
  DisputeEvidence = 'dispute_evidence',
  DocumentProviderIdentityDocument = 'document_provider_identity_document',
  FinanceReportRun = 'finance_report_run',
  IdentityDocument = 'identity_document',
  IdentityDocumentDownloadable = 'identity_document_downloadable',
  PciDocument = 'pci_document',
  Selfie = 'selfie',
  SigmaScheduledQuery = 'sigma_scheduled_query',
  TaxDocumentUserUpload = 'tax_document_user_upload',
  TerminalReaderSplashscreen = 'terminal_reader_splashscreen',
}

export interface StripeAccountController {
  /** `true` if the Connect application retrieving the resource controls the account and can therefore exercise [platform controls](https://stripe.com/docs/connect/platform-controls-for-standard-accounts). Otherwise, this field is null. */
  is_controller?: boolean;
  /** The controller type. Can be `application`, if a Connect application controls the account, or `account`, if the account controls itself. */
  type: StripeAccountControllerType;
}

export enum StripeAccountControllerType {
  Account = 'account',
  Application = 'application',
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListInterface213819169487496921381916948513884213819169466138842138191694641388621381916940138862138191694013887StripeCard {
  object: 'list';
  data: (StripeBankAccount | StripeCard)[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/**
 * You can store multiple cards on a customer in order to charge the customer later. You can also store multiple debit cards on a recipient in order to transfer to those cards later.
 *
 * Related guide: [Card payments with Sources](https://stripe.com/docs/sources/cards)
 */
export interface StripeCard {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'card';
  /** The account this card belongs to. This attribute will not be in the card object if the card belongs to a customer or recipient instead. */
  account?: string | StripeAccount | null;
  /** City/District/Suburb/Town/Village. */
  address_city: string | null;
  /** Billing address country, if provided when creating card. */
  address_country: string | null;
  /** Address line 1 (Street address/PO Box/Company name). */
  address_line1: string | null;
  /** If `address_line1` was provided, results of the check: `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_line1_check: string | null;
  /** Address line 2 (Apartment/Suite/Unit/Building). */
  address_line2: string | null;
  /** State/County/Province/Region. */
  address_state: string | null;
  /** ZIP or postal code. */
  address_zip: string | null;
  /** If `address_zip` was provided, results of the check: `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_zip_check: string | null;
  /** A set of available payout methods for this card. Only values from this set should be passed as the `method` when creating a payout. */
  available_payout_methods?: StripeCardAvailablePayoutMethod[] | null;
  /** Card brand. Can be `American Express`, `Diners Club`, `Discover`, `Eftpos Australia`, `JCB`, `MasterCard`, `UnionPay`, `Visa`, or `Unknown`. */
  brand: string;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** Three-letter [ISO code for currency](https://stripe.com/docs/payouts). Only applicable on accounts (not customers or recipients). The card can be used as a transfer destination for funds in this currency. */
  currency?: string | null;
  /** The customer that this card belongs to. This attribute will not be in the card object if the card belongs to an account or recipient instead. */
  customer?: string | StripeCustomer | StripeDeletedCustomer | null;
  /** If a CVC was provided, results of the check: `pass`, `fail`, `unavailable`, or `unchecked`. A result of unchecked indicates that CVC was provided but hasn't been checked yet. Checks are typically performed when attaching a card to a Customer object, or when creating a charge. For more details, see [Check if a card is valid without a charge](https://support.stripe.com/questions/check-if-a-card-is-valid-without-a-charge). */
  cvc_check: string | null;
  /** Whether this card is the default external account for its currency. */
  default_for_currency?: boolean | null;
  deleted?: null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string;
  /** (For tokenized numbers only.) The last four digits of the device account number. */
  dynamic_last4: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint?: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string;
  /** The last four digits of the card. */
  last4: string;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** Cardholder name. */
  name: string | null;
  /** For external accounts, possible values are `new` and `errored`. If a transfer fails, the status is set to `errored` and transfers are stopped until account details are updated. */
  status?: string | null;
  /** If the card number is tokenized, this is the method that was used. Can be `android_pay` (includes Google Pay), `apple_pay`, `masterpass`, `visa_checkout`, or null. */
  tokenization_method: string | null;
}

export enum StripeCardAvailablePayoutMethod {
  Instant = 'instant',
  Standard = 'standard',
}

/** The DeletedCustomer object. */
export interface StripeDeletedCustomer {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'customer';
  /** Always true for a deleted object */
  deleted: true;
}

export interface StripeAccountFutureRequirements {
  /** Fields that are due and can be satisfied by providing the corresponding alternative fields instead. */
  alternatives: StripeAccountFutureRequirementsAlternative[] | null;
  /** Date on which `future_requirements` merges with the main `requirements` hash and `future_requirements` becomes empty. After the transition, `currently_due` requirements may immediately become `past_due`, but the account may also be given a grace period depending on its enablement state prior to transitioning. */
  current_deadline: number | null;
  /** Fields that need to be collected to keep the account enabled. If not collected by `future_requirements[current_deadline]`, these fields will transition to the main `requirements` hash. */
  currently_due: string[] | null;
  /** This is typed as a string for consistency with `requirements.disabled_reason`, but it safe to assume `future_requirements.disabled_reason` is empty because fields in `future_requirements` will never disable the account. */
  disabled_reason: string | null;
  /** Fields that are `currently_due` and need to be collected again because validation or verification failed. */
  errors: StripeAccountFutureRequirementsError[] | null;
  /** Fields that need to be collected assuming all volume thresholds are reached. As they become required, they appear in `currently_due` as well. */
  eventually_due: string[] | null;
  /** Fields that weren't collected by `requirements.current_deadline`. These fields need to be collected to enable the capability on the account. New fields will never appear here; `future_requirements.past_due` will always be a subset of `requirements.past_due`. */
  past_due: string[] | null;
  /** Fields that may become required depending on the results of verification or review. Will be an empty array unless an asynchronous verification is pending. If verification fails, these fields move to `eventually_due` or `currently_due`. */
  pending_verification: string[] | null;
}

export interface StripeAccountFutureRequirementsAlternative {
  /** Fields that can be provided to satisfy all fields in `original_fields_due`. */
  alternative_fields_due: string[];
  /** Fields that are due and can be satisfied by providing all fields in `alternative_fields_due`. */
  original_fields_due: string[];
}

export interface StripeAccountFutureRequirementsError {
  /** The code for the type of error. */
  code: StripeAccountFutureRequirementsErrorCode;
  /** An informative message that indicates the error type and provides additional details about the error. */
  reason: string;
  /** The specific user onboarding requirement field (in the requirements hash) that needs to be resolved. */
  requirement: string;
}

export enum StripeAccountFutureRequirementsErrorCode {
  InvalidAddressCityStatePostalCode = 'invalid_address_city_state_postal_code',
  InvalidDobAgeUnder18 = 'invalid_dob_age_under_18',
  InvalidRepresentativeCountry = 'invalid_representative_country',
  InvalidStreetAddress = 'invalid_street_address',
  InvalidTosAcceptance = 'invalid_tos_acceptance',
  InvalidValueOther = 'invalid_value_other',
  VerificationDocumentAddressMismatch = 'verification_document_address_mismatch',
  VerificationDocumentAddressMissing = 'verification_document_address_missing',
  VerificationDocumentCorrupt = 'verification_document_corrupt',
  VerificationDocumentCountryNotSupported = 'verification_document_country_not_supported',
  VerificationDocumentDobMismatch = 'verification_document_dob_mismatch',
  VerificationDocumentDuplicateType = 'verification_document_duplicate_type',
  VerificationDocumentExpired = 'verification_document_expired',
  VerificationDocumentFailedCopy = 'verification_document_failed_copy',
  VerificationDocumentFailedGreyscale = 'verification_document_failed_greyscale',
  VerificationDocumentFailedOther = 'verification_document_failed_other',
  VerificationDocumentFailedTestMode = 'verification_document_failed_test_mode',
  VerificationDocumentFraudulent = 'verification_document_fraudulent',
  VerificationDocumentIdNumberMismatch = 'verification_document_id_number_mismatch',
  VerificationDocumentIdNumberMissing = 'verification_document_id_number_missing',
  VerificationDocumentIncomplete = 'verification_document_incomplete',
  VerificationDocumentInvalid = 'verification_document_invalid',
  VerificationDocumentIssueOrExpiryDateMissing = 'verification_document_issue_or_expiry_date_missing',
  VerificationDocumentManipulated = 'verification_document_manipulated',
  VerificationDocumentMissingBack = 'verification_document_missing_back',
  VerificationDocumentMissingFront = 'verification_document_missing_front',
  VerificationDocumentNameMismatch = 'verification_document_name_mismatch',
  VerificationDocumentNameMissing = 'verification_document_name_missing',
  VerificationDocumentNationalityMismatch = 'verification_document_nationality_mismatch',
  VerificationDocumentNotReadable = 'verification_document_not_readable',
  VerificationDocumentNotSigned = 'verification_document_not_signed',
  VerificationDocumentNotUploaded = 'verification_document_not_uploaded',
  VerificationDocumentPhotoMismatch = 'verification_document_photo_mismatch',
  VerificationDocumentTooLarge = 'verification_document_too_large',
  VerificationDocumentTypeNotSupported = 'verification_document_type_not_supported',
  VerificationFailedAddressMatch = 'verification_failed_address_match',
  VerificationFailedBusinessIecNumber = 'verification_failed_business_iec_number',
  VerificationFailedDocumentMatch = 'verification_failed_document_match',
  VerificationFailedIdNumberMatch = 'verification_failed_id_number_match',
  VerificationFailedKeyedIdentity = 'verification_failed_keyed_identity',
  VerificationFailedKeyedMatch = 'verification_failed_keyed_match',
  VerificationFailedNameMatch = 'verification_failed_name_match',
  VerificationFailedOther = 'verification_failed_other',
  VerificationFailedResidentialAddress = 'verification_failed_residential_address',
  VerificationFailedTaxIdMatch = 'verification_failed_tax_id_match',
  VerificationFailedTaxIdNotIssued = 'verification_failed_tax_id_not_issued',
  VerificationMissingExecutives = 'verification_missing_executives',
  VerificationMissingOwners = 'verification_missing_owners',
  VerificationRequiresAdditionalMemorandumOfAssociations = 'verification_requires_additional_memorandum_of_associations',
}

/**
 * This is an object representing a person associated with a Stripe account.
 *
 * A platform cannot access a Standard or Express account's persons after the account starts onboarding, such as after generating an account link for the account. See the [Standard onboarding](https://stripe.com/docs/connect/standard-accounts) or [Express onboarding documentation](https://stripe.com/docs/connect/express-accounts) for information about platform pre-filling and account onboarding steps.
 *
 * Related guide: [Handling identity verification with the API](https://stripe.com/docs/connect/identity-verification-api#person-information)
 */
export interface StripePerson {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'person';
  /** The account the person is associated with. */
  account: string;
  /** The Address object. */
  address?: StripeAddress;
  /** The Kana variation of the person's address (Japan only). */
  address_kana?: StripePersonAddressKana | null;
  /** The Kanji variation of the person's address (Japan only). */
  address_kanji?: StripePersonAddressKanji | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  deleted?: null;
  dob?: StripePersonDob;
  /** The person's email address. */
  email?: string | null;
  /** The person's first name. */
  first_name?: string | null;
  /** The Kana variation of the person's first name (Japan only). */
  first_name_kana?: string | null;
  /** The Kanji variation of the person's first name (Japan only). */
  first_name_kanji?: string | null;
  /** A list of alternate names or aliases that the person is known by. */
  full_name_aliases?: string[];
  /** Information about the upcoming new requirements for this person, including what information needs to be collected, and by when. */
  future_requirements?: StripePersonFutureRequirements | null;
  /** The person's gender (International regulations require either "male" or "female"). */
  gender?: string | null;
  /** Whether the person's `id_number` was provided. */
  id_number_provided?: boolean;
  /** Whether the person's `id_number_secondary` was provided. */
  id_number_secondary_provided?: boolean;
  /** The person's last name. */
  last_name?: string | null;
  /** The Kana variation of the person's last name (Japan only). */
  last_name_kana?: string | null;
  /** The Kanji variation of the person's last name (Japan only). */
  last_name_kanji?: string | null;
  /** The person's maiden name. */
  maiden_name?: string | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata?: StripeMetadata;
  /** The country where the person is a national. */
  nationality?: string | null;
  /** The person's phone number. */
  phone?: string | null;
  /** Indicates if the person or any of their representatives, family members, or other closely related persons, declares that they hold or have held an important public job or function, in any jurisdiction. */
  political_exposure?: StripePersonPoliticalExposure;
  /** The Address object. */
  registered_address?: StripeAddress;
  relationship?: StripePersonRelationship;
  /** Information about the requirements for this person, including what information needs to be collected, and by when. */
  requirements?: StripePersonRequirements | null;
  /** Whether the last four digits of the person's Social Security number have been provided (U.S. only). */
  ssn_last_4_provided?: boolean;
  verification?: StripePersonVerification;
}

export interface StripePersonAddressKana {
  /** City/Ward. */
  city: string | null;
  /** Two-letter country code ([ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)). */
  country: string | null;
  /** Block/Building number. */
  line1: string | null;
  /** Building details. */
  line2: string | null;
  /** ZIP or postal code. */
  postal_code: string | null;
  /** Prefecture. */
  state: string | null;
  /** Town/cho-me. */
  town: string | null;
}

export interface StripePersonAddressKanji {
  /** City/Ward. */
  city: string | null;
  /** Two-letter country code ([ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)). */
  country: string | null;
  /** Block/Building number. */
  line1: string | null;
  /** Building details. */
  line2: string | null;
  /** ZIP or postal code. */
  postal_code: string | null;
  /** Prefecture. */
  state: string | null;
  /** Town/cho-me. */
  town: string | null;
}

export interface StripePersonDob {
  /** The day of birth, between 1 and 31. */
  day: number | null;
  /** The month of birth, between 1 and 12. */
  month: number | null;
  /** The four-digit year of birth. */
  year: number | null;
}

export interface StripePersonFutureRequirements {
  /** Fields that are due and can be satisfied by providing the corresponding alternative fields instead. */
  alternatives: StripePersonFutureRequirementsAlternative[] | null;
  /** Fields that need to be collected to keep the person's account enabled. If not collected by the account's `future_requirements[current_deadline]`, these fields will transition to the main `requirements` hash, and may immediately become `past_due`, but the account may also be given a grace period depending on the account's enablement state prior to transition. */
  currently_due: string[];
  /** Fields that are `currently_due` and need to be collected again because validation or verification failed. */
  errors: StripePersonFutureRequirementsError[];
  /** Fields that need to be collected assuming all volume thresholds are reached. As they become required, they appear in `currently_due` as well, and the account's `future_requirements[current_deadline]` becomes set. */
  eventually_due: string[];
  /** Fields that weren't collected by the account's `requirements.current_deadline`. These fields need to be collected to enable the person's account. New fields will never appear here; `future_requirements.past_due` will always be a subset of `requirements.past_due`. */
  past_due: string[];
  /** Fields that may become required depending on the results of verification or review. Will be an empty array unless an asynchronous verification is pending. If verification fails, these fields move to `eventually_due` or `currently_due`. */
  pending_verification: string[];
}

export interface StripePersonFutureRequirementsAlternative {
  /** Fields that can be provided to satisfy all fields in `original_fields_due`. */
  alternative_fields_due: string[];
  /** Fields that are due and can be satisfied by providing all fields in `alternative_fields_due`. */
  original_fields_due: string[];
}

export interface StripePersonFutureRequirementsError {
  /** The code for the type of error. */
  code: StripePersonFutureRequirementsErrorCode;
  /** An informative message that indicates the error type and provides additional details about the error. */
  reason: string;
  /** The specific user onboarding requirement field (in the requirements hash) that needs to be resolved. */
  requirement: string;
}

export enum StripePersonFutureRequirementsErrorCode {
  InvalidAddressCityStatePostalCode = 'invalid_address_city_state_postal_code',
  InvalidDobAgeUnder18 = 'invalid_dob_age_under_18',
  InvalidRepresentativeCountry = 'invalid_representative_country',
  InvalidStreetAddress = 'invalid_street_address',
  InvalidTosAcceptance = 'invalid_tos_acceptance',
  InvalidValueOther = 'invalid_value_other',
  VerificationDocumentAddressMismatch = 'verification_document_address_mismatch',
  VerificationDocumentAddressMissing = 'verification_document_address_missing',
  VerificationDocumentCorrupt = 'verification_document_corrupt',
  VerificationDocumentCountryNotSupported = 'verification_document_country_not_supported',
  VerificationDocumentDobMismatch = 'verification_document_dob_mismatch',
  VerificationDocumentDuplicateType = 'verification_document_duplicate_type',
  VerificationDocumentExpired = 'verification_document_expired',
  VerificationDocumentFailedCopy = 'verification_document_failed_copy',
  VerificationDocumentFailedGreyscale = 'verification_document_failed_greyscale',
  VerificationDocumentFailedOther = 'verification_document_failed_other',
  VerificationDocumentFailedTestMode = 'verification_document_failed_test_mode',
  VerificationDocumentFraudulent = 'verification_document_fraudulent',
  VerificationDocumentIdNumberMismatch = 'verification_document_id_number_mismatch',
  VerificationDocumentIdNumberMissing = 'verification_document_id_number_missing',
  VerificationDocumentIncomplete = 'verification_document_incomplete',
  VerificationDocumentInvalid = 'verification_document_invalid',
  VerificationDocumentIssueOrExpiryDateMissing = 'verification_document_issue_or_expiry_date_missing',
  VerificationDocumentManipulated = 'verification_document_manipulated',
  VerificationDocumentMissingBack = 'verification_document_missing_back',
  VerificationDocumentMissingFront = 'verification_document_missing_front',
  VerificationDocumentNameMismatch = 'verification_document_name_mismatch',
  VerificationDocumentNameMissing = 'verification_document_name_missing',
  VerificationDocumentNationalityMismatch = 'verification_document_nationality_mismatch',
  VerificationDocumentNotReadable = 'verification_document_not_readable',
  VerificationDocumentNotSigned = 'verification_document_not_signed',
  VerificationDocumentNotUploaded = 'verification_document_not_uploaded',
  VerificationDocumentPhotoMismatch = 'verification_document_photo_mismatch',
  VerificationDocumentTooLarge = 'verification_document_too_large',
  VerificationDocumentTypeNotSupported = 'verification_document_type_not_supported',
  VerificationFailedAddressMatch = 'verification_failed_address_match',
  VerificationFailedBusinessIecNumber = 'verification_failed_business_iec_number',
  VerificationFailedDocumentMatch = 'verification_failed_document_match',
  VerificationFailedIdNumberMatch = 'verification_failed_id_number_match',
  VerificationFailedKeyedIdentity = 'verification_failed_keyed_identity',
  VerificationFailedKeyedMatch = 'verification_failed_keyed_match',
  VerificationFailedNameMatch = 'verification_failed_name_match',
  VerificationFailedOther = 'verification_failed_other',
  VerificationFailedResidentialAddress = 'verification_failed_residential_address',
  VerificationFailedTaxIdMatch = 'verification_failed_tax_id_match',
  VerificationFailedTaxIdNotIssued = 'verification_failed_tax_id_not_issued',
  VerificationMissingExecutives = 'verification_missing_executives',
  VerificationMissingOwners = 'verification_missing_owners',
  VerificationRequiresAdditionalMemorandumOfAssociations = 'verification_requires_additional_memorandum_of_associations',
}

export enum StripePersonPoliticalExposure {
  Existing = 'existing',
  None = 'none',
}

export interface StripePersonRelationship {
  /** Whether the person is a director of the account's legal entity. Directors are typically members of the governing board of the company, or responsible for ensuring the company meets its regulatory obligations. */
  director: boolean | null;
  /** Whether the person has significant responsibility to control, manage, or direct the organization. */
  executive: boolean | null;
  /** Whether the person is an owner of the account's legal entity. */
  owner: boolean | null;
  /** The percent owned by the person of the account's legal entity. */
  percent_ownership: number | null;
  /** Whether the person is authorized as the primary representative of the account. This is the person nominated by the business to provide information about themselves, and general information about the account. There can only be one representative at any given time. At the time the account is created, this person should be set to the person responsible for opening the account. */
  representative: boolean | null;
  /** The person's title (e.g., CEO, Support Engineer). */
  title: string | null;
}

export interface StripePersonRequirements {
  /** Fields that are due and can be satisfied by providing the corresponding alternative fields instead. */
  alternatives: StripePersonRequirementsAlternative[] | null;
  /** Fields that need to be collected to keep the person's account enabled. If not collected by the account's `current_deadline`, these fields appear in `past_due` as well, and the account is disabled. */
  currently_due: string[];
  /** Fields that are `currently_due` and need to be collected again because validation or verification failed. */
  errors: StripePersonRequirementsError[];
  /** Fields that need to be collected assuming all volume thresholds are reached. As they become required, they appear in `currently_due` as well, and the account's `current_deadline` becomes set. */
  eventually_due: string[];
  /** Fields that weren't collected by the account's `current_deadline`. These fields need to be collected to enable the person's account. */
  past_due: string[];
  /** Fields that may become required depending on the results of verification or review. Will be an empty array unless an asynchronous verification is pending. If verification fails, these fields move to `eventually_due`, `currently_due`, or `past_due`. */
  pending_verification: string[];
}

export interface StripePersonRequirementsAlternative {
  /** Fields that can be provided to satisfy all fields in `original_fields_due`. */
  alternative_fields_due: string[];
  /** Fields that are due and can be satisfied by providing all fields in `alternative_fields_due`. */
  original_fields_due: string[];
}

export interface StripePersonRequirementsError {
  /** The code for the type of error. */
  code: StripePersonRequirementsErrorCode;
  /** An informative message that indicates the error type and provides additional details about the error. */
  reason: string;
  /** The specific user onboarding requirement field (in the requirements hash) that needs to be resolved. */
  requirement: string;
}

export enum StripePersonRequirementsErrorCode {
  InvalidAddressCityStatePostalCode = 'invalid_address_city_state_postal_code',
  InvalidDobAgeUnder18 = 'invalid_dob_age_under_18',
  InvalidRepresentativeCountry = 'invalid_representative_country',
  InvalidStreetAddress = 'invalid_street_address',
  InvalidTosAcceptance = 'invalid_tos_acceptance',
  InvalidValueOther = 'invalid_value_other',
  VerificationDocumentAddressMismatch = 'verification_document_address_mismatch',
  VerificationDocumentAddressMissing = 'verification_document_address_missing',
  VerificationDocumentCorrupt = 'verification_document_corrupt',
  VerificationDocumentCountryNotSupported = 'verification_document_country_not_supported',
  VerificationDocumentDobMismatch = 'verification_document_dob_mismatch',
  VerificationDocumentDuplicateType = 'verification_document_duplicate_type',
  VerificationDocumentExpired = 'verification_document_expired',
  VerificationDocumentFailedCopy = 'verification_document_failed_copy',
  VerificationDocumentFailedGreyscale = 'verification_document_failed_greyscale',
  VerificationDocumentFailedOther = 'verification_document_failed_other',
  VerificationDocumentFailedTestMode = 'verification_document_failed_test_mode',
  VerificationDocumentFraudulent = 'verification_document_fraudulent',
  VerificationDocumentIdNumberMismatch = 'verification_document_id_number_mismatch',
  VerificationDocumentIdNumberMissing = 'verification_document_id_number_missing',
  VerificationDocumentIncomplete = 'verification_document_incomplete',
  VerificationDocumentInvalid = 'verification_document_invalid',
  VerificationDocumentIssueOrExpiryDateMissing = 'verification_document_issue_or_expiry_date_missing',
  VerificationDocumentManipulated = 'verification_document_manipulated',
  VerificationDocumentMissingBack = 'verification_document_missing_back',
  VerificationDocumentMissingFront = 'verification_document_missing_front',
  VerificationDocumentNameMismatch = 'verification_document_name_mismatch',
  VerificationDocumentNameMissing = 'verification_document_name_missing',
  VerificationDocumentNationalityMismatch = 'verification_document_nationality_mismatch',
  VerificationDocumentNotReadable = 'verification_document_not_readable',
  VerificationDocumentNotSigned = 'verification_document_not_signed',
  VerificationDocumentNotUploaded = 'verification_document_not_uploaded',
  VerificationDocumentPhotoMismatch = 'verification_document_photo_mismatch',
  VerificationDocumentTooLarge = 'verification_document_too_large',
  VerificationDocumentTypeNotSupported = 'verification_document_type_not_supported',
  VerificationFailedAddressMatch = 'verification_failed_address_match',
  VerificationFailedBusinessIecNumber = 'verification_failed_business_iec_number',
  VerificationFailedDocumentMatch = 'verification_failed_document_match',
  VerificationFailedIdNumberMatch = 'verification_failed_id_number_match',
  VerificationFailedKeyedIdentity = 'verification_failed_keyed_identity',
  VerificationFailedKeyedMatch = 'verification_failed_keyed_match',
  VerificationFailedNameMatch = 'verification_failed_name_match',
  VerificationFailedOther = 'verification_failed_other',
  VerificationFailedResidentialAddress = 'verification_failed_residential_address',
  VerificationFailedTaxIdMatch = 'verification_failed_tax_id_match',
  VerificationFailedTaxIdNotIssued = 'verification_failed_tax_id_not_issued',
  VerificationMissingExecutives = 'verification_missing_executives',
  VerificationMissingOwners = 'verification_missing_owners',
  VerificationRequiresAdditionalMemorandumOfAssociations = 'verification_requires_additional_memorandum_of_associations',
}

export interface StripePersonVerification {
  /** A document showing address, either a passport, local ID card, or utility bill from a well-known utility company. */
  additional_document?: StripePersonVerificationAdditionalDocument | null;
  /** A user-displayable string describing the verification state for the person. For example, this may say "Provided identity information could not be verified". */
  details?: string | null;
  /** One of `document_address_mismatch`, `document_dob_mismatch`, `document_duplicate_type`, `document_id_number_mismatch`, `document_name_mismatch`, `document_nationality_mismatch`, `failed_keyed_identity`, or `failed_other`. A machine-readable code specifying the verification state for the person. */
  details_code?: string | null;
  document?: StripePersonVerificationDocument;
  /** The state of verification for the person. Possible values are `unverified`, `pending`, or `verified`. */
  status: string;
}

export interface StripePersonVerificationAdditionalDocument {
  /** The back of an ID returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `identity_document`. */
  back: string | StripeFile | null;
  /** A user-displayable string describing the verification state of this document. For example, if a document is uploaded and the picture is too fuzzy, this may say "Identity document is too unclear to read". */
  details: string | null;
  /** One of `document_corrupt`, `document_country_not_supported`, `document_expired`, `document_failed_copy`, `document_failed_other`, `document_failed_test_mode`, `document_fraudulent`, `document_failed_greyscale`, `document_incomplete`, `document_invalid`, `document_manipulated`, `document_missing_back`, `document_missing_front`, `document_not_readable`, `document_not_uploaded`, `document_photo_mismatch`, `document_too_large`, or `document_type_not_supported`. A machine-readable code specifying the verification state for this document. */
  details_code: string | null;
  /** The front of an ID returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `identity_document`. */
  front: string | StripeFile | null;
}

export interface StripePersonVerificationDocument {
  /** The back of an ID returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `identity_document`. */
  back: string | StripeFile | null;
  /** A user-displayable string describing the verification state of this document. For example, if a document is uploaded and the picture is too fuzzy, this may say "Identity document is too unclear to read". */
  details: string | null;
  /** One of `document_corrupt`, `document_country_not_supported`, `document_expired`, `document_failed_copy`, `document_failed_other`, `document_failed_test_mode`, `document_fraudulent`, `document_failed_greyscale`, `document_incomplete`, `document_invalid`, `document_manipulated`, `document_missing_back`, `document_missing_front`, `document_not_readable`, `document_not_uploaded`, `document_photo_mismatch`, `document_too_large`, or `document_type_not_supported`. A machine-readable code specifying the verification state for this document. */
  details_code: string | null;
  /** The front of an ID returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `identity_document`. */
  front: string | StripeFile | null;
}

export interface StripeAccountRequirements {
  /** Fields that are due and can be satisfied by providing the corresponding alternative fields instead. */
  alternatives: StripeAccountRequirementsAlternative[] | null;
  /** Date by which the fields in `currently_due` must be collected to keep the account enabled. These fields may disable the account sooner if the next threshold is reached before they are collected. */
  current_deadline: number | null;
  /** Fields that need to be collected to keep the account enabled. If not collected by `current_deadline`, these fields appear in `past_due` as well, and the account is disabled. */
  currently_due: string[] | null;
  /** If the account is disabled, this string describes why. Can be `requirements.past_due`, `requirements.pending_verification`, `listed`, `platform_paused`, `rejected.fraud`, `rejected.listed`, `rejected.terms_of_service`, `rejected.other`, `under_review`, or `other`. */
  disabled_reason: string | null;
  /** Fields that are `currently_due` and need to be collected again because validation or verification failed. */
  errors: StripeAccountRequirementsError[] | null;
  /** Fields that need to be collected assuming all volume thresholds are reached. As they become required, they appear in `currently_due` as well, and `current_deadline` becomes set. */
  eventually_due: string[] | null;
  /** Fields that weren't collected by `current_deadline`. These fields need to be collected to enable the account. */
  past_due: string[] | null;
  /** Fields that may become required depending on the results of verification or review. Will be an empty array unless an asynchronous verification is pending. If verification fails, these fields move to `eventually_due`, `currently_due`, or `past_due`. */
  pending_verification: string[] | null;
}

export interface StripeAccountRequirementsAlternative {
  /** Fields that can be provided to satisfy all fields in `original_fields_due`. */
  alternative_fields_due: string[];
  /** Fields that are due and can be satisfied by providing all fields in `alternative_fields_due`. */
  original_fields_due: string[];
}

export interface StripeAccountRequirementsError {
  /** The code for the type of error. */
  code: StripeAccountRequirementsErrorCode;
  /** An informative message that indicates the error type and provides additional details about the error. */
  reason: string;
  /** The specific user onboarding requirement field (in the requirements hash) that needs to be resolved. */
  requirement: string;
}

export enum StripeAccountRequirementsErrorCode {
  InvalidAddressCityStatePostalCode = 'invalid_address_city_state_postal_code',
  InvalidDobAgeUnder18 = 'invalid_dob_age_under_18',
  InvalidRepresentativeCountry = 'invalid_representative_country',
  InvalidStreetAddress = 'invalid_street_address',
  InvalidTosAcceptance = 'invalid_tos_acceptance',
  InvalidValueOther = 'invalid_value_other',
  VerificationDocumentAddressMismatch = 'verification_document_address_mismatch',
  VerificationDocumentAddressMissing = 'verification_document_address_missing',
  VerificationDocumentCorrupt = 'verification_document_corrupt',
  VerificationDocumentCountryNotSupported = 'verification_document_country_not_supported',
  VerificationDocumentDobMismatch = 'verification_document_dob_mismatch',
  VerificationDocumentDuplicateType = 'verification_document_duplicate_type',
  VerificationDocumentExpired = 'verification_document_expired',
  VerificationDocumentFailedCopy = 'verification_document_failed_copy',
  VerificationDocumentFailedGreyscale = 'verification_document_failed_greyscale',
  VerificationDocumentFailedOther = 'verification_document_failed_other',
  VerificationDocumentFailedTestMode = 'verification_document_failed_test_mode',
  VerificationDocumentFraudulent = 'verification_document_fraudulent',
  VerificationDocumentIdNumberMismatch = 'verification_document_id_number_mismatch',
  VerificationDocumentIdNumberMissing = 'verification_document_id_number_missing',
  VerificationDocumentIncomplete = 'verification_document_incomplete',
  VerificationDocumentInvalid = 'verification_document_invalid',
  VerificationDocumentIssueOrExpiryDateMissing = 'verification_document_issue_or_expiry_date_missing',
  VerificationDocumentManipulated = 'verification_document_manipulated',
  VerificationDocumentMissingBack = 'verification_document_missing_back',
  VerificationDocumentMissingFront = 'verification_document_missing_front',
  VerificationDocumentNameMismatch = 'verification_document_name_mismatch',
  VerificationDocumentNameMissing = 'verification_document_name_missing',
  VerificationDocumentNationalityMismatch = 'verification_document_nationality_mismatch',
  VerificationDocumentNotReadable = 'verification_document_not_readable',
  VerificationDocumentNotSigned = 'verification_document_not_signed',
  VerificationDocumentNotUploaded = 'verification_document_not_uploaded',
  VerificationDocumentPhotoMismatch = 'verification_document_photo_mismatch',
  VerificationDocumentTooLarge = 'verification_document_too_large',
  VerificationDocumentTypeNotSupported = 'verification_document_type_not_supported',
  VerificationFailedAddressMatch = 'verification_failed_address_match',
  VerificationFailedBusinessIecNumber = 'verification_failed_business_iec_number',
  VerificationFailedDocumentMatch = 'verification_failed_document_match',
  VerificationFailedIdNumberMatch = 'verification_failed_id_number_match',
  VerificationFailedKeyedIdentity = 'verification_failed_keyed_identity',
  VerificationFailedKeyedMatch = 'verification_failed_keyed_match',
  VerificationFailedNameMatch = 'verification_failed_name_match',
  VerificationFailedOther = 'verification_failed_other',
  VerificationFailedResidentialAddress = 'verification_failed_residential_address',
  VerificationFailedTaxIdMatch = 'verification_failed_tax_id_match',
  VerificationFailedTaxIdNotIssued = 'verification_failed_tax_id_not_issued',
  VerificationMissingExecutives = 'verification_missing_executives',
  VerificationMissingOwners = 'verification_missing_owners',
  VerificationRequiresAdditionalMemorandumOfAssociations = 'verification_requires_additional_memorandum_of_associations',
}

export interface StripeAccountSettings {
  bacs_debit_payments?: StripeAccountSettingsBacsDebitPayments;
  branding: StripeAccountSettingsBranding;
  card_issuing?: StripeAccountSettingsCardIssuing;
  card_payments: StripeAccountSettingsCardPayments;
  dashboard: StripeAccountSettingsDashboard;
  payments: StripeAccountSettingsPayments;
  payouts?: StripeAccountSettingsPayouts;
  sepa_debit_payments?: StripeAccountSettingsSepaDebitPayments;
  treasury?: StripeAccountSettingsTreasury;
}

export interface StripeAccountSettingsBacsDebitPayments {
  /** The Bacs Direct Debit Display Name for this account. For payments made with Bacs Direct Debit, this will appear on the mandate, and as the statement descriptor. */
  display_name?: string;
}

export interface StripeAccountSettingsBranding {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) An icon for the account. Must be square and at least 128px x 128px. */
  icon: string | StripeFile | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) A logo for the account that will be used in Checkout instead of the icon and without the account's name next to it if provided. Must be at least 128px x 128px. */
  logo: string | StripeFile | null;
  /** A CSS hex color value representing the primary branding color for this account */
  primary_color: string | null;
  /** A CSS hex color value representing the secondary branding color for this account */
  secondary_color: string | null;
}

export interface StripeAccountSettingsCardIssuing {
  tos_acceptance?: StripeAccountSettingsCardIssuingTosAcceptance;
}

export interface StripeAccountSettingsCardIssuingTosAcceptance {
  /** The Unix timestamp marking when the account representative accepted the service agreement. */
  date: number | null;
  /** The IP address from which the account representative accepted the service agreement. */
  ip: string | null;
  /** The user agent of the browser from which the account representative accepted the service agreement. */
  user_agent?: string;
}

export interface StripeAccountSettingsCardPayments {
  decline_on?: StripeAccountSettingsCardPaymentsDeclineOn;
  /** The default text that appears on credit card statements when a charge is made. This field prefixes any dynamic `statement_descriptor` specified on the charge. `statement_descriptor_prefix` is useful for maximizing descriptor space for the dynamic portion. */
  statement_descriptor_prefix: string | null;
  /** The Kana variation of the default text that appears on credit card statements when a charge is made (Japan only). This field prefixes any dynamic `statement_descriptor_suffix_kana` specified on the charge. `statement_descriptor_prefix_kana` is useful for maximizing descriptor space for the dynamic portion. */
  statement_descriptor_prefix_kana: string | null;
  /** The Kanji variation of the default text that appears on credit card statements when a charge is made (Japan only). This field prefixes any dynamic `statement_descriptor_suffix_kanji` specified on the charge. `statement_descriptor_prefix_kanji` is useful for maximizing descriptor space for the dynamic portion. */
  statement_descriptor_prefix_kanji: string | null;
}

export interface StripeAccountSettingsCardPaymentsDeclineOn {
  /** Whether Stripe automatically declines charges with an incorrect ZIP or postal code. This setting only applies when a ZIP or postal code is provided and they fail bank verification. */
  avs_failure: boolean;
  /** Whether Stripe automatically declines charges with an incorrect CVC. This setting only applies when a CVC is provided and it fails bank verification. */
  cvc_failure: boolean;
}

export interface StripeAccountSettingsDashboard {
  /** The display name for this account. This is used on the Stripe Dashboard to differentiate between accounts. */
  display_name: string | null;
  /** The timezone used in the Stripe Dashboard for this account. A list of possible time zone values is maintained at the [IANA Time Zone Database](http://www.iana.org/time-zones). */
  timezone: string | null;
}

export interface StripeAccountSettingsPayments {
  /** The default text that appears on credit card statements when a charge is made. This field prefixes any dynamic `statement_descriptor` specified on the charge. */
  statement_descriptor: string | null;
  /** The Kana variation of the default text that appears on credit card statements when a charge is made (Japan only) */
  statement_descriptor_kana: string | null;
  /** The Kanji variation of the default text that appears on credit card statements when a charge is made (Japan only) */
  statement_descriptor_kanji: string | null;
  /** The Kana variation of the default text that appears on credit card statements when a charge is made (Japan only). This field prefixes any dynamic `statement_descriptor_suffix_kana` specified on the charge. `statement_descriptor_prefix_kana` is useful for maximizing descriptor space for the dynamic portion. */
  statement_descriptor_prefix_kana: string | null;
  /** The Kanji variation of the default text that appears on credit card statements when a charge is made (Japan only). This field prefixes any dynamic `statement_descriptor_suffix_kanji` specified on the charge. `statement_descriptor_prefix_kanji` is useful for maximizing descriptor space for the dynamic portion. */
  statement_descriptor_prefix_kanji: string | null;
}

export interface StripeAccountSettingsPayouts {
  /** A Boolean indicating if Stripe should try to reclaim negative balances from an attached bank account. See our [Understanding Connect Account Balances](https://stripe.com/docs/connect/account-balances) documentation for details. Default value is `false` for Custom accounts, otherwise `true`. */
  debit_negative_balances: boolean;
  schedule: StripeAccountSettingsPayoutsSchedule;
  /** The text that appears on the bank account statement for payouts. If not set, this defaults to the platform's bank descriptor as set in the Dashboard. */
  statement_descriptor: string | null;
}

export interface StripeAccountSettingsPayoutsSchedule {
  /** The number of days charges for the account will be held before being paid out. */
  delay_days: number;
  /** How frequently funds will be paid out. One of `manual` (payouts only created via API call), `daily`, `weekly`, or `monthly`. */
  interval: string;
  /** The day of the month funds will be paid out. Only shown if `interval` is monthly. Payouts scheduled between the 29th and 31st of the month are sent on the last day of shorter months. */
  monthly_anchor?: number;
  /** The day of the week funds will be paid out, of the style 'monday', 'tuesday', etc. Only shown if `interval` is weekly. */
  weekly_anchor?: string;
}

export interface StripeAccountSettingsSepaDebitPayments {
  /** SEPA creditor identifier that identifies the company making the payment. */
  creditor_id?: string;
}

export interface StripeAccountSettingsTreasury {
  tos_acceptance?: StripeAccountSettingsTreasuryTosAcceptance;
}

export interface StripeAccountSettingsTreasuryTosAcceptance {
  /** The Unix timestamp marking when the account representative accepted the service agreement. */
  date: number | null;
  /** The IP address from which the account representative accepted the service agreement. */
  ip: string | null;
  /** The user agent of the browser from which the account representative accepted the service agreement. */
  user_agent?: string;
}

export interface StripeAccountTosAcceptance {
  /** The Unix timestamp marking when the account representative accepted their service agreement */
  date?: number | null;
  /** The IP address from which the account representative accepted their service agreement */
  ip?: string | null;
  /** The user's service agreement type */
  service_agreement?: string;
  /** The user agent of the browser from which the account representative accepted their service agreement */
  user_agent?: string | null;
}

export enum StripeAccountType {
  Custom = 'custom',
  Express = 'express',
  Standard = 'standard',
}

export enum StripeBankAccountAvailablePayoutMethod {
  Instant = 'instant',
  Standard = 'standard',
}

export interface StripeBankAccountFutureRequirements {
  /** Fields that need to be collected to keep the external account enabled. If not collected by `current_deadline`, these fields appear in `past_due` as well, and the account is disabled. */
  currently_due: string[] | null;
  /** Fields that are `currently_due` and need to be collected again because validation or verification failed. */
  errors: StripeBankAccountFutureRequirementsError[] | null;
  /** Fields that weren't collected by `current_deadline`. These fields need to be collected to enable the external account. */
  past_due: string[] | null;
  /** Fields that may become required depending on the results of verification or review. Will be an empty array unless an asynchronous verification is pending. If verification fails, these fields move to `eventually_due`, `currently_due`, or `past_due`. */
  pending_verification: string[] | null;
}

export interface StripeBankAccountFutureRequirementsError {
  /** The code for the type of error. */
  code: StripeBankAccountFutureRequirementsErrorCode;
  /** An informative message that indicates the error type and provides additional details about the error. */
  reason: string;
  /** The specific user onboarding requirement field (in the requirements hash) that needs to be resolved. */
  requirement: string;
}

export enum StripeBankAccountFutureRequirementsErrorCode {
  InvalidAddressCityStatePostalCode = 'invalid_address_city_state_postal_code',
  InvalidDobAgeUnder18 = 'invalid_dob_age_under_18',
  InvalidRepresentativeCountry = 'invalid_representative_country',
  InvalidStreetAddress = 'invalid_street_address',
  InvalidTosAcceptance = 'invalid_tos_acceptance',
  InvalidValueOther = 'invalid_value_other',
  VerificationDocumentAddressMismatch = 'verification_document_address_mismatch',
  VerificationDocumentAddressMissing = 'verification_document_address_missing',
  VerificationDocumentCorrupt = 'verification_document_corrupt',
  VerificationDocumentCountryNotSupported = 'verification_document_country_not_supported',
  VerificationDocumentDobMismatch = 'verification_document_dob_mismatch',
  VerificationDocumentDuplicateType = 'verification_document_duplicate_type',
  VerificationDocumentExpired = 'verification_document_expired',
  VerificationDocumentFailedCopy = 'verification_document_failed_copy',
  VerificationDocumentFailedGreyscale = 'verification_document_failed_greyscale',
  VerificationDocumentFailedOther = 'verification_document_failed_other',
  VerificationDocumentFailedTestMode = 'verification_document_failed_test_mode',
  VerificationDocumentFraudulent = 'verification_document_fraudulent',
  VerificationDocumentIdNumberMismatch = 'verification_document_id_number_mismatch',
  VerificationDocumentIdNumberMissing = 'verification_document_id_number_missing',
  VerificationDocumentIncomplete = 'verification_document_incomplete',
  VerificationDocumentInvalid = 'verification_document_invalid',
  VerificationDocumentIssueOrExpiryDateMissing = 'verification_document_issue_or_expiry_date_missing',
  VerificationDocumentManipulated = 'verification_document_manipulated',
  VerificationDocumentMissingBack = 'verification_document_missing_back',
  VerificationDocumentMissingFront = 'verification_document_missing_front',
  VerificationDocumentNameMismatch = 'verification_document_name_mismatch',
  VerificationDocumentNameMissing = 'verification_document_name_missing',
  VerificationDocumentNationalityMismatch = 'verification_document_nationality_mismatch',
  VerificationDocumentNotReadable = 'verification_document_not_readable',
  VerificationDocumentNotSigned = 'verification_document_not_signed',
  VerificationDocumentNotUploaded = 'verification_document_not_uploaded',
  VerificationDocumentPhotoMismatch = 'verification_document_photo_mismatch',
  VerificationDocumentTooLarge = 'verification_document_too_large',
  VerificationDocumentTypeNotSupported = 'verification_document_type_not_supported',
  VerificationFailedAddressMatch = 'verification_failed_address_match',
  VerificationFailedBusinessIecNumber = 'verification_failed_business_iec_number',
  VerificationFailedDocumentMatch = 'verification_failed_document_match',
  VerificationFailedIdNumberMatch = 'verification_failed_id_number_match',
  VerificationFailedKeyedIdentity = 'verification_failed_keyed_identity',
  VerificationFailedKeyedMatch = 'verification_failed_keyed_match',
  VerificationFailedNameMatch = 'verification_failed_name_match',
  VerificationFailedOther = 'verification_failed_other',
  VerificationFailedResidentialAddress = 'verification_failed_residential_address',
  VerificationFailedTaxIdMatch = 'verification_failed_tax_id_match',
  VerificationFailedTaxIdNotIssued = 'verification_failed_tax_id_not_issued',
  VerificationMissingExecutives = 'verification_missing_executives',
  VerificationMissingOwners = 'verification_missing_owners',
  VerificationRequiresAdditionalMemorandumOfAssociations = 'verification_requires_additional_memorandum_of_associations',
}

export interface StripeBankAccountRequirements {
  /** Fields that need to be collected to keep the external account enabled. If not collected by `current_deadline`, these fields appear in `past_due` as well, and the account is disabled. */
  currently_due: string[] | null;
  /** Fields that are `currently_due` and need to be collected again because validation or verification failed. */
  errors: StripeBankAccountRequirementsError[] | null;
  /** Fields that weren't collected by `current_deadline`. These fields need to be collected to enable the external account. */
  past_due: string[] | null;
  /** Fields that may become required depending on the results of verification or review. Will be an empty array unless an asynchronous verification is pending. If verification fails, these fields move to `eventually_due`, `currently_due`, or `past_due`. */
  pending_verification: string[] | null;
}

export interface StripeBankAccountRequirementsError {
  /** The code for the type of error. */
  code: StripeBankAccountRequirementsErrorCode;
  /** An informative message that indicates the error type and provides additional details about the error. */
  reason: string;
  /** The specific user onboarding requirement field (in the requirements hash) that needs to be resolved. */
  requirement: string;
}

export enum StripeBankAccountRequirementsErrorCode {
  InvalidAddressCityStatePostalCode = 'invalid_address_city_state_postal_code',
  InvalidDobAgeUnder18 = 'invalid_dob_age_under_18',
  InvalidRepresentativeCountry = 'invalid_representative_country',
  InvalidStreetAddress = 'invalid_street_address',
  InvalidTosAcceptance = 'invalid_tos_acceptance',
  InvalidValueOther = 'invalid_value_other',
  VerificationDocumentAddressMismatch = 'verification_document_address_mismatch',
  VerificationDocumentAddressMissing = 'verification_document_address_missing',
  VerificationDocumentCorrupt = 'verification_document_corrupt',
  VerificationDocumentCountryNotSupported = 'verification_document_country_not_supported',
  VerificationDocumentDobMismatch = 'verification_document_dob_mismatch',
  VerificationDocumentDuplicateType = 'verification_document_duplicate_type',
  VerificationDocumentExpired = 'verification_document_expired',
  VerificationDocumentFailedCopy = 'verification_document_failed_copy',
  VerificationDocumentFailedGreyscale = 'verification_document_failed_greyscale',
  VerificationDocumentFailedOther = 'verification_document_failed_other',
  VerificationDocumentFailedTestMode = 'verification_document_failed_test_mode',
  VerificationDocumentFraudulent = 'verification_document_fraudulent',
  VerificationDocumentIdNumberMismatch = 'verification_document_id_number_mismatch',
  VerificationDocumentIdNumberMissing = 'verification_document_id_number_missing',
  VerificationDocumentIncomplete = 'verification_document_incomplete',
  VerificationDocumentInvalid = 'verification_document_invalid',
  VerificationDocumentIssueOrExpiryDateMissing = 'verification_document_issue_or_expiry_date_missing',
  VerificationDocumentManipulated = 'verification_document_manipulated',
  VerificationDocumentMissingBack = 'verification_document_missing_back',
  VerificationDocumentMissingFront = 'verification_document_missing_front',
  VerificationDocumentNameMismatch = 'verification_document_name_mismatch',
  VerificationDocumentNameMissing = 'verification_document_name_missing',
  VerificationDocumentNationalityMismatch = 'verification_document_nationality_mismatch',
  VerificationDocumentNotReadable = 'verification_document_not_readable',
  VerificationDocumentNotSigned = 'verification_document_not_signed',
  VerificationDocumentNotUploaded = 'verification_document_not_uploaded',
  VerificationDocumentPhotoMismatch = 'verification_document_photo_mismatch',
  VerificationDocumentTooLarge = 'verification_document_too_large',
  VerificationDocumentTypeNotSupported = 'verification_document_type_not_supported',
  VerificationFailedAddressMatch = 'verification_failed_address_match',
  VerificationFailedBusinessIecNumber = 'verification_failed_business_iec_number',
  VerificationFailedDocumentMatch = 'verification_failed_document_match',
  VerificationFailedIdNumberMatch = 'verification_failed_id_number_match',
  VerificationFailedKeyedIdentity = 'verification_failed_keyed_identity',
  VerificationFailedKeyedMatch = 'verification_failed_keyed_match',
  VerificationFailedNameMatch = 'verification_failed_name_match',
  VerificationFailedOther = 'verification_failed_other',
  VerificationFailedResidentialAddress = 'verification_failed_residential_address',
  VerificationFailedTaxIdMatch = 'verification_failed_tax_id_match',
  VerificationFailedTaxIdNotIssued = 'verification_failed_tax_id_not_issued',
  VerificationMissingExecutives = 'verification_missing_executives',
  VerificationMissingOwners = 'verification_missing_owners',
  VerificationRequiresAdditionalMemorandumOfAssociations = 'verification_requires_additional_memorandum_of_associations',
}

/**
 * `Source` objects allow you to accept a variety of payment methods. They represent a customer's payment instrument, and can be used with the Stripe API just like a `Card` object: once chargeable, they can be charged, or can be attached to customers.
 *
 * Stripe doesn't recommend using the deprecated [Sources API](https://stripe.com/docs/api/sources). We recommend that you adopt the [PaymentMethods API](https://stripe.com/docs/api/payment_methods). This newer API provides access to our latest features and payment method types.
 *
 * Related guides: [Sources API](https://stripe.com/docs/sources) and [Sources & Customers](https://stripe.com/docs/sources/customers).
 */
export interface StripeSource {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'source';
  ach_credit_transfer?: StripeSourceAchCreditTransfer;
  ach_debit?: StripeSourceAchDebit;
  acss_debit?: StripeSourceAcssDebit;
  alipay?: StripeSourceAlipay;
  /** A positive integer in the smallest currency unit (that is, 100 cents for $1.00, or 1 for ¥1, Japanese Yen being a zero-decimal currency) representing the total amount associated with the source. This is the amount for which the source will be chargeable once ready. Required for `single_use` sources. */
  amount: number | null;
  au_becs_debit?: StripeSourceAuBecsDebit;
  bancontact?: StripeSourceBancontact;
  card?: StripeSourceCard;
  card_present?: StripeSourceCardPresent;
  /** The client secret of the source. Used for client-side retrieval using a publishable key. */
  client_secret: string;
  code_verification?: StripeSourceCodeVerification;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO code for the currency](https://stripe.com/docs/currencies) associated with the source. This is the currency for which the source will be chargeable once ready. Required for `single_use` sources. */
  currency: string | null;
  /** The ID of the customer to which this source is attached. This will not be present when the source has not been attached to a customer. */
  customer?: string;
  eps?: StripeSourceEps;
  /** The authentication `flow` of the source. `flow` is one of `redirect`, `receiver`, `code_verification`, `none`. */
  flow: string;
  giropay?: StripeSourceGiropay;
  ideal?: StripeSourceIdeal;
  klarna?: StripeSourceKlarna;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  multibanco?: StripeSourceMultibanco;
  /** Information about the owner of the payment instrument that may be used or required by particular source types. */
  owner: StripeSourceOwner | null;
  p24?: StripeSourceP24;
  receiver?: StripeSourceReceiver;
  redirect?: StripeSourceRedirect;
  sepa_credit_transfer?: StripeSourceSepaCreditTransfer;
  sepa_debit?: StripeSourceSepaDebit;
  sofort?: StripeSourceSofort;
  source_order?: StripeSourceSourceOrder;
  /** Extra information about a source. This will appear on your customer's statement every time you charge the source. */
  statement_descriptor: string | null;
  /** The status of the source, one of `canceled`, `chargeable`, `consumed`, `failed`, or `pending`. Only `chargeable` sources can be used to create a charge. */
  status: string;
  three_d_secure?: StripeSourceThreeDSecure;
  /** The `type` of the source. The `type` is a payment method, one of `ach_credit_transfer`, `ach_debit`, `alipay`, `bancontact`, `card`, `card_present`, `eps`, `giropay`, `ideal`, `multibanco`, `klarna`, `p24`, `sepa_debit`, `sofort`, `three_d_secure`, or `wechat`. An additional hash is included on the source with a name matching this value. It contains additional information specific to the [payment method](https://stripe.com/docs/sources) used. */
  type: StripeSourceType;
  /** Either `reusable` or `single_use`. Whether this source should be reusable or not. Some source types may or may not be reusable by construction, while others may leave the option at creation. If an incompatible value is passed, an error will be returned. */
  usage: string | null;
  wechat?: StripeSourceWechat;
}

export interface StripeSourceAchCreditTransfer {
  account_number?: string | null;
  bank_name?: string | null;
  fingerprint?: string | null;
  refund_account_holder_name?: string | null;
  refund_account_holder_type?: string | null;
  refund_routing_number?: string | null;
  routing_number?: string | null;
  swift_code?: string | null;
}

export interface StripeSourceAchDebit {
  bank_name?: string | null;
  country?: string | null;
  fingerprint?: string | null;
  last4?: string | null;
  routing_number?: string | null;
  type?: string | null;
}

export interface StripeSourceAcssDebit {
  bank_address_city?: string | null;
  bank_address_line_1?: string | null;
  bank_address_line_2?: string | null;
  bank_address_postal_code?: string | null;
  bank_name?: string | null;
  category?: string | null;
  country?: string | null;
  fingerprint?: string | null;
  last4?: string | null;
  routing_number?: string | null;
}

export interface StripeSourceAlipay {
  data_string?: string | null;
  native_url?: string | null;
  statement_descriptor?: string | null;
}

export interface StripeSourceAuBecsDebit {
  bsb_number?: string | null;
  fingerprint?: string | null;
  last4?: string | null;
}

export interface StripeSourceBancontact {
  bank_code?: string | null;
  bank_name?: string | null;
  bic?: string | null;
  iban_last4?: string | null;
  preferred_language?: string | null;
  statement_descriptor?: string | null;
}

export interface StripeSourceCard {
  address_line1_check?: string | null;
  address_zip_check?: string | null;
  brand?: string | null;
  country?: string | null;
  cvc_check?: string | null;
  description?: string;
  dynamic_last4?: string | null;
  exp_month?: number | null;
  exp_year?: number | null;
  fingerprint?: string;
  funding?: string | null;
  iin?: string;
  issuer?: string;
  last4?: string | null;
  name?: string | null;
  three_d_secure?: string;
  tokenization_method?: string | null;
}

export interface StripeSourceCardPresent {
  application_cryptogram?: string;
  application_preferred_name?: string;
  authorization_code?: string | null;
  authorization_response_code?: string;
  brand?: string | null;
  country?: string | null;
  cvm_type?: string;
  data_type?: string | null;
  dedicated_file_name?: string;
  description?: string;
  emv_auth_data?: string;
  evidence_customer_signature?: string | null;
  evidence_transaction_certificate?: string | null;
  exp_month?: number | null;
  exp_year?: number | null;
  fingerprint?: string;
  funding?: string | null;
  iin?: string;
  issuer?: string;
  last4?: string | null;
  pos_device_id?: string | null;
  pos_entry_mode?: string;
  read_method?: string | null;
  reader?: string | null;
  terminal_verification_results?: string;
  transaction_status_information?: string;
}

export interface StripeSourceCodeVerification {
  /** The number of attempts remaining to authenticate the source object with a verification code. */
  attempts_remaining: number;
  /** The status of the code verification, either `pending` (awaiting verification, `attempts_remaining` should be greater than 0), `succeeded` (successful verification) or `failed` (failed verification, cannot be verified anymore as `attempts_remaining` should be 0). */
  status: string;
}

export interface StripeSourceEps {
  reference?: string | null;
  statement_descriptor?: string | null;
}

export interface StripeSourceGiropay {
  bank_code?: string | null;
  bank_name?: string | null;
  bic?: string | null;
  statement_descriptor?: string | null;
}

export interface StripeSourceIdeal {
  bank?: string | null;
  bic?: string | null;
  iban_last4?: string | null;
  statement_descriptor?: string | null;
}

export interface StripeSourceKlarna {
  background_image_url?: string;
  client_token?: string | null;
  first_name?: string;
  last_name?: string;
  locale?: string;
  logo_url?: string;
  page_title?: string;
  pay_later_asset_urls_descriptive?: string;
  pay_later_asset_urls_standard?: string;
  pay_later_name?: string;
  pay_later_redirect_url?: string;
  pay_now_asset_urls_descriptive?: string;
  pay_now_asset_urls_standard?: string;
  pay_now_name?: string;
  pay_now_redirect_url?: string;
  pay_over_time_asset_urls_descriptive?: string;
  pay_over_time_asset_urls_standard?: string;
  pay_over_time_name?: string;
  pay_over_time_redirect_url?: string;
  payment_method_categories?: string;
  purchase_country?: string;
  purchase_type?: string;
  redirect_url?: string;
  shipping_delay?: number;
  shipping_first_name?: string;
  shipping_last_name?: string;
}

export interface StripeSourceMultibanco {
  entity?: string | null;
  reference?: string | null;
  refund_account_holder_address_city?: string | null;
  refund_account_holder_address_country?: string | null;
  refund_account_holder_address_line1?: string | null;
  refund_account_holder_address_line2?: string | null;
  refund_account_holder_address_postal_code?: string | null;
  refund_account_holder_address_state?: string | null;
  refund_account_holder_name?: string | null;
  refund_iban?: string | null;
}

export interface StripeSourceOwner {
  /** Owner's address. */
  address: StripeAddress | null;
  /** Owner's email address. */
  email: string | null;
  /** Owner's full name. */
  name: string | null;
  /** Owner's phone number (including extension). */
  phone: string | null;
  /** Verified owner's address. Verified values are verified or provided by the payment method directly (and if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_address: StripeAddress | null;
  /** Verified owner's email address. Verified values are verified or provided by the payment method directly (and if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_email: string | null;
  /** Verified owner's full name. Verified values are verified or provided by the payment method directly (and if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
  /** Verified owner's phone number (including extension). Verified values are verified or provided by the payment method directly (and if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_phone: string | null;
}

export interface StripeSourceP24 {
  reference?: string | null;
}

export interface StripeSourceReceiver {
  /** The address of the receiver source. This is the value that should be communicated to the customer to send their funds to. */
  address: string | null;
  /** The total amount that was moved to your balance. This is almost always equal to the amount charged. In rare cases when customers deposit excess funds and we are unable to refund those, those funds get moved to your balance and show up in amount_charged as well. The amount charged is expressed in the source's currency. */
  amount_charged: number;
  /** The total amount received by the receiver source. `amount_received = amount_returned + amount_charged` should be true for consumed sources unless customers deposit excess funds. The amount received is expressed in the source's currency. */
  amount_received: number;
  /** The total amount that was returned to the customer. The amount returned is expressed in the source's currency. */
  amount_returned: number;
  /** Type of refund attribute method, one of `email`, `manual`, or `none`. */
  refund_attributes_method: string;
  /** Type of refund attribute status, one of `missing`, `requested`, or `available`. */
  refund_attributes_status: string;
}

export interface StripeSourceRedirect {
  /** The failure reason for the redirect, either `user_abort` (the customer aborted or dropped out of the redirect flow), `declined` (the authentication failed or the transaction was declined), or `processing_error` (the redirect failed due to a technical error). Present only if the redirect status is `failed`. */
  failure_reason: string | null;
  /** The URL you provide to redirect the customer to after they authenticated their payment. */
  return_url: string;
  /** The status of the redirect, either `pending` (ready to be used by your customer to authenticate the transaction), `succeeded` (succesful authentication, cannot be reused) or `not_required` (redirect should not be used) or `failed` (failed authentication, cannot be reused). */
  status: string;
  /** The URL provided to you to redirect a customer to as part of a `redirect` authentication flow. */
  url: string;
}

export interface StripeSourceSepaCreditTransfer {
  bank_name?: string | null;
  bic?: string | null;
  iban?: string | null;
  refund_account_holder_address_city?: string | null;
  refund_account_holder_address_country?: string | null;
  refund_account_holder_address_line1?: string | null;
  refund_account_holder_address_line2?: string | null;
  refund_account_holder_address_postal_code?: string | null;
  refund_account_holder_address_state?: string | null;
  refund_account_holder_name?: string | null;
  refund_iban?: string | null;
}

export interface StripeSourceSepaDebit {
  bank_code?: string | null;
  branch_code?: string | null;
  country?: string | null;
  fingerprint?: string | null;
  last4?: string | null;
  mandate_reference?: string | null;
  mandate_url?: string | null;
}

export interface StripeSourceSofort {
  bank_code?: string | null;
  bank_name?: string | null;
  bic?: string | null;
  country?: string | null;
  iban_last4?: string | null;
  preferred_language?: string | null;
  statement_descriptor?: string | null;
}

export interface StripeSourceSourceOrder {
  /** A positive integer in the smallest currency unit (that is, 100 cents for $1.00, or 1 for ¥1, Japanese Yen being a zero-decimal currency) representing the total amount for the order. */
  amount: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** The email address of the customer placing the order. */
  email?: string;
  /** List of items constituting the order. */
  items: StripeSourceSourceOrderItem[] | null;
  shipping?: StripeSourceSourceOrderShipping;
}

export interface StripeSourceSourceOrderItem {
  /** The amount (price) for this order item. */
  amount: number | null;
  /** This currency of this order item. Required when `amount` is present. */
  currency: string | null;
  /** Human-readable description for this order item. */
  description: string | null;
  /** The ID of the associated object for this line item. Expandable if not null (e.g., expandable to a SKU). */
  parent: string | null;
  /** The quantity of this order item. When type is `sku`, this is the number of instances of the SKU to be ordered. */
  quantity?: number;
  /** The type of this order item. Must be `sku`, `tax`, or `shipping`. */
  type: string | null;
}

export interface StripeSourceSourceOrderShipping {
  /** The Address object. */
  address?: StripeAddress;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. */
  carrier?: string | null;
  /** Recipient name. */
  name?: string;
  /** Recipient phone (including extension). */
  phone?: string | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  tracking_number?: string | null;
}

export interface StripeSourceThreeDSecure {
  address_line1_check?: string | null;
  address_zip_check?: string | null;
  authenticated?: boolean | null;
  brand?: string | null;
  card?: string | null;
  country?: string | null;
  customer?: string | null;
  cvc_check?: string | null;
  description?: string;
  dynamic_last4?: string | null;
  exp_month?: number | null;
  exp_year?: number | null;
  fingerprint?: string;
  funding?: string | null;
  iin?: string;
  issuer?: string;
  last4?: string | null;
  name?: string | null;
  three_d_secure?: string;
  tokenization_method?: string | null;
}

export enum StripeSourceType {
  AchCreditTransfer = 'ach_credit_transfer',
  AchDebit = 'ach_debit',
  AcssDebit = 'acss_debit',
  Alipay = 'alipay',
  AuBecsDebit = 'au_becs_debit',
  Bancontact = 'bancontact',
  Card = 'card',
  CardPresent = 'card_present',
  Eps = 'eps',
  Giropay = 'giropay',
  Ideal = 'ideal',
  Klarna = 'klarna',
  Multibanco = 'multibanco',
  P24 = 'p24',
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
  Sofort = 'sofort',
  ThreeDSecure = 'three_d_secure',
  Wechat = 'wechat',
}

export interface StripeSourceWechat {
  prepay_id?: string;
  qr_code_url?: string | null;
  statement_descriptor?: string;
}

/**
 * A discount represents the actual application of a [coupon](https://stripe.com/docs/api#coupons) or [promotion code](https://stripe.com/docs/api#promotion_codes). It contains information about when the discount began, when it will end, and what it is applied to.
 *
 * Related guide: [Applying discounts to subscriptions](https://stripe.com/docs/billing/subscriptions/discounts)
 */
export interface StripeDiscount {
  /** The ID of the discount object. Discounts cannot be fetched by ID. Use `expand[]=discounts` in API calls to expand discount IDs in an array. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'discount';
  /** The Checkout session that this coupon is applied to, if it is applied to a particular session in payment mode. Will not be present for subscription mode. */
  checkout_session: string | null;
  /** A coupon contains information about a percent-off or amount-off discount you might want to apply to a customer. Coupons may be applied to [subscriptions](https://stripe.com/docs/api#subscriptions), [invoices](https://stripe.com/docs/api#invoices), [checkout sessions](https://stripe.com/docs/api/checkout/sessions), [quotes](https://stripe.com/docs/api#quotes), and more. Coupons do not work with conventional one-off [charges](https://stripe.com/docs/api#create_charge) or [payment intents](https://stripe.com/docs/api/payment_intents). */
  coupon: StripeCoupon;
  /** The ID of the customer associated with this discount. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  deleted?: null;
  /** If the coupon has a duration of `repeating`, the date that this discount will end. If the coupon has a duration of `once` or `forever`, this attribute will be null. */
  end: number | null;
  /** The invoice that the discount's coupon was applied to, if it was applied directly to a particular invoice. */
  invoice: string | null;
  /** The invoice item `id` (or invoice line item `id` for invoice line items of type='subscription') that the discount's coupon was applied to, if it was applied directly to a particular invoice item or invoice line item. */
  invoice_item: string | null;
  /** The promotion code applied to create this discount. */
  promotion_code: string | StripePromotionCode | null;
  /** Date that the coupon was applied. */
  start: number;
  /** The subscription that this coupon is applied to, if it is applied to a particular subscription. */
  subscription: string | null;
}

/** A coupon contains information about a percent-off or amount-off discount you might want to apply to a customer. Coupons may be applied to [subscriptions](https://stripe.com/docs/api#subscriptions), [invoices](https://stripe.com/docs/api#invoices), [checkout sessions](https://stripe.com/docs/api/checkout/sessions), [quotes](https://stripe.com/docs/api#quotes), and more. Coupons do not work with conventional one-off [charges](https://stripe.com/docs/api#create_charge) or [payment intents](https://stripe.com/docs/api/payment_intents). */
export interface StripeCoupon {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'coupon';
  /** Amount (in the `currency` specified) that will be taken off the subtotal of any invoices for this customer. */
  amount_off: number | null;
  applies_to?: StripeCouponAppliesTo;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** If `amount_off` has been set, the three-letter [ISO code for the currency](https://stripe.com/docs/currencies) of the amount to take off. */
  currency: string | null;
  /** Coupons defined in each available currency option. Each key must be a three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html) and a [supported currency](https://stripe.com/docs/currencies). */
  currency_options?: Record<string, StripeCouponCurrencyOptions>;
  deleted?: null;
  /** One of `forever`, `once`, and `repeating`. Describes how long a customer who applies this coupon will get the discount. */
  duration: StripeCouponDuration;
  /** If `duration` is `repeating`, the number of months the coupon applies. Null if coupon `duration` is `forever` or `once`. */
  duration_in_months: number | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Maximum number of times this coupon can be redeemed, in total, across all customers, before it is no longer valid. */
  max_redemptions: number | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** Name of the coupon displayed to customers on for instance invoices or receipts. */
  name: string | null;
  /** Percent that will be taken off the subtotal of any invoices for this customer for the duration of the coupon. For example, a coupon with percent_off of 50 will make a %s100 invoice %s50 instead. */
  percent_off: number | null;
  /** Date after which the coupon can no longer be redeemed. */
  redeem_by: number | null;
  /** Number of times this coupon has been applied to a customer. */
  times_redeemed: number;
  /** Taking account of the above properties, whether this coupon can still be applied to a customer. */
  valid: boolean;
}

export interface StripeCouponAppliesTo {
  /** A list of product IDs this coupon applies to */
  products: string[];
}

export interface StripeCouponCurrencyOptions {
  /** Amount (in the `currency` specified) that will be taken off the subtotal of any invoices for this customer. */
  amount_off: number;
}

export enum StripeCouponDuration {
  Forever = 'forever',
  Once = 'once',
  Repeating = 'repeating',
}

/** A Promotion Code represents a customer-redeemable code for a [coupon](https://stripe.com/docs/api#coupons). It can be used to create multiple codes for a single coupon. */
export interface StripePromotionCode {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'promotion_code';
  /** Whether the promotion code is currently active. A promotion code is only active if the coupon is also valid. */
  active: boolean;
  /** The customer-facing code. Regardless of case, this code must be unique across all active promotion codes for each customer. */
  code: string;
  /** A coupon contains information about a percent-off or amount-off discount you might want to apply to a customer. Coupons may be applied to [subscriptions](https://stripe.com/docs/api#subscriptions), [invoices](https://stripe.com/docs/api#invoices), [checkout sessions](https://stripe.com/docs/api/checkout/sessions), [quotes](https://stripe.com/docs/api#quotes), and more. Coupons do not work with conventional one-off [charges](https://stripe.com/docs/api#create_charge) or [payment intents](https://stripe.com/docs/api/payment_intents). */
  coupon: StripeCoupon;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The customer that this promotion code can be used by. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** Date at which the promotion code can no longer be redeemed. */
  expires_at: number | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Maximum number of times this promotion code can be redeemed. */
  max_redemptions: number | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  restrictions: StripePromotionCodeRestrictions;
  /** Number of times this promotion code has been used. */
  times_redeemed: number;
}

export interface StripePromotionCodeRestrictions {
  /** Promotion code restrictions defined in each available currency option. Each key must be a three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html) and a [supported currency](https://stripe.com/docs/currencies). */
  currency_options?: Record<string, StripePromotionCodeRestrictionsCurrencyOptions>;
  /** A Boolean indicating if the Promotion Code should only be redeemed for Customers without any successful payments or invoices */
  first_time_transaction: boolean;
  /** Minimum amount required to redeem this Promotion Code into a Coupon (e.g., a purchase must be $100 or more to work). */
  minimum_amount: number | null;
  /** Three-letter [ISO code](https://stripe.com/docs/currencies) for minimum_amount */
  minimum_amount_currency: string | null;
}

export interface StripePromotionCodeRestrictionsCurrencyOptions {
  /** Minimum amount required to redeem this Promotion Code into a Coupon (e.g., a purchase must be $100 or more to work). */
  minimum_amount: number;
}

export interface StripeCustomerInvoiceSettings {
  /** Default custom fields to be displayed on invoices for this customer. */
  custom_fields: StripeCustomerInvoiceSettingsCustomField[] | null;
  /** ID of a payment method that's attached to the customer, to be used as the customer's default payment method for subscriptions and invoices. */
  default_payment_method: string | StripePaymentMethod | null;
  /** Default footer to be displayed on invoices for this customer. */
  footer: string | null;
  /** Default options for invoice PDF rendering for this customer. */
  rendering_options: StripeCustomerInvoiceSettingsRenderingOptions | null;
}

export interface StripeCustomerInvoiceSettingsCustomField {
  /** The name of the custom field. */
  name: string;
  /** The value of the custom field. */
  value: string;
}

/**
 * PaymentMethod objects represent your customer's payment instruments. You can use them with [PaymentIntents](https://stripe.com/docs/payments/payment-intents) to collect payments or save them to Customer objects to store instrument details for future payments.
 *
 * Related guides: [Payment Methods](https://stripe.com/docs/payments/payment-methods) and [More Payment Scenarios](https://stripe.com/docs/payments/more-payment-scenarios).
 */
export interface StripePaymentMethod {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'payment_method';
  acss_debit?: StripePaymentMethodAcssDebit;
  affirm?: StripePaymentMethodAffirm;
  afterpay_clearpay?: StripePaymentMethodAfterpayClearpay;
  alipay?: StripePaymentMethodAlipay;
  au_becs_debit?: StripePaymentMethodAuBecsDebit;
  bacs_debit?: StripePaymentMethodBacsDebit;
  bancontact?: StripePaymentMethodBancontact;
  billing_details: StripePaymentMethodBillingDetails;
  blik?: StripePaymentMethodBlik;
  boleto?: StripePaymentMethodBoleto;
  card?: StripePaymentMethodCard;
  card_present?: StripePaymentMethodCardPresent;
  cashapp?: StripePaymentMethodCashapp;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The ID of the Customer to which this PaymentMethod is saved. This will not be set when the PaymentMethod has not been saved to a Customer. */
  customer: string | StripeCustomer | null;
  customer_balance?: StripePaymentMethodCustomerBalance;
  eps?: StripePaymentMethodEps;
  fpx?: StripePaymentMethodFpx;
  giropay?: StripePaymentMethodGiropay;
  grabpay?: StripePaymentMethodGrabpay;
  ideal?: StripePaymentMethodIdeal;
  interac_present?: StripePaymentMethodInteracPresent;
  klarna?: StripePaymentMethodKlarna;
  konbini?: StripePaymentMethodKonbini;
  link?: StripePaymentMethodLink;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  oxxo?: StripePaymentMethodOxxo;
  p24?: StripePaymentMethodP24;
  paynow?: StripePaymentMethodPaynow;
  paypal?: StripePaymentMethodPaypal;
  pix?: StripePaymentMethodPix;
  promptpay?: StripePaymentMethodPromptpay;
  /** Options to configure Radar. See [Radar Session](https://stripe.com/docs/radar/radar-session) for more information. */
  radar_options?: StripePaymentMethodRadarOptions;
  sepa_debit?: StripePaymentMethodSepaDebit;
  sofort?: StripePaymentMethodSofort;
  /** The type of the PaymentMethod. An additional hash is included on the PaymentMethod with a name matching this value. It contains additional information specific to the PaymentMethod type. */
  type: StripePaymentMethodType;
  us_bank_account?: StripePaymentMethodUsBankAccount;
  wechat_pay?: StripePaymentMethodWechatPay;
  zip?: StripePaymentMethodZip;
}

export interface StripePaymentMethodAcssDebit {
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Institution number of the bank account. */
  institution_number: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** Transit number of the bank account. */
  transit_number: string | null;
}

export type StripePaymentMethodAffirm = object;

export type StripePaymentMethodAfterpayClearpay = object;

export type StripePaymentMethodAlipay = object;

export interface StripePaymentMethodAuBecsDebit {
  /** Six-digit number identifying bank and branch associated with this bank account. */
  bsb_number: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
}

export interface StripePaymentMethodBacsDebit {
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** Sort code of the bank account. (e.g., `10-20-30`) */
  sort_code: string | null;
}

export type StripePaymentMethodBancontact = object;

export interface StripePaymentMethodBillingDetails {
  /** Billing address. */
  address: StripeAddress | null;
  /** Email address. */
  email: string | null;
  /** Full name. */
  name: string | null;
  /** Billing phone number (including extension). */
  phone: string | null;
}

export type StripePaymentMethodBlik = object;

export interface StripePaymentMethodBoleto {
  /** Uniquely identifies the customer tax id (CNPJ or CPF) */
  tax_id: string;
}

export interface StripePaymentMethodCard {
  /** Card brand. Can be `amex`, `diners`, `discover`, `eftpos_au`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  brand: string;
  /** Checks on Card address and CVC if provided. */
  checks: StripePaymentMethodCardChecks | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint?: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string;
  /** Contains information about card networks that can be used to process the payment. */
  networks: StripePaymentMethodCardNetworks | null;
  /** Contains details on how this Card may be used for 3D Secure authentication. */
  three_d_secure_usage: StripePaymentMethodCardThreeDSecureUsage | null;
  /** If this Card is part of a card wallet, this contains the details of the card wallet. */
  wallet: StripePaymentMethodCardWallet | null;
}

export interface StripePaymentMethodCardChecks {
  /** If a address line1 was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_line1_check: string | null;
  /** If a address postal code was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_postal_code_check: string | null;
  /** If a CVC was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  cvc_check: string | null;
}

export interface StripePaymentMethodCardNetworks {
  /** All available networks for the card. */
  available: string[];
  /** The preferred network for the card. */
  preferred: string | null;
}

export interface StripePaymentMethodCardThreeDSecureUsage {
  /** Whether 3D Secure is supported on this card. */
  supported: boolean;
}

export interface StripePaymentMethodCardWallet {
  amex_express_checkout?: StripePaymentMethodCardWalletAmexExpressCheckout;
  apple_pay?: StripePaymentMethodCardWalletApplePay;
  /** (For tokenized numbers only.) The last four digits of the device account number. */
  dynamic_last4: string | null;
  google_pay?: StripePaymentMethodCardWalletGooglePay;
  link?: StripePaymentMethodCardWalletLink;
  masterpass?: StripePaymentMethodCardWalletMasterpass;
  samsung_pay?: StripePaymentMethodCardWalletSamsungPay;
  /** The type of the card wallet, one of `amex_express_checkout`, `apple_pay`, `google_pay`, `masterpass`, `samsung_pay`, `visa_checkout`, or `link`. An additional hash is included on the Wallet subhash with a name matching this value. It contains additional information specific to the card wallet type. */
  type: StripePaymentMethodCardWalletType;
  visa_checkout?: StripePaymentMethodCardWalletVisaCheckout;
}

export type StripePaymentMethodCardWalletAmexExpressCheckout = object;

export type StripePaymentMethodCardWalletApplePay = object;

export type StripePaymentMethodCardWalletGooglePay = object;

export type StripePaymentMethodCardWalletLink = object;

export interface StripePaymentMethodCardWalletMasterpass {
  /** Owner's verified billing address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  billing_address: StripeAddress | null;
  /** Owner's verified email. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  email: string | null;
  /** Owner's verified full name. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  name: string | null;
  /** Owner's verified shipping address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  shipping_address: StripeAddress | null;
}

export type StripePaymentMethodCardWalletSamsungPay = object;

export enum StripePaymentMethodCardWalletType {
  AmexExpressCheckout = 'amex_express_checkout',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  Link = 'link',
  Masterpass = 'masterpass',
  SamsungPay = 'samsung_pay',
  VisaCheckout = 'visa_checkout',
}

export interface StripePaymentMethodCardWalletVisaCheckout {
  /** Owner's verified billing address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  billing_address: StripeAddress | null;
  /** Owner's verified email. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  email: string | null;
  /** Owner's verified full name. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  name: string | null;
  /** Owner's verified shipping address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  shipping_address: StripeAddress | null;
}

export interface StripePaymentMethodCardPresent {
  /** Card brand. Can be `amex`, `diners`, `discover`, `eftpos_au`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  brand: string | null;
  /** The cardholder name as read from the card, in [ISO 7813](https://en.wikipedia.org/wiki/ISO/IEC_7813) format. May include alphanumeric characters, special characters and first/last name separator (`/`). In some cases, the cardholder name may not be available depending on how the issuer has configured the card. Cardholder name is typically not available on swipe or contactless payments, such as those made with Apple Pay and Google Pay. */
  cardholder_name: string | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string | null;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string | null;
  /** Contains information about card networks that can be used to process the payment. */
  networks: StripePaymentMethodCardPresentNetworks | null;
  /** How card details were read in this transaction. */
  read_method: StripePaymentMethodCardPresentReadMethod | null;
}

export interface StripePaymentMethodCardPresentNetworks {
  /** All available networks for the card. */
  available: string[];
  /** The preferred network for the card. */
  preferred: string | null;
}

export enum StripePaymentMethodCardPresentReadMethod {
  ContactEmv = 'contact_emv',
  ContactlessEmv = 'contactless_emv',
  ContactlessMagstripeMode = 'contactless_magstripe_mode',
  MagneticStripeFallback = 'magnetic_stripe_fallback',
  MagneticStripeTrack2 = 'magnetic_stripe_track2',
}

export interface StripePaymentMethodCashapp {
  /** A unique and immutable identifier assigned by Cash App to every buyer. */
  buyer_id: string | null;
  /** A public identifier for buyers using Cash App. */
  cashtag: string | null;
}

export type StripePaymentMethodCustomerBalance = object;

export interface StripePaymentMethodEps {
  /** The customer's bank. Should be one of `arzte_und_apotheker_bank`, `austrian_anadi_bank_ag`, `bank_austria`, `bankhaus_carl_spangler`, `bankhaus_schelhammer_und_schattera_ag`, `bawag_psk_ag`, `bks_bank_ag`, `brull_kallmus_bank_ag`, `btv_vier_lander_bank`, `capital_bank_grawe_gruppe_ag`, `deutsche_bank_ag`, `dolomitenbank`, `easybank_ag`, `erste_bank_und_sparkassen`, `hypo_alpeadriabank_international_ag`, `hypo_noe_lb_fur_niederosterreich_u_wien`, `hypo_oberosterreich_salzburg_steiermark`, `hypo_tirol_bank_ag`, `hypo_vorarlberg_bank_ag`, `hypo_bank_burgenland_aktiengesellschaft`, `marchfelder_bank`, `oberbank_ag`, `raiffeisen_bankengruppe_osterreich`, `schoellerbank_ag`, `sparda_bank_wien`, `volksbank_gruppe`, `volkskreditbank_ag`, or `vr_bank_braunau`. */
  bank: StripePaymentMethodEpsBank | null;
}

export enum StripePaymentMethodEpsBank {
  ArzteUndApothekerBank = 'arzte_und_apotheker_bank',
  AustrianAnadiBankAg = 'austrian_anadi_bank_ag',
  BankAustria = 'bank_austria',
  BankhausCarlSpangler = 'bankhaus_carl_spangler',
  BankhausSchelhammerUndSchatteraAg = 'bankhaus_schelhammer_und_schattera_ag',
  BawagPskAg = 'bawag_psk_ag',
  BksBankAg = 'bks_bank_ag',
  BrullKallmusBankAg = 'brull_kallmus_bank_ag',
  BtvVierLanderBank = 'btv_vier_lander_bank',
  CapitalBankGraweGruppeAg = 'capital_bank_grawe_gruppe_ag',
  DeutscheBankAg = 'deutsche_bank_ag',
  Dolomitenbank = 'dolomitenbank',
  EasybankAg = 'easybank_ag',
  ErsteBankUndSparkassen = 'erste_bank_und_sparkassen',
  HypoAlpeadriabankInternationalAg = 'hypo_alpeadriabank_international_ag',
  HypoBankBurgenlandAktiengesellschaft = 'hypo_bank_burgenland_aktiengesellschaft',
  HypoNoeLbFurNiederosterreichUWien = 'hypo_noe_lb_fur_niederosterreich_u_wien',
  HypoOberosterreichSalzburgSteiermark = 'hypo_oberosterreich_salzburg_steiermark',
  HypoTirolBankAg = 'hypo_tirol_bank_ag',
  HypoVorarlbergBankAg = 'hypo_vorarlberg_bank_ag',
  MarchfelderBank = 'marchfelder_bank',
  OberbankAg = 'oberbank_ag',
  RaiffeisenBankengruppeOsterreich = 'raiffeisen_bankengruppe_osterreich',
  SchoellerbankAg = 'schoellerbank_ag',
  SpardaBankWien = 'sparda_bank_wien',
  VolksbankGruppe = 'volksbank_gruppe',
  VolkskreditbankAg = 'volkskreditbank_ag',
  VrBankBraunau = 'vr_bank_braunau',
}

export interface StripePaymentMethodFpx {
  /** Account holder type, if provided. Can be one of `individual` or `company`. */
  account_holder_type: StripePaymentMethodFpxAccountHolderType | null;
  /** The customer's bank, if provided. Can be one of `affin_bank`, `agrobank`, `alliance_bank`, `ambank`, `bank_islam`, `bank_muamalat`, `bank_rakyat`, `bsn`, `cimb`, `hong_leong_bank`, `hsbc`, `kfh`, `maybank2u`, `ocbc`, `public_bank`, `rhb`, `standard_chartered`, `uob`, `deutsche_bank`, `maybank2e`, `pb_enterprise`, or `bank_of_china`. */
  bank: StripePaymentMethodFpxBank;
}

export enum StripePaymentMethodFpxAccountHolderType {
  Company = 'company',
  Individual = 'individual',
}

export enum StripePaymentMethodFpxBank {
  AffinBank = 'affin_bank',
  Agrobank = 'agrobank',
  AllianceBank = 'alliance_bank',
  Ambank = 'ambank',
  BankIslam = 'bank_islam',
  BankMuamalat = 'bank_muamalat',
  BankOfChina = 'bank_of_china',
  BankRakyat = 'bank_rakyat',
  Bsn = 'bsn',
  Cimb = 'cimb',
  DeutscheBank = 'deutsche_bank',
  HongLeongBank = 'hong_leong_bank',
  Hsbc = 'hsbc',
  Kfh = 'kfh',
  Maybank2E = 'maybank2e',
  Maybank2U = 'maybank2u',
  Ocbc = 'ocbc',
  PbEnterprise = 'pb_enterprise',
  PublicBank = 'public_bank',
  Rhb = 'rhb',
  StandardChartered = 'standard_chartered',
  Uob = 'uob',
}

export type StripePaymentMethodGiropay = object;

export type StripePaymentMethodGrabpay = object;

export interface StripePaymentMethodIdeal {
  /** The customer's bank, if provided. Can be one of `abn_amro`, `asn_bank`, `bunq`, `handelsbanken`, `ing`, `knab`, `moneyou`, `rabobank`, `regiobank`, `revolut`, `sns_bank`, `triodos_bank`, `van_lanschot`, or `yoursafe`. */
  bank: StripePaymentMethodIdealBank | null;
  /** The Bank Identifier Code of the customer's bank, if the bank was provided. */
  bic: StripePaymentMethodIdealBic | null;
}

export enum StripePaymentMethodIdealBank {
  AbnAmro = 'abn_amro',
  AsnBank = 'asn_bank',
  Bunq = 'bunq',
  Handelsbanken = 'handelsbanken',
  Ing = 'ing',
  Knab = 'knab',
  Moneyou = 'moneyou',
  Rabobank = 'rabobank',
  Regiobank = 'regiobank',
  Revolut = 'revolut',
  SnsBank = 'sns_bank',
  TriodosBank = 'triodos_bank',
  VanLanschot = 'van_lanschot',
  Yoursafe = 'yoursafe',
}

export enum StripePaymentMethodIdealBic {
  ABNANL2A = 'ABNANL2A',
  ASNBNL21 = 'ASNBNL21',
  BITSNL2A = 'BITSNL2A',
  BUNQNL2A = 'BUNQNL2A',
  FVLBNL22 = 'FVLBNL22',
  HANDNL2A = 'HANDNL2A',
  INGBNL2A = 'INGBNL2A',
  KNABNL2H = 'KNABNL2H',
  MOYONL21 = 'MOYONL21',
  RABONL2U = 'RABONL2U',
  RBRBNL21 = 'RBRBNL21',
  REVOIE23 = 'REVOIE23',
  REVOLT21 = 'REVOLT21',
  SNSBNL2A = 'SNSBNL2A',
  TRIONL2U = 'TRIONL2U',
}

export interface StripePaymentMethodInteracPresent {
  /** Card brand. Can be `interac`, `mastercard` or `visa`. */
  brand: string | null;
  /** The cardholder name as read from the card, in [ISO 7813](https://en.wikipedia.org/wiki/ISO/IEC_7813) format. May include alphanumeric characters, special characters and first/last name separator (`/`). In some cases, the cardholder name may not be available depending on how the issuer has configured the card. Cardholder name is typically not available on swipe or contactless payments, such as those made with Apple Pay and Google Pay. */
  cardholder_name: string | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string | null;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string | null;
  /** Contains information about card networks that can be used to process the payment. */
  networks: StripePaymentMethodInteracPresentNetworks | null;
  /** EMV tag 5F2D. Preferred languages specified by the integrated circuit chip. */
  preferred_locales: string[] | null;
  /** How card details were read in this transaction. */
  read_method: StripePaymentMethodInteracPresentReadMethod | null;
}

export interface StripePaymentMethodInteracPresentNetworks {
  /** All available networks for the card. */
  available: string[];
  /** The preferred network for the card. */
  preferred: string | null;
}

export enum StripePaymentMethodInteracPresentReadMethod {
  ContactEmv = 'contact_emv',
  ContactlessEmv = 'contactless_emv',
  ContactlessMagstripeMode = 'contactless_magstripe_mode',
  MagneticStripeFallback = 'magnetic_stripe_fallback',
  MagneticStripeTrack2 = 'magnetic_stripe_track2',
}

export interface StripePaymentMethodKlarna {
  /** The customer's date of birth, if provided. */
  dob: StripePaymentMethodKlarnaDob | null;
}

export interface StripePaymentMethodKlarnaDob {
  /** The day of birth, between 1 and 31. */
  day: number | null;
  /** The month of birth, between 1 and 12. */
  month: number | null;
  /** The four-digit year of birth. */
  year: number | null;
}

export type StripePaymentMethodKonbini = object;

export interface StripePaymentMethodLink {
  /** Two-letter ISO code representing the funding source (i.e. card, bank) country beneath the Link payment method. You could use this attribute to get a sense of the international breakdown of funding sources you've collected. */
  country?: string;
  /** Account owner's email address. */
  email: string | null;
  /** Token used for persistent Link logins. */
  persistent_token?: string;
}

export type StripePaymentMethodOxxo = object;

export interface StripePaymentMethodP24 {
  /** The customer's bank, if provided. */
  bank: StripePaymentMethodP24Bank | null;
}

export enum StripePaymentMethodP24Bank {
  AliorBank = 'alior_bank',
  BankMillennium = 'bank_millennium',
  BankNowyBfgSa = 'bank_nowy_bfg_sa',
  BankPekaoSa = 'bank_pekao_sa',
  BankiSpbdzielcze = 'banki_spbdzielcze',
  Blik = 'blik',
  BnpParibas = 'bnp_paribas',
  Boz = 'boz',
  CitiHandlowy = 'citi_handlowy',
  CreditAgricole = 'credit_agricole',
  Envelobank = 'envelobank',
  EtransferPocztowy24 = 'etransfer_pocztowy24',
  GetinBank = 'getin_bank',
  Ideabank = 'ideabank',
  Ing = 'ing',
  Inteligo = 'inteligo',
  MbankMtransfer = 'mbank_mtransfer',
  NestPrzelew = 'nest_przelew',
  NoblePay = 'noble_pay',
  PbacZIpko = 'pbac_z_ipko',
  PlusBank = 'plus_bank',
  SantanderPrzelew24 = 'santander_przelew24',
  TmobileUsbugiBankowe = 'tmobile_usbugi_bankowe',
  ToyotaBank = 'toyota_bank',
  VolkswagenBank = 'volkswagen_bank',
}

export type StripePaymentMethodPaynow = object;

export interface StripePaymentMethodPaypal {
  /** Owner's email. Values are provided by PayPal directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  payer_email?: string | null;
  /** PayPal account PayerID. This identifier uniquely identifies the PayPal customer. */
  payer_id?: string | null;
}

export type StripePaymentMethodPix = object;

export type StripePaymentMethodPromptpay = object;

export interface StripePaymentMethodRadarOptions {
  /** A [Radar Session](https://stripe.com/docs/radar/radar-session) is a snapshot of the browser metadata and device details that help Radar make more accurate predictions on your payments. */
  session?: string;
}

export interface StripePaymentMethodSepaDebit {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Branch code of bank associated with the bank account. */
  branch_code: string | null;
  /** Two-letter ISO code representing the country the bank account is located in. */
  country: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Information about the object that generated this PaymentMethod. */
  generated_from: StripePaymentMethodSepaDebitGeneratedFrom | null;
  /** Last four characters of the IBAN. */
  last4: string | null;
}

export interface StripePaymentMethodSepaDebitGeneratedFrom {
  /** The ID of the Charge that generated this PaymentMethod, if any. */
  charge: string | StripeCharge | null;
  /** The ID of the SetupAttempt that generated this PaymentMethod, if any. */
  setup_attempt: string | StripeSetupAttempt | null;
}

/** The `Charge` object represents a single attempt to move money into your Stripe account. PaymentIntent confirmation is the most common way to create Charges, but transferring money to a different Stripe account through Connect also creates Charges. Some legacy payment flows create Charges directly, which is not recommended for new integrations. */
export interface StripeCharge {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'charge';
  alternate_statement_descriptors?: StripeChargeAlternateStatementDescriptors;
  /** Amount intended to be collected by this payment. A positive integer representing how much to charge in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal) (e.g., 100 cents to charge $1.00 or 100 to charge ¥100, a zero-decimal currency). The minimum amount is $0.50 US or [equivalent in charge currency](https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts). The amount value supports up to eight digits (e.g., a value of 99999999 for a USD charge of $999,999.99). */
  amount: number;
  /** Amount in %s captured (can be less than the amount attribute on the charge if a partial capture was made). */
  amount_captured: number;
  /** Amount in %s refunded (can be less than the amount attribute on the charge if a partial refund was issued). */
  amount_refunded: number;
  /** ID of the Connect application that created the charge. */
  application: string | StripeApplication | null;
  /** The application fee (if any) for the charge. [See the Connect documentation](https://stripe.com/docs/connect/direct-charges#collecting-fees) for details. */
  application_fee: string | StripeApplicationFee | null;
  /** The amount of the application fee (if any) requested for the charge. [See the Connect documentation](https://stripe.com/docs/connect/direct-charges#collecting-fees) for details. */
  application_fee_amount: number | null;
  /** Authorization code on the charge. */
  authorization_code?: string;
  /** ID of the balance transaction that describes the impact of this charge on your account balance (not including refunds or disputes). */
  balance_transaction: string | StripeBalanceTransaction | null;
  billing_details: StripeChargeBillingDetails;
  /** The full statement descriptor that is passed to card networks, and that is displayed on your customers' credit card and bank statements. Allows you to see what the statement descriptor looks like after the static and dynamic portions are combined. */
  calculated_statement_descriptor: string | null;
  /** If the charge was created without capturing, this Boolean represents whether it is still uncaptured or has since been captured. */
  captured: boolean;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** ID of the customer this charge is for if one exists. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** ID of an existing, connected Stripe account to transfer funds to if `transfer_data` was specified in the charge request. */
  destination: string | StripeAccount | null;
  /** Details about the dispute if the charge has been disputed. */
  dispute: string | StripeDispute | null;
  /** Whether the charge has been disputed. */
  disputed: boolean;
  /** ID of the balance transaction that describes the reversal of the balance on your account due to payment failure. */
  failure_balance_transaction: string | StripeBalanceTransaction | null;
  /** Error code explaining reason for charge failure if available (see [the errors section](https://stripe.com/docs/error-codes) for a list of codes). */
  failure_code: string | null;
  /** Message to user further explaining reason for charge failure if available. */
  failure_message: string | null;
  /** Information on fraud assessments for the charge. */
  fraud_details: StripeChargeFraudDetails | null;
  /** ID of the invoice this charge is for if one exists. */
  invoice: string | StripeInvoice | null;
  level3?: StripeChargeLevel3;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** The account (if any) the charge was made on behalf of without triggering an automatic transfer. See the [Connect documentation](https://stripe.com/docs/connect/charges-transfers) for details. */
  on_behalf_of: string | StripeAccount | null;
  /** Details about whether the payment was accepted, and why. See [understanding declines](https://stripe.com/docs/declines) for details. */
  outcome: StripeChargeOutcome | null;
  /** `true` if the charge succeeded, or was successfully authorized for later capture. */
  paid: boolean;
  /** ID of the PaymentIntent associated with this charge, if one exists. */
  payment_intent: string | StripePaymentIntent | null;
  /** ID of the payment method used in this charge. */
  payment_method: string | null;
  /** Details about the payment method at the time of the transaction. */
  payment_method_details: StripeChargePaymentMethodDetails | null;
  /** Options to configure Radar. See [Radar Session](https://stripe.com/docs/radar/radar-session) for more information. */
  radar_options?: StripeChargeRadarOptions;
  /** This is the email address that the receipt for this charge was sent to. */
  receipt_email: string | null;
  /** This is the transaction number that appears on email receipts sent for this charge. This attribute will be `null` until a receipt has been sent. */
  receipt_number: string | null;
  /** This is the URL to view the receipt for this charge. The receipt is kept up-to-date to the latest state of the charge, including any refunds. If the charge is for an Invoice, the receipt will be stylized as an Invoice receipt. */
  receipt_url: string | null;
  /** Whether the charge has been fully refunded. If the charge is only partially refunded, this attribute will still be false. */
  refunded: boolean;
  /** A list of refunds that have been applied to the charge. */
  refunds: StripeApiListStripeRefund | null;
  /** ID of the review associated with this charge if one exists. */
  review: string | StripeReview | null;
  /** Shipping information for the charge. */
  shipping: StripeChargeShipping | null;
  /** This is a legacy field that will be removed in the future. It contains the Source, Card, or BankAccount object used for the charge. For details about the payment method used for this charge, refer to `payment_method` or `payment_method_details` instead. */
  source: StripeCustomerSource | null;
  /** The transfer ID which created this charge. Only present if the charge came from another Stripe account. [See the Connect documentation](https://stripe.com/docs/connect/destination-charges) for details. */
  source_transfer: string | StripeTransfer | null;
  /** For card charges, use `statement_descriptor_suffix` instead. Otherwise, you can use this value as the complete description of a charge on your customers' statements. Must contain at least one letter, maximum 22 characters. */
  statement_descriptor: string | null;
  /** Provides information about the charge that customers see on their statements. Concatenated with the prefix (shortened descriptor) or statement descriptor that's set on the account to form the complete statement descriptor. Maximum 22 characters for the concatenated descriptor. */
  statement_descriptor_suffix: string | null;
  /** The status of the payment is either `succeeded`, `pending`, or `failed`. */
  status: StripeChargeStatus;
  /** ID of the transfer to the `destination` account (only applicable if the charge was created using the `destination` parameter). */
  transfer?: string | StripeTransfer;
  /** An optional dictionary including the account to automatically transfer to as part of a destination charge. [See the Connect documentation](https://stripe.com/docs/connect/destination-charges) for details. */
  transfer_data: StripeChargeTransferData | null;
  /** A string that identifies this transaction as part of a group. See the [Connect documentation](https://stripe.com/docs/connect/charges-transfers#transfer-options) for details. */
  transfer_group: string | null;
}

export interface StripeChargeAlternateStatementDescriptors {
  /** The Kana variation of the descriptor. */
  kana?: string;
  /** The Kanji variation of the descriptor. */
  kanji?: string;
}

/** The ApplicationFee object. */
export interface StripeApplicationFee {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'application_fee';
  /** ID of the Stripe account this fee was taken from. */
  account: string | StripeAccount;
  /** Amount earned, in %s. */
  amount: number;
  /** Amount in %s refunded (can be less than the amount attribute on the fee if a partial refund was issued) */
  amount_refunded: number;
  /** ID of the Connect application that earned the fee. */
  application: string | StripeApplication;
  /** Balance transaction that describes the impact of this collected application fee on your account balance (not including refunds). */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** ID of the charge that the application fee was taken from. */
  charge: string | StripeCharge;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** ID of the corresponding charge on the platform account, if this fee was the result of a charge using the `destination` parameter. */
  originating_transaction: string | StripeCharge | null;
  /** Whether the fee has been fully refunded. If the fee is only partially refunded, this attribute will still be false. */
  refunded: boolean;
  /** A list of refunds that have been applied to the fee. */
  refunds: StripeApiListStripeFeeRefund;
}

/**
 * Balance transactions represent funds moving through your Stripe account. They're created for every type of transaction that comes into or flows out of your Stripe account balance.
 *
 * Related guide: [Balance transaction types](https://stripe.com/docs/reports/balance-transaction-types)
 */
export interface StripeBalanceTransaction {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'balance_transaction';
  /** Gross amount of the transaction, in %s. */
  amount: number;
  /** The date the transaction's net funds will become available in the Stripe balance. */
  available_on: number;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** The exchange rate used, if applicable, for this transaction. Specifically, if money was converted from currency A to currency B, then the `amount` in currency A, times `exchange_rate`, would be the `amount` in currency B. For example, suppose you charged a customer 10.00 EUR. Then the PaymentIntent's `amount` would be `1000` and `currency` would be `eur`. Suppose this was converted into 12.34 USD in your Stripe account. Then the BalanceTransaction's `amount` would be `1234`, `currency` would be `usd`, and `exchange_rate` would be `1.234`. */
  exchange_rate: number | null;
  /** Fees (in %s) paid for this transaction. */
  fee: number;
  /** Detailed breakdown of fees (in %s) paid for this transaction. */
  fee_details: StripeBalanceTransactionFeeDetail[];
  /** Net amount of the transaction, in %s. */
  net: number;
  /** [Learn more](https://stripe.com/docs/reports/reporting-categories) about how reporting categories can help you understand balance transactions from an accounting perspective. */
  reporting_category: string;
  /** The Stripe object to which this transaction is related. */
  source:
    | string
    | StripeApplicationFee
    | StripeCharge
    | StripeConnectCollectionTransfer
    | StripeDispute
    | StripeFeeRefund
    | StripeIssuingAuthorization
    | StripeIssuingDispute
    | StripeIssuingTransaction
    | StripePayout
    | StripePlatformTaxFee
    | StripeRefund
    | StripeReserveTransaction
    | StripeTaxDeductedAtSource
    | StripeTopup
    | StripeTransfer
    | StripeTransferReversal
    | null;
  /** If the transaction's net funds are available in the Stripe balance yet. Either `available` or `pending`. */
  status: string;
  /** Transaction type: `adjustment`, `advance`, `advance_funding`, `anticipation_repayment`, `application_fee`, `application_fee_refund`, `charge`, `connect_collection_transfer`, `contribution`, `issuing_authorization_hold`, `issuing_authorization_release`, `issuing_dispute`, `issuing_transaction`, `payment`, `payment_failure_refund`, `payment_refund`, `payout`, `payout_cancel`, `payout_failure`, `refund`, `refund_failure`, `reserve_transaction`, `reserved_funds`, `stripe_fee`, `stripe_fx_fee`, `tax_fee`, `topup`, `topup_reversal`, `transfer`, `transfer_cancel`, `transfer_failure`, or `transfer_refund`. [Learn more](https://stripe.com/docs/reports/balance-transaction-types) about balance transaction types and what they represent. If you are looking to classify transactions for accounting purposes, you might want to consider `reporting_category` instead. */
  type: StripeBalanceTransactionType;
}

export interface StripeBalanceTransactionFeeDetail {
  /** Amount of the fee, in cents. */
  amount: number;
  /** ID of the Connect application that earned the fee. */
  application: string | null;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** Type of the fee, one of: `application_fee`, `stripe_fee` or `tax`. */
  type: string;
}

/** The ConnectCollectionTransfer object. */
export interface StripeConnectCollectionTransfer {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'connect_collection_transfer';
  /** Amount transferred, in %s. */
  amount: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** ID of the account that funds are being collected for. */
  destination: string | StripeAccount;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
}

/**
 * A dispute occurs when a customer questions your charge with their card issuer. When this happens, you're given the opportunity to respond to the dispute with evidence that shows that the charge is legitimate. You can find more information about the dispute process in our [Disputes and Fraud](https://stripe.com/docs/disputes) documentation.
 *
 * Related guide: [Disputes and fraud](https://stripe.com/docs/disputes)
 */
export interface StripeDispute {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'dispute';
  /** Disputed amount. Usually the amount of the charge, but can differ (usually because of currency fluctuation or because only part of the order is disputed). */
  amount: number;
  /** List of zero, one, or two balance transactions that show funds withdrawn and reinstated to your Stripe account as a result of this dispute. */
  balance_transactions: StripeBalanceTransaction[];
  /** ID of the charge that was disputed. */
  charge: string | StripeCharge;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  evidence: StripeDisputeEvidence;
  evidence_details: StripeDisputeEvidenceDetails;
  /** If true, it is still possible to refund the disputed payment. Once the payment has been fully refunded, no further funds will be withdrawn from your Stripe account as a result of this dispute. */
  is_charge_refundable: boolean;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** Network-dependent reason code for the dispute. */
  network_reason_code?: string | null;
  /** ID of the PaymentIntent that was disputed. */
  payment_intent: string | StripePaymentIntent | null;
  /** Reason given by cardholder for dispute. Possible values are `bank_cannot_process`, `check_returned`, `credit_not_processed`, `customer_initiated`, `debit_not_authorized`, `duplicate`, `fraudulent`, `general`, `incorrect_account_details`, `insufficient_funds`, `product_not_received`, `product_unacceptable`, `subscription_canceled`, or `unrecognized`. Read more about [dispute reasons](https://stripe.com/docs/disputes/categories). */
  reason: string;
  /** Current status of dispute. Possible values are `warning_needs_response`, `warning_under_review`, `warning_closed`, `needs_response`, `under_review`, `charge_refunded`, `won`, or `lost`. */
  status: StripeDisputeStatus;
}

export interface StripeDisputeEvidence {
  /** Any server or activity logs showing proof that the customer accessed or downloaded the purchased digital product. This information should include IP addresses, corresponding timestamps, and any detailed recorded activity. */
  access_activity_log: string | null;
  /** The billing address provided by the customer. */
  billing_address: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Your subscription cancellation policy, as shown to the customer. */
  cancellation_policy: string | StripeFile | null;
  /** An explanation of how and when the customer was shown your refund policy prior to purchase. */
  cancellation_policy_disclosure: string | null;
  /** A justification for why the customer's subscription was not canceled. */
  cancellation_rebuttal: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Any communication with the customer that you feel is relevant to your case. Examples include emails proving that the customer received the product or service, or demonstrating their use of or satisfaction with the product or service. */
  customer_communication: string | StripeFile | null;
  /** The email address of the customer. */
  customer_email_address: string | null;
  /** The name of the customer. */
  customer_name: string | null;
  /** The IP address that the customer used when making the purchase. */
  customer_purchase_ip: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) A relevant document or contract showing the customer's signature. */
  customer_signature: string | StripeFile | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Documentation for the prior charge that can uniquely identify the charge, such as a receipt, shipping label, work order, etc. This document should be paired with a similar document from the disputed payment that proves the two payments are separate. */
  duplicate_charge_documentation: string | StripeFile | null;
  /** An explanation of the difference between the disputed charge versus the prior charge that appears to be a duplicate. */
  duplicate_charge_explanation: string | null;
  /** The Stripe ID for the prior charge which appears to be a duplicate of the disputed charge. */
  duplicate_charge_id: string | null;
  /** A description of the product or service that was sold. */
  product_description: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Any receipt or message sent to the customer notifying them of the charge. */
  receipt: string | StripeFile | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Your refund policy, as shown to the customer. */
  refund_policy: string | StripeFile | null;
  /** Documentation demonstrating that the customer was shown your refund policy prior to purchase. */
  refund_policy_disclosure: string | null;
  /** A justification for why the customer is not entitled to a refund. */
  refund_refusal_explanation: string | null;
  /** The date on which the customer received or began receiving the purchased service, in a clear human-readable format. */
  service_date: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Documentation showing proof that a service was provided to the customer. This could include a copy of a signed contract, work order, or other form of written agreement. */
  service_documentation: string | StripeFile | null;
  /** The address to which a physical product was shipped. You should try to include as complete address information as possible. */
  shipping_address: string | null;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. If multiple carriers were used for this purchase, please separate them with commas. */
  shipping_carrier: string | null;
  /** The date on which a physical product began its route to the shipping address, in a clear human-readable format. */
  shipping_date: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Documentation showing proof that a product was shipped to the customer at the same address the customer provided to you. This could include a copy of the shipment receipt, shipping label, etc. It should show the customer's full shipping address, if possible. */
  shipping_documentation: string | StripeFile | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  shipping_tracking_number: string | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Any additional evidence or statements. */
  uncategorized_file: string | StripeFile | null;
  /** Any additional evidence or statements. */
  uncategorized_text: string | null;
}

export interface StripeDisputeEvidenceDetails {
  /** Date by which evidence must be submitted in order to successfully challenge dispute. Will be 0 if the customer's bank or credit card company doesn't allow a response for this particular dispute. */
  due_by: number | null;
  /** Whether evidence has been staged for this dispute. */
  has_evidence: boolean;
  /** Whether the last evidence submission was submitted past the due date. Defaults to `false` if no evidence submissions have occurred. If `true`, then delivery of the latest evidence is *not* guaranteed. */
  past_due: boolean;
  /** The number of times evidence has been submitted. Typically, you may only submit evidence once. */
  submission_count: number;
}

/**
 * A PaymentIntent guides you through the process of collecting a payment from your customer. We recommend that you create exactly one PaymentIntent for each order or customer session in your system. You can reference the PaymentIntent later to see the history of payment attempts for a particular session.
 *
 * A PaymentIntent transitions through [multiple statuses](https://stripe.com/docs/payments/intents#intent-statuses) throughout its lifetime as it interfaces with Stripe.js to perform authentication flows and ultimately creates at most one successful charge.
 *
 * Related guide: [Payment Intents API](https://stripe.com/docs/payments/payment-intents)
 */
export interface StripePaymentIntent {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'payment_intent';
  /** Amount intended to be collected by this PaymentIntent. A positive integer representing how much to charge in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal) (e.g., 100 cents to charge $1.00 or 100 to charge ¥100, a zero-decimal currency). The minimum amount is $0.50 US or [equivalent in charge currency](https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts). The amount value supports up to eight digits (e.g., a value of 99999999 for a USD charge of $999,999.99). */
  amount: number;
  /** Amount that can be captured from this PaymentIntent. */
  amount_capturable: number;
  amount_details?: StripePaymentIntentAmountDetails;
  /** Amount that was collected by this PaymentIntent. */
  amount_received: number;
  /** ID of the Connect application that created the PaymentIntent. */
  application: string | StripeApplication | null;
  /** The amount of the application fee (if any) that will be requested to be applied to the payment and transferred to the application owner's Stripe account. The amount of the application fee collected will be capped at the total payment amount. For more information, see the PaymentIntents [use case for connected accounts](https://stripe.com/docs/payments/connected-accounts). */
  application_fee_amount: number | null;
  /** Settings to configure compatible payment methods from the [Stripe Dashboard](https://dashboard.stripe.com/settings/payment_methods) */
  automatic_payment_methods: StripePaymentIntentAutomaticPaymentMethods | null;
  /** Populated when `status` is `canceled`, this is the time at which the PaymentIntent was canceled. Measured in seconds since the Unix epoch. */
  canceled_at: number | null;
  /** Reason for cancellation of this PaymentIntent, either user-provided (`duplicate`, `fraudulent`, `requested_by_customer`, or `abandoned`) or generated by Stripe internally (`failed_invoice`, `void_invoice`, or `automatic`). */
  cancellation_reason: StripePaymentIntentCancellationReason | null;
  /** Controls when the funds will be captured from the customer's account. */
  capture_method: StripePaymentIntentCaptureMethod;
  /**
   * The client secret of this PaymentIntent. Used for client-side retrieval using a publishable key.
   *
   * The client secret can be used to complete a payment from your frontend. It should not be stored, logged, or exposed to anyone other than the customer. Make sure that you have TLS enabled on any page that includes the client secret.
   *
   * Refer to our docs to [accept a payment](https://stripe.com/docs/payments/accept-a-payment?ui=elements) and learn about how `client_secret` should be handled.
   */
  client_secret: string | null;
  confirmation_method: StripePaymentIntentConfirmationMethod;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /**
   * ID of the Customer this PaymentIntent belongs to, if one exists.
   *
   * Payment methods attached to other Customers cannot be used with this PaymentIntent.
   *
   * If present in combination with [setup_future_usage](https://stripe.com/docs/api#payment_intent_object-setup_future_usage), this PaymentIntent's payment method will be attached to the Customer after the PaymentIntent has been confirmed and any required actions from the user are complete.
   */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** ID of the invoice that created this PaymentIntent, if it exists. */
  invoice: string | StripeInvoice | null;
  /** The payment error encountered in the previous PaymentIntent confirmation. It will be cleared if the PaymentIntent is later updated for any reason. */
  last_payment_error: StripePaymentIntentLastPaymentError | null;
  /** The latest charge created by this payment intent. */
  latest_charge?: string | StripeCharge | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. For more information, see the [documentation](https://stripe.com/docs/payments/payment-intents/creating-payment-intents#storing-information-in-metadata). */
  metadata: StripeMetadata;
  /** If present, this property tells you what actions you need to take in order for your customer to fulfill a payment using the provided source. */
  next_action: StripePaymentIntentNextAction | null;
  /** The account (if any) for which the funds of the PaymentIntent are intended. See the PaymentIntents [use case for connected accounts](https://stripe.com/docs/payments/connected-accounts) for details. */
  on_behalf_of: string | StripeAccount | null;
  /** ID of the payment method used in this PaymentIntent. */
  payment_method: string | StripePaymentMethod | null;
  /** Payment-method-specific configuration for this PaymentIntent. */
  payment_method_options: StripePaymentIntentPaymentMethodOptions | null;
  /** The list of payment method types (e.g. card) that this PaymentIntent is allowed to use. */
  payment_method_types: string[];
  /** If present, this property tells you about the processing state of the payment. */
  processing: StripePaymentIntentProcessing | null;
  /** Email address that the receipt for the resulting payment will be sent to. If `receipt_email` is specified for a payment in live mode, a receipt will be sent regardless of your [email settings](https://dashboard.stripe.com/account/emails). */
  receipt_email: string | null;
  /** ID of the review associated with this PaymentIntent, if any. */
  review: string | StripeReview | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage: StripePaymentIntentSetupFutureUsage | null;
  /** Shipping information for this PaymentIntent. */
  shipping: StripePaymentIntentShipping | null;
  /** This is a legacy field that will be removed in the future. It is the ID of the Source object that is associated with this PaymentIntent, if one was supplied. */
  source: string | StripeCustomerSource | StripeDeletedBankAccount | StripeDeletedCard | null;
  /** For non-card charges, you can use this value as the complete description that appears on your customers' statements. Must contain at least one letter, maximum 22 characters. */
  statement_descriptor: string | null;
  /** Provides information about a card payment that customers see on their statements. Concatenated with the prefix (shortened descriptor) or statement descriptor that's set on the account to form the complete statement descriptor. Maximum 22 characters for the concatenated descriptor. */
  statement_descriptor_suffix: string | null;
  /** Status of this PaymentIntent, one of `requires_payment_method`, `requires_confirmation`, `requires_action`, `processing`, `requires_capture`, `canceled`, or `succeeded`. Read more about each PaymentIntent [status](https://stripe.com/docs/payments/intents#intent-statuses). */
  status: StripePaymentIntentStatus;
  /** The data with which to automatically create a Transfer when the payment is finalized. See the PaymentIntents [use case for connected accounts](https://stripe.com/docs/payments/connected-accounts) for details. */
  transfer_data: StripePaymentIntentTransferData | null;
  /** A string that identifies the resulting payment as part of a group. See the PaymentIntents [use case for connected accounts](https://stripe.com/docs/payments/connected-accounts) for details. */
  transfer_group: string | null;
}

export interface StripePaymentIntentAmountDetails {
  tip?: StripePaymentIntentAmountDetailsTip;
}

export interface StripePaymentIntentAmountDetailsTip {
  /** Portion of the amount that corresponds to a tip. */
  amount?: number;
}

export interface StripePaymentIntentAutomaticPaymentMethods {
  /** Automatically calculates compatible payment methods */
  enabled: boolean;
}

export enum StripePaymentIntentCancellationReason {
  Abandoned = 'abandoned',
  Automatic = 'automatic',
  Duplicate = 'duplicate',
  FailedInvoice = 'failed_invoice',
  Fraudulent = 'fraudulent',
  RequestedByCustomer = 'requested_by_customer',
  VoidInvoice = 'void_invoice',
}

export enum StripePaymentIntentCaptureMethod {
  Automatic = 'automatic',
  AutomaticAsync = 'automatic_async',
  Manual = 'manual',
}

export enum StripePaymentIntentConfirmationMethod {
  Automatic = 'automatic',
  Manual = 'manual',
}

/**
 * Invoices are statements of amounts owed by a customer, and are either generated one-off, or generated periodically from a subscription.
 *
 * They contain [invoice items](https://stripe.com/docs/api#invoiceitems), and proration adjustments that may be caused by subscription upgrades/downgrades (if necessary).
 *
 * If your invoice is configured to be billed through automatic charges, Stripe automatically finalizes your invoice and attempts payment. Note that finalizing the invoice, [when automatic](https://stripe.com/docs/billing/invoices/workflow/#auto_advance), does not happen immediately as the invoice is created. Stripe waits until one hour after the last webhook was successfully sent (or the last webhook timed out after failing). If you (and the platforms you may have connected to) have no webhooks configured, Stripe waits one hour after creation to finalize the invoice.
 *
 * If your invoice is configured to be billed by sending an email, then based on your [email settings](https://dashboard.stripe.com/account/billing/automatic), Stripe will email the invoice to your customer and await payment. These emails can contain a link to a hosted page to pay the invoice.
 *
 * Stripe applies any customer credit on the account before determining the amount due for the invoice (i.e., the amount that will be actually charged). If the amount due for the invoice is less than Stripe's [minimum allowed charge per currency](https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts), the invoice is automatically marked paid, and we add the amount due to the customer's credit balance which is applied to the next invoice.
 *
 * More details on the customer's credit balance are [here](https://stripe.com/docs/billing/customer/balance).
 *
 * Related guide: [Send invoices to customers](https://stripe.com/docs/billing/invoices/sending)
 */
export interface StripeInvoice {
  /** Unique identifier for the object. This property is always present unless the invoice is an upcoming invoice. See [Retrieve an upcoming invoice](https://stripe.com/docs/api/invoices/upcoming) for more details. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'invoice';
  /** The country of the business associated with this invoice, most often the business creating the invoice. */
  account_country: string | null;
  /** The public name of the business associated with this invoice, most often the business creating the invoice. */
  account_name: string | null;
  /** The account tax IDs associated with the invoice. Only editable when the invoice is a draft. */
  account_tax_ids: (string | StripeTaxId | StripeDeletedTaxId)[] | null;
  /** Final amount due at this time for this invoice. If the invoice's total is smaller than the minimum charge amount, for example, or if there is account credit that can be applied to the invoice, the `amount_due` may be 0. If there is a positive `starting_balance` for the invoice (the customer owes money), the `amount_due` will also take that into account. The charge that gets generated for the invoice will be for the amount specified in `amount_due`. */
  amount_due: number;
  /** The amount, in %s, that was paid. */
  amount_paid: number;
  /** The difference between amount_due and amount_paid, in %s. */
  amount_remaining: number;
  /** This is the sum of all the shipping amounts. */
  amount_shipping: number;
  /** ID of the Connect Application that created the invoice. */
  application: string | StripeApplication | StripeDeletedApplication | null;
  /** The fee in %s that will be applied to the invoice and transferred to the application owner's Stripe account when the invoice is paid. */
  application_fee_amount: number | null;
  /** Number of payment attempts made for this invoice, from the perspective of the payment retry schedule. Any payment attempt counts as the first attempt, and subsequently only automatic retries increment the attempt count. In other words, manual payment attempts after the first attempt do not affect the retry schedule. */
  attempt_count: number;
  /** Whether an attempt has been made to pay the invoice. An invoice is not attempted until 1 hour after the `invoice.created` webhook, for example, so you might not want to display that invoice as unpaid to your users. */
  attempted: boolean;
  /** Controls whether Stripe will perform [automatic collection](https://stripe.com/docs/billing/invoices/workflow/#auto_advance) of the invoice. When `false`, the invoice's state will not automatically advance without an explicit action. */
  auto_advance?: boolean;
  automatic_tax: StripeInvoiceAutomaticTax;
  /** Indicates the reason why the invoice was created. `subscription_cycle` indicates an invoice created by a subscription advancing into a new period. `subscription_create` indicates an invoice created due to creating a subscription. `subscription_update` indicates an invoice created due to updating a subscription. `subscription` is set for all old invoices to indicate either a change to a subscription or a period advancement. `manual` is set for all invoices unrelated to a subscription (for example: created via the invoice editor). The `upcoming` value is reserved for simulated invoices per the upcoming invoice endpoint. `subscription_threshold` indicates an invoice created due to a billing threshold being reached. */
  billing_reason: StripeInvoiceBillingReason | null;
  /** ID of the latest charge generated for this invoice, if any. */
  charge: string | StripeCharge | null;
  /** Either `charge_automatically`, or `send_invoice`. When charging automatically, Stripe will attempt to pay this invoice using the default source attached to the customer. When sending an invoice, Stripe will email this invoice to the customer with payment instructions. */
  collection_method: StripeInvoiceCollectionMethod;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** Custom fields displayed on the invoice. */
  custom_fields: StripeInvoiceCustomField[] | null;
  /** The ID of the customer who will be billed. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** The customer's address. Until the invoice is finalized, this field will equal `customer.address`. Once the invoice is finalized, this field will no longer be updated. */
  customer_address: StripeAddress | null;
  /** The customer's email. Until the invoice is finalized, this field will equal `customer.email`. Once the invoice is finalized, this field will no longer be updated. */
  customer_email: string | null;
  /** The customer's name. Until the invoice is finalized, this field will equal `customer.name`. Once the invoice is finalized, this field will no longer be updated. */
  customer_name: string | null;
  /** The customer's phone number. Until the invoice is finalized, this field will equal `customer.phone`. Once the invoice is finalized, this field will no longer be updated. */
  customer_phone: string | null;
  /** The customer's shipping information. Until the invoice is finalized, this field will equal `customer.shipping`. Once the invoice is finalized, this field will no longer be updated. */
  customer_shipping: StripeInvoiceCustomerShipping | null;
  /** The customer's tax exempt status. Until the invoice is finalized, this field will equal `customer.tax_exempt`. Once the invoice is finalized, this field will no longer be updated. */
  customer_tax_exempt: StripeInvoiceCustomerTaxExempt | null;
  /** The customer's tax IDs. Until the invoice is finalized, this field will contain the same tax IDs as `customer.tax_ids`. Once the invoice is finalized, this field will no longer be updated. */
  customer_tax_ids?: StripeInvoiceCustomerTaxId[] | null;
  /** ID of the default payment method for the invoice. It must belong to the customer associated with the invoice. If not set, defaults to the subscription's default payment method, if any, or to the default payment method in the customer's invoice settings. */
  default_payment_method: string | StripePaymentMethod | null;
  /** ID of the default payment source for the invoice. It must belong to the customer associated with the invoice and be in a chargeable state. If not set, defaults to the subscription's default source, if any, or to the customer's default source. */
  default_source: string | StripeCustomerSource | null;
  /** The tax rates applied to this invoice, if any. */
  default_tax_rates: StripeTaxRate[];
  deleted?: null;
  /** An arbitrary string attached to the object. Often useful for displaying to users. Referenced as 'memo' in the Dashboard. */
  description: string | null;
  /** Describes the current discount applied to this invoice, if there is one. Not populated if there are multiple discounts. */
  discount: StripeDiscount | null;
  /** The discounts applied to the invoice. Line item discounts are applied before invoice discounts. Use `expand[]=discounts` to expand each discount. */
  discounts: (string | StripeDiscount | StripeDeletedDiscount)[] | null;
  /** The date on which payment for this invoice is due. This value will be `null` for invoices where `collection_method=charge_automatically`. */
  due_date: number | null;
  /** Ending customer balance after the invoice is finalized. Invoices are finalized approximately an hour after successful webhook delivery or when payment collection is attempted for the invoice. If the invoice has not been finalized yet, this will be null. */
  ending_balance: number | null;
  /** Footer displayed on the invoice. */
  footer: string | null;
  /** Details of the invoice that was cloned. See the [revision documentation](https://stripe.com/docs/invoicing/invoice-revisions) for more details. */
  from_invoice: StripeInvoiceFromInvoice | null;
  /** The URL for the hosted invoice page, which allows customers to view and pay an invoice. If the invoice has not been finalized yet, this will be null. */
  hosted_invoice_url?: string | null;
  /** The link to download the PDF for the invoice. If the invoice has not been finalized yet, this will be null. */
  invoice_pdf?: string | null;
  /** The error encountered during the previous attempt to finalize the invoice. This field is cleared when the invoice is successfully finalized. */
  last_finalization_error: StripeInvoiceLastFinalizationError | null;
  /** The ID of the most recent non-draft revision of this invoice */
  latest_revision: string | StripeInvoice | null;
  /** The individual line items that make up the invoice. `lines` is sorted as follows: (1) pending invoice items (including prorations) in reverse chronological order, (2) subscription items in reverse chronological order, and (3) invoice items added after invoice creation in chronological order. */
  lines: StripeApiListStripeInvoiceLineItem;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** The time at which payment will next be attempted. This value will be `null` for invoices where `collection_method=send_invoice`. */
  next_payment_attempt: number | null;
  /** A unique, identifying string that appears on emails sent to the customer for this invoice. This starts with the customer's unique invoice_prefix if it is specified. */
  number: string | null;
  /** The account (if any) for which the funds of the invoice payment are intended. If set, the invoice will be presented with the branding and support information of the specified account. See the [Invoices with Connect](https://stripe.com/docs/billing/invoices/connect) documentation for details. */
  on_behalf_of: string | StripeAccount | null;
  /** Whether payment was successfully collected for this invoice. An invoice can be paid (most commonly) with a charge or with credit from the customer's account balance. */
  paid: boolean;
  /** Returns true if the invoice was manually marked paid, returns false if the invoice hasn't been paid yet or was paid on Stripe. */
  paid_out_of_band: boolean;
  /** The PaymentIntent associated with this invoice. The PaymentIntent is generated when the invoice is finalized, and can then be used to pay the invoice. Note that voiding an invoice will cancel the PaymentIntent. */
  payment_intent: string | StripePaymentIntent | null;
  payment_settings: StripeInvoicePaymentSettings;
  /** End of the usage period during which invoice items were added to this invoice. */
  period_end: number;
  /** Start of the usage period during which invoice items were added to this invoice. */
  period_start: number;
  /** Total amount of all post-payment credit notes issued for this invoice. */
  post_payment_credit_notes_amount: number;
  /** Total amount of all pre-payment credit notes issued for this invoice. */
  pre_payment_credit_notes_amount: number;
  /** The quote this invoice was generated from. */
  quote: string | StripeQuote | null;
  /** This is the transaction number that appears on email receipts sent for this invoice. */
  receipt_number: string | null;
  /** Options for invoice PDF rendering. */
  rendering_options: StripeInvoiceRenderingOptions | null;
  /** The details of the cost of shipping, including the ShippingRate applied on the invoice. */
  shipping_cost: StripeInvoiceShippingCost | null;
  /** Shipping details for the invoice. The Invoice PDF will use the `shipping_details` value if it is set, otherwise the PDF will render the shipping address from the customer. */
  shipping_details: StripeInvoiceShippingDetails | null;
  /** Starting customer balance before the invoice is finalized. If the invoice has not been finalized yet, this will be the current customer balance. For revision invoices, this also includes any customer balance that was applied to the original invoice. */
  starting_balance: number;
  /** Extra information about an invoice for the customer's credit card statement. */
  statement_descriptor: string | null;
  /** The status of the invoice, one of `draft`, `open`, `paid`, `uncollectible`, or `void`. [Learn more](https://stripe.com/docs/billing/invoices/workflow#workflow-overview) */
  status: StripeInvoiceStatus | null;
  status_transitions: StripeInvoiceStatusTransitions;
  /** The subscription that this invoice was prepared for, if any. */
  subscription: string | StripeSubscription | null;
  /** Only set for upcoming invoices that preview prorations. The time used to calculate prorations. */
  subscription_proration_date?: number;
  /** Total of all subscriptions, invoice items, and prorations on the invoice before any invoice level discount or exclusive tax is applied. Item discounts are already incorporated */
  subtotal: number;
  /** The integer amount in %s representing the subtotal of the invoice before any invoice level discount or tax is applied. Item discounts are already incorporated */
  subtotal_excluding_tax: number | null;
  /** The amount of tax on this invoice. This is the sum of all the tax amounts on this invoice. */
  tax: number | null;
  /** ID of the test clock this invoice belongs to. */
  test_clock: string | StripeTestHelpersTestClock | null;
  threshold_reason?: StripeInvoiceThresholdReason;
  /** Total after discounts and taxes. */
  total: number;
  /** The aggregate amounts calculated per discount across all line items. */
  total_discount_amounts: StripeInvoiceTotalDiscountAmount[] | null;
  /** The integer amount in %s representing the total amount of the invoice including all discounts but excluding all tax. */
  total_excluding_tax: number | null;
  /** The aggregate amounts calculated per tax rate for all line items. */
  total_tax_amounts: StripeInvoiceTotalTaxAmount[];
  /** The account (if any) the payment will be attributed to for tax reporting, and where funds from the payment will be transferred to for the invoice. */
  transfer_data: StripeInvoiceTransferData | null;
  /** Invoices are automatically paid or sent 1 hour after webhooks are delivered, or until all webhook delivery attempts have [been exhausted](https://stripe.com/docs/billing/webhooks#understand). This field tracks the time when webhooks for this invoice were successfully delivered. If the invoice had no webhooks to deliver, this will be set while the invoice is being created. */
  webhooks_delivered_at: number | null;
}

/**
 * You can add one or multiple tax IDs to a [customer](https://stripe.com/docs/api/customers). A customer's tax IDs are displayed on invoices and credit notes issued for the customer.
 *
 * Related guide: [Customer tax identification numbers](https://stripe.com/docs/billing/taxes/tax-ids)
 */
export interface StripeTaxId {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'tax_id';
  /** Two-letter ISO code representing the country of the tax ID. */
  country: string | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** ID of the customer. */
  customer: string | StripeCustomer | null;
  deleted?: null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Type of the tax ID, one of `ae_trn`, `au_abn`, `au_arn`, `bg_uic`, `br_cnpj`, `br_cpf`, `ca_bn`, `ca_gst_hst`, `ca_pst_bc`, `ca_pst_mb`, `ca_pst_sk`, `ca_qst`, `ch_vat`, `cl_tin`, `eg_tin`, `es_cif`, `eu_oss_vat`, `eu_vat`, `gb_vat`, `ge_vat`, `hk_br`, `hu_tin`, `id_npwp`, `il_vat`, `in_gst`, `is_vat`, `jp_cn`, `jp_rn`, `jp_trn`, `ke_pin`, `kr_brn`, `li_uid`, `mx_rfc`, `my_frp`, `my_itn`, `my_sst`, `no_vat`, `nz_gst`, `ph_tin`, `ru_inn`, `ru_kpp`, `sa_vat`, `sg_gst`, `sg_uen`, `si_tin`, `th_vat`, `tr_tin`, `tw_vat`, `ua_vat`, `us_ein`, or `za_vat`. Note that some legacy tax IDs have type `unknown` */
  type: StripeTaxIdType;
  /** Value of the tax ID. */
  value: string;
  /** Tax ID verification information. */
  verification: StripeTaxIdVerification | null;
}

export enum StripeTaxIdType {
  AeTrn = 'ae_trn',
  AuAbn = 'au_abn',
  AuArn = 'au_arn',
  BgUic = 'bg_uic',
  BrCnpj = 'br_cnpj',
  BrCpf = 'br_cpf',
  CaBn = 'ca_bn',
  CaGstHst = 'ca_gst_hst',
  CaPstBc = 'ca_pst_bc',
  CaPstMb = 'ca_pst_mb',
  CaPstSk = 'ca_pst_sk',
  CaQst = 'ca_qst',
  ChVat = 'ch_vat',
  ClTin = 'cl_tin',
  EgTin = 'eg_tin',
  EsCif = 'es_cif',
  EuOssVat = 'eu_oss_vat',
  EuVat = 'eu_vat',
  GbVat = 'gb_vat',
  GeVat = 'ge_vat',
  HkBr = 'hk_br',
  HuTin = 'hu_tin',
  IdNpwp = 'id_npwp',
  IlVat = 'il_vat',
  InGst = 'in_gst',
  IsVat = 'is_vat',
  JpCn = 'jp_cn',
  JpRn = 'jp_rn',
  JpTrn = 'jp_trn',
  KePin = 'ke_pin',
  KrBrn = 'kr_brn',
  LiUid = 'li_uid',
  MxRfc = 'mx_rfc',
  MyFrp = 'my_frp',
  MyItn = 'my_itn',
  MySst = 'my_sst',
  NoVat = 'no_vat',
  NzGst = 'nz_gst',
  PhTin = 'ph_tin',
  RuInn = 'ru_inn',
  RuKpp = 'ru_kpp',
  SaVat = 'sa_vat',
  SgGst = 'sg_gst',
  SgUen = 'sg_uen',
  SiTin = 'si_tin',
  ThVat = 'th_vat',
  TrTin = 'tr_tin',
  TwVat = 'tw_vat',
  UaVat = 'ua_vat',
  Unknown = 'unknown',
  UsEin = 'us_ein',
  ZaVat = 'za_vat',
}

export interface StripeTaxIdVerification {
  /** Verification status, one of `pending`, `verified`, `unverified`, or `unavailable`. */
  status: StripeTaxIdVerificationStatus;
  /** Verified address. */
  verified_address: string | null;
  /** Verified name. */
  verified_name: string | null;
}

export enum StripeTaxIdVerificationStatus {
  Pending = 'pending',
  Unavailable = 'unavailable',
  Unverified = 'unverified',
  Verified = 'verified',
}

/** The DeletedTaxId object. */
export interface StripeDeletedTaxId {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'tax_id';
  /** Always true for a deleted object */
  deleted: true;
}

export interface StripeInvoiceAutomaticTax {
  /** Whether Stripe automatically computes tax on this invoice. Note that incompatible invoice items (invoice items with manually specified [tax rates](https://stripe.com/docs/api/tax_rates), negative amounts, or `tax_behavior=unspecified`) cannot be added to automatic tax invoices. */
  enabled: boolean;
  /** The status of the most recent automated tax calculation for this invoice. */
  status: StripeInvoiceAutomaticTaxStatus | null;
}

export enum StripeInvoiceAutomaticTaxStatus {
  Complete = 'complete',
  Failed = 'failed',
  RequiresLocationInputs = 'requires_location_inputs',
}

export enum StripeInvoiceBillingReason {
  AutomaticPendingInvoiceItemInvoice = 'automatic_pending_invoice_item_invoice',
  Manual = 'manual',
  QuoteAccept = 'quote_accept',
  Subscription = 'subscription',
  SubscriptionCreate = 'subscription_create',
  SubscriptionCycle = 'subscription_cycle',
  SubscriptionThreshold = 'subscription_threshold',
  SubscriptionUpdate = 'subscription_update',
  Upcoming = 'upcoming',
}

export enum StripeInvoiceCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice',
}

export interface StripeInvoiceCustomField {
  /** The name of the custom field. */
  name: string;
  /** The value of the custom field. */
  value: string;
}

export interface StripeInvoiceCustomerShipping {
  /** The Address object. */
  address?: StripeAddress;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. */
  carrier?: string | null;
  /** Recipient name. */
  name?: string;
  /** Recipient phone (including extension). */
  phone?: string | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  tracking_number?: string | null;
}

export enum StripeInvoiceCustomerTaxExempt {
  Exempt = 'exempt',
  None = 'none',
  Reverse = 'reverse',
}

export interface StripeInvoiceCustomerTaxId {
  /** The type of the tax ID, one of `eu_vat`, `br_cnpj`, `br_cpf`, `eu_oss_vat`, `gb_vat`, `nz_gst`, `au_abn`, `au_arn`, `in_gst`, `no_vat`, `za_vat`, `ch_vat`, `mx_rfc`, `sg_uen`, `ru_inn`, `ru_kpp`, `ca_bn`, `hk_br`, `es_cif`, `tw_vat`, `th_vat`, `jp_cn`, `jp_rn`, `jp_trn`, `li_uid`, `my_itn`, `us_ein`, `kr_brn`, `ca_qst`, `ca_gst_hst`, `ca_pst_bc`, `ca_pst_mb`, `ca_pst_sk`, `my_sst`, `sg_gst`, `ae_trn`, `cl_tin`, `sa_vat`, `id_npwp`, `my_frp`, `il_vat`, `ge_vat`, `ua_vat`, `is_vat`, `bg_uic`, `hu_tin`, `si_tin`, `ke_pin`, `tr_tin`, `eg_tin`, `ph_tin`, or `unknown` */
  type: StripeInvoiceCustomerTaxIdType;
  /** The value of the tax ID. */
  value: string | null;
}

export enum StripeInvoiceCustomerTaxIdType {
  AeTrn = 'ae_trn',
  AuAbn = 'au_abn',
  AuArn = 'au_arn',
  BgUic = 'bg_uic',
  BrCnpj = 'br_cnpj',
  BrCpf = 'br_cpf',
  CaBn = 'ca_bn',
  CaGstHst = 'ca_gst_hst',
  CaPstBc = 'ca_pst_bc',
  CaPstMb = 'ca_pst_mb',
  CaPstSk = 'ca_pst_sk',
  CaQst = 'ca_qst',
  ChVat = 'ch_vat',
  ClTin = 'cl_tin',
  EgTin = 'eg_tin',
  EsCif = 'es_cif',
  EuOssVat = 'eu_oss_vat',
  EuVat = 'eu_vat',
  GbVat = 'gb_vat',
  GeVat = 'ge_vat',
  HkBr = 'hk_br',
  HuTin = 'hu_tin',
  IdNpwp = 'id_npwp',
  IlVat = 'il_vat',
  InGst = 'in_gst',
  IsVat = 'is_vat',
  JpCn = 'jp_cn',
  JpRn = 'jp_rn',
  JpTrn = 'jp_trn',
  KePin = 'ke_pin',
  KrBrn = 'kr_brn',
  LiUid = 'li_uid',
  MxRfc = 'mx_rfc',
  MyFrp = 'my_frp',
  MyItn = 'my_itn',
  MySst = 'my_sst',
  NoVat = 'no_vat',
  NzGst = 'nz_gst',
  PhTin = 'ph_tin',
  RuInn = 'ru_inn',
  RuKpp = 'ru_kpp',
  SaVat = 'sa_vat',
  SgGst = 'sg_gst',
  SgUen = 'sg_uen',
  SiTin = 'si_tin',
  ThVat = 'th_vat',
  TrTin = 'tr_tin',
  TwVat = 'tw_vat',
  UaVat = 'ua_vat',
  Unknown = 'unknown',
  UsEin = 'us_ein',
  ZaVat = 'za_vat',
}

/**
 * Tax rates can be applied to [invoices](https://stripe.com/docs/billing/invoices/tax-rates), [subscriptions](https://stripe.com/docs/billing/subscriptions/taxes) and [Checkout Sessions](https://stripe.com/docs/payments/checkout/set-up-a-subscription#tax-rates) to collect tax.
 *
 * Related guide: [Tax rates](https://stripe.com/docs/billing/taxes/tax-rates)
 */
export interface StripeTaxRate {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'tax_rate';
  /** Defaults to `true`. When set to `false`, this tax rate cannot be used with new applications or Checkout Sessions, but will still work for subscriptions and invoices that already have it set. */
  active: boolean;
  /** Two-letter country code ([ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)). */
  country: string | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** An arbitrary string attached to the tax rate for your internal use only. It will not be visible to your customers. */
  description: string | null;
  /** The display name of the tax rates as it will appear to your customer on their receipt email, PDF, and the hosted invoice page. */
  display_name: string;
  /** Actual/effective tax rate percentage out of 100. For tax calculations with automatic_tax[enabled]=true, this percentage does not include the statutory tax rate of non-taxable jurisdictions. */
  effective_percentage: number | null;
  /** This specifies if the tax rate is inclusive or exclusive. */
  inclusive: boolean;
  /** The jurisdiction for the tax rate. You can use this label field for tax reporting purposes. It also appears on your customer's invoice. */
  jurisdiction: string | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** Tax rate percentage out of 100. For tax calculations with automatic_tax[enabled]=true, this percentage includes the statutory tax rate of non-taxable jurisdictions. */
  percentage: number;
  /** [ISO 3166-2 subdivision code](https://en.wikipedia.org/wiki/ISO_3166-2:US), without country prefix. For example, "NY" for New York, United States. */
  state: string | null;
  /** The high-level tax type, such as `vat` or `sales_tax`. */
  tax_type: StripeTaxRateTaxType | null;
}

export enum StripeTaxRateTaxType {
  AmusementTax = 'amusement_tax',
  CommunicationsTax = 'communications_tax',
  Gst = 'gst',
  Hst = 'hst',
  Igst = 'igst',
  Jct = 'jct',
  LeaseTax = 'lease_tax',
  Pst = 'pst',
  Qst = 'qst',
  Rst = 'rst',
  SalesTax = 'sales_tax',
  Vat = 'vat',
}

/** The DeletedDiscount object. */
export interface StripeDeletedDiscount {
  /** The ID of the discount object. Discounts cannot be fetched by ID. Use `expand[]=discounts` in API calls to expand discount IDs in an array. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'discount';
  /** The Checkout session that this coupon is applied to, if it is applied to a particular session in payment mode. Will not be present for subscription mode. */
  checkout_session: string | null;
  /** A coupon contains information about a percent-off or amount-off discount you might want to apply to a customer. Coupons may be applied to [subscriptions](https://stripe.com/docs/api#subscriptions), [invoices](https://stripe.com/docs/api#invoices), [checkout sessions](https://stripe.com/docs/api/checkout/sessions), [quotes](https://stripe.com/docs/api#quotes), and more. Coupons do not work with conventional one-off [charges](https://stripe.com/docs/api#create_charge) or [payment intents](https://stripe.com/docs/api/payment_intents). */
  coupon: StripeCoupon;
  /** The ID of the customer associated with this discount. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** Always true for a deleted object */
  deleted: true;
  /** The invoice that the discount's coupon was applied to, if it was applied directly to a particular invoice. */
  invoice: string | null;
  /** The invoice item `id` (or invoice line item `id` for invoice line items of type='subscription') that the discount's coupon was applied to, if it was applied directly to a particular invoice item or invoice line item. */
  invoice_item: string | null;
  /** The promotion code applied to create this discount. */
  promotion_code: string | StripePromotionCode | null;
  /** Date that the coupon was applied. */
  start: number;
  /** The subscription that this coupon is applied to, if it is applied to a particular subscription. */
  subscription: string | null;
}

export interface StripeInvoiceFromInvoice {
  /** The relation between this invoice and the cloned invoice */
  action: string;
  /** The invoice that was cloned. */
  invoice: string | StripeInvoice;
}

export interface StripeInvoiceLastFinalizationError {
  /** For card errors, the ID of the failed charge. */
  charge?: string;
  /** For some errors that could be handled programmatically, a short string indicating the [error code](https://stripe.com/docs/error-codes) reported. */
  code?: StripeInvoiceLastFinalizationErrorCode;
  /** For card errors resulting from a card issuer decline, a short string indicating the [card issuer's reason for the decline](https://stripe.com/docs/declines#issuer-declines) if they provide one. */
  decline_code?: string;
  /** A URL to more information about the [error code](https://stripe.com/docs/error-codes) reported. */
  doc_url?: string;
  /** A human-readable message providing more details about the error. For card errors, these messages can be shown to your users. */
  message?: string;
  /** If the error is parameter-specific, the parameter related to the error. For example, you can use this to display a message near the correct form field. */
  param?: string;
  /**
   * A PaymentIntent guides you through the process of collecting a payment from your customer. We recommend that you create exactly one PaymentIntent for each order or customer session in your system. You can reference the PaymentIntent later to see the history of payment attempts for a particular session.
   *
   * A PaymentIntent transitions through [multiple statuses](https://stripe.com/docs/payments/intents#intent-statuses) throughout its lifetime as it interfaces with Stripe.js to perform authentication flows and ultimately creates at most one successful charge.
   *
   * Related guide: [Payment Intents API](https://stripe.com/docs/payments/payment-intents)
   */
  payment_intent?: StripePaymentIntent;
  /**
   * PaymentMethod objects represent your customer's payment instruments. You can use them with [PaymentIntents](https://stripe.com/docs/payments/payment-intents) to collect payments or save them to Customer objects to store instrument details for future payments.
   *
   * Related guides: [Payment Methods](https://stripe.com/docs/payments/payment-methods) and [More Payment Scenarios](https://stripe.com/docs/payments/more-payment-scenarios).
   */
  payment_method?: StripePaymentMethod;
  /** If the error is specific to the type of payment method, the payment method type that had a problem. This field is only populated for invoice-related errors. */
  payment_method_type?: string;
  /** A URL to the request log entry in your dashboard. */
  request_log_url?: string;
  /**
   * A SetupIntent guides you through the process of setting up and saving a customer's payment credentials for future payments. For example, you could use a SetupIntent to set up and save your customer's card without immediately collecting a payment. Later, you can use [PaymentIntents](https://stripe.com/docs/api#payment_intents) to drive the payment flow.
   *
   * Create a SetupIntent as soon as you're ready to collect your customer's payment credentials. Do not maintain long-lived, unconfirmed SetupIntents as they may no longer be valid. The SetupIntent then transitions through multiple [statuses](https://stripe.com/docs/payments/intents#intent-statuses) as it guides you through the setup process.
   *
   * Successful SetupIntents result in payment credentials that are optimized for future payments. For example, cardholders in [certain regions](https://stripe.com/guides/strong-customer-authentication) may need to be run through [Strong Customer Authentication](https://stripe.com/docs/strong-customer-authentication) at the time of payment method collection in order to streamline later [off-session payments](https://stripe.com/docs/payments/setup-intents). If the SetupIntent is used with a [Customer](https://stripe.com/docs/api#setup_intent_object-customer), upon success, it will automatically attach the resulting payment method to that Customer. We recommend using SetupIntents or [setup_future_usage](https://stripe.com/docs/api#payment_intent_object-setup_future_usage) on PaymentIntents to save payment methods in order to prevent saving invalid or unoptimized payment methods.
   *
   * By using SetupIntents, you ensure that your customers experience the minimum set of required friction, even as regulations change over time.
   *
   * Related guide: [Setup Intents API](https://stripe.com/docs/payments/setup-intents)
   */
  setup_intent?: StripeSetupIntent;
  source?: StripeCustomerSource;
  /** The type of error returned. One of `api_error`, `card_error`, `idempotency_error`, or `invalid_request_error` */
  type: StripeInvoiceLastFinalizationErrorType;
}

export enum StripeInvoiceLastFinalizationErrorCode {
  AccountClosed = 'account_closed',
  AccountCountryInvalidAddress = 'account_country_invalid_address',
  AccountErrorCountryChangeRequiresAdditionalSteps = 'account_error_country_change_requires_additional_steps',
  AccountInformationMismatch = 'account_information_mismatch',
  AccountInvalid = 'account_invalid',
  AccountNumberInvalid = 'account_number_invalid',
  AcssDebitSessionIncomplete = 'acss_debit_session_incomplete',
  AlipayUpgradeRequired = 'alipay_upgrade_required',
  AmountTooLarge = 'amount_too_large',
  AmountTooSmall = 'amount_too_small',
  ApiKeyExpired = 'api_key_expired',
  AuthenticationRequired = 'authentication_required',
  BalanceInsufficient = 'balance_insufficient',
  BankAccountBadRoutingNumbers = 'bank_account_bad_routing_numbers',
  BankAccountDeclined = 'bank_account_declined',
  BankAccountExists = 'bank_account_exists',
  BankAccountRestricted = 'bank_account_restricted',
  BankAccountUnusable = 'bank_account_unusable',
  BankAccountUnverified = 'bank_account_unverified',
  BankAccountVerificationFailed = 'bank_account_verification_failed',
  BillingInvalidMandate = 'billing_invalid_mandate',
  BitcoinUpgradeRequired = 'bitcoin_upgrade_required',
  CaptureChargeAuthorizationExpired = 'capture_charge_authorization_expired',
  CaptureUnauthorizedPayment = 'capture_unauthorized_payment',
  CardDeclineRateLimitExceeded = 'card_decline_rate_limit_exceeded',
  CardDeclined = 'card_declined',
  CardholderPhoneNumberRequired = 'cardholder_phone_number_required',
  ChargeAlreadyCaptured = 'charge_already_captured',
  ChargeAlreadyRefunded = 'charge_already_refunded',
  ChargeDisputed = 'charge_disputed',
  ChargeExceedsSourceLimit = 'charge_exceeds_source_limit',
  ChargeExpiredForCapture = 'charge_expired_for_capture',
  ChargeInvalidParameter = 'charge_invalid_parameter',
  ChargeNotRefundable = 'charge_not_refundable',
  ClearingCodeUnsupported = 'clearing_code_unsupported',
  CountryCodeInvalid = 'country_code_invalid',
  CountryUnsupported = 'country_unsupported',
  CouponExpired = 'coupon_expired',
  CustomerMaxPaymentMethods = 'customer_max_payment_methods',
  CustomerMaxSubscriptions = 'customer_max_subscriptions',
  DebitNotAuthorized = 'debit_not_authorized',
  EmailInvalid = 'email_invalid',
  ExpiredCard = 'expired_card',
  IdempotencyKeyInUse = 'idempotency_key_in_use',
  IncorrectAddress = 'incorrect_address',
  IncorrectCvc = 'incorrect_cvc',
  IncorrectNumber = 'incorrect_number',
  IncorrectZip = 'incorrect_zip',
  InstantPayoutsConfigDisabled = 'instant_payouts_config_disabled',
  InstantPayoutsCurrencyDisabled = 'instant_payouts_currency_disabled',
  InstantPayoutsLimitExceeded = 'instant_payouts_limit_exceeded',
  InstantPayoutsUnsupported = 'instant_payouts_unsupported',
  InsufficientFunds = 'insufficient_funds',
  IntentInvalidState = 'intent_invalid_state',
  IntentVerificationMethodMissing = 'intent_verification_method_missing',
  InvalidCardType = 'invalid_card_type',
  InvalidCharacters = 'invalid_characters',
  InvalidChargeAmount = 'invalid_charge_amount',
  InvalidCvc = 'invalid_cvc',
  InvalidExpiryMonth = 'invalid_expiry_month',
  InvalidExpiryYear = 'invalid_expiry_year',
  InvalidNumber = 'invalid_number',
  InvalidSourceUsage = 'invalid_source_usage',
  InvoiceNoCustomerLineItems = 'invoice_no_customer_line_items',
  InvoiceNoPaymentMethodTypes = 'invoice_no_payment_method_types',
  InvoiceNoSubscriptionLineItems = 'invoice_no_subscription_line_items',
  InvoiceNotEditable = 'invoice_not_editable',
  InvoiceOnBehalfOfNotEditable = 'invoice_on_behalf_of_not_editable',
  InvoicePaymentIntentRequiresAction = 'invoice_payment_intent_requires_action',
  InvoiceUpcomingNone = 'invoice_upcoming_none',
  LivemodeMismatch = 'livemode_mismatch',
  LockTimeout = 'lock_timeout',
  Missing = 'missing',
  NoAccount = 'no_account',
  NotAllowedOnStandardAccount = 'not_allowed_on_standard_account',
  OutOfInventory = 'out_of_inventory',
  OwnershipDeclarationNotAllowed = 'ownership_declaration_not_allowed',
  ParameterInvalidEmpty = 'parameter_invalid_empty',
  ParameterInvalidInteger = 'parameter_invalid_integer',
  ParameterInvalidStringBlank = 'parameter_invalid_string_blank',
  ParameterInvalidStringEmpty = 'parameter_invalid_string_empty',
  ParameterMissing = 'parameter_missing',
  ParameterUnknown = 'parameter_unknown',
  ParametersExclusive = 'parameters_exclusive',
  PaymentIntentActionRequired = 'payment_intent_action_required',
  PaymentIntentAuthenticationFailure = 'payment_intent_authentication_failure',
  PaymentIntentIncompatiblePaymentMethod = 'payment_intent_incompatible_payment_method',
  PaymentIntentInvalidParameter = 'payment_intent_invalid_parameter',
  PaymentIntentKonbiniRejectedConfirmationNumber = 'payment_intent_konbini_rejected_confirmation_number',
  PaymentIntentMandateInvalid = 'payment_intent_mandate_invalid',
  PaymentIntentPaymentAttemptExpired = 'payment_intent_payment_attempt_expired',
  PaymentIntentPaymentAttemptFailed = 'payment_intent_payment_attempt_failed',
  PaymentIntentUnexpectedState = 'payment_intent_unexpected_state',
  PaymentMethodBankAccountAlreadyVerified = 'payment_method_bank_account_already_verified',
  PaymentMethodBankAccountBlocked = 'payment_method_bank_account_blocked',
  PaymentMethodBillingDetailsAddressMissing = 'payment_method_billing_details_address_missing',
  PaymentMethodConfigurationFailures = 'payment_method_configuration_failures',
  PaymentMethodCurrencyMismatch = 'payment_method_currency_mismatch',
  PaymentMethodCustomerDecline = 'payment_method_customer_decline',
  PaymentMethodInvalidParameter = 'payment_method_invalid_parameter',
  PaymentMethodInvalidParameterTestmode = 'payment_method_invalid_parameter_testmode',
  PaymentMethodMicrodepositFailed = 'payment_method_microdeposit_failed',
  PaymentMethodMicrodepositVerificationAmountsInvalid = 'payment_method_microdeposit_verification_amounts_invalid',
  PaymentMethodMicrodepositVerificationAmountsMismatch = 'payment_method_microdeposit_verification_amounts_mismatch',
  PaymentMethodMicrodepositVerificationAttemptsExceeded = 'payment_method_microdeposit_verification_attempts_exceeded',
  PaymentMethodMicrodepositVerificationDescriptorCodeMismatch = 'payment_method_microdeposit_verification_descriptor_code_mismatch',
  PaymentMethodMicrodepositVerificationTimeout = 'payment_method_microdeposit_verification_timeout',
  PaymentMethodNotAvailable = 'payment_method_not_available',
  PaymentMethodProviderDecline = 'payment_method_provider_decline',
  PaymentMethodProviderTimeout = 'payment_method_provider_timeout',
  PaymentMethodUnactivated = 'payment_method_unactivated',
  PaymentMethodUnexpectedState = 'payment_method_unexpected_state',
  PaymentMethodUnsupportedType = 'payment_method_unsupported_type',
  PayoutReconciliationNotReady = 'payout_reconciliation_not_ready',
  PayoutsLimitExceeded = 'payouts_limit_exceeded',
  PayoutsNotAllowed = 'payouts_not_allowed',
  PlatformAccountRequired = 'platform_account_required',
  PlatformApiKeyExpired = 'platform_api_key_expired',
  PostalCodeInvalid = 'postal_code_invalid',
  ProcessingError = 'processing_error',
  ProductInactive = 'product_inactive',
  ProgressiveOnboardingLimitExceeded = 'progressive_onboarding_limit_exceeded',
  RateLimit = 'rate_limit',
  ReferToCustomer = 'refer_to_customer',
  RefundDisputedPayment = 'refund_disputed_payment',
  ResourceAlreadyExists = 'resource_already_exists',
  ResourceMissing = 'resource_missing',
  ReturnIntentAlreadyProcessed = 'return_intent_already_processed',
  RoutingNumberInvalid = 'routing_number_invalid',
  SecretKeyRequired = 'secret_key_required',
  SepaUnsupportedAccount = 'sepa_unsupported_account',
  SetupAttemptFailed = 'setup_attempt_failed',
  SetupIntentAuthenticationFailure = 'setup_intent_authentication_failure',
  SetupIntentInvalidParameter = 'setup_intent_invalid_parameter',
  SetupIntentMandateInvalid = 'setup_intent_mandate_invalid',
  SetupIntentSetupAttemptExpired = 'setup_intent_setup_attempt_expired',
  SetupIntentUnexpectedState = 'setup_intent_unexpected_state',
  ShippingCalculationFailed = 'shipping_calculation_failed',
  SkuInactive = 'sku_inactive',
  StateUnsupported = 'state_unsupported',
  StatusTransitionInvalid = 'status_transition_invalid',
  TaxIdInvalid = 'tax_id_invalid',
  TaxesCalculationFailed = 'taxes_calculation_failed',
  TerminalLocationCountryUnsupported = 'terminal_location_country_unsupported',
  TerminalReaderBusy = 'terminal_reader_busy',
  TerminalReaderOffline = 'terminal_reader_offline',
  TerminalReaderTimeout = 'terminal_reader_timeout',
  TestmodeChargesOnly = 'testmode_charges_only',
  TlsVersionUnsupported = 'tls_version_unsupported',
  TokenAlreadyUsed = 'token_already_used',
  TokenInUse = 'token_in_use',
  TransferSourceBalanceParametersMismatch = 'transfer_source_balance_parameters_mismatch',
  TransfersNotAllowed = 'transfers_not_allowed',
  UrlInvalid = 'url_invalid',
}

/**
 * A SetupIntent guides you through the process of setting up and saving a customer's payment credentials for future payments. For example, you could use a SetupIntent to set up and save your customer's card without immediately collecting a payment. Later, you can use [PaymentIntents](https://stripe.com/docs/api#payment_intents) to drive the payment flow.
 *
 * Create a SetupIntent as soon as you're ready to collect your customer's payment credentials. Do not maintain long-lived, unconfirmed SetupIntents as they may no longer be valid. The SetupIntent then transitions through multiple [statuses](https://stripe.com/docs/payments/intents#intent-statuses) as it guides you through the setup process.
 *
 * Successful SetupIntents result in payment credentials that are optimized for future payments. For example, cardholders in [certain regions](https://stripe.com/guides/strong-customer-authentication) may need to be run through [Strong Customer Authentication](https://stripe.com/docs/strong-customer-authentication) at the time of payment method collection in order to streamline later [off-session payments](https://stripe.com/docs/payments/setup-intents). If the SetupIntent is used with a [Customer](https://stripe.com/docs/api#setup_intent_object-customer), upon success, it will automatically attach the resulting payment method to that Customer. We recommend using SetupIntents or [setup_future_usage](https://stripe.com/docs/api#payment_intent_object-setup_future_usage) on PaymentIntents to save payment methods in order to prevent saving invalid or unoptimized payment methods.
 *
 * By using SetupIntents, you ensure that your customers experience the minimum set of required friction, even as regulations change over time.
 *
 * Related guide: [Setup Intents API](https://stripe.com/docs/payments/setup-intents)
 */
export interface StripeSetupIntent {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'setup_intent';
  /** ID of the Connect application that created the SetupIntent. */
  application: string | StripeApplication | null;
  /**
   * If present, the SetupIntent's payment method will be attached to the in-context Stripe Account.
   *
   * It can only be used for this Stripe Account's own money movement flows like InboundTransfer and OutboundTransfers. It cannot be set to true when setting up a PaymentMethod for a Customer, and defaults to false when attaching a PaymentMethod to a Customer.
   */
  attach_to_self?: boolean;
  /** Settings for automatic payment methods compatible with this Setup Intent */
  automatic_payment_methods: StripeSetupIntentAutomaticPaymentMethods | null;
  /** Reason for cancellation of this SetupIntent, one of `abandoned`, `requested_by_customer`, or `duplicate`. */
  cancellation_reason: StripeSetupIntentCancellationReason | null;
  /**
   * The client secret of this SetupIntent. Used for client-side retrieval using a publishable key.
   *
   * The client secret can be used to complete payment setup from your frontend. It should not be stored, logged, or exposed to anyone other than the customer. Make sure that you have TLS enabled on any page that includes the client secret.
   */
  client_secret: string | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /**
   * ID of the Customer this SetupIntent belongs to, if one exists.
   *
   * If present, the SetupIntent's payment method will be attached to the Customer on successful setup. Payment methods attached to other Customers cannot be used with this SetupIntent.
   */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /**
   * Indicates the directions of money movement for which this payment method is intended to be used.
   *
   * Include `inbound` if you intend to use the payment method as the origin to pull funds from. Include `outbound` if you intend to use the payment method as the destination to send funds to. You can include both if you intend to use the payment method for both purposes.
   */
  flow_directions: StripeSetupIntentFlowDirection[] | null;
  /** The error encountered in the previous SetupIntent confirmation. */
  last_setup_error: StripeSetupIntentLastSetupError | null;
  /** The most recent SetupAttempt for this SetupIntent. */
  latest_attempt: string | StripeSetupAttempt | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** ID of the multi use Mandate generated by the SetupIntent. */
  mandate: string | StripeMandate | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** If present, this property tells you what actions you need to take in order for your customer to continue payment setup. */
  next_action: StripeSetupIntentNextAction | null;
  /** The account (if any) for which the setup is intended. */
  on_behalf_of: string | StripeAccount | null;
  /** ID of the payment method used with this SetupIntent. */
  payment_method: string | StripePaymentMethod | null;
  /** Payment-method-specific configuration for this SetupIntent. */
  payment_method_options: StripeSetupIntentPaymentMethodOptions | null;
  /** The list of payment method types (e.g. card) that this SetupIntent is allowed to set up. */
  payment_method_types: string[];
  /** ID of the single_use Mandate generated by the SetupIntent. */
  single_use_mandate: string | StripeMandate | null;
  /** [Status](https://stripe.com/docs/payments/intents#intent-statuses) of this SetupIntent, one of `requires_payment_method`, `requires_confirmation`, `requires_action`, `processing`, `canceled`, or `succeeded`. */
  status: StripeSetupIntentStatus;
  /**
   * Indicates how the payment method is intended to be used in the future.
   *
   * Use `on_session` if you intend to only reuse the payment method when the customer is in your checkout flow. Use `off_session` if your customer may or may not be in your checkout flow. If not provided, this value defaults to `off_session`.
   */
  usage: string;
}

export interface StripeSetupIntentAutomaticPaymentMethods {
  /** Automatically calculates compatible payment methods */
  enabled: boolean | null;
}

export enum StripeSetupIntentCancellationReason {
  Abandoned = 'abandoned',
  Duplicate = 'duplicate',
  RequestedByCustomer = 'requested_by_customer',
}

export enum StripeSetupIntentFlowDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

export interface StripeSetupIntentLastSetupError {
  /** For card errors, the ID of the failed charge. */
  charge?: string;
  /** For some errors that could be handled programmatically, a short string indicating the [error code](https://stripe.com/docs/error-codes) reported. */
  code?: StripeSetupIntentLastSetupErrorCode;
  /** For card errors resulting from a card issuer decline, a short string indicating the [card issuer's reason for the decline](https://stripe.com/docs/declines#issuer-declines) if they provide one. */
  decline_code?: string;
  /** A URL to more information about the [error code](https://stripe.com/docs/error-codes) reported. */
  doc_url?: string;
  /** A human-readable message providing more details about the error. For card errors, these messages can be shown to your users. */
  message?: string;
  /** If the error is parameter-specific, the parameter related to the error. For example, you can use this to display a message near the correct form field. */
  param?: string;
  /**
   * A PaymentIntent guides you through the process of collecting a payment from your customer. We recommend that you create exactly one PaymentIntent for each order or customer session in your system. You can reference the PaymentIntent later to see the history of payment attempts for a particular session.
   *
   * A PaymentIntent transitions through [multiple statuses](https://stripe.com/docs/payments/intents#intent-statuses) throughout its lifetime as it interfaces with Stripe.js to perform authentication flows and ultimately creates at most one successful charge.
   *
   * Related guide: [Payment Intents API](https://stripe.com/docs/payments/payment-intents)
   */
  payment_intent?: StripePaymentIntent;
  /**
   * PaymentMethod objects represent your customer's payment instruments. You can use them with [PaymentIntents](https://stripe.com/docs/payments/payment-intents) to collect payments or save them to Customer objects to store instrument details for future payments.
   *
   * Related guides: [Payment Methods](https://stripe.com/docs/payments/payment-methods) and [More Payment Scenarios](https://stripe.com/docs/payments/more-payment-scenarios).
   */
  payment_method?: StripePaymentMethod;
  /** If the error is specific to the type of payment method, the payment method type that had a problem. This field is only populated for invoice-related errors. */
  payment_method_type?: string;
  /** A URL to the request log entry in your dashboard. */
  request_log_url?: string;
  /**
   * A SetupIntent guides you through the process of setting up and saving a customer's payment credentials for future payments. For example, you could use a SetupIntent to set up and save your customer's card without immediately collecting a payment. Later, you can use [PaymentIntents](https://stripe.com/docs/api#payment_intents) to drive the payment flow.
   *
   * Create a SetupIntent as soon as you're ready to collect your customer's payment credentials. Do not maintain long-lived, unconfirmed SetupIntents as they may no longer be valid. The SetupIntent then transitions through multiple [statuses](https://stripe.com/docs/payments/intents#intent-statuses) as it guides you through the setup process.
   *
   * Successful SetupIntents result in payment credentials that are optimized for future payments. For example, cardholders in [certain regions](https://stripe.com/guides/strong-customer-authentication) may need to be run through [Strong Customer Authentication](https://stripe.com/docs/strong-customer-authentication) at the time of payment method collection in order to streamline later [off-session payments](https://stripe.com/docs/payments/setup-intents). If the SetupIntent is used with a [Customer](https://stripe.com/docs/api#setup_intent_object-customer), upon success, it will automatically attach the resulting payment method to that Customer. We recommend using SetupIntents or [setup_future_usage](https://stripe.com/docs/api#payment_intent_object-setup_future_usage) on PaymentIntents to save payment methods in order to prevent saving invalid or unoptimized payment methods.
   *
   * By using SetupIntents, you ensure that your customers experience the minimum set of required friction, even as regulations change over time.
   *
   * Related guide: [Setup Intents API](https://stripe.com/docs/payments/setup-intents)
   */
  setup_intent?: StripeSetupIntent;
  source?: StripeCustomerSource;
  /** The type of error returned. One of `api_error`, `card_error`, `idempotency_error`, or `invalid_request_error` */
  type: StripeSetupIntentLastSetupErrorType;
}

export enum StripeSetupIntentLastSetupErrorCode {
  AccountClosed = 'account_closed',
  AccountCountryInvalidAddress = 'account_country_invalid_address',
  AccountErrorCountryChangeRequiresAdditionalSteps = 'account_error_country_change_requires_additional_steps',
  AccountInformationMismatch = 'account_information_mismatch',
  AccountInvalid = 'account_invalid',
  AccountNumberInvalid = 'account_number_invalid',
  AcssDebitSessionIncomplete = 'acss_debit_session_incomplete',
  AlipayUpgradeRequired = 'alipay_upgrade_required',
  AmountTooLarge = 'amount_too_large',
  AmountTooSmall = 'amount_too_small',
  ApiKeyExpired = 'api_key_expired',
  AuthenticationRequired = 'authentication_required',
  BalanceInsufficient = 'balance_insufficient',
  BankAccountBadRoutingNumbers = 'bank_account_bad_routing_numbers',
  BankAccountDeclined = 'bank_account_declined',
  BankAccountExists = 'bank_account_exists',
  BankAccountRestricted = 'bank_account_restricted',
  BankAccountUnusable = 'bank_account_unusable',
  BankAccountUnverified = 'bank_account_unverified',
  BankAccountVerificationFailed = 'bank_account_verification_failed',
  BillingInvalidMandate = 'billing_invalid_mandate',
  BitcoinUpgradeRequired = 'bitcoin_upgrade_required',
  CaptureChargeAuthorizationExpired = 'capture_charge_authorization_expired',
  CaptureUnauthorizedPayment = 'capture_unauthorized_payment',
  CardDeclineRateLimitExceeded = 'card_decline_rate_limit_exceeded',
  CardDeclined = 'card_declined',
  CardholderPhoneNumberRequired = 'cardholder_phone_number_required',
  ChargeAlreadyCaptured = 'charge_already_captured',
  ChargeAlreadyRefunded = 'charge_already_refunded',
  ChargeDisputed = 'charge_disputed',
  ChargeExceedsSourceLimit = 'charge_exceeds_source_limit',
  ChargeExpiredForCapture = 'charge_expired_for_capture',
  ChargeInvalidParameter = 'charge_invalid_parameter',
  ChargeNotRefundable = 'charge_not_refundable',
  ClearingCodeUnsupported = 'clearing_code_unsupported',
  CountryCodeInvalid = 'country_code_invalid',
  CountryUnsupported = 'country_unsupported',
  CouponExpired = 'coupon_expired',
  CustomerMaxPaymentMethods = 'customer_max_payment_methods',
  CustomerMaxSubscriptions = 'customer_max_subscriptions',
  DebitNotAuthorized = 'debit_not_authorized',
  EmailInvalid = 'email_invalid',
  ExpiredCard = 'expired_card',
  IdempotencyKeyInUse = 'idempotency_key_in_use',
  IncorrectAddress = 'incorrect_address',
  IncorrectCvc = 'incorrect_cvc',
  IncorrectNumber = 'incorrect_number',
  IncorrectZip = 'incorrect_zip',
  InstantPayoutsConfigDisabled = 'instant_payouts_config_disabled',
  InstantPayoutsCurrencyDisabled = 'instant_payouts_currency_disabled',
  InstantPayoutsLimitExceeded = 'instant_payouts_limit_exceeded',
  InstantPayoutsUnsupported = 'instant_payouts_unsupported',
  InsufficientFunds = 'insufficient_funds',
  IntentInvalidState = 'intent_invalid_state',
  IntentVerificationMethodMissing = 'intent_verification_method_missing',
  InvalidCardType = 'invalid_card_type',
  InvalidCharacters = 'invalid_characters',
  InvalidChargeAmount = 'invalid_charge_amount',
  InvalidCvc = 'invalid_cvc',
  InvalidExpiryMonth = 'invalid_expiry_month',
  InvalidExpiryYear = 'invalid_expiry_year',
  InvalidNumber = 'invalid_number',
  InvalidSourceUsage = 'invalid_source_usage',
  InvoiceNoCustomerLineItems = 'invoice_no_customer_line_items',
  InvoiceNoPaymentMethodTypes = 'invoice_no_payment_method_types',
  InvoiceNoSubscriptionLineItems = 'invoice_no_subscription_line_items',
  InvoiceNotEditable = 'invoice_not_editable',
  InvoiceOnBehalfOfNotEditable = 'invoice_on_behalf_of_not_editable',
  InvoicePaymentIntentRequiresAction = 'invoice_payment_intent_requires_action',
  InvoiceUpcomingNone = 'invoice_upcoming_none',
  LivemodeMismatch = 'livemode_mismatch',
  LockTimeout = 'lock_timeout',
  Missing = 'missing',
  NoAccount = 'no_account',
  NotAllowedOnStandardAccount = 'not_allowed_on_standard_account',
  OutOfInventory = 'out_of_inventory',
  OwnershipDeclarationNotAllowed = 'ownership_declaration_not_allowed',
  ParameterInvalidEmpty = 'parameter_invalid_empty',
  ParameterInvalidInteger = 'parameter_invalid_integer',
  ParameterInvalidStringBlank = 'parameter_invalid_string_blank',
  ParameterInvalidStringEmpty = 'parameter_invalid_string_empty',
  ParameterMissing = 'parameter_missing',
  ParameterUnknown = 'parameter_unknown',
  ParametersExclusive = 'parameters_exclusive',
  PaymentIntentActionRequired = 'payment_intent_action_required',
  PaymentIntentAuthenticationFailure = 'payment_intent_authentication_failure',
  PaymentIntentIncompatiblePaymentMethod = 'payment_intent_incompatible_payment_method',
  PaymentIntentInvalidParameter = 'payment_intent_invalid_parameter',
  PaymentIntentKonbiniRejectedConfirmationNumber = 'payment_intent_konbini_rejected_confirmation_number',
  PaymentIntentMandateInvalid = 'payment_intent_mandate_invalid',
  PaymentIntentPaymentAttemptExpired = 'payment_intent_payment_attempt_expired',
  PaymentIntentPaymentAttemptFailed = 'payment_intent_payment_attempt_failed',
  PaymentIntentUnexpectedState = 'payment_intent_unexpected_state',
  PaymentMethodBankAccountAlreadyVerified = 'payment_method_bank_account_already_verified',
  PaymentMethodBankAccountBlocked = 'payment_method_bank_account_blocked',
  PaymentMethodBillingDetailsAddressMissing = 'payment_method_billing_details_address_missing',
  PaymentMethodConfigurationFailures = 'payment_method_configuration_failures',
  PaymentMethodCurrencyMismatch = 'payment_method_currency_mismatch',
  PaymentMethodCustomerDecline = 'payment_method_customer_decline',
  PaymentMethodInvalidParameter = 'payment_method_invalid_parameter',
  PaymentMethodInvalidParameterTestmode = 'payment_method_invalid_parameter_testmode',
  PaymentMethodMicrodepositFailed = 'payment_method_microdeposit_failed',
  PaymentMethodMicrodepositVerificationAmountsInvalid = 'payment_method_microdeposit_verification_amounts_invalid',
  PaymentMethodMicrodepositVerificationAmountsMismatch = 'payment_method_microdeposit_verification_amounts_mismatch',
  PaymentMethodMicrodepositVerificationAttemptsExceeded = 'payment_method_microdeposit_verification_attempts_exceeded',
  PaymentMethodMicrodepositVerificationDescriptorCodeMismatch = 'payment_method_microdeposit_verification_descriptor_code_mismatch',
  PaymentMethodMicrodepositVerificationTimeout = 'payment_method_microdeposit_verification_timeout',
  PaymentMethodNotAvailable = 'payment_method_not_available',
  PaymentMethodProviderDecline = 'payment_method_provider_decline',
  PaymentMethodProviderTimeout = 'payment_method_provider_timeout',
  PaymentMethodUnactivated = 'payment_method_unactivated',
  PaymentMethodUnexpectedState = 'payment_method_unexpected_state',
  PaymentMethodUnsupportedType = 'payment_method_unsupported_type',
  PayoutReconciliationNotReady = 'payout_reconciliation_not_ready',
  PayoutsLimitExceeded = 'payouts_limit_exceeded',
  PayoutsNotAllowed = 'payouts_not_allowed',
  PlatformAccountRequired = 'platform_account_required',
  PlatformApiKeyExpired = 'platform_api_key_expired',
  PostalCodeInvalid = 'postal_code_invalid',
  ProcessingError = 'processing_error',
  ProductInactive = 'product_inactive',
  ProgressiveOnboardingLimitExceeded = 'progressive_onboarding_limit_exceeded',
  RateLimit = 'rate_limit',
  ReferToCustomer = 'refer_to_customer',
  RefundDisputedPayment = 'refund_disputed_payment',
  ResourceAlreadyExists = 'resource_already_exists',
  ResourceMissing = 'resource_missing',
  ReturnIntentAlreadyProcessed = 'return_intent_already_processed',
  RoutingNumberInvalid = 'routing_number_invalid',
  SecretKeyRequired = 'secret_key_required',
  SepaUnsupportedAccount = 'sepa_unsupported_account',
  SetupAttemptFailed = 'setup_attempt_failed',
  SetupIntentAuthenticationFailure = 'setup_intent_authentication_failure',
  SetupIntentInvalidParameter = 'setup_intent_invalid_parameter',
  SetupIntentMandateInvalid = 'setup_intent_mandate_invalid',
  SetupIntentSetupAttemptExpired = 'setup_intent_setup_attempt_expired',
  SetupIntentUnexpectedState = 'setup_intent_unexpected_state',
  ShippingCalculationFailed = 'shipping_calculation_failed',
  SkuInactive = 'sku_inactive',
  StateUnsupported = 'state_unsupported',
  StatusTransitionInvalid = 'status_transition_invalid',
  TaxIdInvalid = 'tax_id_invalid',
  TaxesCalculationFailed = 'taxes_calculation_failed',
  TerminalLocationCountryUnsupported = 'terminal_location_country_unsupported',
  TerminalReaderBusy = 'terminal_reader_busy',
  TerminalReaderOffline = 'terminal_reader_offline',
  TerminalReaderTimeout = 'terminal_reader_timeout',
  TestmodeChargesOnly = 'testmode_charges_only',
  TlsVersionUnsupported = 'tls_version_unsupported',
  TokenAlreadyUsed = 'token_already_used',
  TokenInUse = 'token_in_use',
  TransferSourceBalanceParametersMismatch = 'transfer_source_balance_parameters_mismatch',
  TransfersNotAllowed = 'transfers_not_allowed',
  UrlInvalid = 'url_invalid',
}

export enum StripeSetupIntentLastSetupErrorType {
  ApiError = 'api_error',
  CardError = 'card_error',
  IdempotencyError = 'idempotency_error',
  InvalidRequestError = 'invalid_request_error',
}

/** A SetupAttempt describes one attempted confirmation of a SetupIntent, whether that confirmation was successful or unsuccessful. You can use SetupAttempts to inspect details of a specific attempt at setting up a payment method using a SetupIntent. */
export interface StripeSetupAttempt {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'setup_attempt';
  /** The value of [application](https://stripe.com/docs/api/setup_intents/object#setup_intent_object-application) on the SetupIntent at the time of this confirmation. */
  application: string | StripeApplication | null;
  /**
   * If present, the SetupIntent's payment method will be attached to the in-context Stripe Account.
   *
   * It can only be used for this Stripe Account's own money movement flows like InboundTransfer and OutboundTransfers. It cannot be set to true when setting up a PaymentMethod for a Customer, and defaults to false when attaching a PaymentMethod to a Customer.
   */
  attach_to_self?: boolean;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The value of [customer](https://stripe.com/docs/api/setup_intents/object#setup_intent_object-customer) on the SetupIntent at the time of this confirmation. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /**
   * Indicates the directions of money movement for which this payment method is intended to be used.
   *
   * Include `inbound` if you intend to use the payment method as the origin to pull funds from. Include `outbound` if you intend to use the payment method as the destination to send funds to. You can include both if you intend to use the payment method for both purposes.
   */
  flow_directions: StripeSetupAttemptFlowDirection[] | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** The value of [on_behalf_of](https://stripe.com/docs/api/setup_intents/object#setup_intent_object-on_behalf_of) on the SetupIntent at the time of this confirmation. */
  on_behalf_of: string | StripeAccount | null;
  /** ID of the payment method used with this SetupAttempt. */
  payment_method: string | StripePaymentMethod;
  payment_method_details: StripeSetupAttemptPaymentMethodDetails;
  /** The error encountered during this attempt to confirm the SetupIntent, if any. */
  setup_error: StripeSetupAttemptSetupError | null;
  /** ID of the SetupIntent that this attempt belongs to. */
  setup_intent: string | StripeSetupIntent;
  /** Status of this SetupAttempt, one of `requires_confirmation`, `requires_action`, `processing`, `succeeded`, `failed`, or `abandoned`. */
  status: string;
  /** The value of [usage](https://stripe.com/docs/api/setup_intents/object#setup_intent_object-usage) on the SetupIntent at the time of this confirmation, one of `off_session` or `on_session`. */
  usage: string;
}

export enum StripeSetupAttemptFlowDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

export interface StripeSetupAttemptPaymentMethodDetails {
  acss_debit?: StripeSetupAttemptPaymentMethodDetailsAcssDebit;
  au_becs_debit?: StripeSetupAttemptPaymentMethodDetailsAuBecsDebit;
  bacs_debit?: StripeSetupAttemptPaymentMethodDetailsBacsDebit;
  bancontact?: StripeSetupAttemptPaymentMethodDetailsBancontact;
  blik?: StripeSetupAttemptPaymentMethodDetailsBlik;
  boleto?: StripeSetupAttemptPaymentMethodDetailsBoleto;
  card?: StripeSetupAttemptPaymentMethodDetailsCard;
  card_present?: StripeSetupAttemptPaymentMethodDetailsCardPresent;
  cashapp?: StripeSetupAttemptPaymentMethodDetailsCashapp;
  ideal?: StripeSetupAttemptPaymentMethodDetailsIdeal;
  klarna?: StripeSetupAttemptPaymentMethodDetailsKlarna;
  link?: StripeSetupAttemptPaymentMethodDetailsLink;
  paypal?: StripeSetupAttemptPaymentMethodDetailsPaypal;
  sepa_debit?: StripeSetupAttemptPaymentMethodDetailsSepaDebit;
  sofort?: StripeSetupAttemptPaymentMethodDetailsSofort;
  /** The type of the payment method used in the SetupIntent (e.g., `card`). An additional hash is included on `payment_method_details` with a name matching this value. It contains confirmation-specific information for the payment method. */
  type: string;
  us_bank_account?: StripeSetupAttemptPaymentMethodDetailsUsBankAccount;
}

export type StripeSetupAttemptPaymentMethodDetailsAcssDebit = object;

export type StripeSetupAttemptPaymentMethodDetailsAuBecsDebit = object;

export type StripeSetupAttemptPaymentMethodDetailsBacsDebit = object;

export interface StripeSetupAttemptPaymentMethodDetailsBancontact {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Bank Identifier Code of the bank associated with the bank account. */
  bic: string | null;
  /** The ID of the SEPA Direct Debit PaymentMethod which was generated by this SetupAttempt. */
  generated_sepa_debit: string | StripePaymentMethod | null;
  /** The mandate for the SEPA Direct Debit PaymentMethod which was generated by this SetupAttempt. */
  generated_sepa_debit_mandate: string | StripeMandate | null;
  /** Last four characters of the IBAN. */
  iban_last4: string | null;
  /** Preferred language of the Bancontact authorization page that the customer is redirected to. Can be one of `en`, `de`, `fr`, or `nl` */
  preferred_language: StripeSetupAttemptPaymentMethodDetailsBancontactPreferredLanguage | null;
  /** Owner's verified full name. Values are verified or provided by Bancontact directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
}

/** A Mandate is a record of the permission a customer has given you to debit their payment method. */
export interface StripeMandate {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'mandate';
  customer_acceptance: StripeMandateCustomerAcceptance;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  multi_use?: StripeMandateMultiUse;
  /** ID of the payment method associated with this mandate. */
  payment_method: string | StripePaymentMethod;
  payment_method_details: StripeMandatePaymentMethodDetails;
  single_use?: StripeMandateSingleUse;
  /** The status of the mandate, which indicates whether it can be used to initiate a payment. */
  status: StripeMandateStatus;
  /** The type of the mandate. */
  type: StripeMandateType;
}

export interface StripeMandateCustomerAcceptance {
  /** The time at which the customer accepted the Mandate. */
  accepted_at: number | null;
  offline?: StripeMandateCustomerAcceptanceOffline;
  online?: StripeMandateCustomerAcceptanceOnline;
  /** The type of customer acceptance information included with the Mandate. One of `online` or `offline`. */
  type: StripeMandateCustomerAcceptanceType;
}

export type StripeMandateCustomerAcceptanceOffline = object;

export interface StripeMandateCustomerAcceptanceOnline {
  /** The IP address from which the Mandate was accepted by the customer. */
  ip_address: string | null;
  /** The user agent of the browser from which the Mandate was accepted by the customer. */
  user_agent: string | null;
}

export enum StripeMandateCustomerAcceptanceType {
  Offline = 'offline',
  Online = 'online',
}

export type StripeMandateMultiUse = object;

export interface StripeMandatePaymentMethodDetails {
  acss_debit?: StripeMandatePaymentMethodDetailsAcssDebit;
  au_becs_debit?: StripeMandatePaymentMethodDetailsAuBecsDebit;
  bacs_debit?: StripeMandatePaymentMethodDetailsBacsDebit;
  blik?: StripeMandatePaymentMethodDetailsBlik;
  card?: StripeMandatePaymentMethodDetailsCard;
  cashapp?: StripeMandatePaymentMethodDetailsCashapp;
  link?: StripeMandatePaymentMethodDetailsLink;
  paypal?: StripeMandatePaymentMethodDetailsPaypal;
  sepa_debit?: StripeMandatePaymentMethodDetailsSepaDebit;
  /** The type of the payment method associated with this mandate. An additional hash is included on `payment_method_details` with a name matching this value. It contains mandate information specific to the payment method. */
  type: string;
  us_bank_account?: StripeMandatePaymentMethodDetailsUsBankAccount;
}

export interface StripeMandatePaymentMethodDetailsAcssDebit {
  /** List of Stripe products where this mandate can be selected automatically. */
  default_for?: StripeMandatePaymentMethodDetailsAcssDebitDefaultFor[];
  /** Description of the interval. Only required if the 'payment_schedule' parameter is 'interval' or 'combined'. */
  interval_description: string | null;
  /** Payment schedule for the mandate. */
  payment_schedule: StripeMandatePaymentMethodDetailsAcssDebitPaymentSchedule;
  /** Transaction type of the mandate. */
  transaction_type: StripeMandatePaymentMethodDetailsAcssDebitTransactionType;
}

export enum StripeMandatePaymentMethodDetailsAcssDebitDefaultFor {
  Invoice = 'invoice',
  Subscription = 'subscription',
}

export enum StripeMandatePaymentMethodDetailsAcssDebitPaymentSchedule {
  Combined = 'combined',
  Interval = 'interval',
  Sporadic = 'sporadic',
}

export enum StripeMandatePaymentMethodDetailsAcssDebitTransactionType {
  Business = 'business',
  Personal = 'personal',
}

export interface StripeMandatePaymentMethodDetailsAuBecsDebit {
  /** The URL of the mandate. This URL generally contains sensitive information about the customer and should be shared with them exclusively. */
  url: string;
}

export interface StripeMandatePaymentMethodDetailsBacsDebit {
  /** The status of the mandate on the Bacs network. Can be one of `pending`, `revoked`, `refused`, or `accepted`. */
  network_status: StripeMandatePaymentMethodDetailsBacsDebitNetworkStatus;
  /** The unique reference identifying the mandate on the Bacs network. */
  reference: string;
  /** The URL that will contain the mandate that the customer has signed. */
  url: string;
}

export enum StripeMandatePaymentMethodDetailsBacsDebitNetworkStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused',
  Revoked = 'revoked',
}

export interface StripeMandatePaymentMethodDetailsBlik {
  /** Date at which the mandate expires. */
  expires_after: number | null;
  off_session?: StripeMandatePaymentMethodDetailsBlikOffSession;
  /** Type of the mandate. */
  type: StripeMandatePaymentMethodDetailsBlikType | null;
}

export interface StripeMandatePaymentMethodDetailsBlikOffSession {
  /** Amount of each recurring payment. */
  amount: number | null;
  /** Currency of each recurring payment. */
  currency: string | null;
  /** Frequency interval of each recurring payment. */
  interval: StripeMandatePaymentMethodDetailsBlikOffSessionInterval | null;
  /** Frequency indicator of each recurring payment. */
  interval_count: number | null;
}

export enum StripeMandatePaymentMethodDetailsBlikOffSessionInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export enum StripeMandatePaymentMethodDetailsBlikType {
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export type StripeMandatePaymentMethodDetailsCard = object;

export type StripeMandatePaymentMethodDetailsCashapp = object;

export type StripeMandatePaymentMethodDetailsLink = object;

export interface StripeMandatePaymentMethodDetailsPaypal {
  /** The PayPal Billing Agreement ID (BAID). This is an ID generated by PayPal which represents the mandate between the merchant and the customer. */
  billing_agreement_id: string | null;
  /** PayPal account PayerID. This identifier uniquely identifies the PayPal customer. */
  payer_id?: string | null;
}

export interface StripeMandatePaymentMethodDetailsSepaDebit {
  /** The unique reference of the mandate. */
  reference: string;
  /** The URL of the mandate. This URL generally contains sensitive information about the customer and should be shared with them exclusively. */
  url: string;
}

export type StripeMandatePaymentMethodDetailsUsBankAccount = object;

export interface StripeMandateSingleUse {
  /** On a single use mandate, the amount of the payment. */
  amount: number;
  /** On a single use mandate, the currency of the payment. */
  currency: string;
}

export enum StripeMandateStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum StripeMandateType {
  MultiUse = 'multi_use',
  SingleUse = 'single_use',
}

export enum StripeSetupAttemptPaymentMethodDetailsBancontactPreferredLanguage {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export type StripeSetupAttemptPaymentMethodDetailsBlik = object;

export type StripeSetupAttemptPaymentMethodDetailsBoleto = object;

export interface StripeSetupAttemptPaymentMethodDetailsCard {
  /** Card brand. Can be `amex`, `diners`, `discover`, `eftpos_au`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  brand: string | null;
  /** Check results by Card networks on Card address and CVC at the time of authorization */
  checks: StripeSetupAttemptPaymentMethodDetailsCardChecks | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number | null;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number | null;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint?: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string | null;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string | null;
  /** Identifies which network this charge was processed on. Can be `amex`, `cartes_bancaires`, `diners`, `discover`, `eftpos_au`, `interac`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  network: string | null;
  /** Populated if this authorization used 3D Secure authentication. */
  three_d_secure: StripeSetupAttemptPaymentMethodDetailsCardThreeDSecure | null;
  /** If this Card is part of a card wallet, this contains the details of the card wallet. */
  wallet: StripeSetupAttemptPaymentMethodDetailsCardWallet | null;
}

export interface StripeSetupAttemptPaymentMethodDetailsCardChecks {
  /** If a address line1 was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_line1_check: string | null;
  /** If a address postal code was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_postal_code_check: string | null;
  /** If a CVC was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  cvc_check: string | null;
}

export interface StripeSetupAttemptPaymentMethodDetailsCardThreeDSecure {
  /** For authenticated transactions: how the customer was authenticated by the issuing bank. */
  authentication_flow: StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureAuthenticationFlow | null;
  /** Indicates the outcome of 3D Secure authentication. */
  result: StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureResult | null;
  /** Additional information about why 3D Secure succeeded or failed based on the `result`. */
  result_reason: StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureResultReason | null;
  /** The version of 3D Secure that was used. */
  version: StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureVersion | null;
}

export enum StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureAuthenticationFlow {
  Challenge = 'challenge',
  Frictionless = 'frictionless',
}

export enum StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureResult {
  AttemptAcknowledged = 'attempt_acknowledged',
  Authenticated = 'authenticated',
  Exempted = 'exempted',
  Failed = 'failed',
  NotSupported = 'not_supported',
  ProcessingError = 'processing_error',
}

export enum StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureResultReason {
  Abandoned = 'abandoned',
  Bypassed = 'bypassed',
  Canceled = 'canceled',
  CardNotEnrolled = 'card_not_enrolled',
  NetworkNotSupported = 'network_not_supported',
  ProtocolError = 'protocol_error',
  Rejected = 'rejected',
}

export enum StripeSetupAttemptPaymentMethodDetailsCardThreeDSecureVersion {
  Value102 = '1.0.2',
  Value210 = '2.1.0',
  Value220 = '2.2.0',
}

export interface StripeSetupAttemptPaymentMethodDetailsCardWallet {
  apple_pay?: StripeSetupAttemptPaymentMethodDetailsCardWalletApplePay;
  google_pay?: StripeSetupAttemptPaymentMethodDetailsCardWalletGooglePay;
  /** The type of the card wallet, one of `apple_pay`, `google_pay`, or `link`. An additional hash is included on the Wallet subhash with a name matching this value. It contains additional information specific to the card wallet type. */
  type: StripeSetupAttemptPaymentMethodDetailsCardWalletType;
}

export type StripeSetupAttemptPaymentMethodDetailsCardWalletApplePay = object;

export type StripeSetupAttemptPaymentMethodDetailsCardWalletGooglePay = object;

export enum StripeSetupAttemptPaymentMethodDetailsCardWalletType {
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  Link = 'link',
}

export interface StripeSetupAttemptPaymentMethodDetailsCardPresent {
  /** The ID of the Card PaymentMethod which was generated by this SetupAttempt. */
  generated_card: string | StripePaymentMethod | null;
}

export type StripeSetupAttemptPaymentMethodDetailsCashapp = object;

export interface StripeSetupAttemptPaymentMethodDetailsIdeal {
  /** The customer's bank. Can be one of `abn_amro`, `asn_bank`, `bunq`, `handelsbanken`, `ing`, `knab`, `moneyou`, `rabobank`, `regiobank`, `revolut`, `sns_bank`, `triodos_bank`, `van_lanschot`, or `yoursafe`. */
  bank: StripeSetupAttemptPaymentMethodDetailsIdealBank | null;
  /** The Bank Identifier Code of the customer's bank. */
  bic: StripeSetupAttemptPaymentMethodDetailsIdealBic | null;
  /** The ID of the SEPA Direct Debit PaymentMethod which was generated by this SetupAttempt. */
  generated_sepa_debit: string | StripePaymentMethod | null;
  /** The mandate for the SEPA Direct Debit PaymentMethod which was generated by this SetupAttempt. */
  generated_sepa_debit_mandate: string | StripeMandate | null;
  /** Last four characters of the IBAN. */
  iban_last4: string | null;
  /** Owner's verified full name. Values are verified or provided by iDEAL directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
}

export enum StripeSetupAttemptPaymentMethodDetailsIdealBank {
  AbnAmro = 'abn_amro',
  AsnBank = 'asn_bank',
  Bunq = 'bunq',
  Handelsbanken = 'handelsbanken',
  Ing = 'ing',
  Knab = 'knab',
  Moneyou = 'moneyou',
  Rabobank = 'rabobank',
  Regiobank = 'regiobank',
  Revolut = 'revolut',
  SnsBank = 'sns_bank',
  TriodosBank = 'triodos_bank',
  VanLanschot = 'van_lanschot',
  Yoursafe = 'yoursafe',
}

export enum StripeSetupAttemptPaymentMethodDetailsIdealBic {
  ABNANL2A = 'ABNANL2A',
  ASNBNL21 = 'ASNBNL21',
  BITSNL2A = 'BITSNL2A',
  BUNQNL2A = 'BUNQNL2A',
  FVLBNL22 = 'FVLBNL22',
  HANDNL2A = 'HANDNL2A',
  INGBNL2A = 'INGBNL2A',
  KNABNL2H = 'KNABNL2H',
  MOYONL21 = 'MOYONL21',
  RABONL2U = 'RABONL2U',
  RBRBNL21 = 'RBRBNL21',
  REVOIE23 = 'REVOIE23',
  REVOLT21 = 'REVOLT21',
  SNSBNL2A = 'SNSBNL2A',
  TRIONL2U = 'TRIONL2U',
}

export type StripeSetupAttemptPaymentMethodDetailsKlarna = object;

export type StripeSetupAttemptPaymentMethodDetailsLink = object;

export type StripeSetupAttemptPaymentMethodDetailsPaypal = object;

export type StripeSetupAttemptPaymentMethodDetailsSepaDebit = object;

export interface StripeSetupAttemptPaymentMethodDetailsSofort {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Bank Identifier Code of the bank associated with the bank account. */
  bic: string | null;
  /** The ID of the SEPA Direct Debit PaymentMethod which was generated by this SetupAttempt. */
  generated_sepa_debit: string | StripePaymentMethod | null;
  /** The mandate for the SEPA Direct Debit PaymentMethod which was generated by this SetupAttempt. */
  generated_sepa_debit_mandate: string | StripeMandate | null;
  /** Last four characters of the IBAN. */
  iban_last4: string | null;
  /** Preferred language of the Sofort authorization page that the customer is redirected to. Can be one of `en`, `de`, `fr`, or `nl` */
  preferred_language: StripeSetupAttemptPaymentMethodDetailsSofortPreferredLanguage | null;
  /** Owner's verified full name. Values are verified or provided by Sofort directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
}

export enum StripeSetupAttemptPaymentMethodDetailsSofortPreferredLanguage {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export type StripeSetupAttemptPaymentMethodDetailsUsBankAccount = object;

export interface StripeSetupAttemptSetupError {
  /** For card errors, the ID of the failed charge. */
  charge?: string;
  /** For some errors that could be handled programmatically, a short string indicating the [error code](https://stripe.com/docs/error-codes) reported. */
  code?: StripeSetupAttemptSetupErrorCode;
  /** For card errors resulting from a card issuer decline, a short string indicating the [card issuer's reason for the decline](https://stripe.com/docs/declines#issuer-declines) if they provide one. */
  decline_code?: string;
  /** A URL to more information about the [error code](https://stripe.com/docs/error-codes) reported. */
  doc_url?: string;
  /** A human-readable message providing more details about the error. For card errors, these messages can be shown to your users. */
  message?: string;
  /** If the error is parameter-specific, the parameter related to the error. For example, you can use this to display a message near the correct form field. */
  param?: string;
  /**
   * A PaymentIntent guides you through the process of collecting a payment from your customer. We recommend that you create exactly one PaymentIntent for each order or customer session in your system. You can reference the PaymentIntent later to see the history of payment attempts for a particular session.
   *
   * A PaymentIntent transitions through [multiple statuses](https://stripe.com/docs/payments/intents#intent-statuses) throughout its lifetime as it interfaces with Stripe.js to perform authentication flows and ultimately creates at most one successful charge.
   *
   * Related guide: [Payment Intents API](https://stripe.com/docs/payments/payment-intents)
   */
  payment_intent?: StripePaymentIntent;
  /**
   * PaymentMethod objects represent your customer's payment instruments. You can use them with [PaymentIntents](https://stripe.com/docs/payments/payment-intents) to collect payments or save them to Customer objects to store instrument details for future payments.
   *
   * Related guides: [Payment Methods](https://stripe.com/docs/payments/payment-methods) and [More Payment Scenarios](https://stripe.com/docs/payments/more-payment-scenarios).
   */
  payment_method?: StripePaymentMethod;
  /** If the error is specific to the type of payment method, the payment method type that had a problem. This field is only populated for invoice-related errors. */
  payment_method_type?: string;
  /** A URL to the request log entry in your dashboard. */
  request_log_url?: string;
  /**
   * A SetupIntent guides you through the process of setting up and saving a customer's payment credentials for future payments. For example, you could use a SetupIntent to set up and save your customer's card without immediately collecting a payment. Later, you can use [PaymentIntents](https://stripe.com/docs/api#payment_intents) to drive the payment flow.
   *
   * Create a SetupIntent as soon as you're ready to collect your customer's payment credentials. Do not maintain long-lived, unconfirmed SetupIntents as they may no longer be valid. The SetupIntent then transitions through multiple [statuses](https://stripe.com/docs/payments/intents#intent-statuses) as it guides you through the setup process.
   *
   * Successful SetupIntents result in payment credentials that are optimized for future payments. For example, cardholders in [certain regions](https://stripe.com/guides/strong-customer-authentication) may need to be run through [Strong Customer Authentication](https://stripe.com/docs/strong-customer-authentication) at the time of payment method collection in order to streamline later [off-session payments](https://stripe.com/docs/payments/setup-intents). If the SetupIntent is used with a [Customer](https://stripe.com/docs/api#setup_intent_object-customer), upon success, it will automatically attach the resulting payment method to that Customer. We recommend using SetupIntents or [setup_future_usage](https://stripe.com/docs/api#payment_intent_object-setup_future_usage) on PaymentIntents to save payment methods in order to prevent saving invalid or unoptimized payment methods.
   *
   * By using SetupIntents, you ensure that your customers experience the minimum set of required friction, even as regulations change over time.
   *
   * Related guide: [Setup Intents API](https://stripe.com/docs/payments/setup-intents)
   */
  setup_intent?: StripeSetupIntent;
  source?: StripeCustomerSource;
  /** The type of error returned. One of `api_error`, `card_error`, `idempotency_error`, or `invalid_request_error` */
  type: StripeSetupAttemptSetupErrorType;
}

export enum StripeSetupAttemptSetupErrorCode {
  AccountClosed = 'account_closed',
  AccountCountryInvalidAddress = 'account_country_invalid_address',
  AccountErrorCountryChangeRequiresAdditionalSteps = 'account_error_country_change_requires_additional_steps',
  AccountInformationMismatch = 'account_information_mismatch',
  AccountInvalid = 'account_invalid',
  AccountNumberInvalid = 'account_number_invalid',
  AcssDebitSessionIncomplete = 'acss_debit_session_incomplete',
  AlipayUpgradeRequired = 'alipay_upgrade_required',
  AmountTooLarge = 'amount_too_large',
  AmountTooSmall = 'amount_too_small',
  ApiKeyExpired = 'api_key_expired',
  AuthenticationRequired = 'authentication_required',
  BalanceInsufficient = 'balance_insufficient',
  BankAccountBadRoutingNumbers = 'bank_account_bad_routing_numbers',
  BankAccountDeclined = 'bank_account_declined',
  BankAccountExists = 'bank_account_exists',
  BankAccountRestricted = 'bank_account_restricted',
  BankAccountUnusable = 'bank_account_unusable',
  BankAccountUnverified = 'bank_account_unverified',
  BankAccountVerificationFailed = 'bank_account_verification_failed',
  BillingInvalidMandate = 'billing_invalid_mandate',
  BitcoinUpgradeRequired = 'bitcoin_upgrade_required',
  CaptureChargeAuthorizationExpired = 'capture_charge_authorization_expired',
  CaptureUnauthorizedPayment = 'capture_unauthorized_payment',
  CardDeclineRateLimitExceeded = 'card_decline_rate_limit_exceeded',
  CardDeclined = 'card_declined',
  CardholderPhoneNumberRequired = 'cardholder_phone_number_required',
  ChargeAlreadyCaptured = 'charge_already_captured',
  ChargeAlreadyRefunded = 'charge_already_refunded',
  ChargeDisputed = 'charge_disputed',
  ChargeExceedsSourceLimit = 'charge_exceeds_source_limit',
  ChargeExpiredForCapture = 'charge_expired_for_capture',
  ChargeInvalidParameter = 'charge_invalid_parameter',
  ChargeNotRefundable = 'charge_not_refundable',
  ClearingCodeUnsupported = 'clearing_code_unsupported',
  CountryCodeInvalid = 'country_code_invalid',
  CountryUnsupported = 'country_unsupported',
  CouponExpired = 'coupon_expired',
  CustomerMaxPaymentMethods = 'customer_max_payment_methods',
  CustomerMaxSubscriptions = 'customer_max_subscriptions',
  DebitNotAuthorized = 'debit_not_authorized',
  EmailInvalid = 'email_invalid',
  ExpiredCard = 'expired_card',
  IdempotencyKeyInUse = 'idempotency_key_in_use',
  IncorrectAddress = 'incorrect_address',
  IncorrectCvc = 'incorrect_cvc',
  IncorrectNumber = 'incorrect_number',
  IncorrectZip = 'incorrect_zip',
  InstantPayoutsConfigDisabled = 'instant_payouts_config_disabled',
  InstantPayoutsCurrencyDisabled = 'instant_payouts_currency_disabled',
  InstantPayoutsLimitExceeded = 'instant_payouts_limit_exceeded',
  InstantPayoutsUnsupported = 'instant_payouts_unsupported',
  InsufficientFunds = 'insufficient_funds',
  IntentInvalidState = 'intent_invalid_state',
  IntentVerificationMethodMissing = 'intent_verification_method_missing',
  InvalidCardType = 'invalid_card_type',
  InvalidCharacters = 'invalid_characters',
  InvalidChargeAmount = 'invalid_charge_amount',
  InvalidCvc = 'invalid_cvc',
  InvalidExpiryMonth = 'invalid_expiry_month',
  InvalidExpiryYear = 'invalid_expiry_year',
  InvalidNumber = 'invalid_number',
  InvalidSourceUsage = 'invalid_source_usage',
  InvoiceNoCustomerLineItems = 'invoice_no_customer_line_items',
  InvoiceNoPaymentMethodTypes = 'invoice_no_payment_method_types',
  InvoiceNoSubscriptionLineItems = 'invoice_no_subscription_line_items',
  InvoiceNotEditable = 'invoice_not_editable',
  InvoiceOnBehalfOfNotEditable = 'invoice_on_behalf_of_not_editable',
  InvoicePaymentIntentRequiresAction = 'invoice_payment_intent_requires_action',
  InvoiceUpcomingNone = 'invoice_upcoming_none',
  LivemodeMismatch = 'livemode_mismatch',
  LockTimeout = 'lock_timeout',
  Missing = 'missing',
  NoAccount = 'no_account',
  NotAllowedOnStandardAccount = 'not_allowed_on_standard_account',
  OutOfInventory = 'out_of_inventory',
  OwnershipDeclarationNotAllowed = 'ownership_declaration_not_allowed',
  ParameterInvalidEmpty = 'parameter_invalid_empty',
  ParameterInvalidInteger = 'parameter_invalid_integer',
  ParameterInvalidStringBlank = 'parameter_invalid_string_blank',
  ParameterInvalidStringEmpty = 'parameter_invalid_string_empty',
  ParameterMissing = 'parameter_missing',
  ParameterUnknown = 'parameter_unknown',
  ParametersExclusive = 'parameters_exclusive',
  PaymentIntentActionRequired = 'payment_intent_action_required',
  PaymentIntentAuthenticationFailure = 'payment_intent_authentication_failure',
  PaymentIntentIncompatiblePaymentMethod = 'payment_intent_incompatible_payment_method',
  PaymentIntentInvalidParameter = 'payment_intent_invalid_parameter',
  PaymentIntentKonbiniRejectedConfirmationNumber = 'payment_intent_konbini_rejected_confirmation_number',
  PaymentIntentMandateInvalid = 'payment_intent_mandate_invalid',
  PaymentIntentPaymentAttemptExpired = 'payment_intent_payment_attempt_expired',
  PaymentIntentPaymentAttemptFailed = 'payment_intent_payment_attempt_failed',
  PaymentIntentUnexpectedState = 'payment_intent_unexpected_state',
  PaymentMethodBankAccountAlreadyVerified = 'payment_method_bank_account_already_verified',
  PaymentMethodBankAccountBlocked = 'payment_method_bank_account_blocked',
  PaymentMethodBillingDetailsAddressMissing = 'payment_method_billing_details_address_missing',
  PaymentMethodConfigurationFailures = 'payment_method_configuration_failures',
  PaymentMethodCurrencyMismatch = 'payment_method_currency_mismatch',
  PaymentMethodCustomerDecline = 'payment_method_customer_decline',
  PaymentMethodInvalidParameter = 'payment_method_invalid_parameter',
  PaymentMethodInvalidParameterTestmode = 'payment_method_invalid_parameter_testmode',
  PaymentMethodMicrodepositFailed = 'payment_method_microdeposit_failed',
  PaymentMethodMicrodepositVerificationAmountsInvalid = 'payment_method_microdeposit_verification_amounts_invalid',
  PaymentMethodMicrodepositVerificationAmountsMismatch = 'payment_method_microdeposit_verification_amounts_mismatch',
  PaymentMethodMicrodepositVerificationAttemptsExceeded = 'payment_method_microdeposit_verification_attempts_exceeded',
  PaymentMethodMicrodepositVerificationDescriptorCodeMismatch = 'payment_method_microdeposit_verification_descriptor_code_mismatch',
  PaymentMethodMicrodepositVerificationTimeout = 'payment_method_microdeposit_verification_timeout',
  PaymentMethodNotAvailable = 'payment_method_not_available',
  PaymentMethodProviderDecline = 'payment_method_provider_decline',
  PaymentMethodProviderTimeout = 'payment_method_provider_timeout',
  PaymentMethodUnactivated = 'payment_method_unactivated',
  PaymentMethodUnexpectedState = 'payment_method_unexpected_state',
  PaymentMethodUnsupportedType = 'payment_method_unsupported_type',
  PayoutReconciliationNotReady = 'payout_reconciliation_not_ready',
  PayoutsLimitExceeded = 'payouts_limit_exceeded',
  PayoutsNotAllowed = 'payouts_not_allowed',
  PlatformAccountRequired = 'platform_account_required',
  PlatformApiKeyExpired = 'platform_api_key_expired',
  PostalCodeInvalid = 'postal_code_invalid',
  ProcessingError = 'processing_error',
  ProductInactive = 'product_inactive',
  ProgressiveOnboardingLimitExceeded = 'progressive_onboarding_limit_exceeded',
  RateLimit = 'rate_limit',
  ReferToCustomer = 'refer_to_customer',
  RefundDisputedPayment = 'refund_disputed_payment',
  ResourceAlreadyExists = 'resource_already_exists',
  ResourceMissing = 'resource_missing',
  ReturnIntentAlreadyProcessed = 'return_intent_already_processed',
  RoutingNumberInvalid = 'routing_number_invalid',
  SecretKeyRequired = 'secret_key_required',
  SepaUnsupportedAccount = 'sepa_unsupported_account',
  SetupAttemptFailed = 'setup_attempt_failed',
  SetupIntentAuthenticationFailure = 'setup_intent_authentication_failure',
  SetupIntentInvalidParameter = 'setup_intent_invalid_parameter',
  SetupIntentMandateInvalid = 'setup_intent_mandate_invalid',
  SetupIntentSetupAttemptExpired = 'setup_intent_setup_attempt_expired',
  SetupIntentUnexpectedState = 'setup_intent_unexpected_state',
  ShippingCalculationFailed = 'shipping_calculation_failed',
  SkuInactive = 'sku_inactive',
  StateUnsupported = 'state_unsupported',
  StatusTransitionInvalid = 'status_transition_invalid',
  TaxIdInvalid = 'tax_id_invalid',
  TaxesCalculationFailed = 'taxes_calculation_failed',
  TerminalLocationCountryUnsupported = 'terminal_location_country_unsupported',
  TerminalReaderBusy = 'terminal_reader_busy',
  TerminalReaderOffline = 'terminal_reader_offline',
  TerminalReaderTimeout = 'terminal_reader_timeout',
  TestmodeChargesOnly = 'testmode_charges_only',
  TlsVersionUnsupported = 'tls_version_unsupported',
  TokenAlreadyUsed = 'token_already_used',
  TokenInUse = 'token_in_use',
  TransferSourceBalanceParametersMismatch = 'transfer_source_balance_parameters_mismatch',
  TransfersNotAllowed = 'transfers_not_allowed',
  UrlInvalid = 'url_invalid',
}

export enum StripeSetupAttemptSetupErrorType {
  ApiError = 'api_error',
  CardError = 'card_error',
  IdempotencyError = 'idempotency_error',
  InvalidRequestError = 'invalid_request_error',
}

export interface StripeSetupIntentNextAction {
  cashapp_handle_redirect_or_display_qr_code?: StripeSetupIntentNextActionCashappHandleRedirectOrDisplayQrCode;
  redirect_to_url?: StripeSetupIntentNextActionRedirectToUrl;
  /** Type of the next action to perform, one of `redirect_to_url`, `use_stripe_sdk`, `alipay_handle_redirect`, `oxxo_display_details`, or `verify_with_microdeposits`. */
  type: string;
  /** When confirming a SetupIntent with Stripe.js, Stripe.js depends on the contents of this dictionary to invoke authentication flows. The shape of the contents is subject to change and is only intended to be used by Stripe.js. */
  use_stripe_sdk?: StripeSetupIntentNextActionUseStripeSdk;
  verify_with_microdeposits?: StripeSetupIntentNextActionVerifyWithMicrodeposits;
}

export interface StripeSetupIntentNextActionCashappHandleRedirectOrDisplayQrCode {
  /** The URL to the hosted Cash App Pay instructions page, which allows customers to view the QR code, and supports QR code refreshing on expiration. */
  hosted_instructions_url: string;
  /** The url for mobile redirect based auth */
  mobile_auth_url: string;
  qr_code: StripeSetupIntentNextActionCashappHandleRedirectOrDisplayQrCodeQrCode;
}

export interface StripeSetupIntentNextActionCashappHandleRedirectOrDisplayQrCodeQrCode {
  /** The date (unix timestamp) when the QR code expires. */
  expires_at: number;
  /** The image_url_png string used to render QR code */
  image_url_png: string;
  /** The image_url_svg string used to render QR code */
  image_url_svg: string;
}

export interface StripeSetupIntentNextActionRedirectToUrl {
  /** If the customer does not exit their browser while authenticating, they will be redirected to this specified URL after completion. */
  return_url: string | null;
  /** The URL you must redirect your customer to in order to authenticate. */
  url: string | null;
}

export type StripeSetupIntentNextActionUseStripeSdk = object;

export interface StripeSetupIntentNextActionVerifyWithMicrodeposits {
  /** The timestamp when the microdeposits are expected to land. */
  arrival_date: number;
  /** The URL for the hosted verification page, which allows customers to verify their bank account. */
  hosted_verification_url: string;
  /** The type of the microdeposit sent to the customer. Used to distinguish between different verification methods. */
  microdeposit_type: StripeSetupIntentNextActionVerifyWithMicrodepositsMicrodepositType | null;
}

export enum StripeSetupIntentNextActionVerifyWithMicrodepositsMicrodepositType {
  Amounts = 'amounts',
  DescriptorCode = 'descriptor_code',
}

export interface StripeSetupIntentPaymentMethodOptions {
  acss_debit?: StripeSetupIntentPaymentMethodOptionsAcssDebit;
  blik?: StripeSetupIntentPaymentMethodOptionsBlik;
  card?: StripeSetupIntentPaymentMethodOptionsCard;
  link?: StripeSetupIntentPaymentMethodOptionsLink;
  paypal?: StripeSetupIntentPaymentMethodOptionsPaypal;
  sepa_debit?: StripeSetupIntentPaymentMethodOptionsSepaDebit;
  us_bank_account?: StripeSetupIntentPaymentMethodOptionsUsBankAccount;
}

export interface StripeSetupIntentPaymentMethodOptionsAcssDebit {
  /** Currency supported by the bank account */
  currency: StripeSetupIntentPaymentMethodOptionsAcssDebitCurrency | null;
  mandate_options?: StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptions;
  /** Bank account verification method. */
  verification_method?: StripeSetupIntentPaymentMethodOptionsAcssDebitVerificationMethod;
}

export enum StripeSetupIntentPaymentMethodOptionsAcssDebitCurrency {
  Cad = 'cad',
  Usd = 'usd',
}

export interface StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptions {
  /** A URL for custom mandate text */
  custom_mandate_url?: string;
  /** List of Stripe products where this mandate can be selected automatically. */
  default_for?: StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptionsDefaultFor[];
  /** Description of the interval. Only required if the 'payment_schedule' parameter is 'interval' or 'combined'. */
  interval_description: string | null;
  /** Payment schedule for the mandate. */
  payment_schedule: StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptionsPaymentSchedule | null;
  /** Transaction type of the mandate. */
  transaction_type: StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptionsTransactionType | null;
}

export enum StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptionsDefaultFor {
  Invoice = 'invoice',
  Subscription = 'subscription',
}

export enum StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptionsPaymentSchedule {
  Combined = 'combined',
  Interval = 'interval',
  Sporadic = 'sporadic',
}

export enum StripeSetupIntentPaymentMethodOptionsAcssDebitMandateOptionsTransactionType {
  Business = 'business',
  Personal = 'personal',
}

export enum StripeSetupIntentPaymentMethodOptionsAcssDebitVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export interface StripeSetupIntentPaymentMethodOptionsBlik {
  mandate_options?: StripeSetupIntentPaymentMethodOptionsBlikMandateOptions;
}

export interface StripeSetupIntentPaymentMethodOptionsBlikMandateOptions {
  /** Date at which the mandate expires. */
  expires_after: number | null;
  off_session?: StripeSetupIntentPaymentMethodOptionsBlikMandateOptionsOffSession;
  /** Type of the mandate. */
  type: StripeSetupIntentPaymentMethodOptionsBlikMandateOptionsType | null;
}

export interface StripeSetupIntentPaymentMethodOptionsBlikMandateOptionsOffSession {
  /** Amount of each recurring payment. */
  amount: number | null;
  /** Currency of each recurring payment. */
  currency: string | null;
  /** Frequency interval of each recurring payment. */
  interval: StripeSetupIntentPaymentMethodOptionsBlikMandateOptionsOffSessionInterval | null;
  /** Frequency indicator of each recurring payment. */
  interval_count: number | null;
}

export enum StripeSetupIntentPaymentMethodOptionsBlikMandateOptionsOffSessionInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export enum StripeSetupIntentPaymentMethodOptionsBlikMandateOptionsType {
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripeSetupIntentPaymentMethodOptionsCard {
  /** Configuration options for setting up an eMandate for cards issued in India. */
  mandate_options: StripeSetupIntentPaymentMethodOptionsCardMandateOptions | null;
  /** Selected network to process this SetupIntent on. Depends on the available networks of the card attached to the setup intent. Can be only set confirm-time. */
  network: StripeSetupIntentPaymentMethodOptionsCardNetwork | null;
  /** We strongly recommend that you rely on our SCA Engine to automatically prompt your customers for authentication based on risk level and [other requirements](https://stripe.com/docs/strong-customer-authentication). However, if you wish to request 3D Secure based on logic from your own fraud engine, provide this option. Permitted values include: `automatic` or `any`. If not provided, defaults to `automatic`. Read our guide on [manually requesting 3D Secure](https://stripe.com/docs/payments/3d-secure#manual-three-ds) for more information on how this configuration interacts with Radar and our SCA Engine. */
  request_three_d_secure: StripeSetupIntentPaymentMethodOptionsCardRequestThreeDSecure | null;
}

export interface StripeSetupIntentPaymentMethodOptionsCardMandateOptions {
  /** Amount to be charged for future payments. */
  amount: number;
  /** One of `fixed` or `maximum`. If `fixed`, the `amount` param refers to the exact amount to be charged in future payments. If `maximum`, the amount charged can be up to the value passed for the `amount` param. */
  amount_type: StripeSetupIntentPaymentMethodOptionsCardMandateOptionsAmountType;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** A description of the mandate or subscription that is meant to be displayed to the customer. */
  description: string | null;
  /** End date of the mandate or subscription. If not provided, the mandate will be active until canceled. If provided, end date should be after start date. */
  end_date: number | null;
  /** Specifies payment frequency. One of `day`, `week`, `month`, `year`, or `sporadic`. */
  interval: StripeSetupIntentPaymentMethodOptionsCardMandateOptionsInterval;
  /** The number of intervals between payments. For example, `interval=month` and `interval_count=3` indicates one payment every three months. Maximum of one year interval allowed (1 year, 12 months, or 52 weeks). This parameter is optional when `interval=sporadic`. */
  interval_count: number | null;
  /** Unique identifier for the mandate or subscription. */
  reference: string;
  /** Start date of the mandate or subscription. Start date should not be lesser than yesterday. */
  start_date: number;
  /** Specifies the type of mandates supported. Possible values are `india`. */
  supported_types: 'india'[] | null;
}

export enum StripeSetupIntentPaymentMethodOptionsCardMandateOptionsAmountType {
  Fixed = 'fixed',
  Maximum = 'maximum',
}

export enum StripeSetupIntentPaymentMethodOptionsCardMandateOptionsInterval {
  Day = 'day',
  Month = 'month',
  Sporadic = 'sporadic',
  Week = 'week',
  Year = 'year',
}

export enum StripeSetupIntentPaymentMethodOptionsCardNetwork {
  Amex = 'amex',
  CartesBancaires = 'cartes_bancaires',
  Diners = 'diners',
  Discover = 'discover',
  EftposAu = 'eftpos_au',
  Interac = 'interac',
  Jcb = 'jcb',
  Mastercard = 'mastercard',
  Unionpay = 'unionpay',
  Unknown = 'unknown',
  Visa = 'visa',
}

export enum StripeSetupIntentPaymentMethodOptionsCardRequestThreeDSecure {
  Any = 'any',
  Automatic = 'automatic',
  ChallengeOnly = 'challenge_only',
}

export interface StripeSetupIntentPaymentMethodOptionsLink {
  /** Token used for persistent Link logins. */
  persistent_token: string | null;
}

export interface StripeSetupIntentPaymentMethodOptionsPaypal {
  /** The PayPal Billing Agreement ID (BAID). This is an ID generated by PayPal which represents the mandate between the merchant and the customer. */
  billing_agreement_id: string | null;
}

export interface StripeSetupIntentPaymentMethodOptionsSepaDebit {
  mandate_options?: StripeSetupIntentPaymentMethodOptionsSepaDebitMandateOptions;
}

export type StripeSetupIntentPaymentMethodOptionsSepaDebitMandateOptions = object;

export interface StripeSetupIntentPaymentMethodOptionsUsBankAccount {
  financial_connections?: StripeSetupIntentPaymentMethodOptionsUsBankAccountFinancialConnections;
  /** Bank account verification method. */
  verification_method?: StripeSetupIntentPaymentMethodOptionsUsBankAccountVerificationMethod;
}

export interface StripeSetupIntentPaymentMethodOptionsUsBankAccountFinancialConnections {
  /** The list of permissions to request. The `payment_method` permission must be included. */
  permissions?: StripeSetupIntentPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission[];
  /** For webview integrations only. Upon completing OAuth login in the native browser, the user will be redirected to this URL to return to your app. */
  return_url?: string;
}

export enum StripeSetupIntentPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission {
  Balances = 'balances',
  Ownership = 'ownership',
  PaymentMethod = 'payment_method',
  Transactions = 'transactions',
}

export enum StripeSetupIntentPaymentMethodOptionsUsBankAccountVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export enum StripeSetupIntentStatus {
  Canceled = 'canceled',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  RequiresConfirmation = 'requires_confirmation',
  RequiresPaymentMethod = 'requires_payment_method',
  Succeeded = 'succeeded',
}

export enum StripeInvoiceLastFinalizationErrorType {
  ApiError = 'api_error',
  CardError = 'card_error',
  IdempotencyError = 'idempotency_error',
  InvalidRequestError = 'invalid_request_error',
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeInvoiceLineItem {
  object: 'list';
  data: StripeInvoiceLineItem[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/** The InvoiceLineItem object. */
export interface StripeInvoiceLineItem {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'line_item';
  /** The amount, in %s. */
  amount: number;
  /** The integer amount in %s representing the amount for this line item, excluding all tax and discounts. */
  amount_excluding_tax: number | null;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** The amount of discount calculated per discount for this line item. */
  discount_amounts: StripeInvoiceLineItemDiscountAmount[] | null;
  /** If true, discounts will apply to this line item. Always false for prorations. */
  discountable: boolean;
  /** The discounts applied to the invoice line item. Line item discounts are applied before invoice discounts. Use `expand[]=discounts` to expand each discount. */
  discounts: (string | StripeDiscount)[] | null;
  /** The ID of the [invoice item](https://stripe.com/docs/api/invoiceitems) associated with this line item if any. */
  invoice_item?: string | StripeInvoiceItem;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. Note that for line items with `type=subscription` this will reflect the metadata of the subscription that caused the line item to be created. */
  metadata: StripeMetadata;
  period: StripeInvoiceLineItemPeriod;
  /** The plan of the subscription, if the line item is a subscription or a proration. */
  plan: StripePlan | null;
  /** The price of the line item. */
  price: StripePrice | null;
  /** Whether this is a proration. */
  proration: boolean;
  /** Additional details for proration line items */
  proration_details: StripeInvoiceLineItemProrationDetails | null;
  /** The quantity of the subscription, if the line item is a subscription or a proration. */
  quantity: number | null;
  /** The subscription that the invoice item pertains to, if any. */
  subscription: string | StripeSubscription | null;
  /** The subscription item that generated this line item. Left empty if the line item is not an explicit result of a subscription. */
  subscription_item?: string | StripeSubscriptionItem;
  /** The amount of tax calculated per tax rate for this line item */
  tax_amounts?: StripeInvoiceLineItemTaxAmount[];
  /** The tax rates which apply to the line item. */
  tax_rates?: StripeTaxRate[];
  /** A string identifying the type of the source of this line item, either an `invoiceitem` or a `subscription`. */
  type: StripeInvoiceLineItemType;
  /** The amount in %s representing the unit amount for this line item, excluding all tax and discounts. */
  unit_amount_excluding_tax: string | null;
}

export interface StripeInvoiceLineItemDiscountAmount {
  /** The amount, in %s, of the discount. */
  amount: number;
  /** The discount that was applied to get this discount amount. */
  discount: string | StripeDiscount | StripeDeletedDiscount;
}

/**
 * Invoice Items represent the component lines of an [invoice](https://stripe.com/docs/api/invoices). An invoice item is added to an invoice by creating or updating it with an `invoice` field, at which point it will be included as [an invoice line item](https://stripe.com/docs/api/invoices/line_item) within [invoice.lines](https://stripe.com/docs/api/invoices/object#invoice_object-lines).
 *
 * Invoice Items can be created before you are ready to actually send the invoice. This can be particularly useful when combined with a [subscription](https://stripe.com/docs/api/subscriptions). Sometimes you want to add a charge or credit to a customer, but actually charge or credit the customer's card only at the end of a regular billing cycle. This is useful for combining several charges (to minimize per-transaction fees), or for having Stripe tabulate your usage-based billing totals.
 *
 * Related guides: [Integrate with the Invoicing API](https://stripe.com/docs/invoicing/integration), [Subscription Invoices](https://stripe.com/docs/billing/invoices/subscription#adding-upcoming-invoice-items).
 */
export interface StripeInvoiceItem {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'invoiceitem';
  /** Amount (in the `currency` specified) of the invoice item. This should always be equal to `unit_amount * quantity`. */
  amount: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** The ID of the customer who will be billed when this invoice item is billed. */
  customer: string | StripeCustomer | StripeDeletedCustomer;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  date: number;
  deleted?: null;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** If true, discounts will apply to this invoice item. Always false for prorations. */
  discountable: boolean;
  /** The discounts which apply to the invoice item. Item discounts are applied before invoice discounts. Use `expand[]=discounts` to expand each discount. */
  discounts: (string | StripeDiscount)[] | null;
  /** The ID of the invoice this invoice item belongs to. */
  invoice: string | StripeInvoice | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  period: StripeInvoiceItemPeriod;
  /** If the invoice item is a proration, the plan of the subscription that the proration was computed for. */
  plan: StripePlan | null;
  /** The price of the invoice item. */
  price: StripePrice | null;
  /** Whether the invoice item was created automatically as a proration adjustment when the customer switched plans. */
  proration: boolean;
  /** Quantity of units for the invoice item. If the invoice item is a proration, the quantity of the subscription that the proration was computed for. */
  quantity: number;
  /** The subscription that this invoice item has been created for, if any. */
  subscription: string | StripeSubscription | null;
  /** The subscription item that this invoice item has been created for, if any. */
  subscription_item?: string;
  /** The tax rates which apply to the invoice item. When set, the `default_tax_rates` on the invoice do not apply to this invoice item. */
  tax_rates: StripeTaxRate[] | null;
  /** ID of the test clock this invoice item belongs to. */
  test_clock: string | StripeTestHelpersTestClock | null;
  /** Unit amount (in the `currency` specified) of the invoice item. */
  unit_amount: number | null;
  /** Same as `unit_amount`, but contains a decimal value with at most 12 decimal places. */
  unit_amount_decimal: string | null;
}

export interface StripeInvoiceItemPeriod {
  /** The end of the period, which must be greater than or equal to the start. This value is inclusive. */
  end: number;
  /** The start of the period. This value is inclusive. */
  start: number;
}

/**
 * You can now model subscriptions more flexibly using the [Prices API](https://stripe.com/docs/api#prices). It replaces the Plans API and is backwards compatible to simplify your migration.
 *
 * Plans define the base price, currency, and billing cycle for recurring purchases of products. [Products](https://stripe.com/docs/api#products) help you track inventory or provisioning, and plans help you track pricing. Different physical goods or levels of service should be represented by products, and pricing options should be represented by plans. This approach lets you change prices without having to change your provisioning scheme.
 *
 * For example, you might have a single "gold" product that has plans for $10/month, $100/year, €9/month, and €90/year.
 *
 * Related guides: [Set up a subscription](https://stripe.com/docs/billing/subscriptions/set-up-subscription) and more about [products and prices](https://stripe.com/docs/products-prices/overview).
 */
export interface StripePlan {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'plan';
  /** Whether the plan can be used for new purchases. */
  active: boolean;
  /** Specifies a usage aggregation strategy for plans of `usage_type=metered`. Allowed values are `sum` for summing up all usage during a period, `last_during_period` for using the last usage record reported within a period, `last_ever` for using the last usage record ever (across period bounds) or `max` which uses the usage record with the maximum reported usage during a period. Defaults to `sum`. */
  aggregate_usage: StripePlanAggregateUsage | null;
  /** The unit amount in %s to be charged, represented as a whole integer if possible. Only set if `billing_scheme=per_unit`. */
  amount: number | null;
  /** The unit amount in %s to be charged, represented as a decimal string with at most 12 decimal places. Only set if `billing_scheme=per_unit`. */
  amount_decimal: string | null;
  /** Describes how to compute the price per period. Either `per_unit` or `tiered`. `per_unit` indicates that the fixed amount (specified in `amount`) will be charged per unit in `quantity` (for plans with `usage_type=licensed`), or per unit of total usage (for plans with `usage_type=metered`). `tiered` indicates that the unit pricing will be computed using a tiering strategy as defined using the `tiers` and `tiers_mode` attributes. */
  billing_scheme: StripePlanBillingScheme;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  deleted?: null;
  /** The frequency at which a subscription is billed. One of `day`, `week`, `month` or `year`. */
  interval: StripePlanInterval;
  /** The number of intervals (specified in the `interval` attribute) between subscription billings. For example, `interval=month` and `interval_count=3` bills every 3 months. */
  interval_count: number;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** A brief description of the plan, hidden from customers. */
  nickname: string | null;
  /** The product whose pricing this plan determines. */
  product: string | StripeProduct | StripeDeletedProduct | null;
  /** Each element represents a pricing tier. This parameter requires `billing_scheme` to be set to `tiered`. See also the documentation for `billing_scheme`. */
  tiers?: StripePlanTier[];
  /** Defines if the tiering price should be `graduated` or `volume` based. In `volume`-based tiering, the maximum quantity within a period determines the per unit price. In `graduated` tiering, pricing can change as the quantity grows. */
  tiers_mode: StripePlanTiersMode | null;
  /** Apply a transformation to the reported usage or set quantity before computing the amount billed. Cannot be combined with `tiers`. */
  transform_usage: StripePlanTransformUsage | null;
  /** Default number of trial days when subscribing a customer to this plan using [`trial_from_plan=true`](https://stripe.com/docs/api#create_subscription-trial_from_plan). */
  trial_period_days: number | null;
  /** Configures how the quantity per period should be determined. Can be either `metered` or `licensed`. `licensed` automatically bills the `quantity` set when adding it to a subscription. `metered` aggregates the total usage based on usage records. Defaults to `licensed`. */
  usage_type: StripePlanUsageType;
}

export enum StripePlanAggregateUsage {
  LastDuringPeriod = 'last_during_period',
  LastEver = 'last_ever',
  Max = 'max',
  Sum = 'sum',
}

export enum StripePlanBillingScheme {
  PerUnit = 'per_unit',
  Tiered = 'tiered',
}

export enum StripePlanInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

/**
 * Products describe the specific goods or services you offer to your customers. For example, you might offer a Standard and Premium version of your goods or service; each version would be a separate Product. They can be used in conjunction with [Prices](https://stripe.com/docs/api#prices) to configure pricing in Payment Links, Checkout, and Subscriptions.
 *
 * Related guides: [Set up a subscription](https://stripe.com/docs/billing/subscriptions/set-up-subscription), [share a Payment Link](https://stripe.com/docs/payment-links), [accept payments with Checkout](https://stripe.com/docs/payments/accept-a-payment#create-product-prices-upfront), and more about [Products and Prices](https://stripe.com/docs/products-prices/overview)
 */
export interface StripeProduct {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'product';
  /** Whether the product is currently available for purchase. */
  active: boolean;
  /** A list of up to 5 attributes that each SKU can provide values for (e.g., `["color", "size"]`). */
  attributes: string[] | null;
  /** A short one-line description of the product, meant to be displayable to the customer. Only applicable to products of `type=good`. */
  caption?: string | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** An array of connect application identifiers that cannot purchase this product. Only applicable to products of `type=good`. */
  deactivate_on?: string[];
  /** The ID of the [Price](https://stripe.com/docs/api/prices) object that is the default price for this product. */
  default_price?: string | StripePrice | null;
  deleted?: null;
  /** The product's description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes. */
  description: string | null;
  /** A list of up to 8 URLs of images for this product, meant to be displayable to the customer. */
  images: string[];
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** The product's name, meant to be displayable to the customer. */
  name: string;
  /** The dimensions of this product for shipping purposes. */
  package_dimensions: StripeProductPackageDimensions | null;
  /** Whether this product is shipped (i.e., physical goods). */
  shippable: boolean | null;
  /** Extra information about a product which will appear on your customer's credit card statement. In the case that multiple products are billed at once, the first statement descriptor will be used. */
  statement_descriptor?: string | null;
  /** A [tax code](https://stripe.com/docs/tax/tax-categories) ID. */
  tax_code: string | StripeTaxCode | null;
  /** The type of the product. The product is either of type `good`, which is eligible for use with Orders and SKUs, or `service`, which is eligible for use with Subscriptions and Plans. */
  type: StripeProductType;
  /** A label that represents units of this product. When set, this will be included in customers' receipts, invoices, Checkout, and the customer portal. */
  unit_label?: string | null;
  /** Time at which the object was last updated. Measured in seconds since the Unix epoch. */
  updated: number;
  /** A URL of a publicly-accessible webpage for this product. */
  url: string | null;
}

/**
 * Prices define the unit cost, currency, and (optional) billing cycle for both recurring and one-time purchases of products. [Products](https://stripe.com/docs/api#products) help you track inventory or provisioning, and prices help you track payment terms. Different physical goods or levels of service should be represented by products, and pricing options should be represented by prices. This approach lets you change prices without having to change your provisioning scheme.
 *
 * For example, you might have a single "gold" product that has prices for $10/month, $100/year, and €9 once.
 *
 * Related guides: [Set up a subscription](https://stripe.com/docs/billing/subscriptions/set-up-subscription), [create an invoice](https://stripe.com/docs/billing/invoices/create), and more about [products and prices](https://stripe.com/docs/products-prices/overview).
 */
export interface StripePrice {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'price';
  /** Whether the price can be used for new purchases. */
  active: boolean;
  /** Describes how to compute the price per period. Either `per_unit` or `tiered`. `per_unit` indicates that the fixed amount (specified in `unit_amount` or `unit_amount_decimal`) will be charged per unit in `quantity` (for prices with `usage_type=licensed`), or per unit of total usage (for prices with `usage_type=metered`). `tiered` indicates that the unit pricing will be computed using a tiering strategy as defined using the `tiers` and `tiers_mode` attributes. */
  billing_scheme: StripePriceBillingScheme;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** Prices defined in each available currency option. Each key must be a three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html) and a [supported currency](https://stripe.com/docs/currencies). */
  currency_options?: Record<string, StripePriceCurrencyOptions>;
  /** When set, provides configuration for the amount to be adjusted by the customer during Checkout Sessions and Payment Links. */
  custom_unit_amount: StripePriceCustomUnitAmount | null;
  deleted?: null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** A lookup key used to retrieve prices dynamically from a static string. This may be up to 200 characters. */
  lookup_key: string | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** A brief description of the price, hidden from customers. */
  nickname: string | null;
  /** The ID of the product this price is associated with. */
  product: string | StripeProduct | StripeDeletedProduct;
  /** The recurring components of a price such as `interval` and `usage_type`. */
  recurring: StripePriceRecurring | null;
  /** Only required if a [default tax behavior](https://stripe.com/docs/tax/products-prices-tax-categories-tax-behavior#setting-a-default-tax-behavior-(recommended)) was not provided in the Stripe Tax settings. Specifies whether the price is considered inclusive of taxes or exclusive of taxes. One of `inclusive`, `exclusive`, or `unspecified`. Once specified as either `inclusive` or `exclusive`, it cannot be changed. */
  tax_behavior: StripePriceTaxBehavior | null;
  /** Each element represents a pricing tier. This parameter requires `billing_scheme` to be set to `tiered`. See also the documentation for `billing_scheme`. */
  tiers?: StripePriceTier[];
  /** Defines if the tiering price should be `graduated` or `volume` based. In `volume`-based tiering, the maximum quantity within a period determines the per unit price. In `graduated` tiering, pricing can change as the quantity grows. */
  tiers_mode: StripePriceTiersMode | null;
  /** Apply a transformation to the reported usage or set quantity before computing the amount billed. Cannot be combined with `tiers`. */
  transform_quantity: StripePriceTransformQuantity | null;
  /** One of `one_time` or `recurring` depending on whether the price is for a one-time purchase or a recurring (subscription) purchase. */
  type: StripePriceType;
  /** The unit amount in %s to be charged, represented as a whole integer if possible. Only set if `billing_scheme=per_unit`. */
  unit_amount: number | null;
  /** The unit amount in %s to be charged, represented as a decimal string with at most 12 decimal places. Only set if `billing_scheme=per_unit`. */
  unit_amount_decimal: string | null;
}

export enum StripePriceBillingScheme {
  PerUnit = 'per_unit',
  Tiered = 'tiered',
}

export interface StripePriceCurrencyOptions {
  /** When set, provides configuration for the amount to be adjusted by the customer during Checkout Sessions and Payment Links. */
  custom_unit_amount: StripePriceCurrencyOptionsCustomUnitAmount | null;
  /** Only required if a [default tax behavior](https://stripe.com/docs/tax/products-prices-tax-categories-tax-behavior#setting-a-default-tax-behavior-(recommended)) was not provided in the Stripe Tax settings. Specifies whether the price is considered inclusive of taxes or exclusive of taxes. One of `inclusive`, `exclusive`, or `unspecified`. Once specified as either `inclusive` or `exclusive`, it cannot be changed. */
  tax_behavior: StripePriceCurrencyOptionsTaxBehavior | null;
  /** Each element represents a pricing tier. This parameter requires `billing_scheme` to be set to `tiered`. See also the documentation for `billing_scheme`. */
  tiers?: StripePriceCurrencyOptionsTier[];
  /** The unit amount in %s to be charged, represented as a whole integer if possible. Only set if `billing_scheme=per_unit`. */
  unit_amount: number | null;
  /** The unit amount in %s to be charged, represented as a decimal string with at most 12 decimal places. Only set if `billing_scheme=per_unit`. */
  unit_amount_decimal: string | null;
}

export interface StripePriceCurrencyOptionsCustomUnitAmount {
  /** The maximum unit amount the customer can specify for this item. */
  maximum: number | null;
  /** The minimum unit amount the customer can specify for this item. Must be at least the minimum charge amount. */
  minimum: number | null;
  /** The starting unit amount which can be updated by the customer. */
  preset: number | null;
}

export enum StripePriceCurrencyOptionsTaxBehavior {
  Exclusive = 'exclusive',
  Inclusive = 'inclusive',
  Unspecified = 'unspecified',
}

export interface StripePriceCurrencyOptionsTier {
  /** Price for the entire tier. */
  flat_amount: number | null;
  /** Same as `flat_amount`, but contains a decimal value with at most 12 decimal places. */
  flat_amount_decimal: string | null;
  /** Per unit price for units relevant to the tier. */
  unit_amount: number | null;
  /** Same as `unit_amount`, but contains a decimal value with at most 12 decimal places. */
  unit_amount_decimal: string | null;
  /** Up to and including to this quantity will be contained in the tier. */
  up_to: number | null;
}

export interface StripePriceCustomUnitAmount {
  /** The maximum unit amount the customer can specify for this item. */
  maximum: number | null;
  /** The minimum unit amount the customer can specify for this item. Must be at least the minimum charge amount. */
  minimum: number | null;
  /** The starting unit amount which can be updated by the customer. */
  preset: number | null;
}

/** The DeletedProduct object. */
export interface StripeDeletedProduct {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'product';
  /** Always true for a deleted object */
  deleted: true;
}

export interface StripePriceRecurring {
  /** Specifies a usage aggregation strategy for prices of `usage_type=metered`. Allowed values are `sum` for summing up all usage during a period, `last_during_period` for using the last usage record reported within a period, `last_ever` for using the last usage record ever (across period bounds) or `max` which uses the usage record with the maximum reported usage during a period. Defaults to `sum`. */
  aggregate_usage: StripePriceRecurringAggregateUsage | null;
  /** The frequency at which a subscription is billed. One of `day`, `week`, `month` or `year`. */
  interval: StripePriceRecurringInterval;
  /** The number of intervals (specified in the `interval` attribute) between subscription billings. For example, `interval=month` and `interval_count=3` bills every 3 months. */
  interval_count: number;
  /** Default number of trial days when subscribing a customer to this price using [`trial_from_plan=true`](https://stripe.com/docs/api#create_subscription-trial_from_plan). */
  trial_period_days: number | null;
  /** Configures how the quantity per period should be determined. Can be either `metered` or `licensed`. `licensed` automatically bills the `quantity` set when adding it to a subscription. `metered` aggregates the total usage based on usage records. Defaults to `licensed`. */
  usage_type: StripePriceRecurringUsageType;
}

export enum StripePriceRecurringAggregateUsage {
  LastDuringPeriod = 'last_during_period',
  LastEver = 'last_ever',
  Max = 'max',
  Sum = 'sum',
}

export enum StripePriceRecurringInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export enum StripePriceRecurringUsageType {
  Licensed = 'licensed',
  Metered = 'metered',
}

export enum StripePriceTaxBehavior {
  Exclusive = 'exclusive',
  Inclusive = 'inclusive',
  Unspecified = 'unspecified',
}

export interface StripePriceTier {
  /** Price for the entire tier. */
  flat_amount: number | null;
  /** Same as `flat_amount`, but contains a decimal value with at most 12 decimal places. */
  flat_amount_decimal: string | null;
  /** Per unit price for units relevant to the tier. */
  unit_amount: number | null;
  /** Same as `unit_amount`, but contains a decimal value with at most 12 decimal places. */
  unit_amount_decimal: string | null;
  /** Up to and including to this quantity will be contained in the tier. */
  up_to: number | null;
}

export enum StripePriceTiersMode {
  Graduated = 'graduated',
  Volume = 'volume',
}

export interface StripePriceTransformQuantity {
  /** Divide usage by this number. */
  divide_by: number;
  /** After division, either round the result `up` or `down`. */
  round: StripePriceTransformQuantityRound;
}

export enum StripePriceTransformQuantityRound {
  Down = 'down',
  Up = 'up',
}

export enum StripePriceType {
  OneTime = 'one_time',
  Recurring = 'recurring',
}

export interface StripeProductPackageDimensions {
  /** Height, in inches. */
  height: number;
  /** Length, in inches. */
  length: number;
  /** Weight, in ounces. */
  weight: number;
  /** Width, in inches. */
  width: number;
}

/** [Tax codes](https://stripe.com/docs/tax/tax-categories) classify goods and services for tax purposes. */
export interface StripeTaxCode {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'tax_code';
  /** A detailed description of which types of products the tax code represents. */
  description: string;
  /** A short name for the tax code. */
  name: string;
}

export enum StripeProductType {
  Good = 'good',
  Service = 'service',
}

export interface StripePlanTier {
  /** Price for the entire tier. */
  flat_amount: number | null;
  /** Same as `flat_amount`, but contains a decimal value with at most 12 decimal places. */
  flat_amount_decimal: string | null;
  /** Per unit price for units relevant to the tier. */
  unit_amount: number | null;
  /** Same as `unit_amount`, but contains a decimal value with at most 12 decimal places. */
  unit_amount_decimal: string | null;
  /** Up to and including to this quantity will be contained in the tier. */
  up_to: number | null;
}

export enum StripePlanTiersMode {
  Graduated = 'graduated',
  Volume = 'volume',
}

export interface StripePlanTransformUsage {
  /** Divide usage by this number. */
  divide_by: number;
  /** After division, either round the result `up` or `down`. */
  round: StripePlanTransformUsageRound;
}

export enum StripePlanTransformUsageRound {
  Down = 'down',
  Up = 'up',
}

export enum StripePlanUsageType {
  Licensed = 'licensed',
  Metered = 'metered',
}

/** A test clock enables deterministic control over objects in testmode. With a test clock, you can create objects at a frozen time in the past or future, and advance to a specific future time to observe webhooks and state changes. After the clock advances, you can either validate the current state of your scenario (and test your assumptions), change the current state of your scenario (and test more complex scenarios), or keep advancing forward in time. */
export interface StripeTestHelpersTestClock {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'test_helpers.test_clock';
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  deleted?: null;
  /** Time at which this clock is scheduled to auto delete. */
  deletes_after: number;
  /** Time at which all objects belonging to this clock are frozen. */
  frozen_time: number;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** The custom name supplied at creation. */
  name: string | null;
  /** The status of the Test Clock. */
  status: StripeTestHelpersTestClockStatus;
}

export enum StripeTestHelpersTestClockStatus {
  Advancing = 'advancing',
  InternalFailure = 'internal_failure',
  Ready = 'ready',
}

export interface StripeInvoiceLineItemPeriod {
  /** The end of the period, which must be greater than or equal to the start. This value is inclusive. */
  end: number;
  /** The start of the period. This value is inclusive. */
  start: number;
}

export interface StripeInvoiceLineItemProrationDetails {
  /** For a credit proration `line_item`, the original debit line_items to which the credit proration applies. */
  credited_items: StripeInvoiceLineItemProrationDetailsCreditedItems | null;
}

export interface StripeInvoiceLineItemProrationDetailsCreditedItems {
  /** Invoice containing the credited invoice line items */
  invoice: string;
  /** Credited invoice line items */
  invoice_line_items: string[];
}

/** Subscription items allow you to create customer subscriptions with more than one plan, making it easy to represent complex billing relationships. */
export interface StripeSubscriptionItem {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'subscription_item';
  /** Define thresholds at which an invoice will be sent, and the related subscription advanced to a new billing period */
  billing_thresholds: StripeSubscriptionItemBillingThresholds | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  deleted?: null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /**
   * You can now model subscriptions more flexibly using the [Prices API](https://stripe.com/docs/api#prices). It replaces the Plans API and is backwards compatible to simplify your migration.
   *
   * Plans define the base price, currency, and billing cycle for recurring purchases of products. [Products](https://stripe.com/docs/api#products) help you track inventory or provisioning, and plans help you track pricing. Different physical goods or levels of service should be represented by products, and pricing options should be represented by plans. This approach lets you change prices without having to change your provisioning scheme.
   *
   * For example, you might have a single "gold" product that has plans for $10/month, $100/year, €9/month, and €90/year.
   *
   * Related guides: [Set up a subscription](https://stripe.com/docs/billing/subscriptions/set-up-subscription) and more about [products and prices](https://stripe.com/docs/products-prices/overview).
   */
  plan: StripePlan;
  /**
   * Prices define the unit cost, currency, and (optional) billing cycle for both recurring and one-time purchases of products. [Products](https://stripe.com/docs/api#products) help you track inventory or provisioning, and prices help you track payment terms. Different physical goods or levels of service should be represented by products, and pricing options should be represented by prices. This approach lets you change prices without having to change your provisioning scheme.
   *
   * For example, you might have a single "gold" product that has prices for $10/month, $100/year, and €9 once.
   *
   * Related guides: [Set up a subscription](https://stripe.com/docs/billing/subscriptions/set-up-subscription), [create an invoice](https://stripe.com/docs/billing/invoices/create), and more about [products and prices](https://stripe.com/docs/products-prices/overview).
   */
  price: StripePrice;
  /** The [quantity](https://stripe.com/docs/subscriptions/quantities) of the plan to which the customer should be subscribed. */
  quantity?: number;
  /** The `subscription` this `subscription_item` belongs to. */
  subscription: string;
  /** The tax rates which apply to this `subscription_item`. When set, the `default_tax_rates` on the subscription do not apply to this `subscription_item`. */
  tax_rates: StripeTaxRate[] | null;
}

export interface StripeSubscriptionItemBillingThresholds {
  /** Usage threshold that triggers the subscription to create an invoice */
  usage_gte: number | null;
}

export interface StripeInvoiceLineItemTaxAmount {
  /** The amount, in %s, of the tax. */
  amount: number;
  /** Whether this tax amount is inclusive or exclusive. */
  inclusive: boolean;
  /** The tax rate that was applied to get this tax amount. */
  tax_rate: string | StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeInvoiceLineItemTaxAmountTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeInvoiceLineItemTaxAmountTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  ZeroRated = 'zero_rated',
}

export enum StripeInvoiceLineItemType {
  Invoiceitem = 'invoiceitem',
  Subscription = 'subscription',
}

export interface StripeInvoicePaymentSettings {
  /** ID of the mandate to be used for this invoice. It must correspond to the payment method used to pay the invoice, including the invoice's default_payment_method or default_source, if set. */
  default_mandate: string | null;
  /** Payment-method-specific configuration to provide to the invoice's PaymentIntent. */
  payment_method_options: StripeInvoicePaymentSettingsPaymentMethodOptions | null;
  /** The list of payment method types (e.g. card) to provide to the invoice's PaymentIntent. If not set, Stripe attempts to automatically determine the types to use by looking at the invoice's default payment method, the subscription's default payment method, the customer's default payment method, and your [invoice template settings](https://dashboard.stripe.com/settings/billing/invoice). */
  payment_method_types: StripeInvoicePaymentSettingsPaymentMethodType[] | null;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptions {
  /** If paying by `acss_debit`, this sub-hash contains details about the Canadian pre-authorized debit payment method options to pass to the invoice's PaymentIntent. */
  acss_debit: StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebit | null;
  /** If paying by `bancontact`, this sub-hash contains details about the Bancontact payment method options to pass to the invoice's PaymentIntent. */
  bancontact: StripeInvoicePaymentSettingsPaymentMethodOptionsBancontact | null;
  /** If paying by `card`, this sub-hash contains details about the Card payment method options to pass to the invoice's PaymentIntent. */
  card: StripeInvoicePaymentSettingsPaymentMethodOptionsCard | null;
  /** If paying by `customer_balance`, this sub-hash contains details about the Bank transfer payment method options to pass to the invoice's PaymentIntent. */
  customer_balance: StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalance | null;
  /** If paying by `konbini`, this sub-hash contains details about the Konbini payment method options to pass to the invoice's PaymentIntent. */
  konbini: StripeInvoicePaymentSettingsPaymentMethodOptionsKonbini | null;
  /** If paying by `us_bank_account`, this sub-hash contains details about the ACH direct debit payment method options to pass to the invoice's PaymentIntent. */
  us_bank_account: StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccount | null;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebit {
  mandate_options?: StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebitMandateOptions;
  /** Bank account verification method. */
  verification_method?: StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebitVerificationMethod;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebitMandateOptions {
  /** Transaction type of the mandate. */
  transaction_type: StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebitMandateOptionsTransactionType | null;
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebitMandateOptionsTransactionType {
  Business = 'business',
  Personal = 'personal',
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsAcssDebitVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsBancontact {
  /** Preferred language of the Bancontact authorization page that the customer is redirected to. */
  preferred_language: StripeInvoicePaymentSettingsPaymentMethodOptionsBancontactPreferredLanguage;
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsBancontactPreferredLanguage {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsCard {
  installments?: StripeInvoicePaymentSettingsPaymentMethodOptionsCardInstallments;
  /** We strongly recommend that you rely on our SCA Engine to automatically prompt your customers for authentication based on risk level and [other requirements](https://stripe.com/docs/strong-customer-authentication). However, if you wish to request 3D Secure based on logic from your own fraud engine, provide this option. Read our guide on [manually requesting 3D Secure](https://stripe.com/docs/payments/3d-secure#manual-three-ds) for more information on how this configuration interacts with Radar and our SCA Engine. */
  request_three_d_secure: StripeInvoicePaymentSettingsPaymentMethodOptionsCardRequestThreeDSecure | null;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsCardInstallments {
  /** Whether Installments are enabled for this Invoice. */
  enabled: boolean | null;
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsCardRequestThreeDSecure {
  Any = 'any',
  Automatic = 'automatic',
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalance {
  bank_transfer?: StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransfer;
  /** The funding method type to be used when there are not enough funds in the customer balance. Permitted values include: `bank_transfer`. */
  funding_type: StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceFundingTypeEnum;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransfer {
  eu_bank_transfer?: StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer;
  /** The bank transfer type that can be used for funding. Permitted values include: `eu_bank_transfer`, `gb_bank_transfer`, `jp_bank_transfer`, `mx_bank_transfer`, or `us_bank_transfer`. */
  type: string | null;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer {
  /** The desired country code of the bank account information. Permitted values include: `BE`, `DE`, `ES`, `FR`, `IE`, or `NL`. */
  country: StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransferCountry;
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransferCountry {
  BE = 'BE',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  IE = 'IE',
  NL = 'NL',
}

export type StripeInvoicePaymentSettingsPaymentMethodOptionsKonbini = object;

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccount {
  financial_connections?: StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnections;
  /** Bank account verification method. */
  verification_method?: StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccountVerificationMethod;
}

export interface StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnections {
  /** The list of permissions to request. The `payment_method` permission must be included. */
  permissions?: StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission[];
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission {
  Balances = 'balances',
  PaymentMethod = 'payment_method',
  Transactions = 'transactions',
}

export enum StripeInvoicePaymentSettingsPaymentMethodOptionsUsBankAccountVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export enum StripeInvoicePaymentSettingsPaymentMethodType {
  AchCreditTransfer = 'ach_credit_transfer',
  AchDebit = 'ach_debit',
  AcssDebit = 'acss_debit',
  AuBecsDebit = 'au_becs_debit',
  BacsDebit = 'bacs_debit',
  Bancontact = 'bancontact',
  Boleto = 'boleto',
  Card = 'card',
  Cashapp = 'cashapp',
  CustomerBalance = 'customer_balance',
  Fpx = 'fpx',
  Giropay = 'giropay',
  Grabpay = 'grabpay',
  Ideal = 'ideal',
  Konbini = 'konbini',
  Link = 'link',
  Paynow = 'paynow',
  Paypal = 'paypal',
  Promptpay = 'promptpay',
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
  Sofort = 'sofort',
  UsBankAccount = 'us_bank_account',
  WechatPay = 'wechat_pay',
}

/** A Quote is a way to model prices that you'd like to provide to a customer. Once accepted, it will automatically create an invoice, subscription or subscription schedule. */
export interface StripeQuote {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'quote';
  /** Total before any discounts or taxes are applied. */
  amount_subtotal: number;
  /** Total after discounts and taxes are applied. */
  amount_total: number;
  /** ID of the Connect Application that created the quote. */
  application: string | StripeApplication | StripeDeletedApplication | null;
  /** The amount of the application fee (if any) that will be requested to be applied to the payment and transferred to the application owner's Stripe account. Only applicable if there are no line items with recurring prices on the quote. */
  application_fee_amount: number | null;
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the application owner's Stripe account. Only applicable if there are line items with recurring prices on the quote. */
  application_fee_percent: number | null;
  automatic_tax: StripeQuoteAutomaticTax;
  /** Either `charge_automatically`, or `send_invoice`. When charging automatically, Stripe will attempt to pay invoices at the end of the subscription cycle or on finalization using the default payment method attached to the subscription or customer. When sending an invoice, Stripe will email your customer an invoice with payment instructions and mark the subscription as `active`. Defaults to `charge_automatically`. */
  collection_method: StripeQuoteCollectionMethod;
  computed: StripeQuoteComputed;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string | null;
  /** The customer which this quote belongs to. A customer is required before finalizing the quote. Once specified, it cannot be changed. */
  customer: string | StripeCustomer | StripeDeletedCustomer | null;
  /** The tax rates applied to this quote. */
  default_tax_rates?: (string | StripeTaxRate)[];
  /** A description that will be displayed on the quote PDF. */
  description: string | null;
  /** The discounts applied to this quote. */
  discounts: (string | StripeDiscount)[];
  /** The date on which the quote will be canceled if in `open` or `draft` status. Measured in seconds since the Unix epoch. */
  expires_at: number;
  /** A footer that will be displayed on the quote PDF. */
  footer: string | null;
  /** Details of the quote that was cloned. See the [cloning documentation](https://stripe.com/docs/quotes/clone) for more details. */
  from_quote: StripeQuoteFromQuote | null;
  /** A header that will be displayed on the quote PDF. */
  header: string | null;
  /** The invoice that was created from this quote. */
  invoice: string | StripeInvoice | StripeDeletedInvoice | null;
  /** All invoices will be billed using the specified settings. */
  invoice_settings: StripeQuoteInvoiceSettings | null;
  /** A list of items the customer is being quoted for. */
  line_items?: StripeApiListStripeLineItem;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** A unique number that identifies this particular quote. This number is assigned once the quote is [finalized](https://stripe.com/docs/quotes/overview#finalize). */
  number: string | null;
  /** The account on behalf of which to charge. See the [Connect documentation](https://support.stripe.com/questions/sending-invoices-on-behalf-of-connected-accounts) for details. */
  on_behalf_of: string | StripeAccount | null;
  /** The status of the quote. */
  status: StripeQuoteStatus;
  status_transitions: StripeQuoteStatusTransitions;
  /** The subscription that was created or updated from this quote. */
  subscription: string | StripeSubscription | null;
  subscription_data: StripeQuoteSubscriptionData;
  /** The subscription schedule that was created or updated from this quote. */
  subscription_schedule: string | StripeSubscriptionSchedule | null;
  /** ID of the test clock this quote belongs to. */
  test_clock: string | StripeTestHelpersTestClock | null;
  total_details: StripeQuoteTotalDetails;
  /** The account (if any) the payments will be attributed to for tax reporting, and where funds from each payment will be transferred to for each of the invoices. */
  transfer_data: StripeQuoteTransferData | null;
}

export interface StripeQuoteAutomaticTax {
  /** Automatically calculate taxes */
  enabled: boolean;
  /** The status of the most recent automated tax calculation for this quote. */
  status: StripeQuoteAutomaticTaxStatus | null;
}

export enum StripeQuoteAutomaticTaxStatus {
  Complete = 'complete',
  Failed = 'failed',
  RequiresLocationInputs = 'requires_location_inputs',
}

export enum StripeQuoteCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice',
}

export interface StripeQuoteComputed {
  /** The definitive totals and line items the customer will be charged on a recurring basis. Takes into account the line items with recurring prices and discounts with `duration=forever` coupons only. Defaults to `null` if no inputted line items with recurring prices. */
  recurring: StripeQuoteComputedRecurring | null;
  upfront: StripeQuoteComputedUpfront;
}

export interface StripeQuoteComputedRecurring {
  /** Total before any discounts or taxes are applied. */
  amount_subtotal: number;
  /** Total after discounts and taxes are applied. */
  amount_total: number;
  /** The frequency at which a subscription is billed. One of `day`, `week`, `month` or `year`. */
  interval: StripeQuoteComputedRecurringInterval;
  /** The number of intervals (specified in the `interval` attribute) between subscription billings. For example, `interval=month` and `interval_count=3` bills every 3 months. */
  interval_count: number;
  total_details: StripeQuoteComputedRecurringTotalDetails;
}

export enum StripeQuoteComputedRecurringInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export interface StripeQuoteComputedRecurringTotalDetails {
  /** This is the sum of all the discounts. */
  amount_discount: number;
  /** This is the sum of all the shipping amounts. */
  amount_shipping: number | null;
  /** This is the sum of all the tax amounts. */
  amount_tax: number;
  breakdown?: StripeQuoteComputedRecurringTotalDetailsBreakdown;
}

export interface StripeQuoteComputedRecurringTotalDetailsBreakdown {
  /** The aggregated discounts. */
  discounts: StripeQuoteComputedRecurringTotalDetailsBreakdownDiscount[];
  /** The aggregated tax amounts by rate. */
  taxes: StripeQuoteComputedRecurringTotalDetailsBreakdownTax[];
}

export interface StripeQuoteComputedRecurringTotalDetailsBreakdownDiscount {
  /** The amount discounted. */
  amount: number;
  /**
   * A discount represents the actual application of a [coupon](https://stripe.com/docs/api#coupons) or [promotion code](https://stripe.com/docs/api#promotion_codes). It contains information about when the discount began, when it will end, and what it is applied to.
   *
   * Related guide: [Applying discounts to subscriptions](https://stripe.com/docs/billing/subscriptions/discounts)
   */
  discount: StripeDiscount;
}

export interface StripeQuoteComputedRecurringTotalDetailsBreakdownTax {
  /** Amount of tax applied for this rate. */
  amount: number;
  /**
   * Tax rates can be applied to [invoices](https://stripe.com/docs/billing/invoices/tax-rates), [subscriptions](https://stripe.com/docs/billing/subscriptions/taxes) and [Checkout Sessions](https://stripe.com/docs/payments/checkout/set-up-a-subscription#tax-rates) to collect tax.
   *
   * Related guide: [Tax rates](https://stripe.com/docs/billing/taxes/tax-rates)
   */
  rate: StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeQuoteComputedRecurringTotalDetailsBreakdownTaxTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeQuoteComputedRecurringTotalDetailsBreakdownTaxTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  ExcludedTerritory = 'excluded_territory',
  JurisdictionUnsupported = 'jurisdiction_unsupported',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  VatExempt = 'vat_exempt',
  ZeroRated = 'zero_rated',
}

export interface StripeQuoteComputedUpfront {
  /** Total before any discounts or taxes are applied. */
  amount_subtotal: number;
  /** Total after discounts and taxes are applied. */
  amount_total: number;
  /** The line items that will appear on the next invoice after this quote is accepted. This does not include pending invoice items that exist on the customer but may still be included in the next invoice. */
  line_items?: StripeApiListStripeLineItem;
  total_details: StripeQuoteComputedUpfrontTotalDetails;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeLineItem {
  object: 'list';
  data: StripeLineItem[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/** A line item. */
export interface StripeLineItem {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'item';
  /** Total discount amount applied. If no discounts were applied, defaults to 0. */
  amount_discount: number;
  /** Total before any discounts or taxes are applied. */
  amount_subtotal: number;
  /** Total tax amount applied. If no tax was applied, defaults to 0. */
  amount_tax: number;
  /** Total after discounts and taxes. */
  amount_total: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. Defaults to product name. */
  description: string;
  /** The discounts applied to the line item. */
  discounts?: StripeLineItemDiscount[];
  /** The price used to generate the line item. */
  price: StripePrice | null;
  /** The quantity of products being purchased. */
  quantity: number | null;
  /** The taxes applied to the line item. */
  taxes?: StripeLineItemTax[];
}

export interface StripeLineItemDiscount {
  /** The amount discounted. */
  amount: number;
  /**
   * A discount represents the actual application of a [coupon](https://stripe.com/docs/api#coupons) or [promotion code](https://stripe.com/docs/api#promotion_codes). It contains information about when the discount began, when it will end, and what it is applied to.
   *
   * Related guide: [Applying discounts to subscriptions](https://stripe.com/docs/billing/subscriptions/discounts)
   */
  discount: StripeDiscount;
}

export interface StripeLineItemTax {
  /** Amount of tax applied for this rate. */
  amount: number;
  /**
   * Tax rates can be applied to [invoices](https://stripe.com/docs/billing/invoices/tax-rates), [subscriptions](https://stripe.com/docs/billing/subscriptions/taxes) and [Checkout Sessions](https://stripe.com/docs/payments/checkout/set-up-a-subscription#tax-rates) to collect tax.
   *
   * Related guide: [Tax rates](https://stripe.com/docs/billing/taxes/tax-rates)
   */
  rate: StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeLineItemTaxTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeLineItemTaxTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  ExcludedTerritory = 'excluded_territory',
  JurisdictionUnsupported = 'jurisdiction_unsupported',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  VatExempt = 'vat_exempt',
  ZeroRated = 'zero_rated',
}

export interface StripeQuoteComputedUpfrontTotalDetails {
  /** This is the sum of all the discounts. */
  amount_discount: number;
  /** This is the sum of all the shipping amounts. */
  amount_shipping: number | null;
  /** This is the sum of all the tax amounts. */
  amount_tax: number;
  breakdown?: StripeQuoteComputedUpfrontTotalDetailsBreakdown;
}

export interface StripeQuoteComputedUpfrontTotalDetailsBreakdown {
  /** The aggregated discounts. */
  discounts: StripeQuoteComputedUpfrontTotalDetailsBreakdownDiscount[];
  /** The aggregated tax amounts by rate. */
  taxes: StripeQuoteComputedUpfrontTotalDetailsBreakdownTax[];
}

export interface StripeQuoteComputedUpfrontTotalDetailsBreakdownDiscount {
  /** The amount discounted. */
  amount: number;
  /**
   * A discount represents the actual application of a [coupon](https://stripe.com/docs/api#coupons) or [promotion code](https://stripe.com/docs/api#promotion_codes). It contains information about when the discount began, when it will end, and what it is applied to.
   *
   * Related guide: [Applying discounts to subscriptions](https://stripe.com/docs/billing/subscriptions/discounts)
   */
  discount: StripeDiscount;
}

export interface StripeQuoteComputedUpfrontTotalDetailsBreakdownTax {
  /** Amount of tax applied for this rate. */
  amount: number;
  /**
   * Tax rates can be applied to [invoices](https://stripe.com/docs/billing/invoices/tax-rates), [subscriptions](https://stripe.com/docs/billing/subscriptions/taxes) and [Checkout Sessions](https://stripe.com/docs/payments/checkout/set-up-a-subscription#tax-rates) to collect tax.
   *
   * Related guide: [Tax rates](https://stripe.com/docs/billing/taxes/tax-rates)
   */
  rate: StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeQuoteComputedUpfrontTotalDetailsBreakdownTaxTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeQuoteComputedUpfrontTotalDetailsBreakdownTaxTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  ExcludedTerritory = 'excluded_territory',
  JurisdictionUnsupported = 'jurisdiction_unsupported',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  VatExempt = 'vat_exempt',
  ZeroRated = 'zero_rated',
}

export interface StripeQuoteFromQuote {
  /** Whether this quote is a revision of a different quote. */
  is_revision: boolean;
  /** The quote that was cloned. */
  quote: string | StripeQuote;
}

/** The DeletedInvoice object. */
export interface StripeDeletedInvoice {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'invoice';
  /** Always true for a deleted object */
  deleted: true;
}

export interface StripeQuoteInvoiceSettings {
  /** Number of days within which a customer must pay invoices generated by this quote. This value will be `null` for quotes where `collection_method=charge_automatically`. */
  days_until_due: number | null;
}

export enum StripeQuoteStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Draft = 'draft',
  Open = 'open',
}

export interface StripeQuoteStatusTransitions {
  /** The time that the quote was accepted. Measured in seconds since Unix epoch. */
  accepted_at: number | null;
  /** The time that the quote was canceled. Measured in seconds since Unix epoch. */
  canceled_at: number | null;
  /** The time that the quote was finalized. Measured in seconds since Unix epoch. */
  finalized_at: number | null;
}

export interface StripeQuoteSubscriptionData {
  /** The subscription's description, meant to be displayable to the customer. Use this field to optionally store an explanation of the subscription. */
  description: string | null;
  /** When creating a new subscription, the date of which the subscription schedule will start after the quote is accepted. This date is ignored if it is in the past when the quote is accepted. Measured in seconds since the Unix epoch. */
  effective_date: number | null;
  /** Integer representing the number of trial period days before the customer is charged for the first time. */
  trial_period_days: number | null;
}

/**
 * A subscription schedule allows you to create and manage the lifecycle of a subscription by predefining expected changes.
 *
 * Related guide: [Subscription schedules](https://stripe.com/docs/billing/subscriptions/subscription-schedules)
 */
export interface StripeSubscriptionSchedule {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'subscription_schedule';
  /** ID of the Connect Application that created the schedule. */
  application: string | StripeApplication | StripeDeletedApplication | null;
  /** Time at which the subscription schedule was canceled. Measured in seconds since the Unix epoch. */
  canceled_at: number | null;
  /** Time at which the subscription schedule was completed. Measured in seconds since the Unix epoch. */
  completed_at: number | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Object representing the start and end dates for the current phase of the subscription schedule, if it is `active`. */
  current_phase: StripeSubscriptionScheduleCurrentPhase | null;
  /** ID of the customer who owns the subscription schedule. */
  customer: string | StripeCustomer | StripeDeletedCustomer;
  default_settings: StripeSubscriptionScheduleDefaultSettings;
  /** Behavior of the subscription schedule and underlying subscription when it ends. Possible values are `release` or `cancel` with the default being `release`. `release` will end the subscription schedule and keep the underlying subscription running.`cancel` will end the subscription schedule and cancel the underlying subscription. */
  end_behavior: StripeSubscriptionScheduleEndBehavior;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** Configuration for the subscription schedule's phases. */
  phases: StripeSubscriptionSchedulePhase[];
  /** Time at which the subscription schedule was released. Measured in seconds since the Unix epoch. */
  released_at: number | null;
  /** ID of the subscription once managed by the subscription schedule (if it is released). */
  released_subscription: string | null;
  /** The present status of the subscription schedule. Possible values are `not_started`, `active`, `completed`, `released`, and `canceled`. You can read more about the different states in our [behavior guide](https://stripe.com/docs/billing/subscriptions/subscription-schedules). */
  status: StripeSubscriptionScheduleStatus;
  /** ID of the subscription managed by the subscription schedule. */
  subscription: string | StripeSubscription | null;
  /** ID of the test clock this subscription schedule belongs to. */
  test_clock: string | StripeTestHelpersTestClock | null;
}

export interface StripeSubscriptionScheduleCurrentPhase {
  /** The end of this phase of the subscription schedule. */
  end_date: number;
  /** The start of this phase of the subscription schedule. */
  start_date: number;
}

export interface StripeSubscriptionScheduleDefaultSettings {
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the application owner's Stripe account during this phase of the schedule. */
  application_fee_percent: number | null;
  automatic_tax?: StripeSubscriptionScheduleDefaultSettingsAutomaticTax;
  /** Possible values are `phase_start` or `automatic`. If `phase_start` then billing cycle anchor of the subscription is set to the start of the phase when entering the phase. If `automatic` then the billing cycle anchor is automatically modified as needed when entering the phase. For more information, see the billing cycle [documentation](https://stripe.com/docs/billing/subscriptions/billing-cycle). */
  billing_cycle_anchor: StripeSubscriptionScheduleDefaultSettingsBillingCycleAnchor;
  /** Define thresholds at which an invoice will be sent, and the subscription advanced to a new billing period */
  billing_thresholds: StripeSubscriptionScheduleDefaultSettingsBillingThresholds | null;
  /** Either `charge_automatically`, or `send_invoice`. When charging automatically, Stripe will attempt to pay the underlying subscription at the end of each billing cycle using the default source attached to the customer. When sending an invoice, Stripe will email your customer an invoice with payment instructions and mark the subscription as `active`. */
  collection_method: StripeSubscriptionScheduleDefaultSettingsCollectionMethod | null;
  /** ID of the default payment method for the subscription schedule. If not set, invoices will use the default payment method in the customer's invoice settings. */
  default_payment_method: string | StripePaymentMethod | null;
  /** Subscription description, meant to be displayable to the customer. Use this field to optionally store an explanation of the subscription. */
  description: string | null;
  /** The subscription schedule's default invoice settings. */
  invoice_settings: StripeSubscriptionScheduleDefaultSettingsInvoiceSettings | null;
  /** The account (if any) the charge was made on behalf of for charges associated with the schedule's subscription. See the Connect documentation for details. */
  on_behalf_of: string | StripeAccount | null;
  /** The account (if any) the associated subscription's payments will be attributed to for tax reporting, and where funds from each payment will be transferred to for each of the subscription's invoices. */
  transfer_data: StripeSubscriptionScheduleDefaultSettingsTransferData | null;
}

export interface StripeSubscriptionScheduleDefaultSettingsAutomaticTax {
  /** Whether Stripe automatically computes tax on invoices created during this phase. */
  enabled: boolean;
}

export enum StripeSubscriptionScheduleDefaultSettingsBillingCycleAnchor {
  Automatic = 'automatic',
  PhaseStart = 'phase_start',
}

export interface StripeSubscriptionScheduleDefaultSettingsBillingThresholds {
  /** Monetary threshold that triggers the subscription to create an invoice */
  amount_gte: number | null;
  /** Indicates if the `billing_cycle_anchor` should be reset when a threshold is reached. If true, `billing_cycle_anchor` will be updated to the date/time the threshold was last reached; otherwise, the value will remain unchanged. This value may not be `true` if the subscription contains items with plans that have `aggregate_usage=last_ever`. */
  reset_billing_cycle_anchor: boolean | null;
}

export enum StripeSubscriptionScheduleDefaultSettingsCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice',
}

export interface StripeSubscriptionScheduleDefaultSettingsInvoiceSettings {
  /** Number of days within which a customer must pay invoices generated by this subscription schedule. This value will be `null` for subscription schedules where `billing=charge_automatically`. */
  days_until_due: number | null;
}

export interface StripeSubscriptionScheduleDefaultSettingsTransferData {
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the destination account. By default, the entire amount is transferred to the destination. */
  amount_percent: number | null;
  /** The account where funds from the payment will be transferred to upon payment success. */
  destination: string | StripeAccount;
}

export enum StripeSubscriptionScheduleEndBehavior {
  Cancel = 'cancel',
  None = 'none',
  Release = 'release',
  Renew = 'renew',
}

export interface StripeSubscriptionSchedulePhase {
  /** A list of prices and quantities that will generate invoice items appended to the next invoice for this phase. */
  add_invoice_items: StripeSubscriptionSchedulePhaseAddInvoiceItem[];
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the application owner's Stripe account during this phase of the schedule. */
  application_fee_percent: number | null;
  automatic_tax?: StripeSubscriptionSchedulePhaseAutomaticTax;
  /** Possible values are `phase_start` or `automatic`. If `phase_start` then billing cycle anchor of the subscription is set to the start of the phase when entering the phase. If `automatic` then the billing cycle anchor is automatically modified as needed when entering the phase. For more information, see the billing cycle [documentation](https://stripe.com/docs/billing/subscriptions/billing-cycle). */
  billing_cycle_anchor: StripeSubscriptionSchedulePhaseBillingCycleAnchor | null;
  /** Define thresholds at which an invoice will be sent, and the subscription advanced to a new billing period */
  billing_thresholds: StripeSubscriptionSchedulePhaseBillingThresholds | null;
  /** Either `charge_automatically`, or `send_invoice`. When charging automatically, Stripe will attempt to pay the underlying subscription at the end of each billing cycle using the default source attached to the customer. When sending an invoice, Stripe will email your customer an invoice with payment instructions and mark the subscription as `active`. */
  collection_method: StripeSubscriptionSchedulePhaseCollectionMethod | null;
  /** ID of the coupon to use during this phase of the subscription schedule. */
  coupon: string | StripeCoupon | StripeDeletedCoupon | null;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** ID of the default payment method for the subscription schedule. It must belong to the customer associated with the subscription schedule. If not set, invoices will use the default payment method in the customer's invoice settings. */
  default_payment_method: string | StripePaymentMethod | null;
  /** The default tax rates to apply to the subscription during this phase of the subscription schedule. */
  default_tax_rates?: StripeTaxRate[] | null;
  /** Subscription description, meant to be displayable to the customer. Use this field to optionally store an explanation of the subscription. */
  description: string | null;
  /** The end of this phase of the subscription schedule. */
  end_date: number;
  /** The invoice settings applicable during this phase. */
  invoice_settings: StripeSubscriptionSchedulePhaseInvoiceSettings | null;
  /** Subscription items to configure the subscription to during this phase of the subscription schedule. */
  items: StripeSubscriptionSchedulePhaseItem[];
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to a phase. Metadata on a schedule's phase will update the underlying subscription's `metadata` when the phase is entered. Updating the underlying subscription's `metadata` directly will not affect the current phase's `metadata`. */
  metadata: StripeMetadata | null;
  /** The account (if any) the charge was made on behalf of for charges associated with the schedule's subscription. See the Connect documentation for details. */
  on_behalf_of: string | StripeAccount | null;
  /** If the subscription schedule will prorate when transitioning to this phase. Possible values are `create_prorations` and `none`. */
  proration_behavior: StripeSubscriptionSchedulePhaseProrationBehavior;
  /** The start of this phase of the subscription schedule. */
  start_date: number;
  /** The account (if any) the associated subscription's payments will be attributed to for tax reporting, and where funds from each payment will be transferred to for each of the subscription's invoices. */
  transfer_data: StripeSubscriptionSchedulePhaseTransferData | null;
  /** When the trial ends within the phase. */
  trial_end: number | null;
}

export interface StripeSubscriptionSchedulePhaseAddInvoiceItem {
  /** ID of the price used to generate the invoice item. */
  price: string | StripePrice | StripeDeletedPrice;
  /** The quantity of the invoice item. */
  quantity: number | null;
  /** The tax rates which apply to the item. When set, the `default_tax_rates` do not apply to this item. */
  tax_rates?: StripeTaxRate[] | null;
}

/** The DeletedPrice object. */
export interface StripeDeletedPrice {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'price';
  /** Always true for a deleted object */
  deleted: true;
}

export interface StripeSubscriptionSchedulePhaseAutomaticTax {
  /** Whether Stripe automatically computes tax on invoices created during this phase. */
  enabled: boolean;
}

export enum StripeSubscriptionSchedulePhaseBillingCycleAnchor {
  Automatic = 'automatic',
  PhaseStart = 'phase_start',
}

export interface StripeSubscriptionSchedulePhaseBillingThresholds {
  /** Monetary threshold that triggers the subscription to create an invoice */
  amount_gte: number | null;
  /** Indicates if the `billing_cycle_anchor` should be reset when a threshold is reached. If true, `billing_cycle_anchor` will be updated to the date/time the threshold was last reached; otherwise, the value will remain unchanged. This value may not be `true` if the subscription contains items with plans that have `aggregate_usage=last_ever`. */
  reset_billing_cycle_anchor: boolean | null;
}

export enum StripeSubscriptionSchedulePhaseCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice',
}

/** The DeletedCoupon object. */
export interface StripeDeletedCoupon {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'coupon';
  /** Always true for a deleted object */
  deleted: true;
}

export interface StripeSubscriptionSchedulePhaseInvoiceSettings {
  /** Number of days within which a customer must pay invoices generated by this subscription schedule. This value will be `null` for subscription schedules where `billing=charge_automatically`. */
  days_until_due: number | null;
}

export interface StripeSubscriptionSchedulePhaseItem {
  /** Define thresholds at which an invoice will be sent, and the related subscription advanced to a new billing period */
  billing_thresholds: StripeSubscriptionSchedulePhaseItemBillingThresholds | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an item. Metadata on this item will update the underlying subscription item's `metadata` when the phase is entered. */
  metadata: StripeMetadata | null;
  /** ID of the plan to which the customer should be subscribed. */
  plan: string | StripePlan | StripeDeletedPlan;
  /** ID of the price to which the customer should be subscribed. */
  price: string | StripePrice | StripeDeletedPrice;
  /** Quantity of the plan to which the customer should be subscribed. */
  quantity?: number;
  /** The tax rates which apply to this `phase_item`. When set, the `default_tax_rates` on the phase do not apply to this `phase_item`. */
  tax_rates?: StripeTaxRate[] | null;
}

export interface StripeSubscriptionSchedulePhaseItemBillingThresholds {
  /** Usage threshold that triggers the subscription to create an invoice */
  usage_gte: number | null;
}

/** The DeletedPlan object. */
export interface StripeDeletedPlan {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'plan';
  /** Always true for a deleted object */
  deleted: true;
}

export enum StripeSubscriptionSchedulePhaseProrationBehavior {
  AlwaysInvoice = 'always_invoice',
  CreateProrations = 'create_prorations',
  None = 'none',
}

export interface StripeSubscriptionSchedulePhaseTransferData {
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the destination account. By default, the entire amount is transferred to the destination. */
  amount_percent: number | null;
  /** The account where funds from the payment will be transferred to upon payment success. */
  destination: string | StripeAccount;
}

export enum StripeSubscriptionScheduleStatus {
  Active = 'active',
  Canceled = 'canceled',
  Completed = 'completed',
  NotStarted = 'not_started',
  Released = 'released',
}

export interface StripeQuoteTotalDetails {
  /** This is the sum of all the discounts. */
  amount_discount: number;
  /** This is the sum of all the shipping amounts. */
  amount_shipping: number | null;
  /** This is the sum of all the tax amounts. */
  amount_tax: number;
  breakdown?: StripeQuoteTotalDetailsBreakdown;
}

export interface StripeQuoteTotalDetailsBreakdown {
  /** The aggregated discounts. */
  discounts: StripeQuoteTotalDetailsBreakdownDiscount[];
  /** The aggregated tax amounts by rate. */
  taxes: StripeQuoteTotalDetailsBreakdownTax[];
}

export interface StripeQuoteTotalDetailsBreakdownDiscount {
  /** The amount discounted. */
  amount: number;
  /**
   * A discount represents the actual application of a [coupon](https://stripe.com/docs/api#coupons) or [promotion code](https://stripe.com/docs/api#promotion_codes). It contains information about when the discount began, when it will end, and what it is applied to.
   *
   * Related guide: [Applying discounts to subscriptions](https://stripe.com/docs/billing/subscriptions/discounts)
   */
  discount: StripeDiscount;
}

export interface StripeQuoteTotalDetailsBreakdownTax {
  /** Amount of tax applied for this rate. */
  amount: number;
  /**
   * Tax rates can be applied to [invoices](https://stripe.com/docs/billing/invoices/tax-rates), [subscriptions](https://stripe.com/docs/billing/subscriptions/taxes) and [Checkout Sessions](https://stripe.com/docs/payments/checkout/set-up-a-subscription#tax-rates) to collect tax.
   *
   * Related guide: [Tax rates](https://stripe.com/docs/billing/taxes/tax-rates)
   */
  rate: StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeQuoteTotalDetailsBreakdownTaxTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeQuoteTotalDetailsBreakdownTaxTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  ExcludedTerritory = 'excluded_territory',
  JurisdictionUnsupported = 'jurisdiction_unsupported',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  VatExempt = 'vat_exempt',
  ZeroRated = 'zero_rated',
}

export interface StripeQuoteTransferData {
  /** The amount in %s that will be transferred to the destination account when the invoice is paid. By default, the entire amount is transferred to the destination. */
  amount: number | null;
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the destination account. By default, the entire amount will be transferred to the destination. */
  amount_percent: number | null;
  /** The account where funds from the payment will be transferred to upon payment success. */
  destination: string | StripeAccount;
}

export interface StripeInvoiceRenderingOptions {
  /** How line-item prices and amounts will be displayed with respect to tax on invoice PDFs. */
  amount_tax_display: string | null;
}

export interface StripeInvoiceShippingCost {
  /** Total shipping cost before any taxes are applied. */
  amount_subtotal: number;
  /** Total tax amount applied due to shipping costs. If no tax was applied, defaults to 0. */
  amount_tax: number;
  /** Total shipping cost after taxes are applied. */
  amount_total: number;
  /** The ID of the ShippingRate for this invoice. */
  shipping_rate: string | StripeShippingRate | null;
  /** The taxes applied to the shipping rate. */
  taxes?: StripeInvoiceShippingCostTax[];
}

/** Shipping rates describe the price of shipping presented to your customers and can be applied to [Checkout Sessions](https://stripe.com/docs/payments/checkout/shipping) and [Orders](https://stripe.com/docs/orders/shipping) to collect shipping costs. */
export interface StripeShippingRate {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'shipping_rate';
  /** Whether the shipping rate can be used for new purchases. Defaults to `true`. */
  active: boolean;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The estimated range for how long shipping will take, meant to be displayable to the customer. This will appear on CheckoutSessions. */
  delivery_estimate: StripeShippingRateDeliveryEstimate | null;
  /** The name of the shipping rate, meant to be displayable to the customer. This will appear on CheckoutSessions. */
  display_name: string | null;
  fixed_amount?: StripeShippingRateFixedAmount;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** Specifies whether the rate is considered inclusive of taxes or exclusive of taxes. One of `inclusive`, `exclusive`, or `unspecified`. */
  tax_behavior: StripeShippingRateTaxBehavior | null;
  /** A [tax code](https://stripe.com/docs/tax/tax-categories) ID. The Shipping tax code is `txcd_92010001`. */
  tax_code: string | StripeTaxCode | null;
  /** The type of calculation to use on the shipping rate. Can only be `fixed_amount` for now. */
  type: 'fixed_amount';
}

export interface StripeShippingRateDeliveryEstimate {
  /** The upper bound of the estimated range. If empty, represents no upper bound i.e., infinite. */
  maximum: StripeShippingRateDeliveryEstimateMaximum | null;
  /** The lower bound of the estimated range. If empty, represents no lower bound. */
  minimum: StripeShippingRateDeliveryEstimateMinimum | null;
}

export interface StripeShippingRateDeliveryEstimateMaximum {
  /** A unit of time. */
  unit: StripeShippingRateDeliveryEstimateMaximumUnit;
  /** Must be greater than 0. */
  value: number;
}

export enum StripeShippingRateDeliveryEstimateMaximumUnit {
  BusinessDay = 'business_day',
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week',
}

export interface StripeShippingRateDeliveryEstimateMinimum {
  /** A unit of time. */
  unit: StripeShippingRateDeliveryEstimateMinimumUnit;
  /** Must be greater than 0. */
  value: number;
}

export enum StripeShippingRateDeliveryEstimateMinimumUnit {
  BusinessDay = 'business_day',
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week',
}

export interface StripeShippingRateFixedAmount {
  /** A non-negative integer in cents representing how much to charge. */
  amount: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** Shipping rates defined in each available currency option. Each key must be a three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html) and a [supported currency](https://stripe.com/docs/currencies). */
  currency_options?: Record<string, StripeShippingRateFixedAmountCurrencyOptions>;
}

export interface StripeShippingRateFixedAmountCurrencyOptions {
  /** A non-negative integer in cents representing how much to charge. */
  amount: number;
  /** Specifies whether the rate is considered inclusive of taxes or exclusive of taxes. One of `inclusive`, `exclusive`, or `unspecified`. */
  tax_behavior: StripeShippingRateFixedAmountCurrencyOptionsTaxBehavior;
}

export enum StripeShippingRateFixedAmountCurrencyOptionsTaxBehavior {
  Exclusive = 'exclusive',
  Inclusive = 'inclusive',
  Unspecified = 'unspecified',
}

export enum StripeShippingRateTaxBehavior {
  Exclusive = 'exclusive',
  Inclusive = 'inclusive',
  Unspecified = 'unspecified',
}

export interface StripeInvoiceShippingCostTax {
  /** Amount of tax applied for this rate. */
  amount: number;
  /**
   * Tax rates can be applied to [invoices](https://stripe.com/docs/billing/invoices/tax-rates), [subscriptions](https://stripe.com/docs/billing/subscriptions/taxes) and [Checkout Sessions](https://stripe.com/docs/payments/checkout/set-up-a-subscription#tax-rates) to collect tax.
   *
   * Related guide: [Tax rates](https://stripe.com/docs/billing/taxes/tax-rates)
   */
  rate: StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeInvoiceShippingCostTaxTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeInvoiceShippingCostTaxTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  ExcludedTerritory = 'excluded_territory',
  JurisdictionUnsupported = 'jurisdiction_unsupported',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  VatExempt = 'vat_exempt',
  ZeroRated = 'zero_rated',
}

export interface StripeInvoiceShippingDetails {
  /** The Address object. */
  address?: StripeAddress;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. */
  carrier?: string | null;
  /** Recipient name. */
  name?: string;
  /** Recipient phone (including extension). */
  phone?: string | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  tracking_number?: string | null;
}

export enum StripeInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void',
}

export interface StripeInvoiceStatusTransitions {
  /** The time that the invoice draft was finalized. */
  finalized_at: number | null;
  /** The time that the invoice was marked uncollectible. */
  marked_uncollectible_at: number | null;
  /** The time that the invoice was paid. */
  paid_at: number | null;
  /** The time that the invoice was voided. */
  voided_at: number | null;
}

export interface StripeInvoiceThresholdReason {
  /** The total invoice amount threshold boundary if it triggered the threshold invoice. */
  amount_gte: number | null;
  /** Indicates which line items triggered a threshold invoice. */
  item_reasons: StripeInvoiceThresholdReasonItemReason[];
}

export interface StripeInvoiceThresholdReasonItemReason {
  /** The IDs of the line items that triggered the threshold invoice. */
  line_item_ids: string[];
  /** The quantity threshold boundary that applied to the given line item. */
  usage_gte: number;
}

export interface StripeInvoiceTotalDiscountAmount {
  /** The amount, in %s, of the discount. */
  amount: number;
  /** The discount that was applied to get this discount amount. */
  discount: string | StripeDiscount | StripeDeletedDiscount;
}

export interface StripeInvoiceTotalTaxAmount {
  /** The amount, in %s, of the tax. */
  amount: number;
  /** Whether this tax amount is inclusive or exclusive. */
  inclusive: boolean;
  /** The tax rate that was applied to get this tax amount. */
  tax_rate: string | StripeTaxRate;
  /** The reasoning behind this tax, for example, if the product is tax exempt. The possible values for this field may be extended as new tax rules are supported. */
  taxability_reason: StripeInvoiceTotalTaxAmountTaxabilityReason | null;
  /** The amount on which tax is calculated, in %s. */
  taxable_amount: number | null;
}

export enum StripeInvoiceTotalTaxAmountTaxabilityReason {
  CustomerExempt = 'customer_exempt',
  NotCollecting = 'not_collecting',
  NotSubjectToTax = 'not_subject_to_tax',
  NotSupported = 'not_supported',
  PortionProductExempt = 'portion_product_exempt',
  PortionReducedRated = 'portion_reduced_rated',
  PortionStandardRated = 'portion_standard_rated',
  ProductExempt = 'product_exempt',
  ProductExemptHoliday = 'product_exempt_holiday',
  ProportionallyRated = 'proportionally_rated',
  ReducedRated = 'reduced_rated',
  ReverseCharge = 'reverse_charge',
  StandardRated = 'standard_rated',
  TaxableBasisReduced = 'taxable_basis_reduced',
  ZeroRated = 'zero_rated',
}

export interface StripeInvoiceTransferData {
  /** The amount in %s that will be transferred to the destination account when the invoice is paid. By default, the entire amount is transferred to the destination. */
  amount: number | null;
  /** The account where funds from the payment will be transferred to upon payment success. */
  destination: string | StripeAccount;
}

export interface StripePaymentIntentLastPaymentError {
  /** For card errors, the ID of the failed charge. */
  charge?: string;
  /** For some errors that could be handled programmatically, a short string indicating the [error code](https://stripe.com/docs/error-codes) reported. */
  code?: StripePaymentIntentLastPaymentErrorCode;
  /** For card errors resulting from a card issuer decline, a short string indicating the [card issuer's reason for the decline](https://stripe.com/docs/declines#issuer-declines) if they provide one. */
  decline_code?: string;
  /** A URL to more information about the [error code](https://stripe.com/docs/error-codes) reported. */
  doc_url?: string;
  /** A human-readable message providing more details about the error. For card errors, these messages can be shown to your users. */
  message?: string;
  /** If the error is parameter-specific, the parameter related to the error. For example, you can use this to display a message near the correct form field. */
  param?: string;
  /**
   * A PaymentIntent guides you through the process of collecting a payment from your customer. We recommend that you create exactly one PaymentIntent for each order or customer session in your system. You can reference the PaymentIntent later to see the history of payment attempts for a particular session.
   *
   * A PaymentIntent transitions through [multiple statuses](https://stripe.com/docs/payments/intents#intent-statuses) throughout its lifetime as it interfaces with Stripe.js to perform authentication flows and ultimately creates at most one successful charge.
   *
   * Related guide: [Payment Intents API](https://stripe.com/docs/payments/payment-intents)
   */
  payment_intent?: StripePaymentIntent;
  /**
   * PaymentMethod objects represent your customer's payment instruments. You can use them with [PaymentIntents](https://stripe.com/docs/payments/payment-intents) to collect payments or save them to Customer objects to store instrument details for future payments.
   *
   * Related guides: [Payment Methods](https://stripe.com/docs/payments/payment-methods) and [More Payment Scenarios](https://stripe.com/docs/payments/more-payment-scenarios).
   */
  payment_method?: StripePaymentMethod;
  /** If the error is specific to the type of payment method, the payment method type that had a problem. This field is only populated for invoice-related errors. */
  payment_method_type?: string;
  /** A URL to the request log entry in your dashboard. */
  request_log_url?: string;
  /**
   * A SetupIntent guides you through the process of setting up and saving a customer's payment credentials for future payments. For example, you could use a SetupIntent to set up and save your customer's card without immediately collecting a payment. Later, you can use [PaymentIntents](https://stripe.com/docs/api#payment_intents) to drive the payment flow.
   *
   * Create a SetupIntent as soon as you're ready to collect your customer's payment credentials. Do not maintain long-lived, unconfirmed SetupIntents as they may no longer be valid. The SetupIntent then transitions through multiple [statuses](https://stripe.com/docs/payments/intents#intent-statuses) as it guides you through the setup process.
   *
   * Successful SetupIntents result in payment credentials that are optimized for future payments. For example, cardholders in [certain regions](https://stripe.com/guides/strong-customer-authentication) may need to be run through [Strong Customer Authentication](https://stripe.com/docs/strong-customer-authentication) at the time of payment method collection in order to streamline later [off-session payments](https://stripe.com/docs/payments/setup-intents). If the SetupIntent is used with a [Customer](https://stripe.com/docs/api#setup_intent_object-customer), upon success, it will automatically attach the resulting payment method to that Customer. We recommend using SetupIntents or [setup_future_usage](https://stripe.com/docs/api#payment_intent_object-setup_future_usage) on PaymentIntents to save payment methods in order to prevent saving invalid or unoptimized payment methods.
   *
   * By using SetupIntents, you ensure that your customers experience the minimum set of required friction, even as regulations change over time.
   *
   * Related guide: [Setup Intents API](https://stripe.com/docs/payments/setup-intents)
   */
  setup_intent?: StripeSetupIntent;
  source?: StripeCustomerSource;
  /** The type of error returned. One of `api_error`, `card_error`, `idempotency_error`, or `invalid_request_error` */
  type: StripePaymentIntentLastPaymentErrorType;
}

export enum StripePaymentIntentLastPaymentErrorCode {
  AccountClosed = 'account_closed',
  AccountCountryInvalidAddress = 'account_country_invalid_address',
  AccountErrorCountryChangeRequiresAdditionalSteps = 'account_error_country_change_requires_additional_steps',
  AccountInformationMismatch = 'account_information_mismatch',
  AccountInvalid = 'account_invalid',
  AccountNumberInvalid = 'account_number_invalid',
  AcssDebitSessionIncomplete = 'acss_debit_session_incomplete',
  AlipayUpgradeRequired = 'alipay_upgrade_required',
  AmountTooLarge = 'amount_too_large',
  AmountTooSmall = 'amount_too_small',
  ApiKeyExpired = 'api_key_expired',
  AuthenticationRequired = 'authentication_required',
  BalanceInsufficient = 'balance_insufficient',
  BankAccountBadRoutingNumbers = 'bank_account_bad_routing_numbers',
  BankAccountDeclined = 'bank_account_declined',
  BankAccountExists = 'bank_account_exists',
  BankAccountRestricted = 'bank_account_restricted',
  BankAccountUnusable = 'bank_account_unusable',
  BankAccountUnverified = 'bank_account_unverified',
  BankAccountVerificationFailed = 'bank_account_verification_failed',
  BillingInvalidMandate = 'billing_invalid_mandate',
  BitcoinUpgradeRequired = 'bitcoin_upgrade_required',
  CaptureChargeAuthorizationExpired = 'capture_charge_authorization_expired',
  CaptureUnauthorizedPayment = 'capture_unauthorized_payment',
  CardDeclineRateLimitExceeded = 'card_decline_rate_limit_exceeded',
  CardDeclined = 'card_declined',
  CardholderPhoneNumberRequired = 'cardholder_phone_number_required',
  ChargeAlreadyCaptured = 'charge_already_captured',
  ChargeAlreadyRefunded = 'charge_already_refunded',
  ChargeDisputed = 'charge_disputed',
  ChargeExceedsSourceLimit = 'charge_exceeds_source_limit',
  ChargeExpiredForCapture = 'charge_expired_for_capture',
  ChargeInvalidParameter = 'charge_invalid_parameter',
  ChargeNotRefundable = 'charge_not_refundable',
  ClearingCodeUnsupported = 'clearing_code_unsupported',
  CountryCodeInvalid = 'country_code_invalid',
  CountryUnsupported = 'country_unsupported',
  CouponExpired = 'coupon_expired',
  CustomerMaxPaymentMethods = 'customer_max_payment_methods',
  CustomerMaxSubscriptions = 'customer_max_subscriptions',
  DebitNotAuthorized = 'debit_not_authorized',
  EmailInvalid = 'email_invalid',
  ExpiredCard = 'expired_card',
  IdempotencyKeyInUse = 'idempotency_key_in_use',
  IncorrectAddress = 'incorrect_address',
  IncorrectCvc = 'incorrect_cvc',
  IncorrectNumber = 'incorrect_number',
  IncorrectZip = 'incorrect_zip',
  InstantPayoutsConfigDisabled = 'instant_payouts_config_disabled',
  InstantPayoutsCurrencyDisabled = 'instant_payouts_currency_disabled',
  InstantPayoutsLimitExceeded = 'instant_payouts_limit_exceeded',
  InstantPayoutsUnsupported = 'instant_payouts_unsupported',
  InsufficientFunds = 'insufficient_funds',
  IntentInvalidState = 'intent_invalid_state',
  IntentVerificationMethodMissing = 'intent_verification_method_missing',
  InvalidCardType = 'invalid_card_type',
  InvalidCharacters = 'invalid_characters',
  InvalidChargeAmount = 'invalid_charge_amount',
  InvalidCvc = 'invalid_cvc',
  InvalidExpiryMonth = 'invalid_expiry_month',
  InvalidExpiryYear = 'invalid_expiry_year',
  InvalidNumber = 'invalid_number',
  InvalidSourceUsage = 'invalid_source_usage',
  InvoiceNoCustomerLineItems = 'invoice_no_customer_line_items',
  InvoiceNoPaymentMethodTypes = 'invoice_no_payment_method_types',
  InvoiceNoSubscriptionLineItems = 'invoice_no_subscription_line_items',
  InvoiceNotEditable = 'invoice_not_editable',
  InvoiceOnBehalfOfNotEditable = 'invoice_on_behalf_of_not_editable',
  InvoicePaymentIntentRequiresAction = 'invoice_payment_intent_requires_action',
  InvoiceUpcomingNone = 'invoice_upcoming_none',
  LivemodeMismatch = 'livemode_mismatch',
  LockTimeout = 'lock_timeout',
  Missing = 'missing',
  NoAccount = 'no_account',
  NotAllowedOnStandardAccount = 'not_allowed_on_standard_account',
  OutOfInventory = 'out_of_inventory',
  OwnershipDeclarationNotAllowed = 'ownership_declaration_not_allowed',
  ParameterInvalidEmpty = 'parameter_invalid_empty',
  ParameterInvalidInteger = 'parameter_invalid_integer',
  ParameterInvalidStringBlank = 'parameter_invalid_string_blank',
  ParameterInvalidStringEmpty = 'parameter_invalid_string_empty',
  ParameterMissing = 'parameter_missing',
  ParameterUnknown = 'parameter_unknown',
  ParametersExclusive = 'parameters_exclusive',
  PaymentIntentActionRequired = 'payment_intent_action_required',
  PaymentIntentAuthenticationFailure = 'payment_intent_authentication_failure',
  PaymentIntentIncompatiblePaymentMethod = 'payment_intent_incompatible_payment_method',
  PaymentIntentInvalidParameter = 'payment_intent_invalid_parameter',
  PaymentIntentKonbiniRejectedConfirmationNumber = 'payment_intent_konbini_rejected_confirmation_number',
  PaymentIntentMandateInvalid = 'payment_intent_mandate_invalid',
  PaymentIntentPaymentAttemptExpired = 'payment_intent_payment_attempt_expired',
  PaymentIntentPaymentAttemptFailed = 'payment_intent_payment_attempt_failed',
  PaymentIntentUnexpectedState = 'payment_intent_unexpected_state',
  PaymentMethodBankAccountAlreadyVerified = 'payment_method_bank_account_already_verified',
  PaymentMethodBankAccountBlocked = 'payment_method_bank_account_blocked',
  PaymentMethodBillingDetailsAddressMissing = 'payment_method_billing_details_address_missing',
  PaymentMethodConfigurationFailures = 'payment_method_configuration_failures',
  PaymentMethodCurrencyMismatch = 'payment_method_currency_mismatch',
  PaymentMethodCustomerDecline = 'payment_method_customer_decline',
  PaymentMethodInvalidParameter = 'payment_method_invalid_parameter',
  PaymentMethodInvalidParameterTestmode = 'payment_method_invalid_parameter_testmode',
  PaymentMethodMicrodepositFailed = 'payment_method_microdeposit_failed',
  PaymentMethodMicrodepositVerificationAmountsInvalid = 'payment_method_microdeposit_verification_amounts_invalid',
  PaymentMethodMicrodepositVerificationAmountsMismatch = 'payment_method_microdeposit_verification_amounts_mismatch',
  PaymentMethodMicrodepositVerificationAttemptsExceeded = 'payment_method_microdeposit_verification_attempts_exceeded',
  PaymentMethodMicrodepositVerificationDescriptorCodeMismatch = 'payment_method_microdeposit_verification_descriptor_code_mismatch',
  PaymentMethodMicrodepositVerificationTimeout = 'payment_method_microdeposit_verification_timeout',
  PaymentMethodNotAvailable = 'payment_method_not_available',
  PaymentMethodProviderDecline = 'payment_method_provider_decline',
  PaymentMethodProviderTimeout = 'payment_method_provider_timeout',
  PaymentMethodUnactivated = 'payment_method_unactivated',
  PaymentMethodUnexpectedState = 'payment_method_unexpected_state',
  PaymentMethodUnsupportedType = 'payment_method_unsupported_type',
  PayoutReconciliationNotReady = 'payout_reconciliation_not_ready',
  PayoutsLimitExceeded = 'payouts_limit_exceeded',
  PayoutsNotAllowed = 'payouts_not_allowed',
  PlatformAccountRequired = 'platform_account_required',
  PlatformApiKeyExpired = 'platform_api_key_expired',
  PostalCodeInvalid = 'postal_code_invalid',
  ProcessingError = 'processing_error',
  ProductInactive = 'product_inactive',
  ProgressiveOnboardingLimitExceeded = 'progressive_onboarding_limit_exceeded',
  RateLimit = 'rate_limit',
  ReferToCustomer = 'refer_to_customer',
  RefundDisputedPayment = 'refund_disputed_payment',
  ResourceAlreadyExists = 'resource_already_exists',
  ResourceMissing = 'resource_missing',
  ReturnIntentAlreadyProcessed = 'return_intent_already_processed',
  RoutingNumberInvalid = 'routing_number_invalid',
  SecretKeyRequired = 'secret_key_required',
  SepaUnsupportedAccount = 'sepa_unsupported_account',
  SetupAttemptFailed = 'setup_attempt_failed',
  SetupIntentAuthenticationFailure = 'setup_intent_authentication_failure',
  SetupIntentInvalidParameter = 'setup_intent_invalid_parameter',
  SetupIntentMandateInvalid = 'setup_intent_mandate_invalid',
  SetupIntentSetupAttemptExpired = 'setup_intent_setup_attempt_expired',
  SetupIntentUnexpectedState = 'setup_intent_unexpected_state',
  ShippingCalculationFailed = 'shipping_calculation_failed',
  SkuInactive = 'sku_inactive',
  StateUnsupported = 'state_unsupported',
  StatusTransitionInvalid = 'status_transition_invalid',
  TaxIdInvalid = 'tax_id_invalid',
  TaxesCalculationFailed = 'taxes_calculation_failed',
  TerminalLocationCountryUnsupported = 'terminal_location_country_unsupported',
  TerminalReaderBusy = 'terminal_reader_busy',
  TerminalReaderOffline = 'terminal_reader_offline',
  TerminalReaderTimeout = 'terminal_reader_timeout',
  TestmodeChargesOnly = 'testmode_charges_only',
  TlsVersionUnsupported = 'tls_version_unsupported',
  TokenAlreadyUsed = 'token_already_used',
  TokenInUse = 'token_in_use',
  TransferSourceBalanceParametersMismatch = 'transfer_source_balance_parameters_mismatch',
  TransfersNotAllowed = 'transfers_not_allowed',
  UrlInvalid = 'url_invalid',
}

export enum StripePaymentIntentLastPaymentErrorType {
  ApiError = 'api_error',
  CardError = 'card_error',
  IdempotencyError = 'idempotency_error',
  InvalidRequestError = 'invalid_request_error',
}

export interface StripePaymentIntentNextAction {
  alipay_handle_redirect?: StripePaymentIntentNextActionAlipayHandleRedirect;
  boleto_display_details?: StripePaymentIntentNextActionBoletoDisplayDetails;
  card_await_notification?: StripePaymentIntentNextActionCardAwaitNotification;
  cashapp_handle_redirect_or_display_qr_code?: StripePaymentIntentNextActionCashappHandleRedirectOrDisplayQrCode;
  display_bank_transfer_instructions?: StripePaymentIntentNextActionDisplayBankTransferInstructions;
  konbini_display_details?: StripePaymentIntentNextActionKonbiniDisplayDetails;
  oxxo_display_details?: StripePaymentIntentNextActionOxxoDisplayDetails;
  paynow_display_qr_code?: StripePaymentIntentNextActionPaynowDisplayQrCode;
  pix_display_qr_code?: StripePaymentIntentNextActionPixDisplayQrCode;
  promptpay_display_qr_code?: StripePaymentIntentNextActionPromptpayDisplayQrCode;
  redirect_to_url?: StripePaymentIntentNextActionRedirectToUrl;
  /** Type of the next action to perform, one of `redirect_to_url`, `use_stripe_sdk`, `alipay_handle_redirect`, `oxxo_display_details`, or `verify_with_microdeposits`. */
  type: string;
  /** When confirming a PaymentIntent with Stripe.js, Stripe.js depends on the contents of this dictionary to invoke authentication flows. The shape of the contents is subject to change and is only intended to be used by Stripe.js. */
  use_stripe_sdk?: StripePaymentIntentNextActionUseStripeSdk;
  verify_with_microdeposits?: StripePaymentIntentNextActionVerifyWithMicrodeposits;
  wechat_pay_display_qr_code?: StripePaymentIntentNextActionWechatPayDisplayQrCode;
  wechat_pay_redirect_to_android_app?: StripePaymentIntentNextActionWechatPayRedirectToAndroidApp;
  wechat_pay_redirect_to_ios_app?: StripePaymentIntentNextActionWechatPayRedirectToIosApp;
}

export interface StripePaymentIntentNextActionAlipayHandleRedirect {
  /** The native data to be used with Alipay SDK you must redirect your customer to in order to authenticate the payment in an Android App. */
  native_data: string | null;
  /** The native URL you must redirect your customer to in order to authenticate the payment in an iOS App. */
  native_url: string | null;
  /** If the customer does not exit their browser while authenticating, they will be redirected to this specified URL after completion. */
  return_url: string | null;
  /** The URL you must redirect your customer to in order to authenticate the payment. */
  url: string | null;
}

export interface StripePaymentIntentNextActionBoletoDisplayDetails {
  /** The timestamp after which the boleto expires. */
  expires_at: number | null;
  /** The URL to the hosted boleto voucher page, which allows customers to view the boleto voucher. */
  hosted_voucher_url: string | null;
  /** The boleto number. */
  number: string | null;
  /** The URL to the downloadable boleto voucher PDF. */
  pdf: string | null;
}

export interface StripePaymentIntentNextActionCardAwaitNotification {
  /** The time that payment will be attempted. If customer approval is required, they need to provide approval before this time. */
  charge_attempt_at: number | null;
  /** For payments greater than INR 15000, the customer must provide explicit approval of the payment with their bank. For payments of lower amount, no customer action is required. */
  customer_approval_required: boolean | null;
}

export interface StripePaymentIntentNextActionCashappHandleRedirectOrDisplayQrCode {
  /** The URL to the hosted Cash App Pay instructions page, which allows customers to view the QR code, and supports QR code refreshing on expiration. */
  hosted_instructions_url: string;
  /** The url for mobile redirect based auth */
  mobile_auth_url: string;
  qr_code: StripePaymentIntentNextActionCashappHandleRedirectOrDisplayQrCodeQrCode;
}

export interface StripePaymentIntentNextActionCashappHandleRedirectOrDisplayQrCodeQrCode {
  /** The date (unix timestamp) when the QR code expires. */
  expires_at: number;
  /** The image_url_png string used to render QR code */
  image_url_png: string;
  /** The image_url_svg string used to render QR code */
  image_url_svg: string;
}

export interface StripePaymentIntentNextActionDisplayBankTransferInstructions {
  /** The remaining amount that needs to be transferred to complete the payment. */
  amount_remaining: number | null;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string | null;
  /** A list of financial addresses that can be used to fund the customer balance */
  financial_addresses?: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddress[];
  /** A link to a hosted page that guides your customer through completing the transfer. */
  hosted_instructions_url: string | null;
  /** A string identifying this payment. Instruct your customer to include this code in the reference or memo field of their bank transfer. */
  reference: string | null;
  /** Type of bank transfer */
  type: StripePaymentIntentNextActionDisplayBankTransferInstructionsType;
}

export interface StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddress {
  /** Iban Records contain E.U. bank account details per the SEPA format. */
  iban?: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressIban;
  /** Sort Code Records contain U.K. bank account details per the sort code format. */
  sort_code?: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressSortCode;
  /** SPEI Records contain Mexico bank account details per the SPEI format. */
  spei?: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressSpei;
  /** The payment networks supported by this FinancialAddress */
  supported_networks?: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressSupportedNetwork[];
  /** The type of financial address */
  type: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressType;
  /** Zengin Records contain Japan bank account details per the Zengin format. */
  zengin?: StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressZengin;
}

export interface StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressIban {
  /** The name of the person or business that owns the bank account */
  account_holder_name: string;
  /** The BIC/SWIFT code of the account. */
  bic: string;
  /** Two-letter country code ([ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)). */
  country: string;
  /** The IBAN of the account. */
  iban: string;
}

export interface StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressSortCode {
  /** The name of the person or business that owns the bank account */
  account_holder_name: string;
  /** The account number */
  account_number: string;
  /** The six-digit sort code */
  sort_code: string;
}

export interface StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressSpei {
  /** The three-digit bank code */
  bank_code: string;
  /** The short banking institution name */
  bank_name: string;
  /** The CLABE number */
  clabe: string;
}

export enum StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressSupportedNetwork {
  Bacs = 'bacs',
  Fps = 'fps',
  Sepa = 'sepa',
  Spei = 'spei',
  Zengin = 'zengin',
}

export enum StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressType {
  Iban = 'iban',
  SortCode = 'sort_code',
  Spei = 'spei',
  Zengin = 'zengin',
}

export interface StripePaymentIntentNextActionDisplayBankTransferInstructionsFinancialAddressZengin {
  /** The account holder name */
  account_holder_name: string | null;
  /** The account number */
  account_number: string | null;
  /** The bank account type. In Japan, this can only be `futsu` or `toza`. */
  account_type: string | null;
  /** The bank code of the account */
  bank_code: string | null;
  /** The bank name of the account */
  bank_name: string | null;
  /** The branch code of the account */
  branch_code: string | null;
  /** The branch name of the account */
  branch_name: string | null;
}

export enum StripePaymentIntentNextActionDisplayBankTransferInstructionsType {
  EuBankTransfer = 'eu_bank_transfer',
  GbBankTransfer = 'gb_bank_transfer',
  JpBankTransfer = 'jp_bank_transfer',
  MxBankTransfer = 'mx_bank_transfer',
  UsBankTransfer = 'us_bank_transfer',
}

export interface StripePaymentIntentNextActionKonbiniDisplayDetails {
  /** The timestamp at which the pending Konbini payment expires. */
  expires_at: number;
  /** The URL for the Konbini payment instructions page, which allows customers to view and print a Konbini voucher. */
  hosted_voucher_url: string | null;
  stores: StripePaymentIntentNextActionKonbiniDisplayDetailsStores;
}

export interface StripePaymentIntentNextActionKonbiniDisplayDetailsStores {
  /** FamilyMart instruction details. */
  familymart: StripePaymentIntentNextActionKonbiniDisplayDetailsStoresFamilymart | null;
  /** Lawson instruction details. */
  lawson: StripePaymentIntentNextActionKonbiniDisplayDetailsStoresLawson | null;
  /** Ministop instruction details. */
  ministop: StripePaymentIntentNextActionKonbiniDisplayDetailsStoresMinistop | null;
  /** Seicomart instruction details. */
  seicomart: StripePaymentIntentNextActionKonbiniDisplayDetailsStoresSeicomart | null;
}

export interface StripePaymentIntentNextActionKonbiniDisplayDetailsStoresFamilymart {
  /** The confirmation number. */
  confirmation_number?: string;
  /** The payment code. */
  payment_code: string;
}

export interface StripePaymentIntentNextActionKonbiniDisplayDetailsStoresLawson {
  /** The confirmation number. */
  confirmation_number?: string;
  /** The payment code. */
  payment_code: string;
}

export interface StripePaymentIntentNextActionKonbiniDisplayDetailsStoresMinistop {
  /** The confirmation number. */
  confirmation_number?: string;
  /** The payment code. */
  payment_code: string;
}

export interface StripePaymentIntentNextActionKonbiniDisplayDetailsStoresSeicomart {
  /** The confirmation number. */
  confirmation_number?: string;
  /** The payment code. */
  payment_code: string;
}

export interface StripePaymentIntentNextActionOxxoDisplayDetails {
  /** The timestamp after which the OXXO voucher expires. */
  expires_after: number | null;
  /** The URL for the hosted OXXO voucher page, which allows customers to view and print an OXXO voucher. */
  hosted_voucher_url: string | null;
  /** OXXO reference number. */
  number: string | null;
}

export interface StripePaymentIntentNextActionPaynowDisplayQrCode {
  /** The raw data string used to generate QR code, it should be used together with QR code library. */
  data: string;
  /** The URL to the hosted PayNow instructions page, which allows customers to view the PayNow QR code. */
  hosted_instructions_url: string | null;
  /** The image_url_png string used to render QR code */
  image_url_png: string;
  /** The image_url_svg string used to render QR code */
  image_url_svg: string;
}

export interface StripePaymentIntentNextActionPixDisplayQrCode {
  /** The raw data string used to generate QR code, it should be used together with QR code library. */
  data?: string;
  /** The date (unix timestamp) when the PIX expires. */
  expires_at?: number;
  /** The URL to the hosted pix instructions page, which allows customers to view the pix QR code. */
  hosted_instructions_url?: string;
  /** The image_url_png string used to render png QR code */
  image_url_png?: string;
  /** The image_url_svg string used to render svg QR code */
  image_url_svg?: string;
}

export interface StripePaymentIntentNextActionPromptpayDisplayQrCode {
  /** The raw data string used to generate QR code, it should be used together with QR code library. */
  data: string;
  /** The URL to the hosted PromptPay instructions page, which allows customers to view the PromptPay QR code. */
  hosted_instructions_url: string;
  /** The PNG path used to render the QR code, can be used as the source in an HTML img tag */
  image_url_png: string;
  /** The SVG path used to render the QR code, can be used as the source in an HTML img tag */
  image_url_svg: string;
}

export interface StripePaymentIntentNextActionRedirectToUrl {
  /** If the customer does not exit their browser while authenticating, they will be redirected to this specified URL after completion. */
  return_url: string | null;
  /** The URL you must redirect your customer to in order to authenticate the payment. */
  url: string | null;
}

export type StripePaymentIntentNextActionUseStripeSdk = object;

export interface StripePaymentIntentNextActionVerifyWithMicrodeposits {
  /** The timestamp when the microdeposits are expected to land. */
  arrival_date: number;
  /** The URL for the hosted verification page, which allows customers to verify their bank account. */
  hosted_verification_url: string;
  /** The type of the microdeposit sent to the customer. Used to distinguish between different verification methods. */
  microdeposit_type: StripePaymentIntentNextActionVerifyWithMicrodepositsMicrodepositType | null;
}

export enum StripePaymentIntentNextActionVerifyWithMicrodepositsMicrodepositType {
  Amounts = 'amounts',
  DescriptorCode = 'descriptor_code',
}

export interface StripePaymentIntentNextActionWechatPayDisplayQrCode {
  /** The data being used to generate QR code */
  data: string;
  /** The URL to the hosted WeChat Pay instructions page, which allows customers to view the WeChat Pay QR code. */
  hosted_instructions_url: string;
  /** The base64 image data for a pre-generated QR code */
  image_data_url: string;
  /** The image_url_png string used to render QR code */
  image_url_png: string;
  /** The image_url_svg string used to render QR code */
  image_url_svg: string;
}

export interface StripePaymentIntentNextActionWechatPayRedirectToAndroidApp {
  /** app_id is the APP ID registered on WeChat open platform */
  app_id: string;
  /** nonce_str is a random string */
  nonce_str: string;
  /** package is static value */
  package: string;
  /** an unique merchant ID assigned by WeChat Pay */
  partner_id: string;
  /** an unique trading ID assigned by WeChat Pay */
  prepay_id: string;
  /** A signature */
  sign: string;
  /** Specifies the current time in epoch format */
  timestamp: string;
}

export interface StripePaymentIntentNextActionWechatPayRedirectToIosApp {
  /** An universal link that redirect to WeChat Pay app */
  native_url: string;
}

export interface StripePaymentIntentPaymentMethodOptions {
  acss_debit?: StripePaymentIntentPaymentMethodOptionsAcssDebit;
  affirm?: StripePaymentIntentPaymentMethodOptionsAffirm;
  afterpay_clearpay?: StripePaymentIntentPaymentMethodOptionsAfterpayClearpay;
  alipay?: StripePaymentIntentPaymentMethodOptionsAlipay;
  au_becs_debit?: StripePaymentIntentPaymentMethodOptionsAuBecsDebit;
  bacs_debit?: StripePaymentIntentPaymentMethodOptionsBacsDebit;
  bancontact?: StripePaymentIntentPaymentMethodOptionsBancontact;
  blik?: StripePaymentIntentPaymentMethodOptionsBlik;
  boleto?: StripePaymentIntentPaymentMethodOptionsBoleto;
  card?: StripePaymentIntentPaymentMethodOptionsCard;
  card_present?: StripePaymentIntentPaymentMethodOptionsCardPresent;
  cashapp?: StripePaymentIntentPaymentMethodOptionsCashapp;
  customer_balance?: StripePaymentIntentPaymentMethodOptionsCustomerBalance;
  eps?: StripePaymentIntentPaymentMethodOptionsEps;
  fpx?: StripePaymentIntentPaymentMethodOptionsFpx;
  giropay?: StripePaymentIntentPaymentMethodOptionsGiropay;
  grabpay?: StripePaymentIntentPaymentMethodOptionsGrabpay;
  ideal?: StripePaymentIntentPaymentMethodOptionsIdeal;
  interac_present?: StripePaymentIntentPaymentMethodOptionsInteracPresent;
  klarna?: StripePaymentIntentPaymentMethodOptionsKlarna;
  konbini?: StripePaymentIntentPaymentMethodOptionsKonbini;
  link?: StripePaymentIntentPaymentMethodOptionsLink;
  oxxo?: StripePaymentIntentPaymentMethodOptionsOxxo;
  p24?: StripePaymentIntentPaymentMethodOptionsP24;
  paynow?: StripePaymentIntentPaymentMethodOptionsPaynow;
  paypal?: StripePaymentIntentPaymentMethodOptionsPaypal;
  pix?: StripePaymentIntentPaymentMethodOptionsPix;
  promptpay?: StripePaymentIntentPaymentMethodOptionsPromptpay;
  sepa_debit?: StripePaymentIntentPaymentMethodOptionsSepaDebit;
  sofort?: StripePaymentIntentPaymentMethodOptionsSofort;
  us_bank_account?: StripePaymentIntentPaymentMethodOptionsUsBankAccount;
  wechat_pay?: StripePaymentIntentPaymentMethodOptionsWechatPay;
  zip?: StripePaymentIntentPaymentMethodOptionsZip;
}

export interface StripePaymentIntentPaymentMethodOptionsAcssDebit {
  mandate_options?: StripePaymentIntentPaymentMethodOptionsAcssDebitMandateOptions;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsAcssDebitSetupFutureUsage;
  /** Bank account verification method. */
  verification_method?: StripePaymentIntentPaymentMethodOptionsAcssDebitVerificationMethod;
}

export interface StripePaymentIntentPaymentMethodOptionsAcssDebitMandateOptions {
  /** A URL for custom mandate text */
  custom_mandate_url?: string;
  /** Description of the interval. Only required if the 'payment_schedule' parameter is 'interval' or 'combined'. */
  interval_description: string | null;
  /** Payment schedule for the mandate. */
  payment_schedule: StripePaymentIntentPaymentMethodOptionsAcssDebitMandateOptionsPaymentSchedule | null;
  /** Transaction type of the mandate. */
  transaction_type: StripePaymentIntentPaymentMethodOptionsAcssDebitMandateOptionsTransactionType | null;
}

export enum StripePaymentIntentPaymentMethodOptionsAcssDebitMandateOptionsPaymentSchedule {
  Combined = 'combined',
  Interval = 'interval',
  Sporadic = 'sporadic',
}

export enum StripePaymentIntentPaymentMethodOptionsAcssDebitMandateOptionsTransactionType {
  Business = 'business',
  Personal = 'personal',
}

export enum StripePaymentIntentPaymentMethodOptionsAcssDebitSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export enum StripePaymentIntentPaymentMethodOptionsAcssDebitVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export interface StripePaymentIntentPaymentMethodOptionsAffirm {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /** Preferred language of the Affirm authorization page that the customer is redirected to. */
  preferred_locale?: string;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsAfterpayClearpay {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /** Order identifier shown to the customer in Afterpay's online portal. We recommend using a value that helps you answer any questions a customer might have about the payment. The identifier is limited to 128 characters and may contain only letters, digits, underscores, backslashes and dashes. */
  reference: string | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsAlipay {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsAlipaySetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsAlipaySetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
}

export interface StripePaymentIntentPaymentMethodOptionsAuBecsDebit {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsAuBecsDebitSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsAuBecsDebitSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentPaymentMethodOptionsBacsDebit {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsBacsDebitSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsBacsDebitSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentPaymentMethodOptionsBancontact {
  /** Preferred language of the Bancontact authorization page that the customer is redirected to. */
  preferred_language: StripePaymentIntentPaymentMethodOptionsBancontactPreferredLanguage;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsBancontactSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsBancontactPreferredLanguage {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export enum StripePaymentIntentPaymentMethodOptionsBancontactSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
}

export type StripePaymentIntentPaymentMethodOptionsBlik = object;

export interface StripePaymentIntentPaymentMethodOptionsBoleto {
  /** The number of calendar days before a Boleto voucher expires. For example, if you create a Boleto voucher on Monday and you set expires_after_days to 2, the Boleto voucher will expire on Wednesday at 23:59 America/Sao_Paulo time. */
  expires_after_days: number;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsBoletoSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsBoletoSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentPaymentMethodOptionsCard {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /**
   * Installment details for this payment (Mexico only).
   *
   * For more information, see the [installments integration guide](https://stripe.com/docs/payments/installments).
   */
  installments: StripePaymentIntentPaymentMethodOptionsCardInstallments | null;
  /** Configuration options for setting up an eMandate for cards issued in India. */
  mandate_options: StripePaymentIntentPaymentMethodOptionsCardMandateOptions | null;
  /** Selected network to process this payment intent on. Depends on the available networks of the card attached to the payment intent. Can be only set confirm-time. */
  network: StripePaymentIntentPaymentMethodOptionsCardNetwork | null;
  /** We strongly recommend that you rely on our SCA Engine to automatically prompt your customers for authentication based on risk level and [other requirements](https://stripe.com/docs/strong-customer-authentication). However, if you wish to request 3D Secure based on logic from your own fraud engine, provide this option. Permitted values include: `automatic` or `any`. If not provided, defaults to `automatic`. Read our guide on [manually requesting 3D Secure](https://stripe.com/docs/payments/3d-secure#manual-three-ds) for more information on how this configuration interacts with Radar and our SCA Engine. */
  request_three_d_secure: StripePaymentIntentPaymentMethodOptionsCardRequestThreeDSecure | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsCardSetupFutureUsage;
  /** Provides information about a card payment that customers see on their statements. Concatenated with the Kana prefix (shortened Kana descriptor) or Kana statement descriptor that's set on the account to form the complete statement descriptor. Maximum 22 characters. On card statements, the *concatenation* of both prefix and suffix (including separators) will appear truncated to 22 characters. */
  statement_descriptor_suffix_kana?: string;
  /** Provides information about a card payment that customers see on their statements. Concatenated with the Kanji prefix (shortened Kanji descriptor) or Kanji statement descriptor that's set on the account to form the complete statement descriptor. Maximum 17 characters. On card statements, the *concatenation* of both prefix and suffix (including separators) will appear truncated to 17 characters. */
  statement_descriptor_suffix_kanji?: string;
}

export interface StripePaymentIntentPaymentMethodOptionsCardInstallments {
  /** Installment plans that may be selected for this PaymentIntent. */
  available_plans: StripePaymentIntentPaymentMethodOptionsCardInstallmentsAvailablePlan[] | null;
  /** Whether Installments are enabled for this PaymentIntent. */
  enabled: boolean;
  /** Installment plan selected for this PaymentIntent. */
  plan: StripePaymentIntentPaymentMethodOptionsCardInstallmentsPlan | null;
}

export interface StripePaymentIntentPaymentMethodOptionsCardInstallmentsAvailablePlan {
  /** For `fixed_count` installment plans, this is the number of installment payments your customer will make to their credit card. */
  count: number | null;
  /** For `fixed_count` installment plans, this is the interval between installment payments your customer will make to their credit card. One of `month`. */
  interval: StripePaymentIntentPaymentMethodOptionsCardInstallmentsAvailablePlanIntervalEnum;
  /** Type of installment plan, one of `fixed_count`. */
  type: 'fixed_count';
}

export interface StripePaymentIntentPaymentMethodOptionsCardInstallmentsPlan {
  /** For `fixed_count` installment plans, this is the number of installment payments your customer will make to their credit card. */
  count: number | null;
  /** For `fixed_count` installment plans, this is the interval between installment payments your customer will make to their credit card. One of `month`. */
  interval: StripePaymentIntentPaymentMethodOptionsCardInstallmentsPlanIntervalEnum;
  /** Type of installment plan, one of `fixed_count`. */
  type: 'fixed_count';
}

export interface StripePaymentIntentPaymentMethodOptionsCardMandateOptions {
  /** Amount to be charged for future payments. */
  amount: number;
  /** One of `fixed` or `maximum`. If `fixed`, the `amount` param refers to the exact amount to be charged in future payments. If `maximum`, the amount charged can be up to the value passed for the `amount` param. */
  amount_type: StripePaymentIntentPaymentMethodOptionsCardMandateOptionsAmountType;
  /** A description of the mandate or subscription that is meant to be displayed to the customer. */
  description: string | null;
  /** End date of the mandate or subscription. If not provided, the mandate will be active until canceled. If provided, end date should be after start date. */
  end_date: number | null;
  /** Specifies payment frequency. One of `day`, `week`, `month`, `year`, or `sporadic`. */
  interval: StripePaymentIntentPaymentMethodOptionsCardMandateOptionsInterval;
  /** The number of intervals between payments. For example, `interval=month` and `interval_count=3` indicates one payment every three months. Maximum of one year interval allowed (1 year, 12 months, or 52 weeks). This parameter is optional when `interval=sporadic`. */
  interval_count: number | null;
  /** Unique identifier for the mandate or subscription. */
  reference: string;
  /** Start date of the mandate or subscription. Start date should not be lesser than yesterday. */
  start_date: number;
  /** Specifies the type of mandates supported. Possible values are `india`. */
  supported_types: 'india'[] | null;
}

export enum StripePaymentIntentPaymentMethodOptionsCardMandateOptionsAmountType {
  Fixed = 'fixed',
  Maximum = 'maximum',
}

export enum StripePaymentIntentPaymentMethodOptionsCardMandateOptionsInterval {
  Day = 'day',
  Month = 'month',
  Sporadic = 'sporadic',
  Week = 'week',
  Year = 'year',
}

export enum StripePaymentIntentPaymentMethodOptionsCardNetwork {
  Amex = 'amex',
  CartesBancaires = 'cartes_bancaires',
  Diners = 'diners',
  Discover = 'discover',
  EftposAu = 'eftpos_au',
  Interac = 'interac',
  Jcb = 'jcb',
  Mastercard = 'mastercard',
  Unionpay = 'unionpay',
  Unknown = 'unknown',
  Visa = 'visa',
}

export enum StripePaymentIntentPaymentMethodOptionsCardRequestThreeDSecure {
  Any = 'any',
  Automatic = 'automatic',
  ChallengeOnly = 'challenge_only',
}

export enum StripePaymentIntentPaymentMethodOptionsCardSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentPaymentMethodOptionsCardPresent {
  /** Request ability to capture this payment beyond the standard [authorization validity window](https://stripe.com/docs/terminal/features/extended-authorizations#authorization-validity) */
  request_extended_authorization: boolean | null;
  /** Request ability to [increment](https://stripe.com/docs/terminal/features/incremental-authorizations) this PaymentIntent if the combination of MCC and card brand is eligible. Check [incremental_authorization_supported](https://stripe.com/docs/api/charges/object#charge_object-payment_method_details-card_present-incremental_authorization_supported) in the [Confirm](https://stripe.com/docs/api/payment_intents/confirm) response to verify support. */
  request_incremental_authorization_support: boolean | null;
}

export interface StripePaymentIntentPaymentMethodOptionsCashapp {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsCashappSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsCashappSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentPaymentMethodOptionsCustomerBalance {
  bank_transfer?: StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransfer;
  /** The funding method type to be used when there are not enough funds in the customer balance. Permitted values include: `bank_transfer`. */
  funding_type: StripePaymentIntentPaymentMethodOptionsCustomerBalanceFundingTypeEnum;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransfer {
  eu_bank_transfer?: StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer;
  /**
   * List of address types that should be returned in the financial_addresses response. If not specified, all valid types will be returned.
   *
   * Permitted values include: `sort_code`, `zengin`, `iban`, or `spei`.
   */
  requested_address_types?: StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferRequestedAddressType[];
  /** The bank transfer type that this PaymentIntent is allowed to use for funding Permitted values include: `eu_bank_transfer`, `gb_bank_transfer`, `jp_bank_transfer`, `mx_bank_transfer`, or `us_bank_transfer`. */
  type: StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferType | null;
}

export interface StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer {
  /** The desired country code of the bank account information. Permitted values include: `BE`, `DE`, `ES`, `FR`, `IE`, or `NL`. */
  country: StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransferCountry;
}

export enum StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransferCountry {
  BE = 'BE',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  IE = 'IE',
  NL = 'NL',
}

export enum StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferRequestedAddressType {
  Aba = 'aba',
  Iban = 'iban',
  Sepa = 'sepa',
  SortCode = 'sort_code',
  Spei = 'spei',
  Swift = 'swift',
  Zengin = 'zengin',
}

export enum StripePaymentIntentPaymentMethodOptionsCustomerBalanceBankTransferType {
  EuBankTransfer = 'eu_bank_transfer',
  GbBankTransfer = 'gb_bank_transfer',
  JpBankTransfer = 'jp_bank_transfer',
  MxBankTransfer = 'mx_bank_transfer',
  UsBankTransfer = 'us_bank_transfer',
}

export interface StripePaymentIntentPaymentMethodOptionsEps {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsFpx {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsGiropay {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsGrabpay {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsIdeal {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsIdealSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsIdealSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
}

export type StripePaymentIntentPaymentMethodOptionsInteracPresent = object;

export interface StripePaymentIntentPaymentMethodOptionsKlarna {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /** Preferred locale of the Klarna checkout page that the customer is redirected to. */
  preferred_locale: string | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsKonbini {
  /** An optional 10 to 11 digit numeric-only string determining the confirmation code at applicable convenience stores. */
  confirmation_number: string | null;
  /** The number of calendar days (between 1 and 60) after which Konbini payment instructions will expire. For example, if a PaymentIntent is confirmed with Konbini and `expires_after_days` set to 2 on Monday JST, the instructions will expire on Wednesday 23:59:59 JST. */
  expires_after_days: number | null;
  /** The timestamp at which the Konbini payment instructions will expire. Only one of `expires_after_days` or `expires_at` may be set. */
  expires_at: number | null;
  /** A product descriptor of up to 22 characters, which will appear to customers at the convenience store. */
  product_description: string | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsLink {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /** Token used for persistent Link logins. */
  persistent_token: string | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsLinkSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsLinkSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
}

export interface StripePaymentIntentPaymentMethodOptionsOxxo {
  /** The number of calendar days before an OXXO invoice expires. For example, if you create an OXXO invoice on Monday and you set expires_after_days to 2, the OXXO invoice will expire on Wednesday at 23:59 America/Mexico_City time. */
  expires_after_days: number;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsP24 {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsPaynow {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsPaypal {
  /** Controls when the funds will be captured from the customer's account. */
  capture_method?: 'manual';
  /** Preferred locale of the PayPal checkout page that the customer is redirected to. */
  preferred_locale: string | null;
  /** A reference of the PayPal transaction visible to customer which is mapped to PayPal's invoice ID. This must be a globally unique ID if you have configured in your PayPal settings to block multiple payments per invoice ID. */
  reference?: string | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsPaypalSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsPaypalSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
}

export interface StripePaymentIntentPaymentMethodOptionsPix {
  /** The number of seconds (between 10 and 1209600) after which Pix payment will expire. */
  expires_after_seconds: number | null;
  /** The timestamp at which the Pix expires. */
  expires_at: number | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsPromptpay {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentPaymentMethodOptionsSepaDebit {
  mandate_options?: StripePaymentIntentPaymentMethodOptionsSepaDebitMandateOptions;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsSepaDebitSetupFutureUsage;
}

export type StripePaymentIntentPaymentMethodOptionsSepaDebitMandateOptions = object;

export enum StripePaymentIntentPaymentMethodOptionsSepaDebitSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentPaymentMethodOptionsSofort {
  /** Preferred language of the SOFORT authorization page that the customer is redirected to. */
  preferred_language: StripePaymentIntentPaymentMethodOptionsSofortPreferredLanguage | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsSofortSetupFutureUsage;
}

export enum StripePaymentIntentPaymentMethodOptionsSofortPreferredLanguage {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl',
  Pl = 'pl',
}

export enum StripePaymentIntentPaymentMethodOptionsSofortSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
}

export interface StripePaymentIntentPaymentMethodOptionsUsBankAccount {
  financial_connections?: StripePaymentIntentPaymentMethodOptionsUsBankAccountFinancialConnections;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: StripePaymentIntentPaymentMethodOptionsUsBankAccountSetupFutureUsage;
  /** Bank account verification method. */
  verification_method?: StripePaymentIntentPaymentMethodOptionsUsBankAccountVerificationMethod;
}

export interface StripePaymentIntentPaymentMethodOptionsUsBankAccountFinancialConnections {
  /** The list of permissions to request. The `payment_method` permission must be included. */
  permissions?: StripePaymentIntentPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission[];
  /** For webview integrations only. Upon completing OAuth login in the native browser, the user will be redirected to this URL to return to your app. */
  return_url?: string;
}

export enum StripePaymentIntentPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission {
  Balances = 'balances',
  Ownership = 'ownership',
  PaymentMethod = 'payment_method',
  Transactions = 'transactions',
}

export enum StripePaymentIntentPaymentMethodOptionsUsBankAccountSetupFutureUsage {
  None = 'none',
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export enum StripePaymentIntentPaymentMethodOptionsUsBankAccountVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export interface StripePaymentIntentPaymentMethodOptionsWechatPay {
  /** The app ID registered with WeChat Pay. Only required when client is ios or android. */
  app_id: string | null;
  /** The client type that the end customer will pay from */
  client: StripePaymentIntentPaymentMethodOptionsWechatPayClient | null;
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export enum StripePaymentIntentPaymentMethodOptionsWechatPayClient {
  Android = 'android',
  Ios = 'ios',
  Web = 'web',
}

export interface StripePaymentIntentPaymentMethodOptionsZip {
  /**
   * Indicates that you intend to make future payments with this PaymentIntent's payment method.
   *
   * Providing this parameter will [attach the payment method](https://stripe.com/docs/payments/save-during-payment) to the PaymentIntent's Customer, if present, after the PaymentIntent is confirmed and any required actions from the user are complete. If no Customer was provided, the payment method can still be [attached](https://stripe.com/docs/api/payment_methods/attach) to a Customer after the transaction completes.
   *
   * When processing card payments, Stripe also uses `setup_future_usage` to dynamically optimize your payment flow and comply with regional legislation and network rules, such as [SCA](https://stripe.com/docs/strong-customer-authentication).
   */
  setup_future_usage?: 'none';
}

export interface StripePaymentIntentProcessing {
  card?: StripePaymentIntentProcessingCard;
  /** Type of the payment method for which payment is in `processing` state, one of `card`. */
  type: 'card';
}

export interface StripePaymentIntentProcessingCard {
  customer_notification?: StripePaymentIntentProcessingCardCustomerNotification;
}

export interface StripePaymentIntentProcessingCardCustomerNotification {
  /** Whether customer approval has been requested for this payment. For payments greater than INR 15000 or mandate amount, the customer must provide explicit approval of the payment with their bank. */
  approval_requested: boolean | null;
  /** If customer approval is required, they need to provide approval before this time. */
  completes_at: number | null;
}

/**
 * Reviews can be used to supplement automated fraud detection with human expertise.
 *
 * Learn more about [Radar](https://stripe.com/radar) and reviewing payments [here](https://stripe.com/docs/radar/reviews).
 */
export interface StripeReview {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'review';
  /** The ZIP or postal code of the card used, if applicable. */
  billing_zip: string | null;
  /** The charge associated with this review. */
  charge: string | StripeCharge | null;
  /** The reason the review was closed, or null if it has not yet been closed. One of `approved`, `refunded`, `refunded_as_fraud`, `disputed`, or `redacted`. */
  closed_reason: StripeReviewClosedReason | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The IP address where the payment originated. */
  ip_address: string | null;
  /** Information related to the location of the payment. Note that this information is an approximation and attempts to locate the nearest population center - it should not be used to determine a specific address. */
  ip_address_location: StripeReviewIpAddressLocation | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** If `true`, the review needs action. */
  open: boolean;
  /** The reason the review was opened. One of `rule` or `manual`. */
  opened_reason: StripeReviewOpenedReason;
  /** The PaymentIntent ID associated with this review, if one exists. */
  payment_intent?: string | StripePaymentIntent;
  /** The reason the review is currently open or closed. One of `rule`, `manual`, `approved`, `refunded`, `refunded_as_fraud`, `disputed`, or `redacted`. */
  reason: string;
  /** Information related to the browsing session of the user who initiated the payment. */
  session: StripeReviewSession | null;
}

export enum StripeReviewClosedReason {
  Approved = 'approved',
  Disputed = 'disputed',
  Redacted = 'redacted',
  Refunded = 'refunded',
  RefundedAsFraud = 'refunded_as_fraud',
}

export interface StripeReviewIpAddressLocation {
  /** The city where the payment originated. */
  city: string | null;
  /** Two-letter ISO code representing the country where the payment originated. */
  country: string | null;
  /** The geographic latitude where the payment originated. */
  latitude: number | null;
  /** The geographic longitude where the payment originated. */
  longitude: number | null;
  /** The state/county/province/region where the payment originated. */
  region: string | null;
}

export enum StripeReviewOpenedReason {
  Manual = 'manual',
  Rule = 'rule',
}

export interface StripeReviewSession {
  /** The browser used in this browser session (e.g., `Chrome`). */
  browser: string | null;
  /** Information about the device used for the browser session (e.g., `Samsung SM-G930T`). */
  device: string | null;
  /** The platform for the browser session (e.g., `Macintosh`). */
  platform: string | null;
  /** The version for the browser session (e.g., `61.0.3163.100`). */
  version: string | null;
}

export enum StripePaymentIntentSetupFutureUsage {
  OffSession = 'off_session',
  OnSession = 'on_session',
}

export interface StripePaymentIntentShipping {
  /** The Address object. */
  address?: StripeAddress;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. */
  carrier?: string | null;
  /** Recipient name. */
  name?: string;
  /** Recipient phone (including extension). */
  phone?: string | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  tracking_number?: string | null;
}

/** The DeletedBankAccount object. */
export interface StripeDeletedBankAccount {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'bank_account';
  /** Three-letter [ISO code for the currency](https://stripe.com/docs/payouts) paid out to the bank account. */
  currency?: string | null;
  /** Always true for a deleted object */
  deleted: true;
}

/** The DeletedCard object. */
export interface StripeDeletedCard {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'card';
  /** Three-letter [ISO code for the currency](https://stripe.com/docs/payouts) paid out to the bank account. */
  currency?: string | null;
  /** Always true for a deleted object */
  deleted: true;
}

export enum StripePaymentIntentStatus {
  Canceled = 'canceled',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  RequiresCapture = 'requires_capture',
  RequiresConfirmation = 'requires_confirmation',
  RequiresPaymentMethod = 'requires_payment_method',
  Succeeded = 'succeeded',
}

export interface StripePaymentIntentTransferData {
  /** Amount intended to be collected by this PaymentIntent. A positive integer representing how much to charge in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal) (e.g., 100 cents to charge $1.00 or 100 to charge ¥100, a zero-decimal currency). The minimum amount is $0.50 US or [equivalent in charge currency](https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts). The amount value supports up to eight digits (e.g., a value of 99999999 for a USD charge of $999,999.99). */
  amount?: number;
  /** The account (if any) the payment will be attributed to for tax reporting, and where funds from the payment will be transferred to upon payment success. */
  destination: string | StripeAccount;
}

export enum StripeDisputeStatus {
  ChargeRefunded = 'charge_refunded',
  Lost = 'lost',
  NeedsResponse = 'needs_response',
  UnderReview = 'under_review',
  WarningClosed = 'warning_closed',
  WarningNeedsResponse = 'warning_needs_response',
  WarningUnderReview = 'warning_under_review',
  Won = 'won',
}

/**
 * `Application Fee Refund` objects allow you to refund an application fee that has previously been created but not yet refunded. Funds will be refunded to the Stripe account from which the fee was originally collected.
 *
 * Related guide: [Refunding application fees](https://stripe.com/docs/connect/destination-charges#refunding-app-fee)
 */
export interface StripeFeeRefund {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'fee_refund';
  /** Amount, in %s. */
  amount: number;
  /** Balance transaction that describes the impact on your account balance. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** ID of the application fee that was refunded. */
  fee: string | StripeApplicationFee;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
}

/**
 * When an [issued card](https://stripe.com/docs/issuing) is used to make a purchase, an Issuing `Authorization` object is created. [Authorizations](https://stripe.com/docs/issuing/purchases/authorizations) must be approved for the purchase to be completed successfully.
 *
 * Related guide: [Issued card authorizations](https://stripe.com/docs/issuing/purchases/authorizations)
 */
export interface StripeIssuingAuthorization {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'issuing.authorization';
  /** The total amount that was authorized or rejected. This amount is in the card's currency and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount: number;
  /** Detailed breakdown of amount components. These amounts are denominated in `currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount_details: StripeIssuingAuthorizationAmountDetails | null;
  /** Whether the authorization has been approved. */
  approved: boolean;
  /** How the card details were provided. */
  authorization_method: StripeIssuingAuthorizationAuthorizationMethod;
  /** List of balance transactions associated with this authorization. */
  balance_transactions: StripeBalanceTransaction[];
  /** You can [create physical or virtual cards](https://stripe.com/docs/issuing/cards) that are issued to cardholders. */
  card: StripeIssuingCard;
  /** The cardholder to whom this authorization belongs. */
  cardholder: string | StripeIssuingCardholder | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** The total amount that was authorized or rejected. This amount is in the `merchant_currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  merchant_amount: number;
  /** The currency that was presented to the cardholder for the authorization. Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  merchant_currency: string;
  merchant_data: StripeIssuingAuthorizationMerchantData;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** Details about the authorization, such as identifiers, set by the card network. */
  network_data: StripeIssuingAuthorizationNetworkData | null;
  /** The pending authorization request. This field will only be non-null during an `issuing_authorization.request` webhook. */
  pending_request: StripeIssuingAuthorizationPendingRequest | null;
  /** History of every time a `pending_request` authorization was approved/declined, either by you directly or by Stripe (e.g. based on your spending_controls). If the merchant changes the authorization by performing an incremental authorization, you can look at this field to see the previous requests for the authorization. This field can be helpful in determining why a given authorization was approved/declined. */
  request_history: StripeIssuingAuthorizationRequestHistory[];
  /** The current status of the authorization in its lifecycle. */
  status: StripeIssuingAuthorizationStatus;
  /** List of [transactions](https://stripe.com/docs/api/issuing/transactions) associated with this authorization. */
  transactions: StripeIssuingTransaction[];
  /** [Treasury](https://stripe.com/docs/api/treasury) details related to this authorization if it was created on a [FinancialAccount](https://stripe.com/docs/api/treasury/financial_accounts). */
  treasury?: StripeIssuingAuthorizationTreasury | null;
  verification_data: StripeIssuingAuthorizationVerificationData;
  /** The digital wallet used for this transaction. One of `apple_pay`, `google_pay`, or `samsung_pay`. Will populate as `null` when no digital wallet was utilized. */
  wallet: string | null;
}

export interface StripeIssuingAuthorizationAmountDetails {
  /** The fee charged by the ATM for the cash withdrawal. */
  atm_fee: number | null;
}

export enum StripeIssuingAuthorizationAuthorizationMethod {
  Chip = 'chip',
  Contactless = 'contactless',
  KeyedIn = 'keyed_in',
  Online = 'online',
  Swipe = 'swipe',
}

/** You can [create physical or virtual cards](https://stripe.com/docs/issuing/cards) that are issued to cardholders. */
export interface StripeIssuingCard {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'issuing.card';
  /** The brand of the card. */
  brand: string;
  /** The reason why the card was canceled. */
  cancellation_reason: StripeIssuingCardCancellationReason | null;
  /**
   * An Issuing `Cardholder` object represents an individual or business entity who is [issued](https://stripe.com/docs/issuing) cards.
   *
   * Related guide: [How to create a cardholder](https://stripe.com/docs/issuing/cards#create-cardholder)
   */
  cardholder: StripeIssuingCardholder;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Supported currencies are `usd` in the US, `eur` in the EU, and `gbp` in the UK. */
  currency: string;
  /** The card's CVC. For security reasons, this is only available for virtual cards, and will be omitted unless you explicitly request it with [the `expand` parameter](https://stripe.com/docs/api/expanding_objects). Additionally, it's only available via the ["Retrieve a card" endpoint](https://stripe.com/docs/api/issuing/cards/retrieve), not via "List all cards" or any other endpoint. */
  cvc?: string;
  /** The expiration month of the card. */
  exp_month: number;
  /** The expiration year of the card. */
  exp_year: number;
  /** The financial account this card is attached to. */
  financial_account?: string | null;
  /** The last 4 digits of the card number. */
  last4: string;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** The full unredacted card number. For security reasons, this is only available for virtual cards, and will be omitted unless you explicitly request it with [the `expand` parameter](https://stripe.com/docs/api/expanding_objects). Additionally, it's only available via the ["Retrieve a card" endpoint](https://stripe.com/docs/api/issuing/cards/retrieve), not via "List all cards" or any other endpoint. */
  number?: string;
  /** The latest card that replaces this card, if any. */
  replaced_by: string | StripeIssuingCard | null;
  /** The card this card replaces, if any. */
  replacement_for: string | StripeIssuingCard | null;
  /** The reason why the previous card needed to be replaced. */
  replacement_reason: StripeIssuingCardReplacementReason | null;
  /** Where and how the card will be shipped. */
  shipping: StripeIssuingCardShipping | null;
  spending_controls: StripeIssuingCardSpendingControls;
  /** Whether authorizations can be approved on this card. May be blocked from activating cards depending on past-due Cardholder requirements. Defaults to `inactive`. */
  status: StripeIssuingCardStatus;
  /** The type of the card. */
  type: StripeIssuingCardType;
  /** Information relating to digital wallets (like Apple Pay and Google Pay). */
  wallets: StripeIssuingCardWallets | null;
}

export enum StripeIssuingCardCancellationReason {
  DesignRejected = 'design_rejected',
  Lost = 'lost',
  Stolen = 'stolen',
}

/**
 * An Issuing `Cardholder` object represents an individual or business entity who is [issued](https://stripe.com/docs/issuing) cards.
 *
 * Related guide: [How to create a cardholder](https://stripe.com/docs/issuing/cards#create-cardholder)
 */
export interface StripeIssuingCardholder {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'issuing.cardholder';
  billing: StripeIssuingCardholderBilling;
  /** Additional information about a `company` cardholder. */
  company: StripeIssuingCardholderCompany | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The cardholder's email address. */
  email: string | null;
  /** Additional information about an `individual` cardholder. */
  individual: StripeIssuingCardholderIndividual | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** The cardholder's name. This will be printed on cards issued to them. */
  name: string;
  /** The cardholder's phone number. This is required for all cardholders who will be creating EU cards. See the [3D Secure documentation](https://stripe.com/docs/issuing/3d-secure#when-is-3d-secure-applied) for more details. */
  phone_number: string | null;
  /** The cardholder's preferred locales (languages), ordered by preference. Locales can be `de`, `en`, `es`, `fr`, or `it`.  This changes the language of the [3D Secure flow](https://stripe.com/docs/issuing/3d-secure) and one-time password messages sent to the cardholder. */
  preferred_locales: StripeIssuingCardholderPreferredLocale[] | null;
  requirements: StripeIssuingCardholderRequirements;
  /** Rules that control spending across this cardholder's cards. Refer to our [documentation](https://stripe.com/docs/issuing/controls/spending-controls) for more details. */
  spending_controls: StripeIssuingCardholderSpendingControls | null;
  /** Specifies whether to permit authorizations on this cardholder's cards. */
  status: StripeIssuingCardholderStatus;
  /** One of `individual` or `company`. See [Choose a cardholder type](https://stripe.com/docs/issuing/other/choose-cardholder) for more details. */
  type: StripeIssuingCardholderType;
}

export interface StripeIssuingCardholderBilling {
  /** The Address object. */
  address: StripeAddress;
}

export interface StripeIssuingCardholderCompany {
  /** Whether the company's business ID number was provided. */
  tax_id_provided: boolean;
}

export interface StripeIssuingCardholderIndividual {
  /** Information related to the card_issuing program for this cardholder. */
  card_issuing: StripeIssuingCardholderIndividualCardIssuing | null;
  /** The date of birth of this cardholder. */
  dob: StripeIssuingCardholderIndividualDob | null;
  /** The first name of this cardholder. Required before activating Cards. This field cannot contain any numbers, special characters (except periods, commas, hyphens, spaces and apostrophes) or non-latin letters. */
  first_name: string | null;
  /** The last name of this cardholder. Required before activating Cards. This field cannot contain any numbers, special characters (except periods, commas, hyphens, spaces and apostrophes) or non-latin letters. */
  last_name: string | null;
  /** Government-issued ID document for this cardholder. */
  verification: StripeIssuingCardholderIndividualVerification | null;
}

export interface StripeIssuingCardholderIndividualCardIssuing {
  /** Information about cardholder acceptance of [Authorized User Terms](https://stripe.com/docs/issuing/cards). */
  user_terms_acceptance: StripeIssuingCardholderIndividualCardIssuingUserTermsAcceptance | null;
}

export interface StripeIssuingCardholderIndividualCardIssuingUserTermsAcceptance {
  /** The Unix timestamp marking when the cardholder accepted the Authorized User Terms. Required for Celtic Spend Card users. */
  date: number | null;
  /** The IP address from which the cardholder accepted the Authorized User Terms. Required for Celtic Spend Card users. */
  ip: string | null;
  /** The user agent of the browser from which the cardholder accepted the Authorized User Terms. */
  user_agent: string | null;
}

export interface StripeIssuingCardholderIndividualDob {
  /** The day of birth, between 1 and 31. */
  day: number | null;
  /** The month of birth, between 1 and 12. */
  month: number | null;
  /** The four-digit year of birth. */
  year: number | null;
}

export interface StripeIssuingCardholderIndividualVerification {
  /** An identifying document, either a passport or local ID card. */
  document: StripeIssuingCardholderIndividualVerificationDocument | null;
}

export interface StripeIssuingCardholderIndividualVerificationDocument {
  /** The back of a document returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `identity_document`. */
  back: string | StripeFile | null;
  /** The front of a document returned by a [file upload](https://stripe.com/docs/api#create_file) with a `purpose` value of `identity_document`. */
  front: string | StripeFile | null;
}

export enum StripeIssuingCardholderPreferredLocale {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
}

export interface StripeIssuingCardholderRequirements {
  /** If `disabled_reason` is present, all cards will decline authorizations with `cardholder_verification_required` reason. */
  disabled_reason: StripeIssuingCardholderRequirementsDisabledReason | null;
  /** Array of fields that need to be collected in order to verify and re-enable the cardholder. */
  past_due: StripeIssuingCardholderRequirementsPastDue[] | null;
}

export enum StripeIssuingCardholderRequirementsDisabledReason {
  Listed = 'listed',
  RejectedListed = 'rejected.listed',
  RequirementsPastDue = 'requirements.past_due',
  UnderReview = 'under_review',
}

export enum StripeIssuingCardholderRequirementsPastDue {
  CompanyTaxId = 'company.tax_id',
  IndividualCardIssuingUserTermsAcceptanceDate = 'individual.card_issuing.user_terms_acceptance.date',
  IndividualCardIssuingUserTermsAcceptanceIp = 'individual.card_issuing.user_terms_acceptance.ip',
  IndividualDobDay = 'individual.dob.day',
  IndividualDobMonth = 'individual.dob.month',
  IndividualDobYear = 'individual.dob.year',
  IndividualFirstName = 'individual.first_name',
  IndividualLastName = 'individual.last_name',
  IndividualVerificationDocument = 'individual.verification.document',
}

export interface StripeIssuingCardholderSpendingControls {
  /** Array of strings containing [categories](https://stripe.com/docs/api#issuing_authorization_object-merchant_data-category) of authorizations to allow. All other categories will be blocked. Cannot be set with `blocked_categories`. */
  allowed_categories: StripeIssuingCardholderSpendingControlsAllowedCategory[] | null;
  /** Array of strings containing [categories](https://stripe.com/docs/api#issuing_authorization_object-merchant_data-category) of authorizations to decline. All other categories will be allowed. Cannot be set with `allowed_categories`. */
  blocked_categories: StripeIssuingCardholderSpendingControlsBlockedCategory[] | null;
  /** Limit spending with amount-based rules that apply across this cardholder's cards. */
  spending_limits: StripeIssuingCardholderSpendingControlsSpendingLimit[] | null;
  /** Currency of the amounts within `spending_limits`. */
  spending_limits_currency: string | null;
}

export enum StripeIssuingCardholderSpendingControlsAllowedCategory {
  AcRefrigerationRepair = 'ac_refrigeration_repair',
  AccountingBookkeepingServices = 'accounting_bookkeeping_services',
  AdvertisingServices = 'advertising_services',
  AgriculturalCooperative = 'agricultural_cooperative',
  AirlinesAirCarriers = 'airlines_air_carriers',
  AirportsFlyingFields = 'airports_flying_fields',
  AmbulanceServices = 'ambulance_services',
  AmusementParksCarnivals = 'amusement_parks_carnivals',
  AntiqueReproductions = 'antique_reproductions',
  AntiqueShops = 'antique_shops',
  Aquariums = 'aquariums',
  ArchitecturalSurveyingServices = 'architectural_surveying_services',
  ArtDealersAndGalleries = 'art_dealers_and_galleries',
  ArtistsSupplyAndCraftShops = 'artists_supply_and_craft_shops',
  AutoAndHomeSupplyStores = 'auto_and_home_supply_stores',
  AutoBodyRepairShops = 'auto_body_repair_shops',
  AutoPaintShops = 'auto_paint_shops',
  AutoServiceShops = 'auto_service_shops',
  AutomatedCashDisburse = 'automated_cash_disburse',
  AutomatedFuelDispensers = 'automated_fuel_dispensers',
  AutomobileAssociations = 'automobile_associations',
  AutomotivePartsAndAccessoriesStores = 'automotive_parts_and_accessories_stores',
  AutomotiveTireStores = 'automotive_tire_stores',
  BailAndBondPayments = 'bail_and_bond_payments',
  Bakeries = 'bakeries',
  BandsOrchestras = 'bands_orchestras',
  BarberAndBeautyShops = 'barber_and_beauty_shops',
  BettingCasinoGambling = 'betting_casino_gambling',
  BicycleShops = 'bicycle_shops',
  BilliardPoolEstablishments = 'billiard_pool_establishments',
  BoatDealers = 'boat_dealers',
  BoatRentalsAndLeases = 'boat_rentals_and_leases',
  BookStores = 'book_stores',
  BooksPeriodicalsAndNewspapers = 'books_periodicals_and_newspapers',
  BowlingAlleys = 'bowling_alleys',
  BusLines = 'bus_lines',
  BusinessSecretarialSchools = 'business_secretarial_schools',
  BuyingShoppingServices = 'buying_shopping_services',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'cable_satellite_and_other_pay_television_and_radio',
  CameraAndPhotographicSupplyStores = 'camera_and_photographic_supply_stores',
  CandyNutAndConfectioneryStores = 'candy_nut_and_confectionery_stores',
  CarAndTruckDealersNewUsed = 'car_and_truck_dealers_new_used',
  CarAndTruckDealersUsedOnly = 'car_and_truck_dealers_used_only',
  CarRentalAgencies = 'car_rental_agencies',
  CarWashes = 'car_washes',
  CarpentryServices = 'carpentry_services',
  CarpetUpholsteryCleaning = 'carpet_upholstery_cleaning',
  Caterers = 'caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'charitable_and_social_service_organizations_fundraising',
  ChemicalsAndAlliedProducts = 'chemicals_and_allied_products',
  ChildCareServices = 'child_care_services',
  ChildrensAndInfantsWearStores = 'childrens_and_infants_wear_stores',
  ChiropodistsPodiatrists = 'chiropodists_podiatrists',
  Chiropractors = 'chiropractors',
  CigarStoresAndStands = 'cigar_stores_and_stands',
  CivicSocialFraternalAssociations = 'civic_social_fraternal_associations',
  CleaningAndMaintenance = 'cleaning_and_maintenance',
  ClothingRental = 'clothing_rental',
  CollegesUniversities = 'colleges_universities',
  CommercialEquipment = 'commercial_equipment',
  CommercialFootwear = 'commercial_footwear',
  CommercialPhotographyArtAndGraphics = 'commercial_photography_art_and_graphics',
  CommuterTransportAndFerries = 'commuter_transport_and_ferries',
  ComputerNetworkServices = 'computer_network_services',
  ComputerProgramming = 'computer_programming',
  ComputerRepair = 'computer_repair',
  ComputerSoftwareStores = 'computer_software_stores',
  ComputersPeripheralsAndSoftware = 'computers_peripherals_and_software',
  ConcreteWorkServices = 'concrete_work_services',
  ConstructionMaterials = 'construction_materials',
  ConsultingPublicRelations = 'consulting_public_relations',
  CorrespondenceSchools = 'correspondence_schools',
  CosmeticStores = 'cosmetic_stores',
  CounselingServices = 'counseling_services',
  CountryClubs = 'country_clubs',
  CourierServices = 'courier_services',
  CourtCosts = 'court_costs',
  CreditReportingAgencies = 'credit_reporting_agencies',
  CruiseLines = 'cruise_lines',
  DairyProductsStores = 'dairy_products_stores',
  DanceHallStudiosSchools = 'dance_hall_studios_schools',
  DatingEscortServices = 'dating_escort_services',
  DentistsOrthodontists = 'dentists_orthodontists',
  DepartmentStores = 'department_stores',
  DetectiveAgencies = 'detective_agencies',
  DigitalGoodsApplications = 'digital_goods_applications',
  DigitalGoodsGames = 'digital_goods_games',
  DigitalGoodsLargeVolume = 'digital_goods_large_volume',
  DigitalGoodsMedia = 'digital_goods_media',
  DirectMarketingCatalogMerchant = 'direct_marketing_catalog_merchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'direct_marketing_combination_catalog_and_retail_merchant',
  DirectMarketingInboundTelemarketing = 'direct_marketing_inbound_telemarketing',
  DirectMarketingInsuranceServices = 'direct_marketing_insurance_services',
  DirectMarketingOther = 'direct_marketing_other',
  DirectMarketingOutboundTelemarketing = 'direct_marketing_outbound_telemarketing',
  DirectMarketingSubscription = 'direct_marketing_subscription',
  DirectMarketingTravel = 'direct_marketing_travel',
  DiscountStores = 'discount_stores',
  Doctors = 'doctors',
  DoorToDoorSales = 'door_to_door_sales',
  DraperyWindowCoveringAndUpholsteryStores = 'drapery_window_covering_and_upholstery_stores',
  DrinkingPlaces = 'drinking_places',
  DrugStoresAndPharmacies = 'drug_stores_and_pharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'drugs_drug_proprietaries_and_druggist_sundries',
  DryCleaners = 'dry_cleaners',
  DurableGoods = 'durable_goods',
  DutyFreeStores = 'duty_free_stores',
  EatingPlacesRestaurants = 'eating_places_restaurants',
  EducationalServices = 'educational_services',
  ElectricRazorStores = 'electric_razor_stores',
  ElectricVehicleCharging = 'electric_vehicle_charging',
  ElectricalPartsAndEquipment = 'electrical_parts_and_equipment',
  ElectricalServices = 'electrical_services',
  ElectronicsRepairShops = 'electronics_repair_shops',
  ElectronicsStores = 'electronics_stores',
  ElementarySecondarySchools = 'elementary_secondary_schools',
  EmergencyServicesGcasVisaUseOnly = 'emergency_services_gcas_visa_use_only',
  EmploymentTempAgencies = 'employment_temp_agencies',
  EquipmentRental = 'equipment_rental',
  ExterminatingServices = 'exterminating_services',
  FamilyClothingStores = 'family_clothing_stores',
  FastFoodRestaurants = 'fast_food_restaurants',
  FinancialInstitutions = 'financial_institutions',
  FinesGovernmentAdministrativeEntities = 'fines_government_administrative_entities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'fireplace_fireplace_screens_and_accessories_stores',
  FloorCoveringStores = 'floor_covering_stores',
  Florists = 'florists',
  FloristsSuppliesNurseryStockAndFlowers = 'florists_supplies_nursery_stock_and_flowers',
  FreezerAndLockerMeatProvisioners = 'freezer_and_locker_meat_provisioners',
  FuelDealersNonAutomotive = 'fuel_dealers_non_automotive',
  FuneralServicesCrematories = 'funeral_services_crematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'furniture_home_furnishings_and_equipment_stores_except_appliances',
  FurnitureRepairRefinishing = 'furniture_repair_refinishing',
  FurriersAndFurShops = 'furriers_and_fur_shops',
  GeneralServices = 'general_services',
  GiftCardNoveltyAndSouvenirShops = 'gift_card_novelty_and_souvenir_shops',
  GlassPaintAndWallpaperStores = 'glass_paint_and_wallpaper_stores',
  GlasswareCrystalStores = 'glassware_crystal_stores',
  GolfCoursesPublic = 'golf_courses_public',
  GovernmentLicensedHorseDogRacingUsRegionOnly = 'government_licensed_horse_dog_racing_us_region_only',
  GovernmentLicensedOnlineCasionsOnlineGamblingUsRegionOnly = 'government_licensed_online_casions_online_gambling_us_region_only',
  GovernmentOwnedLotteriesNonUsRegion = 'government_owned_lotteries_non_us_region',
  GovernmentOwnedLotteriesUsRegionOnly = 'government_owned_lotteries_us_region_only',
  GovernmentServices = 'government_services',
  GroceryStoresSupermarkets = 'grocery_stores_supermarkets',
  HardwareEquipmentAndSupplies = 'hardware_equipment_and_supplies',
  HardwareStores = 'hardware_stores',
  HealthAndBeautySpas = 'health_and_beauty_spas',
  HearingAidsSalesAndSupplies = 'hearing_aids_sales_and_supplies',
  HeatingPlumbingAC = 'heating_plumbing_a_c',
  HobbyToyAndGameShops = 'hobby_toy_and_game_shops',
  HomeSupplyWarehouseStores = 'home_supply_warehouse_stores',
  Hospitals = 'hospitals',
  HotelsMotelsAndResorts = 'hotels_motels_and_resorts',
  HouseholdApplianceStores = 'household_appliance_stores',
  IndustrialSupplies = 'industrial_supplies',
  InformationRetrievalServices = 'information_retrieval_services',
  InsuranceDefault = 'insurance_default',
  InsuranceUnderwritingPremiums = 'insurance_underwriting_premiums',
  IntraCompanyPurchases = 'intra_company_purchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'jewelry_stores_watches_clocks_and_silverware_stores',
  LandscapingServices = 'landscaping_services',
  Laundries = 'laundries',
  LaundryCleaningServices = 'laundry_cleaning_services',
  LegalServicesAttorneys = 'legal_services_attorneys',
  LuggageAndLeatherGoodsStores = 'luggage_and_leather_goods_stores',
  LumberBuildingMaterialsStores = 'lumber_building_materials_stores',
  ManualCashDisburse = 'manual_cash_disburse',
  MarinasServiceAndSupplies = 'marinas_service_and_supplies',
  Marketplaces = 'marketplaces',
  MasonryStoneworkAndPlaster = 'masonry_stonework_and_plaster',
  MassageParlors = 'massage_parlors',
  MedicalAndDentalLabs = 'medical_and_dental_labs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
  MedicalServices = 'medical_services',
  MembershipOrganizations = 'membership_organizations',
  MensAndBoysClothingAndAccessoriesStores = 'mens_and_boys_clothing_and_accessories_stores',
  MensWomensClothingStores = 'mens_womens_clothing_stores',
  MetalServiceCenters = 'metal_service_centers',
  Miscellaneous = 'miscellaneous',
  MiscellaneousApparelAndAccessoryShops = 'miscellaneous_apparel_and_accessory_shops',
  MiscellaneousAutoDealers = 'miscellaneous_auto_dealers',
  MiscellaneousBusinessServices = 'miscellaneous_business_services',
  MiscellaneousFoodStores = 'miscellaneous_food_stores',
  MiscellaneousGeneralMerchandise = 'miscellaneous_general_merchandise',
  MiscellaneousGeneralServices = 'miscellaneous_general_services',
  MiscellaneousHomeFurnishingSpecialtyStores = 'miscellaneous_home_furnishing_specialty_stores',
  MiscellaneousPublishingAndPrinting = 'miscellaneous_publishing_and_printing',
  MiscellaneousRecreationServices = 'miscellaneous_recreation_services',
  MiscellaneousRepairShops = 'miscellaneous_repair_shops',
  MiscellaneousSpecialtyRetail = 'miscellaneous_specialty_retail',
  MobileHomeDealers = 'mobile_home_dealers',
  MotionPictureTheaters = 'motion_picture_theaters',
  MotorFreightCarriersAndTrucking = 'motor_freight_carriers_and_trucking',
  MotorHomesDealers = 'motor_homes_dealers',
  MotorVehicleSuppliesAndNewParts = 'motor_vehicle_supplies_and_new_parts',
  MotorcycleShopsAndDealers = 'motorcycle_shops_and_dealers',
  MotorcycleShopsDealers = 'motorcycle_shops_dealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'music_stores_musical_instruments_pianos_and_sheet_music',
  NewsDealersAndNewsstands = 'news_dealers_and_newsstands',
  NonFiMoneyOrders = 'non_fi_money_orders',
  NonFiStoredValueCardPurchaseLoad = 'non_fi_stored_value_card_purchase_load',
  NondurableGoods = 'nondurable_goods',
  NurseriesLawnAndGardenSupplyStores = 'nurseries_lawn_and_garden_supply_stores',
  NursingPersonalCare = 'nursing_personal_care',
  OfficeAndCommercialFurniture = 'office_and_commercial_furniture',
  OpticiansEyeglasses = 'opticians_eyeglasses',
  OptometristsOphthalmologist = 'optometrists_ophthalmologist',
  OrthopedicGoodsProstheticDevices = 'orthopedic_goods_prosthetic_devices',
  Osteopaths = 'osteopaths',
  PackageStoresBeerWineAndLiquor = 'package_stores_beer_wine_and_liquor',
  PaintsVarnishesAndSupplies = 'paints_varnishes_and_supplies',
  ParkingLotsGarages = 'parking_lots_garages',
  PassengerRailways = 'passenger_railways',
  PawnShops = 'pawn_shops',
  PetShopsPetFoodAndSupplies = 'pet_shops_pet_food_and_supplies',
  PetroleumAndPetroleumProducts = 'petroleum_and_petroleum_products',
  PhotoDeveloping = 'photo_developing',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'photographic_photocopy_microfilm_equipment_and_supplies',
  PhotographicStudios = 'photographic_studios',
  PictureVideoProduction = 'picture_video_production',
  PieceGoodsNotionsAndOtherDryGoods = 'piece_goods_notions_and_other_dry_goods',
  PlumbingHeatingEquipmentAndSupplies = 'plumbing_heating_equipment_and_supplies',
  PoliticalOrganizations = 'political_organizations',
  PostalServicesGovernmentOnly = 'postal_services_government_only',
  PreciousStonesAndMetalsWatchesAndJewelry = 'precious_stones_and_metals_watches_and_jewelry',
  ProfessionalServices = 'professional_services',
  PublicWarehousingAndStorage = 'public_warehousing_and_storage',
  QuickCopyReproAndBlueprint = 'quick_copy_repro_and_blueprint',
  Railroads = 'railroads',
  RealEstateAgentsAndManagersRentals = 'real_estate_agents_and_managers_rentals',
  RecordStores = 'record_stores',
  RecreationalVehicleRentals = 'recreational_vehicle_rentals',
  ReligiousGoodsStores = 'religious_goods_stores',
  ReligiousOrganizations = 'religious_organizations',
  RoofingSidingSheetMetal = 'roofing_siding_sheet_metal',
  SecretarialSupportServices = 'secretarial_support_services',
  SecurityBrokersDealers = 'security_brokers_dealers',
  ServiceStations = 'service_stations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'sewing_needlework_fabric_and_piece_goods_stores',
  ShoeRepairHatCleaning = 'shoe_repair_hat_cleaning',
  ShoeStores = 'shoe_stores',
  SmallApplianceRepair = 'small_appliance_repair',
  SnowmobileDealers = 'snowmobile_dealers',
  SpecialTradeServices = 'special_trade_services',
  SpecialtyCleaning = 'specialty_cleaning',
  SportingGoodsStores = 'sporting_goods_stores',
  SportingRecreationCamps = 'sporting_recreation_camps',
  SportsAndRidingApparelStores = 'sports_and_riding_apparel_stores',
  SportsClubsFields = 'sports_clubs_fields',
  StampAndCoinStores = 'stamp_and_coin_stores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'stationary_office_supplies_printing_and_writing_paper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'stationery_stores_office_and_school_supply_stores',
  SwimmingPoolsSales = 'swimming_pools_sales',
  TUiTravelGermany = 't_ui_travel_germany',
  TailorsAlterations = 'tailors_alterations',
  TaxPaymentsGovernmentAgencies = 'tax_payments_government_agencies',
  TaxPreparationServices = 'tax_preparation_services',
  TaxicabsLimousines = 'taxicabs_limousines',
  TelecommunicationEquipmentAndTelephoneSales = 'telecommunication_equipment_and_telephone_sales',
  TelecommunicationServices = 'telecommunication_services',
  TelegraphServices = 'telegraph_services',
  TentAndAwningShops = 'tent_and_awning_shops',
  TestingLaboratories = 'testing_laboratories',
  TheatricalTicketAgencies = 'theatrical_ticket_agencies',
  Timeshares = 'timeshares',
  TireRetreadingAndRepair = 'tire_retreading_and_repair',
  TollsBridgeFees = 'tolls_bridge_fees',
  TouristAttractionsAndExhibits = 'tourist_attractions_and_exhibits',
  TowingServices = 'towing_services',
  TrailerParksCampgrounds = 'trailer_parks_campgrounds',
  TransportationServices = 'transportation_services',
  TravelAgenciesTourOperators = 'travel_agencies_tour_operators',
  TruckStopIteration = 'truck_stop_iteration',
  TruckUtilityTrailerRentals = 'truck_utility_trailer_rentals',
  TypesettingPlateMakingAndRelatedServices = 'typesetting_plate_making_and_related_services',
  TypewriterStores = 'typewriter_stores',
  USFederalGovernmentAgenciesOrDepartments = 'u_s_federal_government_agencies_or_departments',
  UniformsCommercialClothing = 'uniforms_commercial_clothing',
  UsedMerchandiseAndSecondhandStores = 'used_merchandise_and_secondhand_stores',
  Utilities = 'utilities',
  VarietyStores = 'variety_stores',
  VeterinaryServices = 'veterinary_services',
  VideoAmusementGameSupplies = 'video_amusement_game_supplies',
  VideoGameArcades = 'video_game_arcades',
  VideoTapeRentalStores = 'video_tape_rental_stores',
  VocationalTradeSchools = 'vocational_trade_schools',
  WatchJewelryRepair = 'watch_jewelry_repair',
  WeldingRepair = 'welding_repair',
  WholesaleClubs = 'wholesale_clubs',
  WigAndToupeeStores = 'wig_and_toupee_stores',
  WiresMoneyOrders = 'wires_money_orders',
  WomensAccessoryAndSpecialtyShops = 'womens_accessory_and_specialty_shops',
  WomensReadyToWearStores = 'womens_ready_to_wear_stores',
  WreckingAndSalvageYards = 'wrecking_and_salvage_yards',
}

export enum StripeIssuingCardholderSpendingControlsBlockedCategory {
  AcRefrigerationRepair = 'ac_refrigeration_repair',
  AccountingBookkeepingServices = 'accounting_bookkeeping_services',
  AdvertisingServices = 'advertising_services',
  AgriculturalCooperative = 'agricultural_cooperative',
  AirlinesAirCarriers = 'airlines_air_carriers',
  AirportsFlyingFields = 'airports_flying_fields',
  AmbulanceServices = 'ambulance_services',
  AmusementParksCarnivals = 'amusement_parks_carnivals',
  AntiqueReproductions = 'antique_reproductions',
  AntiqueShops = 'antique_shops',
  Aquariums = 'aquariums',
  ArchitecturalSurveyingServices = 'architectural_surveying_services',
  ArtDealersAndGalleries = 'art_dealers_and_galleries',
  ArtistsSupplyAndCraftShops = 'artists_supply_and_craft_shops',
  AutoAndHomeSupplyStores = 'auto_and_home_supply_stores',
  AutoBodyRepairShops = 'auto_body_repair_shops',
  AutoPaintShops = 'auto_paint_shops',
  AutoServiceShops = 'auto_service_shops',
  AutomatedCashDisburse = 'automated_cash_disburse',
  AutomatedFuelDispensers = 'automated_fuel_dispensers',
  AutomobileAssociations = 'automobile_associations',
  AutomotivePartsAndAccessoriesStores = 'automotive_parts_and_accessories_stores',
  AutomotiveTireStores = 'automotive_tire_stores',
  BailAndBondPayments = 'bail_and_bond_payments',
  Bakeries = 'bakeries',
  BandsOrchestras = 'bands_orchestras',
  BarberAndBeautyShops = 'barber_and_beauty_shops',
  BettingCasinoGambling = 'betting_casino_gambling',
  BicycleShops = 'bicycle_shops',
  BilliardPoolEstablishments = 'billiard_pool_establishments',
  BoatDealers = 'boat_dealers',
  BoatRentalsAndLeases = 'boat_rentals_and_leases',
  BookStores = 'book_stores',
  BooksPeriodicalsAndNewspapers = 'books_periodicals_and_newspapers',
  BowlingAlleys = 'bowling_alleys',
  BusLines = 'bus_lines',
  BusinessSecretarialSchools = 'business_secretarial_schools',
  BuyingShoppingServices = 'buying_shopping_services',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'cable_satellite_and_other_pay_television_and_radio',
  CameraAndPhotographicSupplyStores = 'camera_and_photographic_supply_stores',
  CandyNutAndConfectioneryStores = 'candy_nut_and_confectionery_stores',
  CarAndTruckDealersNewUsed = 'car_and_truck_dealers_new_used',
  CarAndTruckDealersUsedOnly = 'car_and_truck_dealers_used_only',
  CarRentalAgencies = 'car_rental_agencies',
  CarWashes = 'car_washes',
  CarpentryServices = 'carpentry_services',
  CarpetUpholsteryCleaning = 'carpet_upholstery_cleaning',
  Caterers = 'caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'charitable_and_social_service_organizations_fundraising',
  ChemicalsAndAlliedProducts = 'chemicals_and_allied_products',
  ChildCareServices = 'child_care_services',
  ChildrensAndInfantsWearStores = 'childrens_and_infants_wear_stores',
  ChiropodistsPodiatrists = 'chiropodists_podiatrists',
  Chiropractors = 'chiropractors',
  CigarStoresAndStands = 'cigar_stores_and_stands',
  CivicSocialFraternalAssociations = 'civic_social_fraternal_associations',
  CleaningAndMaintenance = 'cleaning_and_maintenance',
  ClothingRental = 'clothing_rental',
  CollegesUniversities = 'colleges_universities',
  CommercialEquipment = 'commercial_equipment',
  CommercialFootwear = 'commercial_footwear',
  CommercialPhotographyArtAndGraphics = 'commercial_photography_art_and_graphics',
  CommuterTransportAndFerries = 'commuter_transport_and_ferries',
  ComputerNetworkServices = 'computer_network_services',
  ComputerProgramming = 'computer_programming',
  ComputerRepair = 'computer_repair',
  ComputerSoftwareStores = 'computer_software_stores',
  ComputersPeripheralsAndSoftware = 'computers_peripherals_and_software',
  ConcreteWorkServices = 'concrete_work_services',
  ConstructionMaterials = 'construction_materials',
  ConsultingPublicRelations = 'consulting_public_relations',
  CorrespondenceSchools = 'correspondence_schools',
  CosmeticStores = 'cosmetic_stores',
  CounselingServices = 'counseling_services',
  CountryClubs = 'country_clubs',
  CourierServices = 'courier_services',
  CourtCosts = 'court_costs',
  CreditReportingAgencies = 'credit_reporting_agencies',
  CruiseLines = 'cruise_lines',
  DairyProductsStores = 'dairy_products_stores',
  DanceHallStudiosSchools = 'dance_hall_studios_schools',
  DatingEscortServices = 'dating_escort_services',
  DentistsOrthodontists = 'dentists_orthodontists',
  DepartmentStores = 'department_stores',
  DetectiveAgencies = 'detective_agencies',
  DigitalGoodsApplications = 'digital_goods_applications',
  DigitalGoodsGames = 'digital_goods_games',
  DigitalGoodsLargeVolume = 'digital_goods_large_volume',
  DigitalGoodsMedia = 'digital_goods_media',
  DirectMarketingCatalogMerchant = 'direct_marketing_catalog_merchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'direct_marketing_combination_catalog_and_retail_merchant',
  DirectMarketingInboundTelemarketing = 'direct_marketing_inbound_telemarketing',
  DirectMarketingInsuranceServices = 'direct_marketing_insurance_services',
  DirectMarketingOther = 'direct_marketing_other',
  DirectMarketingOutboundTelemarketing = 'direct_marketing_outbound_telemarketing',
  DirectMarketingSubscription = 'direct_marketing_subscription',
  DirectMarketingTravel = 'direct_marketing_travel',
  DiscountStores = 'discount_stores',
  Doctors = 'doctors',
  DoorToDoorSales = 'door_to_door_sales',
  DraperyWindowCoveringAndUpholsteryStores = 'drapery_window_covering_and_upholstery_stores',
  DrinkingPlaces = 'drinking_places',
  DrugStoresAndPharmacies = 'drug_stores_and_pharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'drugs_drug_proprietaries_and_druggist_sundries',
  DryCleaners = 'dry_cleaners',
  DurableGoods = 'durable_goods',
  DutyFreeStores = 'duty_free_stores',
  EatingPlacesRestaurants = 'eating_places_restaurants',
  EducationalServices = 'educational_services',
  ElectricRazorStores = 'electric_razor_stores',
  ElectricVehicleCharging = 'electric_vehicle_charging',
  ElectricalPartsAndEquipment = 'electrical_parts_and_equipment',
  ElectricalServices = 'electrical_services',
  ElectronicsRepairShops = 'electronics_repair_shops',
  ElectronicsStores = 'electronics_stores',
  ElementarySecondarySchools = 'elementary_secondary_schools',
  EmergencyServicesGcasVisaUseOnly = 'emergency_services_gcas_visa_use_only',
  EmploymentTempAgencies = 'employment_temp_agencies',
  EquipmentRental = 'equipment_rental',
  ExterminatingServices = 'exterminating_services',
  FamilyClothingStores = 'family_clothing_stores',
  FastFoodRestaurants = 'fast_food_restaurants',
  FinancialInstitutions = 'financial_institutions',
  FinesGovernmentAdministrativeEntities = 'fines_government_administrative_entities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'fireplace_fireplace_screens_and_accessories_stores',
  FloorCoveringStores = 'floor_covering_stores',
  Florists = 'florists',
  FloristsSuppliesNurseryStockAndFlowers = 'florists_supplies_nursery_stock_and_flowers',
  FreezerAndLockerMeatProvisioners = 'freezer_and_locker_meat_provisioners',
  FuelDealersNonAutomotive = 'fuel_dealers_non_automotive',
  FuneralServicesCrematories = 'funeral_services_crematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'furniture_home_furnishings_and_equipment_stores_except_appliances',
  FurnitureRepairRefinishing = 'furniture_repair_refinishing',
  FurriersAndFurShops = 'furriers_and_fur_shops',
  GeneralServices = 'general_services',
  GiftCardNoveltyAndSouvenirShops = 'gift_card_novelty_and_souvenir_shops',
  GlassPaintAndWallpaperStores = 'glass_paint_and_wallpaper_stores',
  GlasswareCrystalStores = 'glassware_crystal_stores',
  GolfCoursesPublic = 'golf_courses_public',
  GovernmentLicensedHorseDogRacingUsRegionOnly = 'government_licensed_horse_dog_racing_us_region_only',
  GovernmentLicensedOnlineCasionsOnlineGamblingUsRegionOnly = 'government_licensed_online_casions_online_gambling_us_region_only',
  GovernmentOwnedLotteriesNonUsRegion = 'government_owned_lotteries_non_us_region',
  GovernmentOwnedLotteriesUsRegionOnly = 'government_owned_lotteries_us_region_only',
  GovernmentServices = 'government_services',
  GroceryStoresSupermarkets = 'grocery_stores_supermarkets',
  HardwareEquipmentAndSupplies = 'hardware_equipment_and_supplies',
  HardwareStores = 'hardware_stores',
  HealthAndBeautySpas = 'health_and_beauty_spas',
  HearingAidsSalesAndSupplies = 'hearing_aids_sales_and_supplies',
  HeatingPlumbingAC = 'heating_plumbing_a_c',
  HobbyToyAndGameShops = 'hobby_toy_and_game_shops',
  HomeSupplyWarehouseStores = 'home_supply_warehouse_stores',
  Hospitals = 'hospitals',
  HotelsMotelsAndResorts = 'hotels_motels_and_resorts',
  HouseholdApplianceStores = 'household_appliance_stores',
  IndustrialSupplies = 'industrial_supplies',
  InformationRetrievalServices = 'information_retrieval_services',
  InsuranceDefault = 'insurance_default',
  InsuranceUnderwritingPremiums = 'insurance_underwriting_premiums',
  IntraCompanyPurchases = 'intra_company_purchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'jewelry_stores_watches_clocks_and_silverware_stores',
  LandscapingServices = 'landscaping_services',
  Laundries = 'laundries',
  LaundryCleaningServices = 'laundry_cleaning_services',
  LegalServicesAttorneys = 'legal_services_attorneys',
  LuggageAndLeatherGoodsStores = 'luggage_and_leather_goods_stores',
  LumberBuildingMaterialsStores = 'lumber_building_materials_stores',
  ManualCashDisburse = 'manual_cash_disburse',
  MarinasServiceAndSupplies = 'marinas_service_and_supplies',
  Marketplaces = 'marketplaces',
  MasonryStoneworkAndPlaster = 'masonry_stonework_and_plaster',
  MassageParlors = 'massage_parlors',
  MedicalAndDentalLabs = 'medical_and_dental_labs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
  MedicalServices = 'medical_services',
  MembershipOrganizations = 'membership_organizations',
  MensAndBoysClothingAndAccessoriesStores = 'mens_and_boys_clothing_and_accessories_stores',
  MensWomensClothingStores = 'mens_womens_clothing_stores',
  MetalServiceCenters = 'metal_service_centers',
  Miscellaneous = 'miscellaneous',
  MiscellaneousApparelAndAccessoryShops = 'miscellaneous_apparel_and_accessory_shops',
  MiscellaneousAutoDealers = 'miscellaneous_auto_dealers',
  MiscellaneousBusinessServices = 'miscellaneous_business_services',
  MiscellaneousFoodStores = 'miscellaneous_food_stores',
  MiscellaneousGeneralMerchandise = 'miscellaneous_general_merchandise',
  MiscellaneousGeneralServices = 'miscellaneous_general_services',
  MiscellaneousHomeFurnishingSpecialtyStores = 'miscellaneous_home_furnishing_specialty_stores',
  MiscellaneousPublishingAndPrinting = 'miscellaneous_publishing_and_printing',
  MiscellaneousRecreationServices = 'miscellaneous_recreation_services',
  MiscellaneousRepairShops = 'miscellaneous_repair_shops',
  MiscellaneousSpecialtyRetail = 'miscellaneous_specialty_retail',
  MobileHomeDealers = 'mobile_home_dealers',
  MotionPictureTheaters = 'motion_picture_theaters',
  MotorFreightCarriersAndTrucking = 'motor_freight_carriers_and_trucking',
  MotorHomesDealers = 'motor_homes_dealers',
  MotorVehicleSuppliesAndNewParts = 'motor_vehicle_supplies_and_new_parts',
  MotorcycleShopsAndDealers = 'motorcycle_shops_and_dealers',
  MotorcycleShopsDealers = 'motorcycle_shops_dealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'music_stores_musical_instruments_pianos_and_sheet_music',
  NewsDealersAndNewsstands = 'news_dealers_and_newsstands',
  NonFiMoneyOrders = 'non_fi_money_orders',
  NonFiStoredValueCardPurchaseLoad = 'non_fi_stored_value_card_purchase_load',
  NondurableGoods = 'nondurable_goods',
  NurseriesLawnAndGardenSupplyStores = 'nurseries_lawn_and_garden_supply_stores',
  NursingPersonalCare = 'nursing_personal_care',
  OfficeAndCommercialFurniture = 'office_and_commercial_furniture',
  OpticiansEyeglasses = 'opticians_eyeglasses',
  OptometristsOphthalmologist = 'optometrists_ophthalmologist',
  OrthopedicGoodsProstheticDevices = 'orthopedic_goods_prosthetic_devices',
  Osteopaths = 'osteopaths',
  PackageStoresBeerWineAndLiquor = 'package_stores_beer_wine_and_liquor',
  PaintsVarnishesAndSupplies = 'paints_varnishes_and_supplies',
  ParkingLotsGarages = 'parking_lots_garages',
  PassengerRailways = 'passenger_railways',
  PawnShops = 'pawn_shops',
  PetShopsPetFoodAndSupplies = 'pet_shops_pet_food_and_supplies',
  PetroleumAndPetroleumProducts = 'petroleum_and_petroleum_products',
  PhotoDeveloping = 'photo_developing',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'photographic_photocopy_microfilm_equipment_and_supplies',
  PhotographicStudios = 'photographic_studios',
  PictureVideoProduction = 'picture_video_production',
  PieceGoodsNotionsAndOtherDryGoods = 'piece_goods_notions_and_other_dry_goods',
  PlumbingHeatingEquipmentAndSupplies = 'plumbing_heating_equipment_and_supplies',
  PoliticalOrganizations = 'political_organizations',
  PostalServicesGovernmentOnly = 'postal_services_government_only',
  PreciousStonesAndMetalsWatchesAndJewelry = 'precious_stones_and_metals_watches_and_jewelry',
  ProfessionalServices = 'professional_services',
  PublicWarehousingAndStorage = 'public_warehousing_and_storage',
  QuickCopyReproAndBlueprint = 'quick_copy_repro_and_blueprint',
  Railroads = 'railroads',
  RealEstateAgentsAndManagersRentals = 'real_estate_agents_and_managers_rentals',
  RecordStores = 'record_stores',
  RecreationalVehicleRentals = 'recreational_vehicle_rentals',
  ReligiousGoodsStores = 'religious_goods_stores',
  ReligiousOrganizations = 'religious_organizations',
  RoofingSidingSheetMetal = 'roofing_siding_sheet_metal',
  SecretarialSupportServices = 'secretarial_support_services',
  SecurityBrokersDealers = 'security_brokers_dealers',
  ServiceStations = 'service_stations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'sewing_needlework_fabric_and_piece_goods_stores',
  ShoeRepairHatCleaning = 'shoe_repair_hat_cleaning',
  ShoeStores = 'shoe_stores',
  SmallApplianceRepair = 'small_appliance_repair',
  SnowmobileDealers = 'snowmobile_dealers',
  SpecialTradeServices = 'special_trade_services',
  SpecialtyCleaning = 'specialty_cleaning',
  SportingGoodsStores = 'sporting_goods_stores',
  SportingRecreationCamps = 'sporting_recreation_camps',
  SportsAndRidingApparelStores = 'sports_and_riding_apparel_stores',
  SportsClubsFields = 'sports_clubs_fields',
  StampAndCoinStores = 'stamp_and_coin_stores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'stationary_office_supplies_printing_and_writing_paper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'stationery_stores_office_and_school_supply_stores',
  SwimmingPoolsSales = 'swimming_pools_sales',
  TUiTravelGermany = 't_ui_travel_germany',
  TailorsAlterations = 'tailors_alterations',
  TaxPaymentsGovernmentAgencies = 'tax_payments_government_agencies',
  TaxPreparationServices = 'tax_preparation_services',
  TaxicabsLimousines = 'taxicabs_limousines',
  TelecommunicationEquipmentAndTelephoneSales = 'telecommunication_equipment_and_telephone_sales',
  TelecommunicationServices = 'telecommunication_services',
  TelegraphServices = 'telegraph_services',
  TentAndAwningShops = 'tent_and_awning_shops',
  TestingLaboratories = 'testing_laboratories',
  TheatricalTicketAgencies = 'theatrical_ticket_agencies',
  Timeshares = 'timeshares',
  TireRetreadingAndRepair = 'tire_retreading_and_repair',
  TollsBridgeFees = 'tolls_bridge_fees',
  TouristAttractionsAndExhibits = 'tourist_attractions_and_exhibits',
  TowingServices = 'towing_services',
  TrailerParksCampgrounds = 'trailer_parks_campgrounds',
  TransportationServices = 'transportation_services',
  TravelAgenciesTourOperators = 'travel_agencies_tour_operators',
  TruckStopIteration = 'truck_stop_iteration',
  TruckUtilityTrailerRentals = 'truck_utility_trailer_rentals',
  TypesettingPlateMakingAndRelatedServices = 'typesetting_plate_making_and_related_services',
  TypewriterStores = 'typewriter_stores',
  USFederalGovernmentAgenciesOrDepartments = 'u_s_federal_government_agencies_or_departments',
  UniformsCommercialClothing = 'uniforms_commercial_clothing',
  UsedMerchandiseAndSecondhandStores = 'used_merchandise_and_secondhand_stores',
  Utilities = 'utilities',
  VarietyStores = 'variety_stores',
  VeterinaryServices = 'veterinary_services',
  VideoAmusementGameSupplies = 'video_amusement_game_supplies',
  VideoGameArcades = 'video_game_arcades',
  VideoTapeRentalStores = 'video_tape_rental_stores',
  VocationalTradeSchools = 'vocational_trade_schools',
  WatchJewelryRepair = 'watch_jewelry_repair',
  WeldingRepair = 'welding_repair',
  WholesaleClubs = 'wholesale_clubs',
  WigAndToupeeStores = 'wig_and_toupee_stores',
  WiresMoneyOrders = 'wires_money_orders',
  WomensAccessoryAndSpecialtyShops = 'womens_accessory_and_specialty_shops',
  WomensReadyToWearStores = 'womens_ready_to_wear_stores',
  WreckingAndSalvageYards = 'wrecking_and_salvage_yards',
}

export interface StripeIssuingCardholderSpendingControlsSpendingLimit {
  /** Maximum amount allowed to spend per interval. This amount is in the card's currency and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount: number;
  /** Array of strings containing [categories](https://stripe.com/docs/api#issuing_authorization_object-merchant_data-category) this limit applies to. Omitting this field will apply the limit to all categories. */
  categories: StripeIssuingCardholderSpendingControlsSpendingLimitCategory[] | null;
  /** Interval (or event) to which the amount applies. */
  interval: StripeIssuingCardholderSpendingControlsSpendingLimitInterval;
}

export enum StripeIssuingCardholderSpendingControlsSpendingLimitCategory {
  AcRefrigerationRepair = 'ac_refrigeration_repair',
  AccountingBookkeepingServices = 'accounting_bookkeeping_services',
  AdvertisingServices = 'advertising_services',
  AgriculturalCooperative = 'agricultural_cooperative',
  AirlinesAirCarriers = 'airlines_air_carriers',
  AirportsFlyingFields = 'airports_flying_fields',
  AmbulanceServices = 'ambulance_services',
  AmusementParksCarnivals = 'amusement_parks_carnivals',
  AntiqueReproductions = 'antique_reproductions',
  AntiqueShops = 'antique_shops',
  Aquariums = 'aquariums',
  ArchitecturalSurveyingServices = 'architectural_surveying_services',
  ArtDealersAndGalleries = 'art_dealers_and_galleries',
  ArtistsSupplyAndCraftShops = 'artists_supply_and_craft_shops',
  AutoAndHomeSupplyStores = 'auto_and_home_supply_stores',
  AutoBodyRepairShops = 'auto_body_repair_shops',
  AutoPaintShops = 'auto_paint_shops',
  AutoServiceShops = 'auto_service_shops',
  AutomatedCashDisburse = 'automated_cash_disburse',
  AutomatedFuelDispensers = 'automated_fuel_dispensers',
  AutomobileAssociations = 'automobile_associations',
  AutomotivePartsAndAccessoriesStores = 'automotive_parts_and_accessories_stores',
  AutomotiveTireStores = 'automotive_tire_stores',
  BailAndBondPayments = 'bail_and_bond_payments',
  Bakeries = 'bakeries',
  BandsOrchestras = 'bands_orchestras',
  BarberAndBeautyShops = 'barber_and_beauty_shops',
  BettingCasinoGambling = 'betting_casino_gambling',
  BicycleShops = 'bicycle_shops',
  BilliardPoolEstablishments = 'billiard_pool_establishments',
  BoatDealers = 'boat_dealers',
  BoatRentalsAndLeases = 'boat_rentals_and_leases',
  BookStores = 'book_stores',
  BooksPeriodicalsAndNewspapers = 'books_periodicals_and_newspapers',
  BowlingAlleys = 'bowling_alleys',
  BusLines = 'bus_lines',
  BusinessSecretarialSchools = 'business_secretarial_schools',
  BuyingShoppingServices = 'buying_shopping_services',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'cable_satellite_and_other_pay_television_and_radio',
  CameraAndPhotographicSupplyStores = 'camera_and_photographic_supply_stores',
  CandyNutAndConfectioneryStores = 'candy_nut_and_confectionery_stores',
  CarAndTruckDealersNewUsed = 'car_and_truck_dealers_new_used',
  CarAndTruckDealersUsedOnly = 'car_and_truck_dealers_used_only',
  CarRentalAgencies = 'car_rental_agencies',
  CarWashes = 'car_washes',
  CarpentryServices = 'carpentry_services',
  CarpetUpholsteryCleaning = 'carpet_upholstery_cleaning',
  Caterers = 'caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'charitable_and_social_service_organizations_fundraising',
  ChemicalsAndAlliedProducts = 'chemicals_and_allied_products',
  ChildCareServices = 'child_care_services',
  ChildrensAndInfantsWearStores = 'childrens_and_infants_wear_stores',
  ChiropodistsPodiatrists = 'chiropodists_podiatrists',
  Chiropractors = 'chiropractors',
  CigarStoresAndStands = 'cigar_stores_and_stands',
  CivicSocialFraternalAssociations = 'civic_social_fraternal_associations',
  CleaningAndMaintenance = 'cleaning_and_maintenance',
  ClothingRental = 'clothing_rental',
  CollegesUniversities = 'colleges_universities',
  CommercialEquipment = 'commercial_equipment',
  CommercialFootwear = 'commercial_footwear',
  CommercialPhotographyArtAndGraphics = 'commercial_photography_art_and_graphics',
  CommuterTransportAndFerries = 'commuter_transport_and_ferries',
  ComputerNetworkServices = 'computer_network_services',
  ComputerProgramming = 'computer_programming',
  ComputerRepair = 'computer_repair',
  ComputerSoftwareStores = 'computer_software_stores',
  ComputersPeripheralsAndSoftware = 'computers_peripherals_and_software',
  ConcreteWorkServices = 'concrete_work_services',
  ConstructionMaterials = 'construction_materials',
  ConsultingPublicRelations = 'consulting_public_relations',
  CorrespondenceSchools = 'correspondence_schools',
  CosmeticStores = 'cosmetic_stores',
  CounselingServices = 'counseling_services',
  CountryClubs = 'country_clubs',
  CourierServices = 'courier_services',
  CourtCosts = 'court_costs',
  CreditReportingAgencies = 'credit_reporting_agencies',
  CruiseLines = 'cruise_lines',
  DairyProductsStores = 'dairy_products_stores',
  DanceHallStudiosSchools = 'dance_hall_studios_schools',
  DatingEscortServices = 'dating_escort_services',
  DentistsOrthodontists = 'dentists_orthodontists',
  DepartmentStores = 'department_stores',
  DetectiveAgencies = 'detective_agencies',
  DigitalGoodsApplications = 'digital_goods_applications',
  DigitalGoodsGames = 'digital_goods_games',
  DigitalGoodsLargeVolume = 'digital_goods_large_volume',
  DigitalGoodsMedia = 'digital_goods_media',
  DirectMarketingCatalogMerchant = 'direct_marketing_catalog_merchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'direct_marketing_combination_catalog_and_retail_merchant',
  DirectMarketingInboundTelemarketing = 'direct_marketing_inbound_telemarketing',
  DirectMarketingInsuranceServices = 'direct_marketing_insurance_services',
  DirectMarketingOther = 'direct_marketing_other',
  DirectMarketingOutboundTelemarketing = 'direct_marketing_outbound_telemarketing',
  DirectMarketingSubscription = 'direct_marketing_subscription',
  DirectMarketingTravel = 'direct_marketing_travel',
  DiscountStores = 'discount_stores',
  Doctors = 'doctors',
  DoorToDoorSales = 'door_to_door_sales',
  DraperyWindowCoveringAndUpholsteryStores = 'drapery_window_covering_and_upholstery_stores',
  DrinkingPlaces = 'drinking_places',
  DrugStoresAndPharmacies = 'drug_stores_and_pharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'drugs_drug_proprietaries_and_druggist_sundries',
  DryCleaners = 'dry_cleaners',
  DurableGoods = 'durable_goods',
  DutyFreeStores = 'duty_free_stores',
  EatingPlacesRestaurants = 'eating_places_restaurants',
  EducationalServices = 'educational_services',
  ElectricRazorStores = 'electric_razor_stores',
  ElectricVehicleCharging = 'electric_vehicle_charging',
  ElectricalPartsAndEquipment = 'electrical_parts_and_equipment',
  ElectricalServices = 'electrical_services',
  ElectronicsRepairShops = 'electronics_repair_shops',
  ElectronicsStores = 'electronics_stores',
  ElementarySecondarySchools = 'elementary_secondary_schools',
  EmergencyServicesGcasVisaUseOnly = 'emergency_services_gcas_visa_use_only',
  EmploymentTempAgencies = 'employment_temp_agencies',
  EquipmentRental = 'equipment_rental',
  ExterminatingServices = 'exterminating_services',
  FamilyClothingStores = 'family_clothing_stores',
  FastFoodRestaurants = 'fast_food_restaurants',
  FinancialInstitutions = 'financial_institutions',
  FinesGovernmentAdministrativeEntities = 'fines_government_administrative_entities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'fireplace_fireplace_screens_and_accessories_stores',
  FloorCoveringStores = 'floor_covering_stores',
  Florists = 'florists',
  FloristsSuppliesNurseryStockAndFlowers = 'florists_supplies_nursery_stock_and_flowers',
  FreezerAndLockerMeatProvisioners = 'freezer_and_locker_meat_provisioners',
  FuelDealersNonAutomotive = 'fuel_dealers_non_automotive',
  FuneralServicesCrematories = 'funeral_services_crematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'furniture_home_furnishings_and_equipment_stores_except_appliances',
  FurnitureRepairRefinishing = 'furniture_repair_refinishing',
  FurriersAndFurShops = 'furriers_and_fur_shops',
  GeneralServices = 'general_services',
  GiftCardNoveltyAndSouvenirShops = 'gift_card_novelty_and_souvenir_shops',
  GlassPaintAndWallpaperStores = 'glass_paint_and_wallpaper_stores',
  GlasswareCrystalStores = 'glassware_crystal_stores',
  GolfCoursesPublic = 'golf_courses_public',
  GovernmentLicensedHorseDogRacingUsRegionOnly = 'government_licensed_horse_dog_racing_us_region_only',
  GovernmentLicensedOnlineCasionsOnlineGamblingUsRegionOnly = 'government_licensed_online_casions_online_gambling_us_region_only',
  GovernmentOwnedLotteriesNonUsRegion = 'government_owned_lotteries_non_us_region',
  GovernmentOwnedLotteriesUsRegionOnly = 'government_owned_lotteries_us_region_only',
  GovernmentServices = 'government_services',
  GroceryStoresSupermarkets = 'grocery_stores_supermarkets',
  HardwareEquipmentAndSupplies = 'hardware_equipment_and_supplies',
  HardwareStores = 'hardware_stores',
  HealthAndBeautySpas = 'health_and_beauty_spas',
  HearingAidsSalesAndSupplies = 'hearing_aids_sales_and_supplies',
  HeatingPlumbingAC = 'heating_plumbing_a_c',
  HobbyToyAndGameShops = 'hobby_toy_and_game_shops',
  HomeSupplyWarehouseStores = 'home_supply_warehouse_stores',
  Hospitals = 'hospitals',
  HotelsMotelsAndResorts = 'hotels_motels_and_resorts',
  HouseholdApplianceStores = 'household_appliance_stores',
  IndustrialSupplies = 'industrial_supplies',
  InformationRetrievalServices = 'information_retrieval_services',
  InsuranceDefault = 'insurance_default',
  InsuranceUnderwritingPremiums = 'insurance_underwriting_premiums',
  IntraCompanyPurchases = 'intra_company_purchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'jewelry_stores_watches_clocks_and_silverware_stores',
  LandscapingServices = 'landscaping_services',
  Laundries = 'laundries',
  LaundryCleaningServices = 'laundry_cleaning_services',
  LegalServicesAttorneys = 'legal_services_attorneys',
  LuggageAndLeatherGoodsStores = 'luggage_and_leather_goods_stores',
  LumberBuildingMaterialsStores = 'lumber_building_materials_stores',
  ManualCashDisburse = 'manual_cash_disburse',
  MarinasServiceAndSupplies = 'marinas_service_and_supplies',
  Marketplaces = 'marketplaces',
  MasonryStoneworkAndPlaster = 'masonry_stonework_and_plaster',
  MassageParlors = 'massage_parlors',
  MedicalAndDentalLabs = 'medical_and_dental_labs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
  MedicalServices = 'medical_services',
  MembershipOrganizations = 'membership_organizations',
  MensAndBoysClothingAndAccessoriesStores = 'mens_and_boys_clothing_and_accessories_stores',
  MensWomensClothingStores = 'mens_womens_clothing_stores',
  MetalServiceCenters = 'metal_service_centers',
  Miscellaneous = 'miscellaneous',
  MiscellaneousApparelAndAccessoryShops = 'miscellaneous_apparel_and_accessory_shops',
  MiscellaneousAutoDealers = 'miscellaneous_auto_dealers',
  MiscellaneousBusinessServices = 'miscellaneous_business_services',
  MiscellaneousFoodStores = 'miscellaneous_food_stores',
  MiscellaneousGeneralMerchandise = 'miscellaneous_general_merchandise',
  MiscellaneousGeneralServices = 'miscellaneous_general_services',
  MiscellaneousHomeFurnishingSpecialtyStores = 'miscellaneous_home_furnishing_specialty_stores',
  MiscellaneousPublishingAndPrinting = 'miscellaneous_publishing_and_printing',
  MiscellaneousRecreationServices = 'miscellaneous_recreation_services',
  MiscellaneousRepairShops = 'miscellaneous_repair_shops',
  MiscellaneousSpecialtyRetail = 'miscellaneous_specialty_retail',
  MobileHomeDealers = 'mobile_home_dealers',
  MotionPictureTheaters = 'motion_picture_theaters',
  MotorFreightCarriersAndTrucking = 'motor_freight_carriers_and_trucking',
  MotorHomesDealers = 'motor_homes_dealers',
  MotorVehicleSuppliesAndNewParts = 'motor_vehicle_supplies_and_new_parts',
  MotorcycleShopsAndDealers = 'motorcycle_shops_and_dealers',
  MotorcycleShopsDealers = 'motorcycle_shops_dealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'music_stores_musical_instruments_pianos_and_sheet_music',
  NewsDealersAndNewsstands = 'news_dealers_and_newsstands',
  NonFiMoneyOrders = 'non_fi_money_orders',
  NonFiStoredValueCardPurchaseLoad = 'non_fi_stored_value_card_purchase_load',
  NondurableGoods = 'nondurable_goods',
  NurseriesLawnAndGardenSupplyStores = 'nurseries_lawn_and_garden_supply_stores',
  NursingPersonalCare = 'nursing_personal_care',
  OfficeAndCommercialFurniture = 'office_and_commercial_furniture',
  OpticiansEyeglasses = 'opticians_eyeglasses',
  OptometristsOphthalmologist = 'optometrists_ophthalmologist',
  OrthopedicGoodsProstheticDevices = 'orthopedic_goods_prosthetic_devices',
  Osteopaths = 'osteopaths',
  PackageStoresBeerWineAndLiquor = 'package_stores_beer_wine_and_liquor',
  PaintsVarnishesAndSupplies = 'paints_varnishes_and_supplies',
  ParkingLotsGarages = 'parking_lots_garages',
  PassengerRailways = 'passenger_railways',
  PawnShops = 'pawn_shops',
  PetShopsPetFoodAndSupplies = 'pet_shops_pet_food_and_supplies',
  PetroleumAndPetroleumProducts = 'petroleum_and_petroleum_products',
  PhotoDeveloping = 'photo_developing',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'photographic_photocopy_microfilm_equipment_and_supplies',
  PhotographicStudios = 'photographic_studios',
  PictureVideoProduction = 'picture_video_production',
  PieceGoodsNotionsAndOtherDryGoods = 'piece_goods_notions_and_other_dry_goods',
  PlumbingHeatingEquipmentAndSupplies = 'plumbing_heating_equipment_and_supplies',
  PoliticalOrganizations = 'political_organizations',
  PostalServicesGovernmentOnly = 'postal_services_government_only',
  PreciousStonesAndMetalsWatchesAndJewelry = 'precious_stones_and_metals_watches_and_jewelry',
  ProfessionalServices = 'professional_services',
  PublicWarehousingAndStorage = 'public_warehousing_and_storage',
  QuickCopyReproAndBlueprint = 'quick_copy_repro_and_blueprint',
  Railroads = 'railroads',
  RealEstateAgentsAndManagersRentals = 'real_estate_agents_and_managers_rentals',
  RecordStores = 'record_stores',
  RecreationalVehicleRentals = 'recreational_vehicle_rentals',
  ReligiousGoodsStores = 'religious_goods_stores',
  ReligiousOrganizations = 'religious_organizations',
  RoofingSidingSheetMetal = 'roofing_siding_sheet_metal',
  SecretarialSupportServices = 'secretarial_support_services',
  SecurityBrokersDealers = 'security_brokers_dealers',
  ServiceStations = 'service_stations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'sewing_needlework_fabric_and_piece_goods_stores',
  ShoeRepairHatCleaning = 'shoe_repair_hat_cleaning',
  ShoeStores = 'shoe_stores',
  SmallApplianceRepair = 'small_appliance_repair',
  SnowmobileDealers = 'snowmobile_dealers',
  SpecialTradeServices = 'special_trade_services',
  SpecialtyCleaning = 'specialty_cleaning',
  SportingGoodsStores = 'sporting_goods_stores',
  SportingRecreationCamps = 'sporting_recreation_camps',
  SportsAndRidingApparelStores = 'sports_and_riding_apparel_stores',
  SportsClubsFields = 'sports_clubs_fields',
  StampAndCoinStores = 'stamp_and_coin_stores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'stationary_office_supplies_printing_and_writing_paper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'stationery_stores_office_and_school_supply_stores',
  SwimmingPoolsSales = 'swimming_pools_sales',
  TUiTravelGermany = 't_ui_travel_germany',
  TailorsAlterations = 'tailors_alterations',
  TaxPaymentsGovernmentAgencies = 'tax_payments_government_agencies',
  TaxPreparationServices = 'tax_preparation_services',
  TaxicabsLimousines = 'taxicabs_limousines',
  TelecommunicationEquipmentAndTelephoneSales = 'telecommunication_equipment_and_telephone_sales',
  TelecommunicationServices = 'telecommunication_services',
  TelegraphServices = 'telegraph_services',
  TentAndAwningShops = 'tent_and_awning_shops',
  TestingLaboratories = 'testing_laboratories',
  TheatricalTicketAgencies = 'theatrical_ticket_agencies',
  Timeshares = 'timeshares',
  TireRetreadingAndRepair = 'tire_retreading_and_repair',
  TollsBridgeFees = 'tolls_bridge_fees',
  TouristAttractionsAndExhibits = 'tourist_attractions_and_exhibits',
  TowingServices = 'towing_services',
  TrailerParksCampgrounds = 'trailer_parks_campgrounds',
  TransportationServices = 'transportation_services',
  TravelAgenciesTourOperators = 'travel_agencies_tour_operators',
  TruckStopIteration = 'truck_stop_iteration',
  TruckUtilityTrailerRentals = 'truck_utility_trailer_rentals',
  TypesettingPlateMakingAndRelatedServices = 'typesetting_plate_making_and_related_services',
  TypewriterStores = 'typewriter_stores',
  USFederalGovernmentAgenciesOrDepartments = 'u_s_federal_government_agencies_or_departments',
  UniformsCommercialClothing = 'uniforms_commercial_clothing',
  UsedMerchandiseAndSecondhandStores = 'used_merchandise_and_secondhand_stores',
  Utilities = 'utilities',
  VarietyStores = 'variety_stores',
  VeterinaryServices = 'veterinary_services',
  VideoAmusementGameSupplies = 'video_amusement_game_supplies',
  VideoGameArcades = 'video_game_arcades',
  VideoTapeRentalStores = 'video_tape_rental_stores',
  VocationalTradeSchools = 'vocational_trade_schools',
  WatchJewelryRepair = 'watch_jewelry_repair',
  WeldingRepair = 'welding_repair',
  WholesaleClubs = 'wholesale_clubs',
  WigAndToupeeStores = 'wig_and_toupee_stores',
  WiresMoneyOrders = 'wires_money_orders',
  WomensAccessoryAndSpecialtyShops = 'womens_accessory_and_specialty_shops',
  WomensReadyToWearStores = 'womens_ready_to_wear_stores',
  WreckingAndSalvageYards = 'wrecking_and_salvage_yards',
}

export enum StripeIssuingCardholderSpendingControlsSpendingLimitInterval {
  AllTime = 'all_time',
  Daily = 'daily',
  Monthly = 'monthly',
  PerAuthorization = 'per_authorization',
  Weekly = 'weekly',
  Yearly = 'yearly',
}

export enum StripeIssuingCardholderStatus {
  Active = 'active',
  Blocked = 'blocked',
  Inactive = 'inactive',
}

export enum StripeIssuingCardholderType {
  Company = 'company',
  Individual = 'individual',
}

export enum StripeIssuingCardReplacementReason {
  Damaged = 'damaged',
  Expired = 'expired',
  Lost = 'lost',
  Stolen = 'stolen',
}

export interface StripeIssuingCardShipping {
  /** The Address object. */
  address: StripeAddress;
  /** The delivery company that shipped a card. */
  carrier: StripeIssuingCardShippingCarrier | null;
  /** Additional information that may be required for clearing customs. */
  customs: StripeIssuingCardShippingCustoms | null;
  /** A unix timestamp representing a best estimate of when the card will be delivered. */
  eta: number | null;
  /** Recipient name. */
  name: string;
  /** The phone number of the receiver of the bulk shipment. This phone number will be provided to the shipping company, who might use it to contact the receiver in case of delivery issues. */
  phone_number: string | null;
  /** Whether a signature is required for card delivery. This feature is only supported for US users. Standard shipping service does not support signature on delivery. The default value for standard shipping service is false and for express and priority services is true. */
  require_signature: boolean | null;
  /** Shipment service, such as `standard` or `express`. */
  service: StripeIssuingCardShippingService;
  /** The delivery status of the card. */
  status: StripeIssuingCardShippingStatus | null;
  /** A tracking number for a card shipment. */
  tracking_number: string | null;
  /** A link to the shipping carrier's site where you can view detailed information about a card shipment. */
  tracking_url: string | null;
  /** Packaging options. */
  type: StripeIssuingCardShippingType;
}

export enum StripeIssuingCardShippingCarrier {
  Dhl = 'dhl',
  Fedex = 'fedex',
  RoyalMail = 'royal_mail',
  Usps = 'usps',
}

export interface StripeIssuingCardShippingCustoms {
  /** A registration number used for customs in Europe. See https://www.gov.uk/eori and https://ec.europa.eu/taxation_customs/business/customs-procedures-import-and-export/customs-procedures/economic-operators-registration-and-identification-number-eori_en. */
  eori_number: string | null;
}

export enum StripeIssuingCardShippingService {
  Express = 'express',
  Priority = 'priority',
  Standard = 'standard',
}

export enum StripeIssuingCardShippingStatus {
  Canceled = 'canceled',
  Delivered = 'delivered',
  Failure = 'failure',
  Pending = 'pending',
  Returned = 'returned',
  Shipped = 'shipped',
}

export enum StripeIssuingCardShippingType {
  Bulk = 'bulk',
  Individual = 'individual',
}

export interface StripeIssuingCardSpendingControls {
  /** Array of strings containing [categories](https://stripe.com/docs/api#issuing_authorization_object-merchant_data-category) of authorizations to allow. All other categories will be blocked. Cannot be set with `blocked_categories`. */
  allowed_categories: StripeIssuingCardSpendingControlsAllowedCategory[] | null;
  /** Array of strings containing [categories](https://stripe.com/docs/api#issuing_authorization_object-merchant_data-category) of authorizations to decline. All other categories will be allowed. Cannot be set with `allowed_categories`. */
  blocked_categories: StripeIssuingCardSpendingControlsBlockedCategory[] | null;
  /** Limit spending with amount-based rules that apply across any cards this card replaced (i.e., its `replacement_for` card and _that_ card's `replacement_for` card, up the chain). */
  spending_limits: StripeIssuingCardSpendingControlsSpendingLimit[] | null;
  /** Currency of the amounts within `spending_limits`. Always the same as the currency of the card. */
  spending_limits_currency: string | null;
}

export enum StripeIssuingCardSpendingControlsAllowedCategory {
  AcRefrigerationRepair = 'ac_refrigeration_repair',
  AccountingBookkeepingServices = 'accounting_bookkeeping_services',
  AdvertisingServices = 'advertising_services',
  AgriculturalCooperative = 'agricultural_cooperative',
  AirlinesAirCarriers = 'airlines_air_carriers',
  AirportsFlyingFields = 'airports_flying_fields',
  AmbulanceServices = 'ambulance_services',
  AmusementParksCarnivals = 'amusement_parks_carnivals',
  AntiqueReproductions = 'antique_reproductions',
  AntiqueShops = 'antique_shops',
  Aquariums = 'aquariums',
  ArchitecturalSurveyingServices = 'architectural_surveying_services',
  ArtDealersAndGalleries = 'art_dealers_and_galleries',
  ArtistsSupplyAndCraftShops = 'artists_supply_and_craft_shops',
  AutoAndHomeSupplyStores = 'auto_and_home_supply_stores',
  AutoBodyRepairShops = 'auto_body_repair_shops',
  AutoPaintShops = 'auto_paint_shops',
  AutoServiceShops = 'auto_service_shops',
  AutomatedCashDisburse = 'automated_cash_disburse',
  AutomatedFuelDispensers = 'automated_fuel_dispensers',
  AutomobileAssociations = 'automobile_associations',
  AutomotivePartsAndAccessoriesStores = 'automotive_parts_and_accessories_stores',
  AutomotiveTireStores = 'automotive_tire_stores',
  BailAndBondPayments = 'bail_and_bond_payments',
  Bakeries = 'bakeries',
  BandsOrchestras = 'bands_orchestras',
  BarberAndBeautyShops = 'barber_and_beauty_shops',
  BettingCasinoGambling = 'betting_casino_gambling',
  BicycleShops = 'bicycle_shops',
  BilliardPoolEstablishments = 'billiard_pool_establishments',
  BoatDealers = 'boat_dealers',
  BoatRentalsAndLeases = 'boat_rentals_and_leases',
  BookStores = 'book_stores',
  BooksPeriodicalsAndNewspapers = 'books_periodicals_and_newspapers',
  BowlingAlleys = 'bowling_alleys',
  BusLines = 'bus_lines',
  BusinessSecretarialSchools = 'business_secretarial_schools',
  BuyingShoppingServices = 'buying_shopping_services',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'cable_satellite_and_other_pay_television_and_radio',
  CameraAndPhotographicSupplyStores = 'camera_and_photographic_supply_stores',
  CandyNutAndConfectioneryStores = 'candy_nut_and_confectionery_stores',
  CarAndTruckDealersNewUsed = 'car_and_truck_dealers_new_used',
  CarAndTruckDealersUsedOnly = 'car_and_truck_dealers_used_only',
  CarRentalAgencies = 'car_rental_agencies',
  CarWashes = 'car_washes',
  CarpentryServices = 'carpentry_services',
  CarpetUpholsteryCleaning = 'carpet_upholstery_cleaning',
  Caterers = 'caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'charitable_and_social_service_organizations_fundraising',
  ChemicalsAndAlliedProducts = 'chemicals_and_allied_products',
  ChildCareServices = 'child_care_services',
  ChildrensAndInfantsWearStores = 'childrens_and_infants_wear_stores',
  ChiropodistsPodiatrists = 'chiropodists_podiatrists',
  Chiropractors = 'chiropractors',
  CigarStoresAndStands = 'cigar_stores_and_stands',
  CivicSocialFraternalAssociations = 'civic_social_fraternal_associations',
  CleaningAndMaintenance = 'cleaning_and_maintenance',
  ClothingRental = 'clothing_rental',
  CollegesUniversities = 'colleges_universities',
  CommercialEquipment = 'commercial_equipment',
  CommercialFootwear = 'commercial_footwear',
  CommercialPhotographyArtAndGraphics = 'commercial_photography_art_and_graphics',
  CommuterTransportAndFerries = 'commuter_transport_and_ferries',
  ComputerNetworkServices = 'computer_network_services',
  ComputerProgramming = 'computer_programming',
  ComputerRepair = 'computer_repair',
  ComputerSoftwareStores = 'computer_software_stores',
  ComputersPeripheralsAndSoftware = 'computers_peripherals_and_software',
  ConcreteWorkServices = 'concrete_work_services',
  ConstructionMaterials = 'construction_materials',
  ConsultingPublicRelations = 'consulting_public_relations',
  CorrespondenceSchools = 'correspondence_schools',
  CosmeticStores = 'cosmetic_stores',
  CounselingServices = 'counseling_services',
  CountryClubs = 'country_clubs',
  CourierServices = 'courier_services',
  CourtCosts = 'court_costs',
  CreditReportingAgencies = 'credit_reporting_agencies',
  CruiseLines = 'cruise_lines',
  DairyProductsStores = 'dairy_products_stores',
  DanceHallStudiosSchools = 'dance_hall_studios_schools',
  DatingEscortServices = 'dating_escort_services',
  DentistsOrthodontists = 'dentists_orthodontists',
  DepartmentStores = 'department_stores',
  DetectiveAgencies = 'detective_agencies',
  DigitalGoodsApplications = 'digital_goods_applications',
  DigitalGoodsGames = 'digital_goods_games',
  DigitalGoodsLargeVolume = 'digital_goods_large_volume',
  DigitalGoodsMedia = 'digital_goods_media',
  DirectMarketingCatalogMerchant = 'direct_marketing_catalog_merchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'direct_marketing_combination_catalog_and_retail_merchant',
  DirectMarketingInboundTelemarketing = 'direct_marketing_inbound_telemarketing',
  DirectMarketingInsuranceServices = 'direct_marketing_insurance_services',
  DirectMarketingOther = 'direct_marketing_other',
  DirectMarketingOutboundTelemarketing = 'direct_marketing_outbound_telemarketing',
  DirectMarketingSubscription = 'direct_marketing_subscription',
  DirectMarketingTravel = 'direct_marketing_travel',
  DiscountStores = 'discount_stores',
  Doctors = 'doctors',
  DoorToDoorSales = 'door_to_door_sales',
  DraperyWindowCoveringAndUpholsteryStores = 'drapery_window_covering_and_upholstery_stores',
  DrinkingPlaces = 'drinking_places',
  DrugStoresAndPharmacies = 'drug_stores_and_pharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'drugs_drug_proprietaries_and_druggist_sundries',
  DryCleaners = 'dry_cleaners',
  DurableGoods = 'durable_goods',
  DutyFreeStores = 'duty_free_stores',
  EatingPlacesRestaurants = 'eating_places_restaurants',
  EducationalServices = 'educational_services',
  ElectricRazorStores = 'electric_razor_stores',
  ElectricVehicleCharging = 'electric_vehicle_charging',
  ElectricalPartsAndEquipment = 'electrical_parts_and_equipment',
  ElectricalServices = 'electrical_services',
  ElectronicsRepairShops = 'electronics_repair_shops',
  ElectronicsStores = 'electronics_stores',
  ElementarySecondarySchools = 'elementary_secondary_schools',
  EmergencyServicesGcasVisaUseOnly = 'emergency_services_gcas_visa_use_only',
  EmploymentTempAgencies = 'employment_temp_agencies',
  EquipmentRental = 'equipment_rental',
  ExterminatingServices = 'exterminating_services',
  FamilyClothingStores = 'family_clothing_stores',
  FastFoodRestaurants = 'fast_food_restaurants',
  FinancialInstitutions = 'financial_institutions',
  FinesGovernmentAdministrativeEntities = 'fines_government_administrative_entities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'fireplace_fireplace_screens_and_accessories_stores',
  FloorCoveringStores = 'floor_covering_stores',
  Florists = 'florists',
  FloristsSuppliesNurseryStockAndFlowers = 'florists_supplies_nursery_stock_and_flowers',
  FreezerAndLockerMeatProvisioners = 'freezer_and_locker_meat_provisioners',
  FuelDealersNonAutomotive = 'fuel_dealers_non_automotive',
  FuneralServicesCrematories = 'funeral_services_crematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'furniture_home_furnishings_and_equipment_stores_except_appliances',
  FurnitureRepairRefinishing = 'furniture_repair_refinishing',
  FurriersAndFurShops = 'furriers_and_fur_shops',
  GeneralServices = 'general_services',
  GiftCardNoveltyAndSouvenirShops = 'gift_card_novelty_and_souvenir_shops',
  GlassPaintAndWallpaperStores = 'glass_paint_and_wallpaper_stores',
  GlasswareCrystalStores = 'glassware_crystal_stores',
  GolfCoursesPublic = 'golf_courses_public',
  GovernmentLicensedHorseDogRacingUsRegionOnly = 'government_licensed_horse_dog_racing_us_region_only',
  GovernmentLicensedOnlineCasionsOnlineGamblingUsRegionOnly = 'government_licensed_online_casions_online_gambling_us_region_only',
  GovernmentOwnedLotteriesNonUsRegion = 'government_owned_lotteries_non_us_region',
  GovernmentOwnedLotteriesUsRegionOnly = 'government_owned_lotteries_us_region_only',
  GovernmentServices = 'government_services',
  GroceryStoresSupermarkets = 'grocery_stores_supermarkets',
  HardwareEquipmentAndSupplies = 'hardware_equipment_and_supplies',
  HardwareStores = 'hardware_stores',
  HealthAndBeautySpas = 'health_and_beauty_spas',
  HearingAidsSalesAndSupplies = 'hearing_aids_sales_and_supplies',
  HeatingPlumbingAC = 'heating_plumbing_a_c',
  HobbyToyAndGameShops = 'hobby_toy_and_game_shops',
  HomeSupplyWarehouseStores = 'home_supply_warehouse_stores',
  Hospitals = 'hospitals',
  HotelsMotelsAndResorts = 'hotels_motels_and_resorts',
  HouseholdApplianceStores = 'household_appliance_stores',
  IndustrialSupplies = 'industrial_supplies',
  InformationRetrievalServices = 'information_retrieval_services',
  InsuranceDefault = 'insurance_default',
  InsuranceUnderwritingPremiums = 'insurance_underwriting_premiums',
  IntraCompanyPurchases = 'intra_company_purchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'jewelry_stores_watches_clocks_and_silverware_stores',
  LandscapingServices = 'landscaping_services',
  Laundries = 'laundries',
  LaundryCleaningServices = 'laundry_cleaning_services',
  LegalServicesAttorneys = 'legal_services_attorneys',
  LuggageAndLeatherGoodsStores = 'luggage_and_leather_goods_stores',
  LumberBuildingMaterialsStores = 'lumber_building_materials_stores',
  ManualCashDisburse = 'manual_cash_disburse',
  MarinasServiceAndSupplies = 'marinas_service_and_supplies',
  Marketplaces = 'marketplaces',
  MasonryStoneworkAndPlaster = 'masonry_stonework_and_plaster',
  MassageParlors = 'massage_parlors',
  MedicalAndDentalLabs = 'medical_and_dental_labs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
  MedicalServices = 'medical_services',
  MembershipOrganizations = 'membership_organizations',
  MensAndBoysClothingAndAccessoriesStores = 'mens_and_boys_clothing_and_accessories_stores',
  MensWomensClothingStores = 'mens_womens_clothing_stores',
  MetalServiceCenters = 'metal_service_centers',
  Miscellaneous = 'miscellaneous',
  MiscellaneousApparelAndAccessoryShops = 'miscellaneous_apparel_and_accessory_shops',
  MiscellaneousAutoDealers = 'miscellaneous_auto_dealers',
  MiscellaneousBusinessServices = 'miscellaneous_business_services',
  MiscellaneousFoodStores = 'miscellaneous_food_stores',
  MiscellaneousGeneralMerchandise = 'miscellaneous_general_merchandise',
  MiscellaneousGeneralServices = 'miscellaneous_general_services',
  MiscellaneousHomeFurnishingSpecialtyStores = 'miscellaneous_home_furnishing_specialty_stores',
  MiscellaneousPublishingAndPrinting = 'miscellaneous_publishing_and_printing',
  MiscellaneousRecreationServices = 'miscellaneous_recreation_services',
  MiscellaneousRepairShops = 'miscellaneous_repair_shops',
  MiscellaneousSpecialtyRetail = 'miscellaneous_specialty_retail',
  MobileHomeDealers = 'mobile_home_dealers',
  MotionPictureTheaters = 'motion_picture_theaters',
  MotorFreightCarriersAndTrucking = 'motor_freight_carriers_and_trucking',
  MotorHomesDealers = 'motor_homes_dealers',
  MotorVehicleSuppliesAndNewParts = 'motor_vehicle_supplies_and_new_parts',
  MotorcycleShopsAndDealers = 'motorcycle_shops_and_dealers',
  MotorcycleShopsDealers = 'motorcycle_shops_dealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'music_stores_musical_instruments_pianos_and_sheet_music',
  NewsDealersAndNewsstands = 'news_dealers_and_newsstands',
  NonFiMoneyOrders = 'non_fi_money_orders',
  NonFiStoredValueCardPurchaseLoad = 'non_fi_stored_value_card_purchase_load',
  NondurableGoods = 'nondurable_goods',
  NurseriesLawnAndGardenSupplyStores = 'nurseries_lawn_and_garden_supply_stores',
  NursingPersonalCare = 'nursing_personal_care',
  OfficeAndCommercialFurniture = 'office_and_commercial_furniture',
  OpticiansEyeglasses = 'opticians_eyeglasses',
  OptometristsOphthalmologist = 'optometrists_ophthalmologist',
  OrthopedicGoodsProstheticDevices = 'orthopedic_goods_prosthetic_devices',
  Osteopaths = 'osteopaths',
  PackageStoresBeerWineAndLiquor = 'package_stores_beer_wine_and_liquor',
  PaintsVarnishesAndSupplies = 'paints_varnishes_and_supplies',
  ParkingLotsGarages = 'parking_lots_garages',
  PassengerRailways = 'passenger_railways',
  PawnShops = 'pawn_shops',
  PetShopsPetFoodAndSupplies = 'pet_shops_pet_food_and_supplies',
  PetroleumAndPetroleumProducts = 'petroleum_and_petroleum_products',
  PhotoDeveloping = 'photo_developing',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'photographic_photocopy_microfilm_equipment_and_supplies',
  PhotographicStudios = 'photographic_studios',
  PictureVideoProduction = 'picture_video_production',
  PieceGoodsNotionsAndOtherDryGoods = 'piece_goods_notions_and_other_dry_goods',
  PlumbingHeatingEquipmentAndSupplies = 'plumbing_heating_equipment_and_supplies',
  PoliticalOrganizations = 'political_organizations',
  PostalServicesGovernmentOnly = 'postal_services_government_only',
  PreciousStonesAndMetalsWatchesAndJewelry = 'precious_stones_and_metals_watches_and_jewelry',
  ProfessionalServices = 'professional_services',
  PublicWarehousingAndStorage = 'public_warehousing_and_storage',
  QuickCopyReproAndBlueprint = 'quick_copy_repro_and_blueprint',
  Railroads = 'railroads',
  RealEstateAgentsAndManagersRentals = 'real_estate_agents_and_managers_rentals',
  RecordStores = 'record_stores',
  RecreationalVehicleRentals = 'recreational_vehicle_rentals',
  ReligiousGoodsStores = 'religious_goods_stores',
  ReligiousOrganizations = 'religious_organizations',
  RoofingSidingSheetMetal = 'roofing_siding_sheet_metal',
  SecretarialSupportServices = 'secretarial_support_services',
  SecurityBrokersDealers = 'security_brokers_dealers',
  ServiceStations = 'service_stations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'sewing_needlework_fabric_and_piece_goods_stores',
  ShoeRepairHatCleaning = 'shoe_repair_hat_cleaning',
  ShoeStores = 'shoe_stores',
  SmallApplianceRepair = 'small_appliance_repair',
  SnowmobileDealers = 'snowmobile_dealers',
  SpecialTradeServices = 'special_trade_services',
  SpecialtyCleaning = 'specialty_cleaning',
  SportingGoodsStores = 'sporting_goods_stores',
  SportingRecreationCamps = 'sporting_recreation_camps',
  SportsAndRidingApparelStores = 'sports_and_riding_apparel_stores',
  SportsClubsFields = 'sports_clubs_fields',
  StampAndCoinStores = 'stamp_and_coin_stores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'stationary_office_supplies_printing_and_writing_paper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'stationery_stores_office_and_school_supply_stores',
  SwimmingPoolsSales = 'swimming_pools_sales',
  TUiTravelGermany = 't_ui_travel_germany',
  TailorsAlterations = 'tailors_alterations',
  TaxPaymentsGovernmentAgencies = 'tax_payments_government_agencies',
  TaxPreparationServices = 'tax_preparation_services',
  TaxicabsLimousines = 'taxicabs_limousines',
  TelecommunicationEquipmentAndTelephoneSales = 'telecommunication_equipment_and_telephone_sales',
  TelecommunicationServices = 'telecommunication_services',
  TelegraphServices = 'telegraph_services',
  TentAndAwningShops = 'tent_and_awning_shops',
  TestingLaboratories = 'testing_laboratories',
  TheatricalTicketAgencies = 'theatrical_ticket_agencies',
  Timeshares = 'timeshares',
  TireRetreadingAndRepair = 'tire_retreading_and_repair',
  TollsBridgeFees = 'tolls_bridge_fees',
  TouristAttractionsAndExhibits = 'tourist_attractions_and_exhibits',
  TowingServices = 'towing_services',
  TrailerParksCampgrounds = 'trailer_parks_campgrounds',
  TransportationServices = 'transportation_services',
  TravelAgenciesTourOperators = 'travel_agencies_tour_operators',
  TruckStopIteration = 'truck_stop_iteration',
  TruckUtilityTrailerRentals = 'truck_utility_trailer_rentals',
  TypesettingPlateMakingAndRelatedServices = 'typesetting_plate_making_and_related_services',
  TypewriterStores = 'typewriter_stores',
  USFederalGovernmentAgenciesOrDepartments = 'u_s_federal_government_agencies_or_departments',
  UniformsCommercialClothing = 'uniforms_commercial_clothing',
  UsedMerchandiseAndSecondhandStores = 'used_merchandise_and_secondhand_stores',
  Utilities = 'utilities',
  VarietyStores = 'variety_stores',
  VeterinaryServices = 'veterinary_services',
  VideoAmusementGameSupplies = 'video_amusement_game_supplies',
  VideoGameArcades = 'video_game_arcades',
  VideoTapeRentalStores = 'video_tape_rental_stores',
  VocationalTradeSchools = 'vocational_trade_schools',
  WatchJewelryRepair = 'watch_jewelry_repair',
  WeldingRepair = 'welding_repair',
  WholesaleClubs = 'wholesale_clubs',
  WigAndToupeeStores = 'wig_and_toupee_stores',
  WiresMoneyOrders = 'wires_money_orders',
  WomensAccessoryAndSpecialtyShops = 'womens_accessory_and_specialty_shops',
  WomensReadyToWearStores = 'womens_ready_to_wear_stores',
  WreckingAndSalvageYards = 'wrecking_and_salvage_yards',
}

export enum StripeIssuingCardSpendingControlsBlockedCategory {
  AcRefrigerationRepair = 'ac_refrigeration_repair',
  AccountingBookkeepingServices = 'accounting_bookkeeping_services',
  AdvertisingServices = 'advertising_services',
  AgriculturalCooperative = 'agricultural_cooperative',
  AirlinesAirCarriers = 'airlines_air_carriers',
  AirportsFlyingFields = 'airports_flying_fields',
  AmbulanceServices = 'ambulance_services',
  AmusementParksCarnivals = 'amusement_parks_carnivals',
  AntiqueReproductions = 'antique_reproductions',
  AntiqueShops = 'antique_shops',
  Aquariums = 'aquariums',
  ArchitecturalSurveyingServices = 'architectural_surveying_services',
  ArtDealersAndGalleries = 'art_dealers_and_galleries',
  ArtistsSupplyAndCraftShops = 'artists_supply_and_craft_shops',
  AutoAndHomeSupplyStores = 'auto_and_home_supply_stores',
  AutoBodyRepairShops = 'auto_body_repair_shops',
  AutoPaintShops = 'auto_paint_shops',
  AutoServiceShops = 'auto_service_shops',
  AutomatedCashDisburse = 'automated_cash_disburse',
  AutomatedFuelDispensers = 'automated_fuel_dispensers',
  AutomobileAssociations = 'automobile_associations',
  AutomotivePartsAndAccessoriesStores = 'automotive_parts_and_accessories_stores',
  AutomotiveTireStores = 'automotive_tire_stores',
  BailAndBondPayments = 'bail_and_bond_payments',
  Bakeries = 'bakeries',
  BandsOrchestras = 'bands_orchestras',
  BarberAndBeautyShops = 'barber_and_beauty_shops',
  BettingCasinoGambling = 'betting_casino_gambling',
  BicycleShops = 'bicycle_shops',
  BilliardPoolEstablishments = 'billiard_pool_establishments',
  BoatDealers = 'boat_dealers',
  BoatRentalsAndLeases = 'boat_rentals_and_leases',
  BookStores = 'book_stores',
  BooksPeriodicalsAndNewspapers = 'books_periodicals_and_newspapers',
  BowlingAlleys = 'bowling_alleys',
  BusLines = 'bus_lines',
  BusinessSecretarialSchools = 'business_secretarial_schools',
  BuyingShoppingServices = 'buying_shopping_services',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'cable_satellite_and_other_pay_television_and_radio',
  CameraAndPhotographicSupplyStores = 'camera_and_photographic_supply_stores',
  CandyNutAndConfectioneryStores = 'candy_nut_and_confectionery_stores',
  CarAndTruckDealersNewUsed = 'car_and_truck_dealers_new_used',
  CarAndTruckDealersUsedOnly = 'car_and_truck_dealers_used_only',
  CarRentalAgencies = 'car_rental_agencies',
  CarWashes = 'car_washes',
  CarpentryServices = 'carpentry_services',
  CarpetUpholsteryCleaning = 'carpet_upholstery_cleaning',
  Caterers = 'caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'charitable_and_social_service_organizations_fundraising',
  ChemicalsAndAlliedProducts = 'chemicals_and_allied_products',
  ChildCareServices = 'child_care_services',
  ChildrensAndInfantsWearStores = 'childrens_and_infants_wear_stores',
  ChiropodistsPodiatrists = 'chiropodists_podiatrists',
  Chiropractors = 'chiropractors',
  CigarStoresAndStands = 'cigar_stores_and_stands',
  CivicSocialFraternalAssociations = 'civic_social_fraternal_associations',
  CleaningAndMaintenance = 'cleaning_and_maintenance',
  ClothingRental = 'clothing_rental',
  CollegesUniversities = 'colleges_universities',
  CommercialEquipment = 'commercial_equipment',
  CommercialFootwear = 'commercial_footwear',
  CommercialPhotographyArtAndGraphics = 'commercial_photography_art_and_graphics',
  CommuterTransportAndFerries = 'commuter_transport_and_ferries',
  ComputerNetworkServices = 'computer_network_services',
  ComputerProgramming = 'computer_programming',
  ComputerRepair = 'computer_repair',
  ComputerSoftwareStores = 'computer_software_stores',
  ComputersPeripheralsAndSoftware = 'computers_peripherals_and_software',
  ConcreteWorkServices = 'concrete_work_services',
  ConstructionMaterials = 'construction_materials',
  ConsultingPublicRelations = 'consulting_public_relations',
  CorrespondenceSchools = 'correspondence_schools',
  CosmeticStores = 'cosmetic_stores',
  CounselingServices = 'counseling_services',
  CountryClubs = 'country_clubs',
  CourierServices = 'courier_services',
  CourtCosts = 'court_costs',
  CreditReportingAgencies = 'credit_reporting_agencies',
  CruiseLines = 'cruise_lines',
  DairyProductsStores = 'dairy_products_stores',
  DanceHallStudiosSchools = 'dance_hall_studios_schools',
  DatingEscortServices = 'dating_escort_services',
  DentistsOrthodontists = 'dentists_orthodontists',
  DepartmentStores = 'department_stores',
  DetectiveAgencies = 'detective_agencies',
  DigitalGoodsApplications = 'digital_goods_applications',
  DigitalGoodsGames = 'digital_goods_games',
  DigitalGoodsLargeVolume = 'digital_goods_large_volume',
  DigitalGoodsMedia = 'digital_goods_media',
  DirectMarketingCatalogMerchant = 'direct_marketing_catalog_merchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'direct_marketing_combination_catalog_and_retail_merchant',
  DirectMarketingInboundTelemarketing = 'direct_marketing_inbound_telemarketing',
  DirectMarketingInsuranceServices = 'direct_marketing_insurance_services',
  DirectMarketingOther = 'direct_marketing_other',
  DirectMarketingOutboundTelemarketing = 'direct_marketing_outbound_telemarketing',
  DirectMarketingSubscription = 'direct_marketing_subscription',
  DirectMarketingTravel = 'direct_marketing_travel',
  DiscountStores = 'discount_stores',
  Doctors = 'doctors',
  DoorToDoorSales = 'door_to_door_sales',
  DraperyWindowCoveringAndUpholsteryStores = 'drapery_window_covering_and_upholstery_stores',
  DrinkingPlaces = 'drinking_places',
  DrugStoresAndPharmacies = 'drug_stores_and_pharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'drugs_drug_proprietaries_and_druggist_sundries',
  DryCleaners = 'dry_cleaners',
  DurableGoods = 'durable_goods',
  DutyFreeStores = 'duty_free_stores',
  EatingPlacesRestaurants = 'eating_places_restaurants',
  EducationalServices = 'educational_services',
  ElectricRazorStores = 'electric_razor_stores',
  ElectricVehicleCharging = 'electric_vehicle_charging',
  ElectricalPartsAndEquipment = 'electrical_parts_and_equipment',
  ElectricalServices = 'electrical_services',
  ElectronicsRepairShops = 'electronics_repair_shops',
  ElectronicsStores = 'electronics_stores',
  ElementarySecondarySchools = 'elementary_secondary_schools',
  EmergencyServicesGcasVisaUseOnly = 'emergency_services_gcas_visa_use_only',
  EmploymentTempAgencies = 'employment_temp_agencies',
  EquipmentRental = 'equipment_rental',
  ExterminatingServices = 'exterminating_services',
  FamilyClothingStores = 'family_clothing_stores',
  FastFoodRestaurants = 'fast_food_restaurants',
  FinancialInstitutions = 'financial_institutions',
  FinesGovernmentAdministrativeEntities = 'fines_government_administrative_entities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'fireplace_fireplace_screens_and_accessories_stores',
  FloorCoveringStores = 'floor_covering_stores',
  Florists = 'florists',
  FloristsSuppliesNurseryStockAndFlowers = 'florists_supplies_nursery_stock_and_flowers',
  FreezerAndLockerMeatProvisioners = 'freezer_and_locker_meat_provisioners',
  FuelDealersNonAutomotive = 'fuel_dealers_non_automotive',
  FuneralServicesCrematories = 'funeral_services_crematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'furniture_home_furnishings_and_equipment_stores_except_appliances',
  FurnitureRepairRefinishing = 'furniture_repair_refinishing',
  FurriersAndFurShops = 'furriers_and_fur_shops',
  GeneralServices = 'general_services',
  GiftCardNoveltyAndSouvenirShops = 'gift_card_novelty_and_souvenir_shops',
  GlassPaintAndWallpaperStores = 'glass_paint_and_wallpaper_stores',
  GlasswareCrystalStores = 'glassware_crystal_stores',
  GolfCoursesPublic = 'golf_courses_public',
  GovernmentLicensedHorseDogRacingUsRegionOnly = 'government_licensed_horse_dog_racing_us_region_only',
  GovernmentLicensedOnlineCasionsOnlineGamblingUsRegionOnly = 'government_licensed_online_casions_online_gambling_us_region_only',
  GovernmentOwnedLotteriesNonUsRegion = 'government_owned_lotteries_non_us_region',
  GovernmentOwnedLotteriesUsRegionOnly = 'government_owned_lotteries_us_region_only',
  GovernmentServices = 'government_services',
  GroceryStoresSupermarkets = 'grocery_stores_supermarkets',
  HardwareEquipmentAndSupplies = 'hardware_equipment_and_supplies',
  HardwareStores = 'hardware_stores',
  HealthAndBeautySpas = 'health_and_beauty_spas',
  HearingAidsSalesAndSupplies = 'hearing_aids_sales_and_supplies',
  HeatingPlumbingAC = 'heating_plumbing_a_c',
  HobbyToyAndGameShops = 'hobby_toy_and_game_shops',
  HomeSupplyWarehouseStores = 'home_supply_warehouse_stores',
  Hospitals = 'hospitals',
  HotelsMotelsAndResorts = 'hotels_motels_and_resorts',
  HouseholdApplianceStores = 'household_appliance_stores',
  IndustrialSupplies = 'industrial_supplies',
  InformationRetrievalServices = 'information_retrieval_services',
  InsuranceDefault = 'insurance_default',
  InsuranceUnderwritingPremiums = 'insurance_underwriting_premiums',
  IntraCompanyPurchases = 'intra_company_purchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'jewelry_stores_watches_clocks_and_silverware_stores',
  LandscapingServices = 'landscaping_services',
  Laundries = 'laundries',
  LaundryCleaningServices = 'laundry_cleaning_services',
  LegalServicesAttorneys = 'legal_services_attorneys',
  LuggageAndLeatherGoodsStores = 'luggage_and_leather_goods_stores',
  LumberBuildingMaterialsStores = 'lumber_building_materials_stores',
  ManualCashDisburse = 'manual_cash_disburse',
  MarinasServiceAndSupplies = 'marinas_service_and_supplies',
  Marketplaces = 'marketplaces',
  MasonryStoneworkAndPlaster = 'masonry_stonework_and_plaster',
  MassageParlors = 'massage_parlors',
  MedicalAndDentalLabs = 'medical_and_dental_labs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
  MedicalServices = 'medical_services',
  MembershipOrganizations = 'membership_organizations',
  MensAndBoysClothingAndAccessoriesStores = 'mens_and_boys_clothing_and_accessories_stores',
  MensWomensClothingStores = 'mens_womens_clothing_stores',
  MetalServiceCenters = 'metal_service_centers',
  Miscellaneous = 'miscellaneous',
  MiscellaneousApparelAndAccessoryShops = 'miscellaneous_apparel_and_accessory_shops',
  MiscellaneousAutoDealers = 'miscellaneous_auto_dealers',
  MiscellaneousBusinessServices = 'miscellaneous_business_services',
  MiscellaneousFoodStores = 'miscellaneous_food_stores',
  MiscellaneousGeneralMerchandise = 'miscellaneous_general_merchandise',
  MiscellaneousGeneralServices = 'miscellaneous_general_services',
  MiscellaneousHomeFurnishingSpecialtyStores = 'miscellaneous_home_furnishing_specialty_stores',
  MiscellaneousPublishingAndPrinting = 'miscellaneous_publishing_and_printing',
  MiscellaneousRecreationServices = 'miscellaneous_recreation_services',
  MiscellaneousRepairShops = 'miscellaneous_repair_shops',
  MiscellaneousSpecialtyRetail = 'miscellaneous_specialty_retail',
  MobileHomeDealers = 'mobile_home_dealers',
  MotionPictureTheaters = 'motion_picture_theaters',
  MotorFreightCarriersAndTrucking = 'motor_freight_carriers_and_trucking',
  MotorHomesDealers = 'motor_homes_dealers',
  MotorVehicleSuppliesAndNewParts = 'motor_vehicle_supplies_and_new_parts',
  MotorcycleShopsAndDealers = 'motorcycle_shops_and_dealers',
  MotorcycleShopsDealers = 'motorcycle_shops_dealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'music_stores_musical_instruments_pianos_and_sheet_music',
  NewsDealersAndNewsstands = 'news_dealers_and_newsstands',
  NonFiMoneyOrders = 'non_fi_money_orders',
  NonFiStoredValueCardPurchaseLoad = 'non_fi_stored_value_card_purchase_load',
  NondurableGoods = 'nondurable_goods',
  NurseriesLawnAndGardenSupplyStores = 'nurseries_lawn_and_garden_supply_stores',
  NursingPersonalCare = 'nursing_personal_care',
  OfficeAndCommercialFurniture = 'office_and_commercial_furniture',
  OpticiansEyeglasses = 'opticians_eyeglasses',
  OptometristsOphthalmologist = 'optometrists_ophthalmologist',
  OrthopedicGoodsProstheticDevices = 'orthopedic_goods_prosthetic_devices',
  Osteopaths = 'osteopaths',
  PackageStoresBeerWineAndLiquor = 'package_stores_beer_wine_and_liquor',
  PaintsVarnishesAndSupplies = 'paints_varnishes_and_supplies',
  ParkingLotsGarages = 'parking_lots_garages',
  PassengerRailways = 'passenger_railways',
  PawnShops = 'pawn_shops',
  PetShopsPetFoodAndSupplies = 'pet_shops_pet_food_and_supplies',
  PetroleumAndPetroleumProducts = 'petroleum_and_petroleum_products',
  PhotoDeveloping = 'photo_developing',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'photographic_photocopy_microfilm_equipment_and_supplies',
  PhotographicStudios = 'photographic_studios',
  PictureVideoProduction = 'picture_video_production',
  PieceGoodsNotionsAndOtherDryGoods = 'piece_goods_notions_and_other_dry_goods',
  PlumbingHeatingEquipmentAndSupplies = 'plumbing_heating_equipment_and_supplies',
  PoliticalOrganizations = 'political_organizations',
  PostalServicesGovernmentOnly = 'postal_services_government_only',
  PreciousStonesAndMetalsWatchesAndJewelry = 'precious_stones_and_metals_watches_and_jewelry',
  ProfessionalServices = 'professional_services',
  PublicWarehousingAndStorage = 'public_warehousing_and_storage',
  QuickCopyReproAndBlueprint = 'quick_copy_repro_and_blueprint',
  Railroads = 'railroads',
  RealEstateAgentsAndManagersRentals = 'real_estate_agents_and_managers_rentals',
  RecordStores = 'record_stores',
  RecreationalVehicleRentals = 'recreational_vehicle_rentals',
  ReligiousGoodsStores = 'religious_goods_stores',
  ReligiousOrganizations = 'religious_organizations',
  RoofingSidingSheetMetal = 'roofing_siding_sheet_metal',
  SecretarialSupportServices = 'secretarial_support_services',
  SecurityBrokersDealers = 'security_brokers_dealers',
  ServiceStations = 'service_stations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'sewing_needlework_fabric_and_piece_goods_stores',
  ShoeRepairHatCleaning = 'shoe_repair_hat_cleaning',
  ShoeStores = 'shoe_stores',
  SmallApplianceRepair = 'small_appliance_repair',
  SnowmobileDealers = 'snowmobile_dealers',
  SpecialTradeServices = 'special_trade_services',
  SpecialtyCleaning = 'specialty_cleaning',
  SportingGoodsStores = 'sporting_goods_stores',
  SportingRecreationCamps = 'sporting_recreation_camps',
  SportsAndRidingApparelStores = 'sports_and_riding_apparel_stores',
  SportsClubsFields = 'sports_clubs_fields',
  StampAndCoinStores = 'stamp_and_coin_stores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'stationary_office_supplies_printing_and_writing_paper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'stationery_stores_office_and_school_supply_stores',
  SwimmingPoolsSales = 'swimming_pools_sales',
  TUiTravelGermany = 't_ui_travel_germany',
  TailorsAlterations = 'tailors_alterations',
  TaxPaymentsGovernmentAgencies = 'tax_payments_government_agencies',
  TaxPreparationServices = 'tax_preparation_services',
  TaxicabsLimousines = 'taxicabs_limousines',
  TelecommunicationEquipmentAndTelephoneSales = 'telecommunication_equipment_and_telephone_sales',
  TelecommunicationServices = 'telecommunication_services',
  TelegraphServices = 'telegraph_services',
  TentAndAwningShops = 'tent_and_awning_shops',
  TestingLaboratories = 'testing_laboratories',
  TheatricalTicketAgencies = 'theatrical_ticket_agencies',
  Timeshares = 'timeshares',
  TireRetreadingAndRepair = 'tire_retreading_and_repair',
  TollsBridgeFees = 'tolls_bridge_fees',
  TouristAttractionsAndExhibits = 'tourist_attractions_and_exhibits',
  TowingServices = 'towing_services',
  TrailerParksCampgrounds = 'trailer_parks_campgrounds',
  TransportationServices = 'transportation_services',
  TravelAgenciesTourOperators = 'travel_agencies_tour_operators',
  TruckStopIteration = 'truck_stop_iteration',
  TruckUtilityTrailerRentals = 'truck_utility_trailer_rentals',
  TypesettingPlateMakingAndRelatedServices = 'typesetting_plate_making_and_related_services',
  TypewriterStores = 'typewriter_stores',
  USFederalGovernmentAgenciesOrDepartments = 'u_s_federal_government_agencies_or_departments',
  UniformsCommercialClothing = 'uniforms_commercial_clothing',
  UsedMerchandiseAndSecondhandStores = 'used_merchandise_and_secondhand_stores',
  Utilities = 'utilities',
  VarietyStores = 'variety_stores',
  VeterinaryServices = 'veterinary_services',
  VideoAmusementGameSupplies = 'video_amusement_game_supplies',
  VideoGameArcades = 'video_game_arcades',
  VideoTapeRentalStores = 'video_tape_rental_stores',
  VocationalTradeSchools = 'vocational_trade_schools',
  WatchJewelryRepair = 'watch_jewelry_repair',
  WeldingRepair = 'welding_repair',
  WholesaleClubs = 'wholesale_clubs',
  WigAndToupeeStores = 'wig_and_toupee_stores',
  WiresMoneyOrders = 'wires_money_orders',
  WomensAccessoryAndSpecialtyShops = 'womens_accessory_and_specialty_shops',
  WomensReadyToWearStores = 'womens_ready_to_wear_stores',
  WreckingAndSalvageYards = 'wrecking_and_salvage_yards',
}

export interface StripeIssuingCardSpendingControlsSpendingLimit {
  /** Maximum amount allowed to spend per interval. This amount is in the card's currency and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount: number;
  /** Array of strings containing [categories](https://stripe.com/docs/api#issuing_authorization_object-merchant_data-category) this limit applies to. Omitting this field will apply the limit to all categories. */
  categories: StripeIssuingCardSpendingControlsSpendingLimitCategory[] | null;
  /** Interval (or event) to which the amount applies. */
  interval: StripeIssuingCardSpendingControlsSpendingLimitInterval;
}

export enum StripeIssuingCardSpendingControlsSpendingLimitCategory {
  AcRefrigerationRepair = 'ac_refrigeration_repair',
  AccountingBookkeepingServices = 'accounting_bookkeeping_services',
  AdvertisingServices = 'advertising_services',
  AgriculturalCooperative = 'agricultural_cooperative',
  AirlinesAirCarriers = 'airlines_air_carriers',
  AirportsFlyingFields = 'airports_flying_fields',
  AmbulanceServices = 'ambulance_services',
  AmusementParksCarnivals = 'amusement_parks_carnivals',
  AntiqueReproductions = 'antique_reproductions',
  AntiqueShops = 'antique_shops',
  Aquariums = 'aquariums',
  ArchitecturalSurveyingServices = 'architectural_surveying_services',
  ArtDealersAndGalleries = 'art_dealers_and_galleries',
  ArtistsSupplyAndCraftShops = 'artists_supply_and_craft_shops',
  AutoAndHomeSupplyStores = 'auto_and_home_supply_stores',
  AutoBodyRepairShops = 'auto_body_repair_shops',
  AutoPaintShops = 'auto_paint_shops',
  AutoServiceShops = 'auto_service_shops',
  AutomatedCashDisburse = 'automated_cash_disburse',
  AutomatedFuelDispensers = 'automated_fuel_dispensers',
  AutomobileAssociations = 'automobile_associations',
  AutomotivePartsAndAccessoriesStores = 'automotive_parts_and_accessories_stores',
  AutomotiveTireStores = 'automotive_tire_stores',
  BailAndBondPayments = 'bail_and_bond_payments',
  Bakeries = 'bakeries',
  BandsOrchestras = 'bands_orchestras',
  BarberAndBeautyShops = 'barber_and_beauty_shops',
  BettingCasinoGambling = 'betting_casino_gambling',
  BicycleShops = 'bicycle_shops',
  BilliardPoolEstablishments = 'billiard_pool_establishments',
  BoatDealers = 'boat_dealers',
  BoatRentalsAndLeases = 'boat_rentals_and_leases',
  BookStores = 'book_stores',
  BooksPeriodicalsAndNewspapers = 'books_periodicals_and_newspapers',
  BowlingAlleys = 'bowling_alleys',
  BusLines = 'bus_lines',
  BusinessSecretarialSchools = 'business_secretarial_schools',
  BuyingShoppingServices = 'buying_shopping_services',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'cable_satellite_and_other_pay_television_and_radio',
  CameraAndPhotographicSupplyStores = 'camera_and_photographic_supply_stores',
  CandyNutAndConfectioneryStores = 'candy_nut_and_confectionery_stores',
  CarAndTruckDealersNewUsed = 'car_and_truck_dealers_new_used',
  CarAndTruckDealersUsedOnly = 'car_and_truck_dealers_used_only',
  CarRentalAgencies = 'car_rental_agencies',
  CarWashes = 'car_washes',
  CarpentryServices = 'carpentry_services',
  CarpetUpholsteryCleaning = 'carpet_upholstery_cleaning',
  Caterers = 'caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'charitable_and_social_service_organizations_fundraising',
  ChemicalsAndAlliedProducts = 'chemicals_and_allied_products',
  ChildCareServices = 'child_care_services',
  ChildrensAndInfantsWearStores = 'childrens_and_infants_wear_stores',
  ChiropodistsPodiatrists = 'chiropodists_podiatrists',
  Chiropractors = 'chiropractors',
  CigarStoresAndStands = 'cigar_stores_and_stands',
  CivicSocialFraternalAssociations = 'civic_social_fraternal_associations',
  CleaningAndMaintenance = 'cleaning_and_maintenance',
  ClothingRental = 'clothing_rental',
  CollegesUniversities = 'colleges_universities',
  CommercialEquipment = 'commercial_equipment',
  CommercialFootwear = 'commercial_footwear',
  CommercialPhotographyArtAndGraphics = 'commercial_photography_art_and_graphics',
  CommuterTransportAndFerries = 'commuter_transport_and_ferries',
  ComputerNetworkServices = 'computer_network_services',
  ComputerProgramming = 'computer_programming',
  ComputerRepair = 'computer_repair',
  ComputerSoftwareStores = 'computer_software_stores',
  ComputersPeripheralsAndSoftware = 'computers_peripherals_and_software',
  ConcreteWorkServices = 'concrete_work_services',
  ConstructionMaterials = 'construction_materials',
  ConsultingPublicRelations = 'consulting_public_relations',
  CorrespondenceSchools = 'correspondence_schools',
  CosmeticStores = 'cosmetic_stores',
  CounselingServices = 'counseling_services',
  CountryClubs = 'country_clubs',
  CourierServices = 'courier_services',
  CourtCosts = 'court_costs',
  CreditReportingAgencies = 'credit_reporting_agencies',
  CruiseLines = 'cruise_lines',
  DairyProductsStores = 'dairy_products_stores',
  DanceHallStudiosSchools = 'dance_hall_studios_schools',
  DatingEscortServices = 'dating_escort_services',
  DentistsOrthodontists = 'dentists_orthodontists',
  DepartmentStores = 'department_stores',
  DetectiveAgencies = 'detective_agencies',
  DigitalGoodsApplications = 'digital_goods_applications',
  DigitalGoodsGames = 'digital_goods_games',
  DigitalGoodsLargeVolume = 'digital_goods_large_volume',
  DigitalGoodsMedia = 'digital_goods_media',
  DirectMarketingCatalogMerchant = 'direct_marketing_catalog_merchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'direct_marketing_combination_catalog_and_retail_merchant',
  DirectMarketingInboundTelemarketing = 'direct_marketing_inbound_telemarketing',
  DirectMarketingInsuranceServices = 'direct_marketing_insurance_services',
  DirectMarketingOther = 'direct_marketing_other',
  DirectMarketingOutboundTelemarketing = 'direct_marketing_outbound_telemarketing',
  DirectMarketingSubscription = 'direct_marketing_subscription',
  DirectMarketingTravel = 'direct_marketing_travel',
  DiscountStores = 'discount_stores',
  Doctors = 'doctors',
  DoorToDoorSales = 'door_to_door_sales',
  DraperyWindowCoveringAndUpholsteryStores = 'drapery_window_covering_and_upholstery_stores',
  DrinkingPlaces = 'drinking_places',
  DrugStoresAndPharmacies = 'drug_stores_and_pharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'drugs_drug_proprietaries_and_druggist_sundries',
  DryCleaners = 'dry_cleaners',
  DurableGoods = 'durable_goods',
  DutyFreeStores = 'duty_free_stores',
  EatingPlacesRestaurants = 'eating_places_restaurants',
  EducationalServices = 'educational_services',
  ElectricRazorStores = 'electric_razor_stores',
  ElectricVehicleCharging = 'electric_vehicle_charging',
  ElectricalPartsAndEquipment = 'electrical_parts_and_equipment',
  ElectricalServices = 'electrical_services',
  ElectronicsRepairShops = 'electronics_repair_shops',
  ElectronicsStores = 'electronics_stores',
  ElementarySecondarySchools = 'elementary_secondary_schools',
  EmergencyServicesGcasVisaUseOnly = 'emergency_services_gcas_visa_use_only',
  EmploymentTempAgencies = 'employment_temp_agencies',
  EquipmentRental = 'equipment_rental',
  ExterminatingServices = 'exterminating_services',
  FamilyClothingStores = 'family_clothing_stores',
  FastFoodRestaurants = 'fast_food_restaurants',
  FinancialInstitutions = 'financial_institutions',
  FinesGovernmentAdministrativeEntities = 'fines_government_administrative_entities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'fireplace_fireplace_screens_and_accessories_stores',
  FloorCoveringStores = 'floor_covering_stores',
  Florists = 'florists',
  FloristsSuppliesNurseryStockAndFlowers = 'florists_supplies_nursery_stock_and_flowers',
  FreezerAndLockerMeatProvisioners = 'freezer_and_locker_meat_provisioners',
  FuelDealersNonAutomotive = 'fuel_dealers_non_automotive',
  FuneralServicesCrematories = 'funeral_services_crematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'furniture_home_furnishings_and_equipment_stores_except_appliances',
  FurnitureRepairRefinishing = 'furniture_repair_refinishing',
  FurriersAndFurShops = 'furriers_and_fur_shops',
  GeneralServices = 'general_services',
  GiftCardNoveltyAndSouvenirShops = 'gift_card_novelty_and_souvenir_shops',
  GlassPaintAndWallpaperStores = 'glass_paint_and_wallpaper_stores',
  GlasswareCrystalStores = 'glassware_crystal_stores',
  GolfCoursesPublic = 'golf_courses_public',
  GovernmentLicensedHorseDogRacingUsRegionOnly = 'government_licensed_horse_dog_racing_us_region_only',
  GovernmentLicensedOnlineCasionsOnlineGamblingUsRegionOnly = 'government_licensed_online_casions_online_gambling_us_region_only',
  GovernmentOwnedLotteriesNonUsRegion = 'government_owned_lotteries_non_us_region',
  GovernmentOwnedLotteriesUsRegionOnly = 'government_owned_lotteries_us_region_only',
  GovernmentServices = 'government_services',
  GroceryStoresSupermarkets = 'grocery_stores_supermarkets',
  HardwareEquipmentAndSupplies = 'hardware_equipment_and_supplies',
  HardwareStores = 'hardware_stores',
  HealthAndBeautySpas = 'health_and_beauty_spas',
  HearingAidsSalesAndSupplies = 'hearing_aids_sales_and_supplies',
  HeatingPlumbingAC = 'heating_plumbing_a_c',
  HobbyToyAndGameShops = 'hobby_toy_and_game_shops',
  HomeSupplyWarehouseStores = 'home_supply_warehouse_stores',
  Hospitals = 'hospitals',
  HotelsMotelsAndResorts = 'hotels_motels_and_resorts',
  HouseholdApplianceStores = 'household_appliance_stores',
  IndustrialSupplies = 'industrial_supplies',
  InformationRetrievalServices = 'information_retrieval_services',
  InsuranceDefault = 'insurance_default',
  InsuranceUnderwritingPremiums = 'insurance_underwriting_premiums',
  IntraCompanyPurchases = 'intra_company_purchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'jewelry_stores_watches_clocks_and_silverware_stores',
  LandscapingServices = 'landscaping_services',
  Laundries = 'laundries',
  LaundryCleaningServices = 'laundry_cleaning_services',
  LegalServicesAttorneys = 'legal_services_attorneys',
  LuggageAndLeatherGoodsStores = 'luggage_and_leather_goods_stores',
  LumberBuildingMaterialsStores = 'lumber_building_materials_stores',
  ManualCashDisburse = 'manual_cash_disburse',
  MarinasServiceAndSupplies = 'marinas_service_and_supplies',
  Marketplaces = 'marketplaces',
  MasonryStoneworkAndPlaster = 'masonry_stonework_and_plaster',
  MassageParlors = 'massage_parlors',
  MedicalAndDentalLabs = 'medical_and_dental_labs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
  MedicalServices = 'medical_services',
  MembershipOrganizations = 'membership_organizations',
  MensAndBoysClothingAndAccessoriesStores = 'mens_and_boys_clothing_and_accessories_stores',
  MensWomensClothingStores = 'mens_womens_clothing_stores',
  MetalServiceCenters = 'metal_service_centers',
  Miscellaneous = 'miscellaneous',
  MiscellaneousApparelAndAccessoryShops = 'miscellaneous_apparel_and_accessory_shops',
  MiscellaneousAutoDealers = 'miscellaneous_auto_dealers',
  MiscellaneousBusinessServices = 'miscellaneous_business_services',
  MiscellaneousFoodStores = 'miscellaneous_food_stores',
  MiscellaneousGeneralMerchandise = 'miscellaneous_general_merchandise',
  MiscellaneousGeneralServices = 'miscellaneous_general_services',
  MiscellaneousHomeFurnishingSpecialtyStores = 'miscellaneous_home_furnishing_specialty_stores',
  MiscellaneousPublishingAndPrinting = 'miscellaneous_publishing_and_printing',
  MiscellaneousRecreationServices = 'miscellaneous_recreation_services',
  MiscellaneousRepairShops = 'miscellaneous_repair_shops',
  MiscellaneousSpecialtyRetail = 'miscellaneous_specialty_retail',
  MobileHomeDealers = 'mobile_home_dealers',
  MotionPictureTheaters = 'motion_picture_theaters',
  MotorFreightCarriersAndTrucking = 'motor_freight_carriers_and_trucking',
  MotorHomesDealers = 'motor_homes_dealers',
  MotorVehicleSuppliesAndNewParts = 'motor_vehicle_supplies_and_new_parts',
  MotorcycleShopsAndDealers = 'motorcycle_shops_and_dealers',
  MotorcycleShopsDealers = 'motorcycle_shops_dealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'music_stores_musical_instruments_pianos_and_sheet_music',
  NewsDealersAndNewsstands = 'news_dealers_and_newsstands',
  NonFiMoneyOrders = 'non_fi_money_orders',
  NonFiStoredValueCardPurchaseLoad = 'non_fi_stored_value_card_purchase_load',
  NondurableGoods = 'nondurable_goods',
  NurseriesLawnAndGardenSupplyStores = 'nurseries_lawn_and_garden_supply_stores',
  NursingPersonalCare = 'nursing_personal_care',
  OfficeAndCommercialFurniture = 'office_and_commercial_furniture',
  OpticiansEyeglasses = 'opticians_eyeglasses',
  OptometristsOphthalmologist = 'optometrists_ophthalmologist',
  OrthopedicGoodsProstheticDevices = 'orthopedic_goods_prosthetic_devices',
  Osteopaths = 'osteopaths',
  PackageStoresBeerWineAndLiquor = 'package_stores_beer_wine_and_liquor',
  PaintsVarnishesAndSupplies = 'paints_varnishes_and_supplies',
  ParkingLotsGarages = 'parking_lots_garages',
  PassengerRailways = 'passenger_railways',
  PawnShops = 'pawn_shops',
  PetShopsPetFoodAndSupplies = 'pet_shops_pet_food_and_supplies',
  PetroleumAndPetroleumProducts = 'petroleum_and_petroleum_products',
  PhotoDeveloping = 'photo_developing',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'photographic_photocopy_microfilm_equipment_and_supplies',
  PhotographicStudios = 'photographic_studios',
  PictureVideoProduction = 'picture_video_production',
  PieceGoodsNotionsAndOtherDryGoods = 'piece_goods_notions_and_other_dry_goods',
  PlumbingHeatingEquipmentAndSupplies = 'plumbing_heating_equipment_and_supplies',
  PoliticalOrganizations = 'political_organizations',
  PostalServicesGovernmentOnly = 'postal_services_government_only',
  PreciousStonesAndMetalsWatchesAndJewelry = 'precious_stones_and_metals_watches_and_jewelry',
  ProfessionalServices = 'professional_services',
  PublicWarehousingAndStorage = 'public_warehousing_and_storage',
  QuickCopyReproAndBlueprint = 'quick_copy_repro_and_blueprint',
  Railroads = 'railroads',
  RealEstateAgentsAndManagersRentals = 'real_estate_agents_and_managers_rentals',
  RecordStores = 'record_stores',
  RecreationalVehicleRentals = 'recreational_vehicle_rentals',
  ReligiousGoodsStores = 'religious_goods_stores',
  ReligiousOrganizations = 'religious_organizations',
  RoofingSidingSheetMetal = 'roofing_siding_sheet_metal',
  SecretarialSupportServices = 'secretarial_support_services',
  SecurityBrokersDealers = 'security_brokers_dealers',
  ServiceStations = 'service_stations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'sewing_needlework_fabric_and_piece_goods_stores',
  ShoeRepairHatCleaning = 'shoe_repair_hat_cleaning',
  ShoeStores = 'shoe_stores',
  SmallApplianceRepair = 'small_appliance_repair',
  SnowmobileDealers = 'snowmobile_dealers',
  SpecialTradeServices = 'special_trade_services',
  SpecialtyCleaning = 'specialty_cleaning',
  SportingGoodsStores = 'sporting_goods_stores',
  SportingRecreationCamps = 'sporting_recreation_camps',
  SportsAndRidingApparelStores = 'sports_and_riding_apparel_stores',
  SportsClubsFields = 'sports_clubs_fields',
  StampAndCoinStores = 'stamp_and_coin_stores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'stationary_office_supplies_printing_and_writing_paper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'stationery_stores_office_and_school_supply_stores',
  SwimmingPoolsSales = 'swimming_pools_sales',
  TUiTravelGermany = 't_ui_travel_germany',
  TailorsAlterations = 'tailors_alterations',
  TaxPaymentsGovernmentAgencies = 'tax_payments_government_agencies',
  TaxPreparationServices = 'tax_preparation_services',
  TaxicabsLimousines = 'taxicabs_limousines',
  TelecommunicationEquipmentAndTelephoneSales = 'telecommunication_equipment_and_telephone_sales',
  TelecommunicationServices = 'telecommunication_services',
  TelegraphServices = 'telegraph_services',
  TentAndAwningShops = 'tent_and_awning_shops',
  TestingLaboratories = 'testing_laboratories',
  TheatricalTicketAgencies = 'theatrical_ticket_agencies',
  Timeshares = 'timeshares',
  TireRetreadingAndRepair = 'tire_retreading_and_repair',
  TollsBridgeFees = 'tolls_bridge_fees',
  TouristAttractionsAndExhibits = 'tourist_attractions_and_exhibits',
  TowingServices = 'towing_services',
  TrailerParksCampgrounds = 'trailer_parks_campgrounds',
  TransportationServices = 'transportation_services',
  TravelAgenciesTourOperators = 'travel_agencies_tour_operators',
  TruckStopIteration = 'truck_stop_iteration',
  TruckUtilityTrailerRentals = 'truck_utility_trailer_rentals',
  TypesettingPlateMakingAndRelatedServices = 'typesetting_plate_making_and_related_services',
  TypewriterStores = 'typewriter_stores',
  USFederalGovernmentAgenciesOrDepartments = 'u_s_federal_government_agencies_or_departments',
  UniformsCommercialClothing = 'uniforms_commercial_clothing',
  UsedMerchandiseAndSecondhandStores = 'used_merchandise_and_secondhand_stores',
  Utilities = 'utilities',
  VarietyStores = 'variety_stores',
  VeterinaryServices = 'veterinary_services',
  VideoAmusementGameSupplies = 'video_amusement_game_supplies',
  VideoGameArcades = 'video_game_arcades',
  VideoTapeRentalStores = 'video_tape_rental_stores',
  VocationalTradeSchools = 'vocational_trade_schools',
  WatchJewelryRepair = 'watch_jewelry_repair',
  WeldingRepair = 'welding_repair',
  WholesaleClubs = 'wholesale_clubs',
  WigAndToupeeStores = 'wig_and_toupee_stores',
  WiresMoneyOrders = 'wires_money_orders',
  WomensAccessoryAndSpecialtyShops = 'womens_accessory_and_specialty_shops',
  WomensReadyToWearStores = 'womens_ready_to_wear_stores',
  WreckingAndSalvageYards = 'wrecking_and_salvage_yards',
}

export enum StripeIssuingCardSpendingControlsSpendingLimitInterval {
  AllTime = 'all_time',
  Daily = 'daily',
  Monthly = 'monthly',
  PerAuthorization = 'per_authorization',
  Weekly = 'weekly',
  Yearly = 'yearly',
}

export enum StripeIssuingCardStatus {
  Active = 'active',
  Canceled = 'canceled',
  Inactive = 'inactive',
}

export enum StripeIssuingCardType {
  Physical = 'physical',
  Virtual = 'virtual',
}

export interface StripeIssuingCardWallets {
  apple_pay: StripeIssuingCardWalletsApplePay;
  google_pay: StripeIssuingCardWalletsGooglePay;
  /** Unique identifier for a card used with digital wallets */
  primary_account_identifier: string | null;
}

export interface StripeIssuingCardWalletsApplePay {
  /** Apple Pay Eligibility */
  eligible: boolean;
  /** Reason the card is ineligible for Apple Pay */
  ineligible_reason: StripeIssuingCardWalletsApplePayIneligibleReason | null;
}

export enum StripeIssuingCardWalletsApplePayIneligibleReason {
  MissingAgreement = 'missing_agreement',
  MissingCardholderContact = 'missing_cardholder_contact',
  UnsupportedRegion = 'unsupported_region',
}

export interface StripeIssuingCardWalletsGooglePay {
  /** Google Pay Eligibility */
  eligible: boolean;
  /** Reason the card is ineligible for Google Pay */
  ineligible_reason: StripeIssuingCardWalletsGooglePayIneligibleReason | null;
}

export enum StripeIssuingCardWalletsGooglePayIneligibleReason {
  MissingAgreement = 'missing_agreement',
  MissingCardholderContact = 'missing_cardholder_contact',
  UnsupportedRegion = 'unsupported_region',
}

export interface StripeIssuingAuthorizationMerchantData {
  /** A categorization of the seller's type of business. See our [merchant categories guide](https://stripe.com/docs/issuing/merchant-categories) for a list of possible values. */
  category: string;
  /** The merchant category code for the seller's business */
  category_code: string;
  /** City where the seller is located */
  city: string | null;
  /** Country where the seller is located */
  country: string | null;
  /** Name of the seller */
  name: string | null;
  /** Identifier assigned to the seller by the card network. Different card networks may assign different network_id fields to the same merchant. */
  network_id: string;
  /** Postal code where the seller is located */
  postal_code: string | null;
  /** State where the seller is located */
  state: string | null;
  /** An ID assigned by the seller to the location of the sale. */
  terminal_id: string | null;
}

export interface StripeIssuingAuthorizationNetworkData {
  /** Identifier assigned to the acquirer by the card network. Sometimes this value is not provided by the network; in this case, the value will be `null`. */
  acquiring_institution_id: string | null;
}

export interface StripeIssuingAuthorizationPendingRequest {
  /** The additional amount Stripe will hold if the authorization is approved, in the card's [currency](https://stripe.com/docs/api#issuing_authorization_object-pending-request-currency) and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount: number;
  /** Detailed breakdown of amount components. These amounts are denominated in `currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount_details: StripeIssuingAuthorizationPendingRequestAmountDetails | null;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** If set `true`, you may provide [amount](https://stripe.com/docs/api/issuing/authorizations/approve#approve_issuing_authorization-amount) to control how much to hold for the authorization. */
  is_amount_controllable: boolean;
  /** The amount the merchant is requesting to be authorized in the `merchant_currency`. The amount is in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  merchant_amount: number;
  /** The local currency the merchant is requesting to authorize. */
  merchant_currency: string;
}

export interface StripeIssuingAuthorizationPendingRequestAmountDetails {
  /** The fee charged by the ATM for the cash withdrawal. */
  atm_fee: number | null;
}

export interface StripeIssuingAuthorizationRequestHistory {
  /** The `pending_request.amount` at the time of the request, presented in your card's currency and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). Stripe held this amount from your account to fund the authorization if the request was approved. */
  amount: number;
  /** Detailed breakdown of amount components. These amounts are denominated in `currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount_details: StripeIssuingAuthorizationRequestHistoryAmountDetails | null;
  /** Whether this request was approved. */
  approved: boolean;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** The `pending_request.merchant_amount` at the time of the request, presented in the `merchant_currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  merchant_amount: number;
  /** The currency that was collected by the merchant and presented to the cardholder for the authorization. Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  merchant_currency: string;
  /** When an authorization is approved or declined by you or by Stripe, this field provides additional detail on the reason for the outcome. */
  reason: StripeIssuingAuthorizationRequestHistoryReason;
  /** If approve/decline decision is directly responsed to the webhook with json payload and if the response is invalid (e.g., parsing errors), we surface the detailed message via this field. */
  reason_message: string | null;
}

export interface StripeIssuingAuthorizationRequestHistoryAmountDetails {
  /** The fee charged by the ATM for the cash withdrawal. */
  atm_fee: number | null;
}

export enum StripeIssuingAuthorizationRequestHistoryReason {
  AccountDisabled = 'account_disabled',
  CardActive = 'card_active',
  CardInactive = 'card_inactive',
  CardholderInactive = 'cardholder_inactive',
  CardholderVerificationRequired = 'cardholder_verification_required',
  InsufficientFunds = 'insufficient_funds',
  NotAllowed = 'not_allowed',
  SpendingControls = 'spending_controls',
  SuspectedFraud = 'suspected_fraud',
  VerificationFailed = 'verification_failed',
  WebhookApproved = 'webhook_approved',
  WebhookDeclined = 'webhook_declined',
  WebhookError = 'webhook_error',
  WebhookTimeout = 'webhook_timeout',
}

export enum StripeIssuingAuthorizationStatus {
  Closed = 'closed',
  Pending = 'pending',
  Reversed = 'reversed',
}

/**
 * Any use of an [issued card](https://stripe.com/docs/issuing) that results in funds entering or leaving your Stripe account, such as a completed purchase or refund, is represented by an Issuing `Transaction` object.
 *
 * Related guide: [Issued card transactions](https://stripe.com/docs/issuing/purchases/transactions)
 */
export interface StripeIssuingTransaction {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'issuing.transaction';
  /** The transaction amount, which will be reflected in your balance. This amount is in your currency and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount: number;
  /** Detailed breakdown of amount components. These amounts are denominated in `currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). */
  amount_details: StripeIssuingTransactionAmountDetails | null;
  /** The `Authorization` object that led to this transaction. */
  authorization: string | StripeIssuingAuthorization | null;
  /** ID of the [balance transaction](https://stripe.com/docs/api/balance_transactions) associated with this transaction. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** The card used to make this transaction. */
  card: string | StripeIssuingCard;
  /** The cardholder to whom this transaction belongs. */
  cardholder: string | StripeIssuingCardholder | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** If you've disputed the transaction, the ID of the dispute. */
  dispute: string | StripeIssuingDispute | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** The amount that the merchant will receive, denominated in `merchant_currency` and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). It will be different from `amount` if the merchant is taking payment in a different currency. */
  merchant_amount: number;
  /** The currency with which the merchant is taking payment. */
  merchant_currency: string;
  merchant_data: StripeIssuingTransactionMerchantData;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** Additional purchase information that is optionally provided by the merchant. */
  purchase_details: StripeIssuingTransactionPurchaseDetails | null;
  /** [Treasury](https://stripe.com/docs/api/treasury) details related to this transaction if it was created on a [FinancialAccount](/docs/api/treasury/financial_accounts */
  treasury?: StripeIssuingTransactionTreasury | null;
  /** The nature of the transaction. */
  type: StripeIssuingTransactionType;
  /** The digital wallet used for this transaction. One of `apple_pay`, `google_pay`, or `samsung_pay`. */
  wallet: StripeIssuingTransactionWallet | null;
}

export interface StripeIssuingTransactionAmountDetails {
  /** The fee charged by the ATM for the cash withdrawal. */
  atm_fee: number | null;
}

/**
 * As a [card issuer](https://stripe.com/docs/issuing), you can dispute transactions that the cardholder does not recognize, suspects to be fraudulent, or has other issues with.
 *
 * Related guide: [Issuing disputes](https://stripe.com/docs/issuing/purchases/disputes)
 */
export interface StripeIssuingDispute {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'issuing.dispute';
  /** Disputed amount in the card's currency and in the [smallest currency unit](https://stripe.com/docs/currencies#zero-decimal). Usually the amount of the `transaction`, but can differ (usually because of currency fluctuation). */
  amount: number;
  /** List of balance transactions associated with the dispute. */
  balance_transactions: StripeBalanceTransaction[] | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** The currency the `transaction` was made in. */
  currency: string;
  evidence: StripeIssuingDisputeEvidence;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** Current status of the dispute. */
  status: StripeIssuingDisputeStatus;
  /** The transaction being disputed. */
  transaction: string | StripeIssuingTransaction;
  /** [Treasury](https://stripe.com/docs/api/treasury) details related to this dispute if it was created on a [FinancialAccount](/docs/api/treasury/financial_accounts */
  treasury?: StripeIssuingDisputeTreasury | null;
}

export interface StripeIssuingDisputeEvidence {
  canceled?: StripeIssuingDisputeEvidenceCanceled;
  duplicate?: StripeIssuingDisputeEvidenceDuplicate;
  fraudulent?: StripeIssuingDisputeEvidenceFraudulent;
  merchandise_not_as_described?: StripeIssuingDisputeEvidenceMerchandiseNotAsDescribed;
  not_received?: StripeIssuingDisputeEvidenceNotReceived;
  other?: StripeIssuingDisputeEvidenceOther;
  /** The reason for filing the dispute. Its value will match the field containing the evidence. */
  reason: StripeIssuingDisputeEvidenceReason;
  service_not_as_described?: StripeIssuingDisputeEvidenceServiceNotAsDescribed;
}

export interface StripeIssuingDisputeEvidenceCanceled {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** Date when order was canceled. */
  canceled_at: number | null;
  /** Whether the cardholder was provided with a cancellation policy. */
  cancellation_policy_provided: boolean | null;
  /** Reason for canceling the order. */
  cancellation_reason: string | null;
  /** Date when the cardholder expected to receive the product. */
  expected_at: number | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
  /** Description of the merchandise or service that was purchased. */
  product_description: string | null;
  /** Whether the product was a merchandise or service. */
  product_type: StripeIssuingDisputeEvidenceCanceledProductType | null;
  /** Result of cardholder's attempt to return the product. */
  return_status: StripeIssuingDisputeEvidenceCanceledReturnStatus | null;
  /** Date when the product was returned or attempted to be returned. */
  returned_at: number | null;
}

export enum StripeIssuingDisputeEvidenceCanceledProductType {
  Merchandise = 'merchandise',
  Service = 'service',
}

export enum StripeIssuingDisputeEvidenceCanceledReturnStatus {
  MerchantRejected = 'merchant_rejected',
  Successful = 'successful',
}

export interface StripeIssuingDisputeEvidenceDuplicate {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Copy of the card statement showing that the product had already been paid for. */
  card_statement: string | StripeFile | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Copy of the receipt showing that the product had been paid for in cash. */
  cash_receipt: string | StripeFile | null;
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Image of the front and back of the check that was used to pay for the product. */
  check_image: string | StripeFile | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
  /** Transaction (e.g., ipi_...) that the disputed transaction is a duplicate of. Of the two or more transactions that are copies of each other, this is original undisputed one. */
  original_transaction: string | null;
}

export interface StripeIssuingDisputeEvidenceFraudulent {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
}

export interface StripeIssuingDisputeEvidenceMerchandiseNotAsDescribed {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
  /** Date when the product was received. */
  received_at: number | null;
  /** Description of the cardholder's attempt to return the product. */
  return_description: string | null;
  /** Result of cardholder's attempt to return the product. */
  return_status: StripeIssuingDisputeEvidenceMerchandiseNotAsDescribedReturnStatus | null;
  /** Date when the product was returned or attempted to be returned. */
  returned_at: number | null;
}

export enum StripeIssuingDisputeEvidenceMerchandiseNotAsDescribedReturnStatus {
  MerchantRejected = 'merchant_rejected',
  Successful = 'successful',
}

export interface StripeIssuingDisputeEvidenceNotReceived {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** Date when the cardholder expected to receive the product. */
  expected_at: number | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
  /** Description of the merchandise or service that was purchased. */
  product_description: string | null;
  /** Whether the product was a merchandise or service. */
  product_type: StripeIssuingDisputeEvidenceNotReceivedProductType | null;
}

export enum StripeIssuingDisputeEvidenceNotReceivedProductType {
  Merchandise = 'merchandise',
  Service = 'service',
}

export interface StripeIssuingDisputeEvidenceOther {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
  /** Description of the merchandise or service that was purchased. */
  product_description: string | null;
  /** Whether the product was a merchandise or service. */
  product_type: StripeIssuingDisputeEvidenceOtherProductType | null;
}

export enum StripeIssuingDisputeEvidenceOtherProductType {
  Merchandise = 'merchandise',
  Service = 'service',
}

export enum StripeIssuingDisputeEvidenceReason {
  Canceled = 'canceled',
  Duplicate = 'duplicate',
  Fraudulent = 'fraudulent',
  MerchandiseNotAsDescribed = 'merchandise_not_as_described',
  NotReceived = 'not_received',
  Other = 'other',
  ServiceNotAsDescribed = 'service_not_as_described',
}

export interface StripeIssuingDisputeEvidenceServiceNotAsDescribed {
  /** (ID of a [file upload](https://stripe.com/docs/guides/file-upload)) Additional documentation supporting the dispute. */
  additional_documentation: string | StripeFile | null;
  /** Date when order was canceled. */
  canceled_at: number | null;
  /** Reason for canceling the order. */
  cancellation_reason: string | null;
  /** Explanation of why the cardholder is disputing this transaction. */
  explanation: string | null;
  /** Date when the product was received. */
  received_at: number | null;
}

export enum StripeIssuingDisputeStatus {
  Expired = 'expired',
  Lost = 'lost',
  Submitted = 'submitted',
  Unsubmitted = 'unsubmitted',
  Won = 'won',
}

export interface StripeIssuingDisputeTreasury {
  /** The Treasury [DebitReversal](https://stripe.com/docs/api/treasury/debit_reversals) representing this Issuing dispute */
  debit_reversal: string | null;
  /** The Treasury [ReceivedDebit](https://stripe.com/docs/api/treasury/received_debits) that is being disputed. */
  received_debit: string;
}

export interface StripeIssuingTransactionMerchantData {
  /** A categorization of the seller's type of business. See our [merchant categories guide](https://stripe.com/docs/issuing/merchant-categories) for a list of possible values. */
  category: string;
  /** The merchant category code for the seller's business */
  category_code: string;
  /** City where the seller is located */
  city: string | null;
  /** Country where the seller is located */
  country: string | null;
  /** Name of the seller */
  name: string | null;
  /** Identifier assigned to the seller by the card network. Different card networks may assign different network_id fields to the same merchant. */
  network_id: string;
  /** Postal code where the seller is located */
  postal_code: string | null;
  /** State where the seller is located */
  state: string | null;
  /** An ID assigned by the seller to the location of the sale. */
  terminal_id: string | null;
}

export interface StripeIssuingTransactionPurchaseDetails {
  /** Information about the flight that was purchased with this transaction. */
  flight: StripeIssuingTransactionPurchaseDetailsFlight | null;
  /** Information about fuel that was purchased with this transaction. */
  fuel: StripeIssuingTransactionPurchaseDetailsFuel | null;
  /** Information about lodging that was purchased with this transaction. */
  lodging: StripeIssuingTransactionPurchaseDetailsLodging | null;
  /** The line items in the purchase. */
  receipt: StripeIssuingTransactionPurchaseDetailsReceipt[] | null;
  /** A merchant-specific order number. */
  reference: string | null;
}

export interface StripeIssuingTransactionPurchaseDetailsFlight {
  /** The time that the flight departed. */
  departure_at: number | null;
  /** The name of the passenger. */
  passenger_name: string | null;
  /** Whether the ticket is refundable. */
  refundable: boolean | null;
  /** The legs of the trip. */
  segments: StripeIssuingTransactionPurchaseDetailsFlightSegment[] | null;
  /** The travel agency that issued the ticket. */
  travel_agency: string | null;
}

export interface StripeIssuingTransactionPurchaseDetailsFlightSegment {
  /** The three-letter IATA airport code of the flight's destination. */
  arrival_airport_code: string | null;
  /** The airline carrier code. */
  carrier: string | null;
  /** The three-letter IATA airport code that the flight departed from. */
  departure_airport_code: string | null;
  /** The flight number. */
  flight_number: string | null;
  /** The flight's service class. */
  service_class: string | null;
  /** Whether a stopover is allowed on this flight. */
  stopover_allowed: boolean | null;
}

export interface StripeIssuingTransactionPurchaseDetailsFuel {
  /** The type of fuel that was purchased. One of `diesel`, `unleaded_plus`, `unleaded_regular`, `unleaded_super`, or `other`. */
  type: string;
  /** The units for `volume_decimal`. One of `us_gallon` or `liter`. */
  unit: string;
  /** The cost in cents per each unit of fuel, represented as a decimal string with at most 12 decimal places. */
  unit_cost_decimal: string;
  /** The volume of the fuel that was pumped, represented as a decimal string with at most 12 decimal places. */
  volume_decimal: string | null;
}

export interface StripeIssuingTransactionPurchaseDetailsLodging {
  /** The time of checking into the lodging. */
  check_in_at: number | null;
  /** The number of nights stayed at the lodging. */
  nights: number | null;
}

export interface StripeIssuingTransactionPurchaseDetailsReceipt {
  /** The description of the item. The maximum length of this field is 26 characters. */
  description: string | null;
  /** The quantity of the item. */
  quantity: number | null;
  /** The total for this line item in cents. */
  total: number | null;
  /** The unit cost of the item in cents. */
  unit_cost: number | null;
}

export interface StripeIssuingTransactionTreasury {
  /** The Treasury [ReceivedCredit](https://stripe.com/docs/api/treasury/received_credits) representing this Issuing transaction if it is a refund */
  received_credit: string | null;
  /** The Treasury [ReceivedDebit](https://stripe.com/docs/api/treasury/received_debits) representing this Issuing transaction if it is a capture */
  received_debit: string | null;
}

export enum StripeIssuingTransactionType {
  Capture = 'capture',
  Refund = 'refund',
}

export enum StripeIssuingTransactionWallet {
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  SamsungPay = 'samsung_pay',
}

export interface StripeIssuingAuthorizationTreasury {
  /** The array of [ReceivedCredits](https://stripe.com/docs/api/treasury/received_credits) associated with this authorization */
  received_credits: string[];
  /** The array of [ReceivedDebits](https://stripe.com/docs/api/treasury/received_debits) associated with this authorization */
  received_debits: string[];
  /** The Treasury [Transaction](https://stripe.com/docs/api/treasury/transactions) associated with this authorization */
  transaction: string | null;
}

export interface StripeIssuingAuthorizationVerificationData {
  /** Whether the cardholder provided an address first line and if it matched the cardholder's `billing.address.line1`. */
  address_line1_check: StripeIssuingAuthorizationVerificationDataAddressLine1Check;
  /** Whether the cardholder provided a postal code and if it matched the cardholder's `billing.address.postal_code`. */
  address_postal_code_check: StripeIssuingAuthorizationVerificationDataAddressPostalCodeCheck;
  /** Whether the cardholder provided a CVC and if it matched Stripe's record. */
  cvc_check: StripeIssuingAuthorizationVerificationDataCvcCheck;
  /** Whether the cardholder provided an expiry date and if it matched Stripe's record. */
  expiry_check: StripeIssuingAuthorizationVerificationDataExpiryCheck;
}

export enum StripeIssuingAuthorizationVerificationDataAddressLine1Check {
  Match = 'match',
  Mismatch = 'mismatch',
  NotProvided = 'not_provided',
}

export enum StripeIssuingAuthorizationVerificationDataAddressPostalCodeCheck {
  Match = 'match',
  Mismatch = 'mismatch',
  NotProvided = 'not_provided',
}

export enum StripeIssuingAuthorizationVerificationDataCvcCheck {
  Match = 'match',
  Mismatch = 'mismatch',
  NotProvided = 'not_provided',
}

export enum StripeIssuingAuthorizationVerificationDataExpiryCheck {
  Match = 'match',
  Mismatch = 'mismatch',
  NotProvided = 'not_provided',
}

/**
 * A `Payout` object is created when you receive funds from Stripe, or when you initiate a payout to either a bank account or debit card of a [connected Stripe account](https://stripe.com/docs/connect/bank-debit-card-payouts). You can retrieve individual payouts, as well as list all payouts. Payouts are made on [varying schedules](https://stripe.com/docs/connect/manage-payout-schedule), depending on your country and industry.
 *
 * Related guide: [Receiving payouts](https://stripe.com/docs/payouts)
 */
export interface StripePayout {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'payout';
  /** Amount (in %s) to be transferred to your bank account or debit card. */
  amount: number;
  /** Date the payout is expected to arrive in the bank. This factors in delays like weekends or bank holidays. */
  arrival_date: number;
  /** Returns `true` if the payout was created by an [automated payout schedule](https://stripe.com/docs/payouts#payout-schedule), and `false` if it was [requested manually](https://stripe.com/docs/payouts#manual-payouts). */
  automatic: boolean;
  /** ID of the balance transaction that describes the impact of this payout on your account balance. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** ID of the bank account or card the payout was sent to. */
  destination: string | StripeBankAccount | StripeDeletedBankAccount | StripeCard | StripeDeletedCard | null;
  /** If the payout failed or was canceled, this will be the ID of the balance transaction that reversed the initial balance transaction, and puts the funds from the failed payout back in your balance. */
  failure_balance_transaction: string | StripeBalanceTransaction | null;
  /** Error code explaining reason for payout failure if available. See [Types of payout failures](https://stripe.com/docs/api#payout_failures) for a list of failure codes. */
  failure_code: string | null;
  /** Message to user further explaining reason for payout failure if available. */
  failure_message: string | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** The method used to send this payout, which can be `standard` or `instant`. `instant` is only supported for payouts to debit cards. (See [Instant payouts for marketplaces](https://stripe.com/blog/instant-payouts-for-marketplaces) for more information.) */
  method: string;
  /** If the payout reverses another, this is the ID of the original payout. */
  original_payout: string | StripePayout | null;
  /** If `completed`, the [Balance Transactions API](https://stripe.com/docs/api/balance_transactions/list#balance_transaction_list-payout) may be used to list all Balance Transactions that were paid out in this payout. */
  reconciliation_status: StripePayoutReconciliationStatus;
  /** If the payout was reversed, this is the ID of the payout that reverses this payout. */
  reversed_by: string | StripePayout | null;
  /** The source balance this payout came from. One of `card`, `fpx`, or `bank_account`. */
  source_type: string;
  /** Extra information about a payout to be displayed on the user's bank statement. */
  statement_descriptor: string | null;
  /** Current status of the payout: `paid`, `pending`, `in_transit`, `canceled` or `failed`. A payout is `pending` until it is submitted to the bank, when it becomes `in_transit`. The status then changes to `paid` if the transaction goes through, or to `failed` or `canceled` (within 5 business days). Some failed payouts may initially show as `paid` but then change to `failed`. */
  status: string;
  /** Can be `bank_account` or `card`. */
  type: StripePayoutType;
}

export enum StripePayoutReconciliationStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  NotApplicable = 'not_applicable',
}

export enum StripePayoutType {
  BankAccount = 'bank_account',
  Card = 'card',
}

/** The PlatformTaxFee object. */
export interface StripePlatformTaxFee {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'platform_tax_fee';
  /** The Connected account that incurred this charge. */
  account: string;
  /** The payment object that caused this tax to be inflicted. */
  source_transaction: string;
  /** The type of tax (VAT). */
  type: string;
}

/**
 * `Refund` objects allow you to refund a charge that has previously been created but not yet refunded. Funds will be refunded to the credit or debit card that was originally charged.
 *
 * Related guide: [Refunds](https://stripe.com/docs/refunds)
 */
export interface StripeRefund {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'refund';
  /** Amount, in %s. */
  amount: number;
  /** Balance transaction that describes the impact on your account balance. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** ID of the charge that was refunded. */
  charge: string | StripeCharge | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. (Available on non-card refunds only) */
  description?: string;
  /** If the refund failed, this balance transaction describes the adjustment made on your account balance that reverses the initial balance transaction. */
  failure_balance_transaction?: string | StripeBalanceTransaction;
  /** If the refund failed, the reason for refund failure if known. Possible values are `lost_or_stolen_card`, `expired_or_canceled_card`, `charge_for_pending_refund_disputed`, `insufficient_funds`, `declined`, `merchant_request` or `unknown`. */
  failure_reason?: string;
  /** For payment methods without native refund support (e.g., Konbini, PromptPay), email for the customer to receive refund instructions. */
  instructions_email?: string;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  next_action?: StripeRefundNextAction;
  /** ID of the PaymentIntent that was refunded. */
  payment_intent: string | StripePaymentIntent | null;
  /** Reason for the refund, either user-provided (`duplicate`, `fraudulent`, or `requested_by_customer`) or generated by Stripe internally (`expired_uncaptured_charge`). */
  reason: StripeRefundReason | null;
  /** This is the transaction number that appears on email receipts sent for this refund. */
  receipt_number: string | null;
  /** The transfer reversal that is associated with the refund. Only present if the charge came from another Stripe account. See the Connect documentation for details. */
  source_transfer_reversal: string | StripeTransferReversal | null;
  /** Status of the refund. For credit card refunds, this can be `pending`, `succeeded`, or `failed`. For other types of refunds, it can be `pending`, `requires_action`, `succeeded`, `failed`, or `canceled`. Refer to our [refunds](https://stripe.com/docs/refunds#failed-refunds) documentation for more details. */
  status: string | null;
  /** If the accompanying transfer was reversed, the transfer reversal object. Only applicable if the charge was created using the destination parameter. */
  transfer_reversal: string | StripeTransferReversal | null;
}

export interface StripeRefundNextAction {
  /** Contains the refund details. */
  display_details: StripeRefundNextActionDisplayDetails | null;
  /** Type of the next action to perform. */
  type: string;
}

export interface StripeRefundNextActionDisplayDetails {
  email_sent: StripeRefundNextActionDisplayDetailsEmailSent;
  /** The expiry timestamp. */
  expires_at: number;
}

export interface StripeRefundNextActionDisplayDetailsEmailSent {
  /** The timestamp when the email was sent. */
  email_sent_at: number;
  /** The recipient's email address. */
  email_sent_to: string;
}

export enum StripeRefundReason {
  Duplicate = 'duplicate',
  ExpiredUncapturedCharge = 'expired_uncaptured_charge',
  Fraudulent = 'fraudulent',
  RequestedByCustomer = 'requested_by_customer',
}

/**
 * [Stripe Connect](https://stripe.com/docs/connect) platforms can reverse transfers made to a connected account, either entirely or partially, and can also specify whether to refund any related application fees. Transfer reversals add to the platform's balance and subtract from the destination account's balance.
 *
 * Reversing a transfer that was made for a [destination charge](https://stripe.com/docs/connect/destination-charges) is allowed only up to the amount of the charge. It is possible to reverse a [transfer_group](https://stripe.com/docs/connect/charges-transfers#transfer-options) transfer only if the destination account has enough balance to cover the reversal.
 *
 * Related guide: [Reversing transfers](https://stripe.com/docs/connect/charges-transfers#reversing-transfers)
 */
export interface StripeTransferReversal {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'transfer_reversal';
  /** Amount, in %s. */
  amount: number;
  /** Balance transaction that describes the impact on your account balance. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** Linked payment refund for the transfer reversal. */
  destination_payment_refund: string | StripeRefund | null;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata | null;
  /** ID of the refund responsible for the transfer reversal. */
  source_refund: string | StripeRefund | null;
  /** ID of the transfer that was reversed. */
  transfer: string | StripeTransfer;
}

/**
 * A `Transfer` object is created when you move funds between Stripe accounts as part of Connect.
 *
 * Before April 6, 2017, transfers also represented movement of funds from a Stripe account to a card or bank account. This behavior has since been split out into a [Payout](https://stripe.com/docs/api#payout_object) object, with corresponding payout endpoints. For more information, read about the [transfer/payout split](https://stripe.com/docs/transfer-payout-split).
 *
 * Related guide: [Creating separate charges and transfers](https://stripe.com/docs/connect/charges-transfers)
 */
export interface StripeTransfer {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'transfer';
  /** Amount in %s to be transferred. */
  amount: number;
  /** Amount in %s reversed (can be less than the amount attribute on the transfer if a partial reversal was issued). */
  amount_reversed: number;
  /** Balance transaction that describes the impact of this transfer on your account balance. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** Time that this record of the transfer was first created. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** ID of the Stripe account the transfer was sent to. */
  destination: string | StripeAccount | null;
  /** If the destination is a Stripe account, this will be the ID of the payment that the destination account received for the transfer. */
  destination_payment?: string | StripeCharge;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** A list of reversals that have been applied to the transfer. */
  reversals: StripeApiListInterface1460729248872489146072924885249314607292486624931460729248642495146072924802495146072924802496;
  /** Whether the transfer has been fully reversed. If the transfer is only partially reversed, this attribute will still be false. */
  reversed: boolean;
  /** ID of the charge or payment that was used to fund the transfer. If null, the transfer was funded from the available balance. */
  source_transaction: string | StripeCharge | null;
  /** The source balance this transfer came from. One of `card`, `fpx`, or `bank_account`. */
  source_type?: string;
  /** A string that identifies this transaction as part of a group. See the [Connect documentation](https://stripe.com/docs/connect/charges-transfers#transfer-options) for details. */
  transfer_group: string | null;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListInterface1460729248872489146072924885249314607292486624931460729248642495146072924802495146072924802496 {
  object: 'list';
  data: StripeTransferReversal[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/** The ReserveTransaction object. */
export interface StripeReserveTransaction {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'reserve_transaction';
  amount: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
}

/** The TaxDeductedAtSource object. */
export interface StripeTaxDeductedAtSource {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'tax_deducted_at_source';
  /** The end of the invoicing period. This TDS applies to Stripe fees collected during this invoicing period. */
  period_end: number;
  /** The start of the invoicing period. This TDS applies to Stripe fees collected during this invoicing period. */
  period_start: number;
  /** The TAN that was supplied to Stripe when TDS was assessed */
  tax_deduction_account_number: string;
}

/**
 * To top up your Stripe balance, you create a top-up object. You can retrieve individual top-ups, as well as list all top-ups. Top-ups are identified by a unique, random ID.
 *
 * Related guide: [Topping up your platform account](https://stripe.com/docs/connect/top-ups)
 */
export interface StripeTopup {
  /** Unique identifier for the object. */
  id: string;
  /** String representing the object's type. Objects of the same type share the same value. */
  object: 'topup';
  /** Amount transferred. */
  amount: number;
  /** ID of the balance transaction that describes the impact of this top-up on your account balance. May not be specified depending on status of top-up. */
  balance_transaction: string | StripeBalanceTransaction | null;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: number;
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency: string;
  /** An arbitrary string attached to the object. Often useful for displaying to users. */
  description: string | null;
  /** Date the funds are expected to arrive in your Stripe account for payouts. This factors in delays like weekends or bank holidays. May not be specified depending on status of top-up. */
  expected_availability_date: number | null;
  /** Error code explaining reason for top-up failure if available (see [the errors section](https://stripe.com/docs/api#errors) for a list of codes). */
  failure_code: string | null;
  /** Message to user further explaining reason for top-up failure if available. */
  failure_message: string | null;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode: boolean;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata: StripeMetadata;
  /** For most Stripe users, the source of every top-up is a bank account. This hash is then the [source object](https://stripe.com/docs/api#source_object) describing that bank account. */
  source: StripeSource | null;
  /** Extra information about a top-up. This will appear on your source's bank statement. It must contain at least one letter. */
  statement_descriptor: string | null;
  /** The status of the top-up is either `canceled`, `failed`, `pending`, `reversed`, or `succeeded`. */
  status: StripeTopupStatus;
  /** A string that identifies this top-up as part of a group. */
  transfer_group: string | null;
}

export enum StripeTopupStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Pending = 'pending',
  Reversed = 'reversed',
  Succeeded = 'succeeded',
}

export enum StripeBalanceTransactionType {
  Adjustment = 'adjustment',
  Advance = 'advance',
  AdvanceFunding = 'advance_funding',
  AnticipationRepayment = 'anticipation_repayment',
  ApplicationFee = 'application_fee',
  ApplicationFeeRefund = 'application_fee_refund',
  Charge = 'charge',
  ConnectCollectionTransfer = 'connect_collection_transfer',
  Contribution = 'contribution',
  IssuingAuthorizationHold = 'issuing_authorization_hold',
  IssuingAuthorizationRelease = 'issuing_authorization_release',
  IssuingDispute = 'issuing_dispute',
  IssuingTransaction = 'issuing_transaction',
  Payment = 'payment',
  PaymentFailureRefund = 'payment_failure_refund',
  PaymentRefund = 'payment_refund',
  Payout = 'payout',
  PayoutCancel = 'payout_cancel',
  PayoutFailure = 'payout_failure',
  Refund = 'refund',
  RefundFailure = 'refund_failure',
  ReserveTransaction = 'reserve_transaction',
  ReservedFunds = 'reserved_funds',
  StripeFee = 'stripe_fee',
  StripeFxFee = 'stripe_fx_fee',
  TaxFee = 'tax_fee',
  Topup = 'topup',
  TopupReversal = 'topup_reversal',
  Transfer = 'transfer',
  TransferCancel = 'transfer_cancel',
  TransferFailure = 'transfer_failure',
  TransferRefund = 'transfer_refund',
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeFeeRefund {
  object: 'list';
  data: StripeFeeRefund[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

export interface StripeChargeBillingDetails {
  /** Billing address. */
  address: StripeAddress | null;
  /** Email address. */
  email: string | null;
  /** Full name. */
  name: string | null;
  /** Billing phone number (including extension). */
  phone: string | null;
}

export interface StripeChargeFraudDetails {
  /** Assessments from Stripe. If set, the value is `fraudulent`. */
  stripe_report?: string;
  /** Assessments reported by you. If set, possible values of are `safe` and `fraudulent`. */
  user_report?: string;
}

export interface StripeChargeLevel3 {
  customer_reference?: string;
  line_items: StripeChargeLevel3LineItem[];
  merchant_reference: string;
  shipping_address_zip?: string;
  shipping_amount?: number;
  shipping_from_zip?: string;
}

export interface StripeChargeLevel3LineItem {
  discount_amount: number | null;
  product_code: string;
  product_description: string;
  quantity: number | null;
  tax_amount: number | null;
  unit_cost: number | null;
}

export interface StripeChargeOutcome {
  /** Possible values are `approved_by_network`, `declined_by_network`, `not_sent_to_network`, and `reversed_after_approval`. The value `reversed_after_approval` indicates the payment was [blocked by Stripe](https://stripe.com/docs/declines#blocked-payments) after bank authorization, and may temporarily appear as "pending" on a cardholder's statement. */
  network_status: string | null;
  /** An enumerated value providing a more detailed explanation of the outcome's `type`. Charges blocked by Radar's default block rule have the value `highest_risk_level`. Charges placed in review by Radar's default review rule have the value `elevated_risk_level`. Charges authorized, blocked, or placed in review by custom rules have the value `rule`. See [understanding declines](https://stripe.com/docs/declines) for more details. */
  reason: string | null;
  /** Stripe Radar's evaluation of the riskiness of the payment. Possible values for evaluated payments are `normal`, `elevated`, `highest`. For non-card payments, and card-based payments predating the public assignment of risk levels, this field will have the value `not_assessed`. In the event of an error in the evaluation, this field will have the value `unknown`. This field is only available with Radar. */
  risk_level?: string;
  /** Stripe Radar's evaluation of the riskiness of the payment. Possible values for evaluated payments are between 0 and 100. For non-card payments, card-based payments predating the public assignment of risk scores, or in the event of an error during evaluation, this field will not be present. This field is only available with Radar for Fraud Teams. */
  risk_score?: number;
  /** The ID of the Radar rule that matched the payment, if applicable. */
  rule?: string | StripeChargeOutcomeRule;
  /** A human-readable description of the outcome type and reason, designed for you (the recipient of the payment), not your customer. */
  seller_message: string | null;
  /** Possible values are `authorized`, `manual_review`, `issuer_declined`, `blocked`, and `invalid`. See [understanding declines](https://stripe.com/docs/declines) and [Radar reviews](https://stripe.com/docs/radar/reviews) for details. */
  type: string;
}

export interface StripeChargeOutcomeRule {
  /** The action taken on the payment. */
  action: string;
  /** Unique identifier for the object. */
  id: string;
  /** The predicate to evaluate the payment against. */
  predicate: string;
}

export interface StripeChargePaymentMethodDetails {
  ach_credit_transfer?: StripeChargePaymentMethodDetailsAchCreditTransfer;
  ach_debit?: StripeChargePaymentMethodDetailsAchDebit;
  acss_debit?: StripeChargePaymentMethodDetailsAcssDebit;
  affirm?: StripeChargePaymentMethodDetailsAffirm;
  afterpay_clearpay?: StripeChargePaymentMethodDetailsAfterpayClearpay;
  alipay?: StripeChargePaymentMethodDetailsAlipay;
  au_becs_debit?: StripeChargePaymentMethodDetailsAuBecsDebit;
  bacs_debit?: StripeChargePaymentMethodDetailsBacsDebit;
  bancontact?: StripeChargePaymentMethodDetailsBancontact;
  blik?: StripeChargePaymentMethodDetailsBlik;
  boleto?: StripeChargePaymentMethodDetailsBoleto;
  card?: StripeChargePaymentMethodDetailsCard;
  card_present?: StripeChargePaymentMethodDetailsCardPresent;
  cashapp?: StripeChargePaymentMethodDetailsCashapp;
  customer_balance?: StripeChargePaymentMethodDetailsCustomerBalance;
  eps?: StripeChargePaymentMethodDetailsEps;
  fpx?: StripeChargePaymentMethodDetailsFpx;
  giropay?: StripeChargePaymentMethodDetailsGiropay;
  grabpay?: StripeChargePaymentMethodDetailsGrabpay;
  ideal?: StripeChargePaymentMethodDetailsIdeal;
  interac_present?: StripeChargePaymentMethodDetailsInteracPresent;
  klarna?: StripeChargePaymentMethodDetailsKlarna;
  konbini?: StripeChargePaymentMethodDetailsKonbini;
  link?: StripeChargePaymentMethodDetailsLink;
  multibanco?: StripeChargePaymentMethodDetailsMultibanco;
  oxxo?: StripeChargePaymentMethodDetailsOxxo;
  p24?: StripeChargePaymentMethodDetailsP24;
  paynow?: StripeChargePaymentMethodDetailsPaynow;
  paypal?: StripeChargePaymentMethodDetailsPaypal;
  pix?: StripeChargePaymentMethodDetailsPix;
  promptpay?: StripeChargePaymentMethodDetailsPromptpay;
  sepa_credit_transfer?: StripeChargePaymentMethodDetailsSepaCreditTransfer;
  sepa_debit?: StripeChargePaymentMethodDetailsSepaDebit;
  sofort?: StripeChargePaymentMethodDetailsSofort;
  stripe_account?: StripeChargePaymentMethodDetailsStripeAccount;
  /** The type of transaction-specific details of the payment method used in the payment, one of `ach_credit_transfer`, `ach_debit`, `acss_debit`, `alipay`, `au_becs_debit`, `bancontact`, `card`, `card_present`, `eps`, `giropay`, `ideal`, `klarna`, `multibanco`, `p24`, `sepa_debit`, `sofort`, `stripe_account`, or `wechat`. An additional hash is included on `payment_method_details` with a name matching this value. It contains information specific to the payment method. */
  type: string;
  us_bank_account?: StripeChargePaymentMethodDetailsUsBankAccount;
  wechat?: StripeChargePaymentMethodDetailsWechat;
  wechat_pay?: StripeChargePaymentMethodDetailsWechatPay;
  zip?: StripeChargePaymentMethodDetailsZip;
}

export interface StripeChargePaymentMethodDetailsAchCreditTransfer {
  /** Account number to transfer funds to. */
  account_number: string | null;
  /** Name of the bank associated with the routing number. */
  bank_name: string | null;
  /** Routing transit number for the bank account to transfer funds to. */
  routing_number: string | null;
  /** SWIFT code of the bank associated with the routing number. */
  swift_code: string | null;
}

export interface StripeChargePaymentMethodDetailsAchDebit {
  /** Type of entity that holds the account. This can be either `individual` or `company`. */
  account_holder_type: StripeChargePaymentMethodDetailsAchDebitAccountHolderType | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Two-letter ISO code representing the country the bank account is located in. */
  country: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** Routing transit number of the bank account. */
  routing_number: string | null;
}

export enum StripeChargePaymentMethodDetailsAchDebitAccountHolderType {
  Company = 'company',
  Individual = 'individual',
}

export interface StripeChargePaymentMethodDetailsAcssDebit {
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Institution number of the bank account */
  institution_number: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** ID of the mandate used to make this payment. */
  mandate?: string;
  /** Transit number of the bank account. */
  transit_number: string | null;
}

export type StripeChargePaymentMethodDetailsAffirm = object;

export interface StripeChargePaymentMethodDetailsAfterpayClearpay {
  /** Order identifier shown to the merchant in Afterpay's online portal. */
  reference: string | null;
}

export interface StripeChargePaymentMethodDetailsAlipay {
  /** Uniquely identifies this particular Alipay account. You can use this attribute to check whether two Alipay accounts are the same. */
  buyer_id?: string;
  /** Uniquely identifies this particular Alipay account. You can use this attribute to check whether two Alipay accounts are the same. */
  fingerprint: string | null;
  /** Transaction ID of this particular Alipay transaction. */
  transaction_id: string | null;
}

export interface StripeChargePaymentMethodDetailsAuBecsDebit {
  /** Bank-State-Branch number of the bank account. */
  bsb_number: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** ID of the mandate used to make this payment. */
  mandate?: string;
}

export interface StripeChargePaymentMethodDetailsBacsDebit {
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** ID of the mandate used to make this payment. */
  mandate: string | null;
  /** Sort code of the bank account. (e.g., `10-20-30`) */
  sort_code: string | null;
}

export interface StripeChargePaymentMethodDetailsBancontact {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Bank Identifier Code of the bank associated with the bank account. */
  bic: string | null;
  /** The ID of the SEPA Direct Debit PaymentMethod which was generated by this Charge. */
  generated_sepa_debit: string | StripePaymentMethod | null;
  /** The mandate for the SEPA Direct Debit PaymentMethod which was generated by this Charge. */
  generated_sepa_debit_mandate: string | StripeMandate | null;
  /** Last four characters of the IBAN. */
  iban_last4: string | null;
  /** Preferred language of the Bancontact authorization page that the customer is redirected to. Can be one of `en`, `de`, `fr`, or `nl` */
  preferred_language: StripeChargePaymentMethodDetailsBancontactPreferredLanguage | null;
  /** Owner's verified full name. Values are verified or provided by Bancontact directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
}

export enum StripeChargePaymentMethodDetailsBancontactPreferredLanguage {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export type StripeChargePaymentMethodDetailsBlik = object;

export interface StripeChargePaymentMethodDetailsBoleto {
  /** The tax ID of the customer (CPF for individuals consumers or CNPJ for businesses consumers) */
  tax_id: string;
}

export interface StripeChargePaymentMethodDetailsCard {
  /** Card brand. Can be `amex`, `diners`, `discover`, `eftpos_au`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  brand: string | null;
  /** Check results by Card networks on Card address and CVC at time of payment. */
  checks: StripeChargePaymentMethodDetailsCardChecks | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint?: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string | null;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /**
   * Installment details for this payment (Mexico only).
   *
   * For more information, see the [installments integration guide](https://stripe.com/docs/payments/installments).
   */
  installments: StripeChargePaymentMethodDetailsCardInstallments | null;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string | null;
  /** ID of the mandate used to make this payment or created by it. */
  mandate: string | null;
  /** True if this payment was marked as MOTO and out of scope for SCA. */
  moto?: boolean | null;
  /** Identifies which network this charge was processed on. Can be `amex`, `cartes_bancaires`, `diners`, `discover`, `eftpos_au`, `interac`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  network: string | null;
  /** If this card has network token credentials, this contains the details of the network token credentials. */
  network_token?: StripeChargePaymentMethodDetailsCardNetworkToken | null;
  /** Populated if this transaction used 3D Secure authentication. */
  three_d_secure: StripeChargePaymentMethodDetailsCardThreeDSecure | null;
  /** If this Card is part of a card wallet, this contains the details of the card wallet. */
  wallet: StripeChargePaymentMethodDetailsCardWallet | null;
}

export interface StripeChargePaymentMethodDetailsCardChecks {
  /** If a address line1 was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_line1_check: string | null;
  /** If a address postal code was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  address_postal_code_check: string | null;
  /** If a CVC was provided, results of the check, one of `pass`, `fail`, `unavailable`, or `unchecked`. */
  cvc_check: string | null;
}

export interface StripeChargePaymentMethodDetailsCardInstallments {
  /** Installment plan selected for the payment. */
  plan: StripeChargePaymentMethodDetailsCardInstallmentsPlan | null;
}

export interface StripeChargePaymentMethodDetailsCardInstallmentsPlan {
  /** For `fixed_count` installment plans, this is the number of installment payments your customer will make to their credit card. */
  count: number | null;
  /** For `fixed_count` installment plans, this is the interval between installment payments your customer will make to their credit card. One of `month`. */
  interval: StripeChargePaymentMethodDetailsCardInstallmentsPlanIntervalEnum;
  /** Type of installment plan, one of `fixed_count`. */
  type: 'fixed_count';
}

export interface StripeChargePaymentMethodDetailsCardNetworkToken {
  /** Indicates if Stripe used a network token, either user provided or Stripe managed when processing the transaction. */
  used: boolean;
}

export interface StripeChargePaymentMethodDetailsCardThreeDSecure {
  /** For authenticated transactions: how the customer was authenticated by the issuing bank. */
  authentication_flow: StripeChargePaymentMethodDetailsCardThreeDSecureAuthenticationFlow | null;
  /** Indicates the outcome of 3D Secure authentication. */
  result: StripeChargePaymentMethodDetailsCardThreeDSecureResult | null;
  /** Additional information about why 3D Secure succeeded or failed based on the `result`. */
  result_reason: StripeChargePaymentMethodDetailsCardThreeDSecureResultReason | null;
  /** The version of 3D Secure that was used. */
  version: StripeChargePaymentMethodDetailsCardThreeDSecureVersion | null;
}

export enum StripeChargePaymentMethodDetailsCardThreeDSecureAuthenticationFlow {
  Challenge = 'challenge',
  Frictionless = 'frictionless',
}

export enum StripeChargePaymentMethodDetailsCardThreeDSecureResult {
  AttemptAcknowledged = 'attempt_acknowledged',
  Authenticated = 'authenticated',
  Exempted = 'exempted',
  Failed = 'failed',
  NotSupported = 'not_supported',
  ProcessingError = 'processing_error',
}

export enum StripeChargePaymentMethodDetailsCardThreeDSecureResultReason {
  Abandoned = 'abandoned',
  Bypassed = 'bypassed',
  Canceled = 'canceled',
  CardNotEnrolled = 'card_not_enrolled',
  NetworkNotSupported = 'network_not_supported',
  ProtocolError = 'protocol_error',
  Rejected = 'rejected',
}

export enum StripeChargePaymentMethodDetailsCardThreeDSecureVersion {
  Value102 = '1.0.2',
  Value210 = '2.1.0',
  Value220 = '2.2.0',
}

export interface StripeChargePaymentMethodDetailsCardWallet {
  amex_express_checkout?: StripeChargePaymentMethodDetailsCardWalletAmexExpressCheckout;
  apple_pay?: StripeChargePaymentMethodDetailsCardWalletApplePay;
  /** (For tokenized numbers only.) The last four digits of the device account number. */
  dynamic_last4: string | null;
  google_pay?: StripeChargePaymentMethodDetailsCardWalletGooglePay;
  link?: StripeChargePaymentMethodDetailsCardWalletLink;
  masterpass?: StripeChargePaymentMethodDetailsCardWalletMasterpass;
  samsung_pay?: StripeChargePaymentMethodDetailsCardWalletSamsungPay;
  /** The type of the card wallet, one of `amex_express_checkout`, `apple_pay`, `google_pay`, `masterpass`, `samsung_pay`, `visa_checkout`, or `link`. An additional hash is included on the Wallet subhash with a name matching this value. It contains additional information specific to the card wallet type. */
  type: StripeChargePaymentMethodDetailsCardWalletType;
  visa_checkout?: StripeChargePaymentMethodDetailsCardWalletVisaCheckout;
}

export type StripeChargePaymentMethodDetailsCardWalletAmexExpressCheckout = object;

export type StripeChargePaymentMethodDetailsCardWalletApplePay = object;

export type StripeChargePaymentMethodDetailsCardWalletGooglePay = object;

export type StripeChargePaymentMethodDetailsCardWalletLink = object;

export interface StripeChargePaymentMethodDetailsCardWalletMasterpass {
  /** Owner's verified billing address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  billing_address: StripeAddress | null;
  /** Owner's verified email. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  email: string | null;
  /** Owner's verified full name. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  name: string | null;
  /** Owner's verified shipping address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  shipping_address: StripeAddress | null;
}

export type StripeChargePaymentMethodDetailsCardWalletSamsungPay = object;

export enum StripeChargePaymentMethodDetailsCardWalletType {
  AmexExpressCheckout = 'amex_express_checkout',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  Link = 'link',
  Masterpass = 'masterpass',
  SamsungPay = 'samsung_pay',
  VisaCheckout = 'visa_checkout',
}

export interface StripeChargePaymentMethodDetailsCardWalletVisaCheckout {
  /** Owner's verified billing address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  billing_address: StripeAddress | null;
  /** Owner's verified email. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  email: string | null;
  /** Owner's verified full name. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  name: string | null;
  /** Owner's verified shipping address. Values are verified or provided by the wallet directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  shipping_address: StripeAddress | null;
}

export interface StripeChargePaymentMethodDetailsCardPresent {
  /** The authorized amount */
  amount_authorized: number | null;
  /** Card brand. Can be `amex`, `diners`, `discover`, `eftpos_au`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  brand: string | null;
  /** When using manual capture, a future timestamp after which the charge will be automatically refunded if uncaptured. */
  capture_before?: number;
  /** The cardholder name as read from the card, in [ISO 7813](https://en.wikipedia.org/wiki/ISO/IEC_7813) format. May include alphanumeric characters, special characters and first/last name separator (`/`). In some cases, the cardholder name may not be available depending on how the issuer has configured the card. Cardholder name is typically not available on swipe or contactless payments, such as those made with Apple Pay and Google Pay. */
  cardholder_name: string | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Authorization response cryptogram. */
  emv_auth_data: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string | null;
  /** ID of a card PaymentMethod generated from the card_present PaymentMethod that may be attached to a Customer for future transactions. Only present if it was possible to generate a card PaymentMethod. */
  generated_card: string | null;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /** Whether this [PaymentIntent](https://stripe.com/docs/api/payment_intents) is eligible for incremental authorizations. Request support using [request_incremental_authorization_support](https://stripe.com/docs/api/payment_intents/create#create_payment_intent-payment_method_options-card_present-request_incremental_authorization_support). */
  incremental_authorization_supported: boolean;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string | null;
  /** Identifies which network this charge was processed on. Can be `amex`, `cartes_bancaires`, `diners`, `discover`, `eftpos_au`, `interac`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  network: string | null;
  /** Defines whether the authorized amount can be over-captured or not */
  overcapture_supported: boolean;
  /** How card details were read in this transaction. */
  read_method: StripeChargePaymentMethodDetailsCardPresentReadMethod | null;
  /** A collection of fields required to be displayed on receipts. Only required for EMV transactions. */
  receipt: StripeChargePaymentMethodDetailsCardPresentReceipt | null;
}

export enum StripeChargePaymentMethodDetailsCardPresentReadMethod {
  ContactEmv = 'contact_emv',
  ContactlessEmv = 'contactless_emv',
  ContactlessMagstripeMode = 'contactless_magstripe_mode',
  MagneticStripeFallback = 'magnetic_stripe_fallback',
  MagneticStripeTrack2 = 'magnetic_stripe_track2',
}

export interface StripeChargePaymentMethodDetailsCardPresentReceipt {
  /** The type of account being debited or credited */
  account_type?: StripeChargePaymentMethodDetailsCardPresentReceiptAccountType;
  /** EMV tag 9F26, cryptogram generated by the integrated circuit chip. */
  application_cryptogram: string | null;
  /** Mnenomic of the Application Identifier. */
  application_preferred_name: string | null;
  /** Identifier for this transaction. */
  authorization_code: string | null;
  /** EMV tag 8A. A code returned by the card issuer. */
  authorization_response_code: string | null;
  /** How the cardholder verified ownership of the card. */
  cardholder_verification_method: string | null;
  /** EMV tag 84. Similar to the application identifier stored on the integrated circuit chip. */
  dedicated_file_name: string | null;
  /** The outcome of a series of EMV functions performed by the card reader. */
  terminal_verification_results: string | null;
  /** An indication of various EMV functions performed during the transaction. */
  transaction_status_information: string | null;
}

export enum StripeChargePaymentMethodDetailsCardPresentReceiptAccountType {
  Checking = 'checking',
  Credit = 'credit',
  Prepaid = 'prepaid',
  Unknown = 'unknown',
}

export interface StripeChargePaymentMethodDetailsCashapp {
  /** A unique and immutable identifier assigned by Cash App to every buyer. */
  buyer_id: string | null;
  /** A public identifier for buyers using Cash App. */
  cashtag: string | null;
}

export type StripeChargePaymentMethodDetailsCustomerBalance = object;

export interface StripeChargePaymentMethodDetailsEps {
  /** The customer's bank. Should be one of `arzte_und_apotheker_bank`, `austrian_anadi_bank_ag`, `bank_austria`, `bankhaus_carl_spangler`, `bankhaus_schelhammer_und_schattera_ag`, `bawag_psk_ag`, `bks_bank_ag`, `brull_kallmus_bank_ag`, `btv_vier_lander_bank`, `capital_bank_grawe_gruppe_ag`, `deutsche_bank_ag`, `dolomitenbank`, `easybank_ag`, `erste_bank_und_sparkassen`, `hypo_alpeadriabank_international_ag`, `hypo_noe_lb_fur_niederosterreich_u_wien`, `hypo_oberosterreich_salzburg_steiermark`, `hypo_tirol_bank_ag`, `hypo_vorarlberg_bank_ag`, `hypo_bank_burgenland_aktiengesellschaft`, `marchfelder_bank`, `oberbank_ag`, `raiffeisen_bankengruppe_osterreich`, `schoellerbank_ag`, `sparda_bank_wien`, `volksbank_gruppe`, `volkskreditbank_ag`, or `vr_bank_braunau`. */
  bank: StripeChargePaymentMethodDetailsEpsBank | null;
  /** Owner's verified full name. Values are verified or provided by EPS directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. EPS rarely provides this information so the attribute is usually empty. */
  verified_name: string | null;
}

export enum StripeChargePaymentMethodDetailsEpsBank {
  ArzteUndApothekerBank = 'arzte_und_apotheker_bank',
  AustrianAnadiBankAg = 'austrian_anadi_bank_ag',
  BankAustria = 'bank_austria',
  BankhausCarlSpangler = 'bankhaus_carl_spangler',
  BankhausSchelhammerUndSchatteraAg = 'bankhaus_schelhammer_und_schattera_ag',
  BawagPskAg = 'bawag_psk_ag',
  BksBankAg = 'bks_bank_ag',
  BrullKallmusBankAg = 'brull_kallmus_bank_ag',
  BtvVierLanderBank = 'btv_vier_lander_bank',
  CapitalBankGraweGruppeAg = 'capital_bank_grawe_gruppe_ag',
  DeutscheBankAg = 'deutsche_bank_ag',
  Dolomitenbank = 'dolomitenbank',
  EasybankAg = 'easybank_ag',
  ErsteBankUndSparkassen = 'erste_bank_und_sparkassen',
  HypoAlpeadriabankInternationalAg = 'hypo_alpeadriabank_international_ag',
  HypoBankBurgenlandAktiengesellschaft = 'hypo_bank_burgenland_aktiengesellschaft',
  HypoNoeLbFurNiederosterreichUWien = 'hypo_noe_lb_fur_niederosterreich_u_wien',
  HypoOberosterreichSalzburgSteiermark = 'hypo_oberosterreich_salzburg_steiermark',
  HypoTirolBankAg = 'hypo_tirol_bank_ag',
  HypoVorarlbergBankAg = 'hypo_vorarlberg_bank_ag',
  MarchfelderBank = 'marchfelder_bank',
  OberbankAg = 'oberbank_ag',
  RaiffeisenBankengruppeOsterreich = 'raiffeisen_bankengruppe_osterreich',
  SchoellerbankAg = 'schoellerbank_ag',
  SpardaBankWien = 'sparda_bank_wien',
  VolksbankGruppe = 'volksbank_gruppe',
  VolkskreditbankAg = 'volkskreditbank_ag',
  VrBankBraunau = 'vr_bank_braunau',
}

export interface StripeChargePaymentMethodDetailsFpx {
  /** Account holder type, if provided. Can be one of `individual` or `company`. */
  account_holder_type: StripeChargePaymentMethodDetailsFpxAccountHolderType | null;
  /** The customer's bank. Can be one of `affin_bank`, `agrobank`, `alliance_bank`, `ambank`, `bank_islam`, `bank_muamalat`, `bank_rakyat`, `bsn`, `cimb`, `hong_leong_bank`, `hsbc`, `kfh`, `maybank2u`, `ocbc`, `public_bank`, `rhb`, `standard_chartered`, `uob`, `deutsche_bank`, `maybank2e`, `pb_enterprise`, or `bank_of_china`. */
  bank: StripeChargePaymentMethodDetailsFpxBank;
  /** Unique transaction id generated by FPX for every request from the merchant */
  transaction_id: string | null;
}

export enum StripeChargePaymentMethodDetailsFpxAccountHolderType {
  Company = 'company',
  Individual = 'individual',
}

export enum StripeChargePaymentMethodDetailsFpxBank {
  AffinBank = 'affin_bank',
  Agrobank = 'agrobank',
  AllianceBank = 'alliance_bank',
  Ambank = 'ambank',
  BankIslam = 'bank_islam',
  BankMuamalat = 'bank_muamalat',
  BankOfChina = 'bank_of_china',
  BankRakyat = 'bank_rakyat',
  Bsn = 'bsn',
  Cimb = 'cimb',
  DeutscheBank = 'deutsche_bank',
  HongLeongBank = 'hong_leong_bank',
  Hsbc = 'hsbc',
  Kfh = 'kfh',
  Maybank2E = 'maybank2e',
  Maybank2U = 'maybank2u',
  Ocbc = 'ocbc',
  PbEnterprise = 'pb_enterprise',
  PublicBank = 'public_bank',
  Rhb = 'rhb',
  StandardChartered = 'standard_chartered',
  Uob = 'uob',
}

export interface StripeChargePaymentMethodDetailsGiropay {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Bank Identifier Code of the bank associated with the bank account. */
  bic: string | null;
  /** Owner's verified full name. Values are verified or provided by Giropay directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. Giropay rarely provides this information so the attribute is usually empty. */
  verified_name: string | null;
}

export interface StripeChargePaymentMethodDetailsGrabpay {
  /** Unique transaction id generated by GrabPay */
  transaction_id: string | null;
}

export interface StripeChargePaymentMethodDetailsIdeal {
  /** The customer's bank. Can be one of `abn_amro`, `asn_bank`, `bunq`, `handelsbanken`, `ing`, `knab`, `moneyou`, `rabobank`, `regiobank`, `revolut`, `sns_bank`, `triodos_bank`, `van_lanschot`, or `yoursafe`. */
  bank: StripeChargePaymentMethodDetailsIdealBank | null;
  /** The Bank Identifier Code of the customer's bank. */
  bic: StripeChargePaymentMethodDetailsIdealBic | null;
  /** The ID of the SEPA Direct Debit PaymentMethod which was generated by this Charge. */
  generated_sepa_debit: string | StripePaymentMethod | null;
  /** The mandate for the SEPA Direct Debit PaymentMethod which was generated by this Charge. */
  generated_sepa_debit_mandate: string | StripeMandate | null;
  /** Last four characters of the IBAN. */
  iban_last4: string | null;
  /** Owner's verified full name. Values are verified or provided by iDEAL directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
}

export enum StripeChargePaymentMethodDetailsIdealBank {
  AbnAmro = 'abn_amro',
  AsnBank = 'asn_bank',
  Bunq = 'bunq',
  Handelsbanken = 'handelsbanken',
  Ing = 'ing',
  Knab = 'knab',
  Moneyou = 'moneyou',
  Rabobank = 'rabobank',
  Regiobank = 'regiobank',
  Revolut = 'revolut',
  SnsBank = 'sns_bank',
  TriodosBank = 'triodos_bank',
  VanLanschot = 'van_lanschot',
  Yoursafe = 'yoursafe',
}

export enum StripeChargePaymentMethodDetailsIdealBic {
  ABNANL2A = 'ABNANL2A',
  ASNBNL21 = 'ASNBNL21',
  BITSNL2A = 'BITSNL2A',
  BUNQNL2A = 'BUNQNL2A',
  FVLBNL22 = 'FVLBNL22',
  HANDNL2A = 'HANDNL2A',
  INGBNL2A = 'INGBNL2A',
  KNABNL2H = 'KNABNL2H',
  MOYONL21 = 'MOYONL21',
  RABONL2U = 'RABONL2U',
  RBRBNL21 = 'RBRBNL21',
  REVOIE23 = 'REVOIE23',
  REVOLT21 = 'REVOLT21',
  SNSBNL2A = 'SNSBNL2A',
  TRIONL2U = 'TRIONL2U',
}

export interface StripeChargePaymentMethodDetailsInteracPresent {
  /** Card brand. Can be `interac`, `mastercard` or `visa`. */
  brand: string | null;
  /** The cardholder name as read from the card, in [ISO 7813](https://en.wikipedia.org/wiki/ISO/IEC_7813) format. May include alphanumeric characters, special characters and first/last name separator (`/`). In some cases, the cardholder name may not be available depending on how the issuer has configured the card. Cardholder name is typically not available on swipe or contactless payments, such as those made with Apple Pay and Google Pay. */
  cardholder_name: string | null;
  /** Two-letter ISO code representing the country of the card. You could use this attribute to get a sense of the international breakdown of cards you've collected. */
  country: string | null;
  /** A high-level description of the type of cards issued in this range. (For internal use only and not typically available in standard API requests.) */
  description?: string | null;
  /** Authorization response cryptogram. */
  emv_auth_data: string | null;
  /** Two-digit number representing the card's expiration month. */
  exp_month: number;
  /** Four-digit number representing the card's expiration year. */
  exp_year: number;
  /**
   * Uniquely identifies this particular card number. You can use this attribute to check whether two customers who've signed up with you are using the same card number, for example. For payment methods that tokenize card information (Apple Pay, Google Pay), the tokenized number might be provided instead of the underlying card number.
   *
   * *Starting May 1, 2021, card fingerprint in India for Connect will change to allow two fingerprints for the same card --- one for India and one for the rest of the world.*
   */
  fingerprint: string | null;
  /** Card funding type. Can be `credit`, `debit`, `prepaid`, or `unknown`. */
  funding: string | null;
  /** ID of a card PaymentMethod generated from the card_present PaymentMethod that may be attached to a Customer for future transactions. Only present if it was possible to generate a card PaymentMethod. */
  generated_card: string | null;
  /** Issuer identification number of the card. (For internal use only and not typically available in standard API requests.) */
  iin?: string | null;
  /** The name of the card's issuing bank. (For internal use only and not typically available in standard API requests.) */
  issuer?: string | null;
  /** The last four digits of the card. */
  last4: string | null;
  /** Identifies which network this charge was processed on. Can be `amex`, `cartes_bancaires`, `diners`, `discover`, `eftpos_au`, `interac`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`. */
  network: string | null;
  /** EMV tag 5F2D. Preferred languages specified by the integrated circuit chip. */
  preferred_locales: string[] | null;
  /** How card details were read in this transaction. */
  read_method: StripeChargePaymentMethodDetailsInteracPresentReadMethod | null;
  /** A collection of fields required to be displayed on receipts. Only required for EMV transactions. */
  receipt: StripeChargePaymentMethodDetailsInteracPresentReceipt | null;
}

export enum StripeChargePaymentMethodDetailsInteracPresentReadMethod {
  ContactEmv = 'contact_emv',
  ContactlessEmv = 'contactless_emv',
  ContactlessMagstripeMode = 'contactless_magstripe_mode',
  MagneticStripeFallback = 'magnetic_stripe_fallback',
  MagneticStripeTrack2 = 'magnetic_stripe_track2',
}

export interface StripeChargePaymentMethodDetailsInteracPresentReceipt {
  /** The type of account being debited or credited */
  account_type?: StripeChargePaymentMethodDetailsInteracPresentReceiptAccountType;
  /** EMV tag 9F26, cryptogram generated by the integrated circuit chip. */
  application_cryptogram: string | null;
  /** Mnenomic of the Application Identifier. */
  application_preferred_name: string | null;
  /** Identifier for this transaction. */
  authorization_code: string | null;
  /** EMV tag 8A. A code returned by the card issuer. */
  authorization_response_code: string | null;
  /** How the cardholder verified ownership of the card. */
  cardholder_verification_method: string | null;
  /** EMV tag 84. Similar to the application identifier stored on the integrated circuit chip. */
  dedicated_file_name: string | null;
  /** The outcome of a series of EMV functions performed by the card reader. */
  terminal_verification_results: string | null;
  /** An indication of various EMV functions performed during the transaction. */
  transaction_status_information: string | null;
}

export enum StripeChargePaymentMethodDetailsInteracPresentReceiptAccountType {
  Checking = 'checking',
  Savings = 'savings',
  Unknown = 'unknown',
}

export interface StripeChargePaymentMethodDetailsKlarna {
  /** The Klarna payment method used for this transaction. Can be one of `pay_later`, `pay_now`, `pay_with_financing`, or `pay_in_installments` */
  payment_method_category: string | null;
  /** Preferred language of the Klarna authorization page that the customer is redirected to. Can be one of `de-AT`, `en-AT`, `nl-BE`, `fr-BE`, `en-BE`, `de-DE`, `en-DE`, `da-DK`, `en-DK`, `es-ES`, `en-ES`, `fi-FI`, `sv-FI`, `en-FI`, `en-GB`, `en-IE`, `it-IT`, `en-IT`, `nl-NL`, `en-NL`, `nb-NO`, `en-NO`, `sv-SE`, `en-SE`, `en-US`, `es-US`, `fr-FR`, `en-FR`, `cs-CZ`, `en-CZ`, `el-GR`, `en-GR`, `en-AU`, `en-NZ`, `en-CA`, `fr-CA`, `pl-PL`, `en-PL`, `pt-PT`, `en-PT`, `de-CH`, `fr-CH`, `it-CH`, or `en-CH` */
  preferred_locale: string | null;
}

export interface StripeChargePaymentMethodDetailsKonbini {
  /** If the payment succeeded, this contains the details of the convenience store where the payment was completed. */
  store: StripeChargePaymentMethodDetailsKonbiniStore | null;
}

export interface StripeChargePaymentMethodDetailsKonbiniStore {
  /** The name of the convenience store chain where the payment was completed. */
  chain: StripeChargePaymentMethodDetailsKonbiniStoreChain | null;
}

export enum StripeChargePaymentMethodDetailsKonbiniStoreChain {
  Familymart = 'familymart',
  Lawson = 'lawson',
  Ministop = 'ministop',
  Seicomart = 'seicomart',
}

export interface StripeChargePaymentMethodDetailsLink {
  /** Two-letter ISO code representing the funding source country beneath the Link payment. You could use this attribute to get a sense of international fees. */
  country: string | null;
}

export interface StripeChargePaymentMethodDetailsMultibanco {
  /** Entity number associated with this Multibanco payment. */
  entity: string | null;
  /** Reference number associated with this Multibanco payment. */
  reference: string | null;
}

export interface StripeChargePaymentMethodDetailsOxxo {
  /** OXXO reference number */
  number: string | null;
}

export interface StripeChargePaymentMethodDetailsP24 {
  /** The customer's bank. Can be one of `ing`, `citi_handlowy`, `tmobile_usbugi_bankowe`, `plus_bank`, `etransfer_pocztowy24`, `banki_spbdzielcze`, `bank_nowy_bfg_sa`, `getin_bank`, `blik`, `noble_pay`, `ideabank`, `envelobank`, `santander_przelew24`, `nest_przelew`, `mbank_mtransfer`, `inteligo`, `pbac_z_ipko`, `bnp_paribas`, `credit_agricole`, `toyota_bank`, `bank_pekao_sa`, `volkswagen_bank`, `bank_millennium`, `alior_bank`, or `boz`. */
  bank: StripeChargePaymentMethodDetailsP24Bank | null;
  /** Unique reference for this Przelewy24 payment. */
  reference: string | null;
  /** Owner's verified full name. Values are verified or provided by Przelewy24 directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. Przelewy24 rarely provides this information so the attribute is usually empty. */
  verified_name: string | null;
}

export enum StripeChargePaymentMethodDetailsP24Bank {
  AliorBank = 'alior_bank',
  BankMillennium = 'bank_millennium',
  BankNowyBfgSa = 'bank_nowy_bfg_sa',
  BankPekaoSa = 'bank_pekao_sa',
  BankiSpbdzielcze = 'banki_spbdzielcze',
  Blik = 'blik',
  BnpParibas = 'bnp_paribas',
  Boz = 'boz',
  CitiHandlowy = 'citi_handlowy',
  CreditAgricole = 'credit_agricole',
  Envelobank = 'envelobank',
  EtransferPocztowy24 = 'etransfer_pocztowy24',
  GetinBank = 'getin_bank',
  Ideabank = 'ideabank',
  Ing = 'ing',
  Inteligo = 'inteligo',
  MbankMtransfer = 'mbank_mtransfer',
  NestPrzelew = 'nest_przelew',
  NoblePay = 'noble_pay',
  PbacZIpko = 'pbac_z_ipko',
  PlusBank = 'plus_bank',
  SantanderPrzelew24 = 'santander_przelew24',
  TmobileUsbugiBankowe = 'tmobile_usbugi_bankowe',
  ToyotaBank = 'toyota_bank',
  VolkswagenBank = 'volkswagen_bank',
}

export interface StripeChargePaymentMethodDetailsPaynow {
  /** Reference number associated with this PayNow payment */
  reference: string | null;
}

export interface StripeChargePaymentMethodDetailsPaypal {
  /** Owner's email. Values are provided by PayPal directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  payer_email?: string | null;
  /** PayPal account PayerID. This identifier uniquely identifies the PayPal customer. */
  payer_id?: string | null;
  /** Owner's full name. Values provided by PayPal directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  payer_name?: string | null;
  /** The level of protection offered as defined by PayPal Seller Protection for Merchants, for this transaction. */
  seller_protection?: StripeChargePaymentMethodDetailsPaypalSellerProtection | null;
  /** A unique ID generated by PayPal for this transaction. */
  transaction_id?: string | null;
}

export interface StripeChargePaymentMethodDetailsPaypalSellerProtection {
  /** An array of conditions that are covered for the transaction, if applicable. */
  dispute_categories: StripeChargePaymentMethodDetailsPaypalSellerProtectionDisputeCategory[] | null;
  /** Indicates whether the transaction is eligible for PayPal's seller protection. */
  status: StripeChargePaymentMethodDetailsPaypalSellerProtectionStatus;
}

export enum StripeChargePaymentMethodDetailsPaypalSellerProtectionDisputeCategory {
  Fraudulent = 'fraudulent',
  ProductNotReceived = 'product_not_received',
}

export enum StripeChargePaymentMethodDetailsPaypalSellerProtectionStatus {
  Eligible = 'eligible',
  NotEligible = 'not_eligible',
  PartiallyEligible = 'partially_eligible',
}

export interface StripeChargePaymentMethodDetailsPix {
  /** Unique transaction id generated by BCB */
  bank_transaction_id?: string | null;
}

export interface StripeChargePaymentMethodDetailsPromptpay {
  /** Bill reference generated by PromptPay */
  reference: string | null;
}

export interface StripeChargePaymentMethodDetailsSepaCreditTransfer {
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Bank Identifier Code of the bank associated with the bank account. */
  bic: string | null;
  /** IBAN of the bank account to transfer funds to. */
  iban: string | null;
}

export interface StripeChargePaymentMethodDetailsSepaDebit {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Branch code of bank associated with the bank account. */
  branch_code: string | null;
  /** Two-letter ISO code representing the country the bank account is located in. */
  country: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four characters of the IBAN. */
  last4: string | null;
  /** ID of the mandate used to make this payment. */
  mandate: string | null;
}

export interface StripeChargePaymentMethodDetailsSofort {
  /** Bank code of bank associated with the bank account. */
  bank_code: string | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Bank Identifier Code of the bank associated with the bank account. */
  bic: string | null;
  /** Two-letter ISO code representing the country the bank account is located in. */
  country: string | null;
  /** The ID of the SEPA Direct Debit PaymentMethod which was generated by this Charge. */
  generated_sepa_debit: string | StripePaymentMethod | null;
  /** The mandate for the SEPA Direct Debit PaymentMethod which was generated by this Charge. */
  generated_sepa_debit_mandate: string | StripeMandate | null;
  /** Last four characters of the IBAN. */
  iban_last4: string | null;
  /** Preferred language of the SOFORT authorization page that the customer is redirected to. Can be one of `de`, `en`, `es`, `fr`, `it`, `nl`, or `pl` */
  preferred_language: StripeChargePaymentMethodDetailsSofortPreferredLanguage | null;
  /** Owner's verified full name. Values are verified or provided by SOFORT directly (if supported) at the time of authorization or settlement. They cannot be set or mutated. */
  verified_name: string | null;
}

export enum StripeChargePaymentMethodDetailsSofortPreferredLanguage {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl',
  Pl = 'pl',
}

export type StripeChargePaymentMethodDetailsStripeAccount = object;

export interface StripeChargePaymentMethodDetailsUsBankAccount {
  /** Account holder type: individual or company. */
  account_holder_type: StripeChargePaymentMethodDetailsUsBankAccountAccountHolderType | null;
  /** Account type: checkings or savings. Defaults to checking if omitted. */
  account_type: StripeChargePaymentMethodDetailsUsBankAccountAccountType | null;
  /** Name of the bank associated with the bank account. */
  bank_name: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** Routing number of the bank account. */
  routing_number: string | null;
}

export enum StripeChargePaymentMethodDetailsUsBankAccountAccountHolderType {
  Company = 'company',
  Individual = 'individual',
}

export enum StripeChargePaymentMethodDetailsUsBankAccountAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

export type StripeChargePaymentMethodDetailsWechat = object;

export interface StripeChargePaymentMethodDetailsWechatPay {
  /** Uniquely identifies this particular WeChat Pay account. You can use this attribute to check whether two WeChat accounts are the same. */
  fingerprint: string | null;
  /** Transaction ID of this particular WeChat Pay transaction. */
  transaction_id: string | null;
}

export type StripeChargePaymentMethodDetailsZip = object;

export interface StripeChargeRadarOptions {
  /** A [Radar Session](https://stripe.com/docs/radar/radar-session) is a snapshot of the browser metadata and device details that help Radar make more accurate predictions on your payments. */
  session?: string;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeRefund {
  object: 'list';
  data: StripeRefund[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

export interface StripeChargeShipping {
  /** The Address object. */
  address?: StripeAddress;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. */
  carrier?: string | null;
  /** Recipient name. */
  name?: string;
  /** Recipient phone (including extension). */
  phone?: string | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  tracking_number?: string | null;
}

export enum StripeChargeStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded',
}

export interface StripeChargeTransferData {
  /** The amount transferred to the destination account, if specified. By default, the entire charge amount is transferred to the destination account. */
  amount: number | null;
  /** ID of an existing, connected Stripe account to transfer funds to if `transfer_data` was specified in the charge request. */
  destination: string | StripeAccount;
}

export interface StripePaymentMethodSofort {
  /** Two-letter ISO code representing the country the bank account is located in. */
  country: string | null;
}

export enum StripePaymentMethodType {
  AcssDebit = 'acss_debit',
  Affirm = 'affirm',
  AfterpayClearpay = 'afterpay_clearpay',
  Alipay = 'alipay',
  AuBecsDebit = 'au_becs_debit',
  BacsDebit = 'bacs_debit',
  Bancontact = 'bancontact',
  Blik = 'blik',
  Boleto = 'boleto',
  Card = 'card',
  CardPresent = 'card_present',
  Cashapp = 'cashapp',
  CustomerBalance = 'customer_balance',
  Eps = 'eps',
  Fpx = 'fpx',
  Giropay = 'giropay',
  Grabpay = 'grabpay',
  Ideal = 'ideal',
  InteracPresent = 'interac_present',
  Klarna = 'klarna',
  Konbini = 'konbini',
  Link = 'link',
  Oxxo = 'oxxo',
  P24 = 'p24',
  Paynow = 'paynow',
  Paypal = 'paypal',
  Pix = 'pix',
  Promptpay = 'promptpay',
  SepaDebit = 'sepa_debit',
  Sofort = 'sofort',
  UsBankAccount = 'us_bank_account',
  WechatPay = 'wechat_pay',
  Zip = 'zip',
}

export interface StripePaymentMethodUsBankAccount {
  /** Account holder type: individual or company. */
  account_holder_type: StripePaymentMethodUsBankAccountAccountHolderType | null;
  /** Account type: checkings or savings. Defaults to checking if omitted. */
  account_type: StripePaymentMethodUsBankAccountAccountType | null;
  /** The name of the bank. */
  bank_name: string | null;
  /** The ID of the Financial Connections Account used to create the payment method. */
  financial_connections_account?: string | null;
  /** Uniquely identifies this particular bank account. You can use this attribute to check whether two bank accounts are the same. */
  fingerprint: string | null;
  /** Last four digits of the bank account number. */
  last4: string | null;
  /** Contains information about US bank account networks that can be used. */
  networks: StripePaymentMethodUsBankAccountNetworks | null;
  /** Routing number of the bank account. */
  routing_number: string | null;
  /** Contains information about the future reusability of this PaymentMethod. */
  status_details?: StripePaymentMethodUsBankAccountStatusDetails | null;
}

export enum StripePaymentMethodUsBankAccountAccountHolderType {
  Company = 'company',
  Individual = 'individual',
}

export enum StripePaymentMethodUsBankAccountAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

export interface StripePaymentMethodUsBankAccountNetworks {
  /** The preferred network. */
  preferred: string | null;
  /** All supported networks. */
  supported: StripePaymentMethodUsBankAccountNetworksSupported[];
}

export enum StripePaymentMethodUsBankAccountNetworksSupported {
  Ach = 'ach',
  UsDomesticWire = 'us_domestic_wire',
}

export interface StripePaymentMethodUsBankAccountStatusDetails {
  blocked?: StripePaymentMethodUsBankAccountStatusDetailsBlocked;
}

export interface StripePaymentMethodUsBankAccountStatusDetailsBlocked {
  /** The ACH network code that resulted in this block. */
  network_code: StripePaymentMethodUsBankAccountStatusDetailsBlockedNetworkCode | null;
  /** The reason why this PaymentMethod's fingerprint has been blocked */
  reason: StripePaymentMethodUsBankAccountStatusDetailsBlockedReason | null;
}

export enum StripePaymentMethodUsBankAccountStatusDetailsBlockedNetworkCode {
  R02 = 'R02',
  R03 = 'R03',
  R04 = 'R04',
  R05 = 'R05',
  R07 = 'R07',
  R08 = 'R08',
  R10 = 'R10',
  R11 = 'R11',
  R16 = 'R16',
  R20 = 'R20',
  R29 = 'R29',
  R31 = 'R31',
}

export enum StripePaymentMethodUsBankAccountStatusDetailsBlockedReason {
  BankAccountClosed = 'bank_account_closed',
  BankAccountFrozen = 'bank_account_frozen',
  BankAccountInvalidDetails = 'bank_account_invalid_details',
  BankAccountRestricted = 'bank_account_restricted',
  BankAccountUnusable = 'bank_account_unusable',
  DebitNotAuthorized = 'debit_not_authorized',
}

export type StripePaymentMethodWechatPay = object;

export type StripePaymentMethodZip = object;

export interface StripeCustomerInvoiceSettingsRenderingOptions {
  /** How line-item prices and amounts will be displayed with respect to tax on invoice PDFs. */
  amount_tax_display: string | null;
}

export interface StripeCustomerShipping {
  /** The Address object. */
  address?: StripeAddress;
  /** The delivery service that shipped a physical product, such as Fedex, UPS, USPS, etc. */
  carrier?: string | null;
  /** Recipient name. */
  name?: string;
  /** Recipient phone (including extension). */
  phone?: string | null;
  /** The tracking number for a physical product, obtained from the delivery service. If multiple tracking numbers were generated for this purchase, please separate them with commas. */
  tracking_number?: string | null;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeCustomerSource {
  object: 'list';
  data: StripeCustomerSource[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListInterface1840160676871133518401606768525530184016067666255301840160676642553218401606760255321840160676025533 {
  object: 'list';
  data: StripeSubscription[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

export interface StripeCustomerTax {
  /** Surfaces if automatic tax computation is possible given the current customer location information. */
  automatic_tax: StripeCustomerTaxAutomaticTax;
  /** A recent IP address of the customer used for tax reporting and tax location inference. */
  ip_address: string | null;
  /** The customer's location as identified by Stripe Tax. */
  location: StripeCustomerTaxLocation | null;
}

export enum StripeCustomerTaxAutomaticTax {
  Failed = 'failed',
  NotCollecting = 'not_collecting',
  Supported = 'supported',
  UnrecognizedLocation = 'unrecognized_location',
}

export interface StripeCustomerTaxLocation {
  /** The customer's country as identified by Stripe Tax. */
  country: string;
  /** The data source used to infer the customer's location. */
  source: StripeCustomerTaxLocationSource;
  /** The customer's state, county, province, or region as identified by Stripe Tax. */
  state: string | null;
}

export enum StripeCustomerTaxLocationSource {
  BillingAddress = 'billing_address',
  IpAddress = 'ip_address',
  PaymentMethod = 'payment_method',
  ShippingDestination = 'shipping_destination',
}

export enum StripeCustomerTaxExempt {
  Exempt = 'exempt',
  None = 'none',
  Reverse = 'reverse',
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeTaxId {
  object: 'list';
  data: StripeTaxId[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeSubscriptionItem {
  object: 'list';
  data: StripeSubscriptionItem[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

export interface StripeSubscriptionPauseCollection {
  /** The payment collection behavior for this subscription while paused. One of `keep_as_draft`, `mark_uncollectible`, or `void`. */
  behavior: StripeSubscriptionPauseCollectionBehavior;
  /** The time after which the subscription will resume collecting payments. */
  resumes_at: number | null;
}

export enum StripeSubscriptionPauseCollectionBehavior {
  KeepAsDraft = 'keep_as_draft',
  MarkUncollectible = 'mark_uncollectible',
  Void = 'void',
}

export interface StripeSubscriptionPaymentSettings {
  /** Payment-method-specific configuration to provide to invoices created by the subscription. */
  payment_method_options: StripeSubscriptionPaymentSettingsPaymentMethodOptions | null;
  /** The list of payment method types to provide to every invoice created by the subscription. If not set, Stripe attempts to automatically determine the types to use by looking at the invoice's default payment method, the subscription's default payment method, the customer's default payment method, and your [invoice template settings](https://dashboard.stripe.com/settings/billing/invoice). */
  payment_method_types: StripeSubscriptionPaymentSettingsPaymentMethodType[] | null;
  /** Either `off`, or `on_subscription`. With `on_subscription` Stripe updates `subscription.default_payment_method` when a subscription payment succeeds. */
  save_default_payment_method: StripeSubscriptionPaymentSettingsSaveDefaultPaymentMethod | null;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptions {
  /** This sub-hash contains details about the Canadian pre-authorized debit payment method options to pass to invoices created by the subscription. */
  acss_debit: StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebit | null;
  /** This sub-hash contains details about the Bancontact payment method options to pass to invoices created by the subscription. */
  bancontact: StripeSubscriptionPaymentSettingsPaymentMethodOptionsBancontact | null;
  /** This sub-hash contains details about the Card payment method options to pass to invoices created by the subscription. */
  card: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCard | null;
  /** This sub-hash contains details about the Bank transfer payment method options to pass to invoices created by the subscription. */
  customer_balance: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalance | null;
  /** This sub-hash contains details about the Konbini payment method options to pass to invoices created by the subscription. */
  konbini: StripeSubscriptionPaymentSettingsPaymentMethodOptionsKonbini | null;
  /** This sub-hash contains details about the ACH direct debit payment method options to pass to invoices created by the subscription. */
  us_bank_account: StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccount | null;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebit {
  mandate_options?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebitMandateOptions;
  /** Bank account verification method. */
  verification_method?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebitVerificationMethod;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebitMandateOptions {
  /** Transaction type of the mandate. */
  transaction_type: StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebitMandateOptionsTransactionType | null;
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebitMandateOptionsTransactionType {
  Business = 'business',
  Personal = 'personal',
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsAcssDebitVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsBancontact {
  /** Preferred language of the Bancontact authorization page that the customer is redirected to. */
  preferred_language: StripeSubscriptionPaymentSettingsPaymentMethodOptionsBancontactPreferredLanguage;
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsBancontactPreferredLanguage {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsCard {
  mandate_options?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardMandateOptions;
  /** Selected network to process this Subscription on. Depends on the available networks of the card attached to the Subscription. Can be only set confirm-time. */
  network: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardNetwork | null;
  /** We strongly recommend that you rely on our SCA Engine to automatically prompt your customers for authentication based on risk level and [other requirements](https://stripe.com/docs/strong-customer-authentication). However, if you wish to request 3D Secure based on logic from your own fraud engine, provide this option. Read our guide on [manually requesting 3D Secure](https://stripe.com/docs/payments/3d-secure#manual-three-ds) for more information on how this configuration interacts with Radar and our SCA Engine. */
  request_three_d_secure: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardRequestThreeDSecure | null;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardMandateOptions {
  /** Amount to be charged for future payments. */
  amount: number | null;
  /** One of `fixed` or `maximum`. If `fixed`, the `amount` param refers to the exact amount to be charged in future payments. If `maximum`, the amount charged can be up to the value passed for the `amount` param. */
  amount_type: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardMandateOptionsAmountType | null;
  /** A description of the mandate or subscription that is meant to be displayed to the customer. */
  description: string | null;
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardMandateOptionsAmountType {
  Fixed = 'fixed',
  Maximum = 'maximum',
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardNetwork {
  Amex = 'amex',
  CartesBancaires = 'cartes_bancaires',
  Diners = 'diners',
  Discover = 'discover',
  EftposAu = 'eftpos_au',
  Interac = 'interac',
  Jcb = 'jcb',
  Mastercard = 'mastercard',
  Unionpay = 'unionpay',
  Unknown = 'unknown',
  Visa = 'visa',
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsCardRequestThreeDSecure {
  Any = 'any',
  Automatic = 'automatic',
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalance {
  bank_transfer?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransfer;
  /** The funding method type to be used when there are not enough funds in the customer balance. Permitted values include: `bank_transfer`. */
  funding_type: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceFundingTypeEnum;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransfer {
  eu_bank_transfer?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer;
  /** The bank transfer type that can be used for funding. Permitted values include: `eu_bank_transfer`, `gb_bank_transfer`, `jp_bank_transfer`, `mx_bank_transfer`, or `us_bank_transfer`. */
  type: string | null;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransfer {
  /** The desired country code of the bank account information. Permitted values include: `BE`, `DE`, `ES`, `FR`, `IE`, or `NL`. */
  country: StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransferCountry;
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceBankTransferEuBankTransferCountry {
  BE = 'BE',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  IE = 'IE',
  NL = 'NL',
}

export type StripeSubscriptionPaymentSettingsPaymentMethodOptionsKonbini = object;

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccount {
  financial_connections?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnections;
  /** Bank account verification method. */
  verification_method?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccountVerificationMethod;
}

export interface StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnections {
  /** The list of permissions to request. The `payment_method` permission must be included. */
  permissions?: StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission[];
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccountFinancialConnectionsPermission {
  Balances = 'balances',
  PaymentMethod = 'payment_method',
  Transactions = 'transactions',
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsUsBankAccountVerificationMethod {
  Automatic = 'automatic',
  Instant = 'instant',
  Microdeposits = 'microdeposits',
}

export enum StripeSubscriptionPaymentSettingsPaymentMethodType {
  AchCreditTransfer = 'ach_credit_transfer',
  AchDebit = 'ach_debit',
  AcssDebit = 'acss_debit',
  AuBecsDebit = 'au_becs_debit',
  BacsDebit = 'bacs_debit',
  Bancontact = 'bancontact',
  Boleto = 'boleto',
  Card = 'card',
  Cashapp = 'cashapp',
  CustomerBalance = 'customer_balance',
  Fpx = 'fpx',
  Giropay = 'giropay',
  Grabpay = 'grabpay',
  Ideal = 'ideal',
  Konbini = 'konbini',
  Link = 'link',
  Paynow = 'paynow',
  Paypal = 'paypal',
  Promptpay = 'promptpay',
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
  Sofort = 'sofort',
  UsBankAccount = 'us_bank_account',
  WechatPay = 'wechat_pay',
}

export enum StripeSubscriptionPaymentSettingsSaveDefaultPaymentMethod {
  Off = 'off',
  OnSubscription = 'on_subscription',
}

export interface StripeSubscriptionPendingInvoiceItemInterval {
  /** Specifies invoicing frequency. Either `day`, `week`, `month` or `year`. */
  interval: StripeSubscriptionPendingInvoiceItemIntervalInterval;
  /** The number of intervals between invoices. For example, `interval=month` and `interval_count=3` bills every 3 months. Maximum of one year interval allowed (1 year, 12 months, or 52 weeks). */
  interval_count: number;
}

export enum StripeSubscriptionPendingInvoiceItemIntervalInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export interface StripeSubscriptionPendingUpdate {
  /** If the update is applied, determines the date of the first full invoice, and, for plans with `month` or `year` intervals, the day of the month for subsequent invoices. The timestamp is in UTC format. */
  billing_cycle_anchor: number | null;
  /** The point after which the changes reflected by this update will be discarded and no longer applied. */
  expires_at: number;
  /** List of subscription items, each with an attached plan, that will be set if the update is applied. */
  subscription_items: StripeSubscriptionItem[] | null;
  /** Unix timestamp representing the end of the trial period the customer will get before being charged for the first time, if the update is applied. */
  trial_end: number | null;
  /** Indicates if a plan's `trial_period_days` should be applied to the subscription. Setting `trial_end` per subscription is preferred, and this defaults to `false`. Setting this flag to `true` together with `trial_end` is not allowed. See [Using trial periods on subscriptions](https://stripe.com/docs/billing/subscriptions/trials) to learn more. */
  trial_from_plan: boolean | null;
}

export enum StripeSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export interface StripeSubscriptionTransferData {
  /** A non-negative decimal between 0 and 100, with at most two decimal places. This represents the percentage of the subscription invoice subtotal that will be transferred to the destination account. By default, the entire amount is transferred to the destination. */
  amount_percent: number | null;
  /** The account where funds from the payment will be transferred to upon payment success. */
  destination: string | StripeAccount;
}

export interface StripeSubscriptionTrialSettings {
  /** Defines how a subscription behaves when a free trial ends. */
  end_behavior: StripeSubscriptionTrialSettingsEndBehavior;
}

export interface StripeSubscriptionTrialSettingsEndBehavior {
  /** Indicates how the subscription should change when the trial ends if the user did not provide a payment method. */
  missing_payment_method: StripeSubscriptionTrialSettingsEndBehaviorMissingPaymentMethod;
}

export enum StripeSubscriptionTrialSettingsEndBehaviorMissingPaymentMethod {
  Cancel = 'cancel',
  CreateInvoice = 'create_invoice',
  Pause = 'pause',
}

export interface UserPaidProductMetaSite {
  id: number;
  host: string;
}

export interface ToggleAgencySiteProductDto {
  product: UserwaySubjectTransactionType;
}

export interface CreateChildUserAndSiteResponseDto {
  widget: WidgetInstallInfo;
}

export interface WidgetInstallInfo {
  code: string;
  siteId: number;
  html: string;
}

export interface CreateChildUserAndSiteDto {
  email: string;
  url: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  widgetColor?: string;
  widgetPosition?: string;
  widgetIconType?: string;
  widgetIconSize?: string;
}

export interface AgencyAccountSummaryReport {
  isLockedPeriod: boolean;
  sites: AgencyAccountSummarySites;
  paymentMethods: PaymentMethodDetailsDto[];
  discount: AgencyAccountDiscount | null;
  upcomingInvoice: AgencyAccountUpcomingInvoice;
}

export interface AgencyAccountSummarySites {
  free: number;
  paid: number;
  agency: number;
  total: number;
}

export interface PaymentMethodDetailsDto {
  uwPaymentDataId: number;
  providerPaymentMethodId: string | null;
  provider: BillingProvider;
  method: BillingMethod;
  isDefault: boolean;
  alias: string | null;
  card: PaymentCardDetailsDto | null;
}

export enum BillingMethod {
  CREDIT_CARD = 'CREDIT_CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  ACH = 'ACH',
}

export interface PaymentCardDetailsDto {
  type: string;
  expYear: number;
  expMonth: number;
  lastFour: string;
  firstName: string;
  lastName: string | null;
}

export interface AgencyAccountDiscount {
  percentage: boolean;
  off: number;
}

export interface AgencyAccountUpcomingInvoice {
  cycle: SubscriptionBillingCycleType;
  total: number;
  subtotal: number;
  /** @format date-time */
  date: string;
}

export enum SubscriptionBillingCycleType {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
  BIANNUAL = 'BIANNUAL',
  TRIENNIAL = 'TRIENNIAL',
  QUINQUENNIAL = 'QUINQUENNIAL',
  YEARLY = 'YEARLY',
  BIMONTHLY = 'BIMONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export interface AgencySubscriptionUpdateNameDto {
  name: string;
}

export interface AgencySubscriptionUpdatePaymentData {
  paymentDataId: number;
}

export interface AgencySiteBillingDetailsDto {
  options: AgencySiteOptionsDto;
  productsMap: RecordUserwaySubjectTransactionTypeAgencySiteBillingProductDetailsDto;
}

export interface AgencySiteOptionsDto {
  widgetVisible: boolean;
}

export interface RecordUserwaySubjectTransactionTypeAgencySiteBillingProductDetailsDto {
  WHITE_LABEL: AgencySiteBillingProductDetailsDto;
  CUSTOM_BRANDING: AgencySiteBillingProductDetailsDto;
  MODIFY_MENU: AgencySiteBillingProductDetailsDto;
  USAGE_STATS: AgencySiteBillingProductDetailsDto;
  LIVE_TRANSLATIONS: AgencySiteBillingProductDetailsDto;
  REMEDIATION: AgencySiteBillingProductDetailsDto;
  REMEDIATION_PLUS: AgencySiteBillingProductDetailsDto;
  REMEDIATION_ULTIMATE: AgencySiteBillingProductDetailsDto;
  SCANNING_AND_MONITORING: AgencySiteBillingProductDetailsDto;
  IMG_REMEDIATION: AgencySiteBillingProductDetailsDto;
  PDF_AUTO_REMEDIATION: AgencySiteBillingProductDetailsDto;
  DONATION: AgencySiteBillingProductDetailsDto;
  PDF_REMEDIATION: AgencySiteBillingProductDetailsDto;
  VIDEO_REMEDIATION: AgencySiteBillingProductDetailsDto;
  STATEMENT_OF_COMPLIANCE: AgencySiteBillingProductDetailsDto;
  GENERAL: AgencySiteBillingProductDetailsDto;
  AUDIT: AgencySiteBillingProductDetailsDto;
  AUDIT_VPAT: AgencySiteBillingProductDetailsDto;
  AUDIT_VALIDATION: AgencySiteBillingProductDetailsDto;
  AUDIT_LANDING_PAGE: AgencySiteBillingProductDetailsDto;
  AUDIT_STANDARD_WEBSITE: AgencySiteBillingProductDetailsDto;
  AUDIT_ECOMMERCE_SITE: AgencySiteBillingProductDetailsDto;
  AUDIT_LARGE_WEBSITE: AgencySiteBillingProductDetailsDto;
  AUDIT_WEB_APP: AgencySiteBillingProductDetailsDto;
  AUDIT_GENERAL: AgencySiteBillingProductDetailsDto;
  MANAGED_ACCESSIBILITY: AgencySiteBillingProductDetailsDto;
  SLA_SUPPORT: AgencySiteBillingProductDetailsDto;
  SUCCESS_PROGRAM: AgencySiteBillingProductDetailsDto;
  REMEDIATION_SERVICES: AgencySiteBillingProductDetailsDto;
  LEGAL_PUNCH_LIST: AgencySiteBillingProductDetailsDto;
  LEGAL_RENOVATION: AgencySiteBillingProductDetailsDto;
  LEGAL_PROOF_POSITIVE: AgencySiteBillingProductDetailsDto;
  LEGAL_EXPERT_REPORT: AgencySiteBillingProductDetailsDto;
  LEGAL_EXPERT_DEPOSITION: AgencySiteBillingProductDetailsDto;
  LEGAL_EXPERT_TRIAL_TESTIMONY: AgencySiteBillingProductDetailsDto;
  SSO: AgencySiteBillingProductDetailsDto;
  PRM: AgencySiteBillingProductDetailsDto;
  ROR: AgencySiteBillingProductDetailsDto;
  CPA: AgencySiteBillingProductDetailsDto;
  STP: AgencySiteBillingProductDetailsDto;
  PLE: AgencySiteBillingProductDetailsDto;
  HR: AgencySiteBillingProductDetailsDto;
  TRAINING_NVDA_FOR_TESTERS: AgencySiteBillingProductDetailsDto;
  TRAINING_ACCESSIBILITY_OVERVIEW: AgencySiteBillingProductDetailsDto;
  TRAINING_EMPATHY_LAB: AgencySiteBillingProductDetailsDto;
  TRAINING_VIRTUAL_DESIGN_BASICS: AgencySiteBillingProductDetailsDto;
  TRAINING_CODE_FE: AgencySiteBillingProductDetailsDto;
  TRAINING_CODE_ARIA: AgencySiteBillingProductDetailsDto;
  TRAINING_CONTENT_WRITERS: AgencySiteBillingProductDetailsDto;
  TRAINING_PDF_CONTENT_WRITERS: AgencySiteBillingProductDetailsDto;
  TRAINING_WCAG_CRITERIA: AgencySiteBillingProductDetailsDto;
  TRAINING_ACCESSIBLE_FORMS: AgencySiteBillingProductDetailsDto;
  TRAINING_ACCESSIBLE_SOCIAL_MEDIA: AgencySiteBillingProductDetailsDto;
  TRAINING_PDF_REMEDIATION: AgencySiteBillingProductDetailsDto;
  DEV_STAGING_SITE: AgencySiteBillingProductDetailsDto;
  BULK_PACKAGE_SITE: AgencySiteBillingProductDetailsDto;
  CA11Y_MANAGED: AgencySiteBillingProductDetailsDto;
  CA11Y_SELF_HOSTED: AgencySiteBillingProductDetailsDto;
  CHARGEBACK: AgencySiteBillingProductDetailsDto;
  REFUND: AgencySiteBillingProductDetailsDto;
  CHARGEBACK_REINSTATED: AgencySiteBillingProductDetailsDto;
}

export interface AgencySiteBillingProductDetailsDto {
  agencyState: AgencySiteConfigProductState | null;
  totals: InvoiceTotalsDto | null;
  isEnabled: boolean;
  startsAt: string | null;
  expiresAt: string | null;
}

export enum AgencySiteConfigProductState {
  PAID = 'PAID',
  FREE = 'FREE',
}

export interface InvoiceTotalsDto {
  currency: PricingCurrency;
  taxUsd: number;
  taxRate: number;
  discountUsd: number;
  discountPercentage: number;
  totalUsd: number;
  subtotalUsd: number;
}

export interface AgencySiteEnableProductDto {
  productType: UserwaySubjectTransactionType;
}

export interface AgencyTransferProductDto {
  siteIdFrom: number;
  siteIdTo: number;
}

export interface AgencySiteDisableProductDto {
  productType: UserwaySubjectTransactionType;
}

export interface AddSitesBatchResponseDto {
  added: number;
  duplicates: number;
  invalid: number;
  addedSites: AddSitesBatchSiteDetails[];
  duplicatesSites: AddSitesBatchSiteDetails[];
}

export interface AddSitesBatchSiteDetails {
  id: number;
  url: string;
}

export interface AgencyDisableSitesBatchResponseDto {
  disabled: number;
  invalid: number;
}

export interface AgencyAccountContextDto {
  agencySubscriptions: AgencySubscriptionPreviewDto[];
  paymentMethods: PaymentMethodDetailsDto[];
  sitesTotals: AgencySitesTotalsDto;
  quotaTotals: AgencyQuotaTotalsDto;
  discount: AgencyAccountDiscount | null;
  upcomingInvoice: AgencySubscriptionUpcomingInvoiceDto | null;
  billingDescriptorSuffix: string | null;
  remediationAllowedStates: AgencySiteState[];
}

export interface AgencySubscriptionPreviewDto {
  id: number;
  name: string;
  type: AgencySubscriptionType;
  status: AgencySubscriptionStatus;
  cycle: SubscriptionBillingCycleType;
  usedSitesQuota: number;
  maxSitesQuota: number | null;
  isLockedPeriod: boolean;
  startsAt: string | null;
  expiresAt: string | null;
}

export enum AgencySubscriptionType {
  POST_PAID = 'POST_PAID',
  BULK_PREPAID = 'BULK_PREPAID',
}

export enum AgencySubscriptionStatus {
  ACTIVE = 'ACTIVE',
  NEW = 'NEW',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  DISABLED = 'DISABLED',
}

export interface AgencySitesTotalsDto {
  agency: number;
  paid: number;
  prePaid: number;
  postPaid: number;
  free: number;
  total: number;
}

export interface AgencyQuotaTotalsDto {
  prePaidTotal: number;
  prePaidUsed: number;
  postPaidTotal: number;
  postPaidUsed: number;
}

export interface AgencySubscriptionUpcomingInvoiceDto {
  totals: InvoiceTotalsDto;
  cycle: SubscriptionBillingCycleType;
  /** @format date-time */
  date: string;
}

export enum AgencySiteState {
  FREE = 'FREE',
  PAID = 'PAID',
}

export interface AgencyAccountUpdateBillingDescriptorDto {
  billingDescriptorSuffix: string | null;
}

export interface LoginWidgetResponseDto {
  token: string;
  refreshToken: string;
  user: UserPrivateInfo;
  jwtUserDetails: SsoJwtUserDetails;
}

export interface UserPrivateInfo {
  id: number;
  email: string;
  code: string;
  first_name: string;
  last_name: string;
  /** **master** role is stored as a separate boolean column in UserWay but is part of the UserType in SSO */
  role: UwSsoRoles;
  isMasterAccount: boolean;
  phone: string;
  parent_id: number | null;
  /** @format date-time */
  created_at: string;
  discount?: string;
  discount_expires_at: string | null;
  status: UserStatus;
  is_blocked: boolean;
  key: string;
  everflowClickId: string;
  ssoUserId: string;
}

/** **master** role is stored as a separate boolean column in UserWay but is part of the UserType in SSO */
export enum UwSsoRoles {
  User = 'user',
  Admin = 'admin',
  Sales = 'sales',
  Company = 'company',
  Author = 'author',
  Master = 'master',
}

export enum UserStatus {
  Activation = 'activation',
  Active = 'active',
  Paused = 'paused',
}

export interface SsoJwtUserDetails {
  sessionID?: string;
  ssoUserId: string;
  accountCode: string;
  userType: string;
  username: string;
  firstName: string;
  lastName: string;
  targetSsoUserId: string;
  targetAccountCode: string;
  targetAccountSlug: string;
  authenticatedUserId?: string;
  targetAccounts?: TargetAccountRecord[];
  hasExtendedToken: boolean;
  targetSiteId?: number;
  loginScopes: UserLoginScope[];
  loginType: UserLoginType;
  loginMechanism: UserLoginMechanism;
  checksum: string;
  authorities: JWTGrantedAuthority[];
  restrictions: JwtRestriction[];
  enabledMfa: boolean;
}

export interface TargetAccountRecord {
  targetSsoUserId: string;
  targetAccountCode: string;
  targetAccountSlug: string;
  requiredMfa: boolean;
  restrictions: JwtRestriction[];
  allowedAllSites: boolean;
}

export interface JwtRestriction {
  roleName: GrantedMemberRole;
  roleScope: string[];
}

export enum GrantedMemberRole {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum UserLoginScope {
  SCANNER_SCOPE = 'SCANNER_SCOPE',
  WIDGET_SCOPE = 'WIDGET_SCOPE',
  CA11YSCOPE = 'CA11Y_SCOPE',
}

export enum UserLoginType {
  USER_LOGIN = 'USER_LOGIN',
  ADMIN_LOGIN_AS = 'ADMIN_LOGIN_AS',
  MEMBER_LOGIN_AS = 'MEMBER_LOGIN_AS',
}

export enum UserLoginMechanism {
  CREDENTIALS_LOGIN = 'CREDENTIALS_LOGIN',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
  SSO_LOGIN = 'SSO_LOGIN',
  API_KEY_LOGIN = 'API_KEY_LOGIN',
  SYSTEM_LOGIN = 'SYSTEM_LOGIN',
}

export interface JWTGrantedAuthority {
  authority: string;
}

export interface WidgetSignInDto {
  email: string;
  password: string;
  account: string;
  siteId: number;
  verificationCode?: string;
  mfaMethod?: MfaMethod;
}

export enum MfaMethod {
  VIRTUAL_MFA = 'VIRTUAL_MFA',
  EMAIL_MFA = 'EMAIL_MFA',
}

export interface DashboardAccessMapResponse {
  accessMap: WidgetAccessMap | DashboardAccessMap;
}

export interface WidgetAccessMap {
  managePage: PageAccessMap;
}

export interface PageAccessMap {
  mySitesTab: SitesTabAccessMap;
  addonsTab: AddonsTabAccessMap;
  widgetSettingsTab: WidgetSettingsTabAccessMap;
  accountSettingsTab: AccountSettingsTabAccessMap;
}

export interface SitesTabAccessMap {
  mySitesService: boolean;
}

export interface AddonsTabAccessMap {
  addonsService: boolean;
}

export interface WidgetSettingsTabAccessMap {
  widgetSettingsService: boolean;
}

export interface AccountSettingsTabAccessMap {
  accountSettingsService: boolean;
}

export interface DashboardAccessMap {
  manageBilling: BillingAccessMap;
  manageTeam: TeamAccessMap;
  manageSites: SitesAccessMap;
  manageScans: ScansAccessMap;
  manageImageAlts: ImageAltsAccessMap;
  managePdfs: PdfsAccessMap;
  manageMyAccount: MyAccountAccessMap;
  manageEmbedCode: EmbedCodeAccessMap;
  manageAccessibilityServices: AccessibilityServicesAccessMap;
  manageDeveloperResources: DeveloperResourcesAccessMap;
  notifications: NotificationsAccessMap;
  manageAgencyResources: AgencyResourcesAccessMap;
  manageRegTracker: RegTrackerAccessMap;
  manageSupportServices: SupportServicesAccessMap;
  becomeAPartnerLink: boolean;
}

export interface BillingAccessMap {
  subscriptionPage: boolean;
  billingInvoicesPage: boolean;
  billingOperations: boolean;
}

export interface TeamAccessMap {
  teamManagementService: boolean;
  teamList: boolean;
  subAccountList: boolean;
  teamManagementPage: ManagementPageAccessMap;
}

export interface ManagementPageAccessMap {
  enforce2FAService: boolean;
  editTeamService: boolean;
  inviteTeamMemberService: boolean;
  addSubAccountService: boolean;
}

export interface SitesAccessMap {
  siteList: boolean;
  deletedSiteList: boolean;
  addSiteService: boolean;
  getCSVListOfSiteService: boolean;
  agencyData: boolean;
  overviewPage: OverviewPageAccessMap;
  configurePage: ConfigurePageAccessMap;
  reportPage: ReportPageAccessMap;
  statPage: StatPageAccessMap;
  customizePage: CustomizePageAccessMap;
  addonPage: AddonPageAccessMap;
  statementPage: StatementPageAccessMap;
  reportedIssuesPage: ReportedIssuesPageAccessMap;
  settingsPage: SettingsPageAccessMap;
}

export interface OverviewPageAccessMap {
  overviewService: boolean;
  needHelp: boolean;
  onboarding: boolean;
  oneOnOne: boolean;
  currentPlan: boolean;
  pdfReport: boolean;
  accessibilityReport: boolean;
  planDetails: boolean;
  statisticsReport: boolean;
  statisticsMedia: boolean;
}

export interface ConfigurePageAccessMap {
  configureService: boolean;
}

export interface ReportPageAccessMap {
  reportService: boolean;
}

export interface StatPageAccessMap {
  statService: boolean;
}

export interface CustomizePageAccessMap {
  customizeService: boolean;
  buttonColor: boolean;
  buttonType: boolean;
  LSTButtons: boolean;
  buttonLocation: boolean;
  widgetCustomization: boolean;
  modifyMenu: boolean;
  widgetType: boolean;
  language: boolean;
  customTrigger: boolean;
  saveToAll: boolean;
}

export interface AddonPageAccessMap {
  switchToAnnualButton: boolean;
  addonService: boolean;
  modifyMenu: boolean;
  liveSiteTranslation: boolean;
  getCSVLstStats: boolean;
}

export interface StatementPageAccessMap {
  statementService: boolean;
  accessibilityStatement: AccessibilityStatementAccessMap;
  accessibilityStatementLink: boolean;
}

export interface AccessibilityStatementAccessMap {
  downloadStatement: boolean;
  customizeStatement: CustomizeStatementAccessMap;
}

export interface CustomizeStatementAccessMap {
  customizeStatementService: boolean;
  statementGenerator: boolean;
  statementProducts: boolean;
}

export interface ReportedIssuesPageAccessMap {
  reportedIssuesService: boolean;
  reportConfiguration: {
    reportConfigurationService: boolean;
  };
  reportedIssuesList: {
    reportedIssuesListService: boolean;
  };
}

export interface SettingsPageAccessMap {
  settingsService: boolean;
}

export interface ScansAccessMap {
  scansTab: boolean;
}

export interface ImageAltsAccessMap {
  imageAltsTab: boolean;
}

export interface PdfsAccessMap {
  pdfsTab: boolean;
  remediationPlanPanel: boolean;
}

export interface MyAccountAccessMap {
  manageMyAccountPage: boolean;
  changePassword: boolean;
  changeEmail: boolean;
  ipWhiteList: boolean;
  manage2fa: boolean;
}

export interface EmbedCodeAccessMap {
  manageEmbedCodeTab: boolean;
  needHelp: boolean;
  onboarding: boolean;
  oneOnOne: boolean;
}

export interface AccessibilityServicesAccessMap {
  manageAccessibilityServicesTab: boolean;
  manageAccessibilityAudit: boolean;
  manageAccessibilityVPAT: boolean;
  manageAccessibilityManagedAccessibility: boolean;
  manageAccessibilityLegalSupport: boolean;
  manageAccessibilityLegalVideosRemediations: boolean;
}

export interface DeveloperResourcesAccessMap {
  manageDeveloperResourcesTab: boolean;
  manageDeveloperResourcesServerSideApi: boolean;
}

export interface NotificationsAccessMap {
  topBar: boolean;
  drawer: boolean;
}

export interface AgencyResourcesAccessMap {
  manageAgencyResourcesTab: boolean;
  manageAgencyResourcesBanner: boolean;
  manageAgencyResourcesDiscount: boolean;
  manageAgencyResourcesContact: boolean;
  manageAgencyResourcesAssets: boolean;
  manageAgencyResourcesVideo: boolean;
  manageAgencyResourcesNewsletter: boolean;
  manageAgencyResourcesLanding: boolean;
  manageAgencyResourcesPosts: boolean;
}

export interface RegTrackerAccessMap {
  manageRegTrackerTab: boolean;
  manageRegTrackerCountrySelector: boolean;
  manageRegTrackerMetrics: RegTrackerMetricsAccessMap;
  manageRegTrackerMap: boolean;
  manageRegTrackerOverall: boolean;
  manageRegTrackerCompliance: boolean;
  manageRegTrackerRisk: boolean;
  manageRegTrackerEnforcement: boolean;
  manageRegTrackerDisproportionateBurden: boolean;
  manageRegTrackerTimeline: boolean;
  manageRegTrackerChecklist: boolean;
  manageRegTrackerLaws: boolean;
  manageRegTrackerUpdates: boolean;
}

export interface RegTrackerMetricsAccessMap {
  risk: boolean;
  enforcement: boolean;
  timeSensitivity: boolean;
}

export interface SupportServicesAccessMap {
  manageSupportServicesTab: boolean;
}

export interface GeneralSignUpResponseDto {
  accessToken: string;
  refreshToken: string;
}

export interface GeneralSignUpDto {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  password: string;
  phone?: string;
  origin: RegistrationOrigin;
}

export enum RegistrationOrigin {
  UNKNOWN = 'UNKNOWN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
  WIX = 'WIX',
  WORDPRESS = 'WORDPRESS',
  SHOPIFY = 'SHOPIFY',
  SITE_GENERAL = 'SITE_GENERAL',
  SITE = 'SITE',
  SSO = 'SSO',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_CODE = 'SITE_CODE',
  MANAGE_SIGN_UP = 'MANAGE_SIGN_UP',
  INSPECTOR_SIGN_UP = 'INSPECTOR_SIGN_UP',
  API_REQUEST = 'API_REQUEST',
  AUDIT = 'AUDIT',
  BIG_COMMERCE = 'BIG_COMMERCE',
  DUDA = 'DUDA',
  MAGENTO = 'MAGENTO',
  JOOMLA = 'JOOMLA',
  SEMRUSH = 'SEMRUSH',
  SEMRUSH_WIDGET = 'SEMRUSH_WIDGET',
  SQUAREUP = 'SQUAREUP',
  SHORTPOINT = 'SHORTPOINT',
  DRUPAL = 'DRUPAL',
  ENVATO = 'ENVATO',
  CAFE24 = 'CAFE24',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  FACEBOOK_LEAD_AD = 'FACEBOOK_LEAD_AD',
  HANDBOOK = 'HANDBOOK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  CONTACT_AN_EXPERT = 'CONTACT_AN_EXPERT',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  MS_OFFICE_FORM = 'MS_OFFICE_FORM',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  SCANNER_SIGNUP = 'SCANNER_SIGNUP',
  TUNINGS_REQUEST = 'TUNINGS_REQUEST',
  CALENDLY = 'CALENDLY',
  LINKEDIN_OUTREACH = 'LINKEDIN_OUTREACH',
  SCANNER_SLG = 'SCANNER_SLG',
  LEGAL_SUPPORT = 'LEGAL_SUPPORT',
  ONBOARDING = 'ONBOARDING',
  DASHBOARD = 'DASHBOARD',
  LEVEL_ACCESS = 'LEVEL_ACCESS',
  HUSKY = 'HUSKY',
}

export interface SmartFormCompanyInfoDto {
  companySize: string | null;
  companyName: string | null;
}

export interface SmartFormRequestDto {
  email: string;
  formOrigin: SmartFormOrigins;
}

export enum SmartFormOrigins {
  SIGNUP_FORM = 'SIGNUP_FORM',
  SITE = 'SITE',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  JOIN_WEBINAR_FORM = 'JOIN_WEBINAR_FORM',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  AUDIT = 'AUDIT',
}

export interface BillingHelperTieredProductsResponseDto {
  currency: PricingCurrency;
  products: BillingHelperProductTieredItemDto[];
}

export interface BillingHelperProductTieredItemDto {
  name: UserwaySubjectTransactionType;
  id: string;
  tiers: BillingHelperItemCostDto[];
}

export interface BillingHelperItemCostDto {
  id?: string;
  quota?: number;
  baseCostMonthly?: number;
  baseCostYearly?: number;
  baseCostBiAnnual?: number;
  baseDiscountPercentYearly?: number;
  baseDiscountPercentBiAnnual?: number;
  baseCostMonthlyDiscounted?: number;
  baseCostYearlyDiscounted?: number;
  baseCostBiAnnualDiscounted?: number;
  oneTimeCost?: number;
  oneTimeCostDiscounted?: number;
}

export type GetHelperProductsBody =
  BillingContextPayloadStructure106082072616191649106082072615961650106082072615591651106082072603978;

export interface BillingContextPayloadStructure106082072616191649106082072615961650106082072615591651106082072603978 {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
}

export enum PaymentFormOrigin {
  IPN = 'IPN',
  JOB = 'JOB',
  AUTO_RENEW = 'AUTO_RENEW',
  ADMIN = 'ADMIN',
  USER = 'USER',
  CONTRACT = 'CONTRACT',
  WEBSITE = 'WEBSITE',
  WEBSITE_GET_FLOW = 'WEBSITE_GET_FLOW',
  MANAGE_CYP = 'MANAGE_CYP',
  MANAGE_CYP_F = 'MANAGE_CYP_F',
  MANAGE_CTA = 'MANAGE_CTA',
  MANAGE_QUOTE = 'MANAGE_QUOTE',
  MANAGE_GENERAL = 'MANAGE_GENERAL',
  MANAGE_USER_SHARED = 'MANAGE_USER_SHARED',
  MANAGE_CONSOLE = 'MANAGE_CONSOLE',
  WIDGET = 'WIDGET',
  WEBSITE_AUDIT = 'WEBSITE_AUDIT',
  WEBSITE_GENERAL = 'WEBSITE_GENERAL',
  CA11Y = 'CA11Y',
  A11YMONITOR = 'A11Y_MONITOR',
  WIX_PLATFORM = 'WIX_PLATFORM',
  WORDPRESS_PLATFORM = 'WORDPRESS_PLATFORM',
  BIGCOMMERCE_PLATFORM = 'BIGCOMMERCE_PLATFORM',
  DRUPAL_PLATFORM = 'DRUPAL_PLATFORM',
  DUDA_PLATFORM = 'DUDA_PLATFORM',
  JOOMLA_PLATFORM = 'JOOMLA_PLATFORM',
  MAGENTO_PLATFORM = 'MAGENTO_PLATFORM',
  SHOPIFY_PLATFORM = 'SHOPIFY_PLATFORM',
  SHORTPOINT_PLATFORM = 'SHORTPOINT_PLATFORM',
  SQUAREUP_PLATFORM = 'SQUAREUP_PLATFORM',
  CAFE24PLATFORM = 'CAFE24_PLATFORM',
  UNKNOWN = 'UNKNOWN',
}

export interface GetSplNullableQueryDto {
  spltoken?: string;
}

export interface PaymentMethodCreateBodyDto {
  paymentMethodId: string;
  isDefault: boolean;
}

export interface BillingPaymentMethodsListResponseDto {
  paymentMethods: PaymentMethodDetailsWithAddressDto[];
}

export interface PaymentMethodDetailsWithAddressDto {
  uwPaymentDataId: number;
  providerPaymentMethodId: string | null;
  provider: BillingProvider;
  method: BillingMethod;
  isDefault: boolean;
  alias: string | null;
  card: PaymentCardDetailsDto | null;
  address: BillingAddressDto | null;
}

export interface BillingAddressDto {
  country: string;
  state?: string;
  postalCode: string;
  city?: string;
  line1?: string;
}

export interface PaymentMethodUpdateBodyDto {
  alias: string;
}

export interface SubscriptionBillingDetails {
  orderId: number | null;
  userServiceId: number;
  isPayOnTrialAvailable: boolean;
  isSwitchToAnnualAvailable: boolean;
  total: number;
  expiresAt: string | null;
  paymentProvider: string;
  paymentProviderSubscriptionId: string | null;
  uwSubscriptionId: number | null;
  uwSubscriptionCancelled: boolean;
  uwSubscriptionCancelledDate: string | null;
  products?: SubscriptionBillingProduct[];
}

export interface SubscriptionBillingProduct {
  type: UserwaySubjectTransactionType;
  total: number;
  discount: number;
  sites?: SubscriptionBillingSite[];
}

export interface SubscriptionBillingSite {
  host: string;
  pageViews: string | number;
  total: number;
  subtotal: number;
  discountPercents: number;
}

export interface SubscriptionBillingDetailsByPaymentDto {
  search?: string;
}

export interface CheckPaymentMethodAddressResponseDto {
  isValid: boolean;
}

export interface CheckPaymentMethodAddressBodyDto {
  billingAddress: BillingAddressDto;
}

export interface RetentionSupportPayload {
  orderId: number;
  subscriptionId: number;
  companyName: string;
  phoneNumber: string;
  retentionSteps: string[];
  message: string;
  isCancellationRequest?: boolean;
}

export interface ApiSuccessResponse {
  success: boolean;
}

export interface CreateMultipleCustomPaymentsDto {
  formOrigin: PaymentFormOrigin;
  email: string;
  firstName: string;
  lastName: string;
  payments: CustomPaymentDto[];
  siteId: number;
  userId?: number;
  country?: string;
  state?: string;
  city?: string;
  address?: string;
  zip?: string;
}

export interface CustomPaymentDto {
  type: UserwaySubjectTransactionType;
  revenueMonths: number;
  paymentItems: CustomPaymentItemDto[];
  comment: string;
}

export interface CustomPaymentItemDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  pageViews: string;
  hostname: string;
  subtotal: number;
  discount: number;
}

export interface SubscriptionBillingDetailsQueryDto {
  search?: string;
}

export interface SubscriptionBillingDetailsByIdResponseDto {
  subscription: SubscriptionBillingDetailsAll | null;
}

export type SubscriptionBillingDetailsAll = SubscriptionBillingDetails | CancelledSubscriptionBillingDetails;

export interface CancelledSubscriptionBillingDetails {
  uwSubscriptionId: number | null;
  uwSubscriptionCancelled: boolean;
  uwSubscriptionCancelledDate: string | null;
  products?: SubscriptionBillingProduct[];
}

export interface CancelTrialSubscriptionDto {
  cancellationReason: string;
}

export interface DowngradeSubscriptionDto {
  productName: string;
  tier: string;
}

export interface ToggleSubscriptionAutoRenewDto {
  isAutoRenew: boolean;
}

export interface CreateNoCardTrialSubscriptionDto {
  siteId: number;
  currency?: PricingCurrency;
}

export interface LaunchNoCardTrialSubscriptionResponseDto {
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription: StripeSubscription;
}

export interface LaunchNoCardTrialSubscriptionDto {
  billingCycle: SubscriptionBillingCycleType;
  couponId?: string;
  formOrigin: PaymentFormOrigin;
  paymentMethodId: string;
  productType?: UserwaySubjectTransactionTypeREMEDIATION | UserwaySubjectTransactionTypeREMEDIATIONPLUS;
}

export type UserwaySubjectTransactionTypeREMEDIATION = 'REMEDIATION';

export type UserwaySubjectTransactionTypeREMEDIATIONPLUS = 'REMEDIATION_PLUS';

export interface CreateAchSetupIntentResponseDto {
  clientSecret: string;
}

export interface LaunchQuoteSubscriptionResponseDto {
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription: StripeSubscription;
}

export interface LaunchQuoteSubscriptionDto {
  quoteHash: string;
  billingCycle: SubscriptionBillingCycleType;
  formOrigin: PaymentFormOrigin;
  paymentMethodId: string;
}

export interface PostBillingEmailsDto {
  origin: UserBillingEmailsOrigin;
  emails: BillingEmailUserDto[];
}

export enum UserBillingEmailsOrigin {
  CA11Y = 'CA11Y',
  SCANNER = 'SCANNER',
  USERWAY = 'USERWAY',
}

export interface BillingEmailUserDto {
  firstName: string;
  lastName: string;
  email: string;
}

export interface BillingEmailsResponseDto {
  emails: BillingEmailUser[];
}

export interface BillingEmailUser {
  firstName: string;
  lastName: string;
  email: string;
}

export interface BillingCalculateCartResponseWithoutInvoiceDto {
  couponApplied: boolean;
  invoiceDto: InvoiceTotalsDto | null;
  estimate?: BillingCartEstimateDto;
}

export type BillingCartEstimateDto = RecordUserwaySubjectTransactionTypeDefInterface172706254959976255172706254908768;

export interface RecordUserwaySubjectTransactionTypeDefInterface172706254959976255172706254908768 {
  WHITE_LABEL: BillingOrderItem[];
  CUSTOM_BRANDING: BillingOrderItem[];
  MODIFY_MENU: BillingOrderItem[];
  USAGE_STATS: BillingOrderItem[];
  LIVE_TRANSLATIONS: BillingOrderItem[];
  REMEDIATION: BillingOrderItem[];
  REMEDIATION_PLUS: BillingOrderItem[];
  REMEDIATION_ULTIMATE: BillingOrderItem[];
  SCANNING_AND_MONITORING: BillingOrderItem[];
  IMG_REMEDIATION: BillingOrderItem[];
  PDF_AUTO_REMEDIATION: BillingOrderItem[];
  DONATION: BillingOrderItem[];
  PDF_REMEDIATION: BillingOrderItem[];
  VIDEO_REMEDIATION: BillingOrderItem[];
  STATEMENT_OF_COMPLIANCE: BillingOrderItem[];
  GENERAL: BillingOrderItem[];
  AUDIT: BillingOrderItem[];
  AUDIT_VPAT: BillingOrderItem[];
  AUDIT_VALIDATION: BillingOrderItem[];
  AUDIT_LANDING_PAGE: BillingOrderItem[];
  AUDIT_STANDARD_WEBSITE: BillingOrderItem[];
  AUDIT_ECOMMERCE_SITE: BillingOrderItem[];
  AUDIT_LARGE_WEBSITE: BillingOrderItem[];
  AUDIT_WEB_APP: BillingOrderItem[];
  AUDIT_GENERAL: BillingOrderItem[];
  MANAGED_ACCESSIBILITY: BillingOrderItem[];
  SLA_SUPPORT: BillingOrderItem[];
  SUCCESS_PROGRAM: BillingOrderItem[];
  REMEDIATION_SERVICES: BillingOrderItem[];
  LEGAL_PUNCH_LIST: BillingOrderItem[];
  LEGAL_RENOVATION: BillingOrderItem[];
  LEGAL_PROOF_POSITIVE: BillingOrderItem[];
  LEGAL_EXPERT_REPORT: BillingOrderItem[];
  LEGAL_EXPERT_DEPOSITION: BillingOrderItem[];
  LEGAL_EXPERT_TRIAL_TESTIMONY: BillingOrderItem[];
  SSO: BillingOrderItem[];
  PRM: BillingOrderItem[];
  ROR: BillingOrderItem[];
  CPA: BillingOrderItem[];
  STP: BillingOrderItem[];
  PLE: BillingOrderItem[];
  HR: BillingOrderItem[];
  TRAINING_NVDA_FOR_TESTERS: BillingOrderItem[];
  TRAINING_ACCESSIBILITY_OVERVIEW: BillingOrderItem[];
  TRAINING_EMPATHY_LAB: BillingOrderItem[];
  TRAINING_VIRTUAL_DESIGN_BASICS: BillingOrderItem[];
  TRAINING_CODE_FE: BillingOrderItem[];
  TRAINING_CODE_ARIA: BillingOrderItem[];
  TRAINING_CONTENT_WRITERS: BillingOrderItem[];
  TRAINING_PDF_CONTENT_WRITERS: BillingOrderItem[];
  TRAINING_WCAG_CRITERIA: BillingOrderItem[];
  TRAINING_ACCESSIBLE_FORMS: BillingOrderItem[];
  TRAINING_ACCESSIBLE_SOCIAL_MEDIA: BillingOrderItem[];
  TRAINING_PDF_REMEDIATION: BillingOrderItem[];
  DEV_STAGING_SITE: BillingOrderItem[];
  BULK_PACKAGE_SITE: BillingOrderItem[];
  CA11Y_MANAGED: BillingOrderItem[];
  CA11Y_SELF_HOSTED: BillingOrderItem[];
  CHARGEBACK: BillingOrderItem[];
  REFUND: BillingOrderItem[];
  CHARGEBACK_REINSTATED: BillingOrderItem[];
}

export interface BillingOrderItem {
  siteItem?: BillingSiteOrderItem;
  settings?: BillingOrderItemSettings;
  cost: number;
  discount: number;
  discountPercents: number;
  total: number;
}

export interface BillingSiteOrderItem {
  id: number;
  host: string;
  url: string;
  views: number;
}

export interface BillingOrderItemSettings {
  description?: string;
  isCustomItem?: boolean;
}

export interface CartCalculateSubscriptionAutoRenew {
  subscriptionId: number;
}

export interface CartCalculateQuoteTotalsDto {
  quoteHash: string;
  address?: BillingAddressDto;
  billingCycle: SubscriptionBillingCycleType;
}

export interface BillingCheckCouponRedeemedDto {
  isCouponRedeemed: boolean;
}

export interface BillingCheckCouponRedeemedRequestDto {
  coupon: string;
}

export interface ConfirmSpecialPaymentResponse {
  payment: SpecialPaymentState;
}

export interface SpecialPaymentState {
  paymentId: string;
  paymentSecret: string | null;
  status: SpecialPaymentStateStatusEnum;
}

export interface ConfirmSpecialPaymentBody {
  paymentId: string;
}

export interface GetTextCompletionResponseDto {
  completion: string;
}

export interface GetTextCompletionDto {
  prompt: string;
}

export interface GetFixMyCodeInstructionsDto {
  userId: string;
  chatId: string;
  pairId: string;
  history: GetFixMyCodePromptPairDto[];
  newPrompt: string;
}

export interface GetFixMyCodePromptPairDto {
  pairId: string;
  prompt: string;
  reply: string;
}

export interface GetFixMyCodeChatTitleResponseDto {
  title: string;
}

export interface GetFixMyCodeChatTitleDto {
  history: GetFixMyCodePromptPairDto[];
}

export interface VoteReplyDto {
  pairId: string;
  type: FixMyCodeReplyVoteType;
  description?: string;
}

export enum FixMyCodeReplyVoteType {
  UPVOTE = 'UPVOTE',
  DOWNVOTE = 'DOWNVOTE',
}

export interface FixMyCodeEmailSubscriptionDto {
  userId: string;
  email: string;
}

export interface GeneralFeedbackDto {
  description: string;
  userId: string;
}

export interface PostTrackBodyDto {
  assetName: string;
}

export interface PostNewslettersBodyDto {
  newsletter: string;
}

export interface PostRetentionsBodyDto {
  subscriptionId: number;
  retentionSteps: RetentionStep[];
}

export enum RetentionStep {
  MAIN_WIDGET_DOESNT_MEET_MY_EXPECTATIONS = 'MAIN_WIDGET_DOESNT_MEET_MY_EXPECTATIONS',
  MAIN_TOO_EXPENSIVE = 'MAIN_TOO_EXPENSIVE',
  MAIN_TECHNICAL_ISSUES = 'MAIN_TECHNICAL_ISSUES',
  MAIN_SITE_IS_NO_LONGER_ACTIVE_OR_UNDER_MANAGEMENT = 'MAIN_SITE_IS_NO_LONGER_ACTIVE_OR_UNDER_MANAGEMENT',
  MAIN_REQUIRE_ADDITIONAL_SERVICES = 'MAIN_REQUIRE_ADDITIONAL_SERVICES',
  MAIN_OTHER = 'MAIN_OTHER',
  WRONG_EXPECTATIONS_STILL_HAVE_ACCESSIBILITY_ISSUES = 'WRONG_EXPECTATIONS_STILL_HAVE_ACCESSIBILITY_ISSUES',
  WRONG_EXPECTATIONS_VISUAL_OR_BRANDING_PROBLEMS = 'WRONG_EXPECTATIONS_VISUAL_OR_BRANDING_PROBLEMS',
  WRONG_EXPECTATIONS_SERVICE_OR_SUPPORT = 'WRONG_EXPECTATIONS_SERVICE_OR_SUPPORT',
  TOO_EXPENSIVE_DO_YOU_QUALIFY_FOR_ONE_OF_OUR_DISCOUNT_PROGRAMS = 'TOO_EXPENSIVE_DO_YOU_QUALIFY_FOR_ONE_OF_OUR_DISCOUNT_PROGRAMS',
  TOOEXPENSIVEFREEADDON3MONTHS = 'TOO_EXPENSIVE_FREE_ADDON_3_MONTHS',
  SITE_NO_LONGER_ACTIVE_MIGRATE_TO_A_NEW_DOMAIN = 'SITE_NO_LONGER_ACTIVE_MIGRATE_TO_A_NEW_DOMAIN',
  SITE_NO_LONGER_ACTIVE_MERGE_ACCOUNTS = 'SITE_NO_LONGER_ACTIVE_MERGE_ACCOUNTS',
  QUALIFYASVOLUMEORBULKSITESMORETHAN10SITES = 'QUALIFY_AS_VOLUME_OR_BULK_SITES_MORE_THAN_10_SITES',
  QUALIFY_AS_AGENCY = 'QUALIFY_AS_AGENCY',
  QUALIFY_AS_NON_PROFIT = 'QUALIFY_AS_NON_PROFIT',
  QUALIFY_AS_STUDENT = 'QUALIFY_AS_STUDENT',
  QUALIFY_AS_STARTUP = 'QUALIFY_AS_STARTUP',
  QUALIFY_AS_NGO = 'QUALIFY_AS_NGO',
  QUALIFY_AS_GOVERNMENT = 'QUALIFY_AS_GOVERNMENT',
  QUALIFY_AS_OTHER = 'QUALIFY_AS_OTHER',
  STILL_HAVE_ISSUES_SCANNING_AND_MONITORING = 'STILL_HAVE_ISSUES_SCANNING_AND_MONITORING',
  STILL_HAVE_ISSUES_I_WOULD_LIKE_LEGAL_CONSULTATION = 'STILL_HAVE_ISSUES_I_WOULD_LIKE_LEGAL_CONSULTATION',
  STILL_HAVE_ISSUES_I_WOULD_LIKE_TO_AUDIT_MY_SITE = 'STILL_HAVE_ISSUES_I_WOULD_LIKE_TO_AUDIT_MY_SITE',
  STILL_HAVE_ISSUES_I_WOULD_LIKE_A_STATEMENT_OF_COMPLIANCE_OR_ACCESSIBILITY_STATEMENT = 'STILL_HAVE_ISSUES_I_WOULD_LIKE_A_STATEMENT_OF_COMPLIANCE_OR_ACCESSIBILITY_STATEMENT',
  STILL_HAVE_ISSUES_I_WOULD_LIKE_TO_MAKE_MY_PDFS_OR_DOCUMENTS_ACCESSIBLE = 'STILL_HAVE_ISSUES_I_WOULD_LIKE_TO_MAKE_MY_PDFS_OR_DOCUMENTS_ACCESSIBLE',
  VISUAL_PROBLEMS_I_WOULD_LIKE_TO_CUSTOMIZE_MY_WIDGET = 'VISUAL_PROBLEMS_I_WOULD_LIKE_TO_CUSTOMIZE_MY_WIDGET',
  VISUAL_PROBLEMS_I_WOULD_LIKE_TO_TRY_ANOTHER_WIDGET_TYPE = 'VISUAL_PROBLEMS_I_WOULD_LIKE_TO_TRY_ANOTHER_WIDGET_TYPE',
}

export interface TrackLandingPageBodyDto {
  landingPage: string;
}

export interface GetAccountManagerResponseDto {
  owner: AccountManager;
}

export interface AccountManager {
  ownerId: string;
  email: string;
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
  calendlyLink: string | null;
}

export interface GenerateAgencyA11YStatementDto {
  firstName: string;
  lastName: string;
  companyName: string;
  phone: string;
  websiteOwnerEmail: string;
  agencyEmail: string;
  websiteUrl: string;
}

export interface CreateOrUpdateRemediationEmptyControlResponseDto {
  created: boolean;
}

export interface CreateOrUpdateRemediationEmptyControlDto {
  siteId: number;
  correction: string;
  xpath: string;
  page?: string | null;
}

export interface ExchangeHostnamesResponseDto {
  sites: ExchangeHostnamesSiteDto[];
}

export interface ExchangeHostnamesSiteDto {
  id: number;
  status: ISiteStatus;
  host: string;
  url: string;
  /** @format date-time */
  createdAt: string;
}

export enum ISiteStatus {
  ACTIVE = 'ACTIVE',
  REMOVED = 'REMOVED',
  PENDING = 'PENDING',
  IGNORED = 'IGNORED',
}

export interface ExchangeHostnamesDto {
  hostnames: string[];
}

export interface SiteSearchResultDto {
  sites: SiteSearchEntryDto[];
  sitesTotal: number;
  sitesAddonsTotal: PartialSiteAddonsTotalsType;
  moreAvailable: boolean;
  pageIdx: number;
  perPage: number;
}

export interface SiteSearchEntryDto {
  id: number;
  host: string;
  url: string;
  iconUrl: string;
  billedAsAgencyAt: string | null;
  paidAsAgency: boolean;
  isPrepaid: boolean;
  remediationId: number | null;
  remediationBillingCycleMonths: number | null;
  remediationProPlus: boolean;
  remediationUltimate: boolean;
  whiteLabelId: number | null;
  customBrandingId: number | null;
  customMenuId: number | null;
  usageStatsId: number | null;
  liveTranslationId: number | null;
  managedAccessibility: boolean;
  platformApp: string | null;
  platformRedirectLink: string | null;
  isPlatformInitialPurchase: boolean;
  loadsPast30Days: number;
  forcedLoadsPast30Days: number | null;
  primarySiteId: number;
  suspended: boolean;
  /** @format date-time */
  created: string;
  whiteLabelAgencyFree: boolean;
  customBrandingAgencyFree: boolean;
  a11yScore: number | null;
  a11ySolution: InstalledA11YSolution | null;
  renewalDate: string | null;
  pdfInfo?: SiteSearchPdfInfoDto;
  viewInfo?: SiteSearchViewDto;
}

export enum InstalledA11YSolution {
  NOA11YSOLUTION = 'NO_A11Y_SOLUTION',
  USERWAY_FREE_SOLUTION = 'USERWAY_FREE_SOLUTION',
  USERWAY_AI_SOLUTION = 'USERWAY_AI_SOLUTION',
  ACCESSIBE_SOLUTION = 'ACCESSIBE_SOLUTION',
  AUDIOEYE_SOLUTION = 'AUDIOEYE_SOLUTION',
  EQUALWEB_SOLUTION = 'EQUALWEB_SOLUTION',
}

export interface SiteSearchPdfInfoDto {
  total: number;
  accessible: number;
  inaccessible: number;
  status: RemediationOfSitePdfsStatus;
}

export enum RemediationOfSitePdfsStatus {
  NONE = 'NONE',
  REMEDIATION_IN_PROGRESS = 'REMEDIATION_IN_PROGRESS',
  REMEDIATED = 'REMEDIATED',
  SOME_FAILED = 'SOME_FAILED',
  ALL_UNAVAILABLE = 'ALL_UNAVAILABLE',
}

export interface SiteSearchViewDto {
  siteUrl: string;
  traffic: number;
  /** @format date-time */
  dateAdded: string;
  billingCycle: SubscriptionBillingCycleType | null;
  product: ProductStatus | InstalledA11YSolution;
  accScore: number | AccSolutionRowState;
  renewalDate: string | null;
}

export enum ProductStatus {
  EMPTY = 'EMPTY',
  COMPETITOR = 'COMPETITOR',
  UW_PRO = 'UW_PRO',
  UW_FREE = 'UW_FREE',
  MANAGED = 'MANAGED',
  UW_PRO_PLUS = 'UW_PRO_PLUS',
}

export enum AccSolutionRowState {
  ACCOUNT_ID_MISMATCH = 'ACCOUNT_ID_MISMATCH',
  NOT_INSTALLED_WIDGET = 'NOT_INSTALLED_WIDGET',
  HAS_VALUE = 'HAS_VALUE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export interface PartialSiteAddonsTotalsType {
  WHITE_LABEL?: number;
  CUSTOM_BRANDING?: number;
  MODIFY_MENU?: number;
  USAGE_STATS?: number;
  LIVE_TRANSLATIONS?: number;
  REMEDIATION?: number;
  REMEDIATION_PLUS?: number;
  REMEDIATION_ULTIMATE?: number;
  SCANNING_AND_MONITORING?: number;
  IMG_REMEDIATION?: number;
  PDF_AUTO_REMEDIATION?: number;
  DONATION?: number;
  PDF_REMEDIATION?: number;
  VIDEO_REMEDIATION?: number;
  STATEMENT_OF_COMPLIANCE?: number;
  GENERAL?: number;
  AUDIT?: number;
  AUDIT_VPAT?: number;
  AUDIT_VALIDATION?: number;
  AUDIT_LANDING_PAGE?: number;
  AUDIT_STANDARD_WEBSITE?: number;
  AUDIT_ECOMMERCE_SITE?: number;
  AUDIT_LARGE_WEBSITE?: number;
  AUDIT_WEB_APP?: number;
  AUDIT_GENERAL?: number;
  MANAGED_ACCESSIBILITY?: number;
  SLA_SUPPORT?: number;
  SUCCESS_PROGRAM?: number;
  REMEDIATION_SERVICES?: number;
  LEGAL_PUNCH_LIST?: number;
  LEGAL_RENOVATION?: number;
  LEGAL_PROOF_POSITIVE?: number;
  LEGAL_EXPERT_REPORT?: number;
  LEGAL_EXPERT_DEPOSITION?: number;
  LEGAL_EXPERT_TRIAL_TESTIMONY?: number;
  SSO?: number;
  PRM?: number;
  ROR?: number;
  CPA?: number;
  STP?: number;
  PLE?: number;
  HR?: number;
  TRAINING_NVDA_FOR_TESTERS?: number;
  TRAINING_ACCESSIBILITY_OVERVIEW?: number;
  TRAINING_EMPATHY_LAB?: number;
  TRAINING_VIRTUAL_DESIGN_BASICS?: number;
  TRAINING_CODE_FE?: number;
  TRAINING_CODE_ARIA?: number;
  TRAINING_CONTENT_WRITERS?: number;
  TRAINING_PDF_CONTENT_WRITERS?: number;
  TRAINING_WCAG_CRITERIA?: number;
  TRAINING_ACCESSIBLE_FORMS?: number;
  TRAINING_ACCESSIBLE_SOCIAL_MEDIA?: number;
  TRAINING_PDF_REMEDIATION?: number;
  DEV_STAGING_SITE?: number;
  BULK_PACKAGE_SITE?: number;
  CA11Y_MANAGED?: number;
  CA11Y_SELF_HOSTED?: number;
  CHARGEBACK?: number;
  REFUND?: number;
  CHARGEBACK_REINSTATED?: number;
}

export interface GetSitesQueryParams {
  referrer?: string;
  siteIds?: string;
  allowedUnitSites?: string;
  products?: string;
  noProducts?: string;
  status?: ISiteStatus;
  type?: SitesSearchSubscriptionTypeArg;
  t?: SitesSearchTrafficArg;
  d?: SitesSearchDateAddedArg;
  pr?: SitesSearchProductsNumberArg;
  prt?: SitesSearchProductsNumberArg;
  bc?: SitesSearchBillingCycleArg;
  a?: SitesSearchAlphabetArg;
  a11yScore?: SitesSortA11YScoreArg;
  isPdfRequest?: boolean;
  p?: number;
  q?: number;
  s?: string;
}

export enum SitesSearchSubscriptionTypeArg {
  FREE = 'FREE',
  PRE = 'PRE',
  POST = 'POST',
  PAID = 'PAID',
}

export enum SitesSearchTrafficArg {
  LOW = 'LOW',
  HIGH = 'HIGH',
}

export enum SitesSearchDateAddedArg {
  OLD = 'OLD',
  NEW = 'NEW',
}

export enum SitesSearchProductsNumberArg {
  LOW = 'LOW',
  HIGH = 'HIGH',
}

export enum SitesSearchBillingCycleArg {
  LOW = 'LOW',
  HIGH = 'HIGH',
}

export enum SitesSearchAlphabetArg {
  A = 'A',
  Z = 'Z',
}

export enum SitesSortA11YScoreArg {
  LOW = 'LOW',
  HIGH = 'HIGH',
}

export interface PostSitesBodyParams {
  siteIds?: string[];
  referrer?: string;
  allowedUnitSites?: string[];
  products?: string[];
  noProducts?: string[];
  status?: ISiteStatus;
  type?: SitesSearchSubscriptionTypeArg;
  t?: SitesSearchTrafficArg;
  d?: SitesSearchDateAddedArg;
  pr?: SitesSearchProductsNumberArg;
  prt?: SitesSearchProductsNumberArg;
  bc?: SitesSearchBillingCycleArg;
  a?: SitesSearchAlphabetArg;
  a11yScore?: SitesSortA11YScoreArg;
  isPdfRequest?: boolean;
  p?: number;
  q?: number;
  s?: string;
}

export interface UpdateRemediationHelperResponseDto {
  success: boolean;
}

export interface UpdateRemediationHelperDto {
  helpers: RemediationHelperUpdateSettingsDto[];
}

export interface RemediationHelperUpdateSettingsDto {
  enabled: boolean;
  name: string;
  config?: AnyObject;
}

export type AnyObject = RecordStringNumberSymbolAny;

export type RecordStringNumberSymbolAny = object;

export interface PdfRemediationStatsResponseDto {
  stats: PdfRemediationStatsDto;
}

export interface PdfRemediationStatsDto {
  /** All pdfs (manual + auto remediated) */
  total: number;
  /** Remediated pdfs (either manually or automatically) */
  accessible: number;
  /** All pds with other statuses such as awaiting payment, etc. */
  inaccessible: number;
}

export interface PdfAutoCalculateResponseDto {
  isUpgradeRequired: boolean;
  tierOptions: ProductQuotaPricingTierOption[];
}

export interface ProductQuotaPricingTierOption {
  name: string;
  quota: number;
  extraQuota?: number;
}

export interface PdfAutoCalculateDto {
  siteIds: number[];
}

export interface InitAutoRemediationResponseDto {
  quota: {
    Subscription: ISubscription | null;
    id: number;
    user_service_id: number;
    site_id: number;
    is_enabled: boolean;
    is_renewable: boolean;
    used_quota: number;
    total_quota: number;
    pricing_tier: PdfAutoRemediationTierType;
  } | null;
  state: RemediationSubmissionState;
}

export enum PdfAutoRemediationTierType {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CUSTOM = 'CUSTOM',
}

export enum RemediationSubmissionState {
  SELECT_SITES = 'SELECT_SITES',
  SELECT_SITES_AND_PLAN = 'SELECT_SITES_AND_PLAN',
  SELECT_NEW_PLAN = 'SELECT_NEW_PLAN',
  UPGRADE_PLAN = 'UPGRADE_PLAN',
  COMPLETE_PAYMENT = 'COMPLETE_PAYMENT',
  CONFIRM_REMEDIATION = 'CONFIRM_REMEDIATION',
  REMEDIATION_STARTED = 'REMEDIATION_STARTED',
  REMEDIATION_NOT_CONFIRMED = 'REMEDIATION_NOT_CONFIRMED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export interface InitAutoRemediationDto {
  flowId: UUID;
}

export interface PdfAutoSelectSitesDto {
  flowId: UUID;
  siteIds: number[];
}

export interface PdfAutoSelectSitesAndPlanResponseDto {
  state: RemediationSubmissionState;
}

export interface PdfAutoSelectSitesAndPlanDto {
  flowId: UUID;
  siteIds: number[];
  billingCycle: PdfRemediationBillingCycle;
}

export enum PdfRemediationBillingCycle {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}

export interface PdfAutoSelectNewPlanResponseDto {
  state: RemediationSubmissionState;
}

export interface PdfAutoSelectNewPlanDto {
  flowId: UUID;
  upgradeType: PdfRemediationUpgradeType;
}

export enum PdfRemediationUpgradeType {
  UPGRADE_PLAN = 'UPGRADE_PLAN',
  TOP_UP = 'TOP_UP',
}

export interface PdfAutoUpgradePlanResponseDto {
  state: RemediationSubmissionState;
}

export interface PdfAutoUpgradePlanDto {
  flowId: UUID;
  remediationPlan: string;
}

export interface PdfAutoCompletePaymentResponseDto {
  state: RemediationSubmissionState;
}

export interface PdfAutoCompletePaymentDto {
  flowId: UUID;
  orderId?: number;
  error?: string;
}

export interface PdfAutoConfirmRemediationResponseDto {
  state: RemediationSubmissionState;
}

export interface PdfAutoConfirmRemediationDto {
  flowId: UUID;
  confirmed: boolean;
}

export interface ApiCodeResponse {
  code: number;
}

export interface PdfAutoExportDto {
  siteId: number;
  email?: string;
}

export interface GetUsageStatsBreakdownResponseDto {
  loadsHistory: LoadsDailyHistory[] | LoadsMonthlyHistory[];
  opensHistory: OpensDailyHistory[] | OpensMonthlyHistory[];
  opens: number;
  loads: number;
  hides: number;
  percentage: string;
  features: SiteUsageStatsFeatures[];
}

export interface LoadsDailyHistory {
  date: string;
  value: number;
}

export interface LoadsMonthlyHistory {
  date: string;
  value: number;
}

export interface OpensDailyHistory {
  date: string;
  value: number;
}

export interface OpensMonthlyHistory {
  date: string;
  value: number;
}

export interface SiteUsageStatsFeatures {
  name: UsageFeatureName | UsageMetricName;
  value: number;
  percents: string;
}

export enum UsageFeatureName {
  S1 = 's1',
  S2 = 's2',
  S3 = 's3',
  S31 = 's3_1',
  S32 = 's3_2',
  S33 = 's3_3',
  S34 = 's3_4',
  S4 = 's4',
  S41 = 's4_1',
  S42 = 's4_2',
  S43 = 's4_3',
  S44 = 's4_4',
  S6 = 's6',
  S7 = 's7',
  S9 = 's9',
  S91 = 's9_1',
  S92 = 's9_2',
  S93 = 's9_3',
  S10 = 's10',
  S11 = 's11',
  S111 = 's11_1',
  S112 = 's11_2',
  S113 = 's11_3',
  S12 = 's12',
  S13 = 's13',
  S14 = 's14',
  S141 = 's14_1',
  S142 = 's14_2',
  S143 = 's14_3',
  S15 = 's15',
  S16 = 's16',
  S17 = 's17',
  S171 = 's17_1',
  S172 = 's17_2',
  S173 = 's17_3',
  S18 = 's18',
  S19 = 's19',
  S191 = 's19_1',
  S192 = 's19_2',
  S193 = 's19_3',
  S194 = 's19_4',
  S20 = 's20',
  S201 = 's20_1',
  S202 = 's20_2',
  S203 = 's20_3',
  S204 = 's20_4',
  S21 = 's21',
  S22 = 's22',
  S221 = 's22_1',
  S222 = 's22_2',
  S223 = 's22_3',
  S224 = 's22_4',
  S225 = 's22_5',
  S23 = 's23',
  S231 = 's23_1',
  S232 = 's23_2',
  S233 = 's23_3',
  S24 = 's24',
  S25 = 's25',
  S101 = 's101',
  S102 = 's102',
  S103 = 's103',
  S104 = 's104',
  S105 = 's105',
  S106 = 's106',
  S107 = 's107',
  S108 = 's108',
}

export enum UsageMetricName {
  B1 = 'b1',
}

export interface GetUsageStatsBreakdownQueryDto {
  siteId: string;
  statsType: LiveTranslationStatsType;
  periodType: GetUsageStatsPeriodType;
  period?: string;
  scope?: UsageStatsScope;
  fromDate?: string;
  toDate?: string;
  [key: string]: any;
}

export enum LiveTranslationStatsType {
  RELATIVE = 'RELATIVE',
  ABSOLUTE = 'ABSOLUTE',
}

export enum GetUsageStatsPeriodType {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
}

export enum UsageStatsScope {
  USER = 'USER',
  ADMIN = 'ADMIN',
}

export interface GetUsageStatsBreakdownCsvQueryDto {
  siteId: string;
  statsType: LiveTranslationStatsType;
  periodType: GetUsageStatsPeriodType;
  period?: string;
  scope?: UsageStatsScope;
  fromDate?: string;
  toDate?: string;
  email?: string;
  [key: string]: any;
}

export interface GetLstStatsCsvQueryDto {
  email?: string;
  siteId?: number;
}

export interface GetMissingImageAltsCsvRequestDto {
  siteId: number;
  shift: number;
  quantity?: number;
  page?: number;
  approved?: number;
  email?: string;
}

export interface GetMissingImageAltsQueryDto {
  date_sort?: MissingAltQueryType;
  alt_length_sort?: MissingAltQueryType;
  special_chars?: MissingAltQueryType;
  with_alts?: MissingAltQueryType;
  without_alts?: MissingAltQueryType;
  ai_generated_alts?: MissingAltQueryType;
  decorative?: MissingAltQueryType;
  search_phrase?: string;
}

export enum MissingAltQueryType {
  DATE_SORT_NEWEST = 'DATE_SORT_NEWEST',
  DATE_SORT_OLDEST = 'DATE_SORT_OLDEST',
  ALT_LENGTH_SORT_SHORTEST = 'ALT_LENGTH_SORT_SHORTEST',
  ALT_LENGTH_SORT_LONGEST = 'ALT_LENGTH_SORT_LONGEST',
  SPECIAL_CHARS_FILTER = 'SPECIAL_CHARS_FILTER',
  WITH_ALTS_FILTER = 'WITH_ALTS_FILTER',
  WITHOUT_ALTS_FILTER = 'WITHOUT_ALTS_FILTER',
  AI_GENERATED_ALTS_FILTER = 'AI_GENERATED_ALTS_FILTER',
  DECORATIVE_FILTER = 'DECORATIVE_FILTER',
}

export interface A11YStatementGeneratorBodyDto {
  email: string;
  host: string;
  company: string;
  phone?: string | null;
  address?: string | null;
  payload?: PartialRecordA11YStatementProductBoolean;
}

export interface PartialRecordA11YStatementProductBoolean {
  WIDGET?: boolean;
  SCANNER?: boolean;
  AUDITS?: boolean;
  MANAGED_A11Y?: boolean;
  MICROSOFT_OFFICE?: boolean;
  PDFS_AND_DOCS?: boolean;
  A11Y_TRAINING?: boolean;
}

export interface A11YStatementGeneratorResponseDto {
  content: string;
}

export interface A11YStatementResponseDto {
  userId: number;
  siteId: number;
  email: string;
  isAccepted: boolean;
  payload: A11YStatementPayloadType;
  companyName?: string;
  address?: string | null;
  phone?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export type A11YStatementPayloadType = PartialRecordA11YStatementProductBoolean;

export interface A11YStatementUpdateDto {
  email?: string;
  companyName?: string;
  payload?: PartialRecordA11YStatementProductBoolean;
  address?: string;
  phone?: string;
  isAccepted?: boolean;
}

export interface GetReportsResponseDto {
  rows: {
    id: number;
    siteId: number | null;
    text: string;
    email: string | null;
    isRead: boolean;
    /** @format date-time */
    createdAt: string;
  }[];
  total: number;
}

export interface GetReportsQueryDto {
  pageSize?: number;
  pageIndex?: number;
  sort?: GetReportsSortType;
}

export enum GetReportsSortType {
  DATE_ASC = 'DATE_ASC',
  DATE_DESC = 'DATE_DESC',
}

export interface SummarizeContentResponseDto {
  summary: string;
}

export interface SummarizeContentDto {
  pageUrl: string;
  content: string;
  mode?: PageSummaryMode;
}

export enum PageSummaryMode {
  BASIC = 'BASIC',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
}

export interface WidgetLogErrorPayloadDto {
  exception: string;
  type: string;
  pageUrl?: string;
}

export interface WidgetInstallationRequestDto {
  siteId: number;
  widgetType: string;
}

export interface SitesCreateDto {
  organizationId: string;
  hostNames: string[];
}

export interface MemberCreateDto {
  organizationId: string;
  email: string;
  firstName: string;
  lastName?: string;
  hostNames: string[];
  role: MemberRoleType;
}

export enum MemberRoleType {
  Admin = 'admin',
  Member = 'member',
}

export interface MemberUpdateDto {
  organizationId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  hostNames?: string[];
  role?: MemberRoleType;
}

export interface OrganizationCreateResponseDto {
  userwayAccountCode: string;
  state: boolean;
  sites: SiteDto[];
  teamMembers: MemberDto[];
}

export interface SiteDto {
  hostName: string;
}

export interface MemberDto {
  email: string;
  firstName: string;
  lastName: string;
  hostNames: string[];
}

export interface OrganizationCreateDto {
  organizationId: string;
  organizationName: string;
}

export interface OrganizationUpdateDto {
  organizationId: string;
  organizationName?: string;
  state?: boolean;
}

export interface PublishConfigVersionResponseDto {
  configId: string;
  deploymentVersion: number;
}

export interface GetAvailableSitesResponseDto {
  isMaster: boolean;
  sites: LabsWebsiteDto[];
}

export interface LabsWebsiteDto {
  siteId: number;
  host: string;
  ownerSsoUserId: string;
  fixesNumber: number;
  /** This is nullable because database allows it. */
  favicon: string | null;
}

export interface GetLabsTuningsResponseDto {
  labs: {
    configUrl: string;
  };
}

export interface GetLabsTuningsBodyDto {
  origin: string;
}

export interface LabsFixResponseDto {
  id: number;
  labsId: string;
  siteId: number;
  status: LabsFixStatus;
  type: LabsFixType;
  labsAuthor: LabsAuthor | null;
  data: AnyObject | null;
  meta: AnyObject | null;
  deploymentVersion: number | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export enum LabsFixStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DEPLOYED = 'DEPLOYED',
  DELETED = 'DELETED',
  CANCELED = 'CANCELED',
}

export enum LabsFixType {
  Advanced = 'advanced',
  Breadcrumb = 'breadcrumb',
  Button = 'button',
  Checkbox = 'checkbox',
  FocusIndicator = 'focusIndicator',
  Form = 'form',
  Heading = 'heading',
  Image = 'image',
  Link = 'link',
  LinkGrouping = 'linkGrouping',
  List = 'list',
  LiveRegion = 'liveRegion',
  Modal = 'modal',
  Navigation = 'navigation',
  NestedInteractiveElement = 'nestedInteractiveElement',
  Pagination = 'pagination',
  Pdf = 'pdf',
  RadioButton = 'radioButton',
  SkipLink = 'skipLink',
  Structure = 'structure',
  TabOrder = 'tabOrder',
  Table = 'table',
  Video = 'video',
}

export interface LabsAuthor {
  userId: number;
  fullName: string;
}

export interface GetLabsFixesResponseDto {
  fixes: LabsFixResponseDto[];
}

export interface GetLabsFixesQueryDto {
  type?: LabsFixType;
}

export interface UpsertLabsFixBodyDto {
  type: LabsFixType;
  data: AnyObject;
  meta?: AnyObject;
  id?: number;
  labsId?: string;
  status?: LabsFixStatus;
}

export interface ImageAltsQuotaResponseDto {
  imageAlts: SiteMissingAltFlowConfig;
}

export interface SiteMissingAltFlowConfig {
  missingAltFlow: MissingAltFlowVersion;
  resourceHash: string;
  imgAltsQuota: number;
  imgAltsQuotaUsage: number;
  quotaTier: AltRemediationTier;
  activationState: AltActivationState;
  missingAlts: MissingAltDto[];
}

export enum MissingAltFlowVersion {
  ALTSV1 = 'ALTS_V1',
  ALTSV2 = 'ALTS_V2',
}

export enum AltRemediationTier {
  FREE_QUOTA_TIER = 'FREE_QUOTA_TIER',
  TRIAL_QUOTA_TIER = 'TRIAL_QUOTA_TIER',
  PAID_QUOTA_TIER = 'PAID_QUOTA_TIER',
  LA_QUOTA_TIER = 'LA_QUOTA_TIER',
}

export enum AltActivationState {
  ALTS_ON = 'ALTS_ON',
  ALTS_OFF = 'ALTS_OFF',
}

export interface MissingAltDto {
  src: string;
  alt: string | null;
  approved: boolean;
  decorative: boolean;
  reverted?: boolean;
  editedByUser?: boolean;
  originalAlt?: string;
}

export interface ImageAltsQuotaQueryDto {
  siteId: string;
}

export interface CountriesResponseDto {
  countries: CountryObjectS3[];
}

export interface CountryObjectS3 {
  id: string;
  name: string;
  isActive: boolean;
}

export interface CountryMetricsDto {
  metrics: CountryMetricsObjectS3[];
}

export interface CountryMetricsObjectS3 {
  name: string;
  max: number;
  current: number;
  description: string;
}

export interface CountryEnforcementDto {
  enforcement: string;
}

export interface CountryLawsDto {
  laws: LawsObjectS3[];
}

export type LawsObjectS3 = Record<
  string,
  Record<
    string,
    {
      template: string;
    }
  >
>;

export interface CountryRiskAssessmentDto {
  riskAssessment: string;
}

export interface CountryTimelineDto {
  timeline: TimelineObjectS3[];
}

export interface TimelineObjectS3 {
  id: string;
  content: string;
  time: string;
  isGeneral: boolean;
}

export interface CountryComplianceDto {
  complianceOverview: string;
  content: string;
}

export interface CountryDisproportionateBurdenDto {
  disproportionateBurden: string;
  content: string;
}

export interface CountryOverallAssessmentDto {
  overallAssesment: string;
}

export interface CountryUpdatesDto {
  content: string;
}

export interface ChecklistBlockResponse {
  checklist: ChecklistBlock;
}

export type ChecklistBlock = RecordStringResponseBlock;

export type RecordStringResponseBlock = Record<string, ResponseBlock>;

export interface ResponseBlock {
  id: number;
  title: string;
  subtitle?: string;
  note?: string;
  parentId?: number;
  answered: number;
  total: number;
  questions?: AnsweredQuestion[];
  children?: Record<string, ResponseBlock>;
}

export interface AnsweredQuestion {
  isChecked: boolean;
  id: number;
  title: string;
  subtitle?: string;
  blockId: number;
}

export interface CheckAnswerDto {
  answers: AnswerDto[];
}

export interface AnswerDto {
  id: number;
  isChecked: boolean;
}

export type CountryDataDto = Record<string, CountryDataType | null>;

export type CountryDataType =
  | CountryMetricsDto
  | CountryEnforcementDto
  | CountryLawsDto
  | CountryRiskAssessmentDto
  | CountryTimelineDto
  | CountryComplianceDto
  | CountryDisproportionateBurdenDto
  | CountryUpdatesDto
  | CountryOverallAssessmentDto;

export interface CountriesRequestDto {
  keys: CountryData[];
}

export enum CountryData {
  Metrics = 'metrics',
  Enforcement = 'enforcement',
  Laws = 'laws',
  Risk = 'risk',
  Timeline = 'timeline',
  Compliance = 'compliance',
  DisproportionateBurden = 'disproportionate-burden',
  Updates = 'updates',
  Overall = 'overall',
}

export interface UpdateSiteRemediationFocusBodyDto {
  enabled: boolean;
  width: number;
  color: string;
  type: string;
}

export interface WidgetRegistrationResponseDto {
  widget: {
    code: string;
    siteId: number;
    html: string;
    paymentLinkSrc: string | null;
  };
}

export interface WidgetRegistrationBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  widget_color?: string;
  widget_language?: string;
  widget_icon_type?: string;
  widget_icon_size?: string;
  widget_position?: string;
  language?: string;
  iconType?: string;
  iconSize?: string;
  url: string;
  first_name?: string;
  last_name?: string;
}

export interface BillingCustomerResponseDto {
  /**
   * This object represents a customer of your business. It lets you create recurring charges and track payments that belong to the same customer.
   *
   * Related guide: [Save a card during payment](https://stripe.com/docs/payments/save-during-payment)
   */
  customer: StripeCustomer;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeSubscription {
  object: 'list';
  data: StripeSubscription[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

export interface BillingSubscriptionResponseDto {
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription: StripeSubscription;
}

export interface BillingCreateSubscriptionResponseDto {
  user: UserStatsBriefDto;
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription?: StripeSubscription;
}

export interface UserStatsBriefDto {
  aiPaidUser: boolean;
  totalSitesLoads: number;
}

export interface CreateSubscriptionBodyDto {
  formOrigin: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  paymentMethodId: string;
  items: BillingRequestProductDto[];
  billingCycle: SubscriptionBillingCycleType;
  trial: boolean;
}

export interface BillingRequestProductDto {
  productId: string;
  sitesIds: number[];
  settings?: BillingAddonSettings;
}

export interface BillingRetryInvoiceResponseDto {
  invoice: StripeInvoice | null;
}

/**
 * A container for paginated lists of objects. The array of objects is on the `.data` property, and `.has_more` indicates whether there are additional objects beyond the end of this list.
 *
 * Learn more in Stripe's [pagination docs](https://stripe.com/docs/api/pagination?lang=node) or, when iterating over many items, try [auto-pagination](https://github.com/stripe/stripe-node#auto-pagination) instead.
 */
export interface StripeApiListStripeBankAccountStripeCard {
  object: 'list';
  data: (StripeBankAccount | StripeCard)[];
  /** True if this list has another page of items after this one that can be fetched. */
  has_more: boolean;
  /** The URL where this list can be accessed. */
  url: string;
}

export interface RetryInvoiceBodyDto {
  paymentMethodId: string;
  subscriptionId: string;
}

export interface BillingConfirmInvoiceResponseDto {
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription: StripeSubscription;
}

export interface ConfirmInvoiceBodyDto {
  formOrigin: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  subscriptionId: string;
  paymentMethodId: string;
}

export interface BillingPayOnTrialResponseDto {
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription: StripeSubscription;
}

export interface UpgradeRemediationBody {
  subscriptionId: number;
  paymentMethodId: string;
}

export interface UpgradeSubscriptionBodyDto {
  formOrigin: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  paymentMethodId: string;
  items: BillingRequestProductDto[];
  billingCycle: SubscriptionBillingCycleType;
}

export interface DeletePaymentMethodBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  paymentMethodId: string;
}

export interface CreatePaymentMethodBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  paymentMethodId: string;
}

export interface BillingCardWalletResponseDto {
  intentSecret: string | null;
  customerId: string;
}

export interface OneTimeCreatePaymentIntentResponseDto {
  paymentIntent: string | null;
}

export interface OneTimeCreatePaymentIntentBodyDto {
  amount: number;
  paymentType: UserwaySubjectTransactionType;
  pdfRemediationOrderId?: string;
  currency?: PricingCurrency;
}

export interface OneTimeChargeResponseDto {
  invoiceToken: string | null;
}

export interface OneTimeChargeBodyDto {
  formOrigin: PaymentFormOrigin;
  paymentIntentId: string;
  meta: BillingMetaInfo;
}

export type BillingMetaInfo = BillingAuditMetaInfo | RecordStringString;

export interface BillingAuditMetaInfo {
  url: string;
  plan: string;
  vpat: boolean;
  companyInfo: BillingCompanyInfo;
}

export interface BillingCompanyInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  companyName: string;
  about: string;
  instructions: string;
}

export type RecordStringString = Record<string, string>;

export interface InvoiceDetailsDto {
  providerInvoiceId: string;
  status: string | null;
  subtotal: number;
  total: number;
  taxTotal: number;
  discountTotal: number;
  products: string[];
}

export interface CreateInvoiceBodyDto {
  formOrigin: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  paymentMethodId: string;
  items: BillingRequestProductDto[];
}

export interface BillingCalculateCartResponseDto {
  couponApplied: boolean;
  invoice: StripeInvoice | null;
  invoiceDto: InvoiceTotalsDto | null;
  estimate?: BillingCartEstimateDto;
}

export interface CalculateSwitchPlanBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  subscriptionId: string;
  address?: BillingAddressDto;
}

export interface GetSplQueryDto {
  spltoken: string;
}

export interface CalculateCartBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  billingCycle?: SubscriptionBillingCycleType;
  address?: BillingAddressDto;
  items: BillingRequestProductDto[];
}

export interface CalculateCartTrialPayNowBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  subscriptionId: string;
  address?: BillingAddressDto;
}

export interface CartRemediationUpgradeBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  subscriptionId: string;
  address?: BillingAddressDto;
}

export interface CalculateSubscriptionUpgradeBodyDto {
  formOrigin?: PaymentFormOrigin;
  forceCalculation?: boolean;
  cancelRunningSubscription?: boolean;
  coupon?: string;
  currency?: PricingCurrency;
  customerId: string;
  subscriptionId: string;
  address?: BillingAddressDto;
  items: BillingRequestProductDto[];
}

export interface GetOrdersListResponseDto {
  rows: OrderMapped[];
  total: number;
}

export interface OrderMapped {
  refunded_id: number;
  payment_origin: WebInfoOrigin | PaymentFormOrigin;
  stats_revenue_months: number;
  /** @format date-time */
  contractStartedAt: string;
  payment_provider: BillingProvider;
  id: number;
  notes: object;
  coupon_total: number;
  /** @format date-time */
  created_at: string;
  invoice_id: number;
  invoice_identifier: string;
  sub_total: number;
  tax_rate: number;
  tax_total: number;
  total: number;
  user_id: number | null;
  transaction_id: string | null;
  isIsraeliTx?: boolean;
  orderId: number;
  paymentType: UserwaySubjectTransactionType;
  paymentEmail: string;
  invoiceHash: string;
  subTotal: number;
  discountTotal: number;
  discountCoupon: string | null;
  isMrrContributor: boolean;
  mrrContributionMonths: number;
  userServiceIdBlsLegacy: number | null;
  paymentProviderTransactionId: string | null;
  userPaymentItems?: IUserPaymentItem[];
  userId?: number;
  /** @format date-time */
  createdAt?: string;
  billing_cycle: SubscriptionBillingCycleType | null;
  payment_type: PaymentTypeMapped;
  paymentTarget: string;
  canBeRefunded: boolean;
}

export enum WebInfoOrigin {
  USER = 'USER',
  ADMIN = 'ADMIN',
  AUTO_RENEW = 'AUTO_RENEW',
}

export interface IUserPaymentItem {
  type: UserPaymentItemType;
  subtotal: number;
  discount: number;
  total: number;
  payload: UserPaymentItemPayload;
}

export enum UserPaymentItemType {
  ONE_TIME_CHARGE = 'ONE_TIME_CHARGE',
  SITE_PAID_PRODUCT = 'SITE_PAID_PRODUCT',
}

export interface UserPaymentItemPayload {
  name?: string;
  pageViews?: number | string;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
}

export interface PaymentTypeMapped {
  type: string;
  arr: number;
  title: string;
  cost: number;
}

export interface GetOrdersListQueryDto {
  p?: number;
  q?: number;
}

export interface GetSingleOrderResponseDto {
  order: SingleOrderMapped;
}

export interface SingleOrderMapped {
  userId: number;
  userFirstName: string;
  userLastName: string;
  orderSubTotal: number;
  orderTaxTotal: number;
  orderTaxRate: number;
  orderCouponTotal: number;
  orderTotal: number;
  orderInvoiceIdentifier: string;
  /** @format date-time */
  orderCreatedAt: string;
  paymentProvider: BillingProvider;
  orderInvoiceId: string;
  items: SingleOrderMappedItem[];
}

export interface SingleOrderMappedItem {
  amount: number;
  product: string;
}

export interface GetOrderReportsResponseDto {
  report: OrderReportIntervalItem[];
  total: number;
}

export interface OrderReportIntervalItem {
  /** @format date-time */
  intervalEnd: string;
  value: number;
}

export interface GetOrderReportsBodyDto {
  startDate: string;
  endDate: string;
}

export interface PayOnTrialResponseDto {
  paid: boolean;
  expiresAt: string | null;
  /**
   * Subscriptions allow you to charge a customer on a recurring basis.
   *
   * Related guide: [Creating subscriptions](https://stripe.com/docs/billing/subscriptions/creating)
   */
  subscription: StripeSubscription;
}

export interface NonSiteProductInfo {
  isTrialApplicable: boolean;
}

export interface AddSiteResponseDto {
  site: Site;
  isNew: boolean;
}

export interface Site {
  id: number;
  user_id: number;
  host: string;
  url: string;
  white_label_id: number | null;
  custom_branding_id: number | null;
  custom_menu_id: number | null;
  usage_stats_id: number | null;
  live_translation_id: number | null;
  remediation_id: number | null;
  managed_accessibility: boolean;
  wl_agency_added_at: string | null;
  /** @format date-time */
  first_activity_date: string;
  status: ISiteStatus;
  platform_app: any;
  comment: string;
  suspended: boolean;
  /** @format date-time */
  created_at: string;
}

export interface AddSiteBodyDto {
  siteName: string;
}

export interface AddBatchSitesResponseDto {
  added: number;
  invalid: number;
  duplicates: number;
  addedSites: AddSitesBatchSiteDetails[];
  duplicatesSites: AddSitesBatchSiteDetails[];
}

export interface SearchUserSitesResult {
  sites: SiteMapped[];
  sitesTotal: number;
  sitesAddonsTotal: SiteAddonsTotalsType;
  moreAvailable: boolean;
  pageIdx: number;
  perPage: number;
}

export interface SiteMapped {
  host: string;
  id: number;
  url: string;
  /** @format date-time */
  billedAsAgencyAt: string;
  paidAsAgency: boolean;
  isPrepaid: boolean;
  remediationId: number;
  remediationBillingCycleMonths: number;
  remediationProPlus: boolean;
  whiteLabelId: number;
  customBrandingId: number;
  customMenuId: number;
  usageStatsId: number;
  liveTranslationId: number;
  managedAccessibility: boolean;
  loadsPast30Days: number;
  forcedLoadsPast30Days: number;
  primarySiteId: number;
  suspended: boolean;
  /** @format date-time */
  created: string;
  a11ySolution: InstalledA11YSolution;
  a11yScore: number;
  whiteLabelAgencyFree?: boolean;
  customBrandingAgencyFree?: boolean;
}

export interface SiteAddonsTotalsType {
  WHITE_LABEL: number;
  CUSTOM_BRANDING: number;
  MODIFY_MENU: number;
  USAGE_STATS: number;
  LIVE_TRANSLATIONS: number;
  REMEDIATION: number;
  REMEDIATION_PLUS: number;
  REMEDIATION_ULTIMATE: number;
  SCANNING_AND_MONITORING: number;
  IMG_REMEDIATION: number;
  PDF_AUTO_REMEDIATION: number;
  DONATION: number;
  PDF_REMEDIATION: number;
  VIDEO_REMEDIATION: number;
  STATEMENT_OF_COMPLIANCE: number;
  GENERAL: number;
  AUDIT: number;
  AUDIT_VPAT: number;
  AUDIT_VALIDATION: number;
  AUDIT_LANDING_PAGE: number;
  AUDIT_STANDARD_WEBSITE: number;
  AUDIT_ECOMMERCE_SITE: number;
  AUDIT_LARGE_WEBSITE: number;
  AUDIT_WEB_APP: number;
  AUDIT_GENERAL: number;
  MANAGED_ACCESSIBILITY: number;
  SLA_SUPPORT: number;
  SUCCESS_PROGRAM: number;
  REMEDIATION_SERVICES: number;
  LEGAL_PUNCH_LIST: number;
  LEGAL_RENOVATION: number;
  LEGAL_PROOF_POSITIVE: number;
  LEGAL_EXPERT_REPORT: number;
  LEGAL_EXPERT_DEPOSITION: number;
  LEGAL_EXPERT_TRIAL_TESTIMONY: number;
  SSO: number;
  PRM: number;
  ROR: number;
  CPA: number;
  STP: number;
  PLE: number;
  HR: number;
  TRAINING_NVDA_FOR_TESTERS: number;
  TRAINING_ACCESSIBILITY_OVERVIEW: number;
  TRAINING_EMPATHY_LAB: number;
  TRAINING_VIRTUAL_DESIGN_BASICS: number;
  TRAINING_CODE_FE: number;
  TRAINING_CODE_ARIA: number;
  TRAINING_CONTENT_WRITERS: number;
  TRAINING_PDF_CONTENT_WRITERS: number;
  TRAINING_WCAG_CRITERIA: number;
  TRAINING_ACCESSIBLE_FORMS: number;
  TRAINING_ACCESSIBLE_SOCIAL_MEDIA: number;
  TRAINING_PDF_REMEDIATION: number;
  DEV_STAGING_SITE: number;
  BULK_PACKAGE_SITE: number;
  CA11Y_MANAGED: number;
  CA11Y_SELF_HOSTED: number;
  CHARGEBACK: number;
  REFUND: number;
  CHARGEBACK_REINSTATED: number;
}

export interface SearchSplQueryDto {
  referrer?: string;
  p?: string;
  q?: string;
  spltoken?: string;
}

export interface ChangePendingSiteBodyDto {
  siteUrl: string;
}

export interface MakeSiteActiveResponseDto {
  data: Site | null;
}

export interface GetSiteExistsResponseDto {
  exists: boolean;
}

export interface GetSiteExistsBodyDto {
  url: string;
}

export interface GetSitesExistResponseDto {
  url: string;
  id: number;
  exists: boolean;
}

export interface GetSitesExistBodyDto {
  urls: string[];
}

export interface SendWidgetInstallDetailsBodyDto {
  email: string;
  code: string;
  site: string;
}

export interface GetAccountCodeBySiteResponseDto {
  account: string | null;
}

export interface GetAccountCodeBySiteBodyDto {
  siteId: string;
}

export interface GetAccountByEmailResponseDto {
  account: string | null;
}

export interface GetAccountByEmailBodyDto {
  email: string;
}

export interface GetSubscriptionSitesQueryDto {
  s?: string;
}

export interface GetOrderIdResponseDto {
  subscription: OrderIdResponse;
}

export interface OrderIdResponse {
  orderId: number;
  userServiceId: number;
  isPayOnTrialAvailable: boolean;
  isSwitchToAnnualAvailable: boolean;
  total: number;
  expiresAt: string | null;
  paymentProvider: BillingProvider;
  paymentProviderSubscriptionId: string | null;
  uwSubscriptionId: number;
  uwSubscriptionCancelled: boolean;
  uwSubscriptionCancelledDate: string | null;
  products: OrderIdProduct[];
}

export interface OrderIdProduct {
  type: UserwaySubjectTransactionType;
  total: number;
  discount: number;
  sites: OrderIdSite[];
}

export interface OrderIdSite {
  host: string;
  pageViews: number;
  total: number;
  subtotal: number;
  discountPercents: number;
}

export interface EstimateResponseDto {
  estimatedSubscriptionAmount: number;
}

export interface UpdatePayoutAddressBodyDto {
  address: string;
}

export interface EverflowAffiliateSignupResponseDto {
  data: string;
  user: {
    isNew: boolean;
  };
  calendlyInfo?: InfoForCalendly;
}

export interface InfoForCalendly {
  phone: string | null;
  employees: number | null;
  website: string | null;
  companySize: string | null;
}

export interface EverflowAffiliateSignupBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  first_name: string;
  last_name: string;
  phone: string;
  company_name: string;
  website_url: string;
  country_code: string;
  main_traffic_channel: string;
  address_1?: string;
  address_2?: string;
  city?: string;
  zip_postal_code?: string;
  custom_terms?: string;
  referral_code?: string;
  legal_type?: string;
  skype_id?: string;
  paypal_account_id?: string;
  calendlyInfo?: InfoForCalendly;
}

export interface GetSiteTrafficStatsResponseDto {
  pageViews: number;
  pagesPerVisit: number;
  bounceRate: number;
  avgVisitDuration: number;
}

export interface GetSiteTrafficStatsBodyDto {
  url: string;
  gl_recaptcha_code?: string;
}

export interface GetOrCreateSplResponseDto {
  splHash: string;
  splUrl: string;
}

export interface GetOrCreateSplQueryDto {
  campaign: string;
}

export interface CreateUserSharedPaymentLinkResponseDto {
  payload: string;
  payloadType?: string;
}

export interface CreateUserSharedPaymentLinkDto {
  userId: number;
  siteIds: number[];
  productIds: string[];
  billingCycle: SubscriptionBillingCycleType;
}

export interface CreateInspectorLeadBodyDto {
  email: string;
  url: string;
}

export interface GetRemediationPdfAllResponseDto {
  total: number;
  moreAvailable: boolean;
  page: number;
  perPage: number;
  orders: {
    rows: PdfRemediationOrderMappedRows;
    count: number;
  };
}

export interface PdfRemediationOrderMappedRows {
  orderId: number;
  orderNumber: number;
  status: string;
  /** @format date-time */
  createdAt: string;
  addedAtWorkAt: boolean;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userId: number;
  /** @format date-time */
  paidAt: string;
  totalPrice: number;
}

export interface GetRemediationPdfAllQueryDto {
  status?: string;
  s?: string;
  p?: number;
  q?: number;
}

export interface GetRemediationPdfActiveOrderResponseDto {
  id: number;
  number: string;
  invoice_id?: string | null;
  status: PdfRemediationOrderStatus;
  paid_at?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;
  files?: PdfRemediationOrderFileAttributes[];
}

export enum PdfRemediationOrderStatus {
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  COMPLETED = 'COMPLETED',
  UPLOADING = 'UPLOADING',
  SUBMITTED = 'SUBMITTED',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  PAID = 'PAID',
  AUTO_REMEDIATION = 'AUTO_REMEDIATION',
}

export interface PdfRemediationOrderFileAttributes {
  id: number;
  source_name: string;
  status?: PdfRemediationOrderFileStatus | null;
  source_key: string;
  dist_key?: string | null;
  desc_key?: string | null;
  remediation_order_id: number;
  info_source_size?: number | null;
  info_form_pages_count?: number;
  info_table_pages_count?: number;
  info_pages_count?: number | null;
  price: number;
  remediation_pdf_id?: number | null;
  hash?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export enum PdfRemediationOrderFileStatus {
  NEW = 'NEW',
  SUBMITTED = 'SUBMITTED',
  UPLOADING = 'UPLOADING',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  PAID = 'PAID',
  DONE = 'DONE',
  COMPLETED = 'COMPLETED',
  AUTO_REMEDIATION = 'AUTO_REMEDIATION',
  CANCELLED = 'CANCELLED',
}

export interface GetRemediationPdfStatusesResponseDto {
  id: number;
  status: string;
}

export interface GetRemediationPdfStatusesQueryDto {
  ids?: string;
}

export interface RemediationFilesFiltersResponseDto {
  total: number;
  moreAvailable: boolean;
  page: number;
  perPage: number;
  ordersFiles: RemediationOrderFilesQueryResult;
}

export interface RemediationOrderFilesQueryResult {
  rows: RemediationPdf[];
  count: number;
}

export interface RemediationPdf {
  id: number;
  site_remediation_id: number;
  /** TODO: Rename to source_file_hash */
  pdf_hash: string;
  /** TODO: Rename to source_file_url */
  pdf_url: string;
  /** TODO: Rename to remediated_file_key */
  remediation_file_url: string;
  remediationStatus?: RemediationPdfAutoStatus | RemediationPdfManualStatus;
  /** Type of remediation used for a website's PDF */
  remediationType?: RemediationPdfType;
  location: string;
  /** TODO: Remove/drop */
  approved: boolean;
  /** TODO: Remove/drop */
  status: RemediationPdfManualStatus | RemediationPdfAutoStatus;
  errorType: RemediationErrorType | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  /** @format date-time */
  deleted_at: string;
}

export enum RemediationPdfAutoStatus {
  AUTO_REMEDIATION = 'AUTO_REMEDIATION',
  DONE = 'DONE',
  FAILED = 'FAILED',
  EXCLUDED = 'EXCLUDED',
}

export enum RemediationPdfManualStatus {
  NEW = 'NEW',
  SUBMITTED = 'SUBMITTED',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  PAID = 'PAID',
  DONE = 'DONE',
  COMPLETED = 'COMPLETED',
  AUTO_REMEDIATION = 'AUTO_REMEDIATION',
  CANCELLED = 'CANCELLED',
}

/** Type of remediation used for a website's PDF */
export enum RemediationPdfType {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
  NONE = 'NONE',
}

export enum RemediationErrorType {
  ORIGINAL_FILE_SIZE_EXCEEDED_LIMIT = 'ORIGINAL_FILE_SIZE_EXCEEDED_LIMIT',
  FILE_STRUCTURE_SIZE_EXCEEDED_LIMIT = 'FILE_STRUCTURE_SIZE_EXCEEDED_LIMIT',
  FILE_NOT_AVAILABLE = 'FILE_NOT_AVAILABLE',
  SERVER_ERROR = 'SERVER_ERROR',
}

export interface RemediationFilesFiltersQueryDto {
  sortingType?: string;
  sortingDirection?: string;
  site?: number;
  status?: string;
  uploaded?: boolean;
  remediated?: boolean;
  p?: number;
  q?: number;
}

export interface RemediationFilesFiltersCountResponseDto {
  counts: {
    site: number;
    sent: number;
    remediated: number;
    waitingPaymentOrder: number;
    sites: SiteNativeQueryRow[];
  };
}

export interface SiteNativeQueryRow {
  file_count: number;
  id: number;
  host: string;
}

export interface RemediationFilesFiltersCountQueryDto {
  site?: number;
}

export interface RemediationFilesScheduleResponseDto {
  files: PickRemediationPdfIdLocationSiteRemediationIdPdfHashPdfUrlStatusApprovedCreatedAtUpdatedAt;
}

export interface PickRemediationPdfIdLocationSiteRemediationIdPdfHashPdfUrlStatusApprovedCreatedAtUpdatedAt {
  id: number;
  location: string;
  site_remediation_id: number;
  /** TODO: Rename to source_file_hash */
  pdf_hash: string;
  /** TODO: Rename to source_file_url */
  pdf_url: string;
  /** TODO: Remove/drop */
  status: RemediationPdfManualStatus | RemediationPdfAutoStatus;
  /** TODO: Remove/drop */
  approved: boolean;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export interface RemediationFilesScheduleRequestDto {
  allFiles?: boolean;
  files?: RemediationPdfFile[];
}

export interface RemediationPdfFile {
  id: number;
}

export interface RemediationFilesCountResponseDto {
  pdfFilesCount: number;
}

export interface RemediationFilesCountRequestDto {
  siteId: number;
}

export interface GetRemediationPdfResponseDto {
  remediationPdfs: MappedRemediationPdf[];
}

export interface MappedRemediationPdf {
  id: number;
  site_remediation_id: number;
  /** TODO: Rename to source_file_hash */
  pdf_hash: string;
  /** TODO: Rename to source_file_url */
  pdf_url: string;
  /** TODO: Rename to remediated_file_key */
  remediation_file_url: string;
  remediationStatus?: RemediationPdfAutoStatus | RemediationPdfManualStatus;
  /** Type of remediation used for a website's PDF */
  remediationType?: RemediationPdfType;
  location: string;
  /** TODO: Remove/drop */
  approved: boolean;
  /** TODO: Remove/drop */
  status: RemediationPdfManualStatus | RemediationPdfAutoStatus;
  errorType: RemediationErrorType | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  /** @format date-time */
  deleted_at: string;
  tooltip: MappedRemediationPdfTooltipEnum;
}

export interface GetRemediationPdfQueryDto {
  statuses: string[];
}

export interface CreateSiteConfigBodyDto {
  config: SiteCreationAccountConfigDto;
}

export interface SiteCreationAccountConfigDto {
  enabled: boolean;
  reviewList: boolean;
}

export interface SiteAccessibilityStatement {
  siteId: SiteId;
  title: string;
  content: string;
  enabled: boolean;
}

export type SiteId = string | number;

export interface GetUserServicesResponseDto {
  user_services: {
    WHITE_LABEL: UserServiceProductInfo;
    CUSTOM_BRANDING: UserServiceProductInfo;
    MODIFY_MENU: UserServiceProductInfo;
    USAGE_STATS: UserServiceProductInfo;
    LIVE_TRANSLATIONS: UserServiceProductInfo;
    REMEDIATION: UserServiceProductInfo;
  };
  trial_applicable: {
    WHITE_LABEL: boolean;
    CUSTOM_BRANDING: boolean;
    MODIFY_MENU: boolean;
    USAGE_STATS: boolean;
    LIVE_TRANSLATIONS: boolean;
    REMEDIATION: boolean;
  };
  thisSite: PickUserServiceSiteIdHost;
}

export interface UserServiceProductInfo {
  sites: UserServiceSite[];
  enabled: boolean;
  isTrial: boolean;
  globalSettings: PartialUserServiceProductSettings;
}

export interface UserServiceSite {
  id: number;
  host: string;
  status: string;
  settings: {
    /** @format date-time */
    expires_at: string;
    id: number;
    user_service_id: number;
    is_enabled: boolean;
    is_renewable: boolean;
    hide_report: boolean;
    hide_manage: boolean;
    hide_logo: boolean;
    hide_asterisk: boolean;
    hide_donate: boolean;
    accessibility_report: any;
  };
}

export interface PartialUserServiceProductSettings {
  id?: number;
  user_service_id?: number;
  is_enabled?: boolean;
  is_renewable?: boolean;
  hide_report?: boolean;
  hide_manage?: boolean;
  hide_logo?: boolean;
  hide_asterisk?: boolean;
  hide_donate?: boolean;
  accessibility_report?: any;
}

export interface PickUserServiceSiteIdHost {
  id: number;
  host: string;
}

export interface GetUserServicesQueryDto {
  siteId: string;
}

export interface UpdateSitesFreeBodyDto {
  serviceType: UserwaySubjectTransactionType;
  sitesIds?: number[];
}

export interface EnableTrialResponseDto {
  custom_service_data: BillingAddonSettings;
  service_type: UserwaySubjectTransactionType;
}

export interface EnableTrialBodyDto {
  serviceType: UserwaySubjectTransactionType;
  sitesIds: number[];
}

export interface RenewServiceBodyDto {
  serviceType: UserwaySubjectTransactionType;
  renewValue: boolean;
}

export interface UpdateDetailsBodyDto {
  serviceType: UserwaySubjectTransactionType;
  serviceSettings: DataAddonUnion;
}

export type DataAddonUnion =
  | ImagesDataAddon
  | PdfDataAddon
  | StatsDataAddon
  | LiveTranslationsDataAddon
  | ModifyMenuDataAddon;

export interface ImagesDataAddon {
  id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  user_service_id: number;
  created_at: string;
  images_quota: number;
  pricing_tier: string;
  updated_at: string;
}

export interface PdfDataAddon {
  id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  user_service_id: number;
  created_at: string;
  total_quota: number;
  pricing_tier: string;
  updated_at: string;
}

export interface StatsDataAddon {
  id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  user_service_id: number;
  stats: IProductDataAddonStats;
}

export interface IProductDataAddonStats {
  NINETY: IProductStatsByPeriod;
  SEVEN: IProductStatsByPeriod;
  SIXTY: IProductStatsByPeriod;
  THIRTY: IProductStatsByPeriod;
  expires_at: string;
  id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  is_trial: boolean;
  trial_applicable: boolean;
  user_service_id: number;
}

export interface IProductStatsByPeriod {
  features: IProductStatsFeatures[];
  featuresByFunction?: IProductStatsFeatures[];
  featuresByProfile?: IProductStatsFeatures[];
  forDays: number;
  hides: number;
  loads: number;
  opens: number;
  percentage: string;
  loadsHistory?: {
    date: string;
    value: number;
  }[];
  opensHistory?: {
    date: string;
    value: number;
  }[];
}

export interface IProductStatsFeatures {
  name: string;
  percents?: string | number;
  value?: number;
  icon?: string;
}

export interface LiveTranslationsDataAddon {
  id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  user_service_id: number;
  auto_renew_on_quota_exceeded: boolean;
  auto_translation: boolean;
  live_translation_quota: number;
  pricing_tier: string;
}

export interface ModifyMenuDataAddon {
  id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  user_service_id: number;
  color_mode: string;
  dictionary: boolean;
  features_pattern: string;
  oversized: boolean;
  profiles: boolean;
  two_columns_layout: boolean;
}

export interface GetCBLogosResponseDto {
  code: number;
  logos: string;
}

export interface WidgetInfoResponseDto {
  user: UserWithWidgetInfo;
  jwtUserDetails: SsoJwtUserDetails;
}

export interface UserWithWidgetInfo {
  id: number;
  email: string;
  code: string;
  first_name: string;
  last_name: string;
  /** **master** role is stored as a separate boolean column in UserWay but is part of the UserType in SSO */
  role: UwSsoRoles;
  isMasterAccount: boolean;
  phone: string;
  parent_id: number | null;
  /** @format date-time */
  created_at: string;
  discount?: string;
  discount_expires_at: string | null;
  status: UserStatus;
  is_blocked: boolean;
  key: string;
  everflowClickId: string;
  ssoUserId: string;
  sitesCount: number;
  totalSitesLoads: number;
  removedSitesCount: number;
  agencyMode: boolean;
  isPartner: boolean;
  is_feedback_submitted: boolean;
  is_feedback_trustpilot_submitted: boolean;
  open_regulation_tracker: boolean;
  regulation_tracker_mode_only: boolean;
  is_feedback_g2_submitted: boolean;
  agencyAccount: object | null;
  releasesSubscriber: boolean;
  siteCreateOnTunings: object;
  siteCreateReviewList: boolean;
  aiPaidUser: boolean;
  isTrialApplicable: boolean;
  walkthroughStatus: WalkthroughStatus;
  isFixMyCodeEnabled: boolean;
  csrConfig?: CsrConfig;
  trialInfo?: TrialInfoDto;
}

export interface WalkthroughStatus {
  MAIN?: boolean;
  DRAWER?: boolean;
  IMAGE_ALTS?: boolean;
}

export interface CsrConfig {
  userId: number;
  scopeAccounts: number[];
  scopeParentAccounts: number[];
  scopeSites: number[];
}

export interface TrialInfoDto {
  isTrialNoCard: boolean;
  isTrialNoCardExpired: boolean;
  isTrialNoCardWelcomeScreenShow: boolean;
}

export interface WidgetInfoQueryDto {
  code: string;
}

export interface UpdateWalkthroughStatusBodyDto {
  walkthroughStatusType: WalkthroughStatusType;
}

export enum WalkthroughStatusType {
  MAIN = 'MAIN',
  DRAWER = 'DRAWER',
  IMAGE_ALTS = 'IMAGE_ALTS',
}

export interface UserCompanyPaymentBodyDto {
  name: string;
  domain: string;
  url: string;
  address?: UserCompanyPaymentAddress;
  sitesNumber?: number;
  companyType?: OrganizationType;
  feedbackMessage?: string;
}

export interface UserCompanyPaymentAddress {
  country: string;
  zip?: string;
  state?: string;
  city?: string;
  address?: string;
}

export enum OrganizationType {
  PARTNER_AGENCY = 'PARTNER_AGENCY',
  STRATEGIC_COMPANY = 'STRATEGIC_COMPANY',
  LARGE_COMPANY = 'LARGE_COMPANY',
  MEDIUM_COMPANY = 'MEDIUM_COMPANY',
  SMALL_COMPANY = 'SMALL_COMPANY',
}

export interface UserRegistrationResponseDto {
  accessToken: string;
  refreshToken: string;
  userAccount: string;
  site: PartialSite;
}

export interface PartialSite {
  id?: number;
  user_id?: number;
  host?: string;
  url?: string;
  white_label_id?: number | null;
  custom_branding_id?: number | null;
  custom_menu_id?: number | null;
  usage_stats_id?: number | null;
  live_translation_id?: number | null;
  remediation_id?: number | null;
  managed_accessibility?: boolean;
  wl_agency_added_at?: string | null;
  /** @format date-time */
  first_activity_date?: string;
  status?: ISiteStatus;
  platform_app?: any;
  comment?: string;
  suspended?: boolean;
  /** @format date-time */
  created_at?: string;
}

export interface UserRegistrationBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  widget_color?: string;
  widget_language?: string;
  widget_icon_type?: string;
  widget_icon_size?: string;
  widget_position?: string;
  language?: string;
  iconType?: string;
  iconSize?: string;
  password: string;
  password_confirm: string;
  first_name: string;
  last_name?: string;
  phone?: string;
  company_type?: string;
  url: string;
}

export interface RegistrationRouteResponseDto {
  user: RegistrationRouteResponseUserDto;
  currency: PricingCurrency;
  sites: RegistrationRouteResponseSiteDto[];
  site: RegistrationRouteResponseSiteDto | null;
}

export interface RegistrationRouteResponseUserDto {
  id?: number;
  code?: string;
  accUuid?: string;
  account_id?: number | null;
  email?: string;
  /** **master** role is stored as a separate boolean column in UserWay but is part of the UserType in SSO */
  role?: UwSsoRoles;
  /** true means user is a master since we don't set "master" role directly in the role column */
  isMasterAccount?: boolean;
  first_name?: string;
  last_name?: string;
  acc_code?: string;
  acc_uuid?: string;
  registration_origin?: string;
  is_open_acc?: number;
  monthly_loads?: string;
  phone?: string;
  companyId?: number;
  key?: string;
  /** @format date-time */
  created_at?: string;
  whitepaper_requested_at?: string | null;
  everflowClickId?: string;
  discount?: string;
  registration_origin_url?: string | null;
  sso_user_id?: string;
  laSfdcId?: string;
  slug?: string;
  parent_id?: number | null;
  discount_expires_at?: string | null;
  status?: UserStatus;
  is_blocked?: boolean;
  mergedToId?: number | null;
  isTuningMigrated?: boolean;
  homePage?: string | null;
  aiTrialApplicable: boolean;
  sharedPaymentLink: string;
  exchangeCode: string;
  ssoAuthToken: string;
  isNew: boolean;
}

export interface RegistrationRouteResponseSiteDto {
  id?: number;
  user_id?: number;
  host?: string;
  url?: string;
  white_label_id?: number | null;
  custom_branding_id?: number | null;
  custom_menu_id?: number | null;
  usage_stats_id?: number | null;
  live_translation_id?: number | null;
  remediation_id?: number | null;
  managed_accessibility?: boolean;
  wl_agency_added_at?: string | null;
  /** @format date-time */
  first_activity_date?: string;
  status?: ISiteStatus;
  platform_app?: any;
  comment?: string;
  suspended?: boolean;
  /** @format date-time */
  created_at?: string;
  siteEstimatedCost: number;
  siteEstimatedAnnualCost: number;
  siteEstimatedBiAnnualCost: number;
  siteEstimatedCostPlus: number;
  siteEstimatedAnnualCostPlus: number;
  siteEstimatedBiAnnualCostPlus: number;
  remediationProductId: number | null;
  isNew: boolean;
  siteLoadsTraffic: number;
}

export interface UserSafeRegistrationBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  widget_color?: string;
  widget_language?: string;
  widget_icon_type?: string;
  widget_icon_size?: string;
  widget_position?: string;
  language?: string;
  iconType?: string;
  iconSize?: string;
  first_name: string;
  last_name?: string;
  url?: string;
  urls?: string[];
  currency?: PricingCurrency;
  forceAiPlan?: UserWayForcedPlan;
  package_name?: string;
  noemail?: boolean;
  phone?: string;
  company_type?: string;
}

export enum UserWayForcedPlan {
  REMEDIATION_PRODUCT_PLAN_SMALL = 'REMEDIATION_PRODUCT_PLAN_SMALL',
  REMEDIATION_PRODUCT_PLAN_MEDIUM = 'REMEDIATION_PRODUCT_PLAN_MEDIUM',
  REMEDIATION_PRODUCT_PLAN_LARGE = 'REMEDIATION_PRODUCT_PLAN_LARGE',
  REMEDIATION_PRODUCT_PLAN_CUSTOM = 'REMEDIATION_PRODUCT_PLAN_CUSTOM',
}

export interface LAUserRegistrationBodyDto {
  url: string;
  first_name: string;
  last_name: string;
  email: string;
  company_name: string;
  laSfdcId: string;
  utm?: HubspotUtmInfo | null;
  originUrl?: string;
}

export interface StatementGeneratorResponseDto {
  user: {
    isNew: boolean;
  };
}

export interface StatementGeneratorBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  widget_color?: string;
  widget_language?: string;
  widget_icon_type?: string;
  widget_icon_size?: string;
  widget_position?: string;
  language?: string;
  iconType?: string;
  iconSize?: string;
  company: string;
  url: string;
  first_name: string;
  last_name?: string;
  phone?: string;
  company_type?: string;
}

export interface WhitepaperRegistrationResponseDto {
  user: {
    code: string;
    isNew: boolean;
  };
}

export interface WhitepaperRegistrationBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  widget_color?: string;
  widget_language?: string;
  widget_icon_type?: string;
  widget_icon_size?: string;
  widget_position?: string;
  language?: string;
  iconType?: string;
  iconSize?: string;
  company_url: string;
  company_type: string;
  first_name: string;
  last_name?: string;
  phone?: string;
}

export interface EnterpriseRegistrationResponseDto {
  user: {
    code: string;
    isNew: boolean;
  };
  calendlyInfo: InfoForCalendly;
}

export interface EnterpriseRegistrationBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  widget_color?: string;
  widget_language?: string;
  widget_icon_type?: string;
  widget_icon_size?: string;
  widget_position?: string;
  language?: string;
  iconType?: string;
  iconSize?: string;
  full_name: string;
  company_url: string;
  company_name: string;
  company_type: string;
  calendlyInfo?: InfoForCalendly;
  message?: string;
  sites_number?: number;
  package_name?: string;
  phone?: string;
}

export interface UserPdfRequestResponseDto {
  user: {
    isNew: boolean;
  };
  calendlyInfo: InfoForCalendly;
}

export interface UserPdfRequestBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  full_name: string;
  phone: string;
  site: string;
  calendlyInfo: InfoForCalendly;
  company_type: string;
  company?: string;
  package_name?: string;
  message1?: string;
  message2?: string;
}

export interface UserDemoRequestResponseDto {
  user: {
    isNew: boolean;
  };
  calendlyInfo: InfoForCalendly;
}

export interface UserDemoRequestBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  phone: string;
  company_type: string;
  first_name: string;
  last_name?: string;
  calendlyInfo?: InfoForCalendly;
  number_of_sites?: number;
  company?: string;
  site?: string;
  package_name?: string;
  message?: string;
}

export interface UserShortDemoRequestResponseDto {
  user: {
    isNew: boolean;
  };
  calendlyInfo: InfoForCalendly;
}

export interface UserShortDemoRequestBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  phone: string;
  first_name: string;
  last_name?: string;
  calendlyInfo?: InfoForCalendly;
  message?: string;
  company_type?: string;
}

export interface WebinarFeedbackRequestResponseDto {
  user: {
    code: string;
    isNew: boolean;
  };
}

export interface WebinarFeedbackRequestBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  first_name: string;
  last_name: string;
  company_url: string;
  message: string;
  company_type?: string;
}

export interface WebsummitRegistrationResponseDto {
  user: {
    code: string;
    isNew: boolean;
  };
}

export interface WebsummitRegistrationBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  full_name: string;
  company_name: string;
  company_type: string;
  phone?: string;
}

export interface CallMeBackBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  website_url: string;
  product: string;
  phone: string;
  first_name: string;
  last_name?: string;
}

export interface AffiliateMeetingResponseDto {
  user: {
    isNew: boolean;
  };
}

export interface AffiliateMeetingBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  website_url: string;
  company_name: string;
  phone: string;
  first_name: string;
  last_name?: string;
  message?: string;
  company_type?: string;
}

export interface CodeToDevBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  code: string;
}

export interface LinkedInOutreachBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  title: string;
  linkedin_profile: string;
  company_name: string;
  first_name: string;
  last_name?: string;
  info?: string;
  company_type?: string;
}

export interface ScannerSlgResponseDto {
  user: {
    code: string;
    isNew: boolean;
  };
  token: string | null;
}

export interface ScannerSlgBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  full_name: string;
  phone?: string;
}

export interface LetsTalkSlgResponseDto {
  user: {
    code: string;
    isNew: boolean;
  };
  token: string | null;
}

export interface LetsTalkSlgBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  full_name: string;
}

export interface CreateUserBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  first_name: string;
  last_name: string;
  role: string;
}

export interface UpdateUserBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  first_name: string;
  last_name: string;
  /** **master** role is stored as a separate boolean column in UserWay but is part of the UserType in SSO */
  role: UwSsoRoles;
  is_blocked: boolean;
  homePage?: string | null;
  phone?: string;
}

export interface UserChangeEmailBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  password: string;
}

export interface ChangeInfoBodyDto {
  name: string;
  phone: string;
}

export interface ChangeStatusBodyDto {
  id: number;
  status: string;
}

export interface CompanyRegistrationBodyDto {
  first_name: string;
  last_name: string;
  company_name: string;
  company_phone_number: string;
  company_url: string;
  company_email: string;
  company_user_amount: string;
  company_comment: string;
}

export interface ChangeResellerInfoBodyDto {
  name: string;
  phone: string;
}

export interface ChangeResellerStatusBodyDto {
  id: number;
  status: string;
}

export interface ResellerRegistrationResponseDto {
  code: number;
  user: {
    reseller_id: number;
    isNew: boolean;
  };
  calendlyInfo?: InfoForCalendly;
}

export interface ResellerRegistrationBodyDto {
  first_name: string;
  last_name: string;
  company_name: string;
  company_phone_number: string;
  company_url: string;
  company_email: string;
  company_user_amount: string;
  company_comment: string;
  calendlyInfo?: InfoForCalendly;
}

export interface PostTuningsResponseDto {
  updatedTunings: TuningsInfo[];
  createdTunings: TuningsInfo[];
  nulledTunings: TuningsInfo[];
}

export interface TuningsInfo {
  pattern: string;
  name: string;
  firstSite?: string;
  value?: string;
}

export interface PostTuningsBodyDto {
  name: string;
  value: string;
  href?: string;
  user_id?: number;
}

export interface UpdateTuningsPersiteResponseDto {
  tuningItems: PostTuningsBodyDto[];
}

export interface UpdateTuningsPersiteBodyDto {
  items: PostTuningsBodyDto[];
  global?: boolean;
  siteId?: number;
  host?: string;
}

export interface UpdatePaidPersiteTuningsResponseDto {
  tuningItems: PaidTuningItem[];
}

export interface PaidTuningItem {
  name: string;
  value: string;
}

export interface UpdatePaidPersiteTuningsRequestDto {
  siteId: number;
  items: PaidTuningItem[];
  global: boolean;
}

export interface PostContactsResponseDto {
  user: {
    isNew: boolean;
  };
  calendlyInfo?: InfoForCalendly;
}

export interface PostContactsBodyDto {
  email: string;
  affiliate?: string;
  everflow_click_id?: string;
  agree_mailing?: boolean;
  origin?: string;
  originUrl?: string;
  utm?: HubspotUtmInfo | null;
  abScope?: string;
  first_name: string;
  last_name?: string;
  calendlyInfo?: InfoForCalendly;
  company?: string;
  company_type?: string;
  message?: string;
  interest?: string;
  phone?: string;
  url?: string;
  number_of_sites?: number;
}

export interface PostContrastBodyDto {
  foreground: string;
  background: string;
  ratio: number;
  emails: string[];
  aaSmallPassed?: boolean;
  aaaSmallPassed?: boolean;
  aaLargePassed?: boolean;
  aaaLargePassed?: boolean;
}

export interface GetSiteResponseDto {
  imageUrlBase: string;
  site: Site | null;
  firstSite: string | null;
  tunings: AnyObject;
  firstSiteTunings: AnyObject | null;
  defaultTunings: AnyObject | null;
  excludedFromMismatch: boolean;
}

export interface GetSitesResponseDto {
  code: number;
  data: GetSitesResponse;
  ids: number[];
}

export interface GetSitesResponse {
  sites: {
    rows: SiteMappedRow[];
    total: number;
  };
}

export interface SiteMappedRow {
  id: number;
  host: string;
  /** @format date-time */
  created_at: string;
  isWhiteLabeled: boolean;
  isCustomBranded: boolean;
  isModifiedMenu: boolean;
  isStatsEnabled: boolean;
  isAIEnabled: boolean;
  liveTranslationEnabled: boolean;
  category: string;
  opens: number;
  loads: number;
  isActive: boolean;
  is_ip_address: boolean;
  user: UserPublicInfo;
}

export interface UserPublicInfo {
  id: number;
  email: string;
  code: string;
  first_name: string;
  last_name: string;
  /** **master** role is stored as a separate boolean column in UserWay but is part of the UserType in SSO */
  role: UwSsoRoles;
  isMasterAccount: boolean;
  phone: string;
  parent_id: number | null;
  /** @format date-time */
  created_at: string;
  discount?: string;
  discount_expires_at: string | null;
}

export interface SiteToggleRequestDto {
  state: boolean;
}

export interface CreateBankTransferResponseDto {
  id: number;
}

export interface CreateBankTransferBodyDto {
  adminId: number;
  companyName: string;
  total: number;
  received: boolean;
  recognized: boolean;
  quoteNumber?: string;
  financialTool?: OrderFinancialTool;
  billingCycle?: SubscriptionBillingCycleType;
}

export enum OrderFinancialTool {
  NETSUITE = 'NETSUITE',
  USERWAY = 'USERWAY',
}

export interface A11YStatementPostBodyDto {
  email: string;
  url: string;
  company: string;
  phone?: string;
}

export interface LoginWidgetBodyDto {
  email: string;
  password: string;
  account: string;
  siteId: number;
}

export interface RegistrationUserResponseDto {
  code: number;
  data: RegistrationUserResponseData;
  message: string;
  errors: string[];
}

export interface RegistrationUserResponseData {
  token: string;
  refreshToken: string;
  user: UserPrivateInfo;
  jwtUserDetails: SsoJwtUserDetails | null;
}

export interface LoginBodyDto {
  email: string;
  password: string;
  origin: string;
  code?: string;
  mfaMethod?: MfaMethod;
}

export interface ChangePasswordBodyDto {
  password: string;
  password_confirm: string;
  password_current: string;
}

export interface ForgotPasswordBodyDto {
  email: string;
  isAccountPage?: boolean;
  account?: string;
}

export interface RecoveryRequestResponseDto {
  token: string;
  user: UserPrivateInfo;
}

export interface RecoveryRequestBodyDto {
  code: string;
  password: string;
  password_confirm: string;
  isAccountPage?: boolean;
}

export interface UpdatePerSiteScriptBodyDto {
  siteId: number;
  enabled: boolean;
  content: string;
}

export interface GetLiveTranslationQuotaResponseDto {
  quota: GetLiveTranslationQuota;
}

export interface GetLiveTranslationQuota {
  total: number;
  remaining: number;
}

export interface GetLiveTranslationQuotaQueryDto {
  siteId: string;
}

export interface ReplaceLiveTranslationOverridesResponseDto {
  csv: string;
}

export interface ReplaceLiveTranslationOverridesRequestDto {
  csv: string;
  siteId: string;
  applyForAllSites: boolean;
}

export interface GetLiveTranslationOverridesResponseDto {
  csv: string;
}

export interface CreateLiveTranslationOverridesStatRequestDto {
  siteId: string;
  wordsOnPage: number;
  wordsOverriden: number;
}

export interface GetLiveTranslationNoTranslatesResponseDto {
  selectors: string;
}

export interface CreateLiveTranslationNoTranslatesResponseDto {
  selectors: string;
}

export interface CreateLiveTranslationNoTranslatesRequestDto {
  siteId: string;
  selectors: string;
}

export interface GetLiveTranslationIgnoredWordsResponseDto {
  ignoredWords: string[];
}

export interface CreateLiveTranslationIgnoredWordsResponseDto {
  ignoredWordsFileUrl: string;
}

export interface CreateLiveTranslationIgnoredWordsRequestDto {
  siteId: number;
  ignoredWords: string[];
}

export interface CreatePdfRemediationDto {
  siteId: number;
  elements: PdfRemediationFile[];
  page: string;
}

export interface PdfRemediationFile {
  url: string;
}

export interface UserIntercomDetails {
  name: string;
  email: string;
  phone: string | null;
  user_hash: string;
  user_id: number;
  created_at: number;
  account_id: string;
  admin_link: string;
  script_link: string;
  most_visited_sites: string[];
  user_total_paid: number;
  next_renewal_amount?: number;
  next_renewal_date?: string;
  total_sites: number;
  free_sites: number;
  deleted_sites: number;
  ai_active_on: number;
  ai_auto_renews: boolean;
  wl_active_on: number;
  wl_auto_renews: boolean;
  cb_active_on: number;
  cb_auto_renews: boolean;
  mm_active_on: number;
  mm_auto_renews: boolean;
  st_active_on: number;
  st_auto_renews: boolean;
  tr_active_on: number;
  tr_auto_renews: boolean;
  scanner_account_exits: boolean;
  scanner_account_sites_num: number | null;
  deal_name: string | null;
  deal_stage: string | null;
  amount: number | null;
  close_date: string | null;
}

export interface AddEventsBodyDto {
  events?: IUiActionEvent[];
}

export interface IUiActionEvent {
  event?: string;
  timestamp?: string;
  abver?: string;
  uId?: string;
  page?: string;
  device?: string;
  lead_type?: string;
  user_source?: UserSource;
  [key: string]: any;
}

export enum UserSource {
  UserWay = 'UserWay',
  LAP = 'LAP',
}

export interface PageContribStatusDto {
  status: string;
}

export interface PdfAutoRemediationAddon {
  id: number;
  user_service_id: number;
  site_id: number;
  is_enabled: boolean;
  is_renewable: boolean;
  used_quota: number;
  total_quota: number;
  pricing_tier: PdfAutoRemediationTierType;
}

/** The funding method type to be used when there are not enough funds in the customer balance. Permitted values include: `bank_transfer`. */
export enum StripeInvoicePaymentSettingsPaymentMethodOptionsCustomerBalanceFundingTypeEnum {
  BankTransfer = 'bank_transfer',
}

/** For `fixed_count` installment plans, this is the interval between installment payments your customer will make to their credit card. One of `month`. */
export enum StripePaymentIntentPaymentMethodOptionsCardInstallmentsAvailablePlanIntervalEnum {
  Month = 'month',
}

/** For `fixed_count` installment plans, this is the interval between installment payments your customer will make to their credit card. One of `month`. */
export enum StripePaymentIntentPaymentMethodOptionsCardInstallmentsPlanIntervalEnum {
  Month = 'month',
}

/** The funding method type to be used when there are not enough funds in the customer balance. Permitted values include: `bank_transfer`. */
export enum StripePaymentIntentPaymentMethodOptionsCustomerBalanceFundingTypeEnum {
  BankTransfer = 'bank_transfer',
}

/** For `fixed_count` installment plans, this is the interval between installment payments your customer will make to their credit card. One of `month`. */
export enum StripeChargePaymentMethodDetailsCardInstallmentsPlanIntervalEnum {
  Month = 'month',
}

/** The funding method type to be used when there are not enough funds in the customer balance. Permitted values include: `bank_transfer`. */
export enum StripeSubscriptionPaymentSettingsPaymentMethodOptionsCustomerBalanceFundingTypeEnum {
  BankTransfer = 'bank_transfer',
}

export enum SpecialPaymentStateStatusEnum {
  Paid = 'paid',
  Pending = 'pending',
  Canceled = 'canceled',
}

export enum MappedRemediationPdfTooltipEnum {
  CouldNotAccessPDFFile = 'Could not access PDF file',
  PDFFileStructureSizeExceedsTheMaximumLimit = 'PDF File structure size exceeds the maximum limit',
  PDFFileSizeExceedsTheMaximumLimit = 'PDF File size exceeds the maximum limit',
  ErrorPleaseContactSupportTeam = 'Error, please contact support team',
}

export interface UwV2ScannerSignupCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: ScannerSignUpResponseDto;
  [key: string]: any;
}

export type UwV2ExposedSitesVisibilityCreateData = object;

export interface UwV2ExposedSitesCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CreateSiteResponseDto;
}

export interface UwV2ExposedAgencySitesEnableProductCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetAgencySiteResponseDto;
}

export interface UwV2ExposedAgencySitesDisableProductCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetAgencySiteResponseDto;
}

export interface UwV2ExposedUsersCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CreateChildUserAndSiteResponseDto;
}

export interface UwV2ExposedAgencyUsersStatsListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: AgencyAccountSummaryReport;
}

export type UwV2ExposedAgencySubscriptionsNamePartialUpdateData = object;

export type UwV2ExposedAgencySubscriptionsPaymentDataPartialUpdateData = object;

export interface UwV2ExposedAgencySubscriptionsSitesBillingDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: AgencySiteBillingDetailsDto;
}

export type UwV2ExposedAgencySubscriptionsSitesEnableCreateData = object;

export type UwV2ExposedAgencySubscriptionsSitesTransferCreateData = object;

export type UwV2ExposedAgencySubscriptionsSitesDisableCreateData = object;

export interface UwV2ExposedAgencySubscriptionsSitesAddBatchCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: AddSitesBatchResponseDto;
}

export interface UwV2ExposedAgencySubscriptionsSitesDisableBatchCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: AgencyDisableSitesBatchResponseDto;
}

export interface UwV2ExposedAgencyAccountsContextDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: AgencyAccountContextDto;
}

export type UwV2ExposedAgencyAccountsBillingDescriptorUpdateData = object;

export interface UwV2AuthLoginWidgetCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: LoginWidgetResponseDto;
  [key: string]: any;
}

export interface UwV2AuthWidgetAccessDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: DashboardAccessMapResponse;
}

export interface UwV2AuthGeneralSignupCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GeneralSignUpResponseDto;
}

export interface UwV2SmartFormsCompanyInfoCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SmartFormCompanyInfoDto;
}

export interface UwV2BillingStripeHelperProductsCreateParams {
  spltoken?: string;
}

export interface UwV2BillingStripeHelperProductsCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingHelperTieredProductsResponseDto;
}

export type UwV2BillingStripePaymentMethodsCreateData = object;

export interface UwV2BillingStripePaymentMethodsListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingPaymentMethodsListResponseDto;
}

export interface UwV2BillingStripePaymentMethodsDefaultListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PaymentMethodDetailsWithAddressDto;
}

export type UwV2BillingStripePaymentMethodsUpdateData = object;

export type UwV2BillingStripePaymentMethodsDeleteData = object;

export interface UwV2BillingStripePaymentMethodsSubscriptionsDetailParams {
  search?: string;
  /** Parameter 'paymentDataId' */
  paymentDataId: string;
}

export interface UwV2BillingStripePaymentMethodsSubscriptionsDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SubscriptionBillingDetails[];
}

export type UwV2BillingStripePaymentMethodsIsDefaultUpdateData = object;

export interface UwV2BillingStripePaymentMethodsSubscriptionsDetail2Data {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PaymentMethodDetailsWithAddressDto;
}

export interface UwV2BillingStripePaymentMethodsCheckAddressCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CheckPaymentMethodAddressResponseDto;
}

export type UwV2BillingRetentionSupportCreateData = object;

export interface UwV2BillingCustomPaymentsCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiSuccessResponse;
}

export interface UwV2BillingSubscriptionsListParams {
  search?: string;
}

export interface UwV2BillingSubscriptionsListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SubscriptionBillingDetails[];
}

export interface UwV2BillingSubscriptionsSubscriptionIdListParams {
  search?: string;
  subscriptionId: string;
}

export interface UwV2BillingSubscriptionsSubscriptionIdListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SubscriptionBillingDetailsByIdResponseDto;
}

export type UwV2BillingSubscriptionsCancelCreateData = object;

export type UwV2BillingSubscriptionsDowngradeCreateData = object;

export type UwV2BillingSubscriptionsToggleAutoRenewCreateData = object;

export type UwV2BillingSubscriptionsNoCardTrialCreateData = object;

export interface UwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: LaunchNoCardTrialSubscriptionResponseDto;
}

export interface UwV2BillingSubscriptionsCreateAchSetupIntentCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CreateAchSetupIntentResponseDto;
}

export interface UwV2BillingSubscriptionsLaunchQuoteSubscriptionCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: LaunchQuoteSubscriptionResponseDto;
}

export interface UwV2BillingEmailsCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiSuccessResponse;
}

export interface UwV2BillingEmailsListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingEmailsResponseDto;
}

export interface UwV2BillingCartCalculateAutoRenewCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseWithoutInvoiceDto;
}

export interface UwV2BillingCartCalculateQuoteCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseWithoutInvoiceDto;
}

export interface UwV2BillingCustomersCheckCouponListParams {
  /** Parameter 'coupon' */
  coupon: string;
}

export interface UwV2BillingCustomersCheckCouponListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCheckCouponRedeemedDto;
}

export interface UwV2BillingSpecialPaymentsConfirmCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ConfirmSpecialPaymentResponse;
}

export interface UwV2AiTextCompletionCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetTextCompletionResponseDto;
}

export type UwV2AiFmcChatCreateData = string;

export interface UwV2AiFmcChatChatTitleCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetFixMyCodeChatTitleResponseDto;
}

export interface UwV2AiFmcChatPromptPairVoteCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetFixMyCodeChatTitleResponseDto;
}

export type UwV2AiFmcChatEmailSubscriptionCreateData = object;

export type UwV2BrandAssetsTrackCreateData = object;

export type UwV2TrackingNewslettersCreateData = object;

export type UwV2TrackingRetentionsCreateData = object;

export type UwV2TrackingLandingPagesCreateData = object;

export type UwV2TrackingSearchForCancellationCreateData = object;

export type UwV2AgencyA11YStatementsGenerateCreateData = object;

export interface UwV2RemediationEmptyControlsCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CreateOrUpdateRemediationEmptyControlResponseDto;
}

export interface UwV2SitesExchangeHostnamesCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ExchangeHostnamesResponseDto;
}

export interface UwV2SitesSearchListParams {
  referrer?: string;
  siteIds?: string;
  allowedUnitSites?: string;
  products?: string;
  noProducts?: string;
  status?: ISiteStatus;
  type?: SitesSearchSubscriptionTypeArg;
  t?: SitesSearchTrafficArg;
  d?: SitesSearchDateAddedArg;
  pr?: SitesSearchProductsNumberArg;
  prt?: SitesSearchProductsNumberArg;
  bc?: SitesSearchBillingCycleArg;
  a?: SitesSearchAlphabetArg;
  a11yScore?: SitesSortA11YScoreArg;
  isPdfRequest?: boolean;
  p?: number;
  q?: number;
  s?: string;
}

export interface UwV2SitesSearchListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SiteSearchResultDto;
}

export interface UwV2SitesSearchCreateParams {
  referrer?: string;
  siteIds?: string;
  allowedUnitSites?: string;
  products?: string;
  noProducts?: string;
  status?: ISiteStatus;
  type?: SitesSearchSubscriptionTypeArg;
  t?: SitesSearchTrafficArg;
  d?: SitesSearchDateAddedArg;
  pr?: SitesSearchProductsNumberArg;
  prt?: SitesSearchProductsNumberArg;
  bc?: SitesSearchBillingCycleArg;
  a?: SitesSearchAlphabetArg;
  a11yScore?: SitesSortA11YScoreArg;
  isPdfRequest?: boolean;
  p?: number;
  q?: number;
  s?: string;
}

export interface UwV2SitesSearchCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SiteSearchResultDto;
}

export interface UwV2SitesRemediationHelpersUpdateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: UpdateRemediationHelperResponseDto;
}

export interface UwV2PdfRemediationStatsListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfRemediationStatsResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionCalculateCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfAutoCalculateResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionInitCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: InitAutoRemediationResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionSelectSitesCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: InitAutoRemediationResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionSelectSitesAndPlanCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfAutoSelectSitesAndPlanResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionSelectNewPlanCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfAutoSelectNewPlanResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionUpgradePlanCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfAutoUpgradePlanResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionCompletePaymentCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfAutoCompletePaymentResponseDto;
}

export interface UwV2PdfAutoRemediationSubmissionConfirmRemediationCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PdfAutoConfirmRemediationResponseDto;
}

export interface UwV2PdfAutoRemediationExportCsvListParams {
  siteId?: number;
  email?: string;
}

export interface UwV2PdfAutoRemediationExportCsvListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiCodeResponse;
}

export interface UwV2DashboardProductsUsageStatsListParams {
  siteId?: string;
  statsType?: LiveTranslationStatsType;
  periodType?: GetUsageStatsPeriodType;
  period?: string;
  scope?: UsageStatsScope;
  fromDate?: string;
  toDate?: string;
}

export interface UwV2DashboardProductsUsageStatsListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetUsageStatsBreakdownResponseDto;
}

export interface UwV2DashboardProductsUsageStatsExportCsvListParams {
  siteId?: string;
  statsType?: LiveTranslationStatsType;
  periodType?: GetUsageStatsPeriodType;
  period?: string;
  scope?: UsageStatsScope;
  fromDate?: string;
  toDate?: string;
  email?: string;
}

export interface UwV2DashboardProductsUsageStatsExportCsvListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiCodeResponse;
}

export interface UwV2DashboardProductsUsageStatsLstExportCsvListParams {
  email?: string;
  siteId?: number;
}

export interface UwV2DashboardProductsUsageStatsLstExportCsvListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiCodeResponse;
}

export interface UwV2DashboardProductsImageAltsExportCsvCreateParams {
  date_sort?: MissingAltQueryType;
  alt_length_sort?: MissingAltQueryType;
  special_chars?: MissingAltQueryType;
  with_alts?: MissingAltQueryType;
  without_alts?: MissingAltQueryType;
  ai_generated_alts?: MissingAltQueryType;
  decorative?: MissingAltQueryType;
  search_phrase?: string;
}

export interface UwV2DashboardProductsImageAltsExportCsvCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiCodeResponse;
}

export type UwV2DashboardStatementGenDownloadCreateData = string;

/** Parameter 'format' */
export enum UwV2DashboardStatementGenDownloadCreateParamsFormatEnum {
  TXT = 'TXT',
  HTML = 'HTML',
}

export enum UwV2DashboardStatementGenDownloadCreateParamsEnum {
  TXT = 'TXT',
  HTML = 'HTML',
}

/** Parameter 'format' */
export enum UwV2DashboardStatementGenCreateParamsFormatEnum {
  TXT = 'TXT',
  HTML = 'HTML',
}

export enum UwV2DashboardStatementGenCreateParamsEnum {
  TXT = 'TXT',
  HTML = 'HTML',
}

export interface UwV2DashboardStatementGenDataDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: A11YStatementResponseDto;
}

export interface UwV2DashboardStatementGenDataCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ApiCodeResponse;
}

export interface UwV2DashboardReportsDetailParams {
  pageSize?: number;
  pageIndex?: number;
  sort?: GetReportsSortType;
  /** Parameter 'siteId' */
  siteId: string;
}

export interface UwV2DashboardReportsDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetReportsResponseDto;
}

export type UwV2DashboardReportsMarkAsReadCreateData = object;

export interface UwV2UnitManagementDashboardAccessDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: DashboardAccessMapResponse;
}

export interface UwV2PagesSummarizationCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: SummarizeContentResponseDto;
}

export type UwV2PagesSummarizationStreamCreateData = string;

export type UwV2OrganizationManagementSiteCreateData = object;

export type UwV2OrganizationManagementSiteDeleteData = object;

export type UwV2OrganizationManagementMemberCreateData = object;

export type UwV2OrganizationManagementMemberUpdateData = object;

export type UwV2OrganizationManagementMemberDeleteData = object;

export interface UwV2OrganizationManagementCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: OrganizationCreateResponseDto;
}

export type UwV2OrganizationManagementUpdateData = object;

export interface UwV2LabsWebsitesPublishCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PublishConfigVersionResponseDto;
}

export interface UwV2LabsWebsitesListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetAvailableSitesResponseDto;
}

export interface UwV2LabsWebsitesCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetLabsTuningsResponseDto;
}

export interface UwV2LabsWebsitesFixesDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: LabsFixResponseDto;
}

export interface UwV2LabsWebsitesFixesDeleteData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: LabsFixResponseDto;
}

export interface UwV2LabsWebsitesFixesDetail2Params {
  type?: LabsFixType;
  /** Parameter 'siteId' */
  siteId: string;
}

export interface UwV2LabsWebsitesFixesDetail2Data {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetLabsFixesResponseDto;
}

export interface UwV2LabsWebsitesFixesCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: LabsFixResponseDto;
}

export interface UwV2ImageAltsQuotaListParams {
  siteId?: string;
}

export interface UwV2ImageAltsQuotaListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ImageAltsQuotaResponseDto;
}

export type WidgetSiteRemediationFocusUpdateData = object;

export interface WidgetCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: WidgetRegistrationResponseDto;
  [key: string]: any;
}

export interface V1BillingStripeTCustomerListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCustomerResponseDto;
}

export interface V1BillingStripeTSubscriptionDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingSubscriptionResponseDto;
}

export interface V1BillingStripeTSubscriptionCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCreateSubscriptionResponseDto;
}

export interface V1BillingStripeTSubscriptionRetryInvoiceCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingRetryInvoiceResponseDto;
}

export interface V1BillingStripeTSubscriptionConfirmInvoiceCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingConfirmInvoiceResponseDto;
}

export type V1BillingStripeSubscriptionSwitchToAnnualCreateData = object;

export interface V1BillingStripeSubscriptionPayOnTrialCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingPayOnTrialResponseDto;
}

export interface V1BillingStripeTSubscriptionUpgradeRemediationCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: ConfirmSpecialPaymentResponse;
}

export type V1BillingStripeTSubscriptionUpgradeCreateData = object;

export type V1BillingStripeTPaymentMethodDefaultListData = object;

export type V1BillingStripeTPaymentMethodDeleteCreateData = object;

export type V1BillingStripeTPaymentMethodCreateCreateData = object;

export interface V1BillingStripeTOneTimePaymentCardWalletListData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCardWalletResponseDto;
}

export interface V1BillingStripeTOneTimePaymentCreatePaymentIntentCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: OneTimeCreatePaymentIntentResponseDto;
}

export interface V1BillingStripeOneTimePaymentChargeCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: OneTimeChargeResponseDto;
}

export interface V1BillingStripeTOneTimePaymentInvoiceCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: InvoiceDetailsDto;
}

export interface V1BillingStripeTCartCalculateSwitchPlanCreateParams {
  spltoken?: string;
}

export interface V1BillingStripeTCartCalculateSwitchPlanCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseDto;
}

export interface V1BillingStripeTCartCalculateCreateParams {
  spltoken?: string;
}

export interface V1BillingStripeTCartCalculateCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseDto;
}

export interface V1BillingStripeTCartTrialPayNowCreateParams {
  spltoken?: string;
}

export interface V1BillingStripeTCartTrialPayNowCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseDto;
}

export interface V1BillingStripeTCartCalculateRemediationUpgradeCreateParams {
  spltoken?: string;
}

export interface V1BillingStripeTCartCalculateRemediationUpgradeCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseDto;
}

export interface V1BillingStripeTCartCalculateSubscriptionUpgradeCreateParams {
  spltoken?: string;
}

export interface V1BillingStripeTCartCalculateSubscriptionUpgradeCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: BillingCalculateCartResponseDto;
}

export interface V1BillingOrdersAdminListDetailParams {
  p?: number;
  q?: number;
  /** Parameter 'userId' */
  userId: string;
}

export interface V1BillingOrdersAdminListDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetOrdersListResponseDto;
  [key: string]: any;
}

export interface V1BillingOrdersListListParams {
  p?: number;
  q?: number;
}

export interface V1BillingOrdersListListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetOrdersListResponseDto;
  [key: string]: any;
}

export interface V1BillingOrdersDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetSingleOrderResponseDto;
  [key: string]: any;
}

export interface V1BillingOrdersReportCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetOrderReportsResponseDto;
  [key: string]: any;
}

export interface V1BillingProductsNonSiteDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: UserPaidAddonDto;
}

export interface V1BillingProductsNonSiteInfoDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: NonSiteProductInfo;
}

export interface V1SitesListOfSitesCsvListParams {
  referrer?: string;
  siteIds?: string;
  allowedUnitSites?: string;
  products?: string;
  noProducts?: string;
  status?: ISiteStatus;
  type?: SitesSearchSubscriptionTypeArg;
  t?: SitesSearchTrafficArg;
  d?: SitesSearchDateAddedArg;
  pr?: SitesSearchProductsNumberArg;
  prt?: SitesSearchProductsNumberArg;
  bc?: SitesSearchBillingCycleArg;
  a?: SitesSearchAlphabetArg;
  a11yScore?: SitesSortA11YScoreArg;
  isPdfRequest?: boolean;
  p?: number;
  q?: number;
  s?: string;
}

export interface V1SitesSplSearchListParams {
  referrer?: string;
  p?: string;
  q?: string;
  spltoken?: string;
}

export type V1SitesPendingRemoveCreateData = object;

export interface V1SitesExistsCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetSiteExistsResponseDto;
  [key: string]: any;
}

export interface V1SitesExistsBatchCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetSitesExistResponseDto[];
  [key: string]: any;
}

export interface V1UsersSubscriptionsListParams {
  s?: string;
}

export interface V1UsersSubscriptionsListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: SubscriptionBillingDetails[];
  [key: string]: any;
}

export interface V1UsersSubscriptionsDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetOrderIdResponseDto;
  [key: string]: any;
}

export interface V1UsersSubscriptionsEstimateCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: EstimateResponseDto;
  [key: string]: any;
}

export interface V1SplGetOrCreateDetailParams {
  campaign?: string;
  /** Parameter 'accountUuid' */
  accountUuid: string;
}

export interface V1SplCreateUserSharedCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CreateUserSharedPaymentLinkResponseDto;
}

export type V1InspectorLeadCreateData = object;

export interface V1RemediationOrdersAllListParams {
  status?: string;
  s?: string;
  p?: number;
  q?: number;
}

export interface V1RemediationOrdersAllListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetRemediationPdfAllResponseDto;
  [key: string]: any;
}

export interface V1RemediationOrdersActiveListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetRemediationPdfActiveOrderResponseDto;
  [key: string]: any;
}

export interface V1RemediationOrdersStatusesListParams {
  ids?: string;
}

export interface V1RemediationOrdersStatusesListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetRemediationPdfStatusesResponseDto[];
  [key: string]: any;
}

export interface V1RemediationOrdersFilesFiltersListParams {
  sortingType?: string;
  sortingDirection?: string;
  site?: number;
  status?: string;
  uploaded?: boolean;
  remediated?: boolean;
  p?: number;
  q?: number;
}

export interface V1RemediationOrdersFilesFiltersListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RemediationFilesFiltersResponseDto;
  [key: string]: any;
}

export interface V1RemediationOrdersFilesFiltersCountsListParams {
  site?: number;
}

export interface V1RemediationOrdersFilesFiltersCountsListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RemediationFilesFiltersCountResponseDto;
  [key: string]: any;
}

export interface V1RemediationOrdersFilesCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: ApiCodeResponse;
  [key: string]: any;
}

export interface V1RemediationOrdersFilesScheduledDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RemediationFilesScheduleResponseDto;
  [key: string]: any;
}

export interface V1RemediationOrdersFilesCountCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RemediationFilesCountResponseDto;
  [key: string]: any;
}

export interface V1RemediationOrdersRemediationPdfsDetailParams {
  statuses?: string[];
  /** Parameter 'siteId' */
  siteId: string;
}

export interface V1RemediationOrdersRemediationPdfsDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetRemediationPdfResponseDto;
  [key: string]: any;
}

export type V1AccountSiteCreateConfigCreateData = object;

export interface V1SiteAccessibilityStatementsDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: SiteAccessibilityStatement;
  [key: string]: any;
}

export interface V1SiteAccessibilityStatementsCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: SiteAccessibilityStatement;
  [key: string]: any;
}

export interface ServicesUserServicesListParams {
  siteId?: string;
}

export interface ServicesUserServicesListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetUserServicesResponseDto;
  [key: string]: any;
}

export interface ServicesEnableTrialCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: EnableTrialResponseDto;
  [key: string]: any;
}

export interface UsersInfoWidgetListParams {
  code?: string;
}

export interface UsersInfoWidgetListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: WidgetInfoResponseDto;
  [key: string]: any;
}

export interface UsersSignupCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: UserRegistrationResponseDto;
  [key: string]: any;
}

export interface UsersSafeRegistrationCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RegistrationRouteResponseDto;
  [key: string]: any;
}

export interface UsersLaRegistrationCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RegistrationRouteResponseDto;
  [key: string]: any;
}

export interface UsersRegistrationCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: RegistrationRouteResponseDto;
  [key: string]: any;
}

export interface UsersStatementGeneratorCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: StatementGeneratorResponseDto;
  [key: string]: any;
}

export interface UsersWhitepaperSignupCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: WhitepaperRegistrationResponseDto;
  [key: string]: any;
}

export interface UsersEnterpriseSignupCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: EnterpriseRegistrationResponseDto;
  [key: string]: any;
}

export interface UsersWebinarFeedbackCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: WebinarFeedbackRequestResponseDto;
  [key: string]: any;
}

export interface UsersWebsummitSignupCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: WebsummitRegistrationResponseDto;
  [key: string]: any;
}

export interface UsersScannerSlgCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: ScannerSlgResponseDto;
  [key: string]: any;
}

export interface UsersLetsTalkSlgCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: LetsTalkSlgResponseDto;
  [key: string]: any;
}

export type TuningsResetDetailData = object;

export interface TuningsCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: PostTuningsResponseDto;
  [key: string]: any;
}

export interface TuningsUpdatePersiteCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: UpdateTuningsPersiteResponseDto;
  [key: string]: any;
}

export interface TuningsUpdatePersitePaidCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: UpdatePaidPersiteTuningsResponseDto;
  [key: string]: any;
}

export interface SitesDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetSiteResponseDto;
  [key: string]: any;
}

export interface AdminBankTransfersCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: CreateBankTransferResponseDto;
  [key: string]: any;
}

export type StatementTxtCreateData = string;

export type StatementHtmlCreateData = string;

export interface AuthLoginWidgetCreateData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: LoginWidgetResponseDto;
  [key: string]: any;
}

export type RemediationPerSiteUpdateScriptWithSecretKeyCreateData = object;

export interface RemediationTranslateQuotaListParams {
  siteId?: string;
}

export interface RemediationTranslateQuotaListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetLiveTranslationQuotaResponseDto;
  [key: string]: any;
}

export interface RemediationTranslateOverridesCsvDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetLiveTranslationOverridesResponseDto;
  [key: string]: any;
}

export interface RemediationTranslateNoTranslatesSelectorsDetailData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: GetLiveTranslationNoTranslatesResponseDto;
  [key: string]: any;
}

export interface RemediationTranslateNoTranslatesWordsDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: GetLiveTranslationIgnoredWordsResponseDto;
}

export interface RemediationTranslateNoTranslatesWordsCreateData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: CreateLiveTranslationIgnoredWordsResponseDto;
}

export type RemediationPdfCreateData = object;

export interface IntercomUserDetailsListData {
  /**
   * @default 200
   * @example 200
   */
  code?: number;
  data?: UserIntercomDetails;
  [key: string]: any;
}

export type AbnEventsCreateData = object;

export type AbnWidgetAdmCreateData = object;

export type AbnManageAdmCreateData = object;

export type AbnInspectorCreateData = object;

export type AbnScannerCreateData = object;

export interface AbnStatusPageDetailData {
  /** @example "SomeClassDto" */
  payloadType?: string;
  payload?: PageContribStatusDto;
}

import type {AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({securityWorker, secure, format, ...axiosConfig}: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({...axiosConfig, baseURL: axiosConfig.baseURL || 'http://localhost'});
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? {'Content-Type': type} : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title UserWay API
 * @version 1.0.0
 * @license Proprietary (https://userway.org/)
 * @baseUrl http://localhost
 * @contact UserWay (https://userway.org/)
 *
 * UserWay API
 */
export class UserWayApiClient<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UwV2ScannerSignupCreate
     * @request POST:/api/uw/v2/scanner/signup
     * @secure
     */
    uwV2ScannerSignupCreate: (data: ScannerSignUpBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2ScannerSignupCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/scanner/signup`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UwV2AuthLoginWidgetCreate
     * @request POST:/api/uw/v2/auth/login-widget
     * @secure
     */
    uwV2AuthLoginWidgetCreate: (data: WidgetSignInDto, params: RequestParams = {}) =>
      this.request<
        UwV2AuthLoginWidgetCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/auth/login-widget`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UwV2AuthGeneralSignupCreate
     * @request POST:/api/uw/v2/auth/general/signup
     * @secure
     */
    uwV2AuthGeneralSignupCreate: (data: GeneralSignUpDto, params: RequestParams = {}) =>
      this.request<
        UwV2AuthGeneralSignupCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/auth/general/signup`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name V1AffiliateEverflowAffiliateSignupCreate
     * @request POST:/api/v1/affiliate/everflow-affiliate-signup
     * @secure
     */
    v1AffiliateEverflowAffiliateSignupCreate: (data: EverflowAffiliateSignupBodyDto, params: RequestParams = {}) =>
      this.request<
        EverflowAffiliateSignupResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/affiliate/everflow-affiliate-signup`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UsersSignupCreate
     * @request POST:/api/users/signup
     * @secure
     */
    usersSignupCreate: (data: UserRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersSignupCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/signup`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UsersSafeRegistrationCreate
     * @request POST:/api/users/safe-registration
     * @secure
     */
    usersSafeRegistrationCreate: (data: UserSafeRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersSafeRegistrationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/safe-registration`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UsersLaRegistrationCreate
     * @request POST:/api/users/la-registration
     * @secure
     */
    usersLaRegistrationCreate: (data: LAUserRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersLaRegistrationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/la-registration`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UsersRegistrationCreate
     * @request POST:/api/users/registration
     * @secure
     */
    usersRegistrationCreate: (data: UserSafeRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersRegistrationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/registration`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UsersWhitepaperSignupCreate
     * @request POST:/api/users/whitepaper-signup
     * @secure
     */
    usersWhitepaperSignupCreate: (data: WhitepaperRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersWhitepaperSignupCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/whitepaper-signup`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name UsersEnterpriseSignupCreate
     * @request POST:/api/users/enterprise-signup
     * @secure
     */
    usersEnterpriseSignupCreate: (data: EnterpriseRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersEnterpriseSignupCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/enterprise-signup`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name AuthLoginWidgetCreate
     * @request POST:/api/auth/login-widget
     * @secure
     */
    authLoginWidgetCreate: (data: LoginWidgetBodyDto, params: RequestParams = {}) =>
      this.request<
        AuthLoginWidgetCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/auth/login-widget`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name AuthLoginCreate
     * @request POST:/api/auth/login
     * @secure
     */
    authLoginCreate: (data: LoginBodyDto, params: RequestParams = {}) =>
      this.request<
        RegistrationUserResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/auth/login`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN, SALES, AUTHOR
     *
     * @tags AUTH
     * @name AuthResetPasswordCreate
     * @request POST:/api/auth/{id}/resetPassword
     * @secure
     */
    authResetPasswordCreate: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/auth/${id}/resetPassword`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name AuthProfilePasswordUpdate
     * @request PUT:/api/auth/profile/password
     * @secure
     */
    authProfilePasswordUpdate: (data: ChangePasswordBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/auth/profile/password`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name AuthForgotCreate
     * @request POST:/api/auth/forgot
     * @secure
     */
    authForgotCreate: (data: ForgotPasswordBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/auth/forgot`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AUTH
     * @name AuthRecoveryCreate
     * @request POST:/api/auth/recovery
     * @secure
     */
    authRecoveryCreate: (data: RecoveryRequestBodyDto, params: RequestParams = {}) =>
      this.request<
        RecoveryRequestResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/auth/recovery`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  sites = {
    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name UwV2ExposedSitesVisibilityCreate
     * @request POST:/api/uw/v2/exposed/sites/{id}/visibility
     * @secure
     */
    uwV2ExposedSitesVisibilityCreate: (id: string, data: ToggleWidgetVisibilityDto, params: RequestParams = {}) =>
      this.request<
        UwV2ExposedSitesVisibilityCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/sites/${id}/visibility`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name UwV2ExposedSitesCreate
     * @request POST:/api/uw/v2/exposed/sites
     * @secure
     */
    uwV2ExposedSitesCreate: (data: CreateSiteDto, params: RequestParams = {}) =>
      this.request<
        UwV2ExposedSitesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/sites`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name UwV2SitesSearchList
     * @request GET:/api/uw/v2/sites/search
     * @secure
     */
    uwV2SitesSearchList: (query: UwV2SitesSearchListParams, params: RequestParams = {}) =>
      this.request<
        UwV2SitesSearchListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/sites/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name UwV2SitesSearchCreate
     * @request POST:/api/uw/v2/sites/search
     * @secure
     */
    uwV2SitesSearchCreate: (
      query: UwV2SitesSearchCreateParams,
      data: PostSitesBodyParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2SitesSearchCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/sites/search`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name UwV2SitesRemediationHelpersUpdate
     * @request PUT:/api/uw/v2/sites/{siteId}/remediation-helpers
     * @secure
     */
    uwV2SitesRemediationHelpersUpdate: (siteId: string, data: UpdateRemediationHelperDto, params: RequestParams = {}) =>
      this.request<
        UwV2SitesRemediationHelpersUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/sites/${siteId}/remediation-helpers`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesAddCreate
     * @request POST:/api/v1/sites/add
     * @secure
     */
    v1SitesAddCreate: (data: AddSiteBodyDto, params: RequestParams = {}) =>
      this.request<
        AddSiteResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/add`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesAddBatchCreate
     * @request POST:/api/v1/sites/add-batch
     * @secure
     */
    v1SitesAddBatchCreate: (data: AddSiteBodyDto, params: RequestParams = {}) =>
      this.request<
        AddBatchSitesResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/add-batch`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesListOfSitesCsvList
     * @request GET:/api/v1/sites/list-of-sites-csv
     * @secure
     */
    v1SitesListOfSitesCsvList: (query: V1SitesListOfSitesCsvListParams, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/list-of-sites-csv`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesSplSearchList
     * @request GET:/api/v1/sites/spl-search
     * @secure
     */
    v1SitesSplSearchList: (query: V1SitesSplSearchListParams, params: RequestParams = {}) =>
      this.request<
        SearchUserSitesResult,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/spl-search`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesPendingRemoveCreate
     * @request POST:/api/v1/sites/pending/remove
     * @secure
     */
    v1SitesPendingRemoveCreate: (data: ChangePendingSiteBodyDto, params: RequestParams = {}) =>
      this.request<
        V1SitesPendingRemoveCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/pending/remove`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesPendingToActiveCreate
     * @request POST:/api/v1/sites/pending/to-active
     * @secure
     */
    v1SitesPendingToActiveCreate: (data: ChangePendingSiteBodyDto, params: RequestParams = {}) =>
      this.request<
        MakeSiteActiveResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/pending/to-active`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesExistsCreate
     * @request POST:/api/v1/sites/exists
     * @secure
     */
    v1SitesExistsCreate: (data: GetSiteExistsBodyDto, params: RequestParams = {}) =>
      this.request<
        V1SitesExistsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/exists`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name V1SitesExistsBatchCreate
     * @request POST:/api/v1/sites/exists-batch
     * @secure
     */
    v1SitesExistsBatchCreate: (data: GetSitesExistBodyDto, params: RequestParams = {}) =>
      this.request<
        V1SitesExistsBatchCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/sites/exists-batch`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name SitesToggleWidgetCreate
     * @request POST:/api/sites/toggle-widget/{id}
     * @secure
     */
    sitesToggleWidgetCreate: (id: string, data: SiteToggleRequestDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/sites/toggle-widget/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name SitesRemoveCreate
     * @request POST:/api/sites/remove/{id}
     * @secure
     */
    sitesRemoveCreate: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/sites/remove/${id}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SITES
     * @name SitesRestoreCreate
     * @request POST:/api/sites/restore/{id}
     * @secure
     */
    sitesRestoreCreate: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/sites/restore/${id}`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  agency = {
    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySitesEnableProductCreate
     * @request POST:/api/uw/v2/exposed/agency/sites/{id}/enable-product
     * @secure
     */
    uwV2ExposedAgencySitesEnableProductCreate: (
      id: string,
      data: ToggleAgencySiteProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySitesEnableProductCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/sites/${id}/enable-product`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySitesDisableProductCreate
     * @request POST:/api/uw/v2/exposed/agency/sites/{id}/disable-product
     * @secure
     */
    uwV2ExposedAgencySitesDisableProductCreate: (
      id: string,
      data: ToggleAgencySiteProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySitesDisableProductCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/sites/${id}/disable-product`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencyUsersStatsList
     * @request GET:/api/uw/v2/exposed/agency/users/stats
     * @secure
     */
    uwV2ExposedAgencyUsersStatsList: (params: RequestParams = {}) =>
      this.request<
        UwV2ExposedAgencyUsersStatsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/users/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySubscriptionsSitesBillingDetail
     * @request GET:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/sites/{siteId}/billing
     * @secure
     */
    uwV2ExposedAgencySubscriptionsSitesBillingDetail: (
      agencySubscriptionId: string,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsSitesBillingDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/sites/${siteId}/billing`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySubscriptionsSitesEnableCreate
     * @request POST:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/sites/{siteId}/enable
     * @secure
     */
    uwV2ExposedAgencySubscriptionsSitesEnableCreate: (
      agencySubscriptionId: string,
      siteId: string,
      data: AgencySiteEnableProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsSitesEnableCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/sites/${siteId}/enable`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySubscriptionsSitesTransferCreate
     * @request POST:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/sites/transfer
     * @secure
     */
    uwV2ExposedAgencySubscriptionsSitesTransferCreate: (
      agencySubscriptionId: string,
      data: AgencyTransferProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsSitesTransferCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/sites/transfer`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySubscriptionsSitesDisableCreate
     * @request POST:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/sites/{siteId}/disable
     * @secure
     */
    uwV2ExposedAgencySubscriptionsSitesDisableCreate: (
      agencySubscriptionId: string,
      siteId: string,
      data: AgencySiteDisableProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsSitesDisableCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/sites/${siteId}/disable`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySubscriptionsSitesAddBatchCreate
     * @request POST:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/sites/add-batch
     * @secure
     */
    uwV2ExposedAgencySubscriptionsSitesAddBatchCreate: (
      agencySubscriptionId: string,
      data: AgencySiteDisableProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsSitesAddBatchCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/sites/add-batch`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2ExposedAgencySubscriptionsSitesDisableBatchCreate
     * @request POST:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/sites/disable-batch
     * @secure
     */
    uwV2ExposedAgencySubscriptionsSitesDisableBatchCreate: (
      agencySubscriptionId: string,
      data: AgencySiteDisableProductDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsSitesDisableBatchCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/sites/disable-batch`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY, ACCOUNTS
     * @name UwV2ExposedAgencyAccountsContextDetail
     * @request GET:/api/uw/v2/exposed/agency/accounts/{userId}/context
     * @secure
     */
    uwV2ExposedAgencyAccountsContextDetail: (userId: string, params: RequestParams = {}) =>
      this.request<
        UwV2ExposedAgencyAccountsContextDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/accounts/${userId}/context`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags AGENCY
     * @name UwV2AgencyAccountManagerList
     * @request GET:/api/uw/v2/agency/account-manager
     * @secure
     */
    uwV2AgencyAccountManagerList: (params: RequestParams = {}) =>
      this.request<
        GetAccountManagerResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/agency/account-manager`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  users = {
    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UwV2ExposedUsersCreate
     * @request POST:/api/uw/v2/exposed/users
     * @secure
     */
    uwV2ExposedUsersCreate: (data: CreateChildUserAndSiteDto, params: RequestParams = {}) =>
      this.request<
        UwV2ExposedUsersCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/users`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name V1UsersSendWidgetInstallationDetailsCreate
     * @request POST:/api/v1/users/send-widget-installation-details
     * @secure
     */
    v1UsersSendWidgetInstallationDetailsCreate: (data: SendWidgetInstallDetailsBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/users/send-widget-installation-details`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name V1UsersAccountCodeBySiteCreate
     * @request POST:/api/v1/users/account-code-by-site
     * @secure
     */
    v1UsersAccountCodeBySiteCreate: (data: GetAccountCodeBySiteBodyDto, params: RequestParams = {}) =>
      this.request<
        GetAccountCodeBySiteResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/users/account-code-by-site`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name V1UsersAccountByEmailCreate
     * @request POST:/api/v1/users/account-by-email
     * @secure
     */
    v1UsersAccountByEmailCreate: (data: GetAccountByEmailBodyDto, params: RequestParams = {}) =>
      this.request<
        GetAccountByEmailResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/users/account-by-email`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name V1UsersSubscriptionsList
     * @request GET:/api/v1/users/subscriptions
     * @secure
     */
    v1UsersSubscriptionsList: (query: V1UsersSubscriptionsListParams, params: RequestParams = {}) =>
      this.request<
        V1UsersSubscriptionsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/users/subscriptions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name V1UsersSubscriptionsDetail
     * @request GET:/api/v1/users/subscriptions/{orderId}
     * @secure
     */
    v1UsersSubscriptionsDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<
        V1UsersSubscriptionsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/users/subscriptions/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name V1UsersSubscriptionsEstimateCreate
     * @request POST:/api/v1/users/subscriptions/estimate
     * @secure
     */
    v1UsersSubscriptionsEstimateCreate: (params: RequestParams = {}) =>
      this.request<
        V1UsersSubscriptionsEstimateCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/users/subscriptions/estimate`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersInfoWidgetList
     * @request GET:/api/users/info-widget
     * @secure
     */
    usersInfoWidgetList: (query: UsersInfoWidgetListParams, params: RequestParams = {}) =>
      this.request<
        UsersInfoWidgetListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/info-widget`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersNcTrialWelcomeScreenShownCreate
     * @request POST:/api/users/nc-trial-welcome-screen-shown
     * @secure
     */
    usersNcTrialWelcomeScreenShownCreate: (params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/nc-trial-welcome-screen-shown`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersWalkthroughStatusCreate
     * @request POST:/api/users/walkthrough-status
     * @secure
     */
    usersWalkthroughStatusCreate: (data: UpdateWalkthroughStatusBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/walkthrough-status`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersPdfRequestCreate
     * @request POST:/api/users/pdf-request
     * @secure
     */
    usersPdfRequestCreate: (data: UserPdfRequestBodyDto, params: RequestParams = {}) =>
      this.request<
        UserPdfRequestResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/pdf-request`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersDemoRequestCreate
     * @request POST:/api/users/demo-request
     * @secure
     */
    usersDemoRequestCreate: (data: UserDemoRequestBodyDto, params: RequestParams = {}) =>
      this.request<
        UserDemoRequestResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/demo-request`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersDemoRequestShortCreate
     * @request POST:/api/users/demo-request-short
     * @secure
     */
    usersDemoRequestShortCreate: (data: UserShortDemoRequestBodyDto, params: RequestParams = {}) =>
      this.request<
        UserShortDemoRequestResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/demo-request-short`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersWebinarFeedbackCreate
     * @request POST:/api/users/webinar-feedback
     * @secure
     */
    usersWebinarFeedbackCreate: (data: WebinarFeedbackRequestBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersWebinarFeedbackCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/webinar-feedback`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersWebsummitSignupCreate
     * @request POST:/api/users/websummit-signup
     * @secure
     */
    usersWebsummitSignupCreate: (data: WebsummitRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersWebsummitSignupCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/websummit-signup`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersCallMeBackCreate
     * @request POST:/api/users/call-me-back
     * @secure
     */
    usersCallMeBackCreate: (data: CallMeBackBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/call-me-back`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersAffiliateMeetingCreate
     * @request POST:/api/users/affiliate-meeting
     * @secure
     */
    usersAffiliateMeetingCreate: (data: AffiliateMeetingBodyDto, params: RequestParams = {}) =>
      this.request<
        AffiliateMeetingResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/affiliate-meeting`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersCodeToDevCreate
     * @request POST:/api/users/code-to-dev
     * @secure
     */
    usersCodeToDevCreate: (data: CodeToDevBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/code-to-dev`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersLinkedinOutreachCreate
     * @request POST:/api/users/linkedin-outreach
     * @secure
     */
    usersLinkedinOutreachCreate: (data: LinkedInOutreachBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/linkedin-outreach`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersScannerSlgCreate
     * @request POST:/api/users/scanner-slg
     * @secure
     */
    usersScannerSlgCreate: (data: ScannerSlgBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersScannerSlgCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/scanner-slg`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersLetsTalkSlgCreate
     * @request POST:/api/users/lets-talk-slg
     * @secure
     */
    usersLetsTalkSlgCreate: (data: LetsTalkSlgBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersLetsTalkSlgCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/lets-talk-slg`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags USERS
     * @name UsersChangeEmailCreate
     * @request POST:/api/users/changeEmail
     * @secure
     */
    usersChangeEmailCreate: (data: UserChangeEmailBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/changeEmail`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  subscriptions = {
    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name UwV2ExposedAgencySubscriptionsNamePartialUpdate
     * @request PATCH:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/name
     * @secure
     */
    uwV2ExposedAgencySubscriptionsNamePartialUpdate: (
      agencySubscriptionId: string,
      data: AgencySubscriptionUpdateNameDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsNamePartialUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/name`,
        method: 'PATCH',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name UwV2ExposedAgencySubscriptionsPaymentDataPartialUpdate
     * @request PATCH:/api/uw/v2/exposed/agency/subscriptions/{agencySubscriptionId}/payment-data
     * @secure
     */
    uwV2ExposedAgencySubscriptionsPaymentDataPartialUpdate: (
      agencySubscriptionId: string,
      data: AgencySubscriptionUpdatePaymentData,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencySubscriptionsPaymentDataPartialUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/subscriptions/${agencySubscriptionId}/payment-data`,
        method: 'PATCH',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): MASTER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeTSubscriptionDetail
     * @request GET:/api/v1/billing/stripeT/subscription/{id}
     * @secure
     */
    v1BillingStripeTSubscriptionDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTSubscriptionDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/subscription/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeTSubscriptionCreate
     * @request POST:/api/v1/billing/stripeT/subscription
     * @secure
     */
    v1BillingStripeTSubscriptionCreate: (data: CreateSubscriptionBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTSubscriptionCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/subscription`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeTSubscriptionRetryInvoiceCreate
     * @request POST:/api/v1/billing/stripeT/subscription/retry-invoice
     * @secure
     */
    v1BillingStripeTSubscriptionRetryInvoiceCreate: (data: RetryInvoiceBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTSubscriptionRetryInvoiceCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/subscription/retry-invoice`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeTSubscriptionConfirmInvoiceCreate
     * @request POST:/api/v1/billing/stripeT/subscription/confirm-invoice
     * @secure
     */
    v1BillingStripeTSubscriptionConfirmInvoiceCreate: (data: ConfirmInvoiceBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTSubscriptionConfirmInvoiceCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/subscription/confirm-invoice`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeSubscriptionSwitchToAnnualCreate
     * @request POST:/api/v1/billing/stripe/subscription/switch-to-annual/{subscriptionId}
     * @secure
     */
    v1BillingStripeSubscriptionSwitchToAnnualCreate: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeSubscriptionSwitchToAnnualCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripe/subscription/switch-to-annual/${subscriptionId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeSubscriptionPayOnTrialCreate
     * @request POST:/api/v1/billing/stripe/subscription/pay-on-trial/{subscriptionId}
     * @secure
     */
    v1BillingStripeSubscriptionPayOnTrialCreate: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeSubscriptionPayOnTrialCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripe/subscription/pay-on-trial/${subscriptionId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeTSubscriptionUpgradeRemediationCreate
     * @request POST:/api/v1/billing/stripeT/subscription/upgrade-remediation
     * @secure
     */
    v1BillingStripeTSubscriptionUpgradeRemediationCreate: (data: UpgradeRemediationBody, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTSubscriptionUpgradeRemediationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/subscription/upgrade-remediation`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SUBSCRIPTIONS
     * @name V1BillingStripeTSubscriptionUpgradeCreate
     * @request POST:/api/v1/billing/stripeT/subscription/{subscriptionId}/upgrade
     * @secure
     */
    v1BillingStripeTSubscriptionUpgradeCreate: (
      subscriptionId: string,
      data: UpgradeSubscriptionBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTSubscriptionUpgradeCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/subscription/${subscriptionId}/upgrade`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  accounts = {
    /**
     * @description Requires role(s): USER
     *
     * @tags ACCOUNTS
     * @name UwV2ExposedAgencyAccountsBillingDescriptorUpdate
     * @request PUT:/api/uw/v2/exposed/agency/accounts/{userId}/billing-descriptor
     * @secure
     */
    uwV2ExposedAgencyAccountsBillingDescriptorUpdate: (
      userId: string,
      data: AgencyAccountUpdateBillingDescriptorDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2ExposedAgencyAccountsBillingDescriptorUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/exposed/agency/accounts/${userId}/billing-descriptor`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ACCOUNTS
     * @name V1AccountSiteCreateConfigCreate
     * @request POST:/api/v1/account/site-create-config
     * @secure
     */
    v1AccountSiteCreateConfigCreate: (data: CreateSiteConfigBodyDto, params: RequestParams = {}) =>
      this.request<
        V1AccountSiteCreateConfigCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/account/site-create-config`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  access = {
    /**
     * @description Requires role(s): USER
     *
     * @tags ACCESS
     * @name UwV2AuthWidgetAccessDetail
     * @request GET:/api/uw/v2/auth/widget-access/{accountCode}
     * @secure
     */
    uwV2AuthWidgetAccessDetail: (accountCode: string, params: RequestParams = {}) =>
      this.request<
        UwV2AuthWidgetAccessDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/auth/widget-access/${accountCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ACCESS
     * @name UwV2UnitManagementDashboardAccessDetail
     * @request GET:/api/uw/v2/unit-management/dashboard-access/{unitId}
     * @secure
     */
    uwV2UnitManagementDashboardAccessDetail: (unitId: string, params: RequestParams = {}) =>
      this.request<
        UwV2UnitManagementDashboardAccessDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/unit-management/dashboard-access/${unitId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  misc = {
    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2SmartFormsCompanyInfoCreate
     * @request POST:/api/uw/v2/smart-forms/company-info
     * @secure
     */
    uwV2SmartFormsCompanyInfoCreate: (data: SmartFormRequestDto, params: RequestParams = {}) =>
      this.request<
        UwV2SmartFormsCompanyInfoCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/smart-forms/company-info`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2BrandAssetsTrackCreate
     * @request POST:/api/uw/v2/brand-assets/track
     * @secure
     */
    uwV2BrandAssetsTrackCreate: (data: PostTrackBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2BrandAssetsTrackCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/brand-assets/track`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2TrackingNewslettersCreate
     * @request POST:/api/uw/v2/tracking/newsletters
     * @secure
     */
    uwV2TrackingNewslettersCreate: (data: PostNewslettersBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2TrackingNewslettersCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/tracking/newsletters`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2TrackingRetentionsCreate
     * @request POST:/api/uw/v2/tracking/retentions
     * @secure
     */
    uwV2TrackingRetentionsCreate: (data: PostRetentionsBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2TrackingRetentionsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/tracking/retentions`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2TrackingLandingPagesCreate
     * @request POST:/api/uw/v2/tracking/landing-pages
     * @secure
     */
    uwV2TrackingLandingPagesCreate: (data: TrackLandingPageBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2TrackingLandingPagesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/tracking/landing-pages`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2TrackingSearchForCancellationCreate
     * @request POST:/api/uw/v2/tracking/search-for-cancellation
     * @secure
     */
    uwV2TrackingSearchForCancellationCreate: (params: RequestParams = {}) =>
      this.request<
        UwV2TrackingSearchForCancellationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/tracking/search-for-cancellation`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER | Summarizes given content of a page URL
     *
     * @tags MISC
     * @name UwV2PagesSummarizationCreate
     * @request POST:/api/uw/v2/pages-summarization
     * @secure
     */
    uwV2PagesSummarizationCreate: (data: SummarizeContentDto, params: RequestParams = {}) =>
      this.request<
        UwV2PagesSummarizationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pages-summarization`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name UwV2PagesSummarizationStreamCreate
     * @request POST:/api/uw/v2/pages-summarization/stream
     * @secure
     */
    uwV2PagesSummarizationStreamCreate: (data: SummarizeContentDto, params: RequestParams = {}) =>
      this.request<
        UwV2PagesSummarizationStreamCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pages-summarization/stream`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name V1HelperTrafficCreate
     * @request POST:/api/v1/helper/traffic
     * @secure
     */
    v1HelperTrafficCreate: (data: GetSiteTrafficStatsBodyDto, params: RequestParams = {}) =>
      this.request<
        GetSiteTrafficStatsResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/helper/traffic`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name V1InspectorLeadCreate
     * @request POST:/api/v1/inspector/lead
     * @secure
     */
    v1InspectorLeadCreate: (data: CreateInspectorLeadBodyDto, params: RequestParams = {}) =>
      this.request<
        V1InspectorLeadCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/inspector/lead`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name IntercomUserDetailsList
     * @request GET:/api/intercom/user-details
     * @secure
     */
    intercomUserDetailsList: (params: RequestParams = {}) =>
      this.request<
        IntercomUserDetailsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/intercom/user-details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name AbnEventsCreate
     * @request POST:/api/abn/events
     * @secure
     */
    abnEventsCreate: (data: AddEventsBodyDto, params: RequestParams = {}) =>
      this.request<
        AbnEventsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/abn/events`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name AbnWidgetAdmCreate
     * @request POST:/api/abn/widget-adm
     * @secure
     */
    abnWidgetAdmCreate: (data: AddEventsBodyDto, params: RequestParams = {}) =>
      this.request<
        AbnWidgetAdmCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/abn/widget-adm`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name AbnManageAdmCreate
     * @request POST:/api/abn/manage-adm
     * @secure
     */
    abnManageAdmCreate: (data: AddEventsBodyDto, params: RequestParams = {}) =>
      this.request<
        AbnManageAdmCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/abn/manage-adm`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name AbnInspectorCreate
     * @request POST:/api/abn/inspector
     * @secure
     */
    abnInspectorCreate: (data: AddEventsBodyDto, params: RequestParams = {}) =>
      this.request<
        AbnInspectorCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/abn/inspector`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name AbnScannerCreate
     * @request POST:/api/abn/scanner
     * @secure
     */
    abnScannerCreate: (data: AddEventsBodyDto, params: RequestParams = {}) =>
      this.request<
        AbnScannerCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/abn/scanner`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags MISC
     * @name AbnStatusPageDetail
     * @request GET:/api/abn/status/page/{url}
     * @secure
     */
    abnStatusPageDetail: (url: string, params: RequestParams = {}) =>
      this.request<
        AbnStatusPageDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/abn/status/page/${url}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  stripe = {
    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripeHelperProductsCreate
     * @request POST:/api/uw/v2/billing/stripe/helper/products
     * @secure
     */
    uwV2BillingStripeHelperProductsCreate: (
      query: UwV2BillingStripeHelperProductsCreateParams,
      data: GetHelperProductsBody,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingStripeHelperProductsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/helper/products`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsCreate
     * @request POST:/api/uw/v2/billing/stripe/payment-methods
     * @secure
     */
    uwV2BillingStripePaymentMethodsCreate: (data: PaymentMethodCreateBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2BillingStripePaymentMethodsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsList
     * @request GET:/api/uw/v2/billing/stripe/payment-methods
     * @secure
     */
    uwV2BillingStripePaymentMethodsList: (params: RequestParams = {}) =>
      this.request<
        UwV2BillingStripePaymentMethodsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsDefaultList
     * @request GET:/api/uw/v2/billing/stripe/payment-methods/default
     * @secure
     */
    uwV2BillingStripePaymentMethodsDefaultList: (params: RequestParams = {}) =>
      this.request<
        UwV2BillingStripePaymentMethodsDefaultListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsUpdate
     * @request PUT:/api/uw/v2/billing/stripe/payment-methods/{paymentDataId}
     * @secure
     */
    uwV2BillingStripePaymentMethodsUpdate: (
      paymentDataId: string,
      data: PaymentMethodUpdateBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingStripePaymentMethodsUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/${paymentDataId}`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsDelete
     * @request DELETE:/api/uw/v2/billing/stripe/payment-methods/{paymentDataId}
     * @secure
     */
    uwV2BillingStripePaymentMethodsDelete: (paymentDataId: string, params: RequestParams = {}) =>
      this.request<
        UwV2BillingStripePaymentMethodsDeleteData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/${paymentDataId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsSubscriptionsDetail
     * @request GET:/api/uw/v2/billing/stripe/payment-methods/{paymentDataId}/subscriptions
     * @secure
     */
    uwV2BillingStripePaymentMethodsSubscriptionsDetail: (
      {paymentDataId, ...query}: UwV2BillingStripePaymentMethodsSubscriptionsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingStripePaymentMethodsSubscriptionsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/${paymentDataId}/subscriptions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsIsDefaultUpdate
     * @request PUT:/api/uw/v2/billing/stripe/payment-methods/{paymentDataId}/is-default
     * @secure
     */
    uwV2BillingStripePaymentMethodsIsDefaultUpdate: (paymentDataId: string, params: RequestParams = {}) =>
      this.request<
        UwV2BillingStripePaymentMethodsIsDefaultUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/${paymentDataId}/is-default`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsSubscriptionsDetail2
     * @request GET:/api/uw/v2/billing/stripe/payment-methods/subscriptions/{subscriptionId}
     * @originalName uwV2BillingStripePaymentMethodsSubscriptionsDetail
     * @duplicate
     * @secure
     */
    uwV2BillingStripePaymentMethodsSubscriptionsDetail2: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<
        UwV2BillingStripePaymentMethodsSubscriptionsDetail2Data,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/subscriptions/${subscriptionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingStripePaymentMethodsCheckAddressCreate
     * @request POST:/api/uw/v2/billing/stripe/payment-methods/check-address
     * @secure
     */
    uwV2BillingStripePaymentMethodsCheckAddressCreate: (
      data: CheckPaymentMethodAddressBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingStripePaymentMethodsCheckAddressCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/stripe/payment-methods/check-address`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingSubscriptionsList
     * @request GET:/api/uw/v2/billing/subscriptions
     * @secure
     */
    uwV2BillingSubscriptionsList: (query: UwV2BillingSubscriptionsListParams, params: RequestParams = {}) =>
      this.request<
        UwV2BillingSubscriptionsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name UwV2BillingSubscriptionsSubscriptionIdList
     * @request GET:/api/uw/v2/billing/subscriptions/:subscriptionId
     * @secure
     */
    uwV2BillingSubscriptionsSubscriptionIdList: (
      {subscriptionId, ...query}: UwV2BillingSubscriptionsSubscriptionIdListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingSubscriptionsSubscriptionIdListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/${subscriptionId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTCustomerList
     * @request GET:/api/v1/billing/stripeT/customer
     * @secure
     */
    v1BillingStripeTCustomerList: (params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTCustomerListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/customer`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTPaymentMethodDefaultList
     * @request GET:/api/v1/billing/stripeT/payment-method/default
     * @secure
     */
    v1BillingStripeTPaymentMethodDefaultList: (params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTPaymentMethodDefaultListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/payment-method/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTPaymentMethodDeleteCreate
     * @request POST:/api/v1/billing/stripeT/payment-method/delete
     * @secure
     */
    v1BillingStripeTPaymentMethodDeleteCreate: (data: DeletePaymentMethodBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTPaymentMethodDeleteCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/payment-method/delete`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTPaymentMethodCreateCreate
     * @request POST:/api/v1/billing/stripeT/payment-method/create
     * @secure
     */
    v1BillingStripeTPaymentMethodCreateCreate: (data: CreatePaymentMethodBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTPaymentMethodCreateCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/payment-method/create`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTCartCalculateSwitchPlanCreate
     * @request POST:/api/v1/billing/stripeT/cart/calculate-switch-plan
     * @secure
     */
    v1BillingStripeTCartCalculateSwitchPlanCreate: (
      query: V1BillingStripeTCartCalculateSwitchPlanCreateParams,
      data: CalculateSwitchPlanBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTCartCalculateSwitchPlanCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/cart/calculate-switch-plan`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTCartCalculateCreate
     * @request POST:/api/v1/billing/stripeT/cart/calculate
     * @secure
     */
    v1BillingStripeTCartCalculateCreate: (
      query: V1BillingStripeTCartCalculateCreateParams,
      data: CalculateCartBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTCartCalculateCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/cart/calculate`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTCartTrialPayNowCreate
     * @request POST:/api/v1/billing/stripeT/cart/trial-pay-now
     * @secure
     */
    v1BillingStripeTCartTrialPayNowCreate: (
      query: V1BillingStripeTCartTrialPayNowCreateParams,
      data: CalculateCartTrialPayNowBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTCartTrialPayNowCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/cart/trial-pay-now`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTCartCalculateRemediationUpgradeCreate
     * @request POST:/api/v1/billing/stripeT/cart/calculate-remediation-upgrade
     * @secure
     */
    v1BillingStripeTCartCalculateRemediationUpgradeCreate: (
      query: V1BillingStripeTCartCalculateRemediationUpgradeCreateParams,
      data: CartRemediationUpgradeBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTCartCalculateRemediationUpgradeCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/cart/calculate-remediation-upgrade`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STRIPE
     * @name V1BillingStripeTCartCalculateSubscriptionUpgradeCreate
     * @request POST:/api/v1/billing/stripeT/cart/calculate-subscription-upgrade
     * @secure
     */
    v1BillingStripeTCartCalculateSubscriptionUpgradeCreate: (
      query: V1BillingStripeTCartCalculateSubscriptionUpgradeCreateParams,
      data: CalculateSubscriptionUpgradeBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTCartCalculateSubscriptionUpgradeCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/cart/calculate-subscription-upgrade`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  billing = {
    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingRetentionSupportCreate
     * @request POST:/api/uw/v2/billing/retention/support
     * @secure
     */
    uwV2BillingRetentionSupportCreate: (data: RetentionSupportPayload, params: RequestParams = {}) =>
      this.request<
        UwV2BillingRetentionSupportCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/retention/support`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingCustomPaymentsCreate
     * @request POST:/api/uw/v2/billing/custom-payments
     * @secure
     */
    uwV2BillingCustomPaymentsCreate: (data: CreateMultipleCustomPaymentsDto, params: RequestParams = {}) =>
      this.request<
        UwV2BillingCustomPaymentsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/custom-payments`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsCancelCreate
     * @request POST:/api/uw/v2/billing/subscriptions/{subscriptionId}/cancel
     * @secure
     */
    uwV2BillingSubscriptionsCancelCreate: (
      subscriptionId: string,
      data: CancelTrialSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingSubscriptionsCancelCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/${subscriptionId}/cancel`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsDowngradeCreate
     * @request POST:/api/uw/v2/billing/subscriptions/{subscriptionId}/downgrade
     * @secure
     */
    uwV2BillingSubscriptionsDowngradeCreate: (
      subscriptionId: string,
      data: DowngradeSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingSubscriptionsDowngradeCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/${subscriptionId}/downgrade`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsToggleAutoRenewCreate
     * @request POST:/api/uw/v2/billing/subscriptions/{subscriptionId}/toggle-auto-renew
     * @secure
     */
    uwV2BillingSubscriptionsToggleAutoRenewCreate: (
      subscriptionId: string,
      data: ToggleSubscriptionAutoRenewDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingSubscriptionsToggleAutoRenewCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/${subscriptionId}/toggle-auto-renew`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsNoCardTrialCreate
     * @request POST:/api/uw/v2/billing/subscriptions/no-card-trial
     * @secure
     */
    uwV2BillingSubscriptionsNoCardTrialCreate: (data: CreateNoCardTrialSubscriptionDto, params: RequestParams = {}) =>
      this.request<
        UwV2BillingSubscriptionsNoCardTrialCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/no-card-trial`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreate
     * @request POST:/api/uw/v2/billing/subscriptions/launch-nc-trial-subscription
     * @secure
     */
    uwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreate: (
      data: LaunchNoCardTrialSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingSubscriptionsLaunchNcTrialSubscriptionCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/launch-nc-trial-subscription`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsCreateAchSetupIntentCreate
     * @request POST:/api/uw/v2/billing/subscriptions/create-ach-setup-intent
     * @secure
     */
    uwV2BillingSubscriptionsCreateAchSetupIntentCreate: (params: RequestParams = {}) =>
      this.request<
        UwV2BillingSubscriptionsCreateAchSetupIntentCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/create-ach-setup-intent`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSubscriptionsLaunchQuoteSubscriptionCreate
     * @request POST:/api/uw/v2/billing/subscriptions/launch-quote-subscription
     * @secure
     */
    uwV2BillingSubscriptionsLaunchQuoteSubscriptionCreate: (
      data: LaunchQuoteSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingSubscriptionsLaunchQuoteSubscriptionCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/subscriptions/launch-quote-subscription`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingEmailsCreate
     * @request POST:/api/uw/v2/billing/emails
     * @secure
     */
    uwV2BillingEmailsCreate: (data: PostBillingEmailsDto, params: RequestParams = {}) =>
      this.request<
        UwV2BillingEmailsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/emails`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingEmailsList
     * @request GET:/api/uw/v2/billing/emails
     * @secure
     */
    uwV2BillingEmailsList: (origin: string, params: RequestParams = {}) =>
      this.request<
        UwV2BillingEmailsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/emails`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingCartCalculateAutoRenewCreate
     * @request POST:/api/uw/v2/billing/cart/calculate-auto-renew
     * @secure
     */
    uwV2BillingCartCalculateAutoRenewCreate: (data: CartCalculateSubscriptionAutoRenew, params: RequestParams = {}) =>
      this.request<
        UwV2BillingCartCalculateAutoRenewCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/cart/calculate-auto-renew`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingCartCalculateQuoteCreate
     * @request POST:/api/uw/v2/billing/cart/calculate-quote
     * @secure
     */
    uwV2BillingCartCalculateQuoteCreate: (data: CartCalculateQuoteTotalsDto, params: RequestParams = {}) =>
      this.request<
        UwV2BillingCartCalculateQuoteCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/cart/calculate-quote`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingCustomersCheckCouponList
     * @request GET:/api/uw/v2/billing/customers/check-coupon
     * @secure
     */
    uwV2BillingCustomersCheckCouponList: (
      {coupon, ...query}: UwV2BillingCustomersCheckCouponListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2BillingCustomersCheckCouponListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/customers/check-coupon`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name UwV2BillingSpecialPaymentsConfirmCreate
     * @request POST:/api/uw/v2/billing/special-payments/confirm
     * @secure
     */
    uwV2BillingSpecialPaymentsConfirmCreate: (data: ConfirmSpecialPaymentBody, params: RequestParams = {}) =>
      this.request<
        UwV2BillingSpecialPaymentsConfirmCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/billing/special-payments/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name V1BillingStripeTOneTimePaymentCardWalletList
     * @request GET:/api/v1/billing/stripeT/one-time-payment/card-wallet
     * @secure
     */
    v1BillingStripeTOneTimePaymentCardWalletList: (params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTOneTimePaymentCardWalletListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/one-time-payment/card-wallet`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name V1BillingStripeTOneTimePaymentCreatePaymentIntentCreate
     * @request POST:/api/v1/billing/stripeT/one-time-payment/create-payment-intent
     * @secure
     */
    v1BillingStripeTOneTimePaymentCreatePaymentIntentCreate: (
      data: OneTimeCreatePaymentIntentBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingStripeTOneTimePaymentCreatePaymentIntentCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/one-time-payment/create-payment-intent`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name V1BillingStripeOneTimePaymentChargeCreate
     * @request POST:/api/v1/billing/stripe/one-time-payment/charge
     * @secure
     */
    v1BillingStripeOneTimePaymentChargeCreate: (data: OneTimeChargeBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeOneTimePaymentChargeCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripe/one-time-payment/charge`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING
     * @name V1BillingStripeTOneTimePaymentInvoiceCreate
     * @request POST:/api/v1/billing/stripeT/one-time-payment/invoice
     * @secure
     */
    v1BillingStripeTOneTimePaymentInvoiceCreate: (data: CreateInvoiceBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingStripeTOneTimePaymentInvoiceCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/stripeT/one-time-payment/invoice`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING, SUBSCRIPTIONS
     * @name V1BillingSubscriptionsPayOnTrialCreate
     * @request POST:/api/v1/billing/subscriptions/pay-on-trial/{userServiceId}
     * @secure
     */
    v1BillingSubscriptionsPayOnTrialCreate: (userServiceId: string, params: RequestParams = {}) =>
      this.request<
        PayOnTrialResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/subscriptions/pay-on-trial/${userServiceId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags BILLING, SUBSCRIPTIONS
     * @name V1BillingSubscriptionsSwitchToAnnualCreate
     * @request POST:/api/v1/billing/subscriptions/switch-to-annual/{userServiceId}
     * @secure
     */
    v1BillingSubscriptionsSwitchToAnnualCreate: (userServiceId: string, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/subscriptions/switch-to-annual/${userServiceId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  openai = {
    /**
     * @description Requires role(s): USER
     *
     * @tags OPENAI
     * @name UwV2AiTextCompletionCreate
     * @request POST:/api/uw/v2/ai/text-completion
     * @secure
     */
    uwV2AiTextCompletionCreate: (data: GetTextCompletionDto, params: RequestParams = {}) =>
      this.request<
        UwV2AiTextCompletionCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/ai/text-completion`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags OPENAI
     * @name UwV2AiFmcChatCreate
     * @request POST:/api/uw/v2/ai/fmc/chat
     * @secure
     */
    uwV2AiFmcChatCreate: (data: GetFixMyCodeInstructionsDto, params: RequestParams = {}) =>
      this.request<
        UwV2AiFmcChatCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/ai/fmc/chat`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags OPENAI
     * @name UwV2AiFmcChatChatTitleCreate
     * @request POST:/api/uw/v2/ai/fmc/chat/chat-title
     * @secure
     */
    uwV2AiFmcChatChatTitleCreate: (data: GetFixMyCodeChatTitleDto, params: RequestParams = {}) =>
      this.request<
        UwV2AiFmcChatChatTitleCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/ai/fmc/chat/chat-title`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags OPENAI
     * @name UwV2AiFmcChatPromptPairVoteCreate
     * @request POST:/api/uw/v2/ai/fmc/chat/prompt-pair-vote
     * @secure
     */
    uwV2AiFmcChatPromptPairVoteCreate: (data: VoteReplyDto, params: RequestParams = {}) =>
      this.request<
        UwV2AiFmcChatPromptPairVoteCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/ai/fmc/chat/prompt-pair-vote`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags OPENAI
     * @name UwV2AiFmcChatEmailSubscriptionCreate
     * @request POST:/api/uw/v2/ai/fmc/chat/email-subscription
     * @secure
     */
    uwV2AiFmcChatEmailSubscriptionCreate: (data: GeneralFeedbackDto, params: RequestParams = {}) =>
      this.request<
        UwV2AiFmcChatEmailSubscriptionCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/ai/fmc/chat/email-subscription`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  a11YStatements = {
    /**
     * @description Requires role(s): USER
     *
     * @tags A11Y_STATEMENTS
     * @name UwV2AgencyA11YStatementsGenerateCreate
     * @request POST:/api/uw/v2/agency/a11y-statements/generate
     * @secure
     */
    uwV2AgencyA11YStatementsGenerateCreate: (data: GenerateAgencyA11YStatementDto, params: RequestParams = {}) =>
      this.request<
        UwV2AgencyA11YStatementsGenerateCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/agency/a11y-statements/generate`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags A11Y_STATEMENTS
     * @name V1SiteAccessibilityStatementsDetail
     * @request GET:/api/v1/site-accessibility-statements/{siteId}
     * @secure
     */
    v1SiteAccessibilityStatementsDetail: (siteId: string, params: RequestParams = {}) =>
      this.request<
        V1SiteAccessibilityStatementsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/site-accessibility-statements/${siteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags A11Y_STATEMENTS
     * @name V1SiteAccessibilityStatementsCreate
     * @request POST:/api/v1/site-accessibility-statements/{siteId}
     * @secure
     */
    v1SiteAccessibilityStatementsCreate: (siteId: string, params: RequestParams = {}) =>
      this.request<
        V1SiteAccessibilityStatementsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/site-accessibility-statements/${siteId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  remediationPdf = {
    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name UwV2RemediationEmptyControlsCreate
     * @request POST:/api/uw/v2/remediation/empty-controls
     * @secure
     */
    uwV2RemediationEmptyControlsCreate: (data: CreateOrUpdateRemediationEmptyControlDto, params: RequestParams = {}) =>
      this.request<
        UwV2RemediationEmptyControlsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/remediation/empty-controls`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name UwV2SitesExchangeHostnamesCreate
     * @request POST:/api/uw/v2/sites/exchange-hostnames
     * @secure
     */
    uwV2SitesExchangeHostnamesCreate: (data: ExchangeHostnamesDto, params: RequestParams = {}) =>
      this.request<
        UwV2SitesExchangeHostnamesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/sites/exchange-hostnames`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name UwV2PdfRemediationStatsList
     * @request GET:/api/uw/v2/pdf-remediation/stats
     * @secure
     */
    uwV2PdfRemediationStatsList: (params: RequestParams = {}) =>
      this.request<
        UwV2PdfRemediationStatsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-remediation/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersActiveList
     * @request GET:/api/v1/remediation-orders/active
     * @secure
     */
    v1RemediationOrdersActiveList: (params: RequestParams = {}) =>
      this.request<
        V1RemediationOrdersActiveListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/active`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersStatusesList
     * @request GET:/api/v1/remediation-orders/statuses
     * @secure
     */
    v1RemediationOrdersStatusesList: (query: V1RemediationOrdersStatusesListParams, params: RequestParams = {}) =>
      this.request<
        V1RemediationOrdersStatusesListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/statuses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesFiltersList
     * @request GET:/api/v1/remediation-orders/files-filters
     * @secure
     */
    v1RemediationOrdersFilesFiltersList: (
      query: V1RemediationOrdersFilesFiltersListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        V1RemediationOrdersFilesFiltersListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/files-filters`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesFiltersCountsList
     * @request GET:/api/v1/remediation-orders/files-filters-counts
     * @secure
     */
    v1RemediationOrdersFilesFiltersCountsList: (
      query: V1RemediationOrdersFilesFiltersCountsListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        V1RemediationOrdersFilesFiltersCountsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/files-filters-counts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesCreate
     * @request POST:/api/v1/remediation-orders/files
     * @secure
     */
    v1RemediationOrdersFilesCreate: (params: RequestParams = {}) =>
      this.request<
        V1RemediationOrdersFilesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/files`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesDelete
     * @request DELETE:/api/v1/remediation-orders/{id}/files/{fileId}
     * @secure
     */
    v1RemediationOrdersFilesDelete: (id: string, fileId: string, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/${id}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesScheduledDetail
     * @request GET:/api/v1/remediation-orders/files-scheduled/{site_id}
     * @secure
     */
    v1RemediationOrdersFilesScheduledDetail: (siteId: string, params: RequestParams = {}) =>
      this.request<
        V1RemediationOrdersFilesScheduledDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/files-scheduled/${siteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesScheduledCreate
     * @request POST:/api/v1/remediation-orders/files-scheduled/{site_id}
     * @secure
     */
    v1RemediationOrdersFilesScheduledCreate: (
      siteId: string,
      data: RemediationFilesScheduleRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/files-scheduled/${siteId}`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersFilesCountCreate
     * @request POST:/api/v1/remediation-orders/files-count
     * @secure
     */
    v1RemediationOrdersFilesCountCreate: (data: RemediationFilesCountRequestDto, params: RequestParams = {}) =>
      this.request<
        V1RemediationOrdersFilesCountCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/files-count`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name V1RemediationOrdersRemediationPdfsDetail
     * @request GET:/api/v1/remediation-orders/remediation-pdfs/{siteId}
     * @secure
     */
    v1RemediationOrdersRemediationPdfsDetail: (
      {siteId, ...query}: V1RemediationOrdersRemediationPdfsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<
        V1RemediationOrdersRemediationPdfsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/remediation-pdfs/${siteId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF
     * @name RemediationPdfCreate
     * @request POST:/api/remediation/pdf
     * @secure
     */
    remediationPdfCreate: (data: CreatePdfRemediationDto, params: RequestParams = {}) =>
      this.request<
        RemediationPdfCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/pdf`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  remediationPdfAuto = {
    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionCalculateCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/calculate
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionCalculateCreate: (data: PdfAutoCalculateDto, params: RequestParams = {}) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionCalculateCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/calculate`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionInitCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/init
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionInitCreate: (data: InitAutoRemediationDto, params: RequestParams = {}) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionInitCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/init`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionSelectSitesCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/select-sites
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionSelectSitesCreate: (data: PdfAutoSelectSitesDto, params: RequestParams = {}) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionSelectSitesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/select-sites`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionSelectSitesAndPlanCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/select-sites-and-plan
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionSelectSitesAndPlanCreate: (
      data: PdfAutoSelectSitesAndPlanDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionSelectSitesAndPlanCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/select-sites-and-plan`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionSelectNewPlanCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/select-new-plan
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionSelectNewPlanCreate: (data: PdfAutoSelectNewPlanDto, params: RequestParams = {}) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionSelectNewPlanCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/select-new-plan`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionUpgradePlanCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/upgrade-plan
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionUpgradePlanCreate: (data: PdfAutoUpgradePlanDto, params: RequestParams = {}) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionUpgradePlanCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/upgrade-plan`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionCompletePaymentCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/complete-payment
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionCompletePaymentCreate: (
      data: PdfAutoCompletePaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionCompletePaymentCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/complete-payment`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationSubmissionConfirmRemediationCreate
     * @request POST:/api/uw/v2/pdf-auto-remediation/submission/confirm-remediation
     * @secure
     */
    uwV2PdfAutoRemediationSubmissionConfirmRemediationCreate: (
      data: PdfAutoConfirmRemediationDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2PdfAutoRemediationSubmissionConfirmRemediationCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/submission/confirm-remediation`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REMEDIATION-PDF-AUTO
     * @name UwV2PdfAutoRemediationExportCsvList
     * @request GET:/api/uw/v2/pdf-auto-remediation/export-csv
     * @secure
     */
    uwV2PdfAutoRemediationExportCsvList: (
      query: UwV2PdfAutoRemediationExportCsvListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2PdfAutoRemediationExportCsvListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/pdf-auto-remediation/export-csv`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  products = {
    /**
     * @description Requires role(s): USER
     *
     * @tags PRODUCTS
     * @name UwV2DashboardProductsUsageStatsList
     * @request GET:/api/uw/v2/dashboard/products/usage-stats
     * @secure
     */
    uwV2DashboardProductsUsageStatsList: (
      query: UwV2DashboardProductsUsageStatsListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2DashboardProductsUsageStatsListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/products/usage-stats`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PRODUCTS
     * @name UwV2DashboardProductsUsageStatsExportCsvList
     * @request GET:/api/uw/v2/dashboard/products/usage-stats/export-csv
     * @secure
     */
    uwV2DashboardProductsUsageStatsExportCsvList: (
      query: UwV2DashboardProductsUsageStatsExportCsvListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2DashboardProductsUsageStatsExportCsvListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/products/usage-stats/export-csv`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PRODUCTS
     * @name UwV2DashboardProductsUsageStatsLstExportCsvList
     * @request GET:/api/uw/v2/dashboard/products/usage-stats/lst/export-csv
     * @secure
     */
    uwV2DashboardProductsUsageStatsLstExportCsvList: (
      query: UwV2DashboardProductsUsageStatsLstExportCsvListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2DashboardProductsUsageStatsLstExportCsvListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/products/usage-stats/lst/export-csv`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PRODUCTS
     * @name V1BillingProductsNonSiteDetail
     * @request GET:/api/v1/billing/products/non-site/{product}
     * @secure
     */
    v1BillingProductsNonSiteDetail: (product: string, params: RequestParams = {}) =>
      this.request<
        V1BillingProductsNonSiteDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/products/non-site/${product}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PRODUCTS
     * @name V1BillingProductsNonSiteInfoDetail
     * @request GET:/api/v1/billing/products/non-site/{product}/info
     * @secure
     */
    v1BillingProductsNonSiteInfoDetail: (product: string, params: RequestParams = {}) =>
      this.request<
        V1BillingProductsNonSiteInfoDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/products/non-site/${product}/info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  imageAlts = {
    /**
     * @description Requires role(s): USER
     *
     * @tags IMAGE-ALTS
     * @name UwV2DashboardProductsImageAltsExportCsvCreate
     * @request POST:/api/uw/v2/dashboard/products/image-alts/export-csv
     * @secure
     */
    uwV2DashboardProductsImageAltsExportCsvCreate: (
      query: UwV2DashboardProductsImageAltsExportCsvCreateParams,
      data: GetMissingImageAltsCsvRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2DashboardProductsImageAltsExportCsvCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/products/image-alts/export-csv`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags IMAGE-ALTS
     * @name UwV2ImageAltsQuotaList
     * @request GET:/api/uw/v2/image-alts/quota
     * @secure
     */
    uwV2ImageAltsQuotaList: (query: UwV2ImageAltsQuotaListParams, params: RequestParams = {}) =>
      this.request<
        UwV2ImageAltsQuotaListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/image-alts/quota`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  statementGenerator = {
    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name UwV2DashboardStatementGenDownloadCreate
     * @request POST:/api/uw/v2/dashboard/statement-gen/download/{format}
     * @secure
     */
    uwV2DashboardStatementGenDownloadCreate: (
      format: UwV2DashboardStatementGenDownloadCreateParamsEnum,
      data: A11YStatementGeneratorBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2DashboardStatementGenDownloadCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/statement-gen/download/${format}`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name UwV2DashboardStatementGenCreate
     * @request POST:/api/uw/v2/dashboard/statement-gen/{format}
     * @secure
     */
    uwV2DashboardStatementGenCreate: (
      format: UwV2DashboardStatementGenCreateParamsEnum,
      data: A11YStatementGeneratorBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        A11YStatementGeneratorResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/statement-gen/${format}`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name UwV2DashboardStatementGenDataDetail
     * @request GET:/api/uw/v2/dashboard/statement-gen/{siteId}/data
     * @secure
     */
    uwV2DashboardStatementGenDataDetail: (siteId: string, params: RequestParams = {}) =>
      this.request<
        UwV2DashboardStatementGenDataDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/statement-gen/${siteId}/data`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name UwV2DashboardStatementGenDataCreate
     * @request POST:/api/uw/v2/dashboard/statement-gen/{siteId}/data
     * @secure
     */
    uwV2DashboardStatementGenDataCreate: (siteId: string, data: A11YStatementUpdateDto, params: RequestParams = {}) =>
      this.request<
        UwV2DashboardStatementGenDataCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/statement-gen/${siteId}/data`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name UsersStatementGeneratorCreate
     * @request POST:/api/users/statement-generator
     * @secure
     */
    usersStatementGeneratorCreate: (data: StatementGeneratorBodyDto, params: RequestParams = {}) =>
      this.request<
        UsersStatementGeneratorCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/statement-generator`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name StatementTxtCreate
     * @request POST:/api/statement/txt
     * @secure
     */
    statementTxtCreate: (data: A11YStatementPostBodyDto, params: RequestParams = {}) =>
      this.request<
        StatementTxtCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/statement/txt`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags STATEMENT-GENERATOR
     * @name StatementHtmlCreate
     * @request POST:/api/statement/html
     * @secure
     */
    statementHtmlCreate: (data: A11YStatementPostBodyDto, params: RequestParams = {}) =>
      this.request<
        StatementHtmlCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/statement/html`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  reports = {
    /**
     * @description Requires role(s): USER
     *
     * @tags REPORTS
     * @name UwV2DashboardReportsDetail
     * @request GET:/api/uw/v2/dashboard/reports/{siteId}
     * @secure
     */
    uwV2DashboardReportsDetail: ({siteId, ...query}: UwV2DashboardReportsDetailParams, params: RequestParams = {}) =>
      this.request<
        UwV2DashboardReportsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/reports/${siteId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REPORTS
     * @name UwV2DashboardReportsMarkAsReadCreate
     * @request POST:/api/uw/v2/dashboard/reports/mark-as-read/{reportId}
     * @secure
     */
    uwV2DashboardReportsMarkAsReadCreate: (reportId: string, params: RequestParams = {}) =>
      this.request<
        UwV2DashboardReportsMarkAsReadCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/dashboard/reports/mark-as-read/${reportId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  widget = {
    /**
     * @description Requires role(s): USER
     *
     * @tags WIDGET
     * @name UwV2WidgetLogErrorCreate
     * @request POST:/api/uw/v2/widget/log/error
     * @secure
     */
    uwV2WidgetLogErrorCreate: (data: WidgetLogErrorPayloadDto, params: RequestParams = {}) =>
      this.request<
        ApiSuccessResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/widget/log/error`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags WIDGET
     * @name UwV2WidgetEventsWidgetInstallationCreate
     * @request POST:/api/uw/v2/widget/events/widget-installation
     * @secure
     */
    uwV2WidgetEventsWidgetInstallationCreate: (data: WidgetInstallationRequestDto, params: RequestParams = {}) =>
      this.request<
        ApiSuccessResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/widget/events/widget-installation`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  organization = {
    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementSiteCreate
     * @request POST:/api/uw/v2/organization-management/site
     * @secure
     */
    uwV2OrganizationManagementSiteCreate: (data: SitesCreateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementSiteCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management/site`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementSiteDelete
     * @request DELETE:/api/uw/v2/organization-management/site
     * @secure
     */
    uwV2OrganizationManagementSiteDelete: (data: SitesCreateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementSiteDeleteData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management/site`,
        method: 'DELETE',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementMemberCreate
     * @request POST:/api/uw/v2/organization-management/member
     * @secure
     */
    uwV2OrganizationManagementMemberCreate: (data: MemberCreateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementMemberCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management/member`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementMemberUpdate
     * @request PUT:/api/uw/v2/organization-management/member
     * @secure
     */
    uwV2OrganizationManagementMemberUpdate: (data: MemberUpdateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementMemberUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management/member`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementMemberDelete
     * @request DELETE:/api/uw/v2/organization-management/member
     * @secure
     */
    uwV2OrganizationManagementMemberDelete: (data: MemberUpdateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementMemberDeleteData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management/member`,
        method: 'DELETE',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementCreate
     * @request POST:/api/uw/v2/organization-management
     * @secure
     */
    uwV2OrganizationManagementCreate: (data: OrganizationCreateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ORGANIZATION
     * @name UwV2OrganizationManagementUpdate
     * @request PUT:/api/uw/v2/organization-management
     * @secure
     */
    uwV2OrganizationManagementUpdate: (data: OrganizationUpdateDto, params: RequestParams = {}) =>
      this.request<
        UwV2OrganizationManagementUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/organization-management`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  labs = {
    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesPublishCreate
     * @request POST:/api/uw/v2/labs/websites/{siteId}/publish
     * @secure
     */
    uwV2LabsWebsitesPublishCreate: (siteId: string, params: RequestParams = {}) =>
      this.request<
        UwV2LabsWebsitesPublishCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites/${siteId}/publish`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesList
     * @request GET:/api/uw/v2/labs/websites
     * @secure
     */
    uwV2LabsWebsitesList: (params: RequestParams = {}) =>
      this.request<
        UwV2LabsWebsitesListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesCreate
     * @request POST:/api/uw/v2/labs/websites/{accountCode}
     * @secure
     */
    uwV2LabsWebsitesCreate: (accountCode: string, data: GetLabsTuningsBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2LabsWebsitesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites/${accountCode}`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesFixesDetail
     * @request GET:/api/uw/v2/labs/websites/{siteId}/fixes/{id}
     * @secure
     */
    uwV2LabsWebsitesFixesDetail: (siteId: string, id: string, params: RequestParams = {}) =>
      this.request<
        UwV2LabsWebsitesFixesDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites/${siteId}/fixes/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesFixesDelete
     * @request DELETE:/api/uw/v2/labs/websites/{siteId}/fixes/{id}
     * @secure
     */
    uwV2LabsWebsitesFixesDelete: (siteId: string, id: string, params: RequestParams = {}) =>
      this.request<
        UwV2LabsWebsitesFixesDeleteData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites/${siteId}/fixes/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesFixesDetail2
     * @request GET:/api/uw/v2/labs/websites/{siteId}/fixes
     * @originalName uwV2LabsWebsitesFixesDetail
     * @duplicate
     * @secure
     */
    uwV2LabsWebsitesFixesDetail2: (
      {siteId, ...query}: UwV2LabsWebsitesFixesDetail2Params,
      params: RequestParams = {},
    ) =>
      this.request<
        UwV2LabsWebsitesFixesDetail2Data,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites/${siteId}/fixes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LABS
     * @name UwV2LabsWebsitesFixesCreate
     * @request POST:/api/uw/v2/labs/websites/{siteId}/fixes
     * @secure
     */
    uwV2LabsWebsitesFixesCreate: (siteId: string, data: UpsertLabsFixBodyDto, params: RequestParams = {}) =>
      this.request<
        UwV2LabsWebsitesFixesCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/uw/v2/labs/websites/${siteId}/fixes`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  regulationTracker = {
    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesList
     * @request GET:/api/regulation-tracker/countries
     * @secure
     */
    regulationTrackerCountriesList: (params: RequestParams = {}) =>
      this.request<
        CountriesResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesDetail
     * @request GET:/api/regulation-tracker/countries/{id}
     * @secure
     */
    regulationTrackerCountriesDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryMetricsDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesEnforcementDetail
     * @request GET:/api/regulation-tracker/countries/{id}/enforcement
     * @secure
     */
    regulationTrackerCountriesEnforcementDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryEnforcementDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/enforcement`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesLawsDetail
     * @request GET:/api/regulation-tracker/countries/{id}/laws
     * @secure
     */
    regulationTrackerCountriesLawsDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryLawsDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/laws`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesRiskDetail
     * @request GET:/api/regulation-tracker/countries/{id}/risk
     * @secure
     */
    regulationTrackerCountriesRiskDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryRiskAssessmentDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/risk`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesTimelineDetail
     * @request GET:/api/regulation-tracker/countries/{id}/timeline
     * @secure
     */
    regulationTrackerCountriesTimelineDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryTimelineDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/timeline`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesComplinesDetail
     * @request GET:/api/regulation-tracker/countries/{id}/complines
     * @secure
     */
    regulationTrackerCountriesComplinesDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryComplianceDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/complines`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesDisproportionateBurdenDetail
     * @request GET:/api/regulation-tracker/countries/{id}/disproportionate-burden
     * @secure
     */
    regulationTrackerCountriesDisproportionateBurdenDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryDisproportionateBurdenDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/disproportionate-burden`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesOverallDetail
     * @request GET:/api/regulation-tracker/countries/{id}/overall
     * @secure
     */
    regulationTrackerCountriesOverallDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryOverallAssessmentDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/overall`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesUpdatesDetail
     * @request GET:/api/regulation-tracker/countries/{id}/updates
     * @secure
     */
    regulationTrackerCountriesUpdatesDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        CountryUpdatesDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/updates`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesChecklistDetail
     * @request GET:/api/regulation-tracker/countries/{id}/checklist
     * @secure
     */
    regulationTrackerCountriesChecklistDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        ChecklistBlockResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/checklist`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesChecklistUpdate
     * @request PUT:/api/regulation-tracker/countries/{id}/checklist
     * @secure
     */
    regulationTrackerCountriesChecklistUpdate: (id: string, data: CheckAnswerDto, params: RequestParams = {}) =>
      this.request<
        ChecklistBlockResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/checklist`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags REGULATION-TRACKER
     * @name RegulationTrackerCountriesAllCreate
     * @request POST:/api/regulation-tracker/countries/{id}/all
     * @secure
     */
    regulationTrackerCountriesAllCreate: (id: string, data: CountriesRequestDto, params: RequestParams = {}) =>
      this.request<
        CountryDataDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/regulation-tracker/countries/${id}/all`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  companies = {
    /**
     * @description Requires role(s): COMPANY
     *
     * @tags COMPANIES
     * @name WidgetSiteRemediationFocusUpdate
     * @request PUT:/api/widget/site/{id}/remediation/focus
     * @secure
     */
    widgetSiteRemediationFocusUpdate: (
      id: string,
      data: UpdateSiteRemediationFocusBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<
        WidgetSiteRemediationFocusUpdateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/widget/site/${id}/remediation/focus`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): COMPANY
     *
     * @tags COMPANIES
     * @name WidgetCreate
     * @request POST:/api/widget
     * @secure
     */
    widgetCreate: (data: WidgetRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        WidgetCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/widget`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags COMPANIES
     * @name CompaniesRegistrationCreate
     * @request POST:/api/companies/registration
     * @secure
     */
    companiesRegistrationCreate: (data: CompanyRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/companies/registration`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  admin = {
    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name V1BillingOrdersAdminListDetail
     * @request GET:/api/v1/billing/orders/admin/list/{userId}
     * @secure
     */
    v1BillingOrdersAdminListDetail: (
      {userId, ...query}: V1BillingOrdersAdminListDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<
        V1BillingOrdersAdminListDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/orders/admin/list/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name V1BillingOrdersListList
     * @request GET:/api/v1/billing/orders/list
     * @secure
     */
    v1BillingOrdersListList: (query: V1BillingOrdersListListParams, params: RequestParams = {}) =>
      this.request<
        V1BillingOrdersListListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/orders/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name V1BillingOrdersDetail
     * @request GET:/api/v1/billing/orders/{id}
     * @secure
     */
    v1BillingOrdersDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        V1BillingOrdersDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/orders/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name V1BillingOrdersReportCreate
     * @request POST:/api/v1/billing/orders/report
     * @secure
     */
    v1BillingOrdersReportCreate: (data: GetOrderReportsBodyDto, params: RequestParams = {}) =>
      this.request<
        V1BillingOrdersReportCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/billing/orders/report`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name V1RemediationOrdersAllList
     * @request GET:/api/v1/remediation-orders/all
     * @secure
     */
    v1RemediationOrdersAllList: (query: V1RemediationOrdersAllListParams, params: RequestParams = {}) =>
      this.request<
        V1RemediationOrdersAllListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/remediation-orders/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN, SALES
     *
     * @tags ADMIN
     * @name UsersCompanyCreate
     * @request POST:/api/users/{id}/company
     * @secure
     */
    usersCompanyCreate: (id: string, data: UserCompanyPaymentBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/${id}/company`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name UsersCreate
     * @request POST:/api/users
     * @secure
     */
    usersCreate: (data: CreateUserBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name UsersUpdate
     * @request PUT:/api/users/{id}
     * @secure
     */
    usersUpdate: (id: string, data: UpdateUserBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/users/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN, COMPANY
     *
     * @tags ADMIN
     * @name CompaniesChangeInfoUpdate
     * @request PUT:/api/companies/{id}/change_info
     * @secure
     */
    companiesChangeInfoUpdate: (id: string, data: ChangeInfoBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/companies/${id}/change_info`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name CompaniesStatusUpdate
     * @request PUT:/api/companies/status
     * @secure
     */
    companiesStatusUpdate: (data: ChangeStatusBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/companies/status`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name ResellersChangeInfoUpdate
     * @request PUT:/api/resellers/{id}/change_info
     * @secure
     */
    resellersChangeInfoUpdate: (id: string, data: ChangeResellerInfoBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/resellers/${id}/change_info`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name ResellersStatusUpdate
     * @request PUT:/api/resellers/status
     * @secure
     */
    resellersStatusUpdate: (data: ChangeResellerStatusBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/resellers/status`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name SitesDetail
     * @request GET:/api/sites/{id}
     * @secure
     */
    sitesDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        SitesDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/sites/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name SitesList
     * @request GET:/api/sites
     * @secure
     */
    sitesList: (params: RequestParams = {}) =>
      this.request<
        GetSitesResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/sites`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): ADMIN
     *
     * @tags ADMIN
     * @name AdminBankTransfersCreate
     * @request POST:/api/admin/bank-transfers
     * @secure
     */
    adminBankTransfersCreate: (data: CreateBankTransferBodyDto, params: RequestParams = {}) =>
      this.request<
        AdminBankTransfersCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/admin/bank-transfers`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name RemediationTranslateOverridesReplaceCreate
     * @request POST:/api/remediation/translate/overrides/replace
     * @secure
     */
    remediationTranslateOverridesReplaceCreate: (
      data: ReplaceLiveTranslationOverridesRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        ReplaceLiveTranslationOverridesResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/overrides/replace`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name RemediationTranslateOverridesCsvDetail
     * @request GET:/api/remediation/translate/overrides/csv/{siteId}
     * @secure
     */
    remediationTranslateOverridesCsvDetail: (siteId: string, params: RequestParams = {}) =>
      this.request<
        RemediationTranslateOverridesCsvDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/overrides/csv/${siteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name RemediationTranslateNoTranslatesSelectorsDetail
     * @request GET:/api/remediation/translate/no-translates/selectors/{siteId}
     * @secure
     */
    remediationTranslateNoTranslatesSelectorsDetail: (siteId: string, params: RequestParams = {}) =>
      this.request<
        RemediationTranslateNoTranslatesSelectorsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/no-translates/selectors/${siteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name RemediationTranslateNoTranslatesReplaceCreate
     * @request POST:/api/remediation/translate/no-translates/replace
     * @secure
     */
    remediationTranslateNoTranslatesReplaceCreate: (
      data: CreateLiveTranslationNoTranslatesRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateLiveTranslationNoTranslatesResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/no-translates/replace`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name RemediationTranslateNoTranslatesWordsDetail
     * @request GET:/api/remediation/translate/no-translates/words/{siteId}
     * @secure
     */
    remediationTranslateNoTranslatesWordsDetail: (siteId: string, params: RequestParams = {}) =>
      this.request<
        RemediationTranslateNoTranslatesWordsDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/no-translates/words/${siteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags ADMIN
     * @name RemediationTranslateNoTranslatesWordsCreate
     * @request POST:/api/remediation/translate/no-translates/words
     * @secure
     */
    remediationTranslateNoTranslatesWordsCreate: (
      data: CreateLiveTranslationIgnoredWordsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        RemediationTranslateNoTranslatesWordsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/no-translates/words`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  affiliate = {
    /**
     * @description Requires role(s): USER
     *
     * @tags AFFILIATE
     * @name V1AffiliatePayoutAddressCreate
     * @request POST:/api/v1/affiliate/payout/address
     * @secure
     */
    v1AffiliatePayoutAddressCreate: (data: UpdatePayoutAddressBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/affiliate/payout/address`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  spl = {
    /**
     * @description Requires role(s): USER
     *
     * @tags SPL
     * @name V1SplGetOrCreateDetail
     * @request GET:/api/v1/spl/get-or-create/{accountUuid}
     * @secure
     */
    v1SplGetOrCreateDetail: ({accountUuid, ...query}: V1SplGetOrCreateDetailParams, params: RequestParams = {}) =>
      this.request<
        GetOrCreateSplResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/spl/get-or-create/${accountUuid}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags SPL
     * @name V1SplCreateUserSharedCreate
     * @request POST:/api/v1/spl/create-user-shared
     * @secure
     */
    v1SplCreateUserSharedCreate: (data: CreateUserSharedPaymentLinkDto, params: RequestParams = {}) =>
      this.request<
        V1SplCreateUserSharedCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/v1/spl/create-user-shared`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  paidServices = {
    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesUserServicesList
     * @request GET:/api/services/user_services
     * @secure
     */
    servicesUserServicesList: (query: ServicesUserServicesListParams, params: RequestParams = {}) =>
      this.request<
        ServicesUserServicesListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/user_services`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesUpdateSitesFreeCreate
     * @request POST:/api/services/update_sites_free
     * @secure
     */
    servicesUpdateSitesFreeCreate: (data: UpdateSitesFreeBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/update_sites_free`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesEnableTrialCreate
     * @request POST:/api/services/enable_trial
     * @secure
     */
    servicesEnableTrialCreate: (data: EnableTrialBodyDto, params: RequestParams = {}) =>
      this.request<
        ServicesEnableTrialCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/enable_trial`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesRenewCreate
     * @request POST:/api/services/renew/{id}
     * @secure
     */
    servicesRenewCreate: (id: string, data: RenewServiceBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/renew/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesRenewGlobalCreate
     * @request POST:/api/services/renew_global
     * @secure
     */
    servicesRenewGlobalCreate: (data: RenewServiceBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/renew_global`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesUpdateDetailsGlobalCreate
     * @request POST:/api/services/update_details_global
     * @secure
     */
    servicesUpdateDetailsGlobalCreate: (data: UpdateDetailsBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/update_details_global`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesUpdateDetailsCreate
     * @request POST:/api/services/update_details/{id}
     * @secure
     */
    servicesUpdateDetailsCreate: (id: string, data: UpdateDetailsBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/update_details/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags PAID-SERVICES
     * @name ServicesCblogosList
     * @request GET:/api/services/cblogos
     * @secure
     */
    servicesCblogosList: (params: RequestParams = {}) =>
      this.request<
        GetCBLogosResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/services/cblogos`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  resellers = {
    /**
     * @description Requires role(s): USER
     *
     * @tags RESELLERS
     * @name ResellersRegistrationCreate
     * @request POST:/api/resellers/registration
     * @secure
     */
    resellersRegistrationCreate: (data: ResellerRegistrationBodyDto, params: RequestParams = {}) =>
      this.request<
        ResellerRegistrationResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/resellers/registration`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  tunings = {
    /**
     * @description Requires role(s): ADMIN
     *
     * @tags TUNINGS
     * @name TuningsResetDetail
     * @request GET:/api/tunings/reset/{code}
     * @secure
     */
    tuningsResetDetail: (code: string, params: RequestParams = {}) =>
      this.request<
        TuningsResetDetailData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/tunings/reset/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags TUNINGS
     * @name TuningsCreate
     * @request POST:/api/tunings
     * @secure
     */
    tuningsCreate: (data: PostTuningsBodyDto, params: RequestParams = {}) =>
      this.request<
        TuningsCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/tunings`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags TUNINGS
     * @name TuningsUpdatePersiteCreate
     * @request POST:/api/tunings/update/persite
     * @secure
     */
    tuningsUpdatePersiteCreate: (data: UpdateTuningsPersiteBodyDto, params: RequestParams = {}) =>
      this.request<
        TuningsUpdatePersiteCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/tunings/update/persite`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags TUNINGS
     * @name TuningsUpdatePersitePaidCreate
     * @request POST:/api/tunings/update/persite-paid
     * @secure
     */
    tuningsUpdatePersitePaidCreate: (data: UpdatePaidPersiteTuningsRequestDto, params: RequestParams = {}) =>
      this.request<
        TuningsUpdatePersitePaidCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/tunings/update/persite-paid`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  contacts = {
    /**
     * @description Requires role(s): USER
     *
     * @tags CONTACTS
     * @name ContactsCreate
     * @request POST:/api/contacts
     * @secure
     */
    contactsCreate: (data: PostContactsBodyDto, params: RequestParams = {}) =>
      this.request<
        PostContactsResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/contacts`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags CONTACTS
     * @name ContactsSupportCreate
     * @request POST:/api/contacts/support
     * @secure
     */
    contactsSupportCreate: (data: PostContactsBodyDto, params: RequestParams = {}) =>
      this.request<
        PostContactsResponseDto,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/contacts/support`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  contrast = {
    /**
     * @description Requires role(s): USER
     *
     * @tags CONTRAST
     * @name ContrastCreate
     * @request POST:/api/contrast
     * @secure
     */
    contrastCreate: (data: PostContrastBodyDto, params: RequestParams = {}) =>
      this.request<
        ApiCodeResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/contrast`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
  csr = {
    /**
     * @description Requires role(s): USER
     *
     * @tags CSR
     * @name RemediationPerSiteUpdateScriptWithSecretKeyCreate
     * @request POST:/api/remediation/per-site/update-script-with-secret-key
     * @secure
     */
    remediationPerSiteUpdateScriptWithSecretKeyCreate: (data: UpdatePerSiteScriptBodyDto, params: RequestParams = {}) =>
      this.request<
        RemediationPerSiteUpdateScriptWithSecretKeyCreateData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/per-site/update-script-with-secret-key`,
        method: 'POST',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  liveTranslation = {
    /**
     * @description Requires role(s): USER
     *
     * @tags LIVE-TRANSLATION
     * @name RemediationTranslateQuotaList
     * @request GET:/api/remediation/translate/quota
     * @secure
     */
    remediationTranslateQuotaList: (query: RemediationTranslateQuotaListParams, params: RequestParams = {}) =>
      this.request<
        RemediationTranslateQuotaListData,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/quota`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LIVE-TRANSLATION
     * @name RemediationTranslateOverridesStatsCreate
     * @request POST:/api/remediation/translate/overrides/stats
     * @secure
     */
    remediationTranslateOverridesStatsCreate: (
      data: CreateLiveTranslationOverridesStatRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiSuccessResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/overrides/stats`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Requires role(s): USER
     *
     * @tags LIVE-TRANSLATION
     * @name RemediationTranslateOverridesStCreate
     * @request POST:/api/remediation/translate/overrides/st
     * @secure
     */
    remediationTranslateOverridesStCreate: (
      data: CreateLiveTranslationOverridesStatRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiSuccessResponse,
        | {
            error?: string;
          }
        | {
            message?: string;
          }
      >({
        path: `/api/remediation/translate/overrides/st`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),
  };
}
